//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.4.0.0 (NJsonSchema v11.3.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable()
export class CoachingRepository {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Activates the coaching.
     * @param createPatientCoaching The create patient coaching.
     */
    activateCoaching(createPatientCoaching: CreatePatientCoaching | null): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/Coaching/ActivateCoaching";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createPatientCoaching);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processActivateCoaching(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processActivateCoaching(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processActivateCoaching(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Creates the activity.
     * @param activityDetails The activity details.
     * @return The id of the created activity
     */
    createActivity(activityDetails: CreateCoachingActivity | null): Observable<number> {
        let url_ = this.baseUrl + "/umbraco/Api/Coaching/CreateActivity";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(activityDetails);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateActivity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateActivity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateActivity(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Creates the coaching.
     * @param coaching The coaching.
     * @return The id of the created coaching
     */
    createCoaching(coaching: CoachingDetails | null): Observable<number> {
        let url_ = this.baseUrl + "/umbraco/Api/Coaching/CreateCoaching";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(coaching);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateCoaching(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateCoaching(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateCoaching(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Creates the recipe.
     * @param recipeDetails The recipe details.
     * @return The id of the created recipe
     */
    createRecipe(recipeDetails: CreateCoachingRecipe | null): Observable<number> {
        let url_ = this.baseUrl + "/umbraco/Api/Coaching/CreateRecipe";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(recipeDetails);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateRecipe(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateRecipe(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateRecipe(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Deletes the activty.
     * @param id The identifier.
     * @return The task.
     */
    deleteActivity(id: number): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/Coaching/DeleteActivity/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteActivity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteActivity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteActivity(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Deletes the coaching.
     * @param id The identifier.
     */
    deleteCoaching(id: number): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/Coaching/DeleteCoaching/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteCoaching(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteCoaching(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteCoaching(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Deletes the activity file.
     * @param id The identifier.
     * @return The task.
     */
    deleteCoachingActivityMedia(id: number): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/Coaching/DeleteCoachingActivityMedia/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteCoachingActivityMedia(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteCoachingActivityMedia(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteCoachingActivityMedia(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Deletes the recipe.
     * @param id The identifier.
     * @return The task.
     */
    deleteRecipe(id: number): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/Coaching/DeleteRecipe/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteRecipe(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteRecipe(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteRecipe(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Disables the coaching.
     * @param patientId The patient identifier.
     * @param coachingId The coaching identifier.
     */
    disableCoaching(patientId: number, coachingId: number): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/Coaching/DisableCoaching/?patientId={patientId}&coachingId={coachingId}";
        if (patientId === undefined || patientId === null)
            throw new Error("The parameter 'patientId' must be defined.");
        url_ = url_.replace("{patientId}", encodeURIComponent("" + patientId));
        if (coachingId === undefined || coachingId === null)
            throw new Error("The parameter 'coachingId' must be defined.");
        url_ = url_.replace("{coachingId}", encodeURIComponent("" + coachingId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDisableCoaching(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDisableCoaching(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDisableCoaching(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Extends the coaching.
     * @param patientId The patient identifier.
     * @param coachingId The coaching identifier.
     */
    extendCoaching(patientId: number, coachingId: number): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/Coaching/ExtendCoaching/?patientId={patientId}&coachingId={coachingId}";
        if (patientId === undefined || patientId === null)
            throw new Error("The parameter 'patientId' must be defined.");
        url_ = url_.replace("{patientId}", encodeURIComponent("" + patientId));
        if (coachingId === undefined || coachingId === null)
            throw new Error("The parameter 'coachingId' must be defined.");
        url_ = url_.replace("{coachingId}", encodeURIComponent("" + coachingId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExtendCoaching(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExtendCoaching(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processExtendCoaching(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the activities.
     * @param searchParams The search parameters.
     * @return All searched activities
     */
    getActivities(searchParams: CoachingActivitySearchParams | null): Observable<CoachingActivity[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Coaching/GetActivities";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchParams);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActivities(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActivities(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CoachingActivity[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CoachingActivity[] | null>;
        }));
    }

    protected processGetActivities(response: HttpResponseBase): Observable<CoachingActivity[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CoachingActivity.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the activities for dropdown.
     * @return Activities for dropdown
     */
    getActivitiesDropdownValues(): Observable<DropdownValue[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Coaching/GetActivitiesDropdownValues";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActivitiesDropdownValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActivitiesDropdownValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DropdownValue[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DropdownValue[] | null>;
        }));
    }

    protected processGetActivitiesDropdownValues(response: HttpResponseBase): Observable<DropdownValue[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DropdownValue.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the activity.
     * @param id The identifier.
     * @return The exepected activity
     */
    getActivity(id: number): Observable<CoachingActivityDetails | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Coaching/GetActivity/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActivity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActivity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CoachingActivityDetails | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CoachingActivityDetails | null>;
        }));
    }

    protected processGetActivity(response: HttpResponseBase): Observable<CoachingActivityDetails | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CoachingActivityDetails.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the activities for library.
     * @param searchParamActivity The search parameters.
     * @return The coaching activities for the doctor library
     */
    getActivitiesForLibrary(searchParamActivity: SearchParamActivity | null): Observable<PaginatorWrapperOfIEnumerableOfCoachingActivityWithWarnings | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Coaching/GetActivitiesForLibrary";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchParamActivity);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActivitiesForLibrary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActivitiesForLibrary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaginatorWrapperOfIEnumerableOfCoachingActivityWithWarnings | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaginatorWrapperOfIEnumerableOfCoachingActivityWithWarnings | null>;
        }));
    }

    protected processGetActivitiesForLibrary(response: HttpResponseBase): Observable<PaginatorWrapperOfIEnumerableOfCoachingActivityWithWarnings | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PaginatorWrapperOfIEnumerableOfCoachingActivityWithWarnings.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the coaching for library.
     * @param searchParam The search parameter.
     * @return The coachign for library.
     */
    getCoachingForLibrary(searchParam: SearchParamCoachingLibrary | null): Observable<PaginatorWrapperOfIEnumerableOfCoachingLibrary | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Coaching/GetCoachingForLibrary";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchParam);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCoachingForLibrary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCoachingForLibrary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaginatorWrapperOfIEnumerableOfCoachingLibrary | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaginatorWrapperOfIEnumerableOfCoachingLibrary | null>;
        }));
    }

    protected processGetCoachingForLibrary(response: HttpResponseBase): Observable<PaginatorWrapperOfIEnumerableOfCoachingLibrary | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PaginatorWrapperOfIEnumerableOfCoachingLibrary.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the coaching.
     * @param id The identifier.
     * @return The expected coaching
     */
    getCoaching(id: number): Observable<CoachingDetails | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Coaching/GetCoaching/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCoaching(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCoaching(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CoachingDetails | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CoachingDetails | null>;
        }));
    }

    protected processGetCoaching(response: HttpResponseBase): Observable<CoachingDetails | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CoachingDetails.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the coaching details pro.
     * @param coachingId The coaching identifier.
     * @param patientId (optional) the patient Id
     * @return th coaching detail for proNutri or My
     */
    getCoachingDetails(coachingId: number, patientId?: number | null | undefined): Observable<CoachingDetailsPro | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Coaching/GetCoachingDetails/?coachingId={coachingId}?";
        if (coachingId === undefined || coachingId === null)
            throw new Error("The parameter 'coachingId' must be defined.");
        url_ = url_.replace("{coachingId}", encodeURIComponent("" + coachingId));
        if (patientId !== undefined && patientId !== null)
            url_ += "patientId=" + encodeURIComponent("" + patientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCoachingDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCoachingDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CoachingDetailsPro | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CoachingDetailsPro | null>;
        }));
    }

    protected processGetCoachingDetails(response: HttpResponseBase): Observable<CoachingDetailsPro | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CoachingDetailsPro.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the patient coaching details.
     * @param patientId The patient identifier.
     * @param consultationId the consultation id.
     * @return the patientCoahcing Details.
     */
    getPatientCoachingDetails(patientId: number, consultationId: number): Observable<PatientCoachingDetails[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Coaching/GetPatientCoachingDetails/?patientId={patientId}&consultationId={consultationId}";
        if (patientId === undefined || patientId === null)
            throw new Error("The parameter 'patientId' must be defined.");
        url_ = url_.replace("{patientId}", encodeURIComponent("" + patientId));
        if (consultationId === undefined || consultationId === null)
            throw new Error("The parameter 'consultationId' must be defined.");
        url_ = url_.replace("{consultationId}", encodeURIComponent("" + consultationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPatientCoachingDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPatientCoachingDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PatientCoachingDetails[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PatientCoachingDetails[] | null>;
        }));
    }

    protected processGetPatientCoachingDetails(response: HttpResponseBase): Observable<PatientCoachingDetails[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PatientCoachingDetails.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the coachings.
     * @param searchParams The search parameters.
     * @return All search coachings
     */
    getCoachings(searchParams: SearchParamsCoaching | null): Observable<Coaching[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Coaching/GetCoachings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchParams);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCoachings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCoachings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Coaching[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Coaching[] | null>;
        }));
    }

    protected processGetCoachings(response: HttpResponseBase): Observable<Coaching[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Coaching.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the current patient recipe asynchronous.
     * @param recipeId The recipe identifier.
     * @return The requested PatientRecipe
     */
    getCurrentPatientRecipe(recipeId: number): Observable<PatientRecipe | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Coaching/GetCurrentPatientRecipe/?recipeId={recipeId}";
        if (recipeId === undefined || recipeId === null)
            throw new Error("The parameter 'recipeId' must be defined.");
        url_ = url_.replace("{recipeId}", encodeURIComponent("" + recipeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentPatientRecipe(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentPatientRecipe(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PatientRecipe | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PatientRecipe | null>;
        }));
    }

    protected processGetCurrentPatientRecipe(response: HttpResponseBase): Observable<PatientRecipe | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PatientRecipe.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the current patient recipes.
     * @param searchParams The search parameters.
     * @return The Recipes
     */
    getCurrentPatientRecipes(searchParams: PatientRecipeSearchParams | null): Observable<PatientRecipe[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Coaching/GetCurrentPatientRecipes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchParams);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentPatientRecipes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentPatientRecipes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PatientRecipe[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PatientRecipe[] | null>;
        }));
    }

    protected processGetCurrentPatientRecipes(response: HttpResponseBase): Observable<PatientRecipe[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PatientRecipe.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the current patient recipe cart.
     * @return The Recipes
     */
    getCurrentPatientRecipeCart(): Observable<PatientRecipe[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Coaching/GetCurrentPatientRecipeCart";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentPatientRecipeCart(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentPatientRecipeCart(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PatientRecipe[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PatientRecipe[] | null>;
        }));
    }

    protected processGetCurrentPatientRecipeCart(response: HttpResponseBase): Observable<PatientRecipe[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PatientRecipe.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the current patient ingredient cart.
     * @return The ingredients in the patient cart
     */
    getCurrentPatientCart(): Observable<PatientCart | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Coaching/GetCurrentPatientCart";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentPatientCart(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentPatientCart(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PatientCart | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PatientCart | null>;
        }));
    }

    protected processGetCurrentPatientCart(response: HttpResponseBase): Observable<PatientCart | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PatientCart.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Sets the current patient cart comment.
     * @param comment (optional) The comment.
     */
    setCurrentPatientCartComment(comment?: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/Coaching/SetCurrentPatientCartComment?";
        if (comment !== undefined && comment !== null)
            url_ += "comment=" + encodeURIComponent("" + comment) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetCurrentPatientCartComment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetCurrentPatientCartComment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetCurrentPatientCartComment(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Sets the patient recipe bookmarked flag.
     * @param coachingRecipeId The coaching recipe identifier.
     * @param value if set to true [is bookmarked].
     */
    setCurrentPatientRecipeBookmarkedFlag(coachingRecipeId: number, value: boolean): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/Coaching/SetCurrentPatientRecipeBookmarkedFlag/?coachingRecipeId={coachingRecipeId}&value={value}";
        if (coachingRecipeId === undefined || coachingRecipeId === null)
            throw new Error("The parameter 'coachingRecipeId' must be defined.");
        url_ = url_.replace("{coachingRecipeId}", encodeURIComponent("" + coachingRecipeId));
        if (value === undefined || value === null)
            throw new Error("The parameter 'value' must be defined.");
        url_ = url_.replace("{value}", encodeURIComponent("" + value));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetCurrentPatientRecipeBookmarkedFlag(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetCurrentPatientRecipeBookmarkedFlag(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetCurrentPatientRecipeBookmarkedFlag(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Sets the patient cart ingredient selected flag.
     * @param patientIngredientCartId The patient ingredient cart identifier.
     * @param value if set to true [is selected].
     */
    setPatientCartIngredientSelectedFlag(patientIngredientCartId: number, value: boolean): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/Coaching/SetPatientCartIngredientSelectedFlag/?patientIngredientCartId={patientIngredientCartId}&value={value}";
        if (patientIngredientCartId === undefined || patientIngredientCartId === null)
            throw new Error("The parameter 'patientIngredientCartId' must be defined.");
        url_ = url_.replace("{patientIngredientCartId}", encodeURIComponent("" + patientIngredientCartId));
        if (value === undefined || value === null)
            throw new Error("The parameter 'value' must be defined.");
        url_ = url_.replace("{value}", encodeURIComponent("" + value));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetPatientCartIngredientSelectedFlag(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetPatientCartIngredientSelectedFlag(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetPatientCartIngredientSelectedFlag(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Sets the coaching recipe spotlighted flag.
     * @param coachingRecipeId The coaching recipe identifier.
     * @param value if set to true [is spotlighted].
     */
    setCoachingRecipeSpotlightedFlag(coachingRecipeId: number, value: boolean): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/Coaching/SetCoachingRecipeSpotlightedFlag/?coachingRecipeId={coachingRecipeId}&value={value}";
        if (coachingRecipeId === undefined || coachingRecipeId === null)
            throw new Error("The parameter 'coachingRecipeId' must be defined.");
        url_ = url_.replace("{coachingRecipeId}", encodeURIComponent("" + coachingRecipeId));
        if (value === undefined || value === null)
            throw new Error("The parameter 'value' must be defined.");
        url_ = url_.replace("{value}", encodeURIComponent("" + value));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetCoachingRecipeSpotlightedFlag(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetCoachingRecipeSpotlightedFlag(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetCoachingRecipeSpotlightedFlag(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Sets the coaching recipe status.
     * @param coachingRecipeId The coaching recipe identifier.
     * @param recipeStatus The recipe status.
     */
    setCoachingRecipeStatus(coachingRecipeId: number, recipeStatus: CoachingRecipeStatus): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/Coaching/SetCoachingRecipeStatus/?coachingRecipeId={coachingRecipeId}&recipeStatus={recipeStatus}";
        if (coachingRecipeId === undefined || coachingRecipeId === null)
            throw new Error("The parameter 'coachingRecipeId' must be defined.");
        url_ = url_.replace("{coachingRecipeId}", encodeURIComponent("" + coachingRecipeId));
        if (recipeStatus === undefined || recipeStatus === null)
            throw new Error("The parameter 'recipeStatus' must be defined.");
        url_ = url_.replace("{recipeStatus}", encodeURIComponent("" + recipeStatus));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetCoachingRecipeStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetCoachingRecipeStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetCoachingRecipeStatus(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Adds the recipe to current patient cart.
     * @param coachingRecipeId The coaching recipe identifier.
     * @param nbPerson The nb persons.
     */
    addRecipeToCurrentPatientCart(coachingRecipeId: number, nbPerson: number): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/Coaching/AddRecipeToCurrentPatientCart/?coachingRecipeId={coachingRecipeId}&nbPerson={nbPerson}";
        if (coachingRecipeId === undefined || coachingRecipeId === null)
            throw new Error("The parameter 'coachingRecipeId' must be defined.");
        url_ = url_.replace("{coachingRecipeId}", encodeURIComponent("" + coachingRecipeId));
        if (nbPerson === undefined || nbPerson === null)
            throw new Error("The parameter 'nbPerson' must be defined.");
        url_ = url_.replace("{nbPerson}", encodeURIComponent("" + nbPerson));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddRecipeToCurrentPatientCart(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddRecipeToCurrentPatientCart(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddRecipeToCurrentPatientCart(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Removes the recipe from patient cart.
     * @param coachingRecipeId The coaching recipe identifier.
     */
    removeRecipeFromPatientCart(coachingRecipeId: number): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/Coaching/RemoveRecipeFromPatientCart/?coachingRecipeId={coachingRecipeId}";
        if (coachingRecipeId === undefined || coachingRecipeId === null)
            throw new Error("The parameter 'coachingRecipeId' must be defined.");
        url_ = url_.replace("{coachingRecipeId}", encodeURIComponent("" + coachingRecipeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveRecipeFromPatientCart(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveRecipeFromPatientCart(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRemoveRecipeFromPatientCart(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates the recipe nb persons in current patient cart.
     * @param coachingRecipeId The coaching recipe identifier.
     * @param nbPerson The nb persons.
     */
    updateRecipeNbPersonsInCurrentPatientCart(coachingRecipeId: number, nbPerson: number): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/Coaching/UpdateRecipeNbPersonsInCurrentPatientCart/?coachingRecipeId={coachingRecipeId}&nbPerson={nbPerson}";
        if (coachingRecipeId === undefined || coachingRecipeId === null)
            throw new Error("The parameter 'coachingRecipeId' must be defined.");
        url_ = url_.replace("{coachingRecipeId}", encodeURIComponent("" + coachingRecipeId));
        if (nbPerson === undefined || nbPerson === null)
            throw new Error("The parameter 'nbPerson' must be defined.");
        url_ = url_.replace("{nbPerson}", encodeURIComponent("" + nbPerson));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateRecipeNbPersonsInCurrentPatientCart(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateRecipeNbPersonsInCurrentPatientCart(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateRecipeNbPersonsInCurrentPatientCart(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the recipe.
     * @param id The identifier.
     * @return The expected recipe
     */
    getRecipeDetailBO(id: number): Observable<CoachingRecipeDetails | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Coaching/GetRecipeDetailBO/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRecipeDetailBO(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRecipeDetailBO(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CoachingRecipeDetails | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CoachingRecipeDetails | null>;
        }));
    }

    protected processGetRecipeDetailBO(response: HttpResponseBase): Observable<CoachingRecipeDetails | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CoachingRecipeDetails.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the recipe.
     * @param id The identifier.
     * @return The expected recipe
     */
    getRecipeDetailPro(id: number): Observable<CoachingRecipeDetails | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Coaching/GetRecipeDetailPro/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRecipeDetailPro(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRecipeDetailPro(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CoachingRecipeDetails | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CoachingRecipeDetails | null>;
        }));
    }

    protected processGetRecipeDetailPro(response: HttpResponseBase): Observable<CoachingRecipeDetails | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CoachingRecipeDetails.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the recipes.
     * @param searchParams The search parameters.
     * @return All searched recipes
     */
    getRecipes(searchParams: CoachingRecipeSearchParams | null): Observable<CoachingRecipe[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Coaching/GetRecipes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchParams);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRecipes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRecipes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CoachingRecipe[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CoachingRecipe[] | null>;
        }));
    }

    protected processGetRecipes(response: HttpResponseBase): Observable<CoachingRecipe[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CoachingRecipe.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the recipe for library.
     * @param searchParam The search parameter.
     * @return All the searched recipe for library
     */
    getRecipeForLibrary(searchParam: CoachingRecipeLibrarySearchParam | null): Observable<PaginatorWrapperOfIEnumerableOfCoachingRecipeForLibrary | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Coaching/GetRecipeForLibrary";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchParam);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRecipeForLibrary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRecipeForLibrary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaginatorWrapperOfIEnumerableOfCoachingRecipeForLibrary | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaginatorWrapperOfIEnumerableOfCoachingRecipeForLibrary | null>;
        }));
    }

    protected processGetRecipeForLibrary(response: HttpResponseBase): Observable<PaginatorWrapperOfIEnumerableOfCoachingRecipeForLibrary | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PaginatorWrapperOfIEnumerableOfCoachingRecipeForLibrary.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the recipes for dropdown.
     * @return Recipes for dropdown
     */
    getRecipesDropdownValues(): Observable<DropdownValue[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Coaching/GetRecipesDropdownValues";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRecipesDropdownValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRecipesDropdownValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DropdownValue[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DropdownValue[] | null>;
        }));
    }

    protected processGetRecipesDropdownValues(response: HttpResponseBase): Observable<DropdownValue[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DropdownValue.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Quicks the search ingredients.
     * @param name The input.
     * @return The ingredients containing the input string
     */
    quickSearchIngredientsByName(name: string): Observable<string[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Coaching/QuickSearchIngredientsByName/?name={name}";
        if (name === undefined || name === null)
            throw new Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processQuickSearchIngredientsByName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processQuickSearchIngredientsByName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[] | null>;
        }));
    }

    protected processQuickSearchIngredientsByName(response: HttpResponseBase): Observable<string[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates the activity.
     * @param activity The activity.
     * @return The task.
     */
    updateActivity(activity: UpdateCoachingActivity | null): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/Coaching/UpdateActivity";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(activity);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateActivity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateActivity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateActivity(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates the coaching.
     * @param coaching The coaching.
     */
    updateCoaching(coaching: CoachingDetails | null): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/Coaching/UpdateCoaching";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(coaching);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCoaching(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCoaching(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateCoaching(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates the recipe.
     * @param recipe The recipe.
     * @return The task.
     */
    updateRecipe(recipe: UpdateCoachingRecipe | null): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/Coaching/UpdateRecipe";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(recipe);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateRecipe(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateRecipe(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateRecipe(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates the coaching recipe status.
     * @param id The identifier.
     * @param status if set to true [status].
     */
    updateCoachingRecipeStatus(id: number, status: boolean): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/Coaching/UpdateCoachingRecipeStatus/{id}?status={status}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (status === undefined || status === null)
            throw new Error("The parameter 'status' must be defined.");
        url_ = url_.replace("{status}", encodeURIComponent("" + status));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCoachingRecipeStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCoachingRecipeStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateCoachingRecipeStatus(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates the coaching status.
     * @param id The identifier.
     * @param status if set to true [status].
     */
    updateCoachingStatus(id: number, status: boolean): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/Coaching/UpdateCoachingStatus/{id}?status={status}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (status === undefined || status === null)
            throw new Error("The parameter 'status' must be defined.");
        url_ = url_.replace("{status}", encodeURIComponent("" + status));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCoachingStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCoachingStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateCoachingStatus(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Exports the coaching activity asynchronous.
     * @param coachingId The coaching activity.
     * @param patientId The patient Identifier.
     * @return The task.
     */
    exportCoaching(coachingId: number, patientId: number): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Coaching/ExportCoaching/?coachingId={coachingId}&patientId={patientId}";
        if (coachingId === undefined || coachingId === null)
            throw new Error("The parameter 'coachingId' must be defined.");
        url_ = url_.replace("{coachingId}", encodeURIComponent("" + coachingId));
        if (patientId === undefined || patientId === null)
            throw new Error("The parameter 'patientId' must be defined.");
        url_ = url_.replace("{patientId}", encodeURIComponent("" + patientId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportCoaching(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportCoaching(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processExportCoaching(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Exports the coaching activity asynchronous.
     * @param coachingActivityId The coaching activity.
     * @return The task.
     */
    exportCoachingActivity(coachingActivityId: number): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Coaching/ExportCoachingActivity/?coachingActivityId={coachingActivityId}";
        if (coachingActivityId === undefined || coachingActivityId === null)
            throw new Error("The parameter 'coachingActivityId' must be defined.");
        url_ = url_.replace("{coachingActivityId}", encodeURIComponent("" + coachingActivityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportCoachingActivity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportCoachingActivity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processExportCoachingActivity(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Exports the coaching recipe asynchronous.
     * @param coachingRecipeId The coaching activity.
     * @return The task.
     */
    exportCoachingRecipe(coachingRecipeId: number): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Coaching/ExportCoachingRecipe/?coachingRecipeId={coachingRecipeId}";
        if (coachingRecipeId === undefined || coachingRecipeId === null)
            throw new Error("The parameter 'coachingRecipeId' must be defined.");
        url_ = url_.replace("{coachingRecipeId}", encodeURIComponent("" + coachingRecipeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportCoachingRecipe(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportCoachingRecipe(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processExportCoachingRecipe(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates the disease category status.
     * @param id The identifier.
     * @param status if set to true [status].
     */
    updateActivityStatus(id: number, status: boolean): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/Coaching/UpdateActivityStatus/{id}?status={status}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (status === undefined || status === null)
            throw new Error("The parameter 'status' must be defined.");
        url_ = url_.replace("{status}", encodeURIComponent("" + status));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateActivityStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateActivityStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateActivityStatus(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ConsultInFormularyRepository {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Creates the formulary.
     * @param formulary The formulary.
     * @return The id of the created formulary
     */
    createFormulary(formulary: CreateConsultInFormularyVersion | null): Observable<StatusValueResourceOfInteger | null> {
        let url_ = this.baseUrl + "/umbraco/Api/ConsultInFormulary/CreateFormulary";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(formulary);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateFormulary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateFormulary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StatusValueResourceOfInteger | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StatusValueResourceOfInteger | null>;
        }));
    }

    protected processCreateFormulary(response: HttpResponseBase): Observable<StatusValueResourceOfInteger | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? StatusValueResourceOfInteger.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Creates the question.
     * @param createQuestion The question.
     * @return The status
     */
    createQuestion(createQuestion: CreateQuestion | null): Observable<StatusValueResourceOfInteger | null> {
        let url_ = this.baseUrl + "/umbraco/Api/ConsultInFormulary/CreateQuestion";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createQuestion);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateQuestion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateQuestion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StatusValueResourceOfInteger | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StatusValueResourceOfInteger | null>;
        }));
    }

    protected processCreateQuestion(response: HttpResponseBase): Observable<StatusValueResourceOfInteger | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? StatusValueResourceOfInteger.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Creates the result.
     * @param createFormularyResult The result.
     * @return The status and the id of the created result
     */
    createResult(createFormularyResult: CreateFormularyResult | null): Observable<StatusValueResourceOfInteger | null> {
        let url_ = this.baseUrl + "/umbraco/Api/ConsultInFormulary/CreateResult";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createFormularyResult);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateResult(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateResult(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StatusValueResourceOfInteger | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StatusValueResourceOfInteger | null>;
        }));
    }

    protected processCreateResult(response: HttpResponseBase): Observable<StatusValueResourceOfInteger | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? StatusValueResourceOfInteger.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Deletes the formulary.
     * @param id The identifier.
     */
    deleteFormulary(id: number): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/ConsultInFormulary/DeleteFormulary/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteFormulary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteFormulary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteFormulary(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Deletes the question.
     * @param id The identifier.
     * @return The status of the operation.
     */
    deleteQuestion(id: number): Observable<StatusValueResourceOfInteger | null> {
        let url_ = this.baseUrl + "/umbraco/Api/ConsultInFormulary/DeleteQuestion/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteQuestion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteQuestion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StatusValueResourceOfInteger | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StatusValueResourceOfInteger | null>;
        }));
    }

    protected processDeleteQuestion(response: HttpResponseBase): Observable<StatusValueResourceOfInteger | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? StatusValueResourceOfInteger.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Deletes the result.
     * @param id The identifier.
     * @return The status
     */
    deleteResult(id: number): Observable<StatusValueResourceOfInteger | null> {
        let url_ = this.baseUrl + "/umbraco/Api/ConsultInFormulary/DeleteResult/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteResult(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteResult(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StatusValueResourceOfInteger | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StatusValueResourceOfInteger | null>;
        }));
    }

    protected processDeleteResult(response: HttpResponseBase): Observable<StatusValueResourceOfInteger | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? StatusValueResourceOfInteger.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Exports the empty formulary asynchronous.
     * @param formularyVersionId The formulary version identifier.
     * @return An async task
     */
    exportEmptyFormulary(formularyVersionId: number): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/umbraco/Api/ConsultInFormulary/ExportEmptyFormulary/?formularyVersionId={formularyVersionId}";
        if (formularyVersionId === undefined || formularyVersionId === null)
            throw new Error("The parameter 'formularyVersionId' must be defined.");
        url_ = url_.replace("{formularyVersionId}", encodeURIComponent("" + formularyVersionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportEmptyFormulary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportEmptyFormulary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processExportEmptyFormulary(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Exports the filled formulary asynchronous.
     * @param formularyVersionId The formulary version identifier.
     * @param consultationId The consultation identifier.
     * @return An asynchronous task
     */
    exportFilledFormulary(formularyVersionId: number, consultationId: number): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/umbraco/Api/ConsultInFormulary/ExportFilledFormulary/?formularyVersionId={formularyVersionId}&consultationId={consultationId}";
        if (formularyVersionId === undefined || formularyVersionId === null)
            throw new Error("The parameter 'formularyVersionId' must be defined.");
        url_ = url_.replace("{formularyVersionId}", encodeURIComponent("" + formularyVersionId));
        if (consultationId === undefined || consultationId === null)
            throw new Error("The parameter 'consultationId' must be defined.");
        url_ = url_.replace("{consultationId}", encodeURIComponent("" + consultationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportFilledFormulary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportFilledFormulary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processExportFilledFormulary(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * reorder formulary questions.
     * @param questionId The question identifier.
     * @param newSortOrder The new sort order.
     */
    reorderFormularyQuestions(questionId: number, newSortOrder: number): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/ConsultInFormulary/ReorderFormularyQuestions/?questionId={questionId}&newSortOrder={newSortOrder}";
        if (questionId === undefined || questionId === null)
            throw new Error("The parameter 'questionId' must be defined.");
        url_ = url_.replace("{questionId}", encodeURIComponent("" + questionId));
        if (newSortOrder === undefined || newSortOrder === null)
            throw new Error("The parameter 'newSortOrder' must be defined.");
        url_ = url_.replace("{newSortOrder}", encodeURIComponent("" + newSortOrder));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReorderFormularyQuestions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReorderFormularyQuestions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processReorderFormularyQuestions(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the answers.
     * @param questionId The question identifier.
     * @return The desired answers
     */
    getAnswers(questionId: number): Observable<Answer[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/ConsultInFormulary/GetAnswers/?questionId={questionId}";
        if (questionId === undefined || questionId === null)
            throw new Error("The parameter 'questionId' must be defined.");
        url_ = url_.replace("{questionId}", encodeURIComponent("" + questionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAnswers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAnswers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Answer[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Answer[] | null>;
        }));
    }

    protected processGetAnswers(response: HttpResponseBase): Observable<Answer[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Answer.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the answer.
     * @param id The identifier.
     * @return The desired answer
     */
    getAnswer(id: number): Observable<Answer | null> {
        let url_ = this.baseUrl + "/umbraco/Api/ConsultInFormulary/GetAnswer/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAnswer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAnswer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Answer | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Answer | null>;
        }));
    }

    protected processGetAnswer(response: HttpResponseBase): Observable<Answer | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? Answer.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the formulary.
     * @param id The identifier.
     * @return The desired formulary
     */
    getFormulary(id: number): Observable<ConsultInFormularyVersionDetails | null> {
        let url_ = this.baseUrl + "/umbraco/Api/ConsultInFormulary/GetFormulary/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFormulary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFormulary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConsultInFormularyVersionDetails | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConsultInFormularyVersionDetails | null>;
        }));
    }

    protected processGetFormulary(response: HttpResponseBase): Observable<ConsultInFormularyVersionDetails | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ConsultInFormularyVersionDetails.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the formulary.
     * @param id The identifier.
     * @return The desired formulary
     */
    getFormularyForProVisualisation(id: number): Observable<ConsultInFormularyVersionDetails | null> {
        let url_ = this.baseUrl + "/umbraco/Api/ConsultInFormulary/GetFormularyForProVisualisation/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFormularyForProVisualisation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFormularyForProVisualisation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConsultInFormularyVersionDetails | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConsultInFormularyVersionDetails | null>;
        }));
    }

    protected processGetFormularyForProVisualisation(response: HttpResponseBase): Observable<ConsultInFormularyVersionDetails | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ConsultInFormularyVersionDetails.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the filtered formularies.
     * @param searchParams The identifier.
     * @return The Formularies filtered
     */
    getFormulariesForLibrary(searchParams: ConsultInFormularySearchParams | null): Observable<PaginatorWrapperOfIEnumerableOfConsultInFormularyVersion | null> {
        let url_ = this.baseUrl + "/umbraco/Api/ConsultInFormulary/GetFormulariesForLibrary";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchParams);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFormulariesForLibrary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFormulariesForLibrary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaginatorWrapperOfIEnumerableOfConsultInFormularyVersion | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaginatorWrapperOfIEnumerableOfConsultInFormularyVersion | null>;
        }));
    }

    protected processGetFormulariesForLibrary(response: HttpResponseBase): Observable<PaginatorWrapperOfIEnumerableOfConsultInFormularyVersion | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PaginatorWrapperOfIEnumerableOfConsultInFormularyVersion.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the formularies.
     * @param searchParams The search parameters.
     * @return All formularies
     */
    getFormularies(searchParams: ConsultInFormularyBackOfficeSearchParams | null): Observable<ConsultInFormularyVersion[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/ConsultInFormulary/GetFormularies";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchParams);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFormularies(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFormularies(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConsultInFormularyVersion[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConsultInFormularyVersion[] | null>;
        }));
    }

    protected processGetFormularies(response: HttpResponseBase): Observable<ConsultInFormularyVersion[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ConsultInFormularyVersion.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the formulary for consultation creation.
     * @param consultationCreationSearch The consultation creation search.
     * @return the formulary for the consultation creation.
     */
    getFormulariesForConsultationCreation(consultationCreationSearch: ConsultationCreationSearch | null): Observable<FormularyConsultationCreation[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/ConsultInFormulary/GetFormulariesForConsultationCreation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(consultationCreationSearch);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFormulariesForConsultationCreation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFormulariesForConsultationCreation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FormularyConsultationCreation[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FormularyConsultationCreation[] | null>;
        }));
    }

    protected processGetFormulariesForConsultationCreation(response: HttpResponseBase): Observable<FormularyConsultationCreation[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FormularyConsultationCreation.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the formulary for consultation creation.
     * @param consultationId The consultation creation search.
     * @param patientId The patient identifier.
     * @return the formulary for the consultation creation.
     */
    getFormularyForConsultationUpdate(consultationId: number, patientId: number): Observable<FormularyConsultationCreation[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/ConsultInFormulary/GetFormularyForConsultationUpdate/?consultationId={consultationId}&patientId={patientId}";
        if (consultationId === undefined || consultationId === null)
            throw new Error("The parameter 'consultationId' must be defined.");
        url_ = url_.replace("{consultationId}", encodeURIComponent("" + consultationId));
        if (patientId === undefined || patientId === null)
            throw new Error("The parameter 'patientId' must be defined.");
        url_ = url_.replace("{patientId}", encodeURIComponent("" + patientId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFormularyForConsultationUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFormularyForConsultationUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FormularyConsultationCreation[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FormularyConsultationCreation[] | null>;
        }));
    }

    protected processGetFormularyForConsultationUpdate(response: HttpResponseBase): Observable<FormularyConsultationCreation[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FormularyConsultationCreation.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the questions.
     * @param formularyId The formulary identifier.
     * @return The desired questions
     */
    getQuestions(formularyId: number): Observable<Question[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/ConsultInFormulary/GetQuestions/?formularyId={formularyId}";
        if (formularyId === undefined || formularyId === null)
            throw new Error("The parameter 'formularyId' must be defined.");
        url_ = url_.replace("{formularyId}", encodeURIComponent("" + formularyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetQuestions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetQuestions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Question[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Question[] | null>;
        }));
    }

    protected processGetQuestions(response: HttpResponseBase): Observable<Question[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Question.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the questions dropdown values.
     * @param formularyVersionId The formulary version identifier.
     */
    getQuestionsDropdownValues(formularyVersionId: number): Observable<DropdownValue[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/ConsultInFormulary/GetQuestionsDropdownValues/?formularyVersionId={formularyVersionId}";
        if (formularyVersionId === undefined || formularyVersionId === null)
            throw new Error("The parameter 'formularyVersionId' must be defined.");
        url_ = url_.replace("{formularyVersionId}", encodeURIComponent("" + formularyVersionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetQuestionsDropdownValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetQuestionsDropdownValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DropdownValue[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DropdownValue[] | null>;
        }));
    }

    protected processGetQuestionsDropdownValues(response: HttpResponseBase): Observable<DropdownValue[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DropdownValue.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the published formularies.
     * @return The published formularies.
     */
    getPublishedFormularies(): Observable<ConsultInFormularyVersion[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/ConsultInFormulary/GetPublishedFormularies";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPublishedFormularies(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPublishedFormularies(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConsultInFormularyVersion[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConsultInFormularyVersion[] | null>;
        }));
    }

    protected processGetPublishedFormularies(response: HttpResponseBase): Observable<ConsultInFormularyVersion[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ConsultInFormularyVersion.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the published formularies.
     * @param consultationReasonId The consultation reason identifier.
     * @return The published formularies.
     */
    getPublishedFormulariesForConsultationReasons(consultationReasonId: number): Observable<ConsultInFormularyVersion[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/ConsultInFormulary/GetPublishedFormulariesForConsultationReasons/?consultationReasonId={consultationReasonId}";
        if (consultationReasonId === undefined || consultationReasonId === null)
            throw new Error("The parameter 'consultationReasonId' must be defined.");
        url_ = url_.replace("{consultationReasonId}", encodeURIComponent("" + consultationReasonId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPublishedFormulariesForConsultationReasons(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPublishedFormulariesForConsultationReasons(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConsultInFormularyVersion[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConsultInFormularyVersion[] | null>;
        }));
    }

    protected processGetPublishedFormulariesForConsultationReasons(response: HttpResponseBase): Observable<ConsultInFormularyVersion[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ConsultInFormularyVersion.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the question.
     * @param id The identifier.
     * @return The desired question
     */
    getQuestion(id: number): Observable<Question | null> {
        let url_ = this.baseUrl + "/umbraco/Api/ConsultInFormulary/GetQuestion/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetQuestion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetQuestion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Question | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Question | null>;
        }));
    }

    protected processGetQuestion(response: HttpResponseBase): Observable<Question | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? Question.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the result.
     * @param id The identifier.
     * @return The expected result
     */
    getResult(id: number): Observable<FormularyResult | null> {
        let url_ = this.baseUrl + "/umbraco/Api/ConsultInFormulary/GetResult/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetResult(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetResult(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FormularyResult | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FormularyResult | null>;
        }));
    }

    protected processGetResult(response: HttpResponseBase): Observable<FormularyResult | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FormularyResult.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the suggested formularies.
     * @param search The search.
     * @return The suggested formularies
     */
    getSuggestedFormularies(search: FormularySuggestionSearch | null): Observable<ConsultInFormularyVersion[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/ConsultInFormulary/GetSuggestedFormularies";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(search);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSuggestedFormularies(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSuggestedFormularies(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConsultInFormularyVersion[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConsultInFormularyVersion[] | null>;
        }));
    }

    protected processGetSuggestedFormularies(response: HttpResponseBase): Observable<ConsultInFormularyVersion[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ConsultInFormularyVersion.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates the formulary.
     * @param formulary The Formulary.
     * @return The status.
     */
    updateFormulary(formulary: UpdateConsultInFormularyVersion | null): Observable<StatusValueResourceOfInteger | null> {
        let url_ = this.baseUrl + "/umbraco/Api/ConsultInFormulary/UpdateFormulary";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(formulary);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateFormulary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateFormulary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StatusValueResourceOfInteger | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StatusValueResourceOfInteger | null>;
        }));
    }

    protected processUpdateFormulary(response: HttpResponseBase): Observable<StatusValueResourceOfInteger | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? StatusValueResourceOfInteger.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates the question.
     * @param updateQuestion The question.
     * @return The status
     */
    updateQuestion(updateQuestion: UpdateQuestion | null): Observable<StatusValueResourceOfInteger | null> {
        let url_ = this.baseUrl + "/umbraco/Api/ConsultInFormulary/UpdateQuestion";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateQuestion);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateQuestion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateQuestion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StatusValueResourceOfInteger | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StatusValueResourceOfInteger | null>;
        }));
    }

    protected processUpdateQuestion(response: HttpResponseBase): Observable<StatusValueResourceOfInteger | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? StatusValueResourceOfInteger.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates the result.
     * @param updateFormularyResult The result.
     * @return The status.
     */
    updateResult(updateFormularyResult: UpdateFormularyResult | null): Observable<StatusValueResourceOfInteger | null> {
        let url_ = this.baseUrl + "/umbraco/Api/ConsultInFormulary/UpdateResult";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateFormularyResult);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateResult(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateResult(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StatusValueResourceOfInteger | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StatusValueResourceOfInteger | null>;
        }));
    }

    protected processUpdateResult(response: HttpResponseBase): Observable<StatusValueResourceOfInteger | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? StatusValueResourceOfInteger.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ConsultInListingRepository {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Creates a biological exam
     * @param biologicalExam the biological exam
     * @return The biological exam id.
     */
    createBiologicalExam(biologicalExam: CreateBiologicalExam | null): Observable<number> {
        let url_ = this.baseUrl + "/umbraco/Api/ConsultInListing/CreateBiologicalExam";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(biologicalExam);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateBiologicalExam(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateBiologicalExam(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateBiologicalExam(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Creates a set of biological exams.
     * @param biologicalExamSet The set of biological exams.
     * @return The identifier of the biological exam set.
     */
    createBiologicalExamSet(biologicalExamSet: BiologicalExamSet | null): Observable<number> {
        let url_ = this.baseUrl + "/umbraco/Api/ConsultInListing/CreateBiologicalExamSet";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(biologicalExamSet);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateBiologicalExamSet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateBiologicalExamSet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateBiologicalExamSet(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Creates a custom biological exam
     * @param biologicalExam the biological exam
     * @return The biological id.
     */
    createCustomBiologicalExam(biologicalExam: CreateBiologicalExam | null): Observable<number> {
        let url_ = this.baseUrl + "/umbraco/Api/ConsultInListing/CreateCustomBiologicalExam";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(biologicalExam);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateCustomBiologicalExam(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateCustomBiologicalExam(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateCustomBiologicalExam(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Creates the specified exam.
     * @param exam The exam.
     * @return The id of the created exam.
     */
    createComplementaryExam(exam: CreateComplementaryExam | null): Observable<number> {
        let url_ = this.baseUrl + "/umbraco/Api/ConsultInListing/CreateComplementaryExam";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(exam);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateComplementaryExam(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateComplementaryExam(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateComplementaryExam(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Creates a custom complementary exam.
     * @param exam The exam.
     * @return The id of the created custom exam.
     */
    createCustomComplementaryExam(exam: CreateComplementaryExam | null): Observable<number> {
        let url_ = this.baseUrl + "/umbraco/Api/ConsultInListing/CreateCustomComplementaryExam";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(exam);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateCustomComplementaryExam(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateCustomComplementaryExam(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateCustomComplementaryExam(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Creates the disease.
     * @param creatDisease The disease.
     * @return The id of the created diseaseDisease
     */
    createDisease(creatDisease: CreateDisease | null): Observable<number> {
        let url_ = this.baseUrl + "/umbraco/Api/ConsultInListing/CreateDisease";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(creatDisease);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateDisease(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateDisease(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateDisease(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Creates the disease category.
     * @param category The disease.
     * @return The id of the created disease categoryDiseaseCategory
     */
    createDiseaseCategory(category: DiseaseCategory | null): Observable<number> {
        let url_ = this.baseUrl + "/umbraco/Api/ConsultInListing/CreateDiseaseCategory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(category);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateDiseaseCategory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateDiseaseCategory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateDiseaseCategory(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param id The identifier.
     */
    deleteComplementaryExam(id: number): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/ConsultInListing/DeleteComplementaryExam/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteComplementaryExam(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteComplementaryExam(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteComplementaryExam(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Deletes a custom biological exam
     * @param id the identifier
     */
    deleteCustomBiologicalExam(id: number): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/ConsultInListing/DeleteCustomBiologicalExam/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteCustomBiologicalExam(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteCustomBiologicalExam(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteCustomBiologicalExam(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Deletes a biological exam set.
     * @param id The identifier.
     */
    deleteBiologicalExamSet(id: number): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/ConsultInListing/DeleteBiologicalExamSet/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteBiologicalExamSet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteBiologicalExamSet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteBiologicalExamSet(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Deletes the custom specified identifier.
     * @param id The identifier.
     */
    deleteCustomComplementaryExam(id: number): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/ConsultInListing/DeleteCustomComplementaryExam/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteCustomComplementaryExam(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteCustomComplementaryExam(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteCustomComplementaryExam(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Deletes the disease.
     * @param id The identifier.
     */
    deleteDisease(id: number): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/ConsultInListing/DeleteDisease/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteDisease(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteDisease(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteDisease(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Deletes the disease category.
     * @param id The identifier.
     */
    deleteDiseaseCategory(id: number): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/ConsultInListing/DeleteDiseaseCategory/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteDiseaseCategory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteDiseaseCategory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteDiseaseCategory(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the biological exams for library.
     * @param searchParams The search parameters.
     * @return Biological exam for library.
     */
    getBiologicalExamsForLibrary(searchParams: BiologicalExamSearchParams | null): Observable<PaginatorWrapperOfIEnumerableOfBiologicalExamWithWarnings | null> {
        let url_ = this.baseUrl + "/umbraco/Api/ConsultInListing/GetBiologicalExamsForLibrary";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchParams);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBiologicalExamsForLibrary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBiologicalExamsForLibrary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaginatorWrapperOfIEnumerableOfBiologicalExamWithWarnings | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaginatorWrapperOfIEnumerableOfBiologicalExamWithWarnings | null>;
        }));
    }

    protected processGetBiologicalExamsForLibrary(response: HttpResponseBase): Observable<PaginatorWrapperOfIEnumerableOfBiologicalExamWithWarnings | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PaginatorWrapperOfIEnumerableOfBiologicalExamWithWarnings.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets all exams.
     * @param complementaryExamSearchParams The search parameters.
     * @return All exams.
     */
    getComplementaryExams(complementaryExamSearchParams: ComplementaryExamSearchParams | null): Observable<ComplementaryExam[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/ConsultInListing/GetComplementaryExams";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(complementaryExamSearchParams);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetComplementaryExams(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetComplementaryExams(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ComplementaryExam[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ComplementaryExam[] | null>;
        }));
    }

    protected processGetComplementaryExams(response: HttpResponseBase): Observable<ComplementaryExam[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ComplementaryExam.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the biological exams.
     * @param biologicalExamSearchParams The search parameters.
     * @return All exams.
     */
    getBiologicalExams(biologicalExamSearchParams: BiologicalExamSearchParams | null): Observable<BiologicalExam[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/ConsultInListing/GetBiologicalExams";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(biologicalExamSearchParams);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBiologicalExams(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBiologicalExams(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BiologicalExam[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BiologicalExam[] | null>;
        }));
    }

    protected processGetBiologicalExams(response: HttpResponseBase): Observable<BiologicalExam[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BiologicalExam.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the biological exams sets.
     * @param biologicalExamSetSearchParams The search parameters.
     * @return The list of biological exam sets.
     */
    getBiologicalExamSetsForLibrary(biologicalExamSetSearchParams: BiologicalExamSetSearchParams | null): Observable<PaginatorWrapperOfIEnumerableOfConsultationBiologicalExamSet | null> {
        let url_ = this.baseUrl + "/umbraco/Api/ConsultInListing/GetBiologicalExamSetsForLibrary";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(biologicalExamSetSearchParams);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBiologicalExamSetsForLibrary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBiologicalExamSetsForLibrary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaginatorWrapperOfIEnumerableOfConsultationBiologicalExamSet | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaginatorWrapperOfIEnumerableOfConsultationBiologicalExamSet | null>;
        }));
    }

    protected processGetBiologicalExamSetsForLibrary(response: HttpResponseBase): Observable<PaginatorWrapperOfIEnumerableOfConsultationBiologicalExamSet | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PaginatorWrapperOfIEnumerableOfConsultationBiologicalExamSet.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the biological exams sets.
     * @param biologicalExamSetSearchParams The search parameters.
     * @return The list of biological exam sets.
     */
    getBiologicalExamSets(biologicalExamSetSearchParams: BiologicalExamSetSearchParams | null): Observable<BiologicalExamSet[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/ConsultInListing/GetBiologicalExamSets";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(biologicalExamSetSearchParams);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBiologicalExamSets(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBiologicalExamSets(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BiologicalExamSet[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BiologicalExamSet[] | null>;
        }));
    }

    protected processGetBiologicalExamSets(response: HttpResponseBase): Observable<BiologicalExamSet[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BiologicalExamSet.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Switches the biological exam set archived status
     * @param biologicalExamId The biological exam id.
     */
    switchBiologicalExamSetArchivedStatus(biologicalExamId: number): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/ConsultInListing/SwitchBiologicalExamSetArchivedStatus/?biologicalExamId={biologicalExamId}";
        if (biologicalExamId === undefined || biologicalExamId === null)
            throw new Error("The parameter 'biologicalExamId' must be defined.");
        url_ = url_.replace("{biologicalExamId}", encodeURIComponent("" + biologicalExamId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSwitchBiologicalExamSetArchivedStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSwitchBiologicalExamSetArchivedStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSwitchBiologicalExamSetArchivedStatus(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the biological exams set by id.
     * @param id The identifier.
     * @return The biological exam set.
     */
    getBiologicalExamSet(id: number): Observable<BiologicalExamSet | null> {
        let url_ = this.baseUrl + "/umbraco/Api/ConsultInListing/GetBiologicalExamSet/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBiologicalExamSet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBiologicalExamSet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BiologicalExamSet | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BiologicalExamSet | null>;
        }));
    }

    protected processGetBiologicalExamSet(response: HttpResponseBase): Observable<BiologicalExamSet | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? BiologicalExamSet.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the biological exam.
     * @param id The identifier.
     * @return The exam.
     */
    getBiologicalExam(id: number): Observable<BiologicalExam | null> {
        let url_ = this.baseUrl + "/umbraco/Api/ConsultInListing/GetBiologicalExam/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBiologicalExam(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBiologicalExam(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BiologicalExam | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BiologicalExam | null>;
        }));
    }

    protected processGetBiologicalExam(response: HttpResponseBase): Observable<BiologicalExam | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? BiologicalExam.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets list for dropdown.
     * @return The list for dropdown
     */
    getComplementaryExamsForDropdown(): Observable<DropdownValue[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/ConsultInListing/GetComplementaryExamsForDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetComplementaryExamsForDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetComplementaryExamsForDropdown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DropdownValue[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DropdownValue[] | null>;
        }));
    }

    protected processGetComplementaryExamsForDropdown(response: HttpResponseBase): Observable<DropdownValue[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DropdownValue.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets list for dropdown.
     * @return The list for dropdown
     */
    getBiologicalExamsForDropdown(): Observable<DropdownValue[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/ConsultInListing/GetBiologicalExamsForDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBiologicalExamsForDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBiologicalExamsForDropdown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DropdownValue[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DropdownValue[] | null>;
        }));
    }

    protected processGetBiologicalExamsForDropdown(response: HttpResponseBase): Observable<DropdownValue[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DropdownValue.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the complementary exams for library.
     * @param searchParams The search parameters.
     * @return Complementary exam for library.
     */
    getComplementaryExamsForLibrary(searchParams: ComplementaryExamSearchParams | null): Observable<PaginatorWrapperOfIEnumerableOfComplementaryExamWithWarnings | null> {
        let url_ = this.baseUrl + "/umbraco/Api/ConsultInListing/GetComplementaryExamsForLibrary";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchParams);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetComplementaryExamsForLibrary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetComplementaryExamsForLibrary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaginatorWrapperOfIEnumerableOfComplementaryExamWithWarnings | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaginatorWrapperOfIEnumerableOfComplementaryExamWithWarnings | null>;
        }));
    }

    protected processGetComplementaryExamsForLibrary(response: HttpResponseBase): Observable<PaginatorWrapperOfIEnumerableOfComplementaryExamWithWarnings | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PaginatorWrapperOfIEnumerableOfComplementaryExamWithWarnings.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the exam by identifier.
     * @param id The identifier.
     * @return The wanted exam
     */
    getComplemetaryExam(id: number): Observable<ComplementaryExam | null> {
        let url_ = this.baseUrl + "/umbraco/Api/ConsultInListing/GetComplemetaryExam/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetComplemetaryExam(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetComplemetaryExam(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ComplementaryExam | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ComplementaryExam | null>;
        }));
    }

    protected processGetComplemetaryExam(response: HttpResponseBase): Observable<ComplementaryExam | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ComplementaryExam.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the consultation type for library.
     * @param searchParam The search parameter.
     * @return the consultation types for the library MY.
     */
    getConsultationTypeForLibrary(searchParam: SearchParamConsultationTypeLibrary | null): Observable<PaginatorWrapperOfIEnumerableOfConsultationTypeLibrary | null> {
        let url_ = this.baseUrl + "/umbraco/Api/ConsultInListing/GetConsultationTypeForLibrary";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchParam);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConsultationTypeForLibrary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConsultationTypeForLibrary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaginatorWrapperOfIEnumerableOfConsultationTypeLibrary | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaginatorWrapperOfIEnumerableOfConsultationTypeLibrary | null>;
        }));
    }

    protected processGetConsultationTypeForLibrary(response: HttpResponseBase): Observable<PaginatorWrapperOfIEnumerableOfConsultationTypeLibrary | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PaginatorWrapperOfIEnumerableOfConsultationTypeLibrary.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the disease.
     * @param id The identifier.
     * @return The desired disease
     */
    getDisease(id: number): Observable<Disease | null> {
        let url_ = this.baseUrl + "/umbraco/Api/ConsultInListing/GetDisease/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDisease(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDisease(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Disease | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Disease | null>;
        }));
    }

    protected processGetDisease(response: HttpResponseBase): Observable<Disease | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? Disease.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the diseases by category.
     * @param id The identifier.
     * @return The desired diseases
     */
    getDiseaseByCategoryId(id: number): Observable<Disease[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/ConsultInListing/GetDiseaseByCategoryId/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDiseaseByCategoryId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDiseaseByCategoryId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Disease[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Disease[] | null>;
        }));
    }

    protected processGetDiseaseByCategoryId(response: HttpResponseBase): Observable<Disease[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Disease.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the disease categories.
     * @param isForBO (optional) if set to true [is for bo].
     * @return All disease categories.
     */
    getDiseaseCategories(isForBO?: boolean | undefined): Observable<DiseaseCategory[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/ConsultInListing/GetDiseaseCategories?";
        if (isForBO === null)
            throw new Error("The parameter 'isForBO' cannot be null.");
        else if (isForBO !== undefined)
            url_ += "isForBO=" + encodeURIComponent("" + isForBO) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDiseaseCategories(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDiseaseCategories(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DiseaseCategory[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DiseaseCategory[] | null>;
        }));
    }

    protected processGetDiseaseCategories(response: HttpResponseBase): Observable<DiseaseCategory[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DiseaseCategory.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the disease category with diseasese.
     * @return the categoris with their diseases.
     */
    getDiseaseCategoryWithDiseasese(): Observable<DiseaseCategoryDetails[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/ConsultInListing/GetDiseaseCategoryWithDiseasese";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDiseaseCategoryWithDiseasese(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDiseaseCategoryWithDiseasese(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DiseaseCategoryDetails[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DiseaseCategoryDetails[] | null>;
        }));
    }

    protected processGetDiseaseCategoryWithDiseasese(response: HttpResponseBase): Observable<DiseaseCategoryDetails[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DiseaseCategoryDetails.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the disease categories dropdown values.
     * @return Disease categories for dropdown
     */
    getDiseaseCategoriesDropdownValues(): Observable<DropdownValue[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/ConsultInListing/GetDiseaseCategoriesDropdownValues";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDiseaseCategoriesDropdownValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDiseaseCategoriesDropdownValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DropdownValue[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DropdownValue[] | null>;
        }));
    }

    protected processGetDiseaseCategoriesDropdownValues(response: HttpResponseBase): Observable<DropdownValue[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DropdownValue.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the disease category.
     * @param id The identifier.
     * @return The desired disease category
     */
    getDiseaseCategory(id: number): Observable<DiseaseCategory | null> {
        let url_ = this.baseUrl + "/umbraco/Api/ConsultInListing/GetDiseaseCategory/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDiseaseCategory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDiseaseCategory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DiseaseCategory | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DiseaseCategory | null>;
        }));
    }

    protected processGetDiseaseCategory(response: HttpResponseBase): Observable<DiseaseCategory | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? DiseaseCategory.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the disease details.
     * @param diseaseId The disease identifier.
     * @return The disease details.
     */
    getDiseaseDetails(diseaseId: number): Observable<DiseaseDetails | null> {
        let url_ = this.baseUrl + "/umbraco/Api/ConsultInListing/GetDiseaseDetails/?diseaseId={diseaseId}";
        if (diseaseId === undefined || diseaseId === null)
            throw new Error("The parameter 'diseaseId' must be defined.");
        url_ = url_.replace("{diseaseId}", encodeURIComponent("" + diseaseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDiseaseDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDiseaseDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DiseaseDetails | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DiseaseDetails | null>;
        }));
    }

    protected processGetDiseaseDetails(response: HttpResponseBase): Observable<DiseaseDetails | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? DiseaseDetails.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the disease details.
     * @param diseaseId The disease identifier.
     * @return The disease details.
     */
    getDiseaseDetailsForDoctor(diseaseId: number): Observable<DiseaseDetails | null> {
        let url_ = this.baseUrl + "/umbraco/Api/ConsultInListing/GetDiseaseDetailsForDoctor/?diseaseId={diseaseId}";
        if (diseaseId === undefined || diseaseId === null)
            throw new Error("The parameter 'diseaseId' must be defined.");
        url_ = url_.replace("{diseaseId}", encodeURIComponent("" + diseaseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDiseaseDetailsForDoctor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDiseaseDetailsForDoctor(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DiseaseDetails | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DiseaseDetails | null>;
        }));
    }

    protected processGetDiseaseDetailsForDoctor(response: HttpResponseBase): Observable<DiseaseDetails | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? DiseaseDetails.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the diseases.
     * @param searchParam The searchParam to filter research.
     * @return All diseases
     */
    getDiseases(searchParam: SearchParamDisease | null): Observable<Disease[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/ConsultInListing/GetDiseases";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchParam);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDiseases(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDiseases(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Disease[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Disease[] | null>;
        }));
    }

    protected processGetDiseases(response: HttpResponseBase): Observable<Disease[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Disease.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the diseases pro.
     * @param searchParam The search parameter.
     * @return All diseases
     */
    getDiseasesForLibrary(searchParam: SearchParamDiseaseLibrary | null): Observable<PaginatorWrapperOfIEnumerableOfDisease | null> {
        let url_ = this.baseUrl + "/umbraco/Api/ConsultInListing/GetDiseasesForLibrary";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchParam);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDiseasesForLibrary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDiseasesForLibrary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaginatorWrapperOfIEnumerableOfDisease | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaginatorWrapperOfIEnumerableOfDisease | null>;
        }));
    }

    protected processGetDiseasesForLibrary(response: HttpResponseBase): Observable<PaginatorWrapperOfIEnumerableOfDisease | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PaginatorWrapperOfIEnumerableOfDisease.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the diseases dropdown values.
     * @return Diseases for dropdown
     */
    getDiseasesDropdownValues(): Observable<SelectItemOfLiteDisease[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/ConsultInListing/GetDiseasesDropdownValues";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDiseasesDropdownValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDiseasesDropdownValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SelectItemOfLiteDisease[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SelectItemOfLiteDisease[] | null>;
        }));
    }

    protected processGetDiseasesDropdownValues(response: HttpResponseBase): Observable<SelectItemOfLiteDisease[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectItemOfLiteDisease.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get custom documents for library.
     * @param documentLibrarySearchParam consultation searchParam.
     * @return document + consult information for library
     */
    getDocumentsForLibrary(documentLibrarySearchParam: DocumentLibrarySearchParam | null): Observable<DocumentForLibrary[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/ConsultInListing/GetDocumentsForLibraryAsync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(documentLibrarySearchParam);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDocumentsForLibrary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDocumentsForLibrary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentForLibrary[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentForLibrary[] | null>;
        }));
    }

    protected processGetDocumentsForLibrary(response: HttpResponseBase): Observable<DocumentForLibrary[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DocumentForLibrary.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * get de document + consult information for library
     * @param documentLibrarySearchParam consultation searchParam.
     * @return document + consult information for library
     */
    getDocumentTemplateForLibrary(documentLibrarySearchParam: DocumentLibrarySearchParam | null): Observable<DocumentTemplateLibrary[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/ConsultInListing/GetDocumentTemplateForLibrary";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(documentLibrarySearchParam);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDocumentTemplateForLibrary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDocumentTemplateForLibrary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentTemplateLibrary[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentTemplateLibrary[] | null>;
        }));
    }

    protected processGetDocumentTemplateForLibrary(response: HttpResponseBase): Observable<DocumentTemplateLibrary[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DocumentTemplateLibrary.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the diseases dropdown values.
     * @return Diseases for dropdown
     */
    getLibraryDiseasesDropdownValues(): Observable<SelectItemOfLiteDisease[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/ConsultInListing/GetLibraryDiseasesDropdownValues";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLibraryDiseasesDropdownValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLibraryDiseasesDropdownValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SelectItemOfLiteDisease[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SelectItemOfLiteDisease[] | null>;
        }));
    }

    protected processGetLibraryDiseasesDropdownValues(response: HttpResponseBase): Observable<SelectItemOfLiteDisease[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectItemOfLiteDisease.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the nutrients details.
     * @return The list of nutrients details
     */
    getNutrientsDropDown(): Observable<DropdownValue[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/ConsultInListing/GetNutrientsDropDown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNutrientsDropDown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNutrientsDropDown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DropdownValue[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DropdownValue[] | null>;
        }));
    }

    protected processGetNutrientsDropDown(response: HttpResponseBase): Observable<DropdownValue[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DropdownValue.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Exports the disease asynchronous.
     * @param diseaseId The disease identifier.
     * @return The Disease to print.
     */
    exportDisease(diseaseId: number): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/umbraco/Api/ConsultInListing/ExportDisease/?diseaseId={diseaseId}";
        if (diseaseId === undefined || diseaseId === null)
            throw new Error("The parameter 'diseaseId' must be defined.");
        url_ = url_.replace("{diseaseId}", encodeURIComponent("" + diseaseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportDisease(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportDisease(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processExportDisease(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates the specified biological exam.
     * @param exam The biological exam.
     */
    updateBiologicalExam(exam: UpdateBiologicalExam | null): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/ConsultInListing/UpdateBiologicalExam";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(exam);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateBiologicalExam(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateBiologicalExam(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateBiologicalExam(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates the biological exam status.
     * @param id The identifier.
     * @param status if set to true [status].
     */
    updateBiologicalExamStatus(id: number, status: boolean): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/ConsultInListing/UpdateBiologicalExamStatus/{id}?status={status}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (status === undefined || status === null)
            throw new Error("The parameter 'status' must be defined.");
        url_ = url_.replace("{status}", encodeURIComponent("" + status));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateBiologicalExamStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateBiologicalExamStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateBiologicalExamStatus(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates the biological exam status.
     * @param id The identifier.
     * @param status if set to true [status].
     */
    updateCustomBiologicalExamStatus(id: number, status: boolean): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/ConsultInListing/UpdateCustomBiologicalExamStatus/{id}?status={status}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (status === undefined || status === null)
            throw new Error("The parameter 'status' must be defined.");
        url_ = url_.replace("{status}", encodeURIComponent("" + status));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCustomBiologicalExamStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCustomBiologicalExamStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateCustomBiologicalExamStatus(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates the specified custom biological exam.
     * @param exam The custom biological exam.
     */
    updateCustomBiologicalExam(exam: UpdateBiologicalExam | null): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/ConsultInListing/UpdateCustomBiologicalExam";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(exam);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCustomBiologicalExam(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCustomBiologicalExam(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateCustomBiologicalExam(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates a biological exam set
     * @param set The biological exam set.
     */
    updateBiologicalExamSet(set: BiologicalExamSet | null): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/ConsultInListing/UpdateBiologicalExamSet";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(set);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateBiologicalExamSet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateBiologicalExamSet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateBiologicalExamSet(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates the specified exam.
     * @param exam The exam.
     */
    updateComplementaryExam(exam: UpdateComplementaryExam | null): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/ConsultInListing/UpdateComplementaryExam";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(exam);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateComplementaryExam(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateComplementaryExam(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateComplementaryExam(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates the complementary exam status.
     * @param id The identifier.
     * @param status if set to true [status].
     */
    updateComplementaryExamStatus(id: number, status: boolean): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/ConsultInListing/UpdateComplementaryExamStatus/{id}?status={status}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (status === undefined || status === null)
            throw new Error("The parameter 'status' must be defined.");
        url_ = url_.replace("{status}", encodeURIComponent("" + status));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateComplementaryExamStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateComplementaryExamStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateComplementaryExamStatus(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates the consultation type status.
     * @param id The identifier.
     * @param status if set to true [status].
     */
    updateConsultationTypeStatus(id: number, status: boolean): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/ConsultInListing/UpdateConsultationTypeStatus/{id}?status={status}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (status === undefined || status === null)
            throw new Error("The parameter 'status' must be defined.");
        url_ = url_.replace("{status}", encodeURIComponent("" + status));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateConsultationTypeStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateConsultationTypeStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateConsultationTypeStatus(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates the disease category status.
     * @param id The identifier.
     * @param status if set to true [status].
     */
    updateDiseaseCategoryStatus(id: number, status: boolean): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/ConsultInListing/UpdateDiseaseCategoryStatus/{id}?status={status}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (status === undefined || status === null)
            throw new Error("The parameter 'status' must be defined.");
        url_ = url_.replace("{status}", encodeURIComponent("" + status));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateDiseaseCategoryStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateDiseaseCategoryStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateDiseaseCategoryStatus(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates the disease status.
     * @param id The identifier.
     * @param status if set to true [status].
     */
    updateDiseaseStatus(id: number, status: boolean): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/ConsultInListing/UpdateDiseaseStatus/{id}?status={status}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (status === undefined || status === null)
            throw new Error("The parameter 'status' must be defined.");
        url_ = url_.replace("{status}", encodeURIComponent("" + status));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateDiseaseStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateDiseaseStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateDiseaseStatus(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates the specified custom exam.
     * @param exam The custom exam.
     */
    updateCustomComplementaryExam(exam: UpdateComplementaryExam | null): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/ConsultInListing/UpdateCustomComplementaryExam";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(exam);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCustomComplementaryExam(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCustomComplementaryExam(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateCustomComplementaryExam(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates the specified disease
     * @param updateDisease The disease.
     */
    updateDisease(updateDisease: UpdateDisease | null): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/ConsultInListing/UpdateDisease";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateDisease);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateDisease(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateDisease(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateDisease(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates the specified disease category.
     * @param category The disease category.
     */
    updateDiseaseCategory(category: DiseaseCategory | null): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/ConsultInListing/UpdateDiseaseCategory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(category);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateDiseaseCategory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateDiseaseCategory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateDiseaseCategory(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates the allergy status.
     * @param id siin allergy id
     * @param status status
     */
    updateSiinAllergyStatus(id: number, status: boolean): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/ConsultInListing/UpdateSiinAllergyStatus/{id}?status={status}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (status === undefined || status === null)
            throw new Error("The parameter 'status' must be defined.");
        url_ = url_.replace("{status}", encodeURIComponent("" + status));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateSiinAllergyStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateSiinAllergyStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateSiinAllergyStatus(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ConsultInChatRepository {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Creates a consultIn message.
     * @param message The message.
     */
    createMessage(message: ConsultInMessage | null): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/ConsultInChat/CreateMessage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(message);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateMessage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateMessage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateMessage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the number of messages that have not been seen.
     * @return The number of messages that have not been seen.
     */
    getNumberOfMessagesNotSeen(): Observable<number> {
        let url_ = this.baseUrl + "/umbraco/Api/ConsultInChat/GetNumberOfMessagesNotSeen";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNumberOfMessagesNotSeen(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNumberOfMessagesNotSeen(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetNumberOfMessagesNotSeen(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Marks discussion as seen.
     * @param consultationId The consultation identifier.
     */
    markDiscussionAsSeen(consultationId: number): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/ConsultInChat/MarkDiscussionAsSeen/?consultationId={consultationId}";
        if (consultationId === undefined || consultationId === null)
            throw new Error("The parameter 'consultationId' must be defined.");
        url_ = url_.replace("{consultationId}", encodeURIComponent("" + consultationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMarkDiscussionAsSeen(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarkDiscussionAsSeen(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processMarkDiscussionAsSeen(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets discussion for current member by consultation identifier.
     * @param consultationId The consultation identifier.
     * @return The discussion.
     */
    getMessagesForCurrentMemberByConsultationId(consultationId: number): Observable<ConsultInDiscussion | null> {
        let url_ = this.baseUrl + "/umbraco/Api/ConsultInChat/GetMessagesForCurrentMemberByConsultationId/?consultationId={consultationId}";
        if (consultationId === undefined || consultationId === null)
            throw new Error("The parameter 'consultationId' must be defined.");
        url_ = url_.replace("{consultationId}", encodeURIComponent("" + consultationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMessagesForCurrentMemberByConsultationId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMessagesForCurrentMemberByConsultationId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConsultInDiscussion | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConsultInDiscussion | null>;
        }));
    }

    protected processGetMessagesForCurrentMemberByConsultationId(response: HttpResponseBase): Observable<ConsultInDiscussion | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ConsultInDiscussion.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets messages for current member by search params
     * @param chatSearchParams The chat search params.
     * @return The messages
     */
    getMessagesForCurrentMemberBySearchParams(chatSearchParams: ChatSearchParams | null): Observable<ConsultInDiscussion[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/ConsultInChat/GetMessagesForCurrentMemberBySearchParams";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(chatSearchParams);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMessagesForCurrentMemberBySearchParams(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMessagesForCurrentMemberBySearchParams(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConsultInDiscussion[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConsultInDiscussion[] | null>;
        }));
    }

    protected processGetMessagesForCurrentMemberBySearchParams(response: HttpResponseBase): Observable<ConsultInDiscussion[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ConsultInDiscussion.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class DoctorRepository {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Adds an integration code to doctors account.
     * @param integrationCode The integration code.
     */
    addDoctorIntegrationCode(integrationCode: string): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/Doctor/AddDoctorIntegrationCode/?integrationCode={integrationCode}";
        if (integrationCode === undefined || integrationCode === null)
            throw new Error("The parameter 'integrationCode' must be defined.");
        url_ = url_.replace("{integrationCode}", encodeURIComponent("" + integrationCode));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddDoctorIntegrationCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddDoctorIntegrationCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddDoctorIntegrationCode(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Activates the doctor sub user.
     * @param subUserId The sub user identifier.
     * @param value the value for activate or desactivate de subUser.
     */
    activateDoctorSubUser(subUserId: number, value: boolean): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/Doctor/ActivateDoctorSubUser/?subUserId={subUserId}&value={value}";
        if (subUserId === undefined || subUserId === null)
            throw new Error("The parameter 'subUserId' must be defined.");
        url_ = url_.replace("{subUserId}", encodeURIComponent("" + subUserId));
        if (value === undefined || value === null)
            throw new Error("The parameter 'value' must be defined.");
        url_ = url_.replace("{value}", encodeURIComponent("" + value));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processActivateDoctorSubUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processActivateDoctorSubUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processActivateDoctorSubUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Change Doctor Integration Code Status.
     * @param integrationPartnerId The integration partner identifier.
     * @param activationStatus The activation status.
     */
    changeDoctorIntegrationCodeStatus(integrationPartnerId: number, activationStatus: boolean): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/Doctor/ChangeDoctorIntegrationCodeStatus/?integrationPartnerId={integrationPartnerId}&activationStatus={activationStatus}";
        if (integrationPartnerId === undefined || integrationPartnerId === null)
            throw new Error("The parameter 'integrationPartnerId' must be defined.");
        url_ = url_.replace("{integrationPartnerId}", encodeURIComponent("" + integrationPartnerId));
        if (activationStatus === undefined || activationStatus === null)
            throw new Error("The parameter 'activationStatus' must be defined.");
        url_ = url_.replace("{activationStatus}", encodeURIComponent("" + activationStatus));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeDoctorIntegrationCodeStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeDoctorIntegrationCodeStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processChangeDoctorIntegrationCodeStatus(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the doctor integration partners.
     * @return The doctor.
     */
    getDoctorIntegrationPartners(): Observable<DoctorIntegrationPartner[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Doctor/GetDoctorIntegrationPartners";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDoctorIntegrationPartners(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDoctorIntegrationPartners(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DoctorIntegrationPartner[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DoctorIntegrationPartner[] | null>;
        }));
    }

    protected processGetDoctorIntegrationPartners(response: HttpResponseBase): Observable<DoctorIntegrationPartner[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DoctorIntegrationPartner.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the doctor sub users.
     * @return the subUsers details.
     */
    getDoctorSubUsers(): Observable<DoctorSubUser[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Doctor/GetDoctorSubUsers";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDoctorSubUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDoctorSubUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DoctorSubUser[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DoctorSubUser[] | null>;
        }));
    }

    protected processGetDoctorSubUsers(response: HttpResponseBase): Observable<DoctorSubUser[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DoctorSubUser.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * get the detail for a subUser
     * @param subUserId the subUser id
     * @return the detail for a subUser.
     */
    getDoctorSubUserDetail(subUserId: number): Observable<DoctorSubUserDetail | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Doctor/GetDoctorSubUserDetail/?subUserId={subUserId}";
        if (subUserId === undefined || subUserId === null)
            throw new Error("The parameter 'subUserId' must be defined.");
        url_ = url_.replace("{subUserId}", encodeURIComponent("" + subUserId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDoctorSubUserDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDoctorSubUserDetail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DoctorSubUserDetail | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DoctorSubUserDetail | null>;
        }));
    }

    protected processGetDoctorSubUserDetail(response: HttpResponseBase): Observable<DoctorSubUserDetail | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? DoctorSubUserDetail.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Determines whether [is consultation coming with this office] [the specified medical office identifier].
     * @param medicalOfficeId The medical office identifier.
     * @return true if [is consultation coming with this office] [the specified medical office identifier]; otherwise, false.
     */
    isConsultationComingWithThisOffice(medicalOfficeId: number): Observable<boolean> {
        let url_ = this.baseUrl + "/umbraco/Api/Doctor/IsConsultationComingWithThisOffice/?medicalOfficeId={medicalOfficeId}";
        if (medicalOfficeId === undefined || medicalOfficeId === null)
            throw new Error("The parameter 'medicalOfficeId' must be defined.");
        url_ = url_.replace("{medicalOfficeId}", encodeURIComponent("" + medicalOfficeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsConsultationComingWithThisOffice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsConsultationComingWithThisOffice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processIsConsultationComingWithThisOffice(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Creats the medical office.
     * @param createMedicalOffice The create medical office.
     * @return the created id.
     */
    createMedicalOffice(createMedicalOffice: CreateMedicalOffice | null): Observable<number> {
        let url_ = this.baseUrl + "/umbraco/Api/Doctor/CreateMedicalOffice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createMedicalOffice);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateMedicalOffice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateMedicalOffice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateMedicalOffice(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Creates the sub user.
     * @param doctorSubUserCreation The doctor sub user creation.
     */
    createSubUser(doctorSubUserCreation: DoctorSubUserCreation | null): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/Doctor/CreateSubUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(doctorSubUserCreation);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateSubUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateSubUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateSubUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete the sub user.
     * @param subUserId The sub user id
     */
    deleteSubUser(subUserId: number): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/Doctor/DeleteSubUser/?subUserId={subUserId}";
        if (subUserId === undefined || subUserId === null)
            throw new Error("The parameter 'subUserId' must be defined.");
        url_ = url_.replace("{subUserId}", encodeURIComponent("" + subUserId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteSubUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteSubUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteSubUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Exports the monthly invoice asynchronous.
     * @param month The month.
     * @param insuranceId The insurance identifier.
     * @return The monthly invoice
     */
    exportMonthlyInvoice(month: Date, insuranceId: number): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Doctor/ExportMonthlyInvoiceAsync/?month={month}&insuranceId={insuranceId}";
        if (month === undefined || month === null)
            throw new Error("The parameter 'month' must be defined.");
        url_ = url_.replace("{month}", encodeURIComponent(month ? "" + month.toISOString() : "null"));
        if (insuranceId === undefined || insuranceId === null)
            throw new Error("The parameter 'insuranceId' must be defined.");
        url_ = url_.replace("{insuranceId}", encodeURIComponent("" + insuranceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportMonthlyInvoice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportMonthlyInvoice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processExportMonthlyInvoice(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the current doctor exportable invoices months.
     * @return The exportable invoices months for the current doctor
     */
    getCurrentDoctorBillableInsurances(): Observable<BillableInsurance[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Doctor/GetCurrentDoctorBillableInsurances";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentDoctorBillableInsurances(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentDoctorBillableInsurances(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BillableInsurance[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BillableInsurance[] | null>;
        }));
    }

    protected processGetCurrentDoctorBillableInsurances(response: HttpResponseBase): Observable<BillableInsurance[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BillableInsurance.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the current doctor billing infos.
     * @return The current doctorbillinginfos
     */
    getCurrentDoctorBillingInfos(): Observable<DoctorBillingInfos | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Doctor/GetCurrentDoctorBillingInfos";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentDoctorBillingInfos(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentDoctorBillingInfos(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DoctorBillingInfos | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DoctorBillingInfos | null>;
        }));
    }

    protected processGetCurrentDoctorBillingInfos(response: HttpResponseBase): Observable<DoctorBillingInfos | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? DoctorBillingInfos.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the current doctor billing infos.
     * @param doctorId The doctor id.
     * @param consultationId The consultation id.
     * @return The payment infos.
     */
    getDoctorPaymentInfosById(doctorId: number, consultationId: number): Observable<DoctorPaymentInfos | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Doctor/GetDoctorPaymentInfosById/?doctorId={doctorId}&consultationId={consultationId}";
        if (doctorId === undefined || doctorId === null)
            throw new Error("The parameter 'doctorId' must be defined.");
        url_ = url_.replace("{doctorId}", encodeURIComponent("" + doctorId));
        if (consultationId === undefined || consultationId === null)
            throw new Error("The parameter 'consultationId' must be defined.");
        url_ = url_.replace("{consultationId}", encodeURIComponent("" + consultationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDoctorPaymentInfosById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDoctorPaymentInfosById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DoctorPaymentInfos | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DoctorPaymentInfos | null>;
        }));
    }

    protected processGetDoctorPaymentInfosById(response: HttpResponseBase): Observable<DoctorPaymentInfos | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? DoctorPaymentInfos.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the current doctor information.
     * @return The current doctor infos.
     */
    getCurrentDoctorInfo(): Observable<CurrentDoctorInfo | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Doctor/GetCurrentDoctorInfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentDoctorInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentDoctorInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CurrentDoctorInfo | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CurrentDoctorInfo | null>;
        }));
    }

    protected processGetCurrentDoctorInfo(response: HttpResponseBase): Observable<CurrentDoctorInfo | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CurrentDoctorInfo.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the current doctor patients.
     * @param searchParams The search parameters.
     * @return The current doctor patients
     */
    getCurrentDoctorPatients(searchParams: DoctorPatientsSearchParams | null): Observable<PaginatorWrapperOfIEnumerableOfDoctorPatient | null> {
        let url_ = this.baseUrl + "/umbraco/api/Doctor/GetCurrentDoctorPatients";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchParams);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentDoctorPatients(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentDoctorPatients(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaginatorWrapperOfIEnumerableOfDoctorPatient | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaginatorWrapperOfIEnumerableOfDoctorPatient | null>;
        }));
    }

    protected processGetCurrentDoctorPatients(response: HttpResponseBase): Observable<PaginatorWrapperOfIEnumerableOfDoctorPatient | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PaginatorWrapperOfIEnumerableOfDoctorPatient.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the current doctor patient.
     * @param patientId The patient identifier.
     * @return The current doctor patient
     */
    getCurrentDoctorPatient(patientId: number): Observable<DoctorPatient | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Doctor/GetCurrentDoctorPatient/?patientId={patientId}";
        if (patientId === undefined || patientId === null)
            throw new Error("The parameter 'patientId' must be defined.");
        url_ = url_.replace("{patientId}", encodeURIComponent("" + patientId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentDoctorPatient(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentDoctorPatient(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DoctorPatient | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DoctorPatient | null>;
        }));
    }

    protected processGetCurrentDoctorPatient(response: HttpResponseBase): Observable<DoctorPatient | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? DoctorPatient.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the doctor consultation configuration.
     * @param doctorId The doctor identifier.
     * @return the consultation configuration from the doctor profile configuration.
     */
    getDoctorConsultationConfiguration(doctorId: number): Observable<DoctorAppointmentConfiguration | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Doctor/GetDoctorConsultationConfiguration/?doctorId={doctorId}";
        if (doctorId === undefined || doctorId === null)
            throw new Error("The parameter 'doctorId' must be defined.");
        url_ = url_.replace("{doctorId}", encodeURIComponent("" + doctorId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDoctorConsultationConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDoctorConsultationConfiguration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DoctorAppointmentConfiguration | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DoctorAppointmentConfiguration | null>;
        }));
    }

    protected processGetDoctorConsultationConfiguration(response: HttpResponseBase): Observable<DoctorAppointmentConfiguration | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? DoctorAppointmentConfiguration.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the doctor medical offices.
     * @return The list of medical office of a doctor.
     */
    getDoctorMedicalOffices(): Observable<MedicalOffice[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Doctor/GetDoctorMedicalOffices";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDoctorMedicalOffices(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDoctorMedicalOffices(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MedicalOffice[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MedicalOffice[] | null>;
        }));
    }

    protected processGetDoctorMedicalOffices(response: HttpResponseBase): Observable<MedicalOffice[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MedicalOffice.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the doctor medical office.
     * @param id The identifier.
     * @return the medical office
     */
    getDoctorMedicalOffice(id: number): Observable<MedicalOffice | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Doctor/GetDoctorMedicalOffice/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDoctorMedicalOffice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDoctorMedicalOffice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MedicalOffice | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MedicalOffice | null>;
        }));
    }

    protected processGetDoctorMedicalOffice(response: HttpResponseBase): Observable<MedicalOffice | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? MedicalOffice.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the medical office drop down.
     * @param doctorId The doctor identifier.
     * @return the dropdown value for medical office of a doctor.
     */
    getMedicalOfficeDropDown(doctorId: number): Observable<DropdownValue[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Doctor/GetMedicalOfficeDropDown/?doctorId={doctorId}";
        if (doctorId === undefined || doctorId === null)
            throw new Error("The parameter 'doctorId' must be defined.");
        url_ = url_.replace("{doctorId}", encodeURIComponent("" + doctorId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMedicalOfficeDropDown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMedicalOfficeDropDown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DropdownValue[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DropdownValue[] | null>;
        }));
    }

    protected processGetMedicalOfficeDropDown(response: HttpResponseBase): Observable<DropdownValue[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DropdownValue.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the languages for dropdown.
     * @return The languages for dropdown.
     */
    getDropdownLanguages(): Observable<string[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Doctor/GetDropdownLanguages";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDropdownLanguages(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDropdownLanguages(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[] | null>;
        }));
    }

    protected processGetDropdownLanguages(response: HttpResponseBase): Observable<string[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the doctor profile.
     * @return the doctor profile
     */
    getDoctorProfile(): Observable<DoctorProfile | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Doctor/GetDoctorProfile";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDoctorProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDoctorProfile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DoctorProfile | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DoctorProfile | null>;
        }));
    }

    protected processGetDoctorProfile(response: HttpResponseBase): Observable<DoctorProfile | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? DoctorProfile.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the doctor displayName.
     * @param doctorId The doctor identifier.
     * @return the doctor profile
     */
    getDoctorDisplayName(doctorId: number): Observable<string | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Doctor/GetDoctorDisplayName/?doctorId={doctorId}";
        if (doctorId === undefined || doctorId === null)
            throw new Error("The parameter 'doctorId' must be defined.");
        url_ = url_.replace("{doctorId}", encodeURIComponent("" + doctorId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDoctorDisplayName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDoctorDisplayName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string | null>;
        }));
    }

    protected processGetDoctorDisplayName(response: HttpResponseBase): Observable<string | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets all the doctors with the filters for the doctor repository.
     * @param searchParams The search parameters.
     * @param allPages (optional) All pages.
     * @return The doctors.
     */
    getDoctorsWithFilters(searchParams: DoctorDirectorySearchParams | null, allPages?: boolean | undefined): Observable<DoctorConsultSiinInfos[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Doctor/GetDoctorsWithFiltersAsync?";
        if (allPages === null)
            throw new Error("The parameter 'allPages' cannot be null.");
        else if (allPages !== undefined)
            url_ += "allPages=" + encodeURIComponent("" + allPages) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchParams);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDoctorsWithFilters(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDoctorsWithFilters(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DoctorConsultSiinInfos[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DoctorConsultSiinInfos[] | null>;
        }));
    }

    protected processGetDoctorsWithFilters(response: HttpResponseBase): Observable<DoctorConsultSiinInfos[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DoctorConsultSiinInfos.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets all the doctors with the filters for the doctor repository for map.
    Pas besoin du all page comme pour la liste car le call est leger on peut tout afficher d'un coup pour la map.
     * @param searchParams The search parameters.
     * @return The doctors.
     */
    getDoctorsWithFiltersForMap(searchParams: DoctorDirectorySearchParams | null): Observable<DoctorConsultSiinInfos[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Doctor/GetDoctorsWithFiltersForMapAsync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchParams);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDoctorsWithFiltersForMap(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDoctorsWithFiltersForMap(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DoctorConsultSiinInfos[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DoctorConsultSiinInfos[] | null>;
        }));
    }

    protected processGetDoctorsWithFiltersForMap(response: HttpResponseBase): Observable<DoctorConsultSiinInfos[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DoctorConsultSiinInfos.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets all the doctors name the filters for the doctor repository.
     * @param searchParams The search parameters.
     * @return The doctors.
     */
    getDoctorsNames(searchParams: DoctorDirectorySearchParams | null): Observable<DoctorConsultSiinInfos[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Doctor/GetDoctorsNamesAsync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchParams);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDoctorsNames(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDoctorsNames(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DoctorConsultSiinInfos[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DoctorConsultSiinInfos[] | null>;
        }));
    }

    protected processGetDoctorsNames(response: HttpResponseBase): Observable<DoctorConsultSiinInfos[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DoctorConsultSiinInfos.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the geocode address dropdown.
     * @param address The address.
     * @return The geocode address dropdown.
     */
    getGeocodeAddressDropdown(address: string): Observable<GeocodeAddressDropdown[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Doctor/GetGeocodeAddressDropdown/?address={address}";
        if (address === undefined || address === null)
            throw new Error("The parameter 'address' must be defined.");
        url_ = url_.replace("{address}", encodeURIComponent("" + address));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGeocodeAddressDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGeocodeAddressDropdown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeocodeAddressDropdown[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeocodeAddressDropdown[] | null>;
        }));
    }

    protected processGetGeocodeAddressDropdown(response: HttpResponseBase): Observable<GeocodeAddressDropdown[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GeocodeAddressDropdown.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Change the status of a medicalOffice.
     * @param medicalOfficeId the id of te medicalOffice.
     */
    switchMedicalOfficeStatus(medicalOfficeId: number): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/Doctor/SwitchMedicalOfficeStatus/?medicalOfficeId={medicalOfficeId}";
        if (medicalOfficeId === undefined || medicalOfficeId === null)
            throw new Error("The parameter 'medicalOfficeId' must be defined.");
        url_ = url_.replace("{medicalOfficeId}", encodeURIComponent("" + medicalOfficeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSwitchMedicalOfficeStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSwitchMedicalOfficeStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSwitchMedicalOfficeStatus(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates the current doctor billing infos.
     * @param infos The infos.
     */
    updateCurrentDoctorBillingInfos(infos: DoctorBillingInfos | null): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/Doctor/UpdateCurrentDoctorBillingInfos";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(infos);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCurrentDoctorBillingInfos(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCurrentDoctorBillingInfos(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateCurrentDoctorBillingInfos(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates the doctor appointment configuration.
     * @param doctorAppointmentConfiguration The doctor appointment configuration.
     * @return The response status
     */
    updateDoctorAppointmentConfiguration(doctorAppointmentConfiguration: DoctorAppointmentConfiguration | null): Observable<ResponseStatus> {
        let url_ = this.baseUrl + "/umbraco/Api/Doctor/UpdateDoctorAppointmentConfiguration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(doctorAppointmentConfiguration);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateDoctorAppointmentConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateDoctorAppointmentConfiguration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseStatus>;
        }));
    }

    protected processUpdateDoctorAppointmentConfiguration(response: HttpResponseBase): Observable<ResponseStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates the doctor profile.
     * @param updateDoctorProfile The doctor profile.
     */
    updateDoctorProfile(updateDoctorProfile: UpdateDoctorProfile | null): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/Doctor/UpdateDoctorProfile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateDoctorProfile);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateDoctorProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateDoctorProfile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateDoctorProfile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates the doctor sub user.
     * @param updateDoctorSubUser The update doctor sub user.
     */
    updateDoctorSubUser(updateDoctorSubUser: UpdateDoctorSubUser | null): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/Doctor/UpdateDoctorSubUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateDoctorSubUser);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateDoctorSubUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateDoctorSubUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateDoctorSubUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates the medical office.
     * @param updateMedicalOffice The update medical office.
     * @return A Task representing the asynchronous operation.
     */
    updateMedicalOffice(updateMedicalOffice: UpdateMedicalOffice | null): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/Doctor/UpdateMedicalOffice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateMedicalOffice);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateMedicalOffice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateMedicalOffice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateMedicalOffice(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates the doctor signature image.
     * @param signatureImage (optional) The signature image.
     * @return A Task representing the asynchronous operation.
     */
    updateDoctorSignatureImage(signatureImage?: FileParameter | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/Doctor/UpdateDoctorSignatureImage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (signatureImage !== null && signatureImage !== undefined)
            content_.append("signatureImage", signatureImage.data, signatureImage.fileName ? signatureImage.fileName : "signatureImage");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateDoctorSignatureImage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateDoctorSignatureImage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateDoctorSignatureImage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates the doctor logo image.
     * @param logoImage (optional) The logo image.
     * @return A Task representing the asynchronous operation.
     */
    updateDoctorLogoImage(logoImage?: FileParameter | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/Doctor/UpdateDoctorLogoImage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (logoImage !== null && logoImage !== undefined)
            content_.append("logoImage", logoImage.data, logoImage.fileName ? logoImage.fileName : "logoImage");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateDoctorLogoImage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateDoctorLogoImage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateDoctorLogoImage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the doctor invoice settings.
     * @return The doctor invoice settings
     */
    getDoctorInvoiceSettings(): Observable<DoctorInvoiceSettingsInfos | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Doctor/GetDoctorInvoiceSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDoctorInvoiceSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDoctorInvoiceSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DoctorInvoiceSettingsInfos | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DoctorInvoiceSettingsInfos | null>;
        }));
    }

    protected processGetDoctorInvoiceSettings(response: HttpResponseBase): Observable<DoctorInvoiceSettingsInfos | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? DoctorInvoiceSettingsInfos.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates the doctor invoice settings.
     * @param settings The settings.
     */
    updateDoctorInvoiceSettings(settings: DoctorInvoiceSettingsInfos | null): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/Doctor/UpdateDoctorInvoiceSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(settings);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateDoctorInvoiceSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateDoctorInvoiceSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateDoctorInvoiceSettings(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the template pdf file of the invoice.
     * @return The template pdf file.
     */
    getTemplateInvoicePdf(): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Doctor/GetTemplateInvoicePdf";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTemplateInvoicePdf(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTemplateInvoicePdf(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processGetTemplateInvoicePdf(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Synchronizes the invoices.
     * @return The number of synchronized invoices.
     */
    synchronizeInvoices(): Observable<number> {
        let url_ = this.baseUrl + "/umbraco/Api/Doctor/SynchronizeInvoicesAsync";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSynchronizeInvoices(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSynchronizeInvoices(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processSynchronizeInvoices(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class InsuranceRepository {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Creates the insurance.
     * @param insurance The insurance.
     * @return The id of the created insurance.
     */
    createInsurance(insurance: InsuranceDetails | null): Observable<number> {
        let url_ = this.baseUrl + "/umbraco/Api/Insurance/CreateInsurance";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(insurance);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateInsurance(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateInsurance(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateInsurance(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param insuranceId The identifier.
     * @return The task.
     */
    deleteInsurance(insuranceId: number): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/Insurance/DeleteInsurance/?insuranceId={insuranceId}";
        if (insuranceId === undefined || insuranceId === null)
            throw new Error("The parameter 'insuranceId' must be defined.");
        url_ = url_.replace("{insuranceId}", encodeURIComponent("" + insuranceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteInsurance(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteInsurance(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteInsurance(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param insuranceId The insurance identifier.
     * @return The task.
     */
    deleteInsuranceLogo(insuranceId: number): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/Insurance/DeleteInsuranceLogo/?insuranceId={insuranceId}";
        if (insuranceId === undefined || insuranceId === null)
            throw new Error("The parameter 'insuranceId' must be defined.");
        url_ = url_.replace("{insuranceId}", encodeURIComponent("" + insuranceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteInsuranceLogo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteInsuranceLogo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteInsuranceLogo(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Generates the empty test health passport.
     * @param uploadKey The upload key.
     * @return The task.
     */
    generateEmptyTestHealthPassport(uploadKey: string): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/Insurance/GenerateEmptyTestHealthPassport/?uploadKey={uploadKey}";
        if (uploadKey === undefined || uploadKey === null)
            throw new Error("The parameter 'uploadKey' must be defined.");
        url_ = url_.replace("{uploadKey}", encodeURIComponent("" + uploadKey));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateEmptyTestHealthPassport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateEmptyTestHealthPassport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGenerateEmptyTestHealthPassport(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the health passport files asynchronous.
     * @param uploadKey The upload key.
     * @return An archive with all health passport.
     */
    getHealthPassportFiles(uploadKey: string): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Insurance/GetHealthPassportFiles/?uploadKey={uploadKey}";
        if (uploadKey === undefined || uploadKey === null)
            throw new Error("The parameter 'uploadKey' must be defined.");
        url_ = url_.replace("{uploadKey}", encodeURIComponent("" + uploadKey));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHealthPassportFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHealthPassportFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processGetHealthPassportFiles(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the invoice.
     * @param insuranceId The insurance identifier.
     * @return The wanted
     */
    getInsurance(insuranceId: number): Observable<InsuranceDetails | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Insurance/GetInsurance/?insuranceId={insuranceId}";
        if (insuranceId === undefined || insuranceId === null)
            throw new Error("The parameter 'insuranceId' must be defined.");
        url_ = url_.replace("{insuranceId}", encodeURIComponent("" + insuranceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInsurance(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInsurance(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InsuranceDetails | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InsuranceDetails | null>;
        }));
    }

    protected processGetInsurance(response: HttpResponseBase): Observable<InsuranceDetails | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? InsuranceDetails.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the insurance tokens.
     * @param insuranceId The insurance identifier.
     * @return The list of tokens
     */
    getInsuranceTokens(insuranceId: number): Observable<InsuranceToken[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Insurance/GetInsuranceTokens/?insuranceId={insuranceId}";
        if (insuranceId === undefined || insuranceId === null)
            throw new Error("The parameter 'insuranceId' must be defined.");
        url_ = url_.replace("{insuranceId}", encodeURIComponent("" + insuranceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInsuranceTokens(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInsuranceTokens(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InsuranceToken[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InsuranceToken[] | null>;
        }));
    }

    protected processGetInsuranceTokens(response: HttpResponseBase): Observable<InsuranceToken[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InsuranceToken.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the insurances.
     * @param searchParams The search parameters.
     * @return All searched insurances
     */
    getInsurances(searchParams: InsuranceSearchParams | null): Observable<Insurance[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Insurance/GetInsurances";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchParams);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInsurances(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInsurances(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Insurance[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Insurance[] | null>;
        }));
    }

    protected processGetInsurances(response: HttpResponseBase): Observable<Insurance[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Insurance.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the insurances dropdown values.
     * @return Insurances for dropdown
     */
    getInsurancesDropdownValues(): Observable<DropdownValue[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Insurance/GetInsurancesDropdownValues";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInsurancesDropdownValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInsurancesDropdownValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DropdownValue[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DropdownValue[] | null>;
        }));
    }

    protected processGetInsurancesDropdownValues(response: HttpResponseBase): Observable<DropdownValue[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DropdownValue.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Imports the insurance token.
     * @param tokens The tokens.
     * @return The status response
     */
    importInsuranceTokens(tokens: InsuranceTokenImport | null): Observable<ResponseStatus> {
        let url_ = this.baseUrl + "/umbraco/Api/Insurance/ImportInsuranceTokens";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(tokens);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportInsuranceTokens(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportInsuranceTokens(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseStatus>;
        }));
    }

    protected processImportInsuranceTokens(response: HttpResponseBase): Observable<ResponseStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates the insurance.
     * @param insurance The insurance.
     * @return An asynchronous operation
     */
    updateInsurance(insurance: InsuranceDetails | null): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/Insurance/UpdateInsurance";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(insurance);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateInsurance(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateInsurance(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateInsurance(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Uploads files to a patient.
     * @param uploadKey Gets or sets the key.
     * @param token Gets or sets the token.
     * @return The asynchronous operation.
     */
    uploadFileToPatient(uploadKey: string, token: string): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/Insurance/UploadFileToPatient/?UploadKey={UploadKey}&Token={Token}";
        if (uploadKey === undefined || uploadKey === null)
            throw new Error("The parameter 'uploadKey' must be defined.");
        url_ = url_.replace("{UploadKey}", encodeURIComponent("" + uploadKey));
        if (token === undefined || token === null)
            throw new Error("The parameter 'token' must be defined.");
        url_ = url_.replace("{Token}", encodeURIComponent("" + token));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadFileToPatient(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadFileToPatient(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUploadFileToPatient(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Uploads the insurance file.
     * @param key The key.
     */
    uploadInsuranceFile(key: string): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/Insurance/UploadInsuranceFile/?key={key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadInsuranceFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadInsuranceFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUploadInsuranceFile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Validates the patient token.
     * @param token The token.
     * @return The insurance linked with the token
     */
    validatePatientToken(token: string): Observable<StatusValueResourceOfPatientInsurance | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Insurance/ValidatePatientToken/?token={token}";
        if (token === undefined || token === null)
            throw new Error("The parameter 'token' must be defined.");
        url_ = url_.replace("{token}", encodeURIComponent("" + token));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidatePatientToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidatePatientToken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StatusValueResourceOfPatientInsurance | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StatusValueResourceOfPatientInsurance | null>;
        }));
    }

    protected processValidatePatientToken(response: HttpResponseBase): Observable<StatusValueResourceOfPatientInsurance | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? StatusValueResourceOfPatientInsurance.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Validates the patient token lite.
     * @param token The token.
     * @param insuranceId The insurance identifier.
     * @return The request status
     */
    validatePatientTokenLite(token: string, insuranceId: number): Observable<ResponseStatus> {
        let url_ = this.baseUrl + "/umbraco/Api/Insurance/ValidatePatientTokenLite/?token={token}&insuranceId={insuranceId}";
        if (token === undefined || token === null)
            throw new Error("The parameter 'token' must be defined.");
        url_ = url_.replace("{token}", encodeURIComponent("" + token));
        if (insuranceId === undefined || insuranceId === null)
            throw new Error("The parameter 'insuranceId' must be defined.");
        url_ = url_.replace("{insuranceId}", encodeURIComponent("" + insuranceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidatePatientTokenLite(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidatePatientTokenLite(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseStatus>;
        }));
    }

    protected processValidatePatientTokenLite(response: HttpResponseBase): Observable<ResponseStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ConsultInNoteRepository {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Changes the note status.
     * @param noteId The note identifier.
     */
    changeNoteStatus(noteId: number): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/ConsultInNote/ChangeNoteStatus/?noteId={noteId}";
        if (noteId === undefined || noteId === null)
            throw new Error("The parameter 'noteId' must be defined.");
        url_ = url_.replace("{noteId}", encodeURIComponent("" + noteId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeNoteStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeNoteStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processChangeNoteStatus(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Creats the note response.
     * @param createNoteResponse The create note response.
     * @return The id of thre created note response.
     */
    createNoteResponse(createNoteResponse: CreateNoteResponse | null): Observable<number> {
        let url_ = this.baseUrl + "/umbraco/Api/ConsultInNote/CreateNoteResponse";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createNoteResponse);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateNoteResponse(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateNoteResponse(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateNoteResponse(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Creates the note.
     * @param createNote The note.
     * @return The identifier of the created note
     */
    createNote(createNote: CreateNote | null): Observable<number> {
        let url_ = this.baseUrl + "/umbraco/Api/ConsultInNote/CreateNote";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createNote);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateNote(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateNote(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateNote(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Deletes the note.
     * @param id The identifier.
     */
    deleteNote(id: number): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/ConsultInNote/DeleteNote/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteNote(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteNote(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteNote(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the note.
     * @param id The identifier.
     * @return The wanted note
     */
    getNote(id: number): Observable<ConsultInNote | null> {
        let url_ = this.baseUrl + "/umbraco/Api/ConsultInNote/GetNote/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNote(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNote(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConsultInNote | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConsultInNote | null>;
        }));
    }

    protected processGetNote(response: HttpResponseBase): Observable<ConsultInNote | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ConsultInNote.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the notes.
     * @param noteSearchParams The note search parameters.
     * @return All notes
     */
    getNotes(noteSearchParams: NoteSearchParams | null): Observable<ConsultInOrderedNote[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/ConsultInNote/GetNotes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(noteSearchParams);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNotes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNotes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConsultInOrderedNote[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConsultInOrderedNote[] | null>;
        }));
    }

    protected processGetNotes(response: HttpResponseBase): Observable<ConsultInOrderedNote[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ConsultInOrderedNote.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class MemberRepository {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Logins the specified manager login.
     * @param login The login.
     * @return True if logged
     */
    loginBackOffice(login: Login | null): Observable<ResponseStatus> {
        let url_ = this.baseUrl + "/umbraco/api/Member/LoginBackOffice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(login);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLoginBackOffice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLoginBackOffice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseStatus>;
        }));
    }

    protected processLoginBackOffice(response: HttpResponseBase): Observable<ResponseStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Logins the specified doctor login.
     * @param login The login.
     * @return True if logged
     */
    loginDoctor(login: Login | null): Observable<ResponseStatus> {
        let url_ = this.baseUrl + "/umbraco/api/Member/LoginDoctor";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(login);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLoginDoctor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLoginDoctor(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseStatus>;
        }));
    }

    protected processLoginDoctor(response: HttpResponseBase): Observable<ResponseStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Logins the patient.
     * @param login The login.
     * @return True if logged in
     */
    loginPatient(login: Login | null): Observable<ResponseStatus> {
        let url_ = this.baseUrl + "/umbraco/api/Member/LoginPatient";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(login);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLoginPatient(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLoginPatient(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseStatus>;
        }));
    }

    protected processLoginPatient(response: HttpResponseBase): Observable<ResponseStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Logouts this instance.
     */
    logout(): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/api/Member/Logout";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLogout(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLogout(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processLogout(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Merges the duplicate members.
     * @param idToKeep The identifier to keep.
     * @param idToMerge The identifier to merge.
     * @return The status of the response
     */
    mergeDuplicateMembers(idToKeep: number, idToMerge: number): Observable<ResponseStatus> {
        let url_ = this.baseUrl + "/umbraco/api/Member/MergeDuplicateMembers?";
        if (idToKeep === undefined || idToKeep === null)
            throw new Error("The parameter 'idToKeep' must be defined and cannot be null.");
        else
            url_ += "idToKeep=" + encodeURIComponent("" + idToKeep) + "&";
        if (idToMerge === undefined || idToMerge === null)
            throw new Error("The parameter 'idToMerge' must be defined and cannot be null.");
        else
            url_ += "idToMerge=" + encodeURIComponent("" + idToMerge) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMergeDuplicateMembers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMergeDuplicateMembers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseStatus>;
        }));
    }

    protected processMergeDuplicateMembers(response: HttpResponseBase): Observable<ResponseStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Redirects the current user to moodle.
     * @return Redirect user to moodle
     */
    redirectCurrentMemberToMoodle(): Observable<RedirectResult | null> {
        let url_ = this.baseUrl + "/umbraco/api/Member/RedirectCurrentMemberToMoodle";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRedirectCurrentMemberToMoodle(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRedirectCurrentMemberToMoodle(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RedirectResult | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RedirectResult | null>;
        }));
    }

    protected processRedirectCurrentMemberToMoodle(response: HttpResponseBase): Observable<RedirectResult | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? RedirectResult.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Redirects the current user to moodle.
     * @return Redirect user to moodle
     */
    redirectCurrentMemberToMoodleHelpPNC(): Observable<RedirectResult | null> {
        let url_ = this.baseUrl + "/umbraco/api/Member/RedirectCurrentMemberToMoodleHelpPNC";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRedirectCurrentMemberToMoodleHelpPNC(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRedirectCurrentMemberToMoodleHelpPNC(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RedirectResult | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RedirectResult | null>;
        }));
    }

    protected processRedirectCurrentMemberToMoodleHelpPNC(response: HttpResponseBase): Observable<RedirectResult | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? RedirectResult.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Creates the subscription for specified member and course.
     * @param request The request.
     * @return The task.
     */
    registerMemberToSessionBO(request: CourseSessionRegistrationRequest | null): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/api/Member/RegisterMemberToSessionBO";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRegisterMemberToSessionBO(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegisterMemberToSessionBO(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRegisterMemberToSessionBO(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates the siin ambassador.
     * @param request The request.
     * @return The status of the response
     */
    registerSiinAmbassador(request: UpdateSiinAmbassadorRequest | null): Observable<ResponseStatus> {
        let url_ = this.baseUrl + "/umbraco/api/Member/RegisterSiinAmbassador";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRegisterSiinAmbassador(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegisterSiinAmbassador(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseStatus>;
        }));
    }

    protected processRegisterSiinAmbassador(response: HttpResponseBase): Observable<ResponseStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Locks the specified identifier.
     * @param id The identifier.
     * @param isLockedOut if set to true [status].
     * @return The task
     */
    setLockedOut(id: number, isLockedOut: boolean): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/api/Member/SetLockedOut/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (isLockedOut === undefined || isLockedOut === null)
            throw new Error("The parameter 'isLockedOut' must be defined and cannot be null.");
        else
            url_ += "isLockedOut=" + encodeURIComponent("" + isLockedOut) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetLockedOut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetLockedOut(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetLockedOut(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates the specified member.
     * @param member The member.
     * @return The task
     */
    update(member: MemberDetails | null): Observable<ResponseStatus> {
        let url_ = this.baseUrl + "/umbraco/api/Member/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(member);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseStatus>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ResponseStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Method for update user enrolment
     * @param request The data of the request.
     * @return The task.
     */
    updateCourseSessionRegistration(request: UpdateCourseSessionRegistration | null): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/api/Member/UpdateCourseSessionRegistration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCourseSessionRegistration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCourseSessionRegistration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateCourseSessionRegistration(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates the password.
     * @param body The body.
     * @return The task
     */
    updatePassword(body: ChangePassword | null): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/api/Member/UpdatePassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdatePassword(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Uploads the ambassador chart.
     * @param request The request.
     * @return The status of the response
     */
    uploadAmbassadorChart(request: DocumentUploadRequest | null): Observable<ResponseStatus> {
        let url_ = this.baseUrl + "/umbraco/api/Member/UploadAmbassadorChart";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadAmbassadorChart(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadAmbassadorChart(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseStatus>;
        }));
    }

    protected processUploadAmbassadorChart(response: HttpResponseBase): Observable<ResponseStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Uploads the ProNutriConsult contract.
     * @param request The request.
     * @return The status of the response
     */
    uploadProNutriConsultContract(request: DocumentUploadRequest | null): Observable<ResponseStatus> {
        let url_ = this.baseUrl + "/umbraco/api/Member/UploadProNutriConsultContract";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadProNutriConsultContract(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadProNutriConsultContract(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseStatus>;
        }));
    }

    protected processUploadProNutriConsultContract(response: HttpResponseBase): Observable<ResponseStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Uploads the profile picture.
     * @param request The request.
     * @return The new media url.
     */
    uploadProfilePicture(request: MemberProfilePicture | null): Observable<string | null> {
        let url_ = this.baseUrl + "/umbraco/api/Member/UploadProfilePicture";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadProfilePicture(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadProfilePicture(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string | null>;
        }));
    }

    protected processUploadProfilePicture(response: HttpResponseBase): Observable<string | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates the pro nutri consult subscription.
     * @param proNutriConsultMemberInformation The pro nutri consult member information.
     */
    updateProNutriConsultSubscription(proNutriConsultMemberInformation: ProNutriConsultMemberInformation | null): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/api/Member/UpdateProNutriConsultSubscription";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(proNutriConsultMemberInformation);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateProNutriConsultSubscription(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateProNutriConsultSubscription(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateProNutriConsultSubscription(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Method for download an Andpc Customer Commitment Form
     * @param formationId The formation identifier.
     * @return an Andpc Customer Commitment Form
     */
    formulaireEngagementClientAndpc(formationId: number): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/umbraco/api/Member/FormulaireEngagementClientAndpc?";
        if (formationId === undefined || formationId === null)
            throw new Error("The parameter 'formationId' must be defined and cannot be null.");
        else
            url_ += "formationId=" + encodeURIComponent("" + formationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFormulaireEngagementClientAndpc(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFormulaireEngagementClientAndpc(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processFormulaireEngagementClientAndpc(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Method for download an Ot Customer Commitment Form
     * @param formationId The formation identifier.
     * @return an Ot Customer Commitment Form
     */
    formulaireEngagementClientOt(formationId: number): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/umbraco/api/Member/FormulaireEngagementClientOt?";
        if (formationId === undefined || formationId === null)
            throw new Error("The parameter 'formationId' must be defined and cannot be null.");
        else
            url_ += "formationId=" + encodeURIComponent("" + formationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFormulaireEngagementClientOt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFormulaireEngagementClientOt(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processFormulaireEngagementClientOt(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Method for create member/client by patient email
     * @param createClientAccountParams The patient email.
     * @return The response status.
     */
    createClientAccountFromExistingAccount(createClientAccountParams: CreateClientAccountParams | null): Observable<ResponseStatus> {
        let url_ = this.baseUrl + "/umbraco/api/Member/CreateClientAccountFromExistingAccount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createClientAccountParams);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateClientAccountFromExistingAccount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateClientAccountFromExistingAccount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseStatus>;
        }));
    }

    protected processCreateClientAccountFromExistingAccount(response: HttpResponseBase): Observable<ResponseStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Checks if a given member can be assigned to the given course session.
     * @param memberId The member to check.
     * @param courseSessionId The course session to which the assignement is to be checked.
     * @return true if the member can be assigned to the course session ; otherwise false.
     */
    canRegisterToSession(memberId: number, courseSessionId: number): Observable<boolean> {
        let url_ = this.baseUrl + "/umbraco/api/Member/CanRegisterToSession?";
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined and cannot be null.");
        else
            url_ += "memberId=" + encodeURIComponent("" + memberId) + "&";
        if (courseSessionId === undefined || courseSessionId === null)
            throw new Error("The parameter 'courseSessionId' must be defined and cannot be null.");
        else
            url_ += "courseSessionId=" + encodeURIComponent("" + courseSessionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCanRegisterToSession(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCanRegisterToSession(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCanRegisterToSession(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the member action reminder.
     * @param id the member action reminder id
     * @return The MemberActionReminder list
     */
    getMemberActionReminderById(id: number): Observable<MemberActionReminder | null> {
        let url_ = this.baseUrl + "/umbraco/api/Member/GetMemberActionReminderById/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMemberActionReminderById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMemberActionReminderById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MemberActionReminder | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MemberActionReminder | null>;
        }));
    }

    protected processGetMemberActionReminderById(response: HttpResponseBase): Observable<MemberActionReminder | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? MemberActionReminder.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the member Documents.
     * @param id the member document id
     * @return The MemberDocumentDetails list
     */
    getMemberDocumentById(id: number): Observable<MemberDocumentDetails | null> {
        let url_ = this.baseUrl + "/umbraco/api/Member/GetMemberDocumentById/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMemberDocumentById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMemberDocumentById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MemberDocumentDetails | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MemberDocumentDetails | null>;
        }));
    }

    protected processGetMemberDocumentById(response: HttpResponseBase): Observable<MemberDocumentDetails | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? MemberDocumentDetails.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the member document count.
     * @param memberId the member identifier
     * @return The member's document count
     */
    getMemberDocumentCount(memberId: number): Observable<MemberDocumentCount | null> {
        let url_ = this.baseUrl + "/umbraco/api/Member/GetMemberDocumentCount?";
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined and cannot be null.");
        else
            url_ += "memberId=" + encodeURIComponent("" + memberId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMemberDocumentCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMemberDocumentCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MemberDocumentCount | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MemberDocumentCount | null>;
        }));
    }

    protected processGetMemberDocumentCount(response: HttpResponseBase): Observable<MemberDocumentCount | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? MemberDocumentCount.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the member's mails.
     * @param memberMailSearchParam the member search param.
     * @return The list of member's mails.
     */
    getMemberMailsLiteByMemberId(memberMailSearchParam: MemberMailSearchParam | null): Observable<MailMemberHistoryLite[] | null> {
        let url_ = this.baseUrl + "/umbraco/api/Member/GetMemberMailsLiteByMemberId";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(memberMailSearchParam);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMemberMailsLiteByMemberId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMemberMailsLiteByMemberId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MailMemberHistoryLite[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MailMemberHistoryLite[] | null>;
        }));
    }

    protected processGetMemberMailsLiteByMemberId(response: HttpResponseBase): Observable<MailMemberHistoryLite[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MailMemberHistoryLite.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add to ProNutriConsult newsletter
     * @param email email.
     * @return Task
     */
    addToProNutriConsultNewsletter(email: string | null): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/api/Member/AddToProNutriConsultNewsletter?";
        if (email === undefined)
            throw new Error("The parameter 'email' must be defined.");
        else if(email !== null)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddToProNutriConsultNewsletter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddToProNutriConsultNewsletter(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddToProNutriConsultNewsletter(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the member's mail details.
     * @param mailId the mail identifier.
     * @return The member's mail details.
     */
    getMemberMailDetailsById(mailId: number): Observable<MailMemberHistory | null> {
        let url_ = this.baseUrl + "/umbraco/api/Member/GetMemberMailDetailsById?";
        if (mailId === undefined || mailId === null)
            throw new Error("The parameter 'mailId' must be defined and cannot be null.");
        else
            url_ += "mailId=" + encodeURIComponent("" + mailId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMemberMailDetailsById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMemberMailDetailsById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MailMemberHistory | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MailMemberHistory | null>;
        }));
    }

    protected processGetMemberMailDetailsById(response: HttpResponseBase): Observable<MailMemberHistory | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? MailMemberHistory.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the attached file with id.
     * @param attachedFileId the attached file identifier.
     * @return The attached file url.
     */
    getAttachedFileUrl(attachedFileId: number): Observable<string | null> {
        let url_ = this.baseUrl + "/umbraco/api/Member/GetAttachedFileUrl?";
        if (attachedFileId === undefined || attachedFileId === null)
            throw new Error("The parameter 'attachedFileId' must be defined and cannot be null.");
        else
            url_ += "attachedFileId=" + encodeURIComponent("" + attachedFileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAttachedFileUrl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAttachedFileUrl(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string | null>;
        }));
    }

    protected processGetAttachedFileUrl(response: HttpResponseBase): Observable<string | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * documentation
     * @param id identifier
     * @return boolean
     */
    getIsHealthProfessional(id: number): Observable<boolean> {
        let url_ = this.baseUrl + "/umbraco/api/Member/GetIsHealthProfessional/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIsHealthProfessional(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIsHealthProfessional(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processGetIsHealthProfessional(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the action list by search params.
     * @param searchParams the search params
     * @return Get the action list
     */
    getAllActions(searchParams: ActionSearchParams | null): Observable<PaginatorWrapperOfIEnumerableOfMemberActionReminder | null> {
        let url_ = this.baseUrl + "/umbraco/api/Member/GetAllActions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchParams);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllActions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllActions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaginatorWrapperOfIEnumerableOfMemberActionReminder | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaginatorWrapperOfIEnumerableOfMemberActionReminder | null>;
        }));
    }

    protected processGetAllActions(response: HttpResponseBase): Observable<PaginatorWrapperOfIEnumerableOfMemberActionReminder | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PaginatorWrapperOfIEnumerableOfMemberActionReminder.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the member Documents.
     * @param searchParams the search params
     * @return The MemberDocumentDetails list
     */
    getAllMemberActionReminder(searchParams: MemberSearchParams | null): Observable<MemberActionReminder[] | null> {
        let url_ = this.baseUrl + "/umbraco/api/Member/GetAllMemberActionReminder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchParams);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllMemberActionReminder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllMemberActionReminder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MemberActionReminder[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MemberActionReminder[] | null>;
        }));
    }

    protected processGetAllMemberActionReminder(response: HttpResponseBase): Observable<MemberActionReminder[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MemberActionReminder.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the member Documents.
     * @param searchParams the search params
     * @param isSiiNDocument is siin document
     * @return The MemberDocumentDetails list
     */
    getAllMemberDocumentByMemberId(searchParams: MemberSearchParams | null, isSiiNDocument: boolean): Observable<MemberDocumentDetails[] | null> {
        let url_ = this.baseUrl + "/umbraco/api/Member/GetAllMemberDocumentByMemberId?";
        if (isSiiNDocument === undefined || isSiiNDocument === null)
            throw new Error("The parameter 'isSiiNDocument' must be defined and cannot be null.");
        else
            url_ += "isSiiNDocument=" + encodeURIComponent("" + isSiiNDocument) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchParams);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllMemberDocumentByMemberId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllMemberDocumentByMemberId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MemberDocumentDetails[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MemberDocumentDetails[] | null>;
        }));
    }

    protected processGetAllMemberDocumentByMemberId(response: HttpResponseBase): Observable<MemberDocumentDetails[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MemberDocumentDetails.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates the siin academy badge.
     * @return The Task.
     */
    addSiinAcademyBadge(): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/api/Member/AddSiinAcademyBadge";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddSiinAcademyBadge(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddSiinAcademyBadge(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddSiinAcademyBadge(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add or update the member action reminder.
     * @param memberActionReminder The member action reminder.
     * @return The status of the response
     */
    addOrUpdateMemberActionReminder(memberActionReminder: MemberActionReminder | null): Observable<number> {
        let url_ = this.baseUrl + "/umbraco/api/Member/AddOrUpdateMemberActionReminder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(memberActionReminder);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddOrUpdateMemberActionReminder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddOrUpdateMemberActionReminder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processAddOrUpdateMemberActionReminder(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add or update the member Document.
     * @param memberDocumentDetails The member Document Details.
     * @return The status of the response
     */
    addOrUpdateMemberDocument(memberDocumentDetails: MemberDocumentDetails | null): Observable<number> {
        let url_ = this.baseUrl + "/umbraco/api/Member/AddOrUpdateMemberDocument";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(memberDocumentDetails);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddOrUpdateMemberDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddOrUpdateMemberDocument(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processAddOrUpdateMemberDocument(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete the member action reminder.
     * @param id The member action reminder id.
     * @return The Task
     */
    deleteMemberActionReminder(id: number): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/api/Member/DeleteMemberActionReminder/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteMemberActionReminder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteMemberActionReminder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteMemberActionReminder(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete the member Document.
     * @param id The member Document id.
     * @return The Task
     */
    deleteMemberDocument(id: number): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/api/Member/DeleteMemberDocument/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteMemberDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteMemberDocument(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteMemberDocument(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Adds the credit points.
     * @param request The request.
     * @return The status of the response
     */
    addCreditPoints(request: MemberBonusRequest | null): Observable<ResponseStatus> {
        let url_ = this.baseUrl + "/umbraco/api/Member/AddCreditPoints";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddCreditPoints(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddCreditPoints(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseStatus>;
        }));
    }

    protected processAddCreditPoints(response: HttpResponseBase): Observable<ResponseStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Asks the new password.
     * @param email The email.
     */
    askNewPassword(email: string | null): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/api/Member/AskNewPassword?";
        if (email === undefined)
            throw new Error("The parameter 'email' must be defined.");
        else if(email !== null)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAskNewPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAskNewPassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAskNewPassword(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Asks the new password from member area.
     * @param email The email.
     * @return The status of the request
     */
    askNewPasswordFromMemberArea(email: string | null): Observable<ResponseStatus> {
        let url_ = this.baseUrl + "/umbraco/api/Member/AskNewPasswordFromMemberArea?";
        if (email === undefined)
            throw new Error("The parameter 'email' must be defined.");
        else if(email !== null)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAskNewPasswordFromMemberArea(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAskNewPasswordFromMemberArea(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseStatus>;
        }));
    }

    protected processAskNewPasswordFromMemberArea(response: HttpResponseBase): Observable<ResponseStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Asks the new password from my consult siin.
     * @param email The email.
     * @return The status of the request.
     */
    askNewPasswordFromMyConsultSiin(email: string | null): Observable<ResponseStatus> {
        let url_ = this.baseUrl + "/umbraco/api/Member/AskNewPasswordFromMyConsultSiin?";
        if (email === undefined)
            throw new Error("The parameter 'email' must be defined.");
        else if(email !== null)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAskNewPasswordFromMyConsultSiin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAskNewPasswordFromMyConsultSiin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseStatus>;
        }));
    }

    protected processAskNewPasswordFromMyConsultSiin(response: HttpResponseBase): Observable<ResponseStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Asks the new password from pro nutri.
     * @param email The email.
     * @return the status of the request.
     */
    askNewPasswordFromProNutri(email: string | null): Observable<ResponseStatus> {
        let url_ = this.baseUrl + "/umbraco/api/Member/AskNewPasswordFromProNutri?";
        if (email === undefined)
            throw new Error("The parameter 'email' must be defined.");
        else if(email !== null)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAskNewPasswordFromProNutri(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAskNewPasswordFromProNutri(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseStatus>;
        }));
    }

    protected processAskNewPasswordFromProNutri(response: HttpResponseBase): Observable<ResponseStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Checks the inactive course.
     * @param courseSessionId The course session identifier.
     * @return The status.
     */
    checkCurrentMemberCanPurchaseCourseSession(courseSessionId: number): Observable<CanPurchaseCourseSessionStatus> {
        let url_ = this.baseUrl + "/umbraco/api/Member/CheckCurrentMemberCanPurchaseCourseSession?";
        if (courseSessionId === undefined || courseSessionId === null)
            throw new Error("The parameter 'courseSessionId' must be defined and cannot be null.");
        else
            url_ += "courseSessionId=" + encodeURIComponent("" + courseSessionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckCurrentMemberCanPurchaseCourseSession(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckCurrentMemberCanPurchaseCourseSession(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CanPurchaseCourseSessionStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CanPurchaseCourseSessionStatus>;
        }));
    }

    protected processCheckCurrentMemberCanPurchaseCourseSession(response: HttpResponseBase): Observable<CanPurchaseCourseSessionStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Completes the information.
     * @param member The member.
     * @return The task
     */
    completeInfo(member: MemberCompleteInfo | null): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/api/Member/CompleteInfo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(member);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCompleteInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCompleteInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCompleteInfo(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Creates the specified member.
     * @param member The member.
     * @return The id of the memeber
     */
    create(member: MemberDetails | null): Observable<number> {
        let url_ = this.baseUrl + "/umbraco/api/Member/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(member);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Creates the client account from existing account for current member.
     * @param memberInfo The member info.
     * @return The response status.
     */
    createClientAccountFromExistingAccountForCurrentMember(memberInfo: MemberInfoToCreateFromExistingAccount | null): Observable<ResponseStatus> {
        let url_ = this.baseUrl + "/umbraco/api/Member/CreateClientAccountFromExistingAccountForCurrentMember";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(memberInfo);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateClientAccountFromExistingAccountForCurrentMember(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateClientAccountFromExistingAccountForCurrentMember(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseStatus>;
        }));
    }

    protected processCreateClientAccountFromExistingAccountForCurrentMember(response: HttpResponseBase): Observable<ResponseStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add external cursus members to an existing external cursus.
     * @param externalCursusMembers The external cursus member.
     */
    addExternalMembersToExternalCursus(externalCursusMembers: ExternalCursusMember[] | null): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/api/Member/AddExternalMembersToExternalCursus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(externalCursusMembers);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddExternalMembersToExternalCursus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddExternalMembersToExternalCursus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddExternalMembersToExternalCursus(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Creates my account.
     * @param member The member.
     * @return The result.
     */
    createMyAccount(member: MemberBasicInfo | null): Observable<ResponseStatus> {
        let url_ = this.baseUrl + "/umbraco/api/Member/CreateMyAccount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(member);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateMyAccount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateMyAccount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseStatus>;
        }));
    }

    protected processCreateMyAccount(response: HttpResponseBase): Observable<ResponseStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Creates the patient account.
     * @param registrationInfos The registration infos.
     * @return The identifier of the newly created patient
     */
    createPatientAccount(registrationInfos: PatientRegistrationInfos | null): Observable<ResponseStatus> {
        let url_ = this.baseUrl + "/umbraco/api/Member/CreatePatientAccount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(registrationInfos);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePatientAccount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePatientAccount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseStatus>;
        }));
    }

    protected processCreatePatientAccount(response: HttpResponseBase): Observable<ResponseStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Currents the member update.
     * @param member The member.
     * @return The response status
     */
    currentMemberUpdate(member: CurrentMemberDetails | null): Observable<ResponseStatus> {
        let url_ = this.baseUrl + "/umbraco/api/Member/CurrentMemberUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(member);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCurrentMemberUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCurrentMemberUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseStatus>;
        }));
    }

    protected processCurrentMemberUpdate(response: HttpResponseBase): Observable<ResponseStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Tests the specified member.
     * @param body The body.
     * @return The response status
     */
    currentMemberUpdatePassword(body: UpdatePassword | null): Observable<ResponseStatus> {
        let url_ = this.baseUrl + "/umbraco/api/Member/CurrentMemberUpdatePassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCurrentMemberUpdatePassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCurrentMemberUpdatePassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseStatus>;
        }));
    }

    protected processCurrentMemberUpdatePassword(response: HttpResponseBase): Observable<ResponseStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Deletes the specified identifier.
     * @param id The identifier.
     * @return The task
     */
    delete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/api/Member/Delete/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Deletes the specified external cusus.
     * @param cursusId The cursus identifier.
     */
    deleteExternalCursus(cursusId: number): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/api/Member/DeleteExternalCursus?";
        if (cursusId === undefined || cursusId === null)
            throw new Error("The parameter 'cursusId' must be defined and cannot be null.");
        else
            url_ += "cursusId=" + encodeURIComponent("" + cursusId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteExternalCursus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteExternalCursus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteExternalCursus(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Method for download an ambassador convention
     * @return The degree
     */
    downloadAmbassadorConvention(): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/umbraco/api/Member/DownloadAmbassadorConvention";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadAmbassadorConvention(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadAmbassadorConvention(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDownloadAmbassadorConvention(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Downloads the chart from member area.
     * @param memberId The member identifier.
     * @return The chart
     */
    downloadChartFromMemberArea(memberId: number): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/umbraco/api/Member/DownloadChartFromMemberArea?";
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined and cannot be null.");
        else
            url_ += "memberId=" + encodeURIComponent("" + memberId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadChartFromMemberArea(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadChartFromMemberArea(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDownloadChartFromMemberArea(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Downloads ProNutriConsult contract in pdf.
     * @return pdf file of the contract.
     */
    downloadProNutriContract(): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/umbraco/api/Member/DownloadProNutriContract";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadProNutriContract(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadProNutriContract(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDownloadProNutriContract(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Collects all the documents saved in blob for a doctor regrouped in a zip file.
     * @param doctorId The doctor identifier.
     */
    enqueueCollectAllDocumentFromBlobForDoctorJob(doctorId: number): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/api/Member/EnqueueCollectAllDocumentFromBlobForDoctorJob?";
        if (doctorId === undefined || doctorId === null)
            throw new Error("The parameter 'doctorId' must be defined and cannot be null.");
        else
            url_ += "doctorId=" + encodeURIComponent("" + doctorId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEnqueueCollectAllDocumentFromBlobForDoctorJob(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEnqueueCollectAllDocumentFromBlobForDoctorJob(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processEnqueueCollectAllDocumentFromBlobForDoctorJob(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets all.
     * @param searchParams The search parameters.
     * @return The list of all member.
     */
    getAll(searchParams: MemberSearchParams | null): Observable<Member[] | null> {
        let url_ = this.baseUrl + "/umbraco/api/Member/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchParams);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Member[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Member[] | null>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<Member[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Member.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets members by name for dropdown.
     * @param searchString the search parameter (title).
     * @return a list of members.
     */
    getDropDownMemberByQuery(searchString: string | null): Observable<Member[] | null> {
        let url_ = this.baseUrl + "/umbraco/api/Member/GetDropDownMemberByQuery?";
        if (searchString === undefined)
            throw new Error("The parameter 'searchString' must be defined.");
        else if(searchString !== null)
            url_ += "searchString=" + encodeURIComponent("" + searchString) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDropDownMemberByQuery(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDropDownMemberByQuery(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Member[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Member[] | null>;
        }));
    }

    protected processGetDropDownMemberByQuery(response: HttpResponseBase): Observable<Member[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Member.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets all active members.
     * @param searchParams The search parameters.
     * @return The list of active members
     */
    getAllActiveMembers(searchParams: MemberActiveSearchParams | null): Observable<MemberActive[] | null> {
        let url_ = this.baseUrl + "/umbraco/api/Member/GetAllActiveMembers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchParams);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllActiveMembers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllActiveMembers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MemberActive[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MemberActive[] | null>;
        }));
    }

    protected processGetAllActiveMembers(response: HttpResponseBase): Observable<MemberActive[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MemberActive.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets all active members for map.
     * @param searchParams The search parameters.
     * @return All active members for map.
     */
    getAllActiveMembersForMap(searchParams: MemberActiveSearchParams | null): Observable<MemberActive[] | null> {
        let url_ = this.baseUrl + "/umbraco/api/Member/GetAllActiveMembersForMap";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchParams);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllActiveMembersForMap(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllActiveMembersForMap(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MemberActive[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MemberActive[] | null>;
        }));
    }

    protected processGetAllActiveMembersForMap(response: HttpResponseBase): Observable<MemberActive[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MemberActive.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets all advantage codes.
     * @return All the advantage codes.
     */
    getAllAdvantageCodes(): Observable<string[] | null> {
        let url_ = this.baseUrl + "/umbraco/api/Member/GetAllAdvantageCodes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllAdvantageCodes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllAdvantageCodes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[] | null>;
        }));
    }

    protected processGetAllAdvantageCodes(response: HttpResponseBase): Observable<string[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets all for export.
     * @param searchParams The search parameters.
     * @return The exported members file
     */
    getAllForExport(searchParams: MemberSearchParams | null): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/umbraco/api/Member/GetAllForExport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchParams);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllForExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllForExport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processGetAllForExport(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the specified external cusus with members.
     * @param cursusId The external cursus identifier.
     * @return The specified external cusus with members
     */
    getExternalCursus(cursusId: number): Observable<ExternalCursus | null> {
        let url_ = this.baseUrl + "/umbraco/api/Member/GetExternalCursus?";
        if (cursusId === undefined || cursusId === null)
            throw new Error("The parameter 'cursusId' must be defined and cannot be null.");
        else
            url_ += "cursusId=" + encodeURIComponent("" + cursusId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExternalCursus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExternalCursus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExternalCursus | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExternalCursus | null>;
        }));
    }

    protected processGetExternalCursus(response: HttpResponseBase): Observable<ExternalCursus | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ExternalCursus.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets all the external cursus without members.
     * @return The list of external cursus
     */
    getAllExternalCursus(): Observable<ExternalCursus[] | null> {
        let url_ = this.baseUrl + "/umbraco/api/Member/GetAllExternalCursus";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllExternalCursus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllExternalCursus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExternalCursus[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExternalCursus[] | null>;
        }));
    }

    protected processGetAllExternalCursus(response: HttpResponseBase): Observable<ExternalCursus[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ExternalCursus.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Authentication Expiration Date
     * @return The expiration date.
     */
    getAuthenticationExpirationDate(): Observable<Date> {
        let url_ = this.baseUrl + "/umbraco/api/Member/GetAuthenticationExpirationDate";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAuthenticationExpirationDate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAuthenticationExpirationDate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Date>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Date>;
        }));
    }

    protected processGetAuthenticationExpirationDate(response: HttpResponseBase): Observable<Date> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? new Date(resultData200.toString()) : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the bonus history.
     * @return A list of bonus history
     */
    getBonusHistory(): Observable<BonusHistory[] | null> {
        let url_ = this.baseUrl + "/umbraco/api/Member/GetBonusHistory";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBonusHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBonusHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BonusHistory[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BonusHistory[] | null>;
        }));
    }

    protected processGetBonusHistory(response: HttpResponseBase): Observable<BonusHistory[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BonusHistory.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the bonus history by id.
     * @param id The identifier.
     * @return A list of bonus history
     */
    getBonusHistoryById(id: number): Observable<BonusHistory | null> {
        let url_ = this.baseUrl + "/umbraco/api/Member/GetBonusHistoryById/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBonusHistoryById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBonusHistoryById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BonusHistory | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BonusHistory | null>;
        }));
    }

    protected processGetBonusHistoryById(response: HttpResponseBase): Observable<BonusHistory | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? BonusHistory.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the bonus history by member identifier.
     * @param id The identifier.
     * @return List of history bonus by Member id
     */
    getBonusHistoryByMemberId(id: number): Observable<BonusHistory[] | null> {
        let url_ = this.baseUrl + "/umbraco/api/Member/GetBonusHistoryByMemberId/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBonusHistoryByMemberId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBonusHistoryByMemberId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BonusHistory[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BonusHistory[] | null>;
        }));
    }

    protected processGetBonusHistoryByMemberId(response: HttpResponseBase): Observable<BonusHistory[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BonusHistory.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the by identifier.
     * @param id The identifier.
     * @return The details of a member
     */
    getById(id: number): Observable<MemberDetails | null> {
        let url_ = this.baseUrl + "/umbraco/api/Member/GetById/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MemberDetails | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MemberDetails | null>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<MemberDetails | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? MemberDetails.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the countries.
     * @return All the countries
     */
    getCountries(): Observable<Country[] | null> {
        let url_ = this.baseUrl + "/umbraco/api/Member/GetCountries";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCountries(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCountries(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Country[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Country[] | null>;
        }));
    }

    protected processGetCountries(response: HttpResponseBase): Observable<Country[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Country.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the countries with name.
     * @return All the countries with name.
     */
    getCountriesWithName(): Observable<CountryWithName[] | null> {
        let url_ = this.baseUrl + "/umbraco/api/Member/GetCountriesWithName";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCountriesWithName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCountriesWithName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CountryWithName[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CountryWithName[] | null>;
        }));
    }

    protected processGetCountriesWithName(response: HttpResponseBase): Observable<CountryWithName[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CountryWithName.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the current member.
     * @return The current member.
     */
    getCurrentMember(): Observable<CurrentMember | null> {
        let url_ = this.baseUrl + "/umbraco/api/Member/GetCurrentMember";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentMember(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentMember(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CurrentMember | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CurrentMember | null>;
        }));
    }

    protected processGetCurrentMember(response: HttpResponseBase): Observable<CurrentMember | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CurrentMember.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the current member cart information.
     * @return The current member cart information.
     */
    getCurrentMemberCartInfo(): Observable<CurrentMemberCartInfo | null> {
        let url_ = this.baseUrl + "/umbraco/api/Member/GetCurrentMemberCartInfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentMemberCartInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentMemberCartInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CurrentMemberCartInfo | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CurrentMemberCartInfo | null>;
        }));
    }

    protected processGetCurrentMemberCartInfo(response: HttpResponseBase): Observable<CurrentMemberCartInfo | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CurrentMemberCartInfo.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the current member cart information.
     * @return The current member information.
     */
    getCurrentMemberCreateInfo(): Observable<CurrentMemberInfo | null> {
        let url_ = this.baseUrl + "/umbraco/api/Member/GetCurrentMemberCreateInfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentMemberCreateInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentMemberCreateInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CurrentMemberInfo | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CurrentMemberInfo | null>;
        }));
    }

    protected processGetCurrentMemberCreateInfo(response: HttpResponseBase): Observable<CurrentMemberInfo | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CurrentMemberInfo.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the current member details.
     * @return The current member details.
     */
    getCurrentMemberEditDetails(): Observable<CurrentMemberDetails | null> {
        let url_ = this.baseUrl + "/umbraco/api/Member/GetCurrentMemberEditDetails";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentMemberEditDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentMemberEditDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CurrentMemberDetails | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CurrentMemberDetails | null>;
        }));
    }

    protected processGetCurrentMemberEditDetails(response: HttpResponseBase): Observable<CurrentMemberDetails | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CurrentMemberDetails.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the current member finance info.
     * @return The current member finance info.
     */
    getCurrentMemberFinanceInfo(): Observable<CurrentMemberFinanceInfo | null> {
        let url_ = this.baseUrl + "/umbraco/api/Member/GetCurrentMemberFinanceInfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentMemberFinanceInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentMemberFinanceInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CurrentMemberFinanceInfo | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CurrentMemberFinanceInfo | null>;
        }));
    }

    protected processGetCurrentMemberFinanceInfo(response: HttpResponseBase): Observable<CurrentMemberFinanceInfo | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CurrentMemberFinanceInfo.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the current member pro nutri information.
     * @return The current member ProNutri info
     */
    getCurrentMemberProNutriInfo(): Observable<CurrentMemberProNutriInfo | null> {
        let url_ = this.baseUrl + "/umbraco/api/Member/GetCurrentMemberProNutriInfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentMemberProNutriInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentMemberProNutriInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CurrentMemberProNutriInfo | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CurrentMemberProNutriInfo | null>;
        }));
    }

    protected processGetCurrentMemberProNutriInfo(response: HttpResponseBase): Observable<CurrentMemberProNutriInfo | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CurrentMemberProNutriInfo.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the current member siin academy information.
     * @return The current member siin academy info.
     */
    getCurrentMemberSiinAcademyInfo(): Observable<CurrentMemberSiinAcademyInfo | null> {
        let url_ = this.baseUrl + "/umbraco/api/Member/GetCurrentMemberSiinAcademyInfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentMemberSiinAcademyInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentMemberSiinAcademyInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CurrentMemberSiinAcademyInfo | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CurrentMemberSiinAcademyInfo | null>;
        }));
    }

    protected processGetCurrentMemberSiinAcademyInfo(response: HttpResponseBase): Observable<CurrentMemberSiinAcademyInfo | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CurrentMemberSiinAcademyInfo.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the departements.
     * @return All the departement
     */
    getDepartements(): Observable<Departement[] | null> {
        let url_ = this.baseUrl + "/umbraco/api/Member/GetDepartements";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDepartements(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDepartements(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Departement[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Departement[] | null>;
        }));
    }

    protected processGetDepartements(response: HttpResponseBase): Observable<Departement[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Departement.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the discount for owned sub course trainings by course session identifier.
     * @param courseSessionId The course session identifier.
     * @return The discount.
     */
    getDiscountForOwnedSubOrTrialCourseTrainingsByCourseSessionId(courseSessionId: number): Observable<number> {
        let url_ = this.baseUrl + "/umbraco/api/Member/GetDiscountForOwnedSubOrTrialCourseTrainingsByCourseSessionId?";
        if (courseSessionId === undefined || courseSessionId === null)
            throw new Error("The parameter 'courseSessionId' must be defined and cannot be null.");
        else
            url_ += "courseSessionId=" + encodeURIComponent("" + courseSessionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDiscountForOwnedSubOrTrialCourseTrainingsByCourseSessionId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDiscountForOwnedSubOrTrialCourseTrainingsByCourseSessionId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetDiscountForOwnedSubOrTrialCourseTrainingsByCourseSessionId(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the dropdown values.
     * @param search The search.
     * @param needMoodleId (optional) Value indicating if we need the umbracoId or MoodleId
     * @return The dropdwon values.
     */
    getDropdownValues(search: string | null, needMoodleId?: boolean | undefined): Observable<DropdownValue[] | null> {
        let url_ = this.baseUrl + "/umbraco/api/Member/GetDropdownValues?";
        if (search === undefined)
            throw new Error("The parameter 'search' must be defined.");
        else if(search !== null)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (needMoodleId === null)
            throw new Error("The parameter 'needMoodleId' cannot be null.");
        else if (needMoodleId !== undefined)
            url_ += "needMoodleId=" + encodeURIComponent("" + needMoodleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDropdownValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDropdownValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DropdownValue[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DropdownValue[] | null>;
        }));
    }

    protected processGetDropdownValues(response: HttpResponseBase): Observable<DropdownValue[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DropdownValue.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the duplicate members.
     * @return List of duplicate members
     */
    getDuplicateMembers(): Observable<MemberDuplicate[] | null> {
        let url_ = this.baseUrl + "/umbraco/api/Member/GetDuplicateMembers";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDuplicateMembers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDuplicateMembers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MemberDuplicate[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MemberDuplicate[] | null>;
        }));
    }

    protected processGetDuplicateMembers(response: HttpResponseBase): Observable<MemberDuplicate[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MemberDuplicate.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the current member ambassador information.
     * @param memberId The member identifier.
     * @return The current member ambassador info
     */
    getMemberAmbassadorInfo(memberId: number): Observable<MemberAmbassadorInfo | null> {
        let url_ = this.baseUrl + "/umbraco/api/Member/GetMemberAmbassadorInfo?";
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined and cannot be null.");
        else
            url_ += "memberId=" + encodeURIComponent("" + memberId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMemberAmbassadorInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMemberAmbassadorInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MemberAmbassadorInfo | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MemberAmbassadorInfo | null>;
        }));
    }

    protected processGetMemberAmbassadorInfo(response: HttpResponseBase): Observable<MemberAmbassadorInfo | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? MemberAmbassadorInfo.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the member available subvention organizations.
     * @param memberId The member identifier.
     * @return The member available subvention organizations
     */
    getMemberAvailableSubventionOrganizations(memberId: number): Observable<MemberSubventionOrganization[] | null> {
        let url_ = this.baseUrl + "/umbraco/api/Member/GetMemberAvailableSubventionOrganizations?";
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined and cannot be null.");
        else
            url_ += "memberId=" + encodeURIComponent("" + memberId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMemberAvailableSubventionOrganizations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMemberAvailableSubventionOrganizations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MemberSubventionOrganization[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MemberSubventionOrganization[] | null>;
        }));
    }

    protected processGetMemberAvailableSubventionOrganizations(response: HttpResponseBase): Observable<MemberSubventionOrganization[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MemberSubventionOrganization.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the member identifier by member moodle identifier.
     * @param memberMoodleId The member moodle identifier.
     * @return The member id.
     */
    getMemberIdByMemberMoodleId(memberMoodleId: number): Observable<number> {
        let url_ = this.baseUrl + "/umbraco/api/Member/GetMemberIdByMemberMoodleId?";
        if (memberMoodleId === undefined || memberMoodleId === null)
            throw new Error("The parameter 'memberMoodleId' must be defined and cannot be null.");
        else
            url_ += "memberMoodleId=" + encodeURIComponent("" + memberMoodleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMemberIdByMemberMoodleId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMemberIdByMemberMoodleId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetMemberIdByMemberMoodleId(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the members by godfather code.
     * @param godfatherCode The godfather code.
     * @return List of members
     */
    getMembersByGodfatherCode(godfatherCode: string | null): Observable<GodfatherSponsorship[] | null> {
        let url_ = this.baseUrl + "/umbraco/api/Member/GetMembersByGodfatherCode?";
        if (godfatherCode === undefined)
            throw new Error("The parameter 'godfatherCode' must be defined.");
        else if(godfatherCode !== null)
            url_ += "godfatherCode=" + encodeURIComponent("" + godfatherCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMembersByGodfatherCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMembersByGodfatherCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GodfatherSponsorship[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GodfatherSponsorship[] | null>;
        }));
    }

    protected processGetMembersByGodfatherCode(response: HttpResponseBase): Observable<GodfatherSponsorship[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GodfatherSponsorship.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the members by reseller code.
     * @param resellerCode The reseller code.
     * @return List of members
     */
    getMembersByResellerCode(resellerCode: string | null): Observable<ResellerClient[] | null> {
        let url_ = this.baseUrl + "/umbraco/api/Member/GetMembersByResellerCode?";
        if (resellerCode === undefined)
            throw new Error("The parameter 'resellerCode' must be defined.");
        else if(resellerCode !== null)
            url_ += "resellerCode=" + encodeURIComponent("" + resellerCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMembersByResellerCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMembersByResellerCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResellerClient[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResellerClient[] | null>;
        }));
    }

    protected processGetMembersByResellerCode(response: HttpResponseBase): Observable<ResellerClient[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ResellerClient.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the members for bonus.
     * @return The list of members
     */
    getMembersForBonus(): Observable<MemberBonus[] | null> {
        let url_ = this.baseUrl + "/umbraco/api/Member/GetMembersForBonus";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMembersForBonus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMembersForBonus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MemberBonus[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MemberBonus[] | null>;
        }));
    }

    protected processGetMembersForBonus(response: HttpResponseBase): Observable<MemberBonus[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MemberBonus.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the notification.
     * @param includeSeen The is seen status
     * @return The list of members
     */
    getMembersNewFileNotifications(includeSeen: boolean): Observable<NewClientFileNotification[] | null> {
        let url_ = this.baseUrl + "/umbraco/api/Member/GetMembersNewFileNotifications?";
        if (includeSeen === undefined || includeSeen === null)
            throw new Error("The parameter 'includeSeen' must be defined and cannot be null.");
        else
            url_ += "includeSeen=" + encodeURIComponent("" + includeSeen) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMembersNewFileNotifications(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMembersNewFileNotifications(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NewClientFileNotification[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NewClientFileNotification[] | null>;
        }));
    }

    protected processGetMembersNewFileNotifications(response: HttpResponseBase): Observable<NewClientFileNotification[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NewClientFileNotification.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the global document list.
     * @param documentBoSearchParams The document seach params
     * @return The list of documents
     */
    getGlobalMembersDocuments(documentBoSearchParams: DocumentBOSearchParams | null): Observable<NewClientFileNotification[] | null> {
        let url_ = this.baseUrl + "/umbraco/api/Member/GetGlobalMembersDocuments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(documentBoSearchParams);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGlobalMembersDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGlobalMembersDocuments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NewClientFileNotification[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NewClientFileNotification[] | null>;
        }));
    }

    protected processGetGlobalMembersDocuments(response: HttpResponseBase): Observable<NewClientFileNotification[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NewClientFileNotification.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Sets the member document status.
     * @param documentId The member document identifier.
     */
    updateMemberDocumentNewStatus(documentId: number): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/api/Member/UpdateMemberDocumentNewStatus?";
        if (documentId === undefined || documentId === null)
            throw new Error("The parameter 'documentId' must be defined and cannot be null.");
        else
            url_ += "documentId=" + encodeURIComponent("" + documentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateMemberDocumentNewStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateMemberDocumentNewStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateMemberDocumentNewStatus(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the nationalities.
     * @return the nationalities with name.
     */
    getNationalities(): Observable<NationalityWithName[] | null> {
        let url_ = this.baseUrl + "/umbraco/api/Member/GetNationalities";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNationalities(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNationalities(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NationalityWithName[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NationalityWithName[] | null>;
        }));
    }

    protected processGetNationalities(response: HttpResponseBase): Observable<NationalityWithName[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NationalityWithName.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the profession by identifier.
     * @param professionId The profession identifier.
     * @return Profession label
     */
    getProfessionById(professionId: number): Observable<string | null> {
        let url_ = this.baseUrl + "/umbraco/api/Member/GetProfessionById?";
        if (professionId === undefined || professionId === null)
            throw new Error("The parameter 'professionId' must be defined and cannot be null.");
        else
            url_ += "professionId=" + encodeURIComponent("" + professionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProfessionById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProfessionById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string | null>;
        }));
    }

    protected processGetProfessionById(response: HttpResponseBase): Observable<string | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the pro nutri consult informations.
     * @param memberId The member identifier.
     * @return ProNutriConsult information for BO
     */
    getProNutriConsultInformations(memberId: number): Observable<ProNutriConsultMemberInformation | null> {
        let url_ = this.baseUrl + "/umbraco/api/Member/GetProNutriConsultInformations?";
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined and cannot be null.");
        else
            url_ += "memberId=" + encodeURIComponent("" + memberId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProNutriConsultInformations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProNutriConsultInformations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProNutriConsultMemberInformation | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProNutriConsultMemberInformation | null>;
        }));
    }

    protected processGetProNutriConsultInformations(response: HttpResponseBase): Observable<ProNutriConsultMemberInformation | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ProNutriConsultMemberInformation.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the purchase order.
     * @param id The identifier.
     * @return The list of purchased order for a member
     */
    getPurchaseOrders(id: number): Observable<PurchaseOrder[] | null> {
        let url_ = this.baseUrl + "/umbraco/api/Member/GetPurchaseOrders/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPurchaseOrders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPurchaseOrders(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PurchaseOrder[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PurchaseOrder[] | null>;
        }));
    }

    protected processGetPurchaseOrders(response: HttpResponseBase): Observable<PurchaseOrder[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PurchaseOrder.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the purchase order.
     * @param memberId The member identifier.
     * @param courseSessionId The course session identifier.
     * @return The purchased order
     */
    getPurchaseOrder(memberId: number, courseSessionId: number): Observable<PurchaseOrderDetails | null> {
        let url_ = this.baseUrl + "/umbraco/api/Member/GetPurchaseOrder?";
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined and cannot be null.");
        else
            url_ += "memberId=" + encodeURIComponent("" + memberId) + "&";
        if (courseSessionId === undefined || courseSessionId === null)
            throw new Error("The parameter 'courseSessionId' must be defined and cannot be null.");
        else
            url_ += "courseSessionId=" + encodeURIComponent("" + courseSessionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPurchaseOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPurchaseOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PurchaseOrderDetails | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PurchaseOrderDetails | null>;
        }));
    }

    protected processGetPurchaseOrder(response: HttpResponseBase): Observable<PurchaseOrderDetails | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PurchaseOrderDetails.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the siin academy member ids.
     * @return The list of siin academy member ids
     */
    getSiinAcademyMemberIds(): Observable<number[] | null> {
        let url_ = this.baseUrl + "/umbraco/api/Member/GetSiinAcademyMemberIds";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSiinAcademyMemberIds(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSiinAcademyMemberIds(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number[] | null>;
        }));
    }

    protected processGetSiinAcademyMemberIds(response: HttpResponseBase): Observable<number[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the professions.
     * @return The list of types in umbraco
     */
    getTypes(): Observable<DataStoreResource[] | null> {
        let url_ = this.baseUrl + "/umbraco/api/Member/GetTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DataStoreResource[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DataStoreResource[] | null>;
        }));
    }

    protected processGetTypes(response: HttpResponseBase): Observable<DataStoreResource[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DataStoreResource.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Imports the external member file.
     * @param externalCursusImport The external cursus to import.
     * @return The status response
     */
    importExternalCursusFile(externalCursusImport: ExternalCursusImport | null): Observable<ResponseStatus> {
        let url_ = this.baseUrl + "/umbraco/api/Member/ImportExternalCursusFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(externalCursusImport);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportExternalCursusFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportExternalCursusFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseStatus>;
        }));
    }

    protected processImportExternalCursusFile(response: HttpResponseBase): Observable<ResponseStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Determines whether [is vat required] [the specified profession identifier].
     * @param professionId The profession identifier.
     * @param country The country.
     * @return true if [is vat required] [the specified profession identifier]; otherwise, false.
     */
    isPharmacyAuthorizationRequired(professionId: number, country: string | null): Observable<boolean> {
        let url_ = this.baseUrl + "/umbraco/api/Member/IsPharmacyAuthorizationRequired?";
        if (professionId === undefined || professionId === null)
            throw new Error("The parameter 'professionId' must be defined and cannot be null.");
        else
            url_ += "professionId=" + encodeURIComponent("" + professionId) + "&";
        if (country === undefined)
            throw new Error("The parameter 'country' must be defined.");
        else if(country !== null)
            url_ += "country=" + encodeURIComponent("" + country) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsPharmacyAuthorizationRequired(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsPharmacyAuthorizationRequired(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processIsPharmacyAuthorizationRequired(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Determines whether the specified advantage code is valid.
     * @param advantageCode The advantage code.
     * @return true if [is valid advantage code]; otherwise, false.
     */
    isValidAdvantageCode(advantageCode: string | null): Observable<boolean> {
        let url_ = this.baseUrl + "/umbraco/api/Member/IsValidAdvantageCode?";
        if (advantageCode === undefined)
            throw new Error("The parameter 'advantageCode' must be defined.");
        else if(advantageCode !== null)
            url_ += "advantageCode=" + encodeURIComponent("" + advantageCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsValidAdvantageCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsValidAdvantageCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processIsValidAdvantageCode(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Logins the specified login.
     * @param login The login.
     * @return True if logged
     */
    loginSiin(login: Login | null): Observable<ResponseStatus> {
        let url_ = this.baseUrl + "/umbraco/api/Member/LoginSiin";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(login);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLoginSiin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLoginSiin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseStatus>;
        }));
    }

    protected processLoginSiin(response: HttpResponseBase): Observable<ResponseStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Logins the specified login.
     * @param member The login with email instead of username.
     * @return True if logged
     */
    loginOrCreateAccount(member: MemberBasicInfo | null): Observable<ResponseStatus> {
        let url_ = this.baseUrl + "/umbraco/api/Member/LoginOrCreateAccount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(member);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLoginOrCreateAccount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLoginOrCreateAccount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseStatus>;
        }));
    }

    protected processLoginOrCreateAccount(response: HttpResponseBase): Observable<ResponseStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Tests the method.
     */
    keepConnectionAlive(): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/api/Member/KeepConnectionAlive";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processKeepConnectionAlive(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processKeepConnectionAlive(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processKeepConnectionAlive(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class NutritionalSupplementRepository {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Archives the laboratory.
     * @param laboratoryId The laboratory identifier.
     */
    archiveLaboratory(laboratoryId: number): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/NutritionalSupplement/ArchiveLaboratory/?laboratoryId={laboratoryId}";
        if (laboratoryId === undefined || laboratoryId === null)
            throw new Error("The parameter 'laboratoryId' must be defined.");
        url_ = url_.replace("{laboratoryId}", encodeURIComponent("" + laboratoryId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processArchiveLaboratory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processArchiveLaboratory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processArchiveLaboratory(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Creates the laboratory.
     * @param laboratory The laboratory.
     * @return The id of the created laboratory.
     */
    createLaboratory(laboratory: Laboratory | null): Observable<number> {
        let url_ = this.baseUrl + "/umbraco/Api/NutritionalSupplement/CreateLaboratory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(laboratory);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateLaboratory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateLaboratory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateLaboratory(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Creates the nutritional supplement.
     * @param nutritionalSupplement The nutritional supplement.
     */
    createNutritionalSupplement(nutritionalSupplement: NutritionalSupplementDetails | null): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/NutritionalSupplement/CreateNutritionalSupplement";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(nutritionalSupplement);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateNutritionalSupplement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateNutritionalSupplement(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateNutritionalSupplement(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the nutritional supplement for library.
     * @param searchParam The search parameter.
     * @return the nutritionalSupplement for library.
     */
    getNutritionalSupplementForLibrary(searchParam: NutritionalSupplementSearchParamLibrary | null): Observable<PaginatorWrapperOfIEnumerableOfNutritionalSupplementLite | null> {
        let url_ = this.baseUrl + "/umbraco/Api/NutritionalSupplement/GetNutritionalSupplementForLibrary";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchParam);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNutritionalSupplementForLibrary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNutritionalSupplementForLibrary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaginatorWrapperOfIEnumerableOfNutritionalSupplementLite | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaginatorWrapperOfIEnumerableOfNutritionalSupplementLite | null>;
        }));
    }

    protected processGetNutritionalSupplementForLibrary(response: HttpResponseBase): Observable<PaginatorWrapperOfIEnumerableOfNutritionalSupplementLite | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PaginatorWrapperOfIEnumerableOfNutritionalSupplementLite.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the nutritional supplement for library.
     * @param searchParam The search parameter.
     * @return the nutritionalSupplement for library.
     */
    getNutritionalSupplementForBackoffice(searchParam: NutritionalSupplementSearchParamLibrary | null): Observable<PaginatorWrapperOfIEnumerableOfNutritionalSupplementLite | null> {
        let url_ = this.baseUrl + "/umbraco/Api/NutritionalSupplement/GetNutritionalSupplementForBackoffice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchParam);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNutritionalSupplementForBackoffice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNutritionalSupplementForBackoffice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaginatorWrapperOfIEnumerableOfNutritionalSupplementLite | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaginatorWrapperOfIEnumerableOfNutritionalSupplementLite | null>;
        }));
    }

    protected processGetNutritionalSupplementForBackoffice(response: HttpResponseBase): Observable<PaginatorWrapperOfIEnumerableOfNutritionalSupplementLite | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PaginatorWrapperOfIEnumerableOfNutritionalSupplementLite.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets a list of active principles.
     * @return A list of active principles.
     */
    getAllActivePrinciples(): Observable<NutritionalSupplementActivePrincipleView[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/NutritionalSupplement/GetAllActivePrinciples";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllActivePrinciples(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllActivePrinciples(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NutritionalSupplementActivePrincipleView[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NutritionalSupplementActivePrincipleView[] | null>;
        }));
    }

    protected processGetAllActivePrinciples(response: HttpResponseBase): Observable<NutritionalSupplementActivePrincipleView[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NutritionalSupplementActivePrincipleView.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets a list of galenics.
     * @return A list of galenics.
     */
    getAllGalenics(): Observable<string[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/NutritionalSupplement/GetAllGalenicsAsync";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllGalenics(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllGalenics(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[] | null>;
        }));
    }

    protected processGetAllGalenics(response: HttpResponseBase): Observable<string[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets a list of plants.
     * @return A list of plants.
     */
    getAllPlants(): Observable<DropdownValue[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/NutritionalSupplement/GetAllPlants";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPlants(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPlants(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DropdownValue[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DropdownValue[] | null>;
        }));
    }

    protected processGetAllPlants(response: HttpResponseBase): Observable<DropdownValue[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DropdownValue.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the laboratories.
     * @param laboratoryId The laboratory identifier.
     * @return The laboratory.
     */
    getLaboratory(laboratoryId: number): Observable<Laboratory | null> {
        let url_ = this.baseUrl + "/umbraco/Api/NutritionalSupplement/GetLaboratory/?laboratoryId={laboratoryId}";
        if (laboratoryId === undefined || laboratoryId === null)
            throw new Error("The parameter 'laboratoryId' must be defined.");
        url_ = url_.replace("{laboratoryId}", encodeURIComponent("" + laboratoryId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLaboratory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLaboratory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Laboratory | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Laboratory | null>;
        }));
    }

    protected processGetLaboratory(response: HttpResponseBase): Observable<Laboratory | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? Laboratory.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the laboratories.
     * @param searchParams The search parameters.
     * @return The laboratories.
     */
    getLaboratories(searchParams: LaboratorySearchParams | null): Observable<Laboratory[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/NutritionalSupplement/GetLaboratories";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchParams);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLaboratories(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLaboratories(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Laboratory[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Laboratory[] | null>;
        }));
    }

    protected processGetLaboratories(response: HttpResponseBase): Observable<Laboratory[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Laboratory.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the laboratory drop down value.
     * @return the dropdown value for laboratory.
     */
    getLaboratoryDropDownValue(): Observable<DropdownValue[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/NutritionalSupplement/GetLaboratoryDropDownValue";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLaboratoryDropDownValue(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLaboratoryDropDownValue(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DropdownValue[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DropdownValue[] | null>;
        }));
    }

    protected processGetLaboratoryDropDownValue(response: HttpResponseBase): Observable<DropdownValue[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DropdownValue.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the nutritional supplement details.
     * @param id The identifier.
     * @return the nutritional details.
     */
    getNutritionalSupplementDetails(id: number): Observable<NutritionalSupplementDetails | null> {
        let url_ = this.baseUrl + "/umbraco/Api/NutritionalSupplement/GetNutritionalSupplementDetails/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNutritionalSupplementDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNutritionalSupplementDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NutritionalSupplementDetails | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NutritionalSupplementDetails | null>;
        }));
    }

    protected processGetNutritionalSupplementDetails(response: HttpResponseBase): Observable<NutritionalSupplementDetails | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? NutritionalSupplementDetails.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates the specified laboratory.
     * @param laboratory The laboratory.
     */
    updateLaboratory(laboratory: Laboratory | null): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/NutritionalSupplement/UpdateLaboratory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(laboratory);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateLaboratory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateLaboratory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateLaboratory(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates the nutritional status.
     * @param id The identifier.
     * @param status if set to true [status].
     */
    updateNutritionalSupplementStatus(id: number, status: boolean): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/NutritionalSupplement/UpdateNutritionalSupplementStatus/{id}?status={status}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (status === undefined || status === null)
            throw new Error("The parameter 'status' must be defined.");
        url_ = url_.replace("{status}", encodeURIComponent("" + status));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateNutritionalSupplementStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateNutritionalSupplementStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateNutritionalSupplementStatus(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates the nutritional supplement.
     * @param nutritionalSupplement The nutritional supplement.
     */
    updateNutritionalSupplement(nutritionalSupplement: NutritionalSupplementDetails | null): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/NutritionalSupplement/UpdateNutritionalSupplement";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(nutritionalSupplement);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateNutritionalSupplement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateNutritionalSupplement(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateNutritionalSupplement(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the doctor's nutritional supplement.
     * @param searchParam The search parameter.
     * @return the doctor's nutritionalSupplement.
     */
    getDoctorNutritionalSupplement(searchParam: NutritionalSupplementSearchParamLibrary | null): Observable<PaginatorWrapperOfIEnumerableOfNutritionalSupplementLite | null> {
        let url_ = this.baseUrl + "/umbraco/Api/NutritionalSupplement/GetDoctorNutritionalSupplement";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchParam);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDoctorNutritionalSupplement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDoctorNutritionalSupplement(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaginatorWrapperOfIEnumerableOfNutritionalSupplementLite | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaginatorWrapperOfIEnumerableOfNutritionalSupplementLite | null>;
        }));
    }

    protected processGetDoctorNutritionalSupplement(response: HttpResponseBase): Observable<PaginatorWrapperOfIEnumerableOfNutritionalSupplementLite | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PaginatorWrapperOfIEnumerableOfNutritionalSupplementLite.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Deletes the doctor's nutritional supplement.
     * @param nutritionalSupplementId The nutritional supplement identifier.
     * @return The response status
     */
    deleteDoctorNutritionalSupplement(nutritionalSupplementId: number): Observable<ResponseStatus> {
        let url_ = this.baseUrl + "/umbraco/Api/NutritionalSupplement/DeleteDoctorNutritionalSupplement/?nutritionalSupplementId={nutritionalSupplementId}";
        if (nutritionalSupplementId === undefined || nutritionalSupplementId === null)
            throw new Error("The parameter 'nutritionalSupplementId' must be defined.");
        url_ = url_.replace("{nutritionalSupplementId}", encodeURIComponent("" + nutritionalSupplementId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteDoctorNutritionalSupplement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteDoctorNutritionalSupplement(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseStatus>;
        }));
    }

    protected processDeleteDoctorNutritionalSupplement(response: HttpResponseBase): Observable<ResponseStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Toggles the doctor's nutritional supplement.
     * @param nutritionalSupplementId The nutritional supplement identifier.
     */
    toggleDoctorNutritionalSupplement(nutritionalSupplementId: number): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/NutritionalSupplement/ToggleDoctorNutritionalSupplement/?nutritionalSupplementId={nutritionalSupplementId}";
        if (nutritionalSupplementId === undefined || nutritionalSupplementId === null)
            throw new Error("The parameter 'nutritionalSupplementId' must be defined.");
        url_ = url_.replace("{nutritionalSupplementId}", encodeURIComponent("" + nutritionalSupplementId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processToggleDoctorNutritionalSupplement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processToggleDoctorNutritionalSupplement(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processToggleDoctorNutritionalSupplement(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates the active principle isadditive flag.
     * @param id The identifier.
     * @param isAdditive if set to true then, is additive.
     */
    updateActivePrincipleIsAdditiveFlag(id: number, isAdditive: boolean): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/NutritionalSupplement/UpdateActivePrincipleIsAdditiveFlag/{id}?isAdditive={isAdditive}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (isAdditive === undefined || isAdditive === null)
            throw new Error("The parameter 'isAdditive' must be defined.");
        url_ = url_.replace("{isAdditive}", encodeURIComponent("" + isAdditive));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateActivePrincipleIsAdditiveFlag(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateActivePrincipleIsAdditiveFlag(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateActivePrincipleIsAdditiveFlag(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class PatientRepository {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Gets the patient relative.
     * @param relativePatientId The relative patient identifier.
     * @return The patient relative.
     */
    goToPatientRelative(relativePatientId: number): Observable<CurrentPatientInfo | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Patient/GoToPatientRelative/?relativePatientId={relativePatientId}";
        if (relativePatientId === undefined || relativePatientId === null)
            throw new Error("The parameter 'relativePatientId' must be defined.");
        url_ = url_.replace("{relativePatientId}", encodeURIComponent("" + relativePatientId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGoToPatientRelative(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGoToPatientRelative(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CurrentPatientInfo | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CurrentPatientInfo | null>;
        }));
    }

    protected processGoToPatientRelative(response: HttpResponseBase): Observable<CurrentPatientInfo | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CurrentPatientInfo.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the current patient relative accessible menu.
     * @param relativePatientId The relative patient identifier.
     * @return The accessible menus.
     */
    getCurrentPatientRelativeSignalitics(relativePatientId: number): Observable<PatientSignalitics | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Patient/GetCurrentPatientRelativeSignalitics/?relativePatientId={relativePatientId}";
        if (relativePatientId === undefined || relativePatientId === null)
            throw new Error("The parameter 'relativePatientId' must be defined.");
        url_ = url_.replace("{relativePatientId}", encodeURIComponent("" + relativePatientId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentPatientRelativeSignalitics(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentPatientRelativeSignalitics(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PatientSignalitics | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PatientSignalitics | null>;
        }));
    }

    protected processGetCurrentPatientRelativeSignalitics(response: HttpResponseBase): Observable<PatientSignalitics | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PatientSignalitics.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the current patient relative accessible menu.
     * @return The accessible menus.
     */
    getCurrentPatientResponsibleSignalitics(): Observable<PatientSignalitics | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Patient/GetCurrentPatientResponsibleSignalitics";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentPatientResponsibleSignalitics(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentPatientResponsibleSignalitics(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PatientSignalitics | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PatientSignalitics | null>;
        }));
    }

    protected processGetCurrentPatientResponsibleSignalitics(response: HttpResponseBase): Observable<PatientSignalitics | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PatientSignalitics.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Unlink the relative patient.
     * @param patientId The patient identifier.
     * @param email The email.
     */
    unlinkResponsible(patientId: number, email: string): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/Patient/UnlinkResponsible/?patientId={patientId}&email={email}";
        if (patientId === undefined || patientId === null)
            throw new Error("The parameter 'patientId' must be defined.");
        url_ = url_.replace("{patientId}", encodeURIComponent("" + patientId));
        if (email === undefined || email === null)
            throw new Error("The parameter 'email' must be defined.");
        url_ = url_.replace("{email}", encodeURIComponent("" + email));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnlinkResponsible(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnlinkResponsible(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUnlinkResponsible(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Creates the patient account.
     * @param registrationInfos The registration infos.
     * @return The identifier of the newly created patient
     */
    createPatientRelativeAccount(registrationInfos: PatientRegistrationInfos | null): Observable<ResponseStatus> {
        let url_ = this.baseUrl + "/umbraco/Api/Patient/CreatePatientRelativeAccount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(registrationInfos);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePatientRelativeAccount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePatientRelativeAccount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseStatus>;
        }));
    }

    protected processCreatePatientRelativeAccount(response: HttpResponseBase): Observable<ResponseStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the doctor patient favorites.
     * @return The doctor patient favorites
     */
    getDoctorPatientFavorites(): Observable<PaginatorWrapperOfIEnumerableOfDoctorConsultSiinInfos | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Patient/GetDoctorPatientFavorites";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDoctorPatientFavorites(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDoctorPatientFavorites(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaginatorWrapperOfIEnumerableOfDoctorConsultSiinInfos | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaginatorWrapperOfIEnumerableOfDoctorConsultSiinInfos | null>;
        }));
    }

    protected processGetDoctorPatientFavorites(response: HttpResponseBase): Observable<PaginatorWrapperOfIEnumerableOfDoctorConsultSiinInfos | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PaginatorWrapperOfIEnumerableOfDoctorConsultSiinInfos.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the doctors list for a patient.
     * @return The doctors
     */
    getDoctorsForCurrentPatient(): Observable<DoctorFilter[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Patient/GetDoctorsForCurrentPatient";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDoctorsForCurrentPatient(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDoctorsForCurrentPatient(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DoctorFilter[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DoctorFilter[] | null>;
        }));
    }

    protected processGetDoctorsForCurrentPatient(response: HttpResponseBase): Observable<DoctorFilter[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DoctorFilter.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Toggle the doctor patient favorites.
     * @param doctorId The doctor id.
     */
    toggleDoctorPatientFavorites(doctorId: number): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/Patient/ToggleDoctorPatientFavorites/?doctorId={doctorId}";
        if (doctorId === undefined || doctorId === null)
            throw new Error("The parameter 'doctorId' must be defined.");
        url_ = url_.replace("{doctorId}", encodeURIComponent("" + doctorId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processToggleDoctorPatientFavorites(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processToggleDoctorPatientFavorites(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processToggleDoctorPatientFavorites(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Creats the patient measure.
     * @param createPatientMeasure The create patient measure.
     * @return The id of the created patient measure.
     */
    createPatientMeasure(createPatientMeasure: CreatePatientMeasure | null): Observable<number> {
        let url_ = this.baseUrl + "/umbraco/Api/Patient/CreatePatientMeasure";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createPatientMeasure);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePatientMeasure(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePatientMeasure(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreatePatientMeasure(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Creates the patient measure.
     * @param createPatientMeasure The create patient measure.
     * @return The id of the created patient measure.
     */
    createCurrentPatientMeasure(createPatientMeasure: CreatePatientMeasure | null): Observable<number> {
        let url_ = this.baseUrl + "/umbraco/Api/Patient/CreateCurrentPatientMeasure";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createPatientMeasure);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateCurrentPatientMeasure(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateCurrentPatientMeasure(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateCurrentPatientMeasure(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates the patient answer or creates it if inexistent.
     * @param patientAnswer The patient answer.
     * @return A Task representing the asynchronous operation.
     */
    createOrUpdatePatientAnswer(patientAnswer: PatientAnswer | null): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/Patient/CreateOrUpdatePatientAnswer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(patientAnswer);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdatePatientAnswer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdatePatientAnswer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrUpdatePatientAnswer(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Checks if patient data exist.
     * @param searchParams The search params.
     * @return Data to complete field.
     */
    checkIfPatientDataExists(searchParams: PatientSearchParams | null): Observable<PatientSignalitics | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Patient/CheckIfPatientDataExists";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchParams);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckIfPatientDataExists(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckIfPatientDataExists(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PatientSignalitics | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PatientSignalitics | null>;
        }));
    }

    protected processCheckIfPatientDataExists(response: HttpResponseBase): Observable<PatientSignalitics | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PatientSignalitics.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Creates the allergy.
     * @param allergy The allergy.
     * @return The identifier of the newly created allergy
     */
    createSiinAllergy(allergy: SiinAllergy | null): Observable<number> {
        let url_ = this.baseUrl + "/umbraco/Api/Patient/CreateSiinAllergy";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(allergy);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateSiinAllergy(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateSiinAllergy(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateSiinAllergy(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Creates the patient.
     * @param registration The registration.
     * @return The identifier of the created patient.
     */
    createPatient(registration: PatientRegistrationInfos | null): Observable<StatusValueResourceOfNullableInteger | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Patient/CreatePatient";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(registration);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePatient(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePatient(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StatusValueResourceOfNullableInteger | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StatusValueResourceOfNullableInteger | null>;
        }));
    }

    protected processCreatePatient(response: HttpResponseBase): Observable<StatusValueResourceOfNullableInteger | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? StatusValueResourceOfNullableInteger.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Creates the patient.
     * @param registration The registration.
     * @return The identifier of the created patient.
     */
    createPatientFromPWA(registration: PatientRegistrationInfos | null): Observable<number> {
        let url_ = this.baseUrl + "/umbraco/Api/Patient/CreatePatientFromPWA";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(registration);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePatientFromPWA(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePatientFromPWA(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreatePatientFromPWA(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Creates the patient.
     * @param phoneNumber (optional) The phone number.
     */
    createPatientFromCustomerAccount(phoneNumber?: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/Patient/CreatePatientFromCustomerAccount?";
        if (phoneNumber !== undefined && phoneNumber !== null)
            url_ += "phoneNumber=" + encodeURIComponent("" + phoneNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePatientFromCustomerAccount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePatientFromCustomerAccount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreatePatientFromCustomerAccount(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Creates patients based on imported list.
     * @param patientsList (optional) The patients list.
     * @return A response status.
     */
    uploadPatientsList(patientsList?: FileParameter | null | undefined): Observable<ResponseStatus> {
        let url_ = this.baseUrl + "/umbraco/Api/Patient/UploadPatientsList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (patientsList !== null && patientsList !== undefined)
            content_.append("patientsList", patientsList.data, patientsList.fileName ? patientsList.fileName : "patientsList");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadPatientsList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadPatientsList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseStatus>;
        }));
    }

    protected processUploadPatientsList(response: HttpResponseBase): Observable<ResponseStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Downloads a template example to import patients from excel file.
     * @return The Excel template.
     */
    downloadPatientsListTemplate(): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Patient/DownloadPatientsListTemplate";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadPatientsListTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadPatientsListTemplate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDownloadPatientsListTemplate(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the type of all patient measure.
     * @param patientId The patient identifier.
     * @return All the measure type used for a patient
     */
    getPatientMeasureType(patientId: number): Observable<PatientMeasureType[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Patient/GetPatientMeasureType/?patientId={patientId}";
        if (patientId === undefined || patientId === null)
            throw new Error("The parameter 'patientId' must be defined.");
        url_ = url_.replace("{patientId}", encodeURIComponent("" + patientId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPatientMeasureType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPatientMeasureType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PatientMeasureType[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PatientMeasureType[] | null>;
        }));
    }

    protected processGetPatientMeasureType(response: HttpResponseBase): Observable<PatientMeasureType[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PatientMeasureType.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the allergies.
     * @return The allergies
     */
    getAllergiesDropdownValues(): Observable<Allergy[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Patient/GetAllergiesDropdownValues";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllergiesDropdownValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllergiesDropdownValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Allergy[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Allergy[] | null>;
        }));
    }

    protected processGetAllergiesDropdownValues(response: HttpResponseBase): Observable<Allergy[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Allergy.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the allergens.
     * @return The allergens
     */
    getAllergensDropdownValues(): Observable<Allergy[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Patient/GetAllergensDropdownValues";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllergensDropdownValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllergensDropdownValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Allergy[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Allergy[] | null>;
        }));
    }

    protected processGetAllergensDropdownValues(response: HttpResponseBase): Observable<Allergy[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Allergy.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the allergens.
     * @return The allergens
     */
    getFoodsDropdownValues(): Observable<Allergy[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Patient/GetFoodsDropdownValues";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFoodsDropdownValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFoodsDropdownValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Allergy[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Allergy[] | null>;
        }));
    }

    protected processGetFoodsDropdownValues(response: HttpResponseBase): Observable<Allergy[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Allergy.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the patient measures.
     * @param searchParam The search parameter.
     * @return The patient mesures.
     */
    getPatientMeasures(searchParam: PatientMeasureSearchParam | null): Observable<PatientMeasure[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Patient/GetPatientMeasures";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchParam);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPatientMeasures(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPatientMeasures(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PatientMeasure[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PatientMeasure[] | null>;
        }));
    }

    protected processGetPatientMeasures(response: HttpResponseBase): Observable<PatientMeasure[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PatientMeasure.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the patient measures.
     * @param searchParam The search parameter.
     * @return The patient mesures.
     */
    getCurrentPatientMeasures(searchParam: PatientMeasureSearchParam | null): Observable<PatientMeasure[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Patient/GetCurrentPatientMeasures";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchParam);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentPatientMeasures(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentPatientMeasures(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PatientMeasure[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PatientMeasure[] | null>;
        }));
    }

    protected processGetCurrentPatientMeasures(response: HttpResponseBase): Observable<PatientMeasure[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PatientMeasure.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the patient measures.
     * @param patientId The patient identifier.
     * @param patientMeasureId The patient measure identifier.
     * @return A single patient measure by id.
     */
    getPatientMeasureById(patientId: number, patientMeasureId: number): Observable<PatientMeasure | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Patient/GetPatientMeasureById/?patientId={patientId}&patientMeasureId={patientMeasureId}";
        if (patientId === undefined || patientId === null)
            throw new Error("The parameter 'patientId' must be defined.");
        url_ = url_.replace("{patientId}", encodeURIComponent("" + patientId));
        if (patientMeasureId === undefined || patientMeasureId === null)
            throw new Error("The parameter 'patientMeasureId' must be defined.");
        url_ = url_.replace("{patientMeasureId}", encodeURIComponent("" + patientMeasureId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPatientMeasureById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPatientMeasureById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PatientMeasure | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PatientMeasure | null>;
        }));
    }

    protected processGetPatientMeasureById(response: HttpResponseBase): Observable<PatientMeasure | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PatientMeasure.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the patient measures summary.
     * @param patientId The patient identifier.
     * @return The summary of last one patient's measures
     */
    getPatientMeasuresSummary(patientId: number): Observable<PatientMeasure[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Patient/GetPatientMeasuresSummary/?patientId={patientId}";
        if (patientId === undefined || patientId === null)
            throw new Error("The parameter 'patientId' must be defined.");
        url_ = url_.replace("{patientId}", encodeURIComponent("" + patientId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPatientMeasuresSummary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPatientMeasuresSummary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PatientMeasure[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PatientMeasure[] | null>;
        }));
    }

    protected processGetPatientMeasuresSummary(response: HttpResponseBase): Observable<PatientMeasure[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PatientMeasure.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the allergies.
     * @param searchParams The search parameters.
     * @return The requested allergies
     */
    getSiinAllergies(searchParams: SiinAllergySearchParams | null): Observable<SiinAllergy[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Patient/GetSiinAllergies";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchParams);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSiinAllergies(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSiinAllergies(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SiinAllergy[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SiinAllergy[] | null>;
        }));
    }

    protected processGetSiinAllergies(response: HttpResponseBase): Observable<SiinAllergy[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SiinAllergy.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the allergy.
     * @param allergyId The allergy identifier.
     * @return The requested allergy
     */
    getSiinAllergy(allergyId: number): Observable<SiinAllergy | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Patient/GetSiinAllergy/?allergyId={allergyId}";
        if (allergyId === undefined || allergyId === null)
            throw new Error("The parameter 'allergyId' must be defined.");
        url_ = url_.replace("{allergyId}", encodeURIComponent("" + allergyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSiinAllergy(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSiinAllergy(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SiinAllergy | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SiinAllergy | null>;
        }));
    }

    protected processGetSiinAllergy(response: HttpResponseBase): Observable<SiinAllergy | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SiinAllergy.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the current patient accessible menu.
     * @return The accessible menus.
     */
    getCurrentPatientInfo(): Observable<CurrentPatientInfo | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Patient/GetCurrentPatientInfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentPatientInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentPatientInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CurrentPatientInfo | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CurrentPatientInfo | null>;
        }));
    }

    protected processGetCurrentPatientInfo(response: HttpResponseBase): Observable<CurrentPatientInfo | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CurrentPatientInfo.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all the coachings link to the specified patient.
     * @param patientId The search parameters.
     * @return All the coachings link to the specified patient.
     */
    getCoachings(patientId: number): Observable<PatientCoaching[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Patient/GetCoachings/?patientId={patientId}";
        if (patientId === undefined || patientId === null)
            throw new Error("The parameter 'patientId' must be defined.");
        url_ = url_.replace("{patientId}", encodeURIComponent("" + patientId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCoachings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCoachings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PatientCoaching[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PatientCoaching[] | null>;
        }));
    }

    protected processGetCoachings(response: HttpResponseBase): Observable<PatientCoaching[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PatientCoaching.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the patient.
     * @return The wanted patient.
     */
    getCurrentPatient(): Observable<PatientSignalitics | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Patient/GetCurrentPatient";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentPatient(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentPatient(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PatientSignalitics | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PatientSignalitics | null>;
        }));
    }

    protected processGetCurrentPatient(response: HttpResponseBase): Observable<PatientSignalitics | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PatientSignalitics.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the current patient activities.
     * @param searchParams The search parameters.
     * @return The Patient Coaching Activities
     */
    getCurrentPatientActivities(searchParams: SearchParams | null): Observable<PaginatorWrapperOfIEnumerableOfPatientCoachingActivity | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Patient/GetCurrentPatientActivities";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchParams);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentPatientActivities(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentPatientActivities(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaginatorWrapperOfIEnumerableOfPatientCoachingActivity | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaginatorWrapperOfIEnumerableOfPatientCoachingActivity | null>;
        }));
    }

    protected processGetCurrentPatientActivities(response: HttpResponseBase): Observable<PaginatorWrapperOfIEnumerableOfPatientCoachingActivity | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PaginatorWrapperOfIEnumerableOfPatientCoachingActivity.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the current patient allergies.
     * @return The patient allergies.
     */
    getCurrentPatientAllergies(): Observable<PatientAllergy[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Patient/GetCurrentPatientAllergies";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentPatientAllergies(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentPatientAllergies(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PatientAllergy[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PatientAllergy[] | null>;
        }));
    }

    protected processGetCurrentPatientAllergies(response: HttpResponseBase): Observable<PatientAllergy[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PatientAllergy.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the patient medical histories.
     * @return The medical histories linked with the current patient
     */
    getCurrentPatientMedicalHistories(): Observable<PatientMedicalHistory[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Patient/GetCurrentPatientMedicalHistories";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentPatientMedicalHistories(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentPatientMedicalHistories(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PatientMedicalHistory[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PatientMedicalHistory[] | null>;
        }));
    }

    protected processGetCurrentPatientMedicalHistories(response: HttpResponseBase): Observable<PatientMedicalHistory[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PatientMedicalHistory.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the current patient medical record.
     * @return The current patient medical record
     */
    getCurrentPatientMedicalRecord(): Observable<MedicalRecord | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Patient/GetCurrentPatientMedicalRecord";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentPatientMedicalRecord(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentPatientMedicalRecord(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MedicalRecord | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MedicalRecord | null>;
        }));
    }

    protected processGetCurrentPatientMedicalRecord(response: HttpResponseBase): Observable<MedicalRecord | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? MedicalRecord.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the current patient consultation formularies.
     * @param parameters The parameters.
     * @return The patient formularies.
     */
    getCurrentPatientConsultationFormularies(parameters: PatientConsultationFormularySearchParams | null): Observable<PatientConsultationFormulary[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Patient/GetCurrentPatientConsultationFormularies";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(parameters);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentPatientConsultationFormularies(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentPatientConsultationFormularies(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PatientConsultationFormulary[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PatientConsultationFormulary[] | null>;
        }));
    }

    protected processGetCurrentPatientConsultationFormularies(response: HttpResponseBase): Observable<PatientConsultationFormulary[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PatientConsultationFormulary.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the formulary patient answers.
     * @param formularyId The formulary identifier.
     * @param consultationId The patient identifier.
     * @return The patient answers to the requested formulary
     */
    getCurrentPatientFormularyAnswers(formularyId: number, consultationId: number): Observable<PatientAnswer[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Patient/GetCurrentPatientFormularyAnswers/?formularyId={formularyId}&consultationId={consultationId}";
        if (formularyId === undefined || formularyId === null)
            throw new Error("The parameter 'formularyId' must be defined.");
        url_ = url_.replace("{formularyId}", encodeURIComponent("" + formularyId));
        if (consultationId === undefined || consultationId === null)
            throw new Error("The parameter 'consultationId' must be defined.");
        url_ = url_.replace("{consultationId}", encodeURIComponent("" + consultationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentPatientFormularyAnswers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentPatientFormularyAnswers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PatientAnswer[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PatientAnswer[] | null>;
        }));
    }

    protected processGetCurrentPatientFormularyAnswers(response: HttpResponseBase): Observable<PatientAnswer[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PatientAnswer.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the current patient notifications.
     * @return The notifications.
     */
    getCurrentPatientNotifications(): Observable<PatientNotification[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Patient/GetCurrentPatientNotifications";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentPatientNotifications(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentPatientNotifications(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PatientNotification[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PatientNotification[] | null>;
        }));
    }

    protected processGetCurrentPatientNotifications(response: HttpResponseBase): Observable<PatientNotification[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PatientNotification.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the current patient parameters.
     * @return The patient parameters.
     */
    getCurrentPatientParameters(): Observable<PatientParameters | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Patient/GetCurrentPatientParameters";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentPatientParameters(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentPatientParameters(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PatientParameters | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PatientParameters | null>;
        }));
    }

    protected processGetCurrentPatientParameters(response: HttpResponseBase): Observable<PatientParameters | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PatientParameters.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the current patient related doctors.
     * @return The related doctors.
     */
    getCurrentPatientRelatedDoctors(): Observable<DoctorLiteInfo[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Patient/GetCurrentPatientRelatedDoctors";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentPatientRelatedDoctors(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentPatientRelatedDoctors(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DoctorLiteInfo[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DoctorLiteInfo[] | null>;
        }));
    }

    protected processGetCurrentPatientRelatedDoctors(response: HttpResponseBase): Observable<DoctorLiteInfo[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DoctorLiteInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the current patient sleep diaries.
     * @return The patient consultation formularies
     */
    getCurrentPatientSleepDiaries(): Observable<PatientConsultationFormulary[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Patient/GetCurrentPatientSleepDiaries";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentPatientSleepDiaries(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentPatientSleepDiaries(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PatientConsultationFormulary[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PatientConsultationFormulary[] | null>;
        }));
    }

    protected processGetCurrentPatientSleepDiaries(response: HttpResponseBase): Observable<PatientConsultationFormulary[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PatientConsultationFormulary.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the default patient.
     * @return The default patient.
     */
    getDefaultPatient(): Observable<StatusValueResourceOfPatientInfo | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Patient/GetDefaultPatient";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDefaultPatient(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDefaultPatient(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StatusValueResourceOfPatientInfo | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StatusValueResourceOfPatientInfo | null>;
        }));
    }

    protected processGetDefaultPatient(response: HttpResponseBase): Observable<StatusValueResourceOfPatientInfo | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? StatusValueResourceOfPatientInfo.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the formulary score.
     * @param consultationId The consultation identifier.
     * @param formularyVersionId The formulary version identifier.
     * @return The formulary score
     */
    getFormularyScore(consultationId: number, formularyVersionId: number): Observable<FormularyScore | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Patient/GetFormularyScore/?consultationId={consultationId}&formularyVersionId={formularyVersionId}";
        if (consultationId === undefined || consultationId === null)
            throw new Error("The parameter 'consultationId' must be defined.");
        url_ = url_.replace("{consultationId}", encodeURIComponent("" + consultationId));
        if (formularyVersionId === undefined || formularyVersionId === null)
            throw new Error("The parameter 'formularyVersionId' must be defined.");
        url_ = url_.replace("{formularyVersionId}", encodeURIComponent("" + formularyVersionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFormularyScore(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFormularyScore(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FormularyScore | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FormularyScore | null>;
        }));
    }

    protected processGetFormularyScore(response: HttpResponseBase): Observable<FormularyScore | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FormularyScore.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets score history of a patient for the specified formulary.
     * @param formularyVersionId The question identifier.
     * @param patientId The patient identifier.
     * @return The formulary scores sorted by date
     */
    getFormularyScoreHistory(formularyVersionId: number, patientId: number): Observable<FormularyScore[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Patient/GetFormularyScoreHistory/?formularyVersionId={formularyVersionId}&patientId={patientId}";
        if (formularyVersionId === undefined || formularyVersionId === null)
            throw new Error("The parameter 'formularyVersionId' must be defined.");
        url_ = url_.replace("{formularyVersionId}", encodeURIComponent("" + formularyVersionId));
        if (patientId === undefined || patientId === null)
            throw new Error("The parameter 'patientId' must be defined.");
        url_ = url_.replace("{patientId}", encodeURIComponent("" + patientId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFormularyScoreHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFormularyScoreHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FormularyScore[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FormularyScore[] | null>;
        }));
    }

    protected processGetFormularyScoreHistory(response: HttpResponseBase): Observable<FormularyScore[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FormularyScore.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the patient.
     * @param id The identifier.
     * @return The wanted patient.
     */
    getPatient(id: number): Observable<PatientInfo | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Patient/GetPatient/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPatient(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPatient(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PatientInfo | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PatientInfo | null>;
        }));
    }

    protected processGetPatient(response: HttpResponseBase): Observable<PatientInfo | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PatientInfo.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the patient allergies.
     * @param patientId The patient identifier.
     * @return The patient allergies
     */
    getPatientAllergies(patientId: number): Observable<PatientAllergy[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Patient/GetPatientAllergies/?patientId={patientId}";
        if (patientId === undefined || patientId === null)
            throw new Error("The parameter 'patientId' must be defined.");
        url_ = url_.replace("{patientId}", encodeURIComponent("" + patientId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPatientAllergies(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPatientAllergies(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PatientAllergy[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PatientAllergy[] | null>;
        }));
    }

    protected processGetPatientAllergies(response: HttpResponseBase): Observable<PatientAllergy[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PatientAllergy.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the patient coachings for my.
     * @return the patient coaching details.
     */
    getPatientCoachingsForMy(): Observable<PatientCoaching[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Patient/GetPatientCoachingsForMy";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPatientCoachingsForMy(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPatientCoachingsForMy(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PatientCoaching[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PatientCoaching[] | null>;
        }));
    }

    protected processGetPatientCoachingsForMy(response: HttpResponseBase): Observable<PatientCoaching[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PatientCoaching.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the patient measure type doctor.
     * @param patientId The patient identifier.
     * @return the ids of PatientMeasureTypeDoctor
     */
    getPatientMeasureTypeDoctor(patientId: number): Observable<number[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Patient/GetPatientMeasureTypeDoctor/?patientId={patientId}";
        if (patientId === undefined || patientId === null)
            throw new Error("The parameter 'patientId' must be defined.");
        url_ = url_.replace("{patientId}", encodeURIComponent("" + patientId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPatientMeasureTypeDoctor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPatientMeasureTypeDoctor(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number[] | null>;
        }));
    }

    protected processGetPatientMeasureTypeDoctor(response: HttpResponseBase): Observable<number[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the sleep diary patient answer.
     * @param consultationId The patient identifier.
     * @param questionId The question identifier.
     * @return The patient sleepDiary answer based on question id and patient id.
     */
    getSleepDiaryPatientAnswer(consultationId: number, questionId: number): Observable<PatientAnswerSleepDiary | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Patient/GetSleepDiaryPatientAnswer/?consultationId={consultationId}&questionId={questionId}";
        if (consultationId === undefined || consultationId === null)
            throw new Error("The parameter 'consultationId' must be defined.");
        url_ = url_.replace("{consultationId}", encodeURIComponent("" + consultationId));
        if (questionId === undefined || questionId === null)
            throw new Error("The parameter 'questionId' must be defined.");
        url_ = url_.replace("{questionId}", encodeURIComponent("" + questionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSleepDiaryPatientAnswer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSleepDiaryPatientAnswer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PatientAnswerSleepDiary | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PatientAnswerSleepDiary | null>;
        }));
    }

    protected processGetSleepDiaryPatientAnswer(response: HttpResponseBase): Observable<PatientAnswerSleepDiary | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PatientAnswerSleepDiary.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the patient insurance status.
     * @param patientId The patient identifier.
     * @return The patient insurance status.
     */
    getPatientInsuranceStatus(patientId: number): Observable<PatientInsuranceStatus | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Patient/GetPatientInsuranceStatus/?patientId={patientId}";
        if (patientId === undefined || patientId === null)
            throw new Error("The parameter 'patientId' must be defined.");
        url_ = url_.replace("{patientId}", encodeURIComponent("" + patientId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPatientInsuranceStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPatientInsuranceStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PatientInsuranceStatus | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PatientInsuranceStatus | null>;
        }));
    }

    protected processGetPatientInsuranceStatus(response: HttpResponseBase): Observable<PatientInsuranceStatus | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PatientInsuranceStatus.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the patient key points.
     * @param patientId The patient identifier.
     * @return The patient key points emmited by this doctor.
     */
    getPatientKeyPoints(patientId: number): Observable<string | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Patient/GetPatientKeyPoints/?patientId={patientId}";
        if (patientId === undefined || patientId === null)
            throw new Error("The parameter 'patientId' must be defined.");
        url_ = url_.replace("{patientId}", encodeURIComponent("" + patientId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPatientKeyPoints(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPatientKeyPoints(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string | null>;
        }));
    }

    protected processGetPatientKeyPoints(response: HttpResponseBase): Observable<string | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the medical record.
     * @param patientId The patient identifier.
     * @return The medical record
     */
    getMedicalRecord(patientId: number): Observable<MedicalRecord | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Patient/GetMedicalRecord/?patientId={patientId}";
        if (patientId === undefined || patientId === null)
            throw new Error("The parameter 'patientId' must be defined.");
        url_ = url_.replace("{patientId}", encodeURIComponent("" + patientId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMedicalRecord(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMedicalRecord(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MedicalRecord | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MedicalRecord | null>;
        }));
    }

    protected processGetMedicalRecord(response: HttpResponseBase): Observable<MedicalRecord | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? MedicalRecord.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the patient profile picture url.
     * @param patientId The patient identifier.
     * @return The medical record
     */
    getPatientProfilePictureUrl(patientId: number): Observable<string | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Patient/GetPatientProfilePictureUrl/?patientId={patientId}";
        if (patientId === undefined || patientId === null)
            throw new Error("The parameter 'patientId' must be defined.");
        url_ = url_.replace("{patientId}", encodeURIComponent("" + patientId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPatientProfilePictureUrl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPatientProfilePictureUrl(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string | null>;
        }));
    }

    protected processGetPatientProfilePictureUrl(response: HttpResponseBase): Observable<string | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the formulary patient answers.
     * @param formularyId The formulary identifier.
     * @param consultationId The patient identifier.
     * @return The patient answers to the requested formulary
     */
    getPatientFormularyAnswers(formularyId: number, consultationId: number): Observable<PatientAnswer[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Patient/GetPatientFormularyAnswers/?formularyId={formularyId}&consultationId={consultationId}";
        if (formularyId === undefined || formularyId === null)
            throw new Error("The parameter 'formularyId' must be defined.");
        url_ = url_.replace("{formularyId}", encodeURIComponent("" + formularyId));
        if (consultationId === undefined || consultationId === null)
            throw new Error("The parameter 'consultationId' must be defined.");
        url_ = url_.replace("{consultationId}", encodeURIComponent("" + consultationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPatientFormularyAnswers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPatientFormularyAnswers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PatientAnswer[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PatientAnswer[] | null>;
        }));
    }

    protected processGetPatientFormularyAnswers(response: HttpResponseBase): Observable<PatientAnswer[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PatientAnswer.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the patient signalitics.
     * @param id The identifier.
     * @return The patient signalitics.
     */
    getPatientSignalitics(id: number): Observable<PatientSignalitics | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Patient/GetPatientSignalitics/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPatientSignalitics(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPatientSignalitics(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PatientSignalitics | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PatientSignalitics | null>;
        }));
    }

    protected processGetPatientSignalitics(response: HttpResponseBase): Observable<PatientSignalitics | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PatientSignalitics.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the patients.
     * @param searchParams The search parameters.
     * @return All patients.
     */
    getPatients(searchParams: PatientSearchParams | null): Observable<PatientLiteInfo[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Patient/GetPatients";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchParams);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPatients(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPatients(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PatientLiteInfo[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PatientLiteInfo[] | null>;
        }));
    }

    protected processGetPatients(response: HttpResponseBase): Observable<PatientLiteInfo[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PatientLiteInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the patient formularies.
     * @param searchParams The search parameters.
     * @return The patient formularies
     */
    getPatientFormularies(searchParams: PatientFormularySearchParams | null): Observable<PaginatorWrapperOfIEnumerableOfPatientFormulary | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Patient/GetPatientFormularies";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchParams);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPatientFormularies(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPatientFormularies(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaginatorWrapperOfIEnumerableOfPatientFormulary | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaginatorWrapperOfIEnumerableOfPatientFormulary | null>;
        }));
    }

    protected processGetPatientFormularies(response: HttpResponseBase): Observable<PaginatorWrapperOfIEnumerableOfPatientFormulary | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PaginatorWrapperOfIEnumerableOfPatientFormulary.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets score history of a patient for the specified question.
     * @param questionId The question identifier.
     * @param patientId The patient identifier.
     * @return The question scores sorted by date
     */
    getQuestionScoreHistory(questionId: number, patientId: number): Observable<QuestionScore[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Patient/GetQuestionScoreHistory/?questionId={questionId}&patientId={patientId}";
        if (questionId === undefined || questionId === null)
            throw new Error("The parameter 'questionId' must be defined.");
        url_ = url_.replace("{questionId}", encodeURIComponent("" + questionId));
        if (patientId === undefined || patientId === null)
            throw new Error("The parameter 'patientId' must be defined.");
        url_ = url_.replace("{patientId}", encodeURIComponent("" + patientId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetQuestionScoreHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetQuestionScoreHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QuestionScore[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QuestionScore[] | null>;
        }));
    }

    protected processGetQuestionScoreHistory(response: HttpResponseBase): Observable<QuestionScore[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(QuestionScore.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Patients the has phone number.
     * @return true if current patient has registered number.
     */
    patientHasPhoneNumber(): Observable<boolean> {
        let url_ = this.baseUrl + "/umbraco/Api/Patient/PatientHasPhoneNumber";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPatientHasPhoneNumber(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPatientHasPhoneNumber(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processPatientHasPhoneNumber(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Determines whether [is current patient blocked by doctor] [the specified doctor identifier].
     * @param doctorId The doctor identifier.
     * @return true if [is current patient blocked by doctor] [the specified doctor identifier]; otherwise, false.
     */
    isCurrentPatientBlockedByDoctor(doctorId: number): Observable<boolean> {
        let url_ = this.baseUrl + "/umbraco/Api/Patient/IsCurrentPatientBlockedByDoctor/?doctorId={doctorId}";
        if (doctorId === undefined || doctorId === null)
            throw new Error("The parameter 'doctorId' must be defined.");
        url_ = url_.replace("{doctorId}", encodeURIComponent("" + doctorId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsCurrentPatientBlockedByDoctor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsCurrentPatientBlockedByDoctor(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processIsCurrentPatientBlockedByDoctor(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Determines whether [is patient blocked by doctor] [the specified doctor identifier].
     * @param patientId The doctor identifier.
     * @return true if [is patient blocked by doctor] [the specified doctor identifier]; otherwise, false.
     */
    isPatientBlockedByDoctor(patientId: number): Observable<boolean> {
        let url_ = this.baseUrl + "/umbraco/Api/Patient/IsPatientBlockedByDoctor/?patientId={patientId}";
        if (patientId === undefined || patientId === null)
            throw new Error("The parameter 'patientId' must be defined.");
        url_ = url_.replace("{patientId}", encodeURIComponent("" + patientId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsPatientBlockedByDoctor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsPatientBlockedByDoctor(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processIsPatientBlockedByDoctor(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Determines whether [is patient archived by doctor] [the specified doctor identifier].
     * @param patientId The doctor identifier.
     * @return true if [is patient archived by doctor] [the specified doctor identifier]; otherwise, false.
     */
    isPatientArchivedByDoctor(patientId: number): Observable<boolean> {
        let url_ = this.baseUrl + "/umbraco/Api/Patient/IsPatientArchivedByDoctor/?patientId={patientId}";
        if (patientId === undefined || patientId === null)
            throw new Error("The parameter 'patientId' must be defined.");
        url_ = url_.replace("{patientId}", encodeURIComponent("" + patientId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsPatientArchivedByDoctor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsPatientArchivedByDoctor(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processIsPatientArchivedByDoctor(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the patients by quick search.
     * @param searchParameter The search parameter, either a name or a date.
     * @param withEmailOnly Whether the patients selected must have an email or not.
     * @return The patients corresponding to the search parameters
     */
    quickSearchPatients(searchParameter: string, withEmailOnly: boolean): Observable<PatientLiteInfo[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Patient/QuickSearchPatients/?searchParameter={searchParameter}&withEmailOnly={withEmailOnly}";
        if (searchParameter === undefined || searchParameter === null)
            throw new Error("The parameter 'searchParameter' must be defined.");
        url_ = url_.replace("{searchParameter}", encodeURIComponent("" + searchParameter));
        if (withEmailOnly === undefined || withEmailOnly === null)
            throw new Error("The parameter 'withEmailOnly' must be defined.");
        url_ = url_.replace("{withEmailOnly}", encodeURIComponent("" + withEmailOnly));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processQuickSearchPatients(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processQuickSearchPatients(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PatientLiteInfo[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PatientLiteInfo[] | null>;
        }));
    }

    protected processQuickSearchPatients(response: HttpResponseBase): Observable<PatientLiteInfo[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PatientLiteInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Marks the activity as read.
     * @param coachingActivityId The coaching activity identifier.
     * @param patientId The patient identifier.
     */
    markActivityAsRead(coachingActivityId: number, patientId: number): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/Patient/MarkActivityAsRead/?coachingActivityId={coachingActivityId}&patientId={patientId}";
        if (coachingActivityId === undefined || coachingActivityId === null)
            throw new Error("The parameter 'coachingActivityId' must be defined.");
        url_ = url_.replace("{coachingActivityId}", encodeURIComponent("" + coachingActivityId));
        if (patientId === undefined || patientId === null)
            throw new Error("The parameter 'patientId' must be defined.");
        url_ = url_.replace("{patientId}", encodeURIComponent("" + patientId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMarkActivityAsRead(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarkActivityAsRead(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processMarkActivityAsRead(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Marks the formulary as open.
     * @param consultationId The consultation identifier.
     * @param formularyVersionId The formulary version identifier.
     */
    markFormularyAsOpen(consultationId: number, formularyVersionId: number): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/Patient/MarkFormularyAsOpen/?consultationId={consultationId}&formularyVersionId={formularyVersionId}";
        if (consultationId === undefined || consultationId === null)
            throw new Error("The parameter 'consultationId' must be defined.");
        url_ = url_.replace("{consultationId}", encodeURIComponent("" + consultationId));
        if (formularyVersionId === undefined || formularyVersionId === null)
            throw new Error("The parameter 'formularyVersionId' must be defined.");
        url_ = url_.replace("{formularyVersionId}", encodeURIComponent("" + formularyVersionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMarkFormularyAsOpen(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarkFormularyAsOpen(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processMarkFormularyAsOpen(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Marks the formulary as complete.
     * @param consultationId The consultation identifier.
     * @param formularyVersionId The formulary version identifier.
     */
    markFormularyAsComplete(consultationId: number, formularyVersionId: number): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/Patient/MarkFormularyAsComplete/?consultationId={consultationId}&formularyVersionId={formularyVersionId}";
        if (consultationId === undefined || consultationId === null)
            throw new Error("The parameter 'consultationId' must be defined.");
        url_ = url_.replace("{consultationId}", encodeURIComponent("" + consultationId));
        if (formularyVersionId === undefined || formularyVersionId === null)
            throw new Error("The parameter 'formularyVersionId' must be defined.");
        url_ = url_.replace("{formularyVersionId}", encodeURIComponent("" + formularyVersionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMarkFormularyAsComplete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarkFormularyAsComplete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processMarkFormularyAsComplete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Sets the doctor patient blocking.
     * @param patientId The patient identifier.
     * @param value if set to true [value].
     */
    setDoctorPatientBlocking(patientId: number, value: boolean): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/Patient/SetDoctorPatientBlocking/?patientId={patientId}&value={value}";
        if (patientId === undefined || patientId === null)
            throw new Error("The parameter 'patientId' must be defined.");
        url_ = url_.replace("{patientId}", encodeURIComponent("" + patientId));
        if (value === undefined || value === null)
            throw new Error("The parameter 'value' must be defined.");
        url_ = url_.replace("{value}", encodeURIComponent("" + value));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetDoctorPatientBlocking(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetDoctorPatientBlocking(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetDoctorPatientBlocking(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Sets the doctor patient is archived.
     * @param patientId The patient identifier.
     * @param isArchived if set to true [value].
     */
    updateDoctorPatientIsArchived(patientId: number, isArchived: boolean): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/Patient/UpdateDoctorPatientIsArchived/?patientId={patientId}&isArchived={isArchived}";
        if (patientId === undefined || patientId === null)
            throw new Error("The parameter 'patientId' must be defined.");
        url_ = url_.replace("{patientId}", encodeURIComponent("" + patientId));
        if (isArchived === undefined || isArchived === null)
            throw new Error("The parameter 'isArchived' must be defined.");
        url_ = url_.replace("{isArchived}", encodeURIComponent("" + isArchived));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateDoctorPatientIsArchived(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateDoctorPatientIsArchived(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateDoctorPatientIsArchived(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Triggers the suggestible for confirmed consultations after updating health profile.
     * @param patientId The patient identifier.
     */
    triggerSuggestibleForConfirmedConsultationsAfterUpdatingHealthProfile(patientId: number): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/Patient/TriggerSuggestibleForConfirmedConsultationsAfterUpdatingHealthProfile/?patientId={patientId}";
        if (patientId === undefined || patientId === null)
            throw new Error("The parameter 'patientId' must be defined.");
        url_ = url_.replace("{patientId}", encodeURIComponent("" + patientId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTriggerSuggestibleForConfirmedConsultationsAfterUpdatingHealthProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTriggerSuggestibleForConfirmedConsultationsAfterUpdatingHealthProfile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processTriggerSuggestibleForConfirmedConsultationsAfterUpdatingHealthProfile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates the allergy.
     * @param allergy The allergy.
     */
    updateSiinAllergy(allergy: SiinAllergy | null): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/Patient/UpdateSiinAllergy";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(allergy);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateSiinAllergy(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateSiinAllergy(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateSiinAllergy(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates the current patient medical histories.
     * @param patientMedicalHistories The patient medical histories.
     */
    updateCurrentPatientMedicalHistories(patientMedicalHistories: PatientMedicalHistory[] | null): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/Patient/UpdateCurrentPatientMedicalHistories";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(patientMedicalHistories);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCurrentPatientMedicalHistories(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCurrentPatientMedicalHistories(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateCurrentPatientMedicalHistories(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates the current patient parameters.
     * @param parameters The parameters.
     */
    updateCurrentPatientParameters(parameters: PatientParameters | null): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/Patient/UpdateCurrentPatientParameters";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(parameters);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCurrentPatientParameters(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCurrentPatientParameters(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateCurrentPatientParameters(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Accepts the current patient GDPR.
     */
    acceptCurrentPatientGDPR(): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/Patient/AcceptCurrentPatientGDPR";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAcceptCurrentPatientGDPR(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAcceptCurrentPatientGDPR(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAcceptCurrentPatientGDPR(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates the current patient signalitics.
     * @param signalitics The signalitics.
     * @return The response status.
     */
    updateCurrentPatientProfile(signalitics: PatientSignalitics | null): Observable<ResponseStatus> {
        let url_ = this.baseUrl + "/umbraco/Api/Patient/UpdateCurrentPatientProfile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(signalitics);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCurrentPatientProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCurrentPatientProfile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseStatus>;
        }));
    }

    protected processUpdateCurrentPatientProfile(response: HttpResponseBase): Observable<ResponseStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates the patient measure type doctor.
     * @param updatePatientMeasureTypeDoctor The patient measure type doctors.
     */
    updatePatientMeasureTypeDoctor(updatePatientMeasureTypeDoctor: UpdatePatientMeasureTypeDoctor | null): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/Patient/UpdatePatientMeasureTypeDoctor";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updatePatientMeasureTypeDoctor);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePatientMeasureTypeDoctor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePatientMeasureTypeDoctor(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdatePatientMeasureTypeDoctor(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the patients medical history.
     * @param patientId The patient identifier.
     * @return The medical histories linked to the specified patient
     */
    getPatientMedicalHistories(patientId: number): Observable<PatientMedicalHistory[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Patient/GetPatientMedicalHistories/?patientId={patientId}";
        if (patientId === undefined || patientId === null)
            throw new Error("The parameter 'patientId' must be defined.");
        url_ = url_.replace("{patientId}", encodeURIComponent("" + patientId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPatientMedicalHistories(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPatientMedicalHistories(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PatientMedicalHistory[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PatientMedicalHistory[] | null>;
        }));
    }

    protected processGetPatientMedicalHistories(response: HttpResponseBase): Observable<PatientMedicalHistory[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PatientMedicalHistory.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates the patient answers.
     * @param patientAnswers The patient answers.
     * @return A Task representing the asynchronous operation.
     */
    updatePatientAnswers(patientAnswers: PatientAnswer[] | null): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/Patient/UpdatePatientAnswers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(patientAnswers);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePatientAnswers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePatientAnswers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdatePatientAnswers(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates the current patient date seeing documents.
     * @param currentPatientDateSeeingDocumentsParams The patient id.
     */
    updateCurrentPatientDateSeeingDocuments(currentPatientDateSeeingDocumentsParams: CurrentPatientDateSeeingDocumentsParams | null): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/Patient/UpdateCurrentPatientDateSeeingDocuments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(currentPatientDateSeeingDocumentsParams);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCurrentPatientDateSeeingDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCurrentPatientDateSeeingDocuments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateCurrentPatientDateSeeingDocuments(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates the medical record.
     * @param medicalRecord The medical record.
     * @return The task
     */
    updateMedicalRecord(medicalRecord: MedicalRecord | null): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/Patient/UpdateMedicalRecord";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(medicalRecord);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateMedicalRecord(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateMedicalRecord(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateMedicalRecord(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates the patient allergies.
     * @param patientId The patient identifier.
     * @param patientAllergies The patient allergies.
     */
    updatePatientAllergies(patientId: number, patientAllergies: PatientAllergy[] | null): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/Patient/UpdatePatientAllergies/?patientId={patientId}";
        if (patientId === undefined || patientId === null)
            throw new Error("The parameter 'patientId' must be defined.");
        url_ = url_.replace("{patientId}", encodeURIComponent("" + patientId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(patientAllergies);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePatientAllergies(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePatientAllergies(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdatePatientAllergies(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates the patient measure.
     * @param updatePatientMeasure The update patient measure.
     */
    updatePatientMeasure(updatePatientMeasure: UpdatePatientMeasure | null): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/Patient/UpdatePatientMeasure";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updatePatientMeasure);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePatientMeasure(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePatientMeasure(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdatePatientMeasure(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates the patient measure.
     * @param updatePatientMeasure The update patient measure.
     */
    updateCurrentPatientMeasure(updatePatientMeasure: UpdatePatientMeasure | null): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/Patient/UpdateCurrentPatientMeasure";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updatePatientMeasure);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCurrentPatientMeasure(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCurrentPatientMeasure(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateCurrentPatientMeasure(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates the patient key points.
     * @param patientKeyPoints The patient key points.
     */
    updatePatientKeyPoints(patientKeyPoints: PatientKeyPoints | null): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/Patient/UpdatePatientKeyPoints";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(patientKeyPoints);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePatientKeyPoints(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePatientKeyPoints(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdatePatientKeyPoints(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates the patient medical histories.
     * @param patientMedicalHistories The patient medical histories.
     * @param patientId The patient identifier
     */
    updatePatientMedicalHistories(patientMedicalHistories: PatientMedicalHistory[] | null, patientId: number): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/Patient/UpdatePatientMedicalHistories/?patientId={patientId}";
        if (patientId === undefined || patientId === null)
            throw new Error("The parameter 'patientId' must be defined.");
        url_ = url_.replace("{patientId}", encodeURIComponent("" + patientId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(patientMedicalHistories);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePatientMedicalHistories(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePatientMedicalHistories(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdatePatientMedicalHistories(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates the patient signalitics.
     * @param signalitics The signalitics.
     */
    updatePatientSignalitics(signalitics: PatientSignalitics | null): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/Patient/UpdatePatientSignalitics";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(signalitics);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePatientSignalitics(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePatientSignalitics(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdatePatientSignalitics(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates the patient signalitics.
     * @param signalitics The signalitics.
     */
    updatePatientRelativeSignalitics(signalitics: PatientSignalitics | null): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/Patient/UpdatePatientRelativeSignalitics";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(signalitics);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePatientRelativeSignalitics(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePatientRelativeSignalitics(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdatePatientRelativeSignalitics(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the patient recommendation activities
     * @param searchParams The search param (patientId).
     * @return the list of PatientRecommendation object (title, (sending) date, id)
     */
    getPatientRecommendationActivities(searchParams: SearchParamsRecommendation | null): Observable<PatientRecommendation[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Patient/GetPatientRecommendationActivities";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchParams);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPatientRecommendationActivities(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPatientRecommendationActivities(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PatientRecommendation[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PatientRecommendation[] | null>;
        }));
    }

    protected processGetPatientRecommendationActivities(response: HttpResponseBase): Observable<PatientRecommendation[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PatientRecommendation.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the patient recommendation suggestionLifeStyle
     * @param searchParams The search param (patientId).
     * @return the list of PatientRecommendation object (title, (sending) date, id)
     */
    getPatientRecommendationSuggestion(searchParams: SearchParamsRecommendationSuggestion | null): Observable<PatientRecommendation[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Patient/GetPatientRecommendationSuggestion";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchParams);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPatientRecommendationSuggestion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPatientRecommendationSuggestion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PatientRecommendation[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PatientRecommendation[] | null>;
        }));
    }

    protected processGetPatientRecommendationSuggestion(response: HttpResponseBase): Observable<PatientRecommendation[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PatientRecommendation.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the patient recommendation Coachings
     * @param searchParams The search param (patientId).
     * @return the list of PatientRecommendation object (title, (sending) date, id)
     */
    getPatientRecommendationCoachings(searchParams: SearchParamsRecommendation | null): Observable<PatientRecommendation[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Patient/GetPatientRecommendationCoachings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchParams);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPatientRecommendationCoachings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPatientRecommendationCoachings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PatientRecommendation[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PatientRecommendation[] | null>;
        }));
    }

    protected processGetPatientRecommendationCoachings(response: HttpResponseBase): Observable<PatientRecommendation[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PatientRecommendation.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the patient prescriptions
     * @param searchParams The search parameter.
     * @return The list of the patient consultation prescriptions.
     */
    getPatientPrescription(searchParams: PatientPrescriptionSearchParams | null): Observable<ConsultationDocumentTemplateLite[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Patient/GetPatientPrescription";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchParams);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPatientPrescription(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPatientPrescription(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConsultationDocumentTemplateLite[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConsultationDocumentTemplateLite[] | null>;
        }));
    }

    protected processGetPatientPrescription(response: HttpResponseBase): Observable<ConsultationDocumentTemplateLite[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ConsultationDocumentTemplateLite.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Unlocks the patient account.
     * @param patientId The patient identifier..
     */
    unlockPatientAccount(patientId: number): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/Patient/UnlockPatientAccount/?patientId={patientId}";
        if (patientId === undefined || patientId === null)
            throw new Error("The parameter 'patientId' must be defined.");
        url_ = url_.replace("{patientId}", encodeURIComponent("" + patientId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnlockPatientAccount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnlockPatientAccount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUnlockPatientAccount(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the patient relatives.
     * @param includeCurrentPatient Whether the current patient should be included in the list.
     * @return The patient relatives.
     */
    getCurrentPatientRelatives(includeCurrentPatient: boolean): Observable<PatientLiteInfo[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Patient/GetCurrentPatientRelatives/?includeCurrentPatient={includeCurrentPatient}";
        if (includeCurrentPatient === undefined || includeCurrentPatient === null)
            throw new Error("The parameter 'includeCurrentPatient' must be defined.");
        url_ = url_.replace("{includeCurrentPatient}", encodeURIComponent("" + includeCurrentPatient));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentPatientRelatives(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentPatientRelatives(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PatientLiteInfo[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PatientLiteInfo[] | null>;
        }));
    }

    protected processGetCurrentPatientRelatives(response: HttpResponseBase): Observable<PatientLiteInfo[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PatientLiteInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ConsultationRepository {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Gets the consultation patient nutritional supplement.
     * @param consultationId The identifier.
     * @return the nutritionalSupplement for a consultation.
     */
    getConsultationPatientNutritionalSupplement(consultationId: number): Observable<ConsultationNutritionalSupplement[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Consultation/GetConsultationPatientNutritionalSupplement/?consultationId={consultationId}";
        if (consultationId === undefined || consultationId === null)
            throw new Error("The parameter 'consultationId' must be defined.");
        url_ = url_.replace("{consultationId}", encodeURIComponent("" + consultationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConsultationPatientNutritionalSupplement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConsultationPatientNutritionalSupplement(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConsultationNutritionalSupplement[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConsultationNutritionalSupplement[] | null>;
        }));
    }

    protected processGetConsultationPatientNutritionalSupplement(response: HttpResponseBase): Observable<ConsultationNutritionalSupplement[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ConsultationNutritionalSupplement.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the consultation type.
     * @param id The identifier.
     * @return The requested consultation type
     */
    getConsultationType(id: number): Observable<ConsultationType | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Consultation/GetConsultationType/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConsultationType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConsultationType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConsultationType | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConsultationType | null>;
        }));
    }

    protected processGetConsultationType(response: HttpResponseBase): Observable<ConsultationType | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ConsultationType.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the consultation subtype.
     * @param id The identifier.
     * @return The requested consultation subtype
     */
    getConsultationSubType(id: number): Observable<ConsultationSubType | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Consultation/GetConsultationSubType/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConsultationSubType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConsultationSubType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConsultationSubType | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConsultationSubType | null>;
        }));
    }

    protected processGetConsultationSubType(response: HttpResponseBase): Observable<ConsultationSubType | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ConsultationSubType.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the consultation subtypes available for consultation config creation.
     * @param consultationConfigId The consultation config identifier.
     * @return The available consultation subtypes.
     */
    getAvailableSubTypesToAdd(consultationConfigId: number): Observable<ConsultationSubType[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Consultation/GetAvailableSubTypesToAdd/?consultationConfigId={consultationConfigId}";
        if (consultationConfigId === undefined || consultationConfigId === null)
            throw new Error("The parameter 'consultationConfigId' must be defined.");
        url_ = url_.replace("{consultationConfigId}", encodeURIComponent("" + consultationConfigId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAvailableSubTypesToAdd(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAvailableSubTypesToAdd(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConsultationSubType[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConsultationSubType[] | null>;
        }));
    }

    protected processGetAvailableSubTypesToAdd(response: HttpResponseBase): Observable<ConsultationSubType[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ConsultationSubType.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the consultation types.
     * @param includeArchive if set to true [include archive].
     * @return the consultation type.
     */
    getConsultationTypes(includeArchive: boolean): Observable<ConsultationType[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Consultation/GetConsultationTypes/?includeArchive={includeArchive}";
        if (includeArchive === undefined || includeArchive === null)
            throw new Error("The parameter 'includeArchive' must be defined.");
        url_ = url_.replace("{includeArchive}", encodeURIComponent("" + includeArchive));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConsultationTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConsultationTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConsultationType[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConsultationType[] | null>;
        }));
    }

    protected processGetConsultationTypes(response: HttpResponseBase): Observable<ConsultationType[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ConsultationType.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the consultation subtypes.
     * @param includeArchive if set to true [include archive].
     * @return the consultation subtype.
     */
    getConsultationSubTypes(includeArchive: boolean): Observable<ConsultationSubType[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Consultation/GetConsultationSubTypes/?includeArchive={includeArchive}";
        if (includeArchive === undefined || includeArchive === null)
            throw new Error("The parameter 'includeArchive' must be defined.");
        url_ = url_.replace("{includeArchive}", encodeURIComponent("" + includeArchive));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConsultationSubTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConsultationSubTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConsultationSubType[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConsultationSubType[] | null>;
        }));
    }

    protected processGetConsultationSubTypes(response: HttpResponseBase): Observable<ConsultationSubType[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ConsultationSubType.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the consultation types for doctors.
     * @param doctorId The doctor identifier.
     * @return A list of consultation types.
     */
    getConsultationTypesForDoctor(doctorId: number): Observable<DropdownValue[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Consultation/GetConsultationTypesForDoctor/?doctorId={doctorId}";
        if (doctorId === undefined || doctorId === null)
            throw new Error("The parameter 'doctorId' must be defined.");
        url_ = url_.replace("{doctorId}", encodeURIComponent("" + doctorId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConsultationTypesForDoctor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConsultationTypesForDoctor(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DropdownValue[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DropdownValue[] | null>;
        }));
    }

    protected processGetConsultationTypesForDoctor(response: HttpResponseBase): Observable<DropdownValue[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DropdownValue.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the consultation types for a doctor.
     * @return All the consultation types.
     */
    getAllForClassicPatient(): Observable<ConsultationType[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Consultation/GetAllForClassicPatient";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllForClassicPatient(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllForClassicPatient(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConsultationType[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConsultationType[] | null>;
        }));
    }

    protected processGetAllForClassicPatient(response: HttpResponseBase): Observable<ConsultationType[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ConsultationType.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Searches the patient consultations.
     * @param parameters The parameters.
     * @return The consultations.
     */
    getCurrentPatientConsultations(parameters: PatientConsultationSearchParams | null): Observable<Consultation[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Consultation/GetCurrentPatientConsultations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(parameters);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentPatientConsultations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentPatientConsultations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Consultation[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Consultation[] | null>;
        }));
    }

    protected processGetCurrentPatientConsultations(response: HttpResponseBase): Observable<Consultation[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Consultation.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets all consultations types for the current patient.
     * @return The consultations types
     */
    getCurrentPatientConsultationsTypes(): Observable<ConsultationTypeFilter[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Consultation/GetCurrentPatientConsultationsTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentPatientConsultationsTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentPatientConsultationsTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConsultationTypeFilter[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConsultationTypeFilter[] | null>;
        }));
    }

    protected processGetCurrentPatientConsultationsTypes(response: HttpResponseBase): Observable<ConsultationTypeFilter[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ConsultationTypeFilter.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the default consultation reason for insurance.
     * @return The default consultation reason for insurance
     */
    getDefaultConsultationReasonForInsurance(): Observable<ConsultationReason | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Consultation/GetDefaultConsultationReasonForInsurance";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDefaultConsultationReasonForInsurance(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDefaultConsultationReasonForInsurance(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConsultationReason | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConsultationReason | null>;
        }));
    }

    protected processGetDefaultConsultationReasonForInsurance(response: HttpResponseBase): Observable<ConsultationReason | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ConsultationReason.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the default consultation type for insurance.
     * @return The default consultation type for insurance
     */
    getDefaultConsultationTypeForInsurance(): Observable<ConsultationType | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Consultation/GetDefaultConsultationTypeForInsurance";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDefaultConsultationTypeForInsurance(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDefaultConsultationTypeForInsurance(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConsultationType | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConsultationType | null>;
        }));
    }

    protected processGetDefaultConsultationTypeForInsurance(response: HttpResponseBase): Observable<ConsultationType | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ConsultationType.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the doctor consultations.
     * @param startDate The start date.
     * @param endDate The end date (exclusive).
     * @return The doctor consultations for the date range
     */
    getDoctorConsultations(startDate: Date, endDate: Date): Observable<Consultation[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Consultation/GetDoctorConsultations/?startDate={startDate}&endDate={endDate}";
        if (startDate === undefined || startDate === null)
            throw new Error("The parameter 'startDate' must be defined.");
        url_ = url_.replace("{startDate}", encodeURIComponent(startDate ? "" + startDate.toISOString() : "null"));
        if (endDate === undefined || endDate === null)
            throw new Error("The parameter 'endDate' must be defined.");
        url_ = url_.replace("{endDate}", encodeURIComponent(endDate ? "" + endDate.toISOString() : "null"));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDoctorConsultations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDoctorConsultations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Consultation[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Consultation[] | null>;
        }));
    }

    protected processGetDoctorConsultations(response: HttpResponseBase): Observable<Consultation[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Consultation.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the first next avalaible consultation date.
     * @param doctorId (optional) The doctor identifier.
     * @param dayDate (optional) The day date.
     * @param consultationConfigId (optional) The consultation config identifier.
     * @param medicalOfficeId (optional) The medical office identifier. If == 0, then any type of consultation : onsite or remote.
     * @return The first next available consultation date after the given date.
     */
    getFirstNextAvailableConsultationDate(doctorId?: number | null | undefined, dayDate?: Date | null | undefined, consultationConfigId?: number | null | undefined, medicalOfficeId?: number | null | undefined): Observable<Date | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Consultation/GetFirstNextAvailableConsultationDate?";
        if (doctorId !== undefined && doctorId !== null)
            url_ += "doctorId=" + encodeURIComponent("" + doctorId) + "&";
        if (dayDate !== undefined && dayDate !== null)
            url_ += "dayDate=" + encodeURIComponent(dayDate ? "" + dayDate.toISOString() : "") + "&";
        if (consultationConfigId !== undefined && consultationConfigId !== null)
            url_ += "consultationConfigId=" + encodeURIComponent("" + consultationConfigId) + "&";
        if (medicalOfficeId !== undefined && medicalOfficeId !== null)
            url_ += "medicalOfficeId=" + encodeURIComponent("" + medicalOfficeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFirstNextAvailableConsultationDate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFirstNextAvailableConsultationDate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Date | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Date | null>;
        }));
    }

    protected processGetFirstNextAvailableConsultationDate(response: HttpResponseBase): Observable<Date | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? new Date(resultData200.toString()) : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add commentMore actions
                Gets the first next avalaible consultation date.
     * @param doctorId (optional) The doctor identifier.
     * @param dayDate (optional) The day date.
     * @param consultationConfigId (optional) The consultation config identifier.
     * @return The first next available consultation date after the given date.
     */
    getFirstNextAvailableConsultationDatesOnsiteAndRemote(doctorId?: number | null | undefined, dayDate?: Date | null | undefined, consultationConfigId?: number | null | undefined): Observable<FirstAvailability | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Consultation/GetFirstNextAvailableConsultationDatesOnsiteAndRemote?";
        if (doctorId !== undefined && doctorId !== null)
            url_ += "doctorId=" + encodeURIComponent("" + doctorId) + "&";
        if (dayDate !== undefined && dayDate !== null)
            url_ += "dayDate=" + encodeURIComponent(dayDate ? "" + dayDate.toISOString() : "") + "&";
        if (consultationConfigId !== undefined && consultationConfigId !== null)
            url_ += "consultationConfigId=" + encodeURIComponent("" + consultationConfigId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFirstNextAvailableConsultationDatesOnsiteAndRemote(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFirstNextAvailableConsultationDatesOnsiteAndRemote(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FirstAvailability | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FirstAvailability | null>;
        }));
    }

    protected processGetFirstNextAvailableConsultationDatesOnsiteAndRemote(response: HttpResponseBase): Observable<FirstAvailability | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FirstAvailability.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the prescription PDF.
     * @param searchParamPrescription The search Param prescription.
     * @return the pdf for a template name
     */
    getPrescriptionPdf(searchParamPrescription: SearchParamPrescription | null): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Consultation/GetPrescriptionPdf";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchParamPrescription);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPrescriptionPdf(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPrescriptionPdf(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processGetPrescriptionPdf(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Generates the presciption blank.
     * @param searchParamPrescription searchParamPrescription.
     * @return the blank prescription.
     */
    generateOtherPresciption(searchParamPrescription: SearchParamPrescription | null): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Consultation/GenerateOtherPresciption";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchParamPrescription);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateOtherPresciption(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateOtherPresciption(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processGenerateOtherPresciption(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the required patient actions.
     * @param consultationId The consultation identifier.
     * @return The required actions
     */
    getRequiredPatientActions(consultationId: number): Observable<ConsultationRequiredPatientActions | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Consultation/GetRequiredPatientActions/?consultationId={consultationId}";
        if (consultationId === undefined || consultationId === null)
            throw new Error("The parameter 'consultationId' must be defined.");
        url_ = url_.replace("{consultationId}", encodeURIComponent("" + consultationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRequiredPatientActions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRequiredPatientActions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConsultationRequiredPatientActions | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConsultationRequiredPatientActions | null>;
        }));
    }

    protected processGetRequiredPatientActions(response: HttpResponseBase): Observable<ConsultationRequiredPatientActions | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ConsultationRequiredPatientActions.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the prescription model document templates.
     * @param consultationId The consultation identifier.
     * @return the ConsultationDocumentTemplates Lite for modelsDocuments.
     */
    getPrescriptionModelDocumentTemplates(consultationId: number): Observable<ConsultationDocumentTemplateLite[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Consultation/GetPrescriptionModelDocumentTemplates/?consultationId={consultationId}";
        if (consultationId === undefined || consultationId === null)
            throw new Error("The parameter 'consultationId' must be defined.");
        url_ = url_.replace("{consultationId}", encodeURIComponent("" + consultationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPrescriptionModelDocumentTemplates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPrescriptionModelDocumentTemplates(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConsultationDocumentTemplateLite[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConsultationDocumentTemplateLite[] | null>;
        }));
    }

    protected processGetPrescriptionModelDocumentTemplates(response: HttpResponseBase): Observable<ConsultationDocumentTemplateLite[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ConsultationDocumentTemplateLite.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the prescription model document templates.
     * @param id The identifier.
     * @return the consultationDOcumentTemplate
     */
    getPrescriptionModelDocumentTemplate(id: number): Observable<ConsultationDocumentTemplate | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Consultation/GetPrescriptionModelDocumentTemplate/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPrescriptionModelDocumentTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPrescriptionModelDocumentTemplate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConsultationDocumentTemplate | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConsultationDocumentTemplate | null>;
        }));
    }

    protected processGetPrescriptionModelDocumentTemplate(response: HttpResponseBase): Observable<ConsultationDocumentTemplate | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ConsultationDocumentTemplate.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the patient consultations.
     * @param patientId The patient identifier.
     * @return The patient consultations.
     */
    getPatientConsultations(patientId: number): Observable<Consultation[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Consultation/GetPatientConsultations/?patientId={patientId}";
        if (patientId === undefined || patientId === null)
            throw new Error("The parameter 'patientId' must be defined.");
        url_ = url_.replace("{patientId}", encodeURIComponent("" + patientId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPatientConsultations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPatientConsultations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Consultation[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Consultation[] | null>;
        }));
    }

    protected processGetPatientConsultations(response: HttpResponseBase): Observable<Consultation[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Consultation.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the doctor consultations.
     * @param searchParams The search parameters.
     * @return The doctor consultations.
     */
    getAllDoctorConsultations(searchParams: SearchParamConsultation | null): Observable<ConsultationPaginatorWrapper | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Consultation/GetAllDoctorConsultations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchParams);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllDoctorConsultations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllDoctorConsultations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConsultationPaginatorWrapper | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConsultationPaginatorWrapper | null>;
        }));
    }

    protected processGetAllDoctorConsultations(response: HttpResponseBase): Observable<ConsultationPaginatorWrapper | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ConsultationPaginatorWrapper.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the patient consultations.
     * @param patientId The patient identifier.
     * @return The patient consultations.
     */
    getPatientConsultationsLiteInfos(patientId: number): Observable<ConsultationLiteInfo[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Consultation/GetPatientConsultationsLiteInfos/?patientId={patientId}";
        if (patientId === undefined || patientId === null)
            throw new Error("The parameter 'patientId' must be defined.");
        url_ = url_.replace("{patientId}", encodeURIComponent("" + patientId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPatientConsultationsLiteInfos(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPatientConsultationsLiteInfos(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConsultationLiteInfo[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConsultationLiteInfo[] | null>;
        }));
    }

    protected processGetPatientConsultationsLiteInfos(response: HttpResponseBase): Observable<ConsultationLiteInfo[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ConsultationLiteInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the prescription document lite.
     * @param consultationId The consultation identifier.
     * @param type The type.
     * @return the prescription document lite info.
     */
    getPrescriptionDocumentLite(consultationId: number, type: ConsultationDocumentTemplateType): Observable<ConsultationDocumentTemplateLite | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Consultation/GetPrescriptionDocumentLite/?consultationId={consultationId}&type={type}";
        if (consultationId === undefined || consultationId === null)
            throw new Error("The parameter 'consultationId' must be defined.");
        url_ = url_.replace("{consultationId}", encodeURIComponent("" + consultationId));
        if (type === undefined || type === null)
            throw new Error("The parameter 'type' must be defined.");
        url_ = url_.replace("{type}", encodeURIComponent("" + type));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPrescriptionDocumentLite(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPrescriptionDocumentLite(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConsultationDocumentTemplateLite | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConsultationDocumentTemplateLite | null>;
        }));
    }

    protected processGetPrescriptionDocumentLite(response: HttpResponseBase): Observable<ConsultationDocumentTemplateLite | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ConsultationDocumentTemplateLite.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the prescription details nutritional supplement.
     * @param consultationId The consultation identifier.
     * @return the prescription detail.
     */
    getPrescriptionNutritionalSupplement(consultationId: number): Observable<ConsultationDocumentBaseModelOfIEnumerableOfConsultationNutritionalSupplement | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Consultation/GetPrescriptionNutritionalSupplement/?consultationId={consultationId}";
        if (consultationId === undefined || consultationId === null)
            throw new Error("The parameter 'consultationId' must be defined.");
        url_ = url_.replace("{consultationId}", encodeURIComponent("" + consultationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPrescriptionNutritionalSupplement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPrescriptionNutritionalSupplement(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConsultationDocumentBaseModelOfIEnumerableOfConsultationNutritionalSupplement | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConsultationDocumentBaseModelOfIEnumerableOfConsultationNutritionalSupplement | null>;
        }));
    }

    protected processGetPrescriptionNutritionalSupplement(response: HttpResponseBase): Observable<ConsultationDocumentBaseModelOfIEnumerableOfConsultationNutritionalSupplement | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ConsultationDocumentBaseModelOfIEnumerableOfConsultationNutritionalSupplement.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the prescription details Biological exam.
     * @param consultationId The consultation identifier.
     * @param setId The set identifier.
     * @param groupId The group identifier.
     * @return the prescription detail.
     */
    getPrescriptionBiologicalExam(consultationId: number, setId: number, groupId: number): Observable<ConsultationDocumentBaseModelOfIEnumerableOfConsultationBiologicalExamTitle | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Consultation/GetPrescriptionBiologicalExam/?consultationId={consultationId}&setId={setId}&groupId={groupId}";
        if (consultationId === undefined || consultationId === null)
            throw new Error("The parameter 'consultationId' must be defined.");
        url_ = url_.replace("{consultationId}", encodeURIComponent("" + consultationId));
        if (setId === undefined || setId === null)
            throw new Error("The parameter 'setId' must be defined.");
        url_ = url_.replace("{setId}", encodeURIComponent("" + setId));
        if (groupId === undefined || groupId === null)
            throw new Error("The parameter 'groupId' must be defined.");
        url_ = url_.replace("{groupId}", encodeURIComponent("" + groupId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPrescriptionBiologicalExam(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPrescriptionBiologicalExam(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConsultationDocumentBaseModelOfIEnumerableOfConsultationBiologicalExamTitle | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConsultationDocumentBaseModelOfIEnumerableOfConsultationBiologicalExamTitle | null>;
        }));
    }

    protected processGetPrescriptionBiologicalExam(response: HttpResponseBase): Observable<ConsultationDocumentBaseModelOfIEnumerableOfConsultationBiologicalExamTitle | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ConsultationDocumentBaseModelOfIEnumerableOfConsultationBiologicalExamTitle.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the prescription complementary exam.
     * @param consultationId The consult identifier.
     * @param consultationComplementaryId The consult exam identifier.
     * @return the prescription for a complementary exam.
     */
    getPrescriptionComplementaryExam(consultationId: number, consultationComplementaryId: number): Observable<ConsultationDocumentBaseModelOfConsultationComplementaryExamTitle | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Consultation/GetPrescriptionComplementaryExam/?consultationId={consultationId}&consultationComplementaryId={consultationComplementaryId}";
        if (consultationId === undefined || consultationId === null)
            throw new Error("The parameter 'consultationId' must be defined.");
        url_ = url_.replace("{consultationId}", encodeURIComponent("" + consultationId));
        if (consultationComplementaryId === undefined || consultationComplementaryId === null)
            throw new Error("The parameter 'consultationComplementaryId' must be defined.");
        url_ = url_.replace("{consultationComplementaryId}", encodeURIComponent("" + consultationComplementaryId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPrescriptionComplementaryExam(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPrescriptionComplementaryExam(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConsultationDocumentBaseModelOfConsultationComplementaryExamTitle | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConsultationDocumentBaseModelOfConsultationComplementaryExamTitle | null>;
        }));
    }

    protected processGetPrescriptionComplementaryExam(response: HttpResponseBase): Observable<ConsultationDocumentBaseModelOfConsultationComplementaryExamTitle | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ConsultationDocumentBaseModelOfConsultationComplementaryExamTitle.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the type of the prescription consultation.
     * @param consultationId The consultation identifier.
     * @param consultationConsultTypeId The consultation consult type identifier.
     * @return the prescription for consultationType
     */
    getPrescriptionConsultationType(consultationId: number, consultationConsultTypeId: number): Observable<ConsultationDocumentBaseModelOfConsultationConsultationTypeTitle | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Consultation/GetPrescriptionConsultationType/?consultationId={consultationId}&consultationConsultTypeId={consultationConsultTypeId}";
        if (consultationId === undefined || consultationId === null)
            throw new Error("The parameter 'consultationId' must be defined.");
        url_ = url_.replace("{consultationId}", encodeURIComponent("" + consultationId));
        if (consultationConsultTypeId === undefined || consultationConsultTypeId === null)
            throw new Error("The parameter 'consultationConsultTypeId' must be defined.");
        url_ = url_.replace("{consultationConsultTypeId}", encodeURIComponent("" + consultationConsultTypeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPrescriptionConsultationType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPrescriptionConsultationType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConsultationDocumentBaseModelOfConsultationConsultationTypeTitle | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConsultationDocumentBaseModelOfConsultationConsultationTypeTitle | null>;
        }));
    }

    protected processGetPrescriptionConsultationType(response: HttpResponseBase): Observable<ConsultationDocumentBaseModelOfConsultationConsultationTypeTitle | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ConsultationDocumentBaseModelOfConsultationConsultationTypeTitle.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the previous consultation summary.
     * @param doctorId The doctor identifier.
     * @param patientId The patient identifier.
     * @return The previous consultation summary.
     */
    getPreviousConsultationSummary(doctorId: number, patientId: number): Observable<string | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Consultation/GetPreviousConsultationSummary/?doctorId={doctorId}&patientId={patientId}";
        if (doctorId === undefined || doctorId === null)
            throw new Error("The parameter 'doctorId' must be defined.");
        url_ = url_.replace("{doctorId}", encodeURIComponent("" + doctorId));
        if (patientId === undefined || patientId === null)
            throw new Error("The parameter 'patientId' must be defined.");
        url_ = url_.replace("{patientId}", encodeURIComponent("" + patientId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPreviousConsultationSummary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPreviousConsultationSummary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string | null>;
        }));
    }

    protected processGetPreviousConsultationSummary(response: HttpResponseBase): Observable<string | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the sending box.
     * @param consultationId The consultation identifier.
     * @return the sending box for a consultation
     */
    getSendingBox(consultationId: number): Observable<SendingBox | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Consultation/GetSendingBox/?consultationId={consultationId}";
        if (consultationId === undefined || consultationId === null)
            throw new Error("The parameter 'consultationId' must be defined.");
        url_ = url_.replace("{consultationId}", encodeURIComponent("" + consultationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSendingBox(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSendingBox(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SendingBox | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SendingBox | null>;
        }));
    }

    protected processGetSendingBox(response: HttpResponseBase): Observable<SendingBox | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SendingBox.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the suggestions.
     * @param consultationId The consultation identifier.
     * @return The suggestions linked to the provided consultation
     */
    getSuggestions(consultationId: number): Observable<ConsultationSuggestion[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Consultation/GetSuggestions/?consultationId={consultationId}";
        if (consultationId === undefined || consultationId === null)
            throw new Error("The parameter 'consultationId' must be defined.");
        url_ = url_.replace("{consultationId}", encodeURIComponent("" + consultationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSuggestions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSuggestions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConsultationSuggestion[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConsultationSuggestion[] | null>;
        }));
    }

    protected processGetSuggestions(response: HttpResponseBase): Observable<ConsultationSuggestion[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ConsultationSuggestion.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the current patient suggestions.
     * @param searchParams The search parameters.
     * @return The suggestions of the patient from suggestible and coaching
     */
    getCurrentPatientSuggestions(searchParams: ConsultationSuggestionSearchParams | null): Observable<SuggestionMyNutri[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Consultation/GetCurrentPatientSuggestions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchParams);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentPatientSuggestions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentPatientSuggestions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SuggestionMyNutri[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SuggestionMyNutri[] | null>;
        }));
    }

    protected processGetCurrentPatientSuggestions(response: HttpResponseBase): Observable<SuggestionMyNutri[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SuggestionMyNutri.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the current patient suggestions by consultation identifier.
     * @param consultationId The consultation identifier.
     * @return The suggestions for the consultation
     */
    getCurrentPatientSuggestionsByConsultationId(consultationId: number): Observable<ConsultationSuggestionLite[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Consultation/GetCurrentPatientSuggestionsByConsultationId/?consultationId={consultationId}";
        if (consultationId === undefined || consultationId === null)
            throw new Error("The parameter 'consultationId' must be defined.");
        url_ = url_.replace("{consultationId}", encodeURIComponent("" + consultationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentPatientSuggestionsByConsultationId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentPatientSuggestionsByConsultationId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConsultationSuggestionLite[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConsultationSuggestionLite[] | null>;
        }));
    }

    protected processGetCurrentPatientSuggestionsByConsultationId(response: HttpResponseBase): Observable<ConsultationSuggestionLite[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ConsultationSuggestionLite.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Moves the consultationBiologicalExamId to biologicalExamSetId.
     * @param consultationId The consultation identifier.
     * @param consultationBiologicalExamId The consultation biological exam id.
     * @param biologicalExamSetId The biological exam set id.
     * @param biologicalExamGroupId The biological exam group id.
     * @return A task.
     */
    moveConsultationBiologicalExam(consultationId: number, consultationBiologicalExamId: number, biologicalExamSetId: number, biologicalExamGroupId: number): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/Consultation/MoveConsultationBiologicalExam/?consultationId={consultationId}&consultationBiologicalExamId={consultationBiologicalExamId}&biologicalExamSetId={biologicalExamSetId}&biologicalExamGroupId={biologicalExamGroupId}";
        if (consultationId === undefined || consultationId === null)
            throw new Error("The parameter 'consultationId' must be defined.");
        url_ = url_.replace("{consultationId}", encodeURIComponent("" + consultationId));
        if (consultationBiologicalExamId === undefined || consultationBiologicalExamId === null)
            throw new Error("The parameter 'consultationBiologicalExamId' must be defined.");
        url_ = url_.replace("{consultationBiologicalExamId}", encodeURIComponent("" + consultationBiologicalExamId));
        if (biologicalExamSetId === undefined || biologicalExamSetId === null)
            throw new Error("The parameter 'biologicalExamSetId' must be defined.");
        url_ = url_.replace("{biologicalExamSetId}", encodeURIComponent("" + biologicalExamSetId));
        if (biologicalExamGroupId === undefined || biologicalExamGroupId === null)
            throw new Error("The parameter 'biologicalExamGroupId' must be defined.");
        url_ = url_.replace("{biologicalExamGroupId}", encodeURIComponent("" + biologicalExamGroupId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMoveConsultationBiologicalExam(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMoveConsultationBiologicalExam(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processMoveConsultationBiologicalExam(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Selects the consultation suggestible.
     * @param consultationSuggestibleSelection The consultation suggestible selection.
     * @return The task.
     */
    selectConsultationSuggestible(consultationSuggestibleSelection: ConsultationSuggestibleInfo | null): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/Consultation/SelectConsultationSuggestible";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(consultationSuggestibleSelection);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSelectConsultationSuggestible(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSelectConsultationSuggestible(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSelectConsultationSuggestible(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Selects in the consultation biological sets.
     * @param consultationId The consultation identifier.
     * @param setIds The set identifiers.
     * @param select The variable to set the select to.
     * @param isGroup Whether the sets are set or group.
     */
    selectConsultationBiologicalExamSets(consultationId: number, setIds: number[] | null, select: boolean, isGroup: boolean): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/Consultation/SelectConsultationBiologicalExamSets/?consultationId={consultationId}&select={select}&isGroup={isGroup}";
        if (consultationId === undefined || consultationId === null)
            throw new Error("The parameter 'consultationId' must be defined.");
        url_ = url_.replace("{consultationId}", encodeURIComponent("" + consultationId));
        if (select === undefined || select === null)
            throw new Error("The parameter 'select' must be defined.");
        url_ = url_.replace("{select}", encodeURIComponent("" + select));
        if (isGroup === undefined || isGroup === null)
            throw new Error("The parameter 'isGroup' must be defined.");
        url_ = url_.replace("{isGroup}", encodeURIComponent("" + isGroup));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(setIds);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSelectConsultationBiologicalExamSets(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSelectConsultationBiologicalExamSets(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSelectConsultationBiologicalExamSets(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Selects the consultation suggestibles.
     * @param consultationSuggestibleSelection The consultation suggestible selection.
     */
    selectConsultationSuggestibles(consultationSuggestibleSelection: ConsultationSuggestibleInfo[] | null): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/Consultation/SelectConsultationSuggestibles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(consultationSuggestibleSelection);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSelectConsultationSuggestibles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSelectConsultationSuggestibles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSelectConsultationSuggestibles(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Selects the nutritionnal supplements.
     * @param nutritionalSupplementSelectionInfo The nutritional supplement selection infos.
     * @return The task.
     */
    selectNutritionnalSupplements(nutritionalSupplementSelectionInfo: NutritionalSupplementSelectionInfo | null): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/Consultation/SelectNutritionnalSupplements";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(nutritionalSupplementSelectionInfo);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSelectNutritionnalSupplements(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSelectNutritionnalSupplements(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSelectNutritionnalSupplements(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Selects the consultation prescription models.
     * @param selectionInformations The selection informations.
     */
    selectOrAddConsultationPrescriptionModels(selectionInformations: DocumentTemplateSelectionInformation[] | null): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/Consultation/SelectOrAddConsultationPrescriptionModels";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(selectionInformations);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSelectOrAddConsultationPrescriptionModels(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSelectOrAddConsultationPrescriptionModels(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSelectOrAddConsultationPrescriptionModels(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Selects the consultation prescription models.
     * @param selectionInformations The selection informations.
     */
    selectConsultationPrescriptionModels(selectionInformations: SelectionInformations | null): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/Consultation/SelectConsultationPrescriptionModels";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(selectionInformations);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSelectConsultationPrescriptionModels(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSelectConsultationPrescriptionModels(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSelectConsultationPrescriptionModels(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Sends the suggestion.
     * @param consultationId The consultation identifier.
     * @param suggestionId The suggestion identifier.
     */
    sendSuggestion(consultationId: number, suggestionId: number): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/Consultation/SendSuggestion/?consultationId={consultationId}&suggestionId={suggestionId}";
        if (consultationId === undefined || consultationId === null)
            throw new Error("The parameter 'consultationId' must be defined.");
        url_ = url_.replace("{consultationId}", encodeURIComponent("" + consultationId));
        if (suggestionId === undefined || suggestionId === null)
            throw new Error("The parameter 'suggestionId' must be defined.");
        url_ = url_.replace("{suggestionId}", encodeURIComponent("" + suggestionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendSuggestion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendSuggestion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendSuggestion(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Sends a suggestible to the patient.
     * @param suggestibleInfo The suggestible.
     */
    sendConsultationSuggestible(suggestibleInfo: ConsultationSuggestibleInfo | null): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/Consultation/SendConsultationSuggestible";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(suggestibleInfo);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendConsultationSuggestible(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendConsultationSuggestible(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendConsultationSuggestible(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Sets the consultation alternative medicine activation.
     * @param alternativeMedicineId The alternative medicine identifier.
     * @param consultationId The consultation identifier.
     * @param value if set to true [value].
     */
    setConsultationAlternativeMedicineActivation(alternativeMedicineId: number, consultationId: number, value: boolean): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/Consultation/SetConsultationAlternativeMedicineActivation/?alternativeMedicineId={alternativeMedicineId}&consultationId={consultationId}&value={value}";
        if (alternativeMedicineId === undefined || alternativeMedicineId === null)
            throw new Error("The parameter 'alternativeMedicineId' must be defined.");
        url_ = url_.replace("{alternativeMedicineId}", encodeURIComponent("" + alternativeMedicineId));
        if (consultationId === undefined || consultationId === null)
            throw new Error("The parameter 'consultationId' must be defined.");
        url_ = url_.replace("{consultationId}", encodeURIComponent("" + consultationId));
        if (value === undefined || value === null)
            throw new Error("The parameter 'value' must be defined.");
        url_ = url_.replace("{value}", encodeURIComponent("" + value));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetConsultationAlternativeMedicineActivation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetConsultationAlternativeMedicineActivation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetConsultationAlternativeMedicineActivation(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Checks if the consultation is overlapping others.
     * @param consultationDetails The consultation.
     * @param update (optional) Whether the consultation is for an update or a creation.
     * @return A value indicating whether the consultation is overlapping other consultations for the same doctor.
     */
    isConsultationOverlappingOthers(consultationDetails: ConsultationBasicInfoEdit | null, update?: boolean | undefined): Observable<ResponseStatus> {
        let url_ = this.baseUrl + "/umbraco/Api/Consultation/IsConsultationOverlappingOthers?";
        if (update === null)
            throw new Error("The parameter 'update' cannot be null.");
        else if (update !== undefined)
            url_ += "update=" + encodeURIComponent("" + update) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(consultationDetails);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsConsultationOverlappingOthers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsConsultationOverlappingOthers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseStatus>;
        }));
    }

    protected processIsConsultationOverlappingOthers(response: HttpResponseBase): Observable<ResponseStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates the consultation.
     * @param consultationUpdate The consultation details.
     * @return The response status
     */
    updateConsultation(consultationUpdate: ConsultationUpdate | null): Observable<ResponseStatus> {
        let url_ = this.baseUrl + "/umbraco/Api/Consultation/UpdateConsultation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(consultationUpdate);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateConsultation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateConsultation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseStatus>;
        }));
    }

    protected processUpdateConsultation(response: HttpResponseBase): Observable<ResponseStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates the consultation.
     * @param consultationUpdate The consultation details.
     * @return The response status
     */
    updateConsultationFromMyNutri(consultationUpdate: ConsultationCreation | null): Observable<ResponseStatus> {
        let url_ = this.baseUrl + "/umbraco/Api/Consultation/UpdateConsultationFromMyNutri";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(consultationUpdate);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateConsultationFromMyNutri(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateConsultationFromMyNutri(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseStatus>;
        }));
    }

    protected processUpdateConsultationFromMyNutri(response: HttpResponseBase): Observable<ResponseStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates the consultation informations.
     * @param consultationInformationUpdate The consultation information update.
     */
    updateConsultationInformations(consultationInformationUpdate: ConsultationInformationUpdate | null): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/Consultation/UpdateConsultationInformations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(consultationInformationUpdate);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateConsultationInformations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateConsultationInformations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateConsultationInformations(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates the consultation configuration.
     * @param consultationConfig The consultation configuration to update
     * @return Returns whether the update has created empty timeslots ot not.
     */
    updateConsultationConfig(consultationConfig: ConsultationConfig | null): Observable<boolean> {
        let url_ = this.baseUrl + "/umbraco/Api/Consultation/UpdateConsultationConfig";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(consultationConfig);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateConsultationConfig(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateConsultationConfig(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpdateConsultationConfig(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates the consultation configuration status.
     * @param consultationConfigId The consultation configuration status to update
     * @param isActive the status of consutlation configuration
     */
    updateConsultationConfigStatus(consultationConfigId: number, isActive: boolean): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/Consultation/UpdateConsultationConfigStatus/?consultationConfigId={consultationConfigId}&isActive={isActive}";
        if (consultationConfigId === undefined || consultationConfigId === null)
            throw new Error("The parameter 'consultationConfigId' must be defined.");
        url_ = url_.replace("{consultationConfigId}", encodeURIComponent("" + consultationConfigId));
        if (isActive === undefined || isActive === null)
            throw new Error("The parameter 'isActive' must be defined.");
        url_ = url_.replace("{isActive}", encodeURIComponent("" + isActive));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateConsultationConfigStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateConsultationConfigStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateConsultationConfigStatus(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates the consultation reason.
     * @param updateConsultationReason The consultation reason.
     * @return The status of the operation
     */
    updateConsultationReason(updateConsultationReason: UpdateConsultationReason | null): Observable<ResponseStatus> {
        let url_ = this.baseUrl + "/umbraco/Api/Consultation/UpdateConsultationReason";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateConsultationReason);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateConsultationReason(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateConsultationReason(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseStatus>;
        }));
    }

    protected processUpdateConsultationReason(response: HttpResponseBase): Observable<ResponseStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Captures the payment for consultation.
     * @param consultationId The consultation identifier.
     * @param amountToCapture The amount to capture.
     * @param fallBackPaymentMethod Used to allow the status to be changed to paid even though the fingerprint has been taken but not captured(because it was too late).
     * @return A Task representing the asynchronous operation.
     */
    captureFunds(consultationId: number, amountToCapture: number, fallBackPaymentMethod: boolean): Observable<StatusValueResourceOfNullableDecimal | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Consultation/CaptureFunds/?consultationId={consultationId}&amountToCapture={amountToCapture}&fallBackPaymentMethod={fallBackPaymentMethod}";
        if (consultationId === undefined || consultationId === null)
            throw new Error("The parameter 'consultationId' must be defined.");
        url_ = url_.replace("{consultationId}", encodeURIComponent("" + consultationId));
        if (amountToCapture === undefined || amountToCapture === null)
            throw new Error("The parameter 'amountToCapture' must be defined.");
        url_ = url_.replace("{amountToCapture}", encodeURIComponent("" + amountToCapture));
        if (fallBackPaymentMethod === undefined || fallBackPaymentMethod === null)
            throw new Error("The parameter 'fallBackPaymentMethod' must be defined.");
        url_ = url_.replace("{fallBackPaymentMethod}", encodeURIComponent("" + fallBackPaymentMethod));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCaptureFunds(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCaptureFunds(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StatusValueResourceOfNullableDecimal | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StatusValueResourceOfNullableDecimal | null>;
        }));
    }

    protected processCaptureFunds(response: HttpResponseBase): Observable<StatusValueResourceOfNullableDecimal | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? StatusValueResourceOfNullableDecimal.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates the consultation status.
     * @param consultationId The consultation identifier.
     * @param paymentStatus The payment status.
     */
    updateConsultationToAnActiveMeansOfPayment(consultationId: number, paymentStatus: PaymentStatus): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/Consultation/UpdateConsultationToAnActiveMeansOfPayment/?consultationId={consultationId}&paymentStatus={paymentStatus}";
        if (consultationId === undefined || consultationId === null)
            throw new Error("The parameter 'consultationId' must be defined.");
        url_ = url_.replace("{consultationId}", encodeURIComponent("" + consultationId));
        if (paymentStatus === undefined || paymentStatus === null)
            throw new Error("The parameter 'paymentStatus' must be defined.");
        url_ = url_.replace("{paymentStatus}", encodeURIComponent("" + paymentStatus));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateConsultationToAnActiveMeansOfPayment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateConsultationToAnActiveMeansOfPayment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateConsultationToAnActiveMeansOfPayment(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates the consultation status.
     * @param consultationId The consultation identifier.
     * @param consultationStatus The consultation status.
     * @return the task.
     */
    updateConsultationStatus(consultationId: number, consultationStatus: ConsultationStatus): Observable<ResponseStatus> {
        let url_ = this.baseUrl + "/umbraco/Api/Consultation/UpdateConsultationStatus/?consultationId={consultationId}&consultationStatus={consultationStatus}";
        if (consultationId === undefined || consultationId === null)
            throw new Error("The parameter 'consultationId' must be defined.");
        url_ = url_.replace("{consultationId}", encodeURIComponent("" + consultationId));
        if (consultationStatus === undefined || consultationStatus === null)
            throw new Error("The parameter 'consultationStatus' must be defined.");
        url_ = url_.replace("{consultationStatus}", encodeURIComponent("" + consultationStatus));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateConsultationStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateConsultationStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseStatus>;
        }));
    }

    protected processUpdateConsultationStatus(response: HttpResponseBase): Observable<ResponseStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates the consultation status.
     * @param consultationId The consultation identifier.
     * @param consultationStatus The consultation status.
     */
    updateConsultationStatusMy(consultationId: number, consultationStatus: ConsultationStatus): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/Consultation/UpdateConsultationStatusMy/?consultationId={consultationId}&consultationStatus={consultationStatus}";
        if (consultationId === undefined || consultationId === null)
            throw new Error("The parameter 'consultationId' must be defined.");
        url_ = url_.replace("{consultationId}", encodeURIComponent("" + consultationId));
        if (consultationStatus === undefined || consultationStatus === null)
            throw new Error("The parameter 'consultationStatus' must be defined.");
        url_ = url_.replace("{consultationStatus}", encodeURIComponent("" + consultationStatus));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateConsultationStatusMy(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateConsultationStatusMy(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateConsultationStatusMy(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates the consultation type.
     * @param consultationType The consultation type to update
     * @return The response status
     */
    updateConsultationType(consultationType: ConsultationType | null): Observable<ResponseStatus> {
        let url_ = this.baseUrl + "/umbraco/Api/Consultation/UpdateConsultationType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(consultationType);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateConsultationType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateConsultationType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseStatus>;
        }));
    }

    protected processUpdateConsultationType(response: HttpResponseBase): Observable<ResponseStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates the consultation subtype.
     * @param consultationSubType The consultation subtype to update
     */
    updateConsultationSubType(consultationSubType: ConsultationSubType | null): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/Consultation/UpdateConsultationSubType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(consultationSubType);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateConsultationSubType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateConsultationSubType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateConsultationSubType(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Auto update the consultation status when current member joined the visio
     * @param infos The consultation auto update status infos
     */
    updateConsultationStatusWhenCurrentMemberJoinedVisio(infos: ConsultationAutoUpdateStatusInfo | null): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/Consultation/UpdateConsultationStatusWhenCurrentMemberJoinedVisio";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(infos);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateConsultationStatusWhenCurrentMemberJoinedVisio(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateConsultationStatusWhenCurrentMemberJoinedVisio(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateConsultationStatusWhenCurrentMemberJoinedVisio(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Auto update the consultation status when current member joined the visio
     * @param infos The consultation auto update status infos
     */
    updateConsultationStatusWhenCurrentMemberLeftVisio(infos: ConsultationAutoUpdateStatusInfo | null): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/Consultation/UpdateConsultationStatusWhenCurrentMemberLeftVisio";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(infos);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateConsultationStatusWhenCurrentMemberLeftVisio(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateConsultationStatusWhenCurrentMemberLeftVisio(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateConsultationStatusWhenCurrentMemberLeftVisio(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates the consultation document template.
     * @param updateConsultationDocumentTemplate The update consultation document template.
     */
    updateConsultationDocumentTemplate(updateConsultationDocumentTemplate: UpdateConsultationDocumentTemplate | null): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/Consultation/UpdateConsultationDocumentTemplate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateConsultationDocumentTemplate);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateConsultationDocumentTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateConsultationDocumentTemplate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateConsultationDocumentTemplate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates the information.
     * @param updateInformationModel The consultation identifier.
     */
    updateInformation(updateInformationModel: UpdateInformationModel | null): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/Consultation/UpdateInformation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateInformationModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateInformation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateInformation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateInformation(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates the nutrionnal supplement.
     * @param consultationId The consultation identifier.
     * @param nutrionnalSup The nutrionnal sup.
     */
    updateNutritionnalSupplement(consultationId: number, nutrionnalSup: string): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/Consultation/UpdateNutritionnalSupplement/?consultationId={consultationId}&nutrionnalSup={nutrionnalSup}";
        if (consultationId === undefined || consultationId === null)
            throw new Error("The parameter 'consultationId' must be defined.");
        url_ = url_.replace("{consultationId}", encodeURIComponent("" + consultationId));
        if (nutrionnalSup === undefined || nutrionnalSup === null)
            throw new Error("The parameter 'nutrionnalSup' must be defined.");
        url_ = url_.replace("{nutrionnalSup}", encodeURIComponent("" + nutrionnalSup));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateNutritionnalSupplement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateNutritionnalSupplement(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateNutritionnalSupplement(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates the posology.
     * @param id The identifier.
     * @param posology The posology.
     */
    updatePosology(id: number, posology: string): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/Consultation/UpdatePosology/{id}?posology={posology}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (posology === undefined || posology === null)
            throw new Error("The parameter 'posology' must be defined.");
        url_ = url_.replace("{posology}", encodeURIComponent("" + posology));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePosology(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePosology(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdatePosology(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates the summary.
     * @param consultationSummary The consultation summary.
     */
    updateSummary(consultationSummary: ConsultationSummary | null): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/Consultation/UpdateSummary";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(consultationSummary);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateSummary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateSummary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateSummary(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates the consultation tag.
     * @param consultationTag The consultation tag.
     */
    updateTag(consultationTag: ConsultationSummary | null): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/Consultation/UpdateTag";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(consultationTag);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateTag(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateTag(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateTag(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates the consultation reason status.
     * @param id The identifier.
     * @param status if set to true [status].
     */
    updateConsultationReasonStatus(id: number, status: boolean): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/Consultation/UpdateConsultationReasonStatus/{id}?status={status}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (status === undefined || status === null)
            throw new Error("The parameter 'status' must be defined.");
        url_ = url_.replace("{status}", encodeURIComponent("" + status));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateConsultationReasonStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateConsultationReasonStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateConsultationReasonStatus(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates the consultation subtype IsArchived.
     * @param id The identifier.
     * @param isarchived if set to true [isarchived].
     */
    updateConsultationSubTypeIsArchived(id: number, isarchived: boolean): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/Consultation/UpdateConsultationSubTypeIsArchived/{id}?isarchived={isarchived}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (isarchived === undefined || isarchived === null)
            throw new Error("The parameter 'isarchived' must be defined.");
        url_ = url_.replace("{isarchived}", encodeURIComponent("" + isarchived));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateConsultationSubTypeIsArchived(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateConsultationSubTypeIsArchived(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateConsultationSubTypeIsArchived(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Creates the consultation.
     * @param consultationId The consultation identifier.
     */
    sendConsultationPatientConfirmation(consultationId: number): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/Consultation/SendConsultationPatientConfirmation/?consultationId={consultationId}";
        if (consultationId === undefined || consultationId === null)
            throw new Error("The parameter 'consultationId' must be defined.");
        url_ = url_.replace("{consultationId}", encodeURIComponent("" + consultationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendConsultationPatientConfirmation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendConsultationPatientConfirmation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendConsultationPatientConfirmation(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Send the document to the patient.
     * @param docsParams The document send to patient.
     * @return Action result
     */
    sendOtherDocumentToPatient(docsParams: SendDocsParams | null): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/Consultation/SendOtherDocumentToPatient";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(docsParams);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendOtherDocumentToPatient(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendOtherDocumentToPatient(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendOtherDocumentToPatient(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Send the document to the patient.
     * @param queryParams The params docs send to patient.
     */
    cancelSendDocumentToPatient(queryParams: SendDocsParams | null): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/Consultation/CancelSendDocumentToPatient";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(queryParams);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancelSendDocumentToPatient(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancelSendDocumentToPatient(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCancelSendDocumentToPatient(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Adds the formularies to the consultation.
     * @param consultationId The consultation identifier.
     * @param formularies The formularies.
     * @param sleepDiaryBegin The sleep diary begin.
     */
    addFormularies(consultationId: number, formularies: ConsultInFormularyVersion[] | null, sleepDiaryBegin: Date): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/Consultation/AddFormularies/?consultationId={consultationId}&sleepDiaryBegin={sleepDiaryBegin}";
        if (consultationId === undefined || consultationId === null)
            throw new Error("The parameter 'consultationId' must be defined.");
        url_ = url_.replace("{consultationId}", encodeURIComponent("" + consultationId));
        if (sleepDiaryBegin === undefined || sleepDiaryBegin === null)
            throw new Error("The parameter 'sleepDiaryBegin' must be defined.");
        url_ = url_.replace("{sleepDiaryBegin}", encodeURIComponent(sleepDiaryBegin ? "" + sleepDiaryBegin.toISOString() : "null"));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(formularies);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddFormularies(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddFormularies(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddFormularies(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Selects the nutritional supplement.
     * @param create The create.
     */
    addConsultationNutritionalSupplement(create: CreateConsultationNutritionalSupplement | null): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/Consultation/AddConsultationNutritionalSupplement";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(create);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddConsultationNutritionalSupplement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddConsultationNutritionalSupplement(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddConsultationNutritionalSupplement(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Adds the suggestible.
     * @param consultationSuggestibleInfo The consultation suggestible information.
     */
    addConsultationSuggestible(consultationSuggestibleInfo: ConsultationSuggestibleInfo | null): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/Consultation/AddConsultationSuggestible";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(consultationSuggestibleInfo);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddConsultationSuggestible(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddConsultationSuggestible(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddConsultationSuggestible(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Adds the consultation suggestibles.
     * @param consultationSuggestibleInfos The consultation suggestible infos.
     */
    addConsultationSuggestibles(consultationSuggestibleInfos: ConsultationSuggestibleInfo[] | null): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/Consultation/AddConsultationSuggestibles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(consultationSuggestibleInfos);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddConsultationSuggestibles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddConsultationSuggestibles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddConsultationSuggestibles(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Adds the biological exam sets to the consultation
     * @param consultationId The consultation identifier.
     * @param biologicalExamSetIds The biological exam sets identifiers.
     */
    addBiologicalExamSetsToConsultation(consultationId: number, biologicalExamSetIds: number[] | null): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/Consultation/AddBiologicalExamSetsToConsultation/?consultationId={consultationId}";
        if (consultationId === undefined || consultationId === null)
            throw new Error("The parameter 'consultationId' must be defined.");
        url_ = url_.replace("{consultationId}", encodeURIComponent("" + consultationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(biologicalExamSetIds);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddBiologicalExamSetsToConsultation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddBiologicalExamSetsToConsultation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddBiologicalExamSetsToConsultation(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Adds the suggestion to the consultation
     * @param consultationSuggestions The consultation suggestion.
     */
    addSuggestions(consultationSuggestions: ConsultationSuggestionCreator[] | null): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/Consultation/AddSuggestions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(consultationSuggestions);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddSuggestions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddSuggestions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddSuggestions(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Cancels the consultation.
     * @param consultationId The consultation identifier.
     */
    cancelConsultation(consultationId: number): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/Consultation/CancelConsultation/?consultationId={consultationId}";
        if (consultationId === undefined || consultationId === null)
            throw new Error("The parameter 'consultationId' must be defined.");
        url_ = url_.replace("{consultationId}", encodeURIComponent("" + consultationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancelConsultation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancelConsultation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCancelConsultation(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Cancels ending a suggestible to the patient.
     * @param suggestibleInfo The suggestible.
     */
    cancelSendConsultationSuggestible(suggestibleInfo: ConsultationSuggestibleInfo | null): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/Consultation/CancelSendConsultationSuggestible";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(suggestibleInfo);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancelSendConsultationSuggestible(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancelSendConsultationSuggestible(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCancelSendConsultationSuggestible(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Confirms the consultation.
     * @param consultationId The consultation identifier.
     * @return A Task representing the asynchronous operation.
     */
    confirmConsultation(consultationId: number): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/Consultation/ConfirmConsultation/?consultationId={consultationId}";
        if (consultationId === undefined || consultationId === null)
            throw new Error("The parameter 'consultationId' must be defined.");
        url_ = url_.replace("{consultationId}", encodeURIComponent("" + consultationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfirmConsultation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfirmConsultation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processConfirmConsultation(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Confirms the PSNC consultation consent.
     * @param consultationId The consultation identifier.
     */
    confirmPSNCConsultationConsent(consultationId: number): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/Consultation/ConfirmPSNCConsultationConsent/?consultationId={consultationId}";
        if (consultationId === undefined || consultationId === null)
            throw new Error("The parameter 'consultationId' must be defined.");
        url_ = url_.replace("{consultationId}", encodeURIComponent("" + consultationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfirmPSNCConsultationConsent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfirmPSNCConsultationConsent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processConfirmPSNCConsultationConsent(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Deletes the consultation nutritional supplement.
     * @param id The identifier.
     * @return A task.
     */
    deleteConsultationNutritionalSupplement(id: number): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/Consultation/DeleteConsultationNutritionalSupplement/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteConsultationNutritionalSupplement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteConsultationNutritionalSupplement(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteConsultationNutritionalSupplement(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Deletes the consultation formularies.
     * @param consultationFormularyIds The ids.
     */
    deleteConsultationFormularies(consultationFormularyIds: number[] | null): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/Consultation/DeleteConsultationFormularies";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(consultationFormularyIds);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteConsultationFormularies(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteConsultationFormularies(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteConsultationFormularies(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Duplicates the prescription model.
     * @param idToDuplicate The identifier to duplicate.
     */
    duplicatePrescriptionModel(idToDuplicate: number): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/Consultation/DuplicatePrescriptionModel/?idToDuplicate={idToDuplicate}";
        if (idToDuplicate === undefined || idToDuplicate === null)
            throw new Error("The parameter 'idToDuplicate' must be defined.");
        url_ = url_.replace("{idToDuplicate}", encodeURIComponent("" + idToDuplicate));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDuplicatePrescriptionModel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDuplicatePrescriptionModel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDuplicatePrescriptionModel(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the consultation selection informations.
     * @param consultationId The consultation identifier.
     * @return All the information about selectable entities.
     */
    getConsultationSelectionInformations(consultationId: number): Observable<ConsultationSelectionInformation | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Consultation/GetConsultationSelectionInformations/?consultationId={consultationId}";
        if (consultationId === undefined || consultationId === null)
            throw new Error("The parameter 'consultationId' must be defined.");
        url_ = url_.replace("{consultationId}", encodeURIComponent("" + consultationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConsultationSelectionInformations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConsultationSelectionInformations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConsultationSelectionInformation | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConsultationSelectionInformation | null>;
        }));
    }

    protected processGetConsultationSelectionInformations(response: HttpResponseBase): Observable<ConsultationSelectionInformation | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ConsultationSelectionInformation.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * verify if a consultation exist for a patient.
     * @param patientId The patient identifier.
     * @param consultationId The consultation identifier.
     * @return Check if a consultation exist for a patient.
     */
    checkPatientConsultation(patientId: number, consultationId: number): Observable<boolean> {
        let url_ = this.baseUrl + "/umbraco/Api/Consultation/CheckPatientConsultation/?patientId={patientId}&consultationId={consultationId}";
        if (patientId === undefined || patientId === null)
            throw new Error("The parameter 'patientId' must be defined.");
        url_ = url_.replace("{patientId}", encodeURIComponent("" + patientId));
        if (consultationId === undefined || consultationId === null)
            throw new Error("The parameter 'consultationId' must be defined.");
        url_ = url_.replace("{consultationId}", encodeURIComponent("" + consultationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckPatientConsultation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckPatientConsultation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCheckPatientConsultation(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Closes the consultation.
     * @param consultationId The consultation identifier.
     * @param sendMail Whether to send the mail or not.
     * @return A Task representing the asynchronous operation.
     */
    closeConsultation(consultationId: number, sendMail: boolean): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/Consultation/CloseConsultation/?consultationId={consultationId}&sendMail={sendMail}";
        if (consultationId === undefined || consultationId === null)
            throw new Error("The parameter 'consultationId' must be defined.");
        url_ = url_.replace("{consultationId}", encodeURIComponent("" + consultationId));
        if (sendMail === undefined || sendMail === null)
            throw new Error("The parameter 'sendMail' must be defined.");
        url_ = url_.replace("{sendMail}", encodeURIComponent("" + sendMail));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCloseConsultation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCloseConsultation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCloseConsultation(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the number complementary exam selected.
     * @param consultationId The consultation identifier.
     * @return the number of selected items
     */
    getNumberComplementaryExamSelected(consultationId: number): Observable<number> {
        let url_ = this.baseUrl + "/umbraco/Api/Consultation/GetNumberComplementaryExamSelected/?consultationId={consultationId}";
        if (consultationId === undefined || consultationId === null)
            throw new Error("The parameter 'consultationId' must be defined.");
        url_ = url_.replace("{consultationId}", encodeURIComponent("" + consultationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNumberComplementaryExamSelected(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNumberComplementaryExamSelected(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetNumberComplementaryExamSelected(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the number biological exam selected.
     * @param consultationId The consultation identifier.
     * @return the number of selected items
     */
    getNumberBiologicalExamSelected(consultationId: number): Observable<number> {
        let url_ = this.baseUrl + "/umbraco/Api/Consultation/GetNumberBiologicalExamSelected/?consultationId={consultationId}";
        if (consultationId === undefined || consultationId === null)
            throw new Error("The parameter 'consultationId' must be defined.");
        url_ = url_.replace("{consultationId}", encodeURIComponent("" + consultationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNumberBiologicalExamSelected(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNumberBiologicalExamSelected(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetNumberBiologicalExamSelected(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the number activity selected.
     * @param consultationId The consultation identifier.
     * @return the number of selected items
     */
    getNumberActivitySelected(consultationId: number): Observable<number> {
        let url_ = this.baseUrl + "/umbraco/Api/Consultation/GetNumberActivitySelected/?consultationId={consultationId}";
        if (consultationId === undefined || consultationId === null)
            throw new Error("The parameter 'consultationId' must be defined.");
        url_ = url_.replace("{consultationId}", encodeURIComponent("" + consultationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNumberActivitySelected(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNumberActivitySelected(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetNumberActivitySelected(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the number suggestion selected.
     * @param consultationId The consultation identifier.
     * @param suggestionType Type of the suggestion.
     * @return the number of selected items
     */
    getNumberSuggestionSelected(consultationId: number, suggestionType: SuggestionType): Observable<number> {
        let url_ = this.baseUrl + "/umbraco/Api/Consultation/GetNumberSuggestionSelected/?consultationId={consultationId}&suggestionType={suggestionType}";
        if (consultationId === undefined || consultationId === null)
            throw new Error("The parameter 'consultationId' must be defined.");
        url_ = url_.replace("{consultationId}", encodeURIComponent("" + consultationId));
        if (suggestionType === undefined || suggestionType === null)
            throw new Error("The parameter 'suggestionType' must be defined.");
        url_ = url_.replace("{suggestionType}", encodeURIComponent("" + suggestionType));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNumberSuggestionSelected(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNumberSuggestionSelected(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetNumberSuggestionSelected(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the number consultation type selected.
     * @param consultationId The consultation identifier.
     * @return the number of selected items
     */
    getNumberConsultationTypeSelected(consultationId: number): Observable<number> {
        let url_ = this.baseUrl + "/umbraco/Api/Consultation/GetNumberConsultationTypeSelected/?consultationId={consultationId}";
        if (consultationId === undefined || consultationId === null)
            throw new Error("The parameter 'consultationId' must be defined.");
        url_ = url_.replace("{consultationId}", encodeURIComponent("" + consultationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNumberConsultationTypeSelected(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNumberConsultationTypeSelected(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetNumberConsultationTypeSelected(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the number formulary selected.
     * @param consultationId The consultation identifier.
     * @param isForNextConsultation if set to true [is for next consultation].
     * @return the number of selected items
     */
    getNumberFormularySelected(consultationId: number, isForNextConsultation: boolean): Observable<number> {
        let url_ = this.baseUrl + "/umbraco/Api/Consultation/GetNumberFormularySelected/?consultationId={consultationId}&isForNextConsultation={isForNextConsultation}";
        if (consultationId === undefined || consultationId === null)
            throw new Error("The parameter 'consultationId' must be defined.");
        url_ = url_.replace("{consultationId}", encodeURIComponent("" + consultationId));
        if (isForNextConsultation === undefined || isForNextConsultation === null)
            throw new Error("The parameter 'isForNextConsultation' must be defined.");
        url_ = url_.replace("{isForNextConsultation}", encodeURIComponent("" + isForNextConsultation));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNumberFormularySelected(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNumberFormularySelected(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetNumberFormularySelected(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the number formulary selected.
     * @param consultationId The consultation identifier.
     * @return the number of selected items
     */
    getNumberNutritionalSupplementSelected(consultationId: number): Observable<number> {
        let url_ = this.baseUrl + "/umbraco/Api/Consultation/GetNumberNutritionalSupplementSelected/?consultationId={consultationId}";
        if (consultationId === undefined || consultationId === null)
            throw new Error("The parameter 'consultationId' must be defined.");
        url_ = url_.replace("{consultationId}", encodeURIComponent("" + consultationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNumberNutritionalSupplementSelected(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNumberNutritionalSupplementSelected(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetNumberNutritionalSupplementSelected(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the graphic value for formulary health status.
     * @param consultationId The consultation identifier.
     * @return the stat for the formulary state of health
     */
    getGraphicValueForFormularyHealthStatus(consultationId: number): Observable<ConsultationAnalysisQuestions | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Consultation/GetGraphicValueForFormularyHealthStatus/?consultationId={consultationId}";
        if (consultationId === undefined || consultationId === null)
            throw new Error("The parameter 'consultationId' must be defined.");
        url_ = url_.replace("{consultationId}", encodeURIComponent("" + consultationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGraphicValueForFormularyHealthStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGraphicValueForFormularyHealthStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConsultationAnalysisQuestions | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConsultationAnalysisQuestions | null>;
        }));
    }

    protected processGetGraphicValueForFormularyHealthStatus(response: HttpResponseBase): Observable<ConsultationAnalysisQuestions | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ConsultationAnalysisQuestions.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the graphic value for formulary hypothesis.
     * @param consultationId The consultation identifier.
     * @return The value for the graphic of hypothesis formulary
     */
    getGraphicValueForFormularyHypothesis(consultationId: number): Observable<ConsultationAnalysisCategories | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Consultation/GetGraphicValueForFormularyHypothesis/?consultationId={consultationId}";
        if (consultationId === undefined || consultationId === null)
            throw new Error("The parameter 'consultationId' must be defined.");
        url_ = url_.replace("{consultationId}", encodeURIComponent("" + consultationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGraphicValueForFormularyHypothesis(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGraphicValueForFormularyHypothesis(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConsultationAnalysisCategories | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConsultationAnalysisCategories | null>;
        }));
    }

    protected processGetGraphicValueForFormularyHypothesis(response: HttpResponseBase): Observable<ConsultationAnalysisCategories | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ConsultationAnalysisCategories.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the graphic value for formulary hypothesis.
     * @param consultationId The consultation identifier.
     * @return The value detail for the graphic of hypothesis formulary
     */
    getGraphicValueForFormularyHypothesisDetails(consultationId: number): Observable<ConsultationAnalysisGraphicCategoryDetails[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Consultation/GetGraphicValueForFormularyHypothesisDetails/?consultationId={consultationId}";
        if (consultationId === undefined || consultationId === null)
            throw new Error("The parameter 'consultationId' must be defined.");
        url_ = url_.replace("{consultationId}", encodeURIComponent("" + consultationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGraphicValueForFormularyHypothesisDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGraphicValueForFormularyHypothesisDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConsultationAnalysisGraphicCategoryDetails[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConsultationAnalysisGraphicCategoryDetails[] | null>;
        }));
    }

    protected processGetGraphicValueForFormularyHypothesisDetails(response: HttpResponseBase): Observable<ConsultationAnalysisGraphicCategoryDetails[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ConsultationAnalysisGraphicCategoryDetails.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the consultation analyse.
     * @param consultationId The consultation identifier.
     * @return the stat of the life Axis graphic
     */
    getGraphicValueForFormularyLifeStyle(consultationId: number): Observable<ConsultationAnalysisCategories | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Consultation/GetGraphicValueForFormularyLifeStyle/?consultationId={consultationId}";
        if (consultationId === undefined || consultationId === null)
            throw new Error("The parameter 'consultationId' must be defined.");
        url_ = url_.replace("{consultationId}", encodeURIComponent("" + consultationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGraphicValueForFormularyLifeStyle(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGraphicValueForFormularyLifeStyle(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConsultationAnalysisCategories | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConsultationAnalysisCategories | null>;
        }));
    }

    protected processGetGraphicValueForFormularyLifeStyle(response: HttpResponseBase): Observable<ConsultationAnalysisCategories | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ConsultationAnalysisCategories.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the consultation analyse.
     * @param doctorId doctor id
     * @param patientId patient id
     * @return the stat of the life Axis graphic
     */
    getGraphicValueForFormularyLifeStyle2(doctorId: number, patientId: number): Observable<ConsultationAnalysisCategories | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Consultation/GetGraphicValueForFormularyLifeStyle/?doctorId={doctorId}&patientId={patientId}";
        if (doctorId === undefined || doctorId === null)
            throw new Error("The parameter 'doctorId' must be defined.");
        url_ = url_.replace("{doctorId}", encodeURIComponent("" + doctorId));
        if (patientId === undefined || patientId === null)
            throw new Error("The parameter 'patientId' must be defined.");
        url_ = url_.replace("{patientId}", encodeURIComponent("" + patientId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGraphicValueForFormularyLifeStyle2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGraphicValueForFormularyLifeStyle2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConsultationAnalysisCategories | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConsultationAnalysisCategories | null>;
        }));
    }

    protected processGetGraphicValueForFormularyLifeStyle2(response: HttpResponseBase): Observable<ConsultationAnalysisCategories | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ConsultationAnalysisCategories.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the consultation analyse.
     * @param consultationId The consultation identifier.
     * @return the details stat of the life Axis graphic
     */
    getGraphicValueForFormularyLifeStyleDetail(consultationId: number): Observable<ConsultationAnalysisGraphicCategoryDetails[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Consultation/GetGraphicValueForFormularyLifeStyleDetail/?consultationId={consultationId}";
        if (consultationId === undefined || consultationId === null)
            throw new Error("The parameter 'consultationId' must be defined.");
        url_ = url_.replace("{consultationId}", encodeURIComponent("" + consultationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGraphicValueForFormularyLifeStyleDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGraphicValueForFormularyLifeStyleDetail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConsultationAnalysisGraphicCategoryDetails[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConsultationAnalysisGraphicCategoryDetails[] | null>;
        }));
    }

    protected processGetGraphicValueForFormularyLifeStyleDetail(response: HttpResponseBase): Observable<ConsultationAnalysisGraphicCategoryDetails[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ConsultationAnalysisGraphicCategoryDetails.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Creates the consultation.
     * @param consultationCreation The consultation.
     * @return The status value
     */
    createConsultation(consultationCreation: ConsultationCreation | null): Observable<StatusValueResourceOfNullableInteger | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Consultation/CreateConsultation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(consultationCreation);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateConsultation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateConsultation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StatusValueResourceOfNullableInteger | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StatusValueResourceOfNullableInteger | null>;
        }));
    }

    protected processCreateConsultation(response: HttpResponseBase): Observable<StatusValueResourceOfNullableInteger | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? StatusValueResourceOfNullableInteger.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Creates A new consultation configuration.
     * @param consultationConfig The consultation configuration to create.
     * @return The Id of the created consultation configuration.
     */
    createConsultationConfig(consultationConfig: ConsultationConfig | null): Observable<number> {
        let url_ = this.baseUrl + "/umbraco/Api/Consultation/CreateConsultationConfig";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(consultationConfig);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateConsultationConfig(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateConsultationConfig(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateConsultationConfig(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Creates a duplicate of the consultation configuration.
     * @param consultationConfigId The consultation configuration to create by its id.
     * @return The Id of the created consultation configuration.
     */
    duplicateConsultationConfig(consultationConfigId: number): Observable<number> {
        let url_ = this.baseUrl + "/umbraco/Api/Consultation/DuplicateConsultationConfig/?consultationConfigId={consultationConfigId}";
        if (consultationConfigId === undefined || consultationConfigId === null)
            throw new Error("The parameter 'consultationConfigId' must be defined.");
        url_ = url_.replace("{consultationConfigId}", encodeURIComponent("" + consultationConfigId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDuplicateConsultationConfig(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDuplicateConsultationConfig(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processDuplicateConsultationConfig(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Creates the consultation reason
     * @param createConsultationReason The consultation reason.
     * @return The identifier of the newly created consultation reason
     */
    createConsultationReason(createConsultationReason: CreateConsultationReason | null): Observable<StatusValueResourceOfInteger | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Consultation/CreateConsultationReason";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createConsultationReason);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateConsultationReason(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateConsultationReason(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StatusValueResourceOfInteger | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StatusValueResourceOfInteger | null>;
        }));
    }

    protected processCreateConsultationReason(response: HttpResponseBase): Observable<StatusValueResourceOfInteger | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? StatusValueResourceOfInteger.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Creates A new consultation type.
     * @param consultationType Type of the consultation.
     * @return The Id of the created consultation type
     */
    createConsultationType(consultationType: ConsultationType | null): Observable<StatusValueResourceOfInteger | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Consultation/CreateConsultationType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(consultationType);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateConsultationType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateConsultationType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StatusValueResourceOfInteger | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StatusValueResourceOfInteger | null>;
        }));
    }

    protected processCreateConsultationType(response: HttpResponseBase): Observable<StatusValueResourceOfInteger | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? StatusValueResourceOfInteger.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Creates A new consultation subtype.
     * @param consultationSubType Subtype of the consultation.
     * @return The Id of the created consultation subtype
     */
    createConsultationSubType(consultationSubType: ConsultationSubType | null): Observable<number> {
        let url_ = this.baseUrl + "/umbraco/Api/Consultation/CreateConsultationSubType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(consultationSubType);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateConsultationSubType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateConsultationSubType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateConsultationSubType(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Creates the insurance consultation.
     * @param consultation The consultation.
     * @return The status value ressource of the request
     */
    createInsuranceConsultation(consultation: InsuranceConsultationCreation | null): Observable<StatusValueResourceOfInteger | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Consultation/CreateInsuranceConsultation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(consultation);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateInsuranceConsultation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateInsuranceConsultation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StatusValueResourceOfInteger | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StatusValueResourceOfInteger | null>;
        }));
    }

    protected processCreateInsuranceConsultation(response: HttpResponseBase): Observable<StatusValueResourceOfInteger | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? StatusValueResourceOfInteger.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Creates the insurance consultation.
     * @param consultationCreationMyNutri The consultation.
     * @return The consultation identifier.
     */
    createConsultationWithMyNutri(consultationCreationMyNutri: ConsultationCreation | null): Observable<StatusValueResourceOfNullableInteger | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Consultation/CreateConsultationWithMyNutri";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(consultationCreationMyNutri);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateConsultationWithMyNutri(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateConsultationWithMyNutri(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StatusValueResourceOfNullableInteger | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StatusValueResourceOfNullableInteger | null>;
        }));
    }

    protected processCreateConsultationWithMyNutri(response: HttpResponseBase): Observable<StatusValueResourceOfNullableInteger | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? StatusValueResourceOfNullableInteger.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Creates a consultation document template from a model.
     * @param consultationId The consultation identifier.
     * @param templateName The template name.
     */
    createConsultationDocumentTemplateFromAOtherTemplate(consultationId: number, templateName: string): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/Consultation/CreateConsultationDocumentTemplateFromAOtherTemplate/?consultationId={consultationId}&templateName={templateName}";
        if (consultationId === undefined || consultationId === null)
            throw new Error("The parameter 'consultationId' must be defined.");
        url_ = url_.replace("{consultationId}", encodeURIComponent("" + consultationId));
        if (templateName === undefined || templateName === null)
            throw new Error("The parameter 'templateName' must be defined.");
        url_ = url_.replace("{templateName}", encodeURIComponent("" + templateName));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateConsultationDocumentTemplateFromAOtherTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateConsultationDocumentTemplateFromAOtherTemplate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateConsultationDocumentTemplateFromAOtherTemplate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Deletes the consultation.
     * @param id The identifier.
     */
    deleteConsultation(id: number): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/Consultation/DeleteConsultation/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteConsultation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteConsultation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteConsultation(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Deletes the consultation biological exam.
     * @param id The identifier.
     * @return A task
     */
    deleteConsultationBiologicalExam(id: number): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/Consultation/DeleteConsultationBiologicalExam/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteConsultationBiologicalExam(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteConsultationBiologicalExam(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteConsultationBiologicalExam(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Deletes the consultation complementary exam.
     * @param id The identifier.
     * @return The task.
     */
    deleteConsultationComplementaryExam(id: number): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/Consultation/DeleteConsultationComplementaryExam/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteConsultationComplementaryExam(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteConsultationComplementaryExam(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteConsultationComplementaryExam(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Deletes the consultation activity.
     * @param id The identifier.
     */
    deleteConsultationActivity(id: number): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/Consultation/DeleteConsultationActivity/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteConsultationActivity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteConsultationActivity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteConsultationActivity(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Deletes the consultation recipe.
     * @param id The identifier.
     */
    deleteConsultationRecipe(id: number): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/Consultation/DeleteConsultationRecipe/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteConsultationRecipe(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteConsultationRecipe(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteConsultationRecipe(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Deletes the consultation document template.
     * @param id The identifier.
     */
    deleteConsultationDocumentTemplate(id: number): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/Consultation/DeleteConsultationDocumentTemplate/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteConsultationDocumentTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteConsultationDocumentTemplate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteConsultationDocumentTemplate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Deletes the consultation formulary.
     * @param id The identifier.
     */
    deleteConsultationFormulary(id: number): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/Consultation/DeleteConsultationFormulary/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteConsultationFormulary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteConsultationFormulary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteConsultationFormulary(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Deletes the consultation consultationtype.
     * @param id The identifier.
     * @return The task.
     */
    deleteConsultationConsultationtype(id: number): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/Consultation/DeleteConsultationConsultationtype/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteConsultationConsultationtype(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteConsultationConsultationtype(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteConsultationConsultationtype(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Deletes the consultation configuration.
     * @param id The identifier of the consultation configuration to delete.
     */
    deleteConsultationConfig(id: number): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/Consultation/DeleteConsultationConfig/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteConsultationConfig(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteConsultationConfig(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteConsultationConfig(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Deletes the medical history.
     * @param id The identifier.
     */
    deleteConsultationReason(id: number): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/Consultation/DeleteConsultationReason/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteConsultationReason(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteConsultationReason(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteConsultationReason(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Deletes the consultation type.
     * @param id The identifier of the consultation type to delete.
     */
    deleteConsultationType(id: number): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/Consultation/DeleteConsultationType/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteConsultationType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteConsultationType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteConsultationType(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Deletes the formulary.
     * @param consultationId The consultation identifier.
     * @param formularyVersionId The formulary identifier.
     */
    deleteFormulary(consultationId: number, formularyVersionId: number): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/Consultation/DeleteFormulary/?consultationId={consultationId}&formularyVersionId={formularyVersionId}";
        if (consultationId === undefined || consultationId === null)
            throw new Error("The parameter 'consultationId' must be defined.");
        url_ = url_.replace("{consultationId}", encodeURIComponent("" + consultationId));
        if (formularyVersionId === undefined || formularyVersionId === null)
            throw new Error("The parameter 'formularyVersionId' must be defined.");
        url_ = url_.replace("{formularyVersionId}", encodeURIComponent("" + formularyVersionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteFormulary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteFormulary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteFormulary(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Deletes the link between the provided consultation and suggestion.
     * @param id The suggestion identifier.
     */
    deleteConsultationSuggestion(id: number): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/Consultation/DeleteConsultationSuggestion/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteConsultationSuggestion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteConsultationSuggestion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteConsultationSuggestion(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the alternative medicines dropdowns.
     * @return The alternative medicines dropdown values
     */
    getAlternativeMedicinesDropdowns(): Observable<DropdownValue[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Consultation/GetAlternativeMedicinesDropdowns";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAlternativeMedicinesDropdowns(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAlternativeMedicinesDropdowns(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DropdownValue[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DropdownValue[] | null>;
        }));
    }

    protected processGetAlternativeMedicinesDropdowns(response: HttpResponseBase): Observable<DropdownValue[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DropdownValue.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the patient consultation as ics file.
     * @param consultationId The consultation identifier.
     * @return The ics file
     */
    getPatientConsultationAsIcsFile(consultationId: number): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Consultation/GetPatientConsultationAsIcsFile/?consultationId={consultationId}";
        if (consultationId === undefined || consultationId === null)
            throw new Error("The parameter 'consultationId' must be defined.");
        url_ = url_.replace("{consultationId}", encodeURIComponent("" + consultationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPatientConsultationAsIcsFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPatientConsultationAsIcsFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processGetPatientConsultationAsIcsFile(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the available insurance consultation dates.
     * @param doctorId (optional) The doctor identifier.
     * @param firstDayDate (optional) The first day date.
     * @return The available dates for insurance consultation
     */
    getAvailableInsuranceConsultationDates(doctorId?: number | null | undefined, firstDayDate?: Date | null | undefined): Observable<StatusValueResourceOfIEnumerableOfDateTime | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Consultation/GetAvailableInsuranceConsultationDates?";
        if (doctorId !== undefined && doctorId !== null)
            url_ += "doctorId=" + encodeURIComponent("" + doctorId) + "&";
        if (firstDayDate !== undefined && firstDayDate !== null)
            url_ += "firstDayDate=" + encodeURIComponent(firstDayDate ? "" + firstDayDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAvailableInsuranceConsultationDates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAvailableInsuranceConsultationDates(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StatusValueResourceOfIEnumerableOfDateTime | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StatusValueResourceOfIEnumerableOfDateTime | null>;
        }));
    }

    protected processGetAvailableInsuranceConsultationDates(response: HttpResponseBase): Observable<StatusValueResourceOfIEnumerableOfDateTime | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? StatusValueResourceOfIEnumerableOfDateTime.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the consultation alternative medicines.
     * @param consultationId The consultation identifier.
     * @return The ConsultationALternativeMedicines
     */
    getConsultationAlternativeMedicines(consultationId: number): Observable<ConsultationAlternativeMedicine[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Consultation/GetConsultationAlternativeMedicines/?consultationId={consultationId}";
        if (consultationId === undefined || consultationId === null)
            throw new Error("The parameter 'consultationId' must be defined.");
        url_ = url_.replace("{consultationId}", encodeURIComponent("" + consultationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConsultationAlternativeMedicines(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConsultationAlternativeMedicines(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConsultationAlternativeMedicine[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConsultationAlternativeMedicine[] | null>;
        }));
    }

    protected processGetConsultationAlternativeMedicines(response: HttpResponseBase): Observable<ConsultationAlternativeMedicine[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ConsultationAlternativeMedicine.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the doctor available dates by consultation configuration.
     * @param availabilityParam The availibility param.
     * @return The available dates for an insurance consultation of the provided config
     */
    getDoctorAvailableDatesByConsultationConfig(availabilityParam: AvailabilityParam | null): Observable<Date[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Consultation/GetDoctorAvailableDatesByConsultationConfig";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(availabilityParam);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDoctorAvailableDatesByConsultationConfig(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDoctorAvailableDatesByConsultationConfig(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Date[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Date[] | null>;
        }));
    }

    protected processGetDoctorAvailableDatesByConsultationConfig(response: HttpResponseBase): Observable<Date[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(new Date(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the consultation configuration.
     * @param id The identifier.
     * @return The requested consultation configuration
     */
    getConsultationConfig(id: number): Observable<ConsultationConfig | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Consultation/GetConsultationConfig/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConsultationConfig(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConsultationConfig(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConsultationConfig | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConsultationConfig | null>;
        }));
    }

    protected processGetConsultationConfig(response: HttpResponseBase): Observable<ConsultationConfig | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ConsultationConfig.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the consultation configuration for appointment tunnel.
     * @param id The identifier.
     * @return The requested consultation configuration for appointment tunnel
     */
    getConsultationConfigLiteForAppointmentTunnel(id: number): Observable<ConsultationConfigLite | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Consultation/GetConsultationConfigLiteForAppointmentTunnel/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConsultationConfigLiteForAppointmentTunnel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConsultationConfigLiteForAppointmentTunnel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConsultationConfigLite | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConsultationConfigLite | null>;
        }));
    }

    protected processGetConsultationConfigLiteForAppointmentTunnel(response: HttpResponseBase): Observable<ConsultationConfigLite | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ConsultationConfigLite.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the consultation notification.
     * @return the notifications for doctor.
     */
    getConsultationNotification(): Observable<Notification[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Consultation/GetConsultationNotification";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConsultationNotification(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConsultationNotification(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Notification[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Notification[] | null>;
        }));
    }

    protected processGetConsultationNotification(response: HttpResponseBase): Observable<Notification[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Notification.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the consultation types for dropdown.
     * @return The consultation types for dropdown.
     */
    getDropdownConsultationTypes(): Observable<DropdownValue[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Consultation/GetDropdownConsultationTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDropdownConsultationTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDropdownConsultationTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DropdownValue[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DropdownValue[] | null>;
        }));
    }

    protected processGetDropdownConsultationTypes(response: HttpResponseBase): Observable<DropdownValue[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DropdownValue.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets all the consultation configurations.
     * @return The requested consultation configurations.
     */
    getPopularConsultationTypesList(): Observable<DropdownValue[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Consultation/GetPopularConsultationTypesList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPopularConsultationTypesList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPopularConsultationTypesList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DropdownValue[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DropdownValue[] | null>;
        }));
    }

    protected processGetPopularConsultationTypesList(response: HttpResponseBase): Observable<DropdownValue[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DropdownValue.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the consultation configurations.
     * @param showFullName (optional) Whether to show the name with the subtype or not.
     * @return All the consultation configurations.
     */
    getConsultationConfigs(showFullName?: boolean | undefined): Observable<ConsultationConfig[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Consultation/GetConsultationConfigs?";
        if (showFullName === null)
            throw new Error("The parameter 'showFullName' cannot be null.");
        else if (showFullName !== undefined)
            url_ += "showFullName=" + encodeURIComponent("" + showFullName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConsultationConfigs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConsultationConfigs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConsultationConfig[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConsultationConfig[] | null>;
        }));
    }

    protected processGetConsultationConfigs(response: HttpResponseBase): Observable<ConsultationConfig[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ConsultationConfig.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the consultation configurations for dropdown.
     * @return All the consultation configurations for dropdown.
     */
    getConsultationConfigsForDropdown(): Observable<ConsultationConfig[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Consultation/GetConsultationConfigsForDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConsultationConfigsForDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConsultationConfigsForDropdown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConsultationConfig[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConsultationConfig[] | null>;
        }));
    }

    protected processGetConsultationConfigsForDropdown(response: HttpResponseBase): Observable<ConsultationConfig[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ConsultationConfig.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the consultation configurations for dropdown.
     * @return All the consultation configurations for dropdown.
     */
    getConsultationConfigsForDropdownRemote(): Observable<ConsultationConfig[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Consultation/GetConsultationConfigsForDropdownRemote";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConsultationConfigsForDropdownRemote(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConsultationConfigsForDropdownRemote(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConsultationConfig[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConsultationConfig[] | null>;
        }));
    }

    protected processGetConsultationConfigsForDropdownRemote(response: HttpResponseBase): Observable<ConsultationConfig[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ConsultationConfig.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the consultation configurations for dropdown by medical office.
     * @param medicalOfficeId The medical office identifier.
     * @return All the consultation configurations for dropdown by medical office.
     */
    getConsultationConfigsForDropdownByMedicalOffice(medicalOfficeId: number): Observable<ConsultationConfig[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Consultation/GetConsultationConfigsForDropdownByMedicalOffice/?medicalOfficeId={medicalOfficeId}";
        if (medicalOfficeId === undefined || medicalOfficeId === null)
            throw new Error("The parameter 'medicalOfficeId' must be defined.");
        url_ = url_.replace("{medicalOfficeId}", encodeURIComponent("" + medicalOfficeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConsultationConfigsForDropdownByMedicalOffice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConsultationConfigsForDropdownByMedicalOffice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConsultationConfig[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConsultationConfig[] | null>;
        }));
    }

    protected processGetConsultationConfigsForDropdownByMedicalOffice(response: HttpResponseBase): Observable<ConsultationConfig[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ConsultationConfig.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the consultation details.
     * @param consultationId The consultation identifier.
     * @return The consultation details.
     */
    getConsultationDetails(consultationId: number): Observable<StatusValueResourceOfConsultationDetails | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Consultation/GetConsultationDetails/?consultationId={consultationId}";
        if (consultationId === undefined || consultationId === null)
            throw new Error("The parameter 'consultationId' must be defined.");
        url_ = url_.replace("{consultationId}", encodeURIComponent("" + consultationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConsultationDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConsultationDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StatusValueResourceOfConsultationDetails | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StatusValueResourceOfConsultationDetails | null>;
        }));
    }

    protected processGetConsultationDetails(response: HttpResponseBase): Observable<StatusValueResourceOfConsultationDetails | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? StatusValueResourceOfConsultationDetails.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the consultation informations.
     * @param consultationId The consultation identifier.
     * @return The consultation informations.
     */
    getConsultationInformations(consultationId: number): Observable<ConsultationInformations | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Consultation/GetConsultationInformations/?consultationId={consultationId}";
        if (consultationId === undefined || consultationId === null)
            throw new Error("The parameter 'consultationId' must be defined.");
        url_ = url_.replace("{consultationId}", encodeURIComponent("" + consultationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConsultationInformations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConsultationInformations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConsultationInformations | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConsultationInformations | null>;
        }));
    }

    protected processGetConsultationInformations(response: HttpResponseBase): Observable<ConsultationInformations | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ConsultationInformations.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the consultation information for patient.
     * @param consultationId The consultation identifier.
     * @return the consultation information ofr patient
     */
    getConsultationInformationForPatient(consultationId: number): Observable<ConsultationInformationPatient | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Consultation/GetConsultationInformationForPatient/?consultationId={consultationId}";
        if (consultationId === undefined || consultationId === null)
            throw new Error("The parameter 'consultationId' must be defined.");
        url_ = url_.replace("{consultationId}", encodeURIComponent("" + consultationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConsultationInformationForPatient(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConsultationInformationForPatient(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConsultationInformationPatient | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConsultationInformationPatient | null>;
        }));
    }

    protected processGetConsultationInformationForPatient(response: HttpResponseBase): Observable<ConsultationInformationPatient | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ConsultationInformationPatient.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the consultation formulary.
     * @param consultationId The consultation identifier.
     * @param formularyId The formulary identifier.
     * @return The consultation formulary identified by the parameters
     */
    getConsultationFormulary(consultationId: number, formularyId: number): Observable<ConsultationFormulary | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Consultation/GetConsultationFormulary/?consultationId={consultationId}&formularyId={formularyId}";
        if (consultationId === undefined || consultationId === null)
            throw new Error("The parameter 'consultationId' must be defined.");
        url_ = url_.replace("{consultationId}", encodeURIComponent("" + consultationId));
        if (formularyId === undefined || formularyId === null)
            throw new Error("The parameter 'formularyId' must be defined.");
        url_ = url_.replace("{formularyId}", encodeURIComponent("" + formularyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConsultationFormulary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConsultationFormulary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConsultationFormulary | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConsultationFormulary | null>;
        }));
    }

    protected processGetConsultationFormulary(response: HttpResponseBase): Observable<ConsultationFormulary | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ConsultationFormulary.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the consultation formulary.
     * @param consultationId The consultation identifier.
     * @return The list of formulary linked to the consultation.
     */
    getConsultationFormularies(consultationId: number): Observable<ConsultationFormularyTitle[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Consultation/GetConsultationFormularies/?consultationId={consultationId}";
        if (consultationId === undefined || consultationId === null)
            throw new Error("The parameter 'consultationId' must be defined.");
        url_ = url_.replace("{consultationId}", encodeURIComponent("" + consultationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConsultationFormularies(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConsultationFormularies(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConsultationFormularyTitle[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConsultationFormularyTitle[] | null>;
        }));
    }

    protected processGetConsultationFormularies(response: HttpResponseBase): Observable<ConsultationFormularyTitle[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ConsultationFormularyTitle.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the medical history.
     * @param id The medical history identifier.
     * @return The wanted medical history
     */
    getConsultationReason(id: number): Observable<ConsultationReason | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Consultation/GetConsultationReason/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConsultationReason(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConsultationReason(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConsultationReason | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConsultationReason | null>;
        }));
    }

    protected processGetConsultationReason(response: HttpResponseBase): Observable<ConsultationReason | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ConsultationReason.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the medical history.
     * @param id The medical history identifier.
     * @return The wanted medical history
     */
    getConsultationReasonDetail(id: number): Observable<ConsultationReasonDetails | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Consultation/GetConsultationReasonDetail/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConsultationReasonDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConsultationReasonDetail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConsultationReasonDetails | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConsultationReasonDetails | null>;
        }));
    }

    protected processGetConsultationReasonDetail(response: HttpResponseBase): Observable<ConsultationReasonDetails | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ConsultationReasonDetails.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the consultation reasons.
     * @return the consultation reasons.
     */
    getConsultationReasonsBackoffice(): Observable<ConsultationReason[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Consultation/GetConsultationReasonsBackoffice";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConsultationReasonsBackoffice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConsultationReasonsBackoffice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConsultationReason[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConsultationReason[] | null>;
        }));
    }

    protected processGetConsultationReasonsBackoffice(response: HttpResponseBase): Observable<ConsultationReason[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ConsultationReason.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the consultation reasons.
     * @return the consultation reasons.
     */
    getConsultationReasons(): Observable<ConsultationReason[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Consultation/GetConsultationReasons";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConsultationReasons(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConsultationReasons(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConsultationReason[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConsultationReason[] | null>;
        }));
    }

    protected processGetConsultationReasons(response: HttpResponseBase): Observable<ConsultationReason[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ConsultationReason.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the consultationreasons for drop down.
     * @return The consultation reasons mapped for dropdowns
     */
    getConsultationReasonsForDropdown(): Observable<DropdownValue[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Consultation/GetConsultationReasonsForDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConsultationReasonsForDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConsultationReasonsForDropdown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DropdownValue[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DropdownValue[] | null>;
        }));
    }

    protected processGetConsultationReasonsForDropdown(response: HttpResponseBase): Observable<DropdownValue[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DropdownValue.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the type of the consultation patient consultation.
     * @param searchParam The search parameter.
     * @return The ConsultationConsultationtype for a patient.
     */
    getConsultationPatientConsultationType(searchParam: SearchParamConsultationSuggestible | null): Observable<ConsultationConsultationTypeTitle[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Consultation/GetConsultationPatientConsultationType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchParam);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConsultationPatientConsultationType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConsultationPatientConsultationType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConsultationConsultationTypeTitle[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConsultationConsultationTypeTitle[] | null>;
        }));
    }

    protected processGetConsultationPatientConsultationType(response: HttpResponseBase): Observable<ConsultationConsultationTypeTitle[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ConsultationConsultationTypeTitle.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the consultation patient suggestions.
     * @param searchParam The search parameter.
     * @return The list of the patient consultation suggestions.
     */
    getConsultationPatientSuggestions(searchParam: SearchParamConsultationSuggestibleSuggestion | null): Observable<ConsultationSuggestionTitle[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Consultation/GetConsultationPatientSuggestions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchParam);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConsultationPatientSuggestions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConsultationPatientSuggestions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConsultationSuggestionTitle[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConsultationSuggestionTitle[] | null>;
        }));
    }

    protected processGetConsultationPatientSuggestions(response: HttpResponseBase): Observable<ConsultationSuggestionTitle[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ConsultationSuggestionTitle.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the consultation patient activity.
     * @param searchParam The search parameter.
     * @return The list of the consultationpatient activity.
     */
    getConsultationPatientActivity(searchParam: SearchParamConsultationSuggestible | null): Observable<ConsultationActivityTitle[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Consultation/GetConsultationPatientActivity";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchParam);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConsultationPatientActivity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConsultationPatientActivity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConsultationActivityTitle[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConsultationActivityTitle[] | null>;
        }));
    }

    protected processGetConsultationPatientActivity(response: HttpResponseBase): Observable<ConsultationActivityTitle[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ConsultationActivityTitle.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the consultation patient recipe.
     * @param searchParam The search parameter.
     * @return The list of the consultation patient recipe.
     */
    getConsultationPatientRecipe(searchParam: SearchParamConsultationSuggestible | null): Observable<ConsultationRecipeTitle[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Consultation/GetConsultationPatientRecipe";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchParam);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConsultationPatientRecipe(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConsultationPatientRecipe(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConsultationRecipeTitle[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConsultationRecipeTitle[] | null>;
        }));
    }

    protected processGetConsultationPatientRecipe(response: HttpResponseBase): Observable<ConsultationRecipeTitle[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ConsultationRecipeTitle.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the consultation patient biological exam.
     * @param searchParam The search parameter.
     * @return The list of biological exams (ordered by set) added to the consultation.
     */
    getConsultationPatientBiologicalExam(searchParam: SearchParamConsultationSuggestible | null): Observable<ConsultationBiologicalExamTitleBySet[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Consultation/GetConsultationPatientBiologicalExam";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchParam);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConsultationPatientBiologicalExam(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConsultationPatientBiologicalExam(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConsultationBiologicalExamTitleBySet[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConsultationBiologicalExamTitleBySet[] | null>;
        }));
    }

    protected processGetConsultationPatientBiologicalExam(response: HttpResponseBase): Observable<ConsultationBiologicalExamTitleBySet[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ConsultationBiologicalExamTitleBySet.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the consultation patient complementary exam.
     * @param searchParam The search parameter.
     * @return La list des examens complementaire à suggerer pour une consultation.
     */
    getConsultationPatientComplementaryExam(searchParam: SearchParamConsultationSuggestible | null): Observable<ConsultationComplementaryExamTitle[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Consultation/GetConsultationPatientComplementaryExam";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchParam);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConsultationPatientComplementaryExam(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConsultationPatientComplementaryExam(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConsultationComplementaryExamTitle[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConsultationComplementaryExamTitle[] | null>;
        }));
    }

    protected processGetConsultationPatientComplementaryExam(response: HttpResponseBase): Observable<ConsultationComplementaryExamTitle[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ConsultationComplementaryExamTitle.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the consultation patient formularies.
     * @param searchParam The search parameter.
     * @return The consultation Formularies.
     */
    getConsultationPatientFormularies(searchParam: SearchParamConsultationSuggestible | null): Observable<ConsultationFormularyTitle[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Consultation/GetConsultationPatientFormularies";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchParam);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConsultationPatientFormularies(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConsultationPatientFormularies(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConsultationFormularyTitle[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConsultationFormularyTitle[] | null>;
        }));
    }

    protected processGetConsultationPatientFormularies(response: HttpResponseBase): Observable<ConsultationFormularyTitle[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ConsultationFormularyTitle.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the consultation patient nutrient.
     * @param searchParam The search parameter.
     * @return the nutriment with information in the consultation.
     */
    getConsultationPatientNutrient(searchParam: SearchParamConsultationSuggestible | null): Observable<ConsultationSuggestibleTitle[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Consultation/GetConsultationPatientNutrient";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchParam);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConsultationPatientNutrient(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConsultationPatientNutrient(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConsultationSuggestibleTitle[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConsultationSuggestibleTitle[] | null>;
        }));
    }

    protected processGetConsultationPatientNutrient(response: HttpResponseBase): Observable<ConsultationSuggestibleTitle[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ConsultationSuggestibleTitle.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ReferenceDataRepository {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Gets all diplomas.
     * @return All diplomas.
     */
    getAllDiplomas(): Observable<Diploma[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/ReferenceData/GetAllDiplomas";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllDiplomas(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllDiplomas(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Diploma[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Diploma[] | null>;
        }));
    }

    protected processGetAllDiplomas(response: HttpResponseBase): Observable<Diploma[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Diploma.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the allergens.
     * @return The list of allergens
     */
    getAllergens(): Observable<DataStoreResource[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/ReferenceData/GetAllergens";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllergens(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllergens(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DataStoreResource[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DataStoreResource[] | null>;
        }));
    }

    protected processGetAllergens(response: HttpResponseBase): Observable<DataStoreResource[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DataStoreResource.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the coaching types.
     * @return The list of available coaching types.
     */
    getCoachingTypes(): Observable<DataStoreResource[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/ReferenceData/GetCoachingTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCoachingTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCoachingTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DataStoreResource[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DataStoreResource[] | null>;
        }));
    }

    protected processGetCoachingTypes(response: HttpResponseBase): Observable<DataStoreResource[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DataStoreResource.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the coaching types details.
     * @return The list of available coaching types details.
     */
    getCoachingTypesDetails(): Observable<CoachingTypeDetails[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/ReferenceData/GetCoachingTypesDetails";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCoachingTypesDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCoachingTypesDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CoachingTypeDetails[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CoachingTypeDetails[] | null>;
        }));
    }

    protected processGetCoachingTypesDetails(response: HttpResponseBase): Observable<CoachingTypeDetails[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CoachingTypeDetails.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the consultation means of payment.
     * @return The list of available consultation means of payment.
     */
    getConsultationMeansOfPayments(): Observable<DataStoreResource[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/ReferenceData/GetConsultationMeansOfPayments";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConsultationMeansOfPayments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConsultationMeansOfPayments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DataStoreResource[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DataStoreResource[] | null>;
        }));
    }

    protected processGetConsultationMeansOfPayments(response: HttpResponseBase): Observable<DataStoreResource[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DataStoreResource.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the refund methods for dropdown.
     * @return The refund methods for dropdown.
     */
    getDropdownRefundMethods(): Observable<DropdownValue[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/ReferenceData/GetDropdownRefundMethods";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDropdownRefundMethods(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDropdownRefundMethods(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DropdownValue[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DropdownValue[] | null>;
        }));
    }

    protected processGetDropdownRefundMethods(response: HttpResponseBase): Observable<DropdownValue[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DropdownValue.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the availabilities for dropdown.
     * @return The availabilities for dropdown.
     */
    getDropdownsAvailabilities(): Observable<DropdownValueWithTechnical[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/ReferenceData/GetDropdownsAvailabilities";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDropdownsAvailabilities(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDropdownsAvailabilities(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DropdownValueWithTechnical[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DropdownValueWithTechnical[] | null>;
        }));
    }

    protected processGetDropdownsAvailabilities(response: HttpResponseBase): Observable<DropdownValueWithTechnical[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DropdownValueWithTechnical.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the dietary plans.
     * @return The list of dietary plans
     */
    getDietaryPlans(): Observable<DataStoreResource[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/ReferenceData/GetDietaryPlans";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDietaryPlans(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDietaryPlans(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DataStoreResource[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DataStoreResource[] | null>;
        }));
    }

    protected processGetDietaryPlans(response: HttpResponseBase): Observable<DataStoreResource[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DataStoreResource.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the dish types.
     * @return The list of dish types
     */
    getDishTypes(): Observable<DataStoreResource[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/ReferenceData/GetDishTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDishTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDishTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DataStoreResource[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DataStoreResource[] | null>;
        }));
    }

    protected processGetDishTypes(response: HttpResponseBase): Observable<DataStoreResource[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DataStoreResource.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the document types.
     * @return the document types.
     */
    getDocumentTypes(): Observable<DataStoreResource[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/ReferenceData/GetDocumentTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDocumentTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDocumentTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DataStoreResource[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DataStoreResource[] | null>;
        }));
    }

    protected processGetDocumentTypes(response: HttpResponseBase): Observable<DataStoreResource[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DataStoreResource.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the DPC sessions.
     * @return The list of available DPC sessions stored in Umbraco.
     */
    getDpcSessions(): Observable<DataStoreResource[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/ReferenceData/GetDpcSessions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDpcSessions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDpcSessions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DataStoreResource[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DataStoreResource[] | null>;
        }));
    }

    protected processGetDpcSessions(response: HttpResponseBase): Observable<DataStoreResource[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DataStoreResource.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the DPC theme details.
     * @return The list of available DPC themes with details.
     */
    getDpcThemeDetails(): Observable<DpcThemeDetails[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/ReferenceData/GetDpcThemeDetails";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDpcThemeDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDpcThemeDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DpcThemeDetails[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DpcThemeDetails[] | null>;
        }));
    }

    protected processGetDpcThemeDetails(response: HttpResponseBase): Observable<DpcThemeDetails[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DpcThemeDetails.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the DPC themes.
     * @return The list of available DPC themes stored in Umbraco.
     */
    getDpcThemes(): Observable<DataStoreResource[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/ReferenceData/GetDpcThemes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDpcThemes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDpcThemes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DataStoreResource[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DataStoreResource[] | null>;
        }));
    }

    protected processGetDpcThemes(response: HttpResponseBase): Observable<DataStoreResource[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DataStoreResource.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the eco responsabilities.
     * @return The list of eco-responsabilities
     */
    getEcoResponsabilities(): Observable<DataStoreResource[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/ReferenceData/GetEcoResponsabilities";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEcoResponsabilities(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEcoResponsabilities(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DataStoreResource[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DataStoreResource[] | null>;
        }));
    }

    protected processGetEcoResponsabilities(response: HttpResponseBase): Observable<DataStoreResource[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DataStoreResource.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the facilities
     * @return The list of facilities
     */
    getFacilities(): Observable<DataStoreResource[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/ReferenceData/GetFacilities";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFacilities(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFacilities(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DataStoreResource[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DataStoreResource[] | null>;
        }));
    }

    protected processGetFacilities(response: HttpResponseBase): Observable<DataStoreResource[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DataStoreResource.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the formulary questions categories.
     * @return The formulary questions categories.
     */
    getFormularyQuestionsCategories(): Observable<DataStoreResource[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/ReferenceData/GetFormularyQuestionsCategories";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFormularyQuestionsCategories(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFormularyQuestionsCategories(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DataStoreResource[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DataStoreResource[] | null>;
        }));
    }

    protected processGetFormularyQuestionsCategories(response: HttpResponseBase): Observable<DataStoreResource[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DataStoreResource.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the formulary questions categories details.
     * @return The formulary questions categories details.
     */
    getFormularyQuestionsCategoriesDetails(): Observable<ConsultInQuestionCategory[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/ReferenceData/GetFormularyQuestionsCategoriesDetails";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFormularyQuestionsCategoriesDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFormularyQuestionsCategoriesDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConsultInQuestionCategory[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConsultInQuestionCategory[] | null>;
        }));
    }

    protected processGetFormularyQuestionsCategoriesDetails(response: HttpResponseBase): Observable<ConsultInQuestionCategory[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ConsultInQuestionCategory.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the formulary survey types.
     * @return The list of available survey types
     */
    getFormularySurveyTypes(): Observable<DataStoreResource[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/ReferenceData/GetFormularySurveyTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFormularySurveyTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFormularySurveyTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DataStoreResource[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DataStoreResource[] | null>;
        }));
    }

    protected processGetFormularySurveyTypes(response: HttpResponseBase): Observable<DataStoreResource[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DataStoreResource.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the formulary trouble spheres.
     * @return The list of available trouble spheres
     */
    getFormularyTroubleSpheres(): Observable<DataStoreResource[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/ReferenceData/GetFormularyTroubleSpheres";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFormularyTroubleSpheres(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFormularyTroubleSpheres(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DataStoreResource[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DataStoreResource[] | null>;
        }));
    }

    protected processGetFormularyTroubleSpheres(response: HttpResponseBase): Observable<DataStoreResource[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DataStoreResource.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the means of payments.
     * @return The list of available means of payments.
     */
    getMeansOfPayments(): Observable<DataStoreResource[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/ReferenceData/GetMeansOfPayments";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMeansOfPayments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMeansOfPayments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DataStoreResource[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DataStoreResource[] | null>;
        }));
    }

    protected processGetMeansOfPayments(response: HttpResponseBase): Observable<DataStoreResource[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DataStoreResource.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the languages.
     * @return all the spoken languages.
     */
    getLanguages(): Observable<DataStoreResource[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/ReferenceData/GetLanguages";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLanguages(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLanguages(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DataStoreResource[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DataStoreResource[] | null>;
        }));
    }

    protected processGetLanguages(response: HttpResponseBase): Observable<DataStoreResource[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DataStoreResource.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the physiopathological hypotheses.
     * @return the physiopathological hypotheses
     */
    getPhysiopathologicalHypotheses(): Observable<PhysiopathologicalHypothesis[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/ReferenceData/GetPhysiopathologicalHypotheses";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPhysiopathologicalHypotheses(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPhysiopathologicalHypotheses(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PhysiopathologicalHypothesis[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PhysiopathologicalHypothesis[] | null>;
        }));
    }

    protected processGetPhysiopathologicalHypotheses(response: HttpResponseBase): Observable<PhysiopathologicalHypothesis[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PhysiopathologicalHypothesis.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the physiopathological hypothesis categories.
     * @return the physiopathological hypothesis categories
     */
    getPhysiopathologicalHypothesisCategories(): Observable<DataStoreResource[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/ReferenceData/GetPhysiopathologicalHypothesisCategories";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPhysiopathologicalHypothesisCategories(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPhysiopathologicalHypothesisCategories(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DataStoreResource[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DataStoreResource[] | null>;
        }));
    }

    protected processGetPhysiopathologicalHypothesisCategories(response: HttpResponseBase): Observable<DataStoreResource[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DataStoreResource.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets product types.
     * @return The list of available product types.
     */
    getProductTypes(): Observable<DataStoreResource[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/ReferenceData/GetProductTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProductTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DataStoreResource[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DataStoreResource[] | null>;
        }));
    }

    protected processGetProductTypes(response: HttpResponseBase): Observable<DataStoreResource[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DataStoreResource.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the professions.
     * @return The list of profession in Umbraco.
     */
    getProfessions(): Observable<DataStoreResource[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/ReferenceData/GetProfessions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProfessions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProfessions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DataStoreResource[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DataStoreResource[] | null>;
        }));
    }

    protected processGetProfessions(response: HttpResponseBase): Observable<DataStoreResource[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DataStoreResource.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the professions for the web site.
     * @param nationalityIso3 (optional) The nationality iso 3.
     * @return The professions for the web site.
     */
    getProfessionsWebSite(nationalityIso3?: string | null | undefined): Observable<ProfessionsWithOtherProfessionId | null> {
        let url_ = this.baseUrl + "/umbraco/Api/ReferenceData/GetProfessionsWebSite?";
        if (nationalityIso3 !== undefined && nationalityIso3 !== null)
            url_ += "nationalityIso3=" + encodeURIComponent("" + nationalityIso3) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProfessionsWebSite(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProfessionsWebSite(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProfessionsWithOtherProfessionId | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProfessionsWithOtherProfessionId | null>;
        }));
    }

    protected processGetProfessionsWebSite(response: HttpResponseBase): Observable<ProfessionsWithOtherProfessionId | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ProfessionsWithOtherProfessionId.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the specialities for the web site.
     * @return The specialities for the web site.
     */
    getSpecialitiesWebSite(): Observable<DataStoreResource[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/ReferenceData/GetSpecialitiesWebSite";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSpecialitiesWebSite(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSpecialitiesWebSite(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DataStoreResource[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DataStoreResource[] | null>;
        }));
    }

    protected processGetSpecialitiesWebSite(response: HttpResponseBase): Observable<DataStoreResource[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DataStoreResource.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the seasons.
     * @return The list of seasons
     */
    getSeasons(): Observable<DataStoreResource[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/ReferenceData/GetSeasons";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSeasons(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSeasons(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DataStoreResource[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DataStoreResource[] | null>;
        }));
    }

    protected processGetSeasons(response: HttpResponseBase): Observable<DataStoreResource[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DataStoreResource.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the specialization.
     * @return The list of specializations in Umbraco.
     */
    getSpecializations(): Observable<DataStoreResource[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/ReferenceData/GetSpecializations";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSpecializations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSpecializations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DataStoreResource[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DataStoreResource[] | null>;
        }));
    }

    protected processGetSpecializations(response: HttpResponseBase): Observable<DataStoreResource[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DataStoreResource.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the subvention organisation details.
     * @param subventionOrganisationId The subvention organisation identifier.
     * @return The details of an subvention organisation
     */
    getSubventionOrganisationDetails(subventionOrganisationId: number): Observable<SubventionOrganization | null> {
        let url_ = this.baseUrl + "/umbraco/Api/ReferenceData/GetSubventionOrganisationDetails/?subventionOrganisationId={subventionOrganisationId}";
        if (subventionOrganisationId === undefined || subventionOrganisationId === null)
            throw new Error("The parameter 'subventionOrganisationId' must be defined.");
        url_ = url_.replace("{subventionOrganisationId}", encodeURIComponent("" + subventionOrganisationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSubventionOrganisationDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSubventionOrganisationDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SubventionOrganization | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SubventionOrganization | null>;
        }));
    }

    protected processGetSubventionOrganisationDetails(response: HttpResponseBase): Observable<SubventionOrganization | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SubventionOrganization.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the subvention organizations.
     * @return The list of available subvention organizations in Umbraco.
     */
    getSubventionOrganizations(): Observable<DataStoreResource[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/ReferenceData/GetSubventionOrganizations";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSubventionOrganizations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSubventionOrganizations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DataStoreResource[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DataStoreResource[] | null>;
        }));
    }

    protected processGetSubventionOrganizations(response: HttpResponseBase): Observable<DataStoreResource[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DataStoreResource.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets suggestion types.
     * @return The list of available suggestion types.
     */
    getSuggestionTypes(): Observable<DataStoreResource[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/ReferenceData/GetSuggestionTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSuggestionTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSuggestionTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DataStoreResource[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DataStoreResource[] | null>;
        }));
    }

    protected processGetSuggestionTypes(response: HttpResponseBase): Observable<DataStoreResource[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DataStoreResource.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets suggestion types.
     * @return The list of available suggestion types with details.
     */
    getSuggestionTypesDetails(): Observable<SuggestionTypeDetails[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/ReferenceData/GetSuggestionTypesDetails";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSuggestionTypesDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSuggestionTypesDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SuggestionTypeDetails[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SuggestionTypeDetails[] | null>;
        }));
    }

    protected processGetSuggestionTypesDetails(response: HttpResponseBase): Observable<SuggestionTypeDetails[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SuggestionTypeDetails.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the zoom types.
     * @return The zoom types
     */
    getZoomTypes(): Observable<DataStoreResource[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/ReferenceData/GetZoomTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetZoomTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetZoomTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DataStoreResource[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DataStoreResource[] | null>;
        }));
    }

    protected processGetZoomTypes(response: HttpResponseBase): Observable<DataStoreResource[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DataStoreResource.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the zoom types.
     * @return The zoom types
     */
    getDocumentTemplates(): Observable<DocumentTemplateLite[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/ReferenceData/GetDocumentTemplates";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDocumentTemplates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDocumentTemplates(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentTemplateLite[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentTemplateLite[] | null>;
        }));
    }

    protected processGetDocumentTemplates(response: HttpResponseBase): Observable<DocumentTemplateLite[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DocumentTemplateLite.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the zoom types.
     * @param technicalId The technical id.
     * @return The zoom types
     */
    getDocument(technicalId: string): Observable<DocumentTemplate | null> {
        let url_ = this.baseUrl + "/umbraco/Api/ReferenceData/GetDocument/?technicalId={technicalId}";
        if (technicalId === undefined || technicalId === null)
            throw new Error("The parameter 'technicalId' must be defined.");
        url_ = url_.replace("{technicalId}", encodeURIComponent("" + technicalId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDocument(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentTemplate | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentTemplate | null>;
        }));
    }

    protected processGetDocument(response: HttpResponseBase): Observable<DocumentTemplate | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? DocumentTemplate.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the pronutriconsult subscription levels.
     * @return The pronutriconsult subscription levels.
     */
    getProNutriConsultSubscriptionLevels(): Observable<DataStoreResource[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/ReferenceData/GetProNutriConsultSubscriptionLevels";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProNutriConsultSubscriptionLevels(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProNutriConsultSubscriptionLevels(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DataStoreResource[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DataStoreResource[] | null>;
        }));
    }

    protected processGetProNutriConsultSubscriptionLevels(response: HttpResponseBase): Observable<DataStoreResource[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DataStoreResource.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the zoom types.
     * @return The zoom types
     */
    getTests(): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/ReferenceData/GetTests";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTests(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTests(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGetTests(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SuggestionRepository {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Creates the custom suggestion.
     * @param suggestion The suggestion.
     * @return The id of the created suggestion.
     */
    createCustomSuggestion(suggestion: CreateCustomSuggestion | null): Observable<number> {
        let url_ = this.baseUrl + "/umbraco/Api/Suggestion/CreateCustomSuggestion";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(suggestion);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateCustomSuggestion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateCustomSuggestion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateCustomSuggestion(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Creates the suggestion.
     * @param suggestion The suggestion.
     * @return The id of the created suggestion.
     */
    createSuggestion(suggestion: CreateSuggestion | null): Observable<number> {
        let url_ = this.baseUrl + "/umbraco/Api/Suggestion/CreateSuggestion";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(suggestion);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateSuggestion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateSuggestion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateSuggestion(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Creates the zoom section asynchronous.
     * @param zoomSection The zoom section.
     * @return the identifier of the newly created zoom section
     */
    createZoomSection(zoomSection: ZoomSection | null): Observable<number> {
        let url_ = this.baseUrl + "/umbraco/Api/Suggestion/CreateZoomSection";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(zoomSection);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateZoomSection(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateZoomSection(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateZoomSection(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Deletes the custom zoom image asynchronous.
     * @param zoomSectionId The zoom section identifier.
     * @return An asynchronous operation
     */
    deleteCustomZoomImage(zoomSectionId: number): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/Suggestion/DeleteCustomZoomImage/?zoomSectionId={zoomSectionId}";
        if (zoomSectionId === undefined || zoomSectionId === null)
            throw new Error("The parameter 'zoomSectionId' must be defined.");
        url_ = url_.replace("{zoomSectionId}", encodeURIComponent("" + zoomSectionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteCustomZoomImage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteCustomZoomImage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteCustomZoomImage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Deletes the suggestion.
     * @param id The identifier.
     * @return The task.
     */
    deleteSuggestion(id: number): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/Suggestion/DeleteSuggestion/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteSuggestion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteSuggestion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteSuggestion(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Deletes the suggestion banner asynchronous.
     * @param id The identifier.
     * @return The task.
     */
    deleteSuggestionBanner(id: number): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/Suggestion/DeleteSuggestionBanner/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteSuggestionBanner(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteSuggestionBanner(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteSuggestionBanner(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Deletes the file.
     * @param id The identifier.
     * @return The task.
     */
    deleteSuggestionMedia(id: number): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/Suggestion/DeleteSuggestionMedia/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteSuggestionMedia(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteSuggestionMedia(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteSuggestionMedia(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Deletes the zoom section asynchronous.
     * @param zoomSectionId The zoom section identifier.
     * @return An asynchronous operation
     */
    deleteZoomSection(zoomSectionId: number): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/Suggestion/DeleteZoomSection/?zoomSectionId={zoomSectionId}";
        if (zoomSectionId === undefined || zoomSectionId === null)
            throw new Error("The parameter 'zoomSectionId' must be defined.");
        url_ = url_.replace("{zoomSectionId}", encodeURIComponent("" + zoomSectionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteZoomSection(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteZoomSection(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteZoomSection(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Exports the suggestion for doctor asynchronous.
     * @param suggestionId The suggestion identifier.
     * @return An asynchronous operation
     */
    exportSuggestionForDoctor(suggestionId: number): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Suggestion/ExportSuggestionForDoctor/?suggestionId={suggestionId}";
        if (suggestionId === undefined || suggestionId === null)
            throw new Error("The parameter 'suggestionId' must be defined.");
        url_ = url_.replace("{suggestionId}", encodeURIComponent("" + suggestionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportSuggestionForDoctor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportSuggestionForDoctor(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processExportSuggestionForDoctor(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Exports the suggestion.
     * @param suggestionId The suggestion identifier.
     * @return The pdf file
     */
    exportSuggestionForPatient(suggestionId: number): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Suggestion/ExportSuggestionForPatient/?suggestionId={suggestionId}";
        if (suggestionId === undefined || suggestionId === null)
            throw new Error("The parameter 'suggestionId' must be defined.");
        url_ = url_.replace("{suggestionId}", encodeURIComponent("" + suggestionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportSuggestionForPatient(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportSuggestionForPatient(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processExportSuggestionForPatient(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the suggestion.
     * @param id The identifier.
     * @return The desired suggestion
     */
    getSuggestion(id: number): Observable<SuggestionDetails | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Suggestion/GetSuggestion/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSuggestion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSuggestion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SuggestionDetails | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SuggestionDetails | null>;
        }));
    }

    protected processGetSuggestion(response: HttpResponseBase): Observable<SuggestionDetails | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SuggestionDetails.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the suggestions.
     * @param searchParams The search parameters.
     * @return All suggestions
     */
    getSiinSuggestions(searchParams: SuggestionSearchParams | null): Observable<Suggestion[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Suggestion/GetSiinSuggestions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchParams);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSiinSuggestions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSiinSuggestions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Suggestion[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Suggestion[] | null>;
        }));
    }

    protected processGetSiinSuggestions(response: HttpResponseBase): Observable<Suggestion[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Suggestion.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the suggestions for library.
     * @param searchParams The search parameters.
     * @return The suggestions for library.
     */
    getSuggestionsForLibrary(searchParams: SuggestionLibrarySearchParams | null): Observable<PaginatorWrapperOfIEnumerableOfSuggestionWithWarnings | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Suggestion/GetSuggestionsForLibrary";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchParams);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSuggestionsForLibrary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSuggestionsForLibrary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaginatorWrapperOfIEnumerableOfSuggestionWithWarnings | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaginatorWrapperOfIEnumerableOfSuggestionWithWarnings | null>;
        }));
    }

    protected processGetSuggestionsForLibrary(response: HttpResponseBase): Observable<PaginatorWrapperOfIEnumerableOfSuggestionWithWarnings | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PaginatorWrapperOfIEnumerableOfSuggestionWithWarnings.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the siin suggestion dropdown values.
     * @return The siin suggestion dropdown values.
     */
    getSiinSuggestionDropdownValues(): Observable<DropdownValue[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Suggestion/GetSiinSuggestionDropdownValues";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSiinSuggestionDropdownValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSiinSuggestionDropdownValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DropdownValue[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DropdownValue[] | null>;
        }));
    }

    protected processGetSiinSuggestionDropdownValues(response: HttpResponseBase): Observable<DropdownValue[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DropdownValue.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the type of the siin suggestion dropdown values by public.
     * @param suggestionPublicType Type of the suggestion public.
     * @return The siin suggestion dropdown values.
     */
    getSiinSuggestionDropdownValuesByPublicType(suggestionPublicType: SuggestionPublicType): Observable<DropdownValue[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Suggestion/GetSiinSuggestionDropdownValuesByPublicType/?suggestionPublicType={suggestionPublicType}";
        if (suggestionPublicType === undefined || suggestionPublicType === null)
            throw new Error("The parameter 'suggestionPublicType' must be defined.");
        url_ = url_.replace("{suggestionPublicType}", encodeURIComponent("" + suggestionPublicType));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSiinSuggestionDropdownValuesByPublicType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSiinSuggestionDropdownValuesByPublicType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DropdownValue[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DropdownValue[] | null>;
        }));
    }

    protected processGetSiinSuggestionDropdownValuesByPublicType(response: HttpResponseBase): Observable<DropdownValue[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DropdownValue.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the suggestion dropdown values.
     * @return The suggestion dropdown values.
     */
    getSuggestionsDropdownValues(): Observable<SelectItemOfLiteSuggestion[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Suggestion/GetSuggestionsDropdownValues";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSuggestionsDropdownValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSuggestionsDropdownValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SelectItemOfLiteSuggestion[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SelectItemOfLiteSuggestion[] | null>;
        }));
    }

    protected processGetSuggestionsDropdownValues(response: HttpResponseBase): Observable<SelectItemOfLiteSuggestion[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectItemOfLiteSuggestion.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the zoom section asynchronous.
     * @param zoomSectionId The zoom section identifier.
     * @return The requested zoom section
     */
    getZoomSection(zoomSectionId: number): Observable<ZoomSection | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Suggestion/GetZoomSection/?zoomSectionId={zoomSectionId}";
        if (zoomSectionId === undefined || zoomSectionId === null)
            throw new Error("The parameter 'zoomSectionId' must be defined.");
        url_ = url_.replace("{zoomSectionId}", encodeURIComponent("" + zoomSectionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetZoomSection(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetZoomSection(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ZoomSection | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ZoomSection | null>;
        }));
    }

    protected processGetZoomSection(response: HttpResponseBase): Observable<ZoomSection | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ZoomSection.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the zoom section dropdown values.
     * @return The zoom section dropdown values
     */
    getZoomSectionDropdownValues(): Observable<DropdownValue[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Suggestion/GetZoomSectionDropdownValues";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetZoomSectionDropdownValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetZoomSectionDropdownValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DropdownValue[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DropdownValue[] | null>;
        }));
    }

    protected processGetZoomSectionDropdownValues(response: HttpResponseBase): Observable<DropdownValue[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DropdownValue.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the zoom sections.
     * @param searchParams The search parameters.
     * @return The zoom sections
     */
    getZoomSections(searchParams: ZoomSectionSearchParams | null): Observable<ZoomSectionLite[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Suggestion/GetZoomSections";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchParams);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetZoomSections(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetZoomSections(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ZoomSectionLite[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ZoomSectionLite[] | null>;
        }));
    }

    protected processGetZoomSections(response: HttpResponseBase): Observable<ZoomSectionLite[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ZoomSectionLite.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Marks as read by patient.
     * @param suggestionId The suggestion identifier.
     */
    markAsReadByPatient(suggestionId: number): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/Suggestion/MarkAsReadByPatient/?suggestionId={suggestionId}";
        if (suggestionId === undefined || suggestionId === null)
            throw new Error("The parameter 'suggestionId' must be defined.");
        url_ = url_.replace("{suggestionId}", encodeURIComponent("" + suggestionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMarkAsReadByPatient(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarkAsReadByPatient(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processMarkAsReadByPatient(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Patients the get suggestion asynchronous.
     * @param id The identifier.
     * @return The requested suggestion details
     */
    getPatientSuggestion(id: number): Observable<SuggestionDetails | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Suggestion/GetPatientSuggestion/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPatientSuggestion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPatientSuggestion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SuggestionDetails | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SuggestionDetails | null>;
        }));
    }

    protected processGetPatientSuggestion(response: HttpResponseBase): Observable<SuggestionDetails | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SuggestionDetails.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates the custom suggestion asynchronous.
     * @param suggestion The suggestion.
     * @return The task.
     */
    updateCustomSuggestion(suggestion: UpdateCustomSuggestion | null): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/Suggestion/UpdateCustomSuggestion";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(suggestion);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCustomSuggestion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCustomSuggestion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateCustomSuggestion(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates the specified suggestion
     * @param suggestion The suggestion.
     * @return The task.
     */
    updateSuggestion(suggestion: UpdateSuggestion | null): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/Suggestion/UpdateSuggestion";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(suggestion);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateSuggestion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateSuggestion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateSuggestion(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates the suggestion status.
     * @param id The identifier.
     * @param status The status.
     */
    updateSuggestionStatus(id: number, status: StatusSuggestion): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/Suggestion/UpdateSuggestionStatus/{id}?status={status}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (status === undefined || status === null)
            throw new Error("The parameter 'status' must be defined.");
        url_ = url_.replace("{status}", encodeURIComponent("" + status));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateSuggestionStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateSuggestionStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateSuggestionStatus(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates the zoom section asynchronous.
     * @param zoomSection The zoom section.
     * @return An asynchronous operation
     */
    updateZoomSection(zoomSection: ZoomSection | null): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/Suggestion/UpdateZoomSection";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(zoomSection);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateZoomSection(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateZoomSection(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateZoomSection(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates the zoom status.
     * @param id The identifier.
     * @param status if set to true [status].
     */
    updateZoomStatus(id: number, status: boolean): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/Suggestion/UpdateZoomStatus/{id}?status={status}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (status === undefined || status === null)
            throw new Error("The parameter 'status' must be defined.");
        url_ = url_.replace("{status}", encodeURIComponent("" + status));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateZoomStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateZoomStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateZoomStatus(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class DocumentRepository {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * The doctor create a document asynchronous.
     * @param documentCreation The document creation.
     * @return An asynchronous operation.
     */
    createDoctorDocument(documentCreation: DoctorDocumentCreation | null): Observable<number> {
        let url_ = this.baseUrl + "/umbraco/Api/Document/CreateDoctorDocumentAsync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(documentCreation);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateDoctorDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateDoctorDocument(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateDoctorDocument(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Adds saved doctor document to consultation.
     * @param documentIds The document identifiers.
     * @param consultationId The consultation identifier.
     * @param select Value indicating whether to select if true, false otherwise
     */
    addDoctorCustomDocumentToConsultation(documentIds: number[] | null, consultationId: number, select: boolean): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/Document/AddDoctorCustomDocumentToConsultation/?consultationId={consultationId}&select={select}";
        if (consultationId === undefined || consultationId === null)
            throw new Error("The parameter 'consultationId' must be defined.");
        url_ = url_.replace("{consultationId}", encodeURIComponent("" + consultationId));
        if (select === undefined || select === null)
            throw new Error("The parameter 'select' must be defined.");
        url_ = url_.replace("{select}", encodeURIComponent("" + select));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(documentIds);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddDoctorCustomDocumentToConsultation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddDoctorCustomDocumentToConsultation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddDoctorCustomDocumentToConsultation(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * The patient create a document asynchronous.
     * @param documentCreation The document creation.
     * @return An asynchronous operation
     */
    createPatientDocument(documentCreation: PatientDocumentCreation | null): Observable<number> {
        let url_ = this.baseUrl + "/umbraco/Api/Document/CreatePatientDocumentAsync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(documentCreation);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePatientDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePatientDocument(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreatePatientDocument(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Deletes the document.
     * @param documentId The document identifier.
     */
    deleteDocument(documentId: number): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/Document/DeleteDocument/?documentId={documentId}";
        if (documentId === undefined || documentId === null)
            throw new Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteDocument(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteDocument(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the import patients error file for current doctor.
     * @return The file url.
     */
    getCurrentDoctorImportPatientsErrorFileUrl(): Observable<string | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Document/GetCurrentDoctorImportPatientsErrorFileUrl";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentDoctorImportPatientsErrorFileUrl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentDoctorImportPatientsErrorFileUrl(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string | null>;
        }));
    }

    protected processGetCurrentDoctorImportPatientsErrorFileUrl(response: HttpResponseBase): Observable<string | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the by consultation identifier.
     * @param consultationId The consultation identifier.
     * @return The required documents
     */
    getByConsultationId(consultationId: number): Observable<DocumentWrapper[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Document/GetByConsultationId/?consultationId={consultationId}";
        if (consultationId === undefined || consultationId === null)
            throw new Error("The parameter 'consultationId' must be defined.");
        url_ = url_.replace("{consultationId}", encodeURIComponent("" + consultationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByConsultationId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByConsultationId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentWrapper[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentWrapper[] | null>;
        }));
    }

    protected processGetByConsultationId(response: HttpResponseBase): Observable<DocumentWrapper[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DocumentWrapper.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the document from patient.
     * @param patientId The patient identifier.
     * @return the document send by the patient.
     */
    getDocumentFromPatient(patientId: number): Observable<Document[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Document/GetDocumentFromPatient/?patientId={patientId}";
        if (patientId === undefined || patientId === null)
            throw new Error("The parameter 'patientId' must be defined.");
        url_ = url_.replace("{patientId}", encodeURIComponent("" + patientId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDocumentFromPatient(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDocumentFromPatient(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Document[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Document[] | null>;
        }));
    }

    protected processGetDocumentFromPatient(response: HttpResponseBase): Observable<Document[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Document.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the document from doctor.
     * @param consultationId The consultation identifier.
     * @return the document send by the doctor.
     */
    getDocumentFromDoctor(consultationId: number): Observable<Document[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Document/GetDocumentFromDoctor/?consultationId={consultationId}";
        if (consultationId === undefined || consultationId === null)
            throw new Error("The parameter 'consultationId' must be defined.");
        url_ = url_.replace("{consultationId}", encodeURIComponent("" + consultationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDocumentFromDoctor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDocumentFromDoctor(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Document[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Document[] | null>;
        }));
    }

    protected processGetDocumentFromDoctor(response: HttpResponseBase): Observable<Document[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Document.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the document.
     * @param documentId The document identifier.
     * @return the document.
     */
    getDocument(documentId: number): Observable<Document | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Document/GetDocument/?documentId={documentId}";
        if (documentId === undefined || documentId === null)
            throw new Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDocument(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Document | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Document | null>;
        }));
    }

    protected processGetDocument(response: HttpResponseBase): Observable<Document | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? Document.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the number document send by patient.
     * @param patientId The patient identifier.
     * @return the number of selected document send by the patient.
     */
    getNumberDocumentSendByPatient(patientId: number): Observable<number> {
        let url_ = this.baseUrl + "/umbraco/Api/Document/GetNumberDocumentSendByPatient/?patientId={patientId}";
        if (patientId === undefined || patientId === null)
            throw new Error("The parameter 'patientId' must be defined.");
        url_ = url_.replace("{patientId}", encodeURIComponent("" + patientId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNumberDocumentSendByPatient(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNumberDocumentSendByPatient(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetNumberDocumentSendByPatient(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the number document send by doctor.
     * @param consultationId The consultation identifier.
     * @return the number of selected document.
     */
    getNumberDocumentSendByDoctor(consultationId: number): Observable<number> {
        let url_ = this.baseUrl + "/umbraco/Api/Document/GetNumberDocumentSendByDoctor/?consultationId={consultationId}";
        if (consultationId === undefined || consultationId === null)
            throw new Error("The parameter 'consultationId' must be defined.");
        url_ = url_.replace("{consultationId}", encodeURIComponent("" + consultationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNumberDocumentSendByDoctor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNumberDocumentSendByDoctor(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetNumberDocumentSendByDoctor(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the number document model.
     * @param consultationId The consultation identifier.
     * @return the number of selected documentModel.
     */
    getNumberDocumentModel(consultationId: number): Observable<number> {
        let url_ = this.baseUrl + "/umbraco/Api/Document/GetNumberDocumentModel/?consultationId={consultationId}";
        if (consultationId === undefined || consultationId === null)
            throw new Error("The parameter 'consultationId' must be defined.");
        url_ = url_.replace("{consultationId}", encodeURIComponent("" + consultationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNumberDocumentModel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNumberDocumentModel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetNumberDocumentModel(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the current patient documents.
     * @param searchParams The search parameters.
     * @return The documents
     */
    getCurrentPatientDocuments(searchParams: DocumentSearchParams | null): Observable<DocumentWrapper[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Document/GetCurrentPatientDocuments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchParams);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentPatientDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentPatientDocuments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentWrapper[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentWrapper[] | null>;
        }));
    }

    protected processGetCurrentPatientDocuments(response: HttpResponseBase): Observable<DocumentWrapper[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DocumentWrapper.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the current patient filter values.
     * @return The values for the filter.
     */
    getCurrentPatientFilterValues(): Observable<PatientFilterValues | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Document/GetCurrentPatientFilterValues";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentPatientFilterValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentPatientFilterValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PatientFilterValues | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PatientFilterValues | null>;
        }));
    }

    protected processGetCurrentPatientFilterValues(response: HttpResponseBase): Observable<PatientFilterValues | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PatientFilterValues.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the documents matching the .
     * @param searchParams The search parameters.
     * @return The documents.
     */
    getDocuments(searchParams: DocumentSearchParams | null): Observable<Document[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Document/GetDocuments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchParams);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDocuments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Document[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Document[] | null>;
        }));
    }

    protected processGetDocuments(response: HttpResponseBase): Observable<Document[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Document.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the specified container.
     * @param documentId The documentId.
     * @return File in a http response.
     */
    getFile(documentId: number): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Document/GetFileAsync/?documentId={documentId}";
        if (documentId === undefined || documentId === null)
            throw new Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processGetFile(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Redirects the file URL asynchronous.
     * @param documentId The document id
     * @return Redirect to file URL.
     */
    redirectFileUrl(documentId: number): Observable<RedirectResult | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Document/RedirectFileUrl/?documentId={documentId}";
        if (documentId === undefined || documentId === null)
            throw new Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRedirectFileUrl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRedirectFileUrl(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RedirectResult | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RedirectResult | null>;
        }));
    }

    protected processRedirectFileUrl(response: HttpResponseBase): Observable<RedirectResult | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? RedirectResult.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Selects the document.
     * @param documentId The document identifier.
     * @param value if set to true [value].
     */
    selectDocument(documentId: number, value: boolean): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/Document/SelectDocument/?documentId={documentId}&value={value}";
        if (documentId === undefined || documentId === null)
            throw new Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        if (value === undefined || value === null)
            throw new Error("The parameter 'value' must be defined.");
        url_ = url_.replace("{value}", encodeURIComponent("" + value));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSelectDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSelectDocument(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSelectDocument(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Selects the documents.
     * @param selectionInformations The selection informations.
     */
    selectDocuments(selectionInformations: SelectionInformations | null): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/Document/SelectDocuments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(selectionInformations);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSelectDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSelectDocuments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSelectDocuments(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Send the document to the patient.
     * @param documentToPatient The document send to patient.
     */
    sendDocumentToPatient(documentToPatient: DocumentToPatient | null): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/Document/SendDocumentToPatient";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(documentToPatient);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendDocumentToPatient(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendDocumentToPatient(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendDocumentToPatient(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates the document from my.
     * @param documentEdition The document edition.
     */
    updatePatientDocument(documentEdition: PatientDocumentEdition | null): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/Document/UpdatePatientDocument";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(documentEdition);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePatientDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePatientDocument(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdatePatientDocument(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates the document from pro.
     * @param documentUpdate The document update.
     * @return .The task.
     */
    updateDoctorDocument(documentUpdate: UpdateDoctorDocument | null): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/Document/UpdateDoctorDocumentAsync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(documentUpdate);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateDoctorDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateDoctorDocument(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateDoctorDocument(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AgendaRepository {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Creates the time slot.
     * @param timeSlotDetails The time slot details.
     * @return The id of the created TimeSlot.
     */
    createTimeSlot(timeSlotDetails: TimeSlot | null): Observable<StatusValueResourceOfNullableInteger | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Agenda/CreateTimeSlot";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(timeSlotDetails);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateTimeSlot(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateTimeSlot(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StatusValueResourceOfNullableInteger | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StatusValueResourceOfNullableInteger | null>;
        }));
    }

    protected processCreateTimeSlot(response: HttpResponseBase): Observable<StatusValueResourceOfNullableInteger | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? StatusValueResourceOfNullableInteger.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Creates the unavailability.
     * @param agendaUnavailability The agenda unavailability.
     * @return The id of the created Unavailability.
     */
    createUnavailability(agendaUnavailability: AgendaUnavailability | null): Observable<StatusValueResourceOfNullableInteger | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Agenda/CreateUnavailability";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(agendaUnavailability);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateUnavailability(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateUnavailability(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StatusValueResourceOfNullableInteger | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StatusValueResourceOfNullableInteger | null>;
        }));
    }

    protected processCreateUnavailability(response: HttpResponseBase): Observable<StatusValueResourceOfNullableInteger | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? StatusValueResourceOfNullableInteger.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Deletes the unavailability event contact by identifier.
     * @param contactId The contact identifier.
     */
    deleteAgendaUnavailabilityContact(contactId: number): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/api/Agenda/DeleteAgendaUnavailabilityContact?";
        if (contactId === undefined || contactId === null)
            throw new Error("The parameter 'contactId' must be defined and cannot be null.");
        else
            url_ += "contactId=" + encodeURIComponent("" + contactId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteAgendaUnavailabilityContact(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteAgendaUnavailabilityContact(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteAgendaUnavailabilityContact(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Deletes the time slot by identifier.
     * @param deleteTimeSlot The delete timeslot.
     */
    deleteTimeSlotById(deleteTimeSlot: DeleteTimeSlot | null): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/api/Agenda/DeleteTimeSlotById";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(deleteTimeSlot);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteTimeSlotById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteTimeSlotById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteTimeSlotById(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Deletes the unavailability by identifier.
     * @param unavailabilityId The unavailability identifier.
     */
    deleteUnavailabilityById(unavailabilityId: number): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/Agenda/DeleteUnavailabilityById/?unavailabilityId={unavailabilityId}";
        if (unavailabilityId === undefined || unavailabilityId === null)
            throw new Error("The parameter 'unavailabilityId' must be defined.");
        url_ = url_.replace("{unavailabilityId}", encodeURIComponent("" + unavailabilityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteUnavailabilityById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteUnavailabilityById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteUnavailabilityById(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the current doctor contacts.
     * @return The contacts.
     */
    getDoctorContacts(): Observable<AgendaUnavailabilityEventContact[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Agenda/GetDoctorContacts";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDoctorContacts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDoctorContacts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AgendaUnavailabilityEventContact[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AgendaUnavailabilityEventContact[] | null>;
        }));
    }

    protected processGetDoctorContacts(response: HttpResponseBase): Observable<AgendaUnavailabilityEventContact[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AgendaUnavailabilityEventContact.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the weekly doctor time slots.
     * @param startDate The start date.
     * @param endDate The end date.
     * @return The TimeSlots of the doctor for the week.
     */
    getDoctorTimeSlots(startDate: Date, endDate: Date): Observable<TimeSlot[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Agenda/GetDoctorTimeSlots/?startDate={startDate}&endDate={endDate}";
        if (startDate === undefined || startDate === null)
            throw new Error("The parameter 'startDate' must be defined.");
        url_ = url_.replace("{startDate}", encodeURIComponent(startDate ? "" + startDate.toISOString() : "null"));
        if (endDate === undefined || endDate === null)
            throw new Error("The parameter 'endDate' must be defined.");
        url_ = url_.replace("{endDate}", encodeURIComponent(endDate ? "" + endDate.toISOString() : "null"));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDoctorTimeSlots(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDoctorTimeSlots(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TimeSlot[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TimeSlot[] | null>;
        }));
    }

    protected processGetDoctorTimeSlots(response: HttpResponseBase): Observable<TimeSlot[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TimeSlot.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the note to do numbers.
     * @param startDate The start date.
     * @param endDate The end date.
     * @return The nb of notes to do by day.
     */
    getNoteToDoNumbers(startDate: Date, endDate: Date): Observable<NoteToDoNumber[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Agenda/GetNoteToDoNumbers/?startDate={startDate}&endDate={endDate}";
        if (startDate === undefined || startDate === null)
            throw new Error("The parameter 'startDate' must be defined.");
        url_ = url_.replace("{startDate}", encodeURIComponent(startDate ? "" + startDate.toISOString() : "null"));
        if (endDate === undefined || endDate === null)
            throw new Error("The parameter 'endDate' must be defined.");
        url_ = url_.replace("{endDate}", encodeURIComponent(endDate ? "" + endDate.toISOString() : "null"));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNoteToDoNumbers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNoteToDoNumbers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NoteToDoNumber[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NoteToDoNumber[] | null>;
        }));
    }

    protected processGetNoteToDoNumbers(response: HttpResponseBase): Observable<NoteToDoNumber[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NoteToDoNumber.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the doctor unavailabilities.
     * @return The unavailabilities.
     */
    getDoctorUnavailabilities(): Observable<AgendaUnavailability[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Agenda/GetDoctorUnavailabilities";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDoctorUnavailabilities(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDoctorUnavailabilities(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AgendaUnavailability[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AgendaUnavailability[] | null>;
        }));
    }

    protected processGetDoctorUnavailabilities(response: HttpResponseBase): Observable<AgendaUnavailability[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AgendaUnavailability.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the doctor unavailabilities.
     * @param type The unavailability type.
     * @return The unavailabilities.
     */
    getDoctorUnavailabilitiesByType(type: number): Observable<AgendaUnavailability[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Agenda/GetDoctorUnavailabilitiesByType/?type={type}";
        if (type === undefined || type === null)
            throw new Error("The parameter 'type' must be defined.");
        url_ = url_.replace("{type}", encodeURIComponent("" + type));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDoctorUnavailabilitiesByType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDoctorUnavailabilitiesByType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AgendaUnavailability[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AgendaUnavailability[] | null>;
        }));
    }

    protected processGetDoctorUnavailabilitiesByType(response: HttpResponseBase): Observable<AgendaUnavailability[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AgendaUnavailability.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the doctor unavailabilities.
     * @param startDate The start date.
     * @param endDate The end date.
     * @param type The unavailability type.
     * @return The unavailabilities.
     */
    getDoctorUnavailabilitiesByDateAndType(startDate: Date, endDate: Date, type: AgendaUnavailabilityType): Observable<AgendaUnavailability[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Agenda/GetDoctorUnavailabilitiesByDateAndType/?startDate={startDate}&endDate={endDate}&type={type}";
        if (startDate === undefined || startDate === null)
            throw new Error("The parameter 'startDate' must be defined.");
        url_ = url_.replace("{startDate}", encodeURIComponent(startDate ? "" + startDate.toISOString() : "null"));
        if (endDate === undefined || endDate === null)
            throw new Error("The parameter 'endDate' must be defined.");
        url_ = url_.replace("{endDate}", encodeURIComponent(endDate ? "" + endDate.toISOString() : "null"));
        if (type === undefined || type === null)
            throw new Error("The parameter 'type' must be defined.");
        url_ = url_.replace("{type}", encodeURIComponent("" + type));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDoctorUnavailabilitiesByDateAndType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDoctorUnavailabilitiesByDateAndType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AgendaUnavailability[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AgendaUnavailability[] | null>;
        }));
    }

    protected processGetDoctorUnavailabilitiesByDateAndType(response: HttpResponseBase): Observable<AgendaUnavailability[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AgendaUnavailability.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the doctor unavailabilities.
     * @param startDate The start date.
     * @param endDate The end date.
     * @return The unavailabilities.
     */
    getDoctorUnavailabilitiesByDate(startDate: Date, endDate: Date): Observable<AgendaUnavailability[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Agenda/GetDoctorUnavailabilitiesByDate/?startDate={startDate}&endDate={endDate}";
        if (startDate === undefined || startDate === null)
            throw new Error("The parameter 'startDate' must be defined.");
        url_ = url_.replace("{startDate}", encodeURIComponent(startDate ? "" + startDate.toISOString() : "null"));
        if (endDate === undefined || endDate === null)
            throw new Error("The parameter 'endDate' must be defined.");
        url_ = url_.replace("{endDate}", encodeURIComponent(endDate ? "" + endDate.toISOString() : "null"));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDoctorUnavailabilitiesByDate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDoctorUnavailabilitiesByDate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AgendaUnavailability[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AgendaUnavailability[] | null>;
        }));
    }

    protected processGetDoctorUnavailabilitiesByDate(response: HttpResponseBase): Observable<AgendaUnavailability[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AgendaUnavailability.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the uncovered by insurance pool time slots.
     * @param firstDay The first day.
     * @param lastDay The last day.
     * @return The uncovered timeslots
     */
    getUncoveredByInsurancePoolTimeSlots(firstDay: Date, lastDay: Date): Observable<TimeSlot[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Agenda/GetUncoveredByInsurancePoolTimeSlots/?firstDay={firstDay}&lastDay={lastDay}";
        if (firstDay === undefined || firstDay === null)
            throw new Error("The parameter 'firstDay' must be defined.");
        url_ = url_.replace("{firstDay}", encodeURIComponent(firstDay ? "" + firstDay.toISOString() : "null"));
        if (lastDay === undefined || lastDay === null)
            throw new Error("The parameter 'lastDay' must be defined.");
        url_ = url_.replace("{lastDay}", encodeURIComponent(lastDay ? "" + lastDay.toISOString() : "null"));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUncoveredByInsurancePoolTimeSlots(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUncoveredByInsurancePoolTimeSlots(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TimeSlot[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TimeSlot[] | null>;
        }));
    }

    protected processGetUncoveredByInsurancePoolTimeSlots(response: HttpResponseBase): Observable<TimeSlot[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TimeSlot.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates the time slot.
     * @param timeSlot The time slot.
     * @return The response status.
     */
    updateTimeSlot(timeSlot: UpdateTimeSlot | null): Observable<ResponseStatus> {
        let url_ = this.baseUrl + "/umbraco/Api/Agenda/UpdateTimeSlot";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(timeSlot);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateTimeSlot(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateTimeSlot(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseStatus>;
        }));
    }

    protected processUpdateTimeSlot(response: HttpResponseBase): Observable<ResponseStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates the unavailability.
     * @param agendaUnavailability The agenda unavailability.
     * @return The response status.
     */
    updateUnavailability(agendaUnavailability: AgendaUnavailability | null): Observable<ResponseStatus> {
        let url_ = this.baseUrl + "/umbraco/Api/Agenda/UpdateUnavailability";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(agendaUnavailability);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateUnavailability(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateUnavailability(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseStatus>;
        }));
    }

    protected processUpdateUnavailability(response: HttpResponseBase): Observable<ResponseStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class MyNutriConsultRepository {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Gets the privacy link.
     * @return The privacy link.
     */
    getConsultSiinDirectoryUrl(): Observable<string | null> {
        let url_ = this.baseUrl + "/umbraco/Api/MyNutriConsult/GetConsultSiinDirectoryUrl";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConsultSiinDirectoryUrl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConsultSiinDirectoryUrl(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string | null>;
        }));
    }

    protected processGetConsultSiinDirectoryUrl(response: HttpResponseBase): Observable<string | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the privacy link.
     * @return The privacy link.
     */
    getPrivacyLink(): Observable<string | null> {
        let url_ = this.baseUrl + "/umbraco/Api/MyNutriConsult/GetPrivacyLink";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPrivacyLink(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPrivacyLink(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string | null>;
        }));
    }

    protected processGetPrivacyLink(response: HttpResponseBase): Observable<string | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the terms and conditions link.
     * @return The link of terms and conditions pages
     */
    getTermsAndConditionsLink(): Observable<string | null> {
        let url_ = this.baseUrl + "/umbraco/Api/MyNutriConsult/GetTermsAndConditionsLink";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTermsAndConditionsLink(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTermsAndConditionsLink(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string | null>;
        }));
    }

    protected processGetTermsAndConditionsLink(response: HttpResponseBase): Observable<string | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the guide link.
     * @return The link of the guide page.
     */
    getGuideLink(): Observable<string | null> {
        let url_ = this.baseUrl + "/umbraco/Api/MyNutriConsult/GetGuideLink";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGuideLink(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGuideLink(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string | null>;
        }));
    }

    protected processGetGuideLink(response: HttpResponseBase): Observable<string | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the MyNutriConsult url.
     * @return The MyNutriConsult url.
     */
    getMyConsultSiinAppHomeUrl(): Observable<string | null> {
        let url_ = this.baseUrl + "/umbraco/Api/MyNutriConsult/GetMyConsultSiinAppHomeUrl";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyConsultSiinAppHomeUrl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyConsultSiinAppHomeUrl(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string | null>;
        }));
    }

    protected processGetMyConsultSiinAppHomeUrl(response: HttpResponseBase): Observable<string | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the MyNutriConsult url.
     * @return The MyNutriConsult url.
     */
    getMyConsultSiinMarketingHomeUrl(): Observable<string | null> {
        let url_ = this.baseUrl + "/umbraco/Api/MyNutriConsult/GetMyConsultSiinMarketingHomeUrl";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyConsultSiinMarketingHomeUrl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyConsultSiinMarketingHomeUrl(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string | null>;
        }));
    }

    protected processGetMyConsultSiinMarketingHomeUrl(response: HttpResponseBase): Observable<string | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ProNutriConsultAppRepository {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Gets the privacy link.
     * @return The privacy link.
     */
    getMemberAreaUrl(): Observable<string | null> {
        let url_ = this.baseUrl + "/umbraco/Api/ProNutriConsultApp/GetMemberAreaUrl";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMemberAreaUrl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMemberAreaUrl(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string | null>;
        }));
    }

    protected processGetMemberAreaUrl(response: HttpResponseBase): Observable<string | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the pronutri product on Siin url.
     * @return the pronutri product on Siin url.
     */
    getProNutriConsultProductUrl(): Observable<string | null> {
        let url_ = this.baseUrl + "/umbraco/Api/ProNutriConsultApp/GetProNutriConsultProductUrl";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProNutriConsultProductUrl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProNutriConsultProductUrl(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string | null>;
        }));
    }

    protected processGetProNutriConsultProductUrl(response: HttpResponseBase): Observable<string | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the pronutri solution on Siin url.
     * @return the pronutri solution on Siin url.
     */
    getProNutriConsultSolutionUrl(): Observable<string | null> {
        let url_ = this.baseUrl + "/umbraco/Api/ProNutriConsultApp/GetProNutriConsultSolutionUrl";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProNutriConsultSolutionUrl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProNutriConsultSolutionUrl(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string | null>;
        }));
    }

    protected processGetProNutriConsultSolutionUrl(response: HttpResponseBase): Observable<string | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class CalnutRepository {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Creates the nutrient.
     * @param createNutrient The create nutrient.
     */
    createNutrient(createNutrient: CreateNutrient | null): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/Calnut/CreateNutrient";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createNutrient);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateNutrient(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateNutrient(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateNutrient(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all the unit types
     * @return the unit types.
     */
    getAllUnitTypes(): Observable<UnitType[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Calnut/GetAllUnitTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllUnitTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllUnitTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UnitType[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UnitType[] | null>;
        }));
    }

    protected processGetAllUnitTypes(response: HttpResponseBase): Observable<UnitType[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UnitType.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the category dropdow value.
     * @return the dropwon value for nutrientCategory.
     */
    getCategoryDropdowValue(): Observable<DropdownValue2[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Calnut/GetCategoryDropdowValue";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCategoryDropdowValue(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCategoryDropdowValue(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DropdownValue2[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DropdownValue2[] | null>;
        }));
    }

    protected processGetCategoryDropdowValue(response: HttpResponseBase): Observable<DropdownValue2[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DropdownValue2.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get the ingredient info (including nutritional info).
     * @param ingredientId ingredient id.
     * @param quantity The quantity.
     * @param unitTypeId The unit type identifier.
     * @return The ingredient info (including nutritional info).
     */
    getIngredientNutritionalInfo(ingredientId: number, quantity: number, unitTypeId: number): Observable<IngredientDetails | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Calnut/GetIngredientNutritionalInfo/?ingredientId={ingredientId}&quantity={quantity}&unitTypeId={unitTypeId}";
        if (ingredientId === undefined || ingredientId === null)
            throw new Error("The parameter 'ingredientId' must be defined.");
        url_ = url_.replace("{ingredientId}", encodeURIComponent("" + ingredientId));
        if (quantity === undefined || quantity === null)
            throw new Error("The parameter 'quantity' must be defined.");
        url_ = url_.replace("{quantity}", encodeURIComponent("" + quantity));
        if (unitTypeId === undefined || unitTypeId === null)
            throw new Error("The parameter 'unitTypeId' must be defined.");
        url_ = url_.replace("{unitTypeId}", encodeURIComponent("" + unitTypeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIngredientNutritionalInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIngredientNutritionalInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IngredientDetails | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IngredientDetails | null>;
        }));
    }

    protected processGetIngredientNutritionalInfo(response: HttpResponseBase): Observable<IngredientDetails | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? IngredientDetails.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get the unit types associated to ingredient
     * @param ingredientId ingredient id.
     * @return the unit types associated to ingredient.
     */
    getIngredientUnitTypes(ingredientId: number): Observable<UnitType[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Calnut/GetIngredientUnitTypes/?ingredientId={ingredientId}";
        if (ingredientId === undefined || ingredientId === null)
            throw new Error("The parameter 'ingredientId' must be defined.");
        url_ = url_.replace("{ingredientId}", encodeURIComponent("" + ingredientId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIngredientUnitTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIngredientUnitTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UnitType[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UnitType[] | null>;
        }));
    }

    protected processGetIngredientUnitTypes(response: HttpResponseBase): Observable<UnitType[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UnitType.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets all ingredients.
     * @return All the ingredients.
     */
    getIngredientValueForDropDownAll(): Observable<DropdownValue2[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Calnut/GetIngredientValueForDropDown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIngredientValueForDropDownAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIngredientValueForDropDownAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DropdownValue2[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DropdownValue2[] | null>;
        }));
    }

    protected processGetIngredientValueForDropDownAll(response: HttpResponseBase): Observable<DropdownValue2[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DropdownValue2.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets all ingredients.
     * @param consultationId The consultation identifier.
     * @return All the ingredients.
     */
    getIngredientValueForDropDown(consultationId: number): Observable<DropdownValue2[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Calnut/GetIngredientValueForDropDown/?consultationId={consultationId}";
        if (consultationId === undefined || consultationId === null)
            throw new Error("The parameter 'consultationId' must be defined.");
        url_ = url_.replace("{consultationId}", encodeURIComponent("" + consultationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIngredientValueForDropDown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIngredientValueForDropDown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DropdownValue2[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DropdownValue2[] | null>;
        }));
    }

    protected processGetIngredientValueForDropDown(response: HttpResponseBase): Observable<DropdownValue2[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DropdownValue2.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the nutrient detail.
     * @param id The identifier.
     * @return the nutrient detail.
     */
    getNutrientDetail(id: number): Observable<Nutrient | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Calnut/GetNutrientDetail/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNutrientDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNutrientDetail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Nutrient | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Nutrient | null>;
        }));
    }

    protected processGetNutrientDetail(response: HttpResponseBase): Observable<Nutrient | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? Nutrient.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the nutrients.
     * @return All the nutrients.
     */
    getNutrients(): Observable<NutrientLite[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Calnut/GetNutrients";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNutrients(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNutrients(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NutrientLite[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NutrientLite[] | null>;
        }));
    }

    protected processGetNutrients(response: HttpResponseBase): Observable<NutrientLite[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NutrientLite.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the ingredients for library.
     * @param searchParams The search params.
     * @return The list of ingredients for the library.
     */
    getIngredientsForLibrary(searchParams: CalnutSearchParams | null): Observable<PaginatorWrapperOfIEnumerableOfIngredientForLibrary | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Calnut/GetIngredientsForLibrary";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchParams);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIngredientsForLibrary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIngredientsForLibrary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaginatorWrapperOfIEnumerableOfIngredientForLibrary | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaginatorWrapperOfIEnumerableOfIngredientForLibrary | null>;
        }));
    }

    protected processGetIngredientsForLibrary(response: HttpResponseBase): Observable<PaginatorWrapperOfIEnumerableOfIngredientForLibrary | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PaginatorWrapperOfIEnumerableOfIngredientForLibrary.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates the nutrient.
     * @param nutrient The nutrient.
     */
    updateNutrient(nutrient: UpdateNutrient | null): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/Calnut/UpdateNutrient";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(nutrient);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateNutrient(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateNutrient(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateNutrient(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the ingredients.
     * @param searchParams The search params.
     * @return The list of ingredients for the library.
     */
    getIngredients(searchParams: IngredientSearchParams | null): Observable<PaginatorWrapperOfIEnumerableOfIngredientCalnut | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Calnut/GetIngredientsAsync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchParams);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIngredients(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIngredients(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaginatorWrapperOfIEnumerableOfIngredientCalnut | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaginatorWrapperOfIEnumerableOfIngredientCalnut | null>;
        }));
    }

    protected processGetIngredients(response: HttpResponseBase): Observable<PaginatorWrapperOfIEnumerableOfIngredientCalnut | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PaginatorWrapperOfIEnumerableOfIngredientCalnut.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the foods category for ingredients.
     * @return All the foods category for ingredients.
     */
    getFoodCategories(): Observable<FoodCategory[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Calnut/GetFoodCategoriesAsync";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFoodCategories(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFoodCategories(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FoodCategory[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FoodCategory[] | null>;
        }));
    }

    protected processGetFoodCategories(response: HttpResponseBase): Observable<FoodCategory[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FoodCategory.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the foods for ingredients.
     * @return All the foods for ingredients.
     */
    getFoods(): Observable<Food[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Calnut/GetFoodsAsync";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFoods(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFoods(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Food[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Food[] | null>;
        }));
    }

    protected processGetFoods(response: HttpResponseBase): Observable<Food[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Food.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets all nutrients.
     * @return All nutrients for ingredients list
     */
    getAllNutrients(): Observable<NutrientLite[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Calnut/GetAllNutrients";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllNutrients(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllNutrients(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NutrientLite[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NutrientLite[] | null>;
        }));
    }

    protected processGetAllNutrients(response: HttpResponseBase): Observable<NutrientLite[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NutrientLite.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Saves the ingredient.
     * @param ingredient The ingredient.
     * @return A task
     */
    saveIngredient(ingredient: IngredientCalnut | null): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/Calnut/SaveIngredientAsync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(ingredient);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveIngredient(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveIngredient(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSaveIngredient(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Saves the food category.
     * @param foodCategory The food category.
     * @return A task
     */
    saveFoodCategory(foodCategory: FoodCategory | null): Observable<number> {
        let url_ = this.baseUrl + "/umbraco/Api/Calnut/SaveFoodCategoryAsync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(foodCategory);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveFoodCategory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveFoodCategory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processSaveFoodCategory(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Saves the food.
     * @param food The food.
     * @return A task
     */
    saveFood(food: Food | null): Observable<number> {
        let url_ = this.baseUrl + "/umbraco/Api/Calnut/SaveFoodAsync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(food);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveFood(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveFood(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processSaveFood(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Deletes the food category.
     * @param id The food category identifier.
     * @return A task
     */
    deleteFoodCategory(id: number): Observable<ResponseStatus> {
        let url_ = this.baseUrl + "/umbraco/Api/Calnut/DeleteFoodCategoryAsync/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteFoodCategory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteFoodCategory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseStatus>;
        }));
    }

    protected processDeleteFoodCategory(response: HttpResponseBase): Observable<ResponseStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Deletes the food.
     * @param id The food identifier.
     * @return A task
     */
    deleteFood(id: number): Observable<ResponseStatus> {
        let url_ = this.baseUrl + "/umbraco/Api/Calnut/DeleteFoodAsync/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteFood(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteFood(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseStatus>;
        }));
    }

    protected processDeleteFood(response: HttpResponseBase): Observable<ResponseStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Deletes the ingredient identified by the specified ID.
     * @param id The unique identifier of the ingredient to delete.
     * @return A task that represents the asynchronous delete operation.
     */
    deleteIngredient(id: number): Observable<ResponseStatus> {
        let url_ = this.baseUrl + "/umbraco/Api/Calnut/DeleteIngredientAsync/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteIngredient(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteIngredient(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseStatus>;
        }));
    }

    protected processDeleteIngredient(response: HttpResponseBase): Observable<ResponseStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the ingredient calnut by identifier.
     * @param id The unique identifier for an ingredient calnut
     * @return The ingredient calnut
     */
    getIngredientById(id: number): Observable<IngredientCalnut | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Calnut/GetIngredientByIdAsync/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIngredientById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIngredientById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IngredientCalnut | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IngredientCalnut | null>;
        }));
    }

    protected processGetIngredientById(response: HttpResponseBase): Observable<IngredientCalnut | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? IngredientCalnut.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets list of ingredients lite.
     * @return The list of ingredients
     */
    getIngredientsLite(): Observable<IngredientForLibrary[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Calnut/GetIngredientsLite";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIngredientsLite(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIngredientsLite(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IngredientForLibrary[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IngredientForLibrary[] | null>;
        }));
    }

    protected processGetIngredientsLite(response: HttpResponseBase): Observable<IngredientForLibrary[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IngredientForLibrary.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Validates the ingredient.
     * @param validateIngredient The validate ingredient.
     * @return A task that represents the asynchronous operation.
     */
    validateIngredient(validateIngredient: ValidateIngredient | null): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/Calnut/ValidateIngredientAsync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(validateIngredient);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidateIngredient(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidateIngredient(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processValidateIngredient(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ClientFolderRepository {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Fill Or Get Direct Satisfaction.
     * @param followUpId The follow up id.
     * @return The redirect result.
     */
    fillOrGetDirectSatisfaction(followUpId: number): Observable<RedirectResult | null> {
        let url_ = this.baseUrl + "/umbraco/Api/ClientFolder/FillOrGetDirectSatisfaction/?followUpId={followUpId}";
        if (followUpId === undefined || followUpId === null)
            throw new Error("The parameter 'followUpId' must be defined.");
        url_ = url_.replace("{followUpId}", encodeURIComponent("" + followUpId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFillOrGetDirectSatisfaction(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFillOrGetDirectSatisfaction(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RedirectResult | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RedirectResult | null>;
        }));
    }

    protected processFillOrGetDirectSatisfaction(response: HttpResponseBase): Observable<RedirectResult | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? RedirectResult.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Fill Or Get Three Month Later Satisfaction.
     * @param followUpId The follow up id.
     * @return The redirect result.
     */
    fillOrGetThreeMonthSatisfaction(followUpId: number): Observable<RedirectResult | null> {
        let url_ = this.baseUrl + "/umbraco/Api/ClientFolder/FillOrGetThreeMonthSatisfaction/?followUpId={followUpId}";
        if (followUpId === undefined || followUpId === null)
            throw new Error("The parameter 'followUpId' must be defined.");
        url_ = url_.replace("{followUpId}", encodeURIComponent("" + followUpId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFillOrGetThreeMonthSatisfaction(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFillOrGetThreeMonthSatisfaction(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RedirectResult | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RedirectResult | null>;
        }));
    }

    protected processFillOrGetThreeMonthSatisfaction(response: HttpResponseBase): Observable<RedirectResult | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? RedirectResult.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Save the satisfaction form.
     * @param complexSatisfactionForm The list of answers
     * @return Task.
     */
    saveSatisfactionForm(complexSatisfactionForm: ComplexSatisfactionForm | null): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/ClientFolder/SaveSatisfactionForm";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(complexSatisfactionForm);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveSatisfactionForm(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveSatisfactionForm(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSaveSatisfactionForm(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all satisfaction forms.
     * @param satisfactionFormParams satisfaction params
     * @return The satisfaction forms.
     */
    getAllSatisfactionForm(satisfactionFormParams: SatisfactionFormParams | null): Observable<PaginatorWrapperOfIEnumerableOfSatisfactionForm | null> {
        let url_ = this.baseUrl + "/umbraco/Api/ClientFolder/GetAllSatisfactionForm";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(satisfactionFormParams);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSatisfactionForm(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSatisfactionForm(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaginatorWrapperOfIEnumerableOfSatisfactionForm | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaginatorWrapperOfIEnumerableOfSatisfactionForm | null>;
        }));
    }

    protected processGetAllSatisfactionForm(response: HttpResponseBase): Observable<PaginatorWrapperOfIEnumerableOfSatisfactionForm | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PaginatorWrapperOfIEnumerableOfSatisfactionForm.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all satisfaction types.
     * @return The satisfaction types.
     */
    getSatisfactionType(): Observable<DropdownValueString[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/ClientFolder/GetSatisfactionType";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSatisfactionType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSatisfactionType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DropdownValueString[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DropdownValueString[] | null>;
        }));
    }

    protected processGetSatisfactionType(response: HttpResponseBase): Observable<DropdownValueString[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DropdownValueString.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all satisfaction pdf urls.
     * @param id id
     * @param formularyType formulary type
     * @return Pdf Url.
     */
    getSatisfactionPdfUrl(id: number, formularyType: string): Observable<string | null> {
        let url_ = this.baseUrl + "/umbraco/Api/ClientFolder/GetSatisfactionPdfUrl/{id}?formularyType={formularyType}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (formularyType === undefined || formularyType === null)
            throw new Error("The parameter 'formularyType' must be defined.");
        url_ = url_.replace("{formularyType}", encodeURIComponent("" + formularyType));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSatisfactionPdfUrl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSatisfactionPdfUrl(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string | null>;
        }));
    }

    protected processGetSatisfactionPdfUrl(response: HttpResponseBase): Observable<string | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Download satisfaction pdf.
     * @param id id
     * @param formularyType formulary type
     * @return Satisfaction pdf.
     */
    downloadSatisfactionPdf(id: number, formularyType: string): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/umbraco/Api/ClientFolder/DownloadSatisfactionPdf/{id}?formularyType={formularyType}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (formularyType === undefined || formularyType === null)
            throw new Error("The parameter 'formularyType' must be defined.");
        url_ = url_.replace("{formularyType}", encodeURIComponent("" + formularyType));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadSatisfactionPdf(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadSatisfactionPdf(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDownloadSatisfactionPdf(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the satisfaction mails.
     * @param satisfactionFormParams satisfaction Form Params
     * @return The list of satisfaction mails.
     */
    getSatisfactionMails(satisfactionFormParams: SatisfactionFormParams | null): Observable<MailMemberHistoryLite[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/ClientFolder/GetSatisfactionMails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(satisfactionFormParams);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSatisfactionMails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSatisfactionMails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MailMemberHistoryLite[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MailMemberHistoryLite[] | null>;
        }));
    }

    protected processGetSatisfactionMails(response: HttpResponseBase): Observable<MailMemberHistoryLite[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MailMemberHistoryLite.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the satisfaction mail body.
     * @param id The mail identifier.
     * @return The mail.
     */
    getSatisfactionMail(id: number): Observable<MailMemberHistoryDetails | null> {
        let url_ = this.baseUrl + "/umbraco/Api/ClientFolder/GetSatisfactionMail/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSatisfactionMail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSatisfactionMail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MailMemberHistoryDetails | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MailMemberHistoryDetails | null>;
        }));
    }

    protected processGetSatisfactionMail(response: HttpResponseBase): Observable<MailMemberHistoryDetails | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? MailMemberHistoryDetails.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Send the manual satisfaction survey email.
     * @param anonymousSurveys The anonymous survey.
     */
    sendManualSurveyMail(anonymousSurveys: AnonymousSurveys | null): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/ClientFolder/SendManualSurveyMail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(anonymousSurveys);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendManualSurveyMail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendManualSurveyMail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendManualSurveyMail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class BiodyRepository {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Activates doctor Biody.
     * @param doctorBiodyInfo The doctor Biody information.
     * @return A Task representing the asynchronous operation.
     */
    activateBiody(doctorBiodyInfo: DoctorBiodyInformation | null): Observable<ResponseStatus> {
        let url_ = this.baseUrl + "/umbraco/Api/Biody/ActivateBiody";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(doctorBiodyInfo);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processActivateBiody(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processActivateBiody(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseStatus>;
        }));
    }

    protected processActivateBiody(response: HttpResponseBase): Observable<ResponseStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Connects doctor to biody.
     * @return A Task representing the asynchronous operation.
     */
    connectToBiody(): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/Biody/ConnectToBiody";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConnectToBiody(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConnectToBiody(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processConnectToBiody(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Imports the biody patients.
     * @return The list of unmatched biody patients
     */
    importBiodyPatients(): Observable<BiodyPatient[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Biody/ImportBiodyPatients";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportBiodyPatients(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportBiodyPatients(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BiodyPatient[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BiodyPatient[] | null>;
        }));
    }

    protected processImportBiodyPatients(response: HttpResponseBase): Observable<BiodyPatient[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BiodyPatient.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Links the biody patient.
     * @param biodyPatientId The biody identifier.
     * @param patientId The patient identifier.
     */
    linkBiodyPatient(biodyPatientId: number, patientId: number): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/Biody/LinkBiodyPatient/?biodyPatientId={biodyPatientId}&patientId={patientId}";
        if (biodyPatientId === undefined || biodyPatientId === null)
            throw new Error("The parameter 'biodyPatientId' must be defined.");
        url_ = url_.replace("{biodyPatientId}", encodeURIComponent("" + biodyPatientId));
        if (patientId === undefined || patientId === null)
            throw new Error("The parameter 'patientId' must be defined.");
        url_ = url_.replace("{patientId}", encodeURIComponent("" + patientId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLinkBiodyPatient(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLinkBiodyPatient(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processLinkBiodyPatient(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create the patients to biody.
     * @return The Task including a boolean determining if the patients have been created successfully
     */
    createBiodyPatients(): Observable<boolean> {
        let url_ = this.baseUrl + "/umbraco/Api/Biody/CreateBiodyPatients";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateBiodyPatients(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateBiodyPatients(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCreateBiodyPatients(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create the patient to Biody.
     * @param patientId The patient identifier.
     * @return The Task including a boolean determining if the patient have been created successfully
     */
    createBiodyPatient(patientId: number): Observable<boolean> {
        let url_ = this.baseUrl + "/umbraco/Api/Biody/CreateBiodyPatient/?patientId={patientId}";
        if (patientId === undefined || patientId === null)
            throw new Error("The parameter 'patientId' must be defined.");
        url_ = url_.replace("{patientId}", encodeURIComponent("" + patientId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateBiodyPatient(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateBiodyPatient(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCreateBiodyPatient(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the Biody login.
     * @return The Biody login.
     */
    getBiodyLogin(): Observable<string | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Biody/GetBiodyLogin";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBiodyLogin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBiodyLogin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string | null>;
        }));
    }

    protected processGetBiodyLogin(response: HttpResponseBase): Observable<string | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create the patient to Biody.
     * @param patientId The patient identifier.
     * @return The list of patient biody measurements
     */
    getBiodyPatientMeasurements(patientId: number): Observable<PatientBiodyMeasurement[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Biody/GetBiodyPatientMeasurements/?patientId={patientId}";
        if (patientId === undefined || patientId === null)
            throw new Error("The parameter 'patientId' must be defined.");
        url_ = url_.replace("{patientId}", encodeURIComponent("" + patientId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBiodyPatientMeasurements(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBiodyPatientMeasurements(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PatientBiodyMeasurement[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PatientBiodyMeasurement[] | null>;
        }));
    }

    protected processGetBiodyPatientMeasurements(response: HttpResponseBase): Observable<PatientBiodyMeasurement[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PatientBiodyMeasurement.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create the patient to Biody.
     * @return The list of patient biody measurements
     */
    getCurrentPatientBiodyMeasurements(): Observable<PatientBiodyMeasurement[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/Biody/GetCurrentPatientBiodyMeasurements";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentPatientBiodyMeasurements(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentPatientBiodyMeasurements(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PatientBiodyMeasurement[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PatientBiodyMeasurement[] | null>;
        }));
    }

    protected processGetCurrentPatientBiodyMeasurements(response: HttpResponseBase): Observable<PatientBiodyMeasurement[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PatientBiodyMeasurement.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create the patient to Biody.
     * @param patientId The patient identifier.
     * @return The list of patient biody measurements
     */
    importPatientMeasurements(patientId: number): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/Biody/ImportPatientMeasurements/?patientId={patientId}";
        if (patientId === undefined || patientId === null)
            throw new Error("The parameter 'patientId' must be defined.");
        url_ = url_.replace("{patientId}", encodeURIComponent("" + patientId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportPatientMeasurements(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportPatientMeasurements(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processImportPatientMeasurements(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class NutritionProgramRepository {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Adds a nutrition program food to a nutrition program.
     * @param food The food to add.
     */
    addNutritionProgramFood(food: NutritionProgramFoodDetails | null): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/NutritionProgram/AddNutritionProgramFood";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(food);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddNutritionProgramFood(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddNutritionProgramFood(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddNutritionProgramFood(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Adds the NutritionProgram to Patient.
     * @param nutritionProgramId The nutrition program id.
     * @param patientId The patient id.
     */
    addNutritionProgramToPatient(nutritionProgramId: number, patientId: number): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/NutritionProgram/AddNutritionProgramToPatient/?nutritionProgramId={nutritionProgramId}&patientId={patientId}";
        if (nutritionProgramId === undefined || nutritionProgramId === null)
            throw new Error("The parameter 'nutritionProgramId' must be defined.");
        url_ = url_.replace("{nutritionProgramId}", encodeURIComponent("" + nutritionProgramId));
        if (patientId === undefined || patientId === null)
            throw new Error("The parameter 'patientId' must be defined.");
        url_ = url_.replace("{patientId}", encodeURIComponent("" + patientId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddNutritionProgramToPatient(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddNutritionProgramToPatient(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddNutritionProgramToPatient(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Adds a nutrition program week to a nutrition program.
     * @param nutritionProgramId The nutrition program week.
     * @return The created week.
     */
    addNutritionProgramWeek(nutritionProgramId: number): Observable<NutritionProgramWeek | null> {
        let url_ = this.baseUrl + "/umbraco/Api/NutritionProgram/AddNutritionProgramWeek/?nutritionProgramId={nutritionProgramId}";
        if (nutritionProgramId === undefined || nutritionProgramId === null)
            throw new Error("The parameter 'nutritionProgramId' must be defined.");
        url_ = url_.replace("{nutritionProgramId}", encodeURIComponent("" + nutritionProgramId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddNutritionProgramWeek(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddNutritionProgramWeek(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NutritionProgramWeek | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NutritionProgramWeek | null>;
        }));
    }

    protected processAddNutritionProgramWeek(response: HttpResponseBase): Observable<NutritionProgramWeek | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? NutritionProgramWeek.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Creates a nutrition program.
     * @param nutritionProgram The nutrition program.
     */
    createNutritionProgram(nutritionProgram: CreateNutritionProgram | null): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/NutritionProgram/CreateNutritionProgram";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(nutritionProgram);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateNutritionProgram(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateNutritionProgram(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateNutritionProgram(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Deletes the nutrition program.
     * @param nutritionProgramId The nutrition program id.
     */
    deleteNutritionProgram(nutritionProgramId: number): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/NutritionProgram/DeleteNutritionProgram/?nutritionProgramId={nutritionProgramId}";
        if (nutritionProgramId === undefined || nutritionProgramId === null)
            throw new Error("The parameter 'nutritionProgramId' must be defined.");
        url_ = url_.replace("{nutritionProgramId}", encodeURIComponent("" + nutritionProgramId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteNutritionProgram(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteNutritionProgram(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteNutritionProgram(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Deletes the nutrition program food.
     * @param nutritionProgramFoodId The nutrition program food id.
     */
    deleteNutritionProgramFood(nutritionProgramFoodId: number): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/NutritionProgram/DeleteNutritionProgramFood/?nutritionProgramFoodId={nutritionProgramFoodId}";
        if (nutritionProgramFoodId === undefined || nutritionProgramFoodId === null)
            throw new Error("The parameter 'nutritionProgramFoodId' must be defined.");
        url_ = url_.replace("{nutritionProgramFoodId}", encodeURIComponent("" + nutritionProgramFoodId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteNutritionProgramFood(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteNutritionProgramFood(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteNutritionProgramFood(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Deletes the nutrition program week.
     * @param nutritionProgramWeekId The nutrition program week id.
     */
    deleteNutritionProgramWeek(nutritionProgramWeekId: number): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/NutritionProgram/DeleteNutritionProgramWeek/?nutritionProgramWeekId={nutritionProgramWeekId}";
        if (nutritionProgramWeekId === undefined || nutritionProgramWeekId === null)
            throw new Error("The parameter 'nutritionProgramWeekId' must be defined.");
        url_ = url_.replace("{nutritionProgramWeekId}", encodeURIComponent("" + nutritionProgramWeekId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteNutritionProgramWeek(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteNutritionProgramWeek(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteNutritionProgramWeek(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Duplicates the nutrition program week.
     * @param nutritionProgramId The nutrition program id.
     * @param nutritionProgramWeekId The nutrition program week id.
     */
    duplicateNutritionProgramWeek(nutritionProgramId: number, nutritionProgramWeekId: number): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/NutritionProgram/DuplicateNutritionProgramWeek/?nutritionProgramId={nutritionProgramId}&nutritionProgramWeekId={nutritionProgramWeekId}";
        if (nutritionProgramId === undefined || nutritionProgramId === null)
            throw new Error("The parameter 'nutritionProgramId' must be defined.");
        url_ = url_.replace("{nutritionProgramId}", encodeURIComponent("" + nutritionProgramId));
        if (nutritionProgramWeekId === undefined || nutritionProgramWeekId === null)
            throw new Error("The parameter 'nutritionProgramWeekId' must be defined.");
        url_ = url_.replace("{nutritionProgramWeekId}", encodeURIComponent("" + nutritionProgramWeekId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDuplicateNutritionProgramWeek(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDuplicateNutritionProgramWeek(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDuplicateNutritionProgramWeek(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Exports the nutrition program for printing.
     * @param nutritionProgramId The nutrition program id.
     * @return A nutrition program file
     */
    exportNutritionProgram(nutritionProgramId: number): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/umbraco/Api/NutritionProgram/ExportNutritionProgram/?nutritionProgramId={nutritionProgramId}";
        if (nutritionProgramId === undefined || nutritionProgramId === null)
            throw new Error("The parameter 'nutritionProgramId' must be defined.");
        url_ = url_.replace("{nutritionProgramId}", encodeURIComponent("" + nutritionProgramId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportNutritionProgram(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportNutritionProgram(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processExportNutritionProgram(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the nutrition program day nutrition info for doctor.
     * @param nutritionProgramDayId The nutrition program day id.
     * @return the nutrition program day nutrition info.
     */
    getDayNutritionInfo(nutritionProgramDayId: number): Observable<NutritionProgramNutritionInfo[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/NutritionProgram/GetDayNutritionInfo/?nutritionProgramDayId={nutritionProgramDayId}";
        if (nutritionProgramDayId === undefined || nutritionProgramDayId === null)
            throw new Error("The parameter 'nutritionProgramDayId' must be defined.");
        url_ = url_.replace("{nutritionProgramDayId}", encodeURIComponent("" + nutritionProgramDayId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDayNutritionInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDayNutritionInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NutritionProgramNutritionInfo[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NutritionProgramNutritionInfo[] | null>;
        }));
    }

    protected processGetDayNutritionInfo(response: HttpResponseBase): Observable<NutritionProgramNutritionInfo[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NutritionProgramNutritionInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the nutrition program meal nutrition info for doctor.
     * @param nutritionProgramMealId The nutrition program meal id.
     * @return the nutrition program meal nutrition info.
     */
    getMealNutritionInfo(nutritionProgramMealId: number): Observable<NutritionProgramNutritionInfo[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/NutritionProgram/GetMealNutritionInfo/?nutritionProgramMealId={nutritionProgramMealId}";
        if (nutritionProgramMealId === undefined || nutritionProgramMealId === null)
            throw new Error("The parameter 'nutritionProgramMealId' must be defined.");
        url_ = url_.replace("{nutritionProgramMealId}", encodeURIComponent("" + nutritionProgramMealId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMealNutritionInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMealNutritionInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NutritionProgramNutritionInfo[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NutritionProgramNutritionInfo[] | null>;
        }));
    }

    protected processGetMealNutritionInfo(response: HttpResponseBase): Observable<NutritionProgramNutritionInfo[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NutritionProgramNutritionInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the nutrition programs for doctor.
     * @param nutritionProgramId The nutrition program id.
     * @return the nutrition programs.
     */
    getNutritionProgram(nutritionProgramId: number): Observable<NutritionProgramDetails | null> {
        let url_ = this.baseUrl + "/umbraco/Api/NutritionProgram/GetNutritionProgram/?nutritionProgramId={nutritionProgramId}";
        if (nutritionProgramId === undefined || nutritionProgramId === null)
            throw new Error("The parameter 'nutritionProgramId' must be defined.");
        url_ = url_.replace("{nutritionProgramId}", encodeURIComponent("" + nutritionProgramId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNutritionProgram(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNutritionProgram(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NutritionProgramDetails | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NutritionProgramDetails | null>;
        }));
    }

    protected processGetNutritionProgram(response: HttpResponseBase): Observable<NutritionProgramDetails | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? NutritionProgramDetails.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the nutrition programs for doctor.
     * @param searchParams The nutrition program identifier.
     * @return the nutrition programs.
     */
    getNutritionPrograms(searchParams: NutritionProgramSearchParams | null): Observable<NutritionProgram[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/NutritionProgram/GetNutritionPrograms";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchParams);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNutritionPrograms(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNutritionPrograms(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NutritionProgram[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NutritionProgram[] | null>;
        }));
    }

    protected processGetNutritionPrograms(response: HttpResponseBase): Observable<NutritionProgram[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NutritionProgram.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the nutrition program details for library by id.
     * @param searchParams The nutrition program identifier.
     * @return The nutrition program.
     */
    getNutritionProgramsForLibrary(searchParams: NutritionProgramSearchParams | null): Observable<PaginatorWrapperOfIEnumerableOfNutritionProgram | null> {
        let url_ = this.baseUrl + "/umbraco/Api/NutritionProgram/GetNutritionProgramsForLibrary";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchParams);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNutritionProgramsForLibrary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNutritionProgramsForLibrary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaginatorWrapperOfIEnumerableOfNutritionProgram | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaginatorWrapperOfIEnumerableOfNutritionProgram | null>;
        }));
    }

    protected processGetNutritionProgramsForLibrary(response: HttpResponseBase): Observable<PaginatorWrapperOfIEnumerableOfNutritionProgram | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PaginatorWrapperOfIEnumerableOfNutritionProgram.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the nutrition programs week days.
     * @param weekId The week id.
     * @return the nutrition programs week days.
     */
    getNutritionProgramWeekDays(weekId: number): Observable<NutritionProgramDay[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/NutritionProgram/GetNutritionProgramWeekDays/?weekId={weekId}";
        if (weekId === undefined || weekId === null)
            throw new Error("The parameter 'weekId' must be defined.");
        url_ = url_.replace("{weekId}", encodeURIComponent("" + weekId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNutritionProgramWeekDays(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNutritionProgramWeekDays(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NutritionProgramDay[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NutritionProgramDay[] | null>;
        }));
    }

    protected processGetNutritionProgramWeekDays(response: HttpResponseBase): Observable<NutritionProgramDay[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NutritionProgramDay.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the nutrition programs for patient.
     * @return the nutrition programs.
     */
    getPatientNutritionPrograms(): Observable<NutritionProgram[] | null> {
        let url_ = this.baseUrl + "/umbraco/Api/NutritionProgram/GetPatientNutritionPrograms";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPatientNutritionPrograms(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPatientNutritionPrograms(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NutritionProgram[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NutritionProgram[] | null>;
        }));
    }

    protected processGetPatientNutritionPrograms(response: HttpResponseBase): Observable<NutritionProgram[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NutritionProgram.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Deletes the nutrition program.
     * @param nutritionProgramId The nutrition program id.
     */
    toggleNutritionProgramActivation(nutritionProgramId: number): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/NutritionProgram/ToggleNutritionProgramActivation/?nutritionProgramId={nutritionProgramId}";
        if (nutritionProgramId === undefined || nutritionProgramId === null)
            throw new Error("The parameter 'nutritionProgramId' must be defined.");
        url_ = url_.replace("{nutritionProgramId}", encodeURIComponent("" + nutritionProgramId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processToggleNutritionProgramActivation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processToggleNutritionProgramActivation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processToggleNutritionProgramActivation(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates the nutrition program food quantity.
     * @param foodId The food identifier.
     * @param quantity The quantity.
     */
    updateFoodQuantity(foodId: number, quantity: number): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/NutritionProgram/UpdateFoodQuantity/?foodId={foodId}&quantity={quantity}";
        if (foodId === undefined || foodId === null)
            throw new Error("The parameter 'foodId' must be defined.");
        url_ = url_.replace("{foodId}", encodeURIComponent("" + foodId));
        if (quantity === undefined || quantity === null)
            throw new Error("The parameter 'quantity' must be defined.");
        url_ = url_.replace("{quantity}", encodeURIComponent("" + quantity));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateFoodQuantity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateFoodQuantity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateFoodQuantity(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates the nutrition program food unit type.
     * @param foodId The food identifier.
     * @param unitTypeId The unit type id.
     */
    updateFoodUnitType(foodId: number, unitTypeId: number): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/NutritionProgram/UpdateFoodUnitType/?foodId={foodId}&unitTypeId={unitTypeId}";
        if (foodId === undefined || foodId === null)
            throw new Error("The parameter 'foodId' must be defined.");
        url_ = url_.replace("{foodId}", encodeURIComponent("" + foodId));
        if (unitTypeId === undefined || unitTypeId === null)
            throw new Error("The parameter 'unitTypeId' must be defined.");
        url_ = url_.replace("{unitTypeId}", encodeURIComponent("" + unitTypeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateFoodUnitType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateFoodUnitType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateFoodUnitType(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Reorders the weeks of a nutrition program id.
     * @param nutritionProgramId The nutrition program identifier.
     * @param nutritionProgramWeekId The nutrition program week identifier.
     * @param newPosition The position to reorder the week in.
     */
    reorderWeek(nutritionProgramId: number, nutritionProgramWeekId: number, newPosition: number): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/NutritionProgram/ReorderWeek/?nutritionProgramId={nutritionProgramId}&nutritionProgramWeekId={nutritionProgramWeekId}&newPosition={newPosition}";
        if (nutritionProgramId === undefined || nutritionProgramId === null)
            throw new Error("The parameter 'nutritionProgramId' must be defined.");
        url_ = url_.replace("{nutritionProgramId}", encodeURIComponent("" + nutritionProgramId));
        if (nutritionProgramWeekId === undefined || nutritionProgramWeekId === null)
            throw new Error("The parameter 'nutritionProgramWeekId' must be defined.");
        url_ = url_.replace("{nutritionProgramWeekId}", encodeURIComponent("" + nutritionProgramWeekId));
        if (newPosition === undefined || newPosition === null)
            throw new Error("The parameter 'newPosition' must be defined.");
        url_ = url_.replace("{newPosition}", encodeURIComponent("" + newPosition));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReorderWeek(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReorderWeek(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processReorderWeek(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates the nutrition program.
     * @param nutritionProgram The nutrition program.
     */
    updateNutritionProgram(nutritionProgram: NutritionProgram | null): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/NutritionProgram/UpdateNutritionProgram";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(nutritionProgram);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateNutritionProgram(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateNutritionProgram(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateNutritionProgram(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Duplicate a meal in a nutrition program.
     * @param nutritionProgramDuplicateMeal The nutrition program duplicate meal.
     */
    duplicateNutritionProgramMeal(nutritionProgramDuplicateMeal: NutritionProgramDuplicateMeal | null): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/NutritionProgram/DuplicateNutritionProgramMeal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(nutritionProgramDuplicateMeal);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDuplicateNutritionProgramMeal(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDuplicateNutritionProgramMeal(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDuplicateNutritionProgramMeal(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ConsultationInvoiceRepository {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Get all consultation invoices finalized.
     * @param searchParams The search parameters for consultation invoices.
     * @return The list of invoices in finalized state.
     */
    getAllConsultationInvoices(searchParams: SearchParamConsultationInvoice | null): Observable<PaginatorWrapperOfIEnumerableOfConsultationInvoice | null> {
        let url_ = this.baseUrl + "/umbraco/Api/ConsultationInvoice/GetAllConsultationInvoicesAsync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchParams);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllConsultationInvoices(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllConsultationInvoices(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaginatorWrapperOfIEnumerableOfConsultationInvoice | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaginatorWrapperOfIEnumerableOfConsultationInvoice | null>;
        }));
    }

    protected processGetAllConsultationInvoices(response: HttpResponseBase): Observable<PaginatorWrapperOfIEnumerableOfConsultationInvoice | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PaginatorWrapperOfIEnumerableOfConsultationInvoice.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all consultation invoices in draft state.
     * @param searchParams The search parameters for consultation invoices draft.
     * @return The list of invoices in draft state.
     */
    getConsultationInvoicesDraft(searchParams: SearchParamConsultationInvoiceDraft | null): Observable<PaginatorWrapperOfIEnumerableOfConsultationInvoice | null> {
        let url_ = this.baseUrl + "/umbraco/Api/ConsultationInvoice/GetConsultationInvoicesDraftAsync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchParams);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConsultationInvoicesDraft(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConsultationInvoicesDraft(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaginatorWrapperOfIEnumerableOfConsultationInvoice | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaginatorWrapperOfIEnumerableOfConsultationInvoice | null>;
        }));
    }

    protected processGetConsultationInvoicesDraft(response: HttpResponseBase): Observable<PaginatorWrapperOfIEnumerableOfConsultationInvoice | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PaginatorWrapperOfIEnumerableOfConsultationInvoice.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Validates the consultation invoice.
     * @param consultationInvoice The consultation invoice.
     * @return The response status.
     */
    validateConsultationInvoice(consultationInvoice: ConsultationInvoiceValidate | null): Observable<ResponseStatus> {
        let url_ = this.baseUrl + "/umbraco/Api/ConsultationInvoice/ValidateConsultationInvoiceAsync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(consultationInvoice);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidateConsultationInvoice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidateConsultationInvoice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseStatus>;
        }));
    }

    protected processValidateConsultationInvoice(response: HttpResponseBase): Observable<ResponseStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Set the consultation invoice visible for patient.
     * @param invoiceId The consultation invoice identifier.
     */
    setIsVisibleForPatient(invoiceId: number): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/ConsultationInvoice/SetIsVisibleForPatient/?invoiceId={invoiceId}";
        if (invoiceId === undefined || invoiceId === null)
            throw new Error("The parameter 'invoiceId' must be defined.");
        url_ = url_.replace("{invoiceId}", encodeURIComponent("" + invoiceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetIsVisibleForPatient(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetIsVisibleForPatient(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetIsVisibleForPatient(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Deletes the consultation invoice.
     * @param id The identifier.
     */
    deleteConsultationInvoice(id: number): Observable<void> {
        let url_ = this.baseUrl + "/umbraco/Api/ConsultationInvoice/DeleteConsultationInvoice/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteConsultationInvoice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteConsultationInvoice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteConsultationInvoice(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the zip of pdf files of the consultation invoice.
     * @param searchParams The search parameters for consultation invoices.
     * @return The zip pdf files.
     */
    getInvoicesZip(searchParams: SearchParamConsultationInvoice | null): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/umbraco/Api/ConsultationInvoice/GetInvoicesZip";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchParams);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInvoicesZip(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInvoicesZip(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processGetInvoicesZip(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the excel of the consultation invoice.
     * @param searchParams The search parameters for consultation invoices.
     * @return The excel file
     */
    getInvoicesExcel(searchParams: SearchParamConsultationInvoice | null): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/umbraco/Api/ConsultationInvoice/GetInvoicesExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchParams);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInvoicesExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInvoicesExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processGetInvoicesExcel(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Validates 50 next consultation invoices.
     * @return The response status.
     */
    validateNextConsultationInvoiceDrafts(): Observable<ResponseStatus> {
        let url_ = this.baseUrl + "/umbraco/Api/ConsultationInvoice/ValidateNextConsultationInvoiceDraftsAsync";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidateNextConsultationInvoiceDrafts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidateNextConsultationInvoiceDrafts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseStatus>;
        }));
    }

    protected processValidateNextConsultationInvoiceDrafts(response: HttpResponseBase): Observable<ResponseStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

/** Contains the definition of an object of type CreatePatientCoaching. */
export class CreatePatientCoaching implements ICreatePatientCoaching {
    /** Gets or sets the patient identifier. */
    patientId!: number;
    /** Gets or sets the coaching identifier. */
    coachingId!: number;

    constructor(data?: ICreatePatientCoaching) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.patientId = _data["patientId"];
            this.coachingId = _data["coachingId"];
        }
    }

    static fromJS(data: any): CreatePatientCoaching {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePatientCoaching();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["patientId"] = this.patientId;
        data["coachingId"] = this.coachingId;
        return data;
    }
}

/** Contains the definition of an object of type CreatePatientCoaching. */
export interface ICreatePatientCoaching {
    /** Gets or sets the patient identifier. */
    patientId: number;
    /** Gets or sets the coaching identifier. */
    coachingId: number;
}

/** Contains the definition of an object of type CoachingActivityBaseEdit. */
export class CoachingActivityBaseEdit implements ICoachingActivityBaseEdit {
    /** Gets or sets the allowed subscription levels. */
    allowedSubscriptionLevels?: number[] | undefined;
    /** Gets or sets the image identifier. */
    bannerName?: string | undefined;
    /** Gets or sets the image path. */
    bannerPath?: string | undefined;
    /** Gets or sets the image URL. */
    bannerUrl?: string | undefined;
    /** Gets or sets the description. */
    description?: string | undefined;
    /** Gets or sets the files. */
    files?: CoachingActivityMedia[] | undefined;
    /** Gets or sets the images. */
    images?: CoachingActivityMedia[] | undefined;
    /** Gets or sets the intention. */
    intention!: IntentionLevelType;
    /** Gets or sets the status. */
    status!: StatusCoachingActivity;
    /** Gets or sets the streaming element identifier. */
    streamingElementId?: number | undefined;
    /** Gets or sets the suggestible. */
    suggestible?: Suggestible | undefined;
    /** Gets or sets the suggestible identifier. */
    suggestibleId!: number;
    /** Gets or sets the suggestible source with entity names. */
    suggestibleSourceWithEntityNames?: SuggestibleSourceWithEntityName[] | undefined;
    /** Gets or sets the title. */
    title?: string | undefined;
    /** Gets or sets the upload banner. */
    uploadBanner?: any | undefined;
    /** Gets or sets the upload files. */
    uploadFiles?: any[] | undefined;
    /** Gets or sets the upload images. */
    uploadImages?: any[] | undefined;

    constructor(data?: ICoachingActivityBaseEdit) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["AllowedSubscriptionLevels"])) {
                this.allowedSubscriptionLevels = [] as any;
                for (let item of _data["AllowedSubscriptionLevels"])
                    this.allowedSubscriptionLevels!.push(item);
            }
            this.bannerName = _data["BannerName"];
            this.bannerPath = _data["BannerPath"];
            this.bannerUrl = _data["BannerUrl"];
            this.description = _data["Description"];
            if (Array.isArray(_data["Files"])) {
                this.files = [] as any;
                for (let item of _data["Files"])
                    this.files!.push(CoachingActivityMedia.fromJS(item));
            }
            if (Array.isArray(_data["Images"])) {
                this.images = [] as any;
                for (let item of _data["Images"])
                    this.images!.push(CoachingActivityMedia.fromJS(item));
            }
            this.intention = _data["Intention"];
            this.status = _data["Status"];
            this.streamingElementId = _data["StreamingElementId"];
            this.suggestible = _data["Suggestible"] ? Suggestible.fromJS(_data["Suggestible"]) : <any>undefined;
            this.suggestibleId = _data["SuggestibleId"];
            if (Array.isArray(_data["SuggestibleSourceWithEntityNames"])) {
                this.suggestibleSourceWithEntityNames = [] as any;
                for (let item of _data["SuggestibleSourceWithEntityNames"])
                    this.suggestibleSourceWithEntityNames!.push(SuggestibleSourceWithEntityName.fromJS(item));
            }
            this.title = _data["Title"];
            this.uploadBanner = _data["uploadBanner"];
            if (Array.isArray(_data["uploadFiles"])) {
                this.uploadFiles = [] as any;
                for (let item of _data["uploadFiles"])
                    this.uploadFiles!.push(item);
            }
            if (Array.isArray(_data["uploadImages"])) {
                this.uploadImages = [] as any;
                for (let item of _data["uploadImages"])
                    this.uploadImages!.push(item);
            }
        }
    }

    static fromJS(data: any): CoachingActivityBaseEdit {
        data = typeof data === 'object' ? data : {};
        let result = new CoachingActivityBaseEdit();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.allowedSubscriptionLevels)) {
            data["AllowedSubscriptionLevels"] = [];
            for (let item of this.allowedSubscriptionLevels)
                data["AllowedSubscriptionLevels"].push(item);
        }
        data["BannerName"] = this.bannerName;
        data["BannerPath"] = this.bannerPath;
        data["BannerUrl"] = this.bannerUrl;
        data["Description"] = this.description;
        if (Array.isArray(this.files)) {
            data["Files"] = [];
            for (let item of this.files)
                data["Files"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.images)) {
            data["Images"] = [];
            for (let item of this.images)
                data["Images"].push(item ? item.toJSON() : <any>undefined);
        }
        data["Intention"] = this.intention;
        data["Status"] = this.status;
        data["StreamingElementId"] = this.streamingElementId;
        data["Suggestible"] = this.suggestible ? this.suggestible.toJSON() : <any>undefined;
        data["SuggestibleId"] = this.suggestibleId;
        if (Array.isArray(this.suggestibleSourceWithEntityNames)) {
            data["SuggestibleSourceWithEntityNames"] = [];
            for (let item of this.suggestibleSourceWithEntityNames)
                data["SuggestibleSourceWithEntityNames"].push(item ? item.toJSON() : <any>undefined);
        }
        data["Title"] = this.title;
        data["uploadBanner"] = this.uploadBanner;
        if (Array.isArray(this.uploadFiles)) {
            data["uploadFiles"] = [];
            for (let item of this.uploadFiles)
                data["uploadFiles"].push(item);
        }
        if (Array.isArray(this.uploadImages)) {
            data["uploadImages"] = [];
            for (let item of this.uploadImages)
                data["uploadImages"].push(item);
        }
        return data;
    }
}

/** Contains the definition of an object of type CoachingActivityBaseEdit. */
export interface ICoachingActivityBaseEdit {
    /** Gets or sets the allowed subscription levels. */
    allowedSubscriptionLevels?: number[] | undefined;
    /** Gets or sets the image identifier. */
    bannerName?: string | undefined;
    /** Gets or sets the image path. */
    bannerPath?: string | undefined;
    /** Gets or sets the image URL. */
    bannerUrl?: string | undefined;
    /** Gets or sets the description. */
    description?: string | undefined;
    /** Gets or sets the files. */
    files?: CoachingActivityMedia[] | undefined;
    /** Gets or sets the images. */
    images?: CoachingActivityMedia[] | undefined;
    /** Gets or sets the intention. */
    intention: IntentionLevelType;
    /** Gets or sets the status. */
    status: StatusCoachingActivity;
    /** Gets or sets the streaming element identifier. */
    streamingElementId?: number | undefined;
    /** Gets or sets the suggestible. */
    suggestible?: Suggestible | undefined;
    /** Gets or sets the suggestible identifier. */
    suggestibleId: number;
    /** Gets or sets the suggestible source with entity names. */
    suggestibleSourceWithEntityNames?: SuggestibleSourceWithEntityName[] | undefined;
    /** Gets or sets the title. */
    title?: string | undefined;
    /** Gets or sets the upload banner. */
    uploadBanner?: any | undefined;
    /** Gets or sets the upload files. */
    uploadFiles?: any[] | undefined;
    /** Gets or sets the upload images. */
    uploadImages?: any[] | undefined;
}

/** Contains the definition of an object of type CreateCoachingActivity. */
export class CreateCoachingActivity extends CoachingActivityBaseEdit implements ICreateCoachingActivity {

    constructor(data?: ICreateCoachingActivity) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): CreateCoachingActivity {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCoachingActivity();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type CreateCoachingActivity. */
export interface ICreateCoachingActivity extends ICoachingActivityBaseEdit {
}

/** Contains the definition of an object of type CoachingActivityMedia. */
export class CoachingActivityMedia implements ICoachingActivityMedia {
    /** Gets or sets the identifier. */
    id!: number;
    /** Gets or sets the name. */
    name?: string | undefined;
    /** Gets or sets the URL. */
    url?: string | undefined;

    constructor(data?: ICoachingActivityMedia) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.url = _data["url"];
        }
    }

    static fromJS(data: any): CoachingActivityMedia {
        data = typeof data === 'object' ? data : {};
        let result = new CoachingActivityMedia();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["url"] = this.url;
        return data;
    }
}

/** Contains the definition of an object of type CoachingActivityMedia. */
export interface ICoachingActivityMedia {
    /** Gets or sets the identifier. */
    id: number;
    /** Gets or sets the name. */
    name?: string | undefined;
    /** Gets or sets the URL. */
    url?: string | undefined;
}

/** Contains the definition of an object of type IntentionLevelType. */
export enum IntentionLevelType {
    Unknow = 0,
    FirstIntention = 1,
    SecondIntention = 2,
}

/** Contains the definition of an object of type StatusCoachingActivity. */
export enum StatusCoachingActivity {
    Unknown = 0,
    Published = 1,
    Unpublished = 2,
    InProgress = 3,
}

/** Contains the definition of an object of type Suggestible */
export class Suggestible implements ISuggestible {
    /** Gets or sets the biological exam identifier. */
    biologicalExamId?: number | undefined;
    /** Gets or sets the coaching activity identifier. */
    coachingActivityId?: number | undefined;
    /** Gets or sets the coaching identifier. */
    coachingId?: number | undefined;
    /** Gets or sets the complementary exam identifier. */
    complementaryExamId?: number | undefined;
    /** Gets or sets the consultationtype identifier. */
    consultationTypeId?: number | undefined;
    /** Gets or sets the identifier. */
    id!: number;
    /** Gets or sets the sources. */
    sources?: SuggestibleSuggestibleSource[] | undefined;
    /** Gets or sets the suggestion identifier. */
    suggestionId?: number | undefined;
    /** Gets or sets the type of the suggestible. */
    suggestibleType!: SuggestibleType;
    /** Gets or sets the formulary version identifier. */
    formularyVersionId?: number | undefined;
    /** Gets or sets the nutrient identifier. */
    nutrientId?: number | undefined;

    constructor(data?: ISuggestible) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.biologicalExamId = _data["biologicalExamId"];
            this.coachingActivityId = _data["coachingActivityId"];
            this.coachingId = _data["coachingId"];
            this.complementaryExamId = _data["complementaryExamId"];
            this.consultationTypeId = _data["consultationTypeId"];
            this.id = _data["id"];
            if (Array.isArray(_data["sources"])) {
                this.sources = [] as any;
                for (let item of _data["sources"])
                    this.sources!.push(SuggestibleSuggestibleSource.fromJS(item));
            }
            this.suggestionId = _data["suggestionId"];
            this.suggestibleType = _data["suggestibleType"];
            this.formularyVersionId = _data["formularyVersionId"];
            this.nutrientId = _data["nutrientId"];
        }
    }

    static fromJS(data: any): Suggestible {
        data = typeof data === 'object' ? data : {};
        let result = new Suggestible();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["biologicalExamId"] = this.biologicalExamId;
        data["coachingActivityId"] = this.coachingActivityId;
        data["coachingId"] = this.coachingId;
        data["complementaryExamId"] = this.complementaryExamId;
        data["consultationTypeId"] = this.consultationTypeId;
        data["id"] = this.id;
        if (Array.isArray(this.sources)) {
            data["sources"] = [];
            for (let item of this.sources)
                data["sources"].push(item ? item.toJSON() : <any>undefined);
        }
        data["suggestionId"] = this.suggestionId;
        data["suggestibleType"] = this.suggestibleType;
        data["formularyVersionId"] = this.formularyVersionId;
        data["nutrientId"] = this.nutrientId;
        return data;
    }
}

/** Contains the definition of an object of type Suggestible */
export interface ISuggestible {
    /** Gets or sets the biological exam identifier. */
    biologicalExamId?: number | undefined;
    /** Gets or sets the coaching activity identifier. */
    coachingActivityId?: number | undefined;
    /** Gets or sets the coaching identifier. */
    coachingId?: number | undefined;
    /** Gets or sets the complementary exam identifier. */
    complementaryExamId?: number | undefined;
    /** Gets or sets the consultationtype identifier. */
    consultationTypeId?: number | undefined;
    /** Gets or sets the identifier. */
    id: number;
    /** Gets or sets the sources. */
    sources?: SuggestibleSuggestibleSource[] | undefined;
    /** Gets or sets the suggestion identifier. */
    suggestionId?: number | undefined;
    /** Gets or sets the type of the suggestible. */
    suggestibleType: SuggestibleType;
    /** Gets or sets the formulary version identifier. */
    formularyVersionId?: number | undefined;
    /** Gets or sets the nutrient identifier. */
    nutrientId?: number | undefined;
}

/** Contains the definition of an object of type SuggestibleSuggestibleSource */
export class SuggestibleSuggestibleSource implements ISuggestibleSuggestibleSource {
    /** Gets or sets a value indicating whether this instance is exclussion. */
    isExclusion!: boolean;
    /** Gets or sets the suggestible identifier. */
    suggestibleId!: number;
    /** Gets or sets the suggestible source. */
    suggestibleSource?: SuggestibleSource | undefined;
    /** Gets or sets the suggestible source identifier. */
    suggestibleSourceId!: number;

    constructor(data?: ISuggestibleSuggestibleSource) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isExclusion = _data["isExclusion"];
            this.suggestibleId = _data["suggestibleId"];
            this.suggestibleSource = _data["suggestibleSource"] ? SuggestibleSource.fromJS(_data["suggestibleSource"]) : <any>undefined;
            this.suggestibleSourceId = _data["suggestibleSourceId"];
        }
    }

    static fromJS(data: any): SuggestibleSuggestibleSource {
        data = typeof data === 'object' ? data : {};
        let result = new SuggestibleSuggestibleSource();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isExclusion"] = this.isExclusion;
        data["suggestibleId"] = this.suggestibleId;
        data["suggestibleSource"] = this.suggestibleSource ? this.suggestibleSource.toJSON() : <any>undefined;
        data["suggestibleSourceId"] = this.suggestibleSourceId;
        return data;
    }
}

/** Contains the definition of an object of type SuggestibleSuggestibleSource */
export interface ISuggestibleSuggestibleSource {
    /** Gets or sets a value indicating whether this instance is exclussion. */
    isExclusion: boolean;
    /** Gets or sets the suggestible identifier. */
    suggestibleId: number;
    /** Gets or sets the suggestible source. */
    suggestibleSource?: SuggestibleSource | undefined;
    /** Gets or sets the suggestible source identifier. */
    suggestibleSourceId: number;
}

/** Contains the definition of an object of type SuggestibleSource */
export class SuggestibleSource implements ISuggestibleSource {
    /** Gets or sets the allergen identifier. */
    allergenId?: number | undefined;
    /** Gets or sets the consultation reason identifier. */
    consultationReasonId?: number | undefined;
    /** Gets or sets the disease identifier. */
    diseaseId?: number | undefined;
    /** Gets or sets the food category identifier. */
    foodCategoryId?: number | undefined;
    /** Gets or sets the food identifier. */
    foodId?: number | undefined;
    /** Gets or sets the identifier. */
    id!: number;
    /** Gets or sets the medical history identifier. */
    personnalMedicalHistoryId?: number | undefined;
    /** Gets or sets the siin allergy identifier. */
    siinAllergyId?: number | undefined;
    /** Gets or sets the type of the suggestible source. */
    suggestibleSourceType!: SuggestibleSourceType;

    constructor(data?: ISuggestibleSource) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.allergenId = _data["allergenId"];
            this.consultationReasonId = _data["consultationReasonId"];
            this.diseaseId = _data["diseaseId"];
            this.foodCategoryId = _data["foodCategoryId"];
            this.foodId = _data["foodId"];
            this.id = _data["id"];
            this.personnalMedicalHistoryId = _data["personnalMedicalHistoryId"];
            this.siinAllergyId = _data["siinAllergyId"];
            this.suggestibleSourceType = _data["suggestibleSourceType"];
        }
    }

    static fromJS(data: any): SuggestibleSource {
        data = typeof data === 'object' ? data : {};
        let result = new SuggestibleSource();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["allergenId"] = this.allergenId;
        data["consultationReasonId"] = this.consultationReasonId;
        data["diseaseId"] = this.diseaseId;
        data["foodCategoryId"] = this.foodCategoryId;
        data["foodId"] = this.foodId;
        data["id"] = this.id;
        data["personnalMedicalHistoryId"] = this.personnalMedicalHistoryId;
        data["siinAllergyId"] = this.siinAllergyId;
        data["suggestibleSourceType"] = this.suggestibleSourceType;
        return data;
    }
}

/** Contains the definition of an object of type SuggestibleSource */
export interface ISuggestibleSource {
    /** Gets or sets the allergen identifier. */
    allergenId?: number | undefined;
    /** Gets or sets the consultation reason identifier. */
    consultationReasonId?: number | undefined;
    /** Gets or sets the disease identifier. */
    diseaseId?: number | undefined;
    /** Gets or sets the food category identifier. */
    foodCategoryId?: number | undefined;
    /** Gets or sets the food identifier. */
    foodId?: number | undefined;
    /** Gets or sets the identifier. */
    id: number;
    /** Gets or sets the medical history identifier. */
    personnalMedicalHistoryId?: number | undefined;
    /** Gets or sets the siin allergy identifier. */
    siinAllergyId?: number | undefined;
    /** Gets or sets the type of the suggestible source. */
    suggestibleSourceType: SuggestibleSourceType;
}

/** Contains the definition of an object of type SuggestibleSourceType */
export enum SuggestibleSourceType {
    Unknown = 0,
    Disease = 1,
    DiseaseFirstIntention = 2,
    DiseaseSecondIntention = 3,
    PersonnalMedicalHistory = 4,
    PersonnalMedicalHistoryFirstIntention = 5,
    PersonnalMedicalHistorySecondIntention = 6,
    SiinAllergy = 7,
    SiinAllergyFirstIntention = 8,
    SiinAllergySecondIntention = 9,
    FoodCategory = 10,
    FoodCategoryFirstIntention = 11,
    FoodCategorySecondIntention = 12,
    Food = 13,
    FoodFirstIntention = 14,
    FoodSecondIntention = 15,
    Allergen = 16,
    AllergenFirstIntention = 17,
    AllergenSecondIntention = 18,
    ConsultationReason = 19,
    ConsultationReasonFirstIntention = 20,
    ConsultationReasonSecondIntention = 21,
    ConsultationConfig = 22,
}

/** Contains the definition of an object of type SuggestibleType */
export enum SuggestibleType {
    Unknown = 0,
    Activity = 1,
    Coaching = 3,
    Suggestion = 4,
    BiologicalExam = 5,
    ComplementaryExam = 6,
    FormularyVersion = 7,
    Orientation = 8,
    Nutrient = 9,
    Recipe = 10,
}

/** Contains the definition of an object of type SuggestibleSourceWithEntityName. */
export class SuggestibleSourceWithEntityName implements ISuggestibleSourceWithEntityName {
    /** Gets or sets the type of the source. */
    sourceType!: SuggestibleSourceType;
    /** Gets or sets the suggestible source identifier. */
    suggestibleSourceId!: number;
    /** Gets or sets the entity identifier. */
    entityId?: number | undefined;
    /** Gets or sets the name. */
    name?: string | undefined;

    constructor(data?: ISuggestibleSourceWithEntityName) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sourceType = _data["sourceType"];
            this.suggestibleSourceId = _data["suggestibleSourceId"];
            this.entityId = _data["entityId"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): SuggestibleSourceWithEntityName {
        data = typeof data === 'object' ? data : {};
        let result = new SuggestibleSourceWithEntityName();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sourceType"] = this.sourceType;
        data["suggestibleSourceId"] = this.suggestibleSourceId;
        data["entityId"] = this.entityId;
        data["name"] = this.name;
        return data;
    }
}

/** Contains the definition of an object of type SuggestibleSourceWithEntityName. */
export interface ISuggestibleSourceWithEntityName {
    /** Gets or sets the type of the source. */
    sourceType: SuggestibleSourceType;
    /** Gets or sets the suggestible source identifier. */
    suggestibleSourceId: number;
    /** Gets or sets the entity identifier. */
    entityId?: number | undefined;
    /** Gets or sets the name. */
    name?: string | undefined;
}

/** Contains the definition of an object of type Coaching. */
export class Coaching implements ICoaching {
    /** Gets or sets the identifier. */
    id!: number;
    /** Gets or sets the publication status. */
    status!: StatusCoaching;
    /** Gets or sets the title. */
    title?: string | undefined;
    /** Gets or sets the type. */
    type!: number;
    /** Gets or sets the name of the type. */
    typeName?: string | undefined;
    /** Gets or sets the description. */
    description?: string | undefined;

    constructor(data?: ICoaching) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.status = _data["status"];
            this.title = _data["title"];
            this.type = _data["type"];
            this.typeName = _data["typeName"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): Coaching {
        data = typeof data === 'object' ? data : {};
        let result = new Coaching();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["status"] = this.status;
        data["title"] = this.title;
        data["type"] = this.type;
        data["typeName"] = this.typeName;
        data["description"] = this.description;
        return data;
    }
}

/** Contains the definition of an object of type Coaching. */
export interface ICoaching {
    /** Gets or sets the identifier. */
    id: number;
    /** Gets or sets the publication status. */
    status: StatusCoaching;
    /** Gets or sets the title. */
    title?: string | undefined;
    /** Gets or sets the type. */
    type: number;
    /** Gets or sets the name of the type. */
    typeName?: string | undefined;
    /** Gets or sets the description. */
    description?: string | undefined;
}

/** Contains the definition of an object of type CoachingDetails. */
export class CoachingDetails extends Coaching implements ICoachingDetails {
    /** Gets or sets the activities. */
    activities?: CoachingCoachingActivity[] | undefined;
    /** Gets or sets the recipes. */
    recipes?: CoachingCoachingRecipe[] | undefined;
    /** Gets or sets the suggestions. */
    suggestions?: CoachingSuggestion[] | undefined;
    /** Gets or sets the suggestible. */
    suggestible?: Suggestible | undefined;

    constructor(data?: ICoachingDetails) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["activities"])) {
                this.activities = [] as any;
                for (let item of _data["activities"])
                    this.activities!.push(CoachingCoachingActivity.fromJS(item));
            }
            if (Array.isArray(_data["recipes"])) {
                this.recipes = [] as any;
                for (let item of _data["recipes"])
                    this.recipes!.push(CoachingCoachingRecipe.fromJS(item));
            }
            if (Array.isArray(_data["suggestions"])) {
                this.suggestions = [] as any;
                for (let item of _data["suggestions"])
                    this.suggestions!.push(CoachingSuggestion.fromJS(item));
            }
            this.suggestible = _data["suggestible"] ? Suggestible.fromJS(_data["suggestible"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): CoachingDetails {
        data = typeof data === 'object' ? data : {};
        let result = new CoachingDetails();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.activities)) {
            data["activities"] = [];
            for (let item of this.activities)
                data["activities"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.recipes)) {
            data["recipes"] = [];
            for (let item of this.recipes)
                data["recipes"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.suggestions)) {
            data["suggestions"] = [];
            for (let item of this.suggestions)
                data["suggestions"].push(item ? item.toJSON() : <any>undefined);
        }
        data["suggestible"] = this.suggestible ? this.suggestible.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type CoachingDetails. */
export interface ICoachingDetails extends ICoaching {
    /** Gets or sets the activities. */
    activities?: CoachingCoachingActivity[] | undefined;
    /** Gets or sets the recipes. */
    recipes?: CoachingCoachingRecipe[] | undefined;
    /** Gets or sets the suggestions. */
    suggestions?: CoachingSuggestion[] | undefined;
    /** Gets or sets the suggestible. */
    suggestible?: Suggestible | undefined;
}

/** Contains the definition of an object of type CoachingCoachingActivity. */
export class CoachingCoachingActivity implements ICoachingCoachingActivity {
    /** Gets or sets the activation days. */
    activationDays?: number | undefined;
    /** Gets or sets the activity identifier. */
    activityId!: number;
    /** Gets or sets the coaching identifier. */
    coachingId!: number;
    /** Gets a value indicating whether this instance is activation days. */
    isActivationDays!: boolean;
    /** Gets a value indicating whether this instance is periodicity. */
    isPeriodicity!: boolean;
    /** Gets or sets the periodicity. */
    periodicity?: Periodicity | undefined;

    constructor(data?: ICoachingCoachingActivity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.activationDays = _data["activationDays"];
            this.activityId = _data["activityId"];
            this.coachingId = _data["coachingId"];
            this.isActivationDays = _data["isActivationDays"];
            this.isPeriodicity = _data["isPeriodicity"];
            this.periodicity = _data["periodicity"] ? Periodicity.fromJS(_data["periodicity"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CoachingCoachingActivity {
        data = typeof data === 'object' ? data : {};
        let result = new CoachingCoachingActivity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activationDays"] = this.activationDays;
        data["activityId"] = this.activityId;
        data["coachingId"] = this.coachingId;
        data["isActivationDays"] = this.isActivationDays;
        data["isPeriodicity"] = this.isPeriodicity;
        data["periodicity"] = this.periodicity ? this.periodicity.toJSON() : <any>undefined;
        return data;
    }
}

/** Contains the definition of an object of type CoachingCoachingActivity. */
export interface ICoachingCoachingActivity {
    /** Gets or sets the activation days. */
    activationDays?: number | undefined;
    /** Gets or sets the activity identifier. */
    activityId: number;
    /** Gets or sets the coaching identifier. */
    coachingId: number;
    /** Gets a value indicating whether this instance is activation days. */
    isActivationDays: boolean;
    /** Gets a value indicating whether this instance is periodicity. */
    isPeriodicity: boolean;
    /** Gets or sets the periodicity. */
    periodicity?: Periodicity | undefined;
}

/** Contains the definition of an object of type Periodicity. */
export class Periodicity implements IPeriodicity {
    /** Gets or sets the monthly. */
    monthly?: MonthlyPeriodicity | undefined;
    /** Gets or sets the type. */
    type!: PeriodicityType;
    /** Gets or sets the weekly. */
    weekly?: Days[] | undefined;

    constructor(data?: IPeriodicity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.monthly = _data["monthly"] ? MonthlyPeriodicity.fromJS(_data["monthly"]) : <any>undefined;
            this.type = _data["type"];
            if (Array.isArray(_data["weekly"])) {
                this.weekly = [] as any;
                for (let item of _data["weekly"])
                    this.weekly!.push(item);
            }
        }
    }

    static fromJS(data: any): Periodicity {
        data = typeof data === 'object' ? data : {};
        let result = new Periodicity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["monthly"] = this.monthly ? this.monthly.toJSON() : <any>undefined;
        data["type"] = this.type;
        if (Array.isArray(this.weekly)) {
            data["weekly"] = [];
            for (let item of this.weekly)
                data["weekly"].push(item);
        }
        return data;
    }
}

/** Contains the definition of an object of type Periodicity. */
export interface IPeriodicity {
    /** Gets or sets the monthly. */
    monthly?: MonthlyPeriodicity | undefined;
    /** Gets or sets the type. */
    type: PeriodicityType;
    /** Gets or sets the weekly. */
    weekly?: Days[] | undefined;
}

/** Contains the definition of an object of type MonthlyPeriodicity. */
export class MonthlyPeriodicity implements IMonthlyPeriodicity {
    /** Gets or sets the day. */
    day!: Days;
    /** Gets or sets the week. */
    week!: WeekOrder;

    constructor(data?: IMonthlyPeriodicity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.day = _data["day"];
            this.week = _data["week"];
        }
    }

    static fromJS(data: any): MonthlyPeriodicity {
        data = typeof data === 'object' ? data : {};
        let result = new MonthlyPeriodicity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["day"] = this.day;
        data["week"] = this.week;
        return data;
    }
}

/** Contains the definition of an object of type MonthlyPeriodicity. */
export interface IMonthlyPeriodicity {
    /** Gets or sets the day. */
    day: Days;
    /** Gets or sets the week. */
    week: WeekOrder;
}

/** Contains the definition of an object of type Days. */
export enum Days {
    Unknown = 0,
    Monday = 1,
    Tuesday = 2,
    Wednesday = 3,
    Thursday = 4,
    Friday = 5,
    Saturday = 6,
    Sunday = 7,
}

/** Contains the definition of an object of type WeekOrder. */
export enum WeekOrder {
    Unknown = 0,
    First = 1,
    Second = 2,
    Third = 3,
    Fourth = 4,
    Last = 5,
}

/** Contains the definition of an object of type PeriodicityType. */
export enum PeriodicityType {
    Unknown = 0,
    Weekly = 1,
    Monthly = 2,
}

/** Contains the definition of an object of type CoachingCoachingRecipe. */
export class CoachingCoachingRecipe implements ICoachingCoachingRecipe {
    /** Gets or sets the activation days. */
    activationDays?: number | undefined;
    /** Gets or sets the recipe identifier. */
    recipeId!: number;
    /** Gets or sets the coaching identifier. */
    coachingId!: number;
    /** Gets a value indicating whether this instance is activation days. */
    isActivationDays!: boolean;
    /** Gets a value indicating whether this instance is periodicity. */
    isPeriodicity!: boolean;
    /** Gets or sets the periodicity. */
    periodicity?: Periodicity | undefined;

    constructor(data?: ICoachingCoachingRecipe) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.activationDays = _data["activationDays"];
            this.recipeId = _data["recipeId"];
            this.coachingId = _data["coachingId"];
            this.isActivationDays = _data["isActivationDays"];
            this.isPeriodicity = _data["isPeriodicity"];
            this.periodicity = _data["periodicity"] ? Periodicity.fromJS(_data["periodicity"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CoachingCoachingRecipe {
        data = typeof data === 'object' ? data : {};
        let result = new CoachingCoachingRecipe();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activationDays"] = this.activationDays;
        data["recipeId"] = this.recipeId;
        data["coachingId"] = this.coachingId;
        data["isActivationDays"] = this.isActivationDays;
        data["isPeriodicity"] = this.isPeriodicity;
        data["periodicity"] = this.periodicity ? this.periodicity.toJSON() : <any>undefined;
        return data;
    }
}

/** Contains the definition of an object of type CoachingCoachingRecipe. */
export interface ICoachingCoachingRecipe {
    /** Gets or sets the activation days. */
    activationDays?: number | undefined;
    /** Gets or sets the recipe identifier. */
    recipeId: number;
    /** Gets or sets the coaching identifier. */
    coachingId: number;
    /** Gets a value indicating whether this instance is activation days. */
    isActivationDays: boolean;
    /** Gets a value indicating whether this instance is periodicity. */
    isPeriodicity: boolean;
    /** Gets or sets the periodicity. */
    periodicity?: Periodicity | undefined;
}

/** Contains the definition of an object of type Coaching Suggestion */
export class CoachingSuggestion implements ICoachingSuggestion {
    /** Gets or sets the activation days. */
    activationDays?: number | undefined;
    /** Gets or sets the coaching identifier. */
    coachingId!: number;
    /** Gets a value indicating whether this instance is activation days. */
    isActivationDays!: boolean;
    /** Gets a value indicating whether this instance is periodicity. */
    isPeriodicity!: boolean;
    /** Gets or sets the periodicity. */
    periodicity?: Periodicity | undefined;
    /** Gets or sets the suggestion identifier. */
    suggestionId!: number;

    constructor(data?: ICoachingSuggestion) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.activationDays = _data["activationDays"];
            this.coachingId = _data["coachingId"];
            this.isActivationDays = _data["isActivationDays"];
            this.isPeriodicity = _data["isPeriodicity"];
            this.periodicity = _data["periodicity"] ? Periodicity.fromJS(_data["periodicity"]) : <any>undefined;
            this.suggestionId = _data["suggestionId"];
        }
    }

    static fromJS(data: any): CoachingSuggestion {
        data = typeof data === 'object' ? data : {};
        let result = new CoachingSuggestion();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activationDays"] = this.activationDays;
        data["coachingId"] = this.coachingId;
        data["isActivationDays"] = this.isActivationDays;
        data["isPeriodicity"] = this.isPeriodicity;
        data["periodicity"] = this.periodicity ? this.periodicity.toJSON() : <any>undefined;
        data["suggestionId"] = this.suggestionId;
        return data;
    }
}

/** Contains the definition of an object of type Coaching Suggestion */
export interface ICoachingSuggestion {
    /** Gets or sets the activation days. */
    activationDays?: number | undefined;
    /** Gets or sets the coaching identifier. */
    coachingId: number;
    /** Gets a value indicating whether this instance is activation days. */
    isActivationDays: boolean;
    /** Gets a value indicating whether this instance is periodicity. */
    isPeriodicity: boolean;
    /** Gets or sets the periodicity. */
    periodicity?: Periodicity | undefined;
    /** Gets or sets the suggestion identifier. */
    suggestionId: number;
}

/** Contains the definition of an object of type StatusCoaching. */
export enum StatusCoaching {
    Unknown = 0,
    Published = 1,
    Unpublished = 2,
    InProgress = 3,
}

/** Contains the definition of an object of type CoachingRecipeBaseEdit. */
export class CoachingRecipeBaseEdit implements ICoachingRecipeBaseEdit {
    /** Gets or sets the title. */
    title?: string | undefined;
    /** Gets or sets a value indicating whether this instance is spotlighted. */
    isSpotlighted!: boolean;
    /** Gets or sets the upload image. */
    uploadImage?: any | undefined;
    /** Gets or sets the dish type identifier. */
    dishTypes?: number[] | undefined;
    /** Gets or sets the dietary plan. */
    dietaryPlans?: number[] | undefined;
    /** Gets or sets the eco responsability. */
    ecoResponsabilities?: number[] | undefined;
    /** Gets or sets the zoom sections. */
    zoomSections?: CoachingRecipeZoomSection[] | undefined;
    /** Gets or sets the promoted nutrients. */
    promotedNutrients?: PromotedNutrient[] | undefined;
    /** Gets or sets the status. */
    status!: CoachingRecipeStatus;
    /** Gets or sets the description. */
    description?: string | undefined;
    /** Gets or sets the nb person. */
    nbPerson!: number;
    /** Gets or sets the Facility. */
    facility!: number;
    /** Gets or sets the description. */
    duration!: number;
    /** Gets or sets the coaching recipe seasons. */
    seasons?: CoachingRecipeSeason[] | undefined;
    /** Gets or sets the allergens. */
    allergens?: CoachingRecipeAllergen[] | undefined;
    /** Gets or sets the streaming element identifier. */
    streamingElementId?: number | undefined;
    /** Gets or sets a value indicating whether this instance is active. */
    isArchived!: boolean;

    constructor(data?: ICoachingRecipeBaseEdit) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.isSpotlighted = _data["isSpotlighted"];
            this.uploadImage = _data["uploadImage"];
            if (Array.isArray(_data["dishTypes"])) {
                this.dishTypes = [] as any;
                for (let item of _data["dishTypes"])
                    this.dishTypes!.push(item);
            }
            if (Array.isArray(_data["dietaryPlans"])) {
                this.dietaryPlans = [] as any;
                for (let item of _data["dietaryPlans"])
                    this.dietaryPlans!.push(item);
            }
            if (Array.isArray(_data["ecoResponsabilities"])) {
                this.ecoResponsabilities = [] as any;
                for (let item of _data["ecoResponsabilities"])
                    this.ecoResponsabilities!.push(item);
            }
            if (Array.isArray(_data["zoomSections"])) {
                this.zoomSections = [] as any;
                for (let item of _data["zoomSections"])
                    this.zoomSections!.push(CoachingRecipeZoomSection.fromJS(item));
            }
            if (Array.isArray(_data["promotedNutrients"])) {
                this.promotedNutrients = [] as any;
                for (let item of _data["promotedNutrients"])
                    this.promotedNutrients!.push(PromotedNutrient.fromJS(item));
            }
            this.status = _data["status"];
            this.description = _data["description"];
            this.nbPerson = _data["nbPerson"];
            this.facility = _data["facility"];
            this.duration = _data["duration"];
            if (Array.isArray(_data["seasons"])) {
                this.seasons = [] as any;
                for (let item of _data["seasons"])
                    this.seasons!.push(CoachingRecipeSeason.fromJS(item));
            }
            if (Array.isArray(_data["allergens"])) {
                this.allergens = [] as any;
                for (let item of _data["allergens"])
                    this.allergens!.push(CoachingRecipeAllergen.fromJS(item));
            }
            this.streamingElementId = _data["streamingElementId"];
            this.isArchived = _data["isArchived"];
        }
    }

    static fromJS(data: any): CoachingRecipeBaseEdit {
        data = typeof data === 'object' ? data : {};
        let result = new CoachingRecipeBaseEdit();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["isSpotlighted"] = this.isSpotlighted;
        data["uploadImage"] = this.uploadImage;
        if (Array.isArray(this.dishTypes)) {
            data["dishTypes"] = [];
            for (let item of this.dishTypes)
                data["dishTypes"].push(item);
        }
        if (Array.isArray(this.dietaryPlans)) {
            data["dietaryPlans"] = [];
            for (let item of this.dietaryPlans)
                data["dietaryPlans"].push(item);
        }
        if (Array.isArray(this.ecoResponsabilities)) {
            data["ecoResponsabilities"] = [];
            for (let item of this.ecoResponsabilities)
                data["ecoResponsabilities"].push(item);
        }
        if (Array.isArray(this.zoomSections)) {
            data["zoomSections"] = [];
            for (let item of this.zoomSections)
                data["zoomSections"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.promotedNutrients)) {
            data["promotedNutrients"] = [];
            for (let item of this.promotedNutrients)
                data["promotedNutrients"].push(item ? item.toJSON() : <any>undefined);
        }
        data["status"] = this.status;
        data["description"] = this.description;
        data["nbPerson"] = this.nbPerson;
        data["facility"] = this.facility;
        data["duration"] = this.duration;
        if (Array.isArray(this.seasons)) {
            data["seasons"] = [];
            for (let item of this.seasons)
                data["seasons"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.allergens)) {
            data["allergens"] = [];
            for (let item of this.allergens)
                data["allergens"].push(item ? item.toJSON() : <any>undefined);
        }
        data["streamingElementId"] = this.streamingElementId;
        data["isArchived"] = this.isArchived;
        return data;
    }
}

/** Contains the definition of an object of type CoachingRecipeBaseEdit. */
export interface ICoachingRecipeBaseEdit {
    /** Gets or sets the title. */
    title?: string | undefined;
    /** Gets or sets a value indicating whether this instance is spotlighted. */
    isSpotlighted: boolean;
    /** Gets or sets the upload image. */
    uploadImage?: any | undefined;
    /** Gets or sets the dish type identifier. */
    dishTypes?: number[] | undefined;
    /** Gets or sets the dietary plan. */
    dietaryPlans?: number[] | undefined;
    /** Gets or sets the eco responsability. */
    ecoResponsabilities?: number[] | undefined;
    /** Gets or sets the zoom sections. */
    zoomSections?: CoachingRecipeZoomSection[] | undefined;
    /** Gets or sets the promoted nutrients. */
    promotedNutrients?: PromotedNutrient[] | undefined;
    /** Gets or sets the status. */
    status: CoachingRecipeStatus;
    /** Gets or sets the description. */
    description?: string | undefined;
    /** Gets or sets the nb person. */
    nbPerson: number;
    /** Gets or sets the Facility. */
    facility: number;
    /** Gets or sets the description. */
    duration: number;
    /** Gets or sets the coaching recipe seasons. */
    seasons?: CoachingRecipeSeason[] | undefined;
    /** Gets or sets the allergens. */
    allergens?: CoachingRecipeAllergen[] | undefined;
    /** Gets or sets the streaming element identifier. */
    streamingElementId?: number | undefined;
    /** Gets or sets a value indicating whether this instance is active. */
    isArchived: boolean;
}

/** Contains the definition of an object of type CreateCoachingRecipe. */
export class CreateCoachingRecipe extends CoachingRecipeBaseEdit implements ICreateCoachingRecipe {
    /** Gets or sets the ingredients. */
    coachingRecipeIngredients?: CreateCoachingRecipeIngredient[] | undefined;

    constructor(data?: ICreateCoachingRecipe) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["coachingRecipeIngredients"])) {
                this.coachingRecipeIngredients = [] as any;
                for (let item of _data["coachingRecipeIngredients"])
                    this.coachingRecipeIngredients!.push(CreateCoachingRecipeIngredient.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): CreateCoachingRecipe {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCoachingRecipe();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.coachingRecipeIngredients)) {
            data["coachingRecipeIngredients"] = [];
            for (let item of this.coachingRecipeIngredients)
                data["coachingRecipeIngredients"].push(item ? item.toJSON() : <any>undefined);
        }
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type CreateCoachingRecipe. */
export interface ICreateCoachingRecipe extends ICoachingRecipeBaseEdit {
    /** Gets or sets the ingredients. */
    coachingRecipeIngredients?: CreateCoachingRecipeIngredient[] | undefined;
}

/** Contains the definition of an object of type CoachingRecipeIngredientBaseEdit. */
export class CoachingRecipeIngredientBaseEdit implements ICoachingRecipeIngredientBaseEdit {
    /** Gets or sets the recipe identifier. */
    ingredientId!: number;
    /** Gets or sets the unit type identifier. */
    unitTypeId!: number;
    /** Gets or sets the quantity. */
    quantity!: number;

    constructor(data?: ICoachingRecipeIngredientBaseEdit) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ingredientId = _data["ingredientId"];
            this.unitTypeId = _data["unitTypeId"];
            this.quantity = _data["quantity"];
        }
    }

    static fromJS(data: any): CoachingRecipeIngredientBaseEdit {
        data = typeof data === 'object' ? data : {};
        let result = new CoachingRecipeIngredientBaseEdit();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ingredientId"] = this.ingredientId;
        data["unitTypeId"] = this.unitTypeId;
        data["quantity"] = this.quantity;
        return data;
    }
}

/** Contains the definition of an object of type CoachingRecipeIngredientBaseEdit. */
export interface ICoachingRecipeIngredientBaseEdit {
    /** Gets or sets the recipe identifier. */
    ingredientId: number;
    /** Gets or sets the unit type identifier. */
    unitTypeId: number;
    /** Gets or sets the quantity. */
    quantity: number;
}

/** Contains the definition of an object of type CreateCoachingRecipeIngredient. */
export class CreateCoachingRecipeIngredient extends CoachingRecipeIngredientBaseEdit implements ICreateCoachingRecipeIngredient {

    constructor(data?: ICreateCoachingRecipeIngredient) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): CreateCoachingRecipeIngredient {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCoachingRecipeIngredient();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type CreateCoachingRecipeIngredient. */
export interface ICreateCoachingRecipeIngredient extends ICoachingRecipeIngredientBaseEdit {
}

/** Contains the definition of an object of type CoachingRecipeZoomSection. */
export class CoachingRecipeZoomSection implements ICoachingRecipeZoomSection {
    /** Gets or sets the coaching recipe identifier. */
    coachingRecipeId!: number;
    /** Gets or sets the zoom section identifier. */
    zoomSectionId!: number;

    constructor(data?: ICoachingRecipeZoomSection) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.coachingRecipeId = _data["coachingRecipeId"];
            this.zoomSectionId = _data["zoomSectionId"];
        }
    }

    static fromJS(data: any): CoachingRecipeZoomSection {
        data = typeof data === 'object' ? data : {};
        let result = new CoachingRecipeZoomSection();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["coachingRecipeId"] = this.coachingRecipeId;
        data["zoomSectionId"] = this.zoomSectionId;
        return data;
    }
}

/** Contains the definition of an object of type CoachingRecipeZoomSection. */
export interface ICoachingRecipeZoomSection {
    /** Gets or sets the coaching recipe identifier. */
    coachingRecipeId: number;
    /** Gets or sets the zoom section identifier. */
    zoomSectionId: number;
}

/** Contains the definition of an object of type PromotedNutrient. */
export class PromotedNutrient implements IPromotedNutrient {
    /** Gets or sets the coaching recipe identifier. */
    coachingRecipeId!: number;
    /** Gets or sets the nutrient identifier. */
    nutrientId!: number;

    constructor(data?: IPromotedNutrient) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.coachingRecipeId = _data["coachingRecipeId"];
            this.nutrientId = _data["nutrientId"];
        }
    }

    static fromJS(data: any): PromotedNutrient {
        data = typeof data === 'object' ? data : {};
        let result = new PromotedNutrient();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["coachingRecipeId"] = this.coachingRecipeId;
        data["nutrientId"] = this.nutrientId;
        return data;
    }
}

/** Contains the definition of an object of type PromotedNutrient. */
export interface IPromotedNutrient {
    /** Gets or sets the coaching recipe identifier. */
    coachingRecipeId: number;
    /** Gets or sets the nutrient identifier. */
    nutrientId: number;
}

/** Contains the definition of an object of type CoachingRecipeStatus. */
export enum CoachingRecipeStatus {
    InProcess = 0,
    Archived = 1,
    Published = 2,
}

/** Contains the definition of an object of type CoachingRecipeSeason. */
export class CoachingRecipeSeason implements ICoachingRecipeSeason {
    /** Gets or sets the recipe identifier. */
    recipeId!: number;
    /** Gets or sets the season identifier. */
    seasonId!: number;

    constructor(data?: ICoachingRecipeSeason) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.recipeId = _data["recipeId"];
            this.seasonId = _data["seasonId"];
        }
    }

    static fromJS(data: any): CoachingRecipeSeason {
        data = typeof data === 'object' ? data : {};
        let result = new CoachingRecipeSeason();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["recipeId"] = this.recipeId;
        data["seasonId"] = this.seasonId;
        return data;
    }
}

/** Contains the definition of an object of type CoachingRecipeSeason. */
export interface ICoachingRecipeSeason {
    /** Gets or sets the recipe identifier. */
    recipeId: number;
    /** Gets or sets the season identifier. */
    seasonId: number;
}

/** Contains the definition of an object of type CoachingRecipeAllergen. */
export class CoachingRecipeAllergen implements ICoachingRecipeAllergen {
    /** Gets or sets the recipe identifier. */
    recipeId!: number;
    /** Gets or sets the allergen identifier. */
    allergenId!: number;

    constructor(data?: ICoachingRecipeAllergen) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.recipeId = _data["recipeId"];
            this.allergenId = _data["allergenId"];
        }
    }

    static fromJS(data: any): CoachingRecipeAllergen {
        data = typeof data === 'object' ? data : {};
        let result = new CoachingRecipeAllergen();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["recipeId"] = this.recipeId;
        data["allergenId"] = this.allergenId;
        return data;
    }
}

/** Contains the definition of an object of type CoachingRecipeAllergen. */
export interface ICoachingRecipeAllergen {
    /** Gets or sets the recipe identifier. */
    recipeId: number;
    /** Gets or sets the allergen identifier. */
    allergenId: number;
}

/** Contains the definition of an object of type CoachingActivity. */
export class CoachingActivity implements ICoachingActivity {
    /** Gets or sets the identifier. */
    id!: number;
    /** Gets or sets the title. */
    title?: string | undefined;
    /** Gets or sets the status. */
    status!: StatusCoachingActivity;
    /** Gets or sets the suggestible source with entity names. */
    suggestibleSourceWithEntityNames?: SuggestibleSourceWithEntityName[] | undefined;
    /** Gets or sets the intention. */
    intention!: IntentionLevelType;

    constructor(data?: ICoachingActivity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.status = _data["status"];
            if (Array.isArray(_data["suggestibleSourceWithEntityNames"])) {
                this.suggestibleSourceWithEntityNames = [] as any;
                for (let item of _data["suggestibleSourceWithEntityNames"])
                    this.suggestibleSourceWithEntityNames!.push(SuggestibleSourceWithEntityName.fromJS(item));
            }
            this.intention = _data["intention"];
        }
    }

    static fromJS(data: any): CoachingActivity {
        data = typeof data === 'object' ? data : {};
        let result = new CoachingActivity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["status"] = this.status;
        if (Array.isArray(this.suggestibleSourceWithEntityNames)) {
            data["suggestibleSourceWithEntityNames"] = [];
            for (let item of this.suggestibleSourceWithEntityNames)
                data["suggestibleSourceWithEntityNames"].push(item ? item.toJSON() : <any>undefined);
        }
        data["intention"] = this.intention;
        return data;
    }
}

/** Contains the definition of an object of type CoachingActivity. */
export interface ICoachingActivity {
    /** Gets or sets the identifier. */
    id: number;
    /** Gets or sets the title. */
    title?: string | undefined;
    /** Gets or sets the status. */
    status: StatusCoachingActivity;
    /** Gets or sets the suggestible source with entity names. */
    suggestibleSourceWithEntityNames?: SuggestibleSourceWithEntityName[] | undefined;
    /** Gets or sets the intention. */
    intention: IntentionLevelType;
}

/** Contains the definition of an object of type SearchParams. */
export class SearchParams implements ISearchParams {
    /** Gets or sets the page. */
    page!: number;

    constructor(data?: ISearchParams) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.page = _data["page"];
        }
    }

    static fromJS(data: any): SearchParams {
        data = typeof data === 'object' ? data : {};
        let result = new SearchParams();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["page"] = this.page;
        return data;
    }
}

/** Contains the definition of an object of type SearchParams. */
export interface ISearchParams {
    /** Gets or sets the page. */
    page: number;
}

/** Contains the definition of an object of type CoachingActivitySearchParams. */
export class CoachingActivitySearchParams extends SearchParams implements ICoachingActivitySearchParams {
    /** Gets or sets the identifier. */
    id?: number | undefined;
    /** Gets or sets the title. */
    title?: string | undefined;
    /** Gets or sets the status. */
    status?: StatusCoachingActivity | undefined;

    constructor(data?: ICoachingActivitySearchParams) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.status = _data["status"];
        }
    }

    static override fromJS(data: any): CoachingActivitySearchParams {
        data = typeof data === 'object' ? data : {};
        let result = new CoachingActivitySearchParams();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["status"] = this.status;
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type CoachingActivitySearchParams. */
export interface ICoachingActivitySearchParams extends ISearchParams {
    /** Gets or sets the identifier. */
    id?: number | undefined;
    /** Gets or sets the title. */
    title?: string | undefined;
    /** Gets or sets the status. */
    status?: StatusCoachingActivity | undefined;
}

/** Contains the definition of an object of type DropdownValue. */
export class DropdownValue implements IDropdownValue {
    /** Gets or sets the identifier. */
    id!: number;
    /** Gets or sets the label. */
    label?: string | undefined;

    constructor(data?: IDropdownValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.label = _data["label"];
        }
    }

    static fromJS(data: any): DropdownValue {
        data = typeof data === 'object' ? data : {};
        let result = new DropdownValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["label"] = this.label;
        return data;
    }
}

/** Contains the definition of an object of type DropdownValue. */
export interface IDropdownValue {
    /** Gets or sets the identifier. */
    id: number;
    /** Gets or sets the label. */
    label?: string | undefined;
}

/** Contains the definition of an object of type CoachingActivityDetails. */
export class CoachingActivityDetails extends CoachingActivity implements ICoachingActivityDetails {
    /** Gets or sets the allowed subscription levels. */
    allowedSubscriptionLevels?: number[] | undefined;
    /** Gets or sets the image URL. */
    bannerUrl?: string | undefined;
    /** Gets or sets the description. */
    description?: string | undefined;
    /** Gets or sets the files. */
    files?: CoachingActivityMedia[] | undefined;
    /** Gets or sets the images. */
    images?: CoachingActivityMedia[] | undefined;
    /** Gets or sets the suggestible. */
    suggestible?: Suggestible | undefined;
    /** Gets or sets the upload banner. */
    uploadBanner?: any | undefined;
    /** Gets or sets the upload files. */
    uploadFiles?: any[] | undefined;
    /** Gets or sets the upload images. */
    uploadImages?: any[] | undefined;
    /** Gets or sets the streaming URL. */
    streamingUrl?: string | undefined;
    /** Gets or sets the name of the streaming element. */
    streamingElementName?: string | undefined;
    /** Gets or sets the streaming element identifier. */
    streamingElementId?: number | undefined;

    constructor(data?: ICoachingActivityDetails) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["allowedSubscriptionLevels"])) {
                this.allowedSubscriptionLevels = [] as any;
                for (let item of _data["allowedSubscriptionLevels"])
                    this.allowedSubscriptionLevels!.push(item);
            }
            this.bannerUrl = _data["bannerUrl"];
            this.description = _data["description"];
            if (Array.isArray(_data["files"])) {
                this.files = [] as any;
                for (let item of _data["files"])
                    this.files!.push(CoachingActivityMedia.fromJS(item));
            }
            if (Array.isArray(_data["images"])) {
                this.images = [] as any;
                for (let item of _data["images"])
                    this.images!.push(CoachingActivityMedia.fromJS(item));
            }
            this.suggestible = _data["suggestible"] ? Suggestible.fromJS(_data["suggestible"]) : <any>undefined;
            this.uploadBanner = _data["uploadBanner"];
            if (Array.isArray(_data["uploadFiles"])) {
                this.uploadFiles = [] as any;
                for (let item of _data["uploadFiles"])
                    this.uploadFiles!.push(item);
            }
            if (Array.isArray(_data["uploadImages"])) {
                this.uploadImages = [] as any;
                for (let item of _data["uploadImages"])
                    this.uploadImages!.push(item);
            }
            this.streamingUrl = _data["streamingUrl"];
            this.streamingElementName = _data["streamingElementName"];
            this.streamingElementId = _data["streamingElementId"];
        }
    }

    static override fromJS(data: any): CoachingActivityDetails {
        data = typeof data === 'object' ? data : {};
        let result = new CoachingActivityDetails();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.allowedSubscriptionLevels)) {
            data["allowedSubscriptionLevels"] = [];
            for (let item of this.allowedSubscriptionLevels)
                data["allowedSubscriptionLevels"].push(item);
        }
        data["bannerUrl"] = this.bannerUrl;
        data["description"] = this.description;
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.images)) {
            data["images"] = [];
            for (let item of this.images)
                data["images"].push(item ? item.toJSON() : <any>undefined);
        }
        data["suggestible"] = this.suggestible ? this.suggestible.toJSON() : <any>undefined;
        data["uploadBanner"] = this.uploadBanner;
        if (Array.isArray(this.uploadFiles)) {
            data["uploadFiles"] = [];
            for (let item of this.uploadFiles)
                data["uploadFiles"].push(item);
        }
        if (Array.isArray(this.uploadImages)) {
            data["uploadImages"] = [];
            for (let item of this.uploadImages)
                data["uploadImages"].push(item);
        }
        data["streamingUrl"] = this.streamingUrl;
        data["streamingElementName"] = this.streamingElementName;
        data["streamingElementId"] = this.streamingElementId;
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type CoachingActivityDetails. */
export interface ICoachingActivityDetails extends ICoachingActivity {
    /** Gets or sets the allowed subscription levels. */
    allowedSubscriptionLevels?: number[] | undefined;
    /** Gets or sets the image URL. */
    bannerUrl?: string | undefined;
    /** Gets or sets the description. */
    description?: string | undefined;
    /** Gets or sets the files. */
    files?: CoachingActivityMedia[] | undefined;
    /** Gets or sets the images. */
    images?: CoachingActivityMedia[] | undefined;
    /** Gets or sets the suggestible. */
    suggestible?: Suggestible | undefined;
    /** Gets or sets the upload banner. */
    uploadBanner?: any | undefined;
    /** Gets or sets the upload files. */
    uploadFiles?: any[] | undefined;
    /** Gets or sets the upload images. */
    uploadImages?: any[] | undefined;
    /** Gets or sets the streaming URL. */
    streamingUrl?: string | undefined;
    /** Gets or sets the name of the streaming element. */
    streamingElementName?: string | undefined;
    /** Gets or sets the streaming element identifier. */
    streamingElementId?: number | undefined;
}

export class PaginatorWrapperOfIEnumerableOfCoachingActivityWithWarnings implements IPaginatorWrapperOfIEnumerableOfCoachingActivityWithWarnings {
    totalRecords!: number;
    data?: CoachingActivityWithWarnings[] | undefined;

    constructor(data?: IPaginatorWrapperOfIEnumerableOfCoachingActivityWithWarnings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRecords = _data["totalRecords"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(CoachingActivityWithWarnings.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatorWrapperOfIEnumerableOfCoachingActivityWithWarnings {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatorWrapperOfIEnumerableOfCoachingActivityWithWarnings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IPaginatorWrapperOfIEnumerableOfCoachingActivityWithWarnings {
    totalRecords: number;
    data?: CoachingActivityWithWarnings[] | undefined;
}

/** Contains the definition of an object of type CoachingActivityWithWarnings. */
export class CoachingActivityWithWarnings extends CoachingActivity implements ICoachingActivityWithWarnings {
    /** Gets or sets the warnings. */
    warnings?: SuggestibleSourceWithEntityName[] | undefined;
    /** Gets or sets the suggestible. */
    suggestible?: Suggestible | undefined;
    /** Gets or sets a value indicating whether this instance is selected. */
    isSelected!: boolean;
    /** Gets or sets a value indicating whether this instance is already in consult. */
    isAlreadyInConsult!: boolean;
    /** Gets or sets the last sending to patient. */
    lastSendingToPatient?: Date | undefined;

    constructor(data?: ICoachingActivityWithWarnings) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["warnings"])) {
                this.warnings = [] as any;
                for (let item of _data["warnings"])
                    this.warnings!.push(SuggestibleSourceWithEntityName.fromJS(item));
            }
            this.suggestible = _data["suggestible"] ? Suggestible.fromJS(_data["suggestible"]) : <any>undefined;
            this.isSelected = _data["isSelected"];
            this.isAlreadyInConsult = _data["isAlreadyInConsult"];
            this.lastSendingToPatient = _data["lastSendingToPatient"] ? new Date(_data["lastSendingToPatient"].toString()) : <any>undefined;
        }
    }

    static override fromJS(data: any): CoachingActivityWithWarnings {
        data = typeof data === 'object' ? data : {};
        let result = new CoachingActivityWithWarnings();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.warnings)) {
            data["warnings"] = [];
            for (let item of this.warnings)
                data["warnings"].push(item ? item.toJSON() : <any>undefined);
        }
        data["suggestible"] = this.suggestible ? this.suggestible.toJSON() : <any>undefined;
        data["isSelected"] = this.isSelected;
        data["isAlreadyInConsult"] = this.isAlreadyInConsult;
        data["lastSendingToPatient"] = this.lastSendingToPatient ? this.lastSendingToPatient.toISOString() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type CoachingActivityWithWarnings. */
export interface ICoachingActivityWithWarnings extends ICoachingActivity {
    /** Gets or sets the warnings. */
    warnings?: SuggestibleSourceWithEntityName[] | undefined;
    /** Gets or sets the suggestible. */
    suggestible?: Suggestible | undefined;
    /** Gets or sets a value indicating whether this instance is selected. */
    isSelected: boolean;
    /** Gets or sets a value indicating whether this instance is already in consult. */
    isAlreadyInConsult: boolean;
    /** Gets or sets the last sending to patient. */
    lastSendingToPatient?: Date | undefined;
}

/** Contains the definition of an object of type SearchParams. */
export class SearchParamSuggestible extends SearchParams implements ISearchParamSuggestible {
    /** Gets or sets the title. */
    title?: string | undefined;
    /** Gets or sets a value indicating whether this instance is from siin. */
    isFromSiin!: boolean;
    /** Gets or sets the consultation identifier. */
    consultationId?: number | undefined;
    /** Gets or sets the patient identifier. */
    patientId?: number | undefined;

    constructor(data?: ISearchParamSuggestible) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.title = _data["title"];
            this.isFromSiin = _data["isFromSiin"];
            this.consultationId = _data["consultationId"];
            this.patientId = _data["patientId"];
        }
    }

    static override fromJS(data: any): SearchParamSuggestible {
        data = typeof data === 'object' ? data : {};
        let result = new SearchParamSuggestible();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["isFromSiin"] = this.isFromSiin;
        data["consultationId"] = this.consultationId;
        data["patientId"] = this.patientId;
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type SearchParams. */
export interface ISearchParamSuggestible extends ISearchParams {
    /** Gets or sets the title. */
    title?: string | undefined;
    /** Gets or sets a value indicating whether this instance is from siin. */
    isFromSiin: boolean;
    /** Gets or sets the consultation identifier. */
    consultationId?: number | undefined;
    /** Gets or sets the patient identifier. */
    patientId?: number | undefined;
}

/** search param for activity */
export class SearchParamActivity extends SearchParamSuggestible implements ISearchParamActivity {

    constructor(data?: ISearchParamActivity) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): SearchParamActivity {
        data = typeof data === 'object' ? data : {};
        let result = new SearchParamActivity();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

/** search param for activity */
export interface ISearchParamActivity extends ISearchParamSuggestible {
}

export class PaginatorWrapperOfIEnumerableOfCoachingLibrary implements IPaginatorWrapperOfIEnumerableOfCoachingLibrary {
    totalRecords!: number;
    data?: CoachingLibrary[] | undefined;

    constructor(data?: IPaginatorWrapperOfIEnumerableOfCoachingLibrary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRecords = _data["totalRecords"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(CoachingLibrary.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatorWrapperOfIEnumerableOfCoachingLibrary {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatorWrapperOfIEnumerableOfCoachingLibrary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IPaginatorWrapperOfIEnumerableOfCoachingLibrary {
    totalRecords: number;
    data?: CoachingLibrary[] | undefined;
}

/** Contains the definition of an object of type CoachingLibrary. */
export class CoachingLibrary extends Coaching implements ICoachingLibrary {
    /** Gets or sets the end activation date. */
    endActivationDate?: Date | undefined;
    /** Gets or sets the suggestible source with entity names. */
    suggestibleSourceWithEntityNames?: SuggestibleSourceWithEntityName[] | undefined;
    /** Gets or sets the intention. */
    intention!: IntentionLevelType;
    /** Gets or sets the doctor identifier. */
    doctorId!: number;

    constructor(data?: ICoachingLibrary) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.endActivationDate = _data["endActivationDate"] ? new Date(_data["endActivationDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["suggestibleSourceWithEntityNames"])) {
                this.suggestibleSourceWithEntityNames = [] as any;
                for (let item of _data["suggestibleSourceWithEntityNames"])
                    this.suggestibleSourceWithEntityNames!.push(SuggestibleSourceWithEntityName.fromJS(item));
            }
            this.intention = _data["intention"];
            this.doctorId = _data["doctorId"];
        }
    }

    static override fromJS(data: any): CoachingLibrary {
        data = typeof data === 'object' ? data : {};
        let result = new CoachingLibrary();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["endActivationDate"] = this.endActivationDate ? this.endActivationDate.toISOString() : <any>undefined;
        if (Array.isArray(this.suggestibleSourceWithEntityNames)) {
            data["suggestibleSourceWithEntityNames"] = [];
            for (let item of this.suggestibleSourceWithEntityNames)
                data["suggestibleSourceWithEntityNames"].push(item ? item.toJSON() : <any>undefined);
        }
        data["intention"] = this.intention;
        data["doctorId"] = this.doctorId;
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type CoachingLibrary. */
export interface ICoachingLibrary extends ICoaching {
    /** Gets or sets the end activation date. */
    endActivationDate?: Date | undefined;
    /** Gets or sets the suggestible source with entity names. */
    suggestibleSourceWithEntityNames?: SuggestibleSourceWithEntityName[] | undefined;
    /** Gets or sets the intention. */
    intention: IntentionLevelType;
    /** Gets or sets the doctor identifier. */
    doctorId: number;
}

/** Contains the definition of an object of type SearchParamCoachingLibrary. */
export class SearchParamCoachingLibrary extends SearchParamSuggestible implements ISearchParamCoachingLibrary {
    /** Gets or sets the type identifier. */
    typeId?: number | undefined;

    constructor(data?: ISearchParamCoachingLibrary) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.typeId = _data["typeId"];
        }
    }

    static override fromJS(data: any): SearchParamCoachingLibrary {
        data = typeof data === 'object' ? data : {};
        let result = new SearchParamCoachingLibrary();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typeId"] = this.typeId;
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type SearchParamCoachingLibrary. */
export interface ISearchParamCoachingLibrary extends ISearchParamSuggestible {
    /** Gets or sets the type identifier. */
    typeId?: number | undefined;
}

/** Contains the definition of an object of type CoachingDetailsPro. */
export class CoachingDetailsPro extends Coaching implements ICoachingDetailsPro {
    /** Gets or sets the activities. */
    activities?: CoachingCoachingActivityDetails[] | undefined;
    /** Gets or sets the recipes. */
    recipes?: CoachingCoachingRecipeDetail[] | undefined;
    /** Gets or sets the suggestions. */
    suggestionsAlimentary?: CoachingSuggestionDetails[] | undefined;
    /** Gets or sets the suggestions. */
    suggestionsLifeStyle?: CoachingSuggestionDetails[] | undefined;
    /** Gets or sets the end date. */
    endValidationDate?: Date | undefined;

    constructor(data?: ICoachingDetailsPro) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["activities"])) {
                this.activities = [] as any;
                for (let item of _data["activities"])
                    this.activities!.push(CoachingCoachingActivityDetails.fromJS(item));
            }
            if (Array.isArray(_data["recipes"])) {
                this.recipes = [] as any;
                for (let item of _data["recipes"])
                    this.recipes!.push(CoachingCoachingRecipeDetail.fromJS(item));
            }
            if (Array.isArray(_data["suggestionsAlimentary"])) {
                this.suggestionsAlimentary = [] as any;
                for (let item of _data["suggestionsAlimentary"])
                    this.suggestionsAlimentary!.push(CoachingSuggestionDetails.fromJS(item));
            }
            if (Array.isArray(_data["suggestionsLifeStyle"])) {
                this.suggestionsLifeStyle = [] as any;
                for (let item of _data["suggestionsLifeStyle"])
                    this.suggestionsLifeStyle!.push(CoachingSuggestionDetails.fromJS(item));
            }
            this.endValidationDate = _data["endValidationDate"] ? new Date(_data["endValidationDate"].toString()) : <any>undefined;
        }
    }

    static override fromJS(data: any): CoachingDetailsPro {
        data = typeof data === 'object' ? data : {};
        let result = new CoachingDetailsPro();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.activities)) {
            data["activities"] = [];
            for (let item of this.activities)
                data["activities"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.recipes)) {
            data["recipes"] = [];
            for (let item of this.recipes)
                data["recipes"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.suggestionsAlimentary)) {
            data["suggestionsAlimentary"] = [];
            for (let item of this.suggestionsAlimentary)
                data["suggestionsAlimentary"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.suggestionsLifeStyle)) {
            data["suggestionsLifeStyle"] = [];
            for (let item of this.suggestionsLifeStyle)
                data["suggestionsLifeStyle"].push(item ? item.toJSON() : <any>undefined);
        }
        data["endValidationDate"] = this.endValidationDate ? this.endValidationDate.toISOString() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type CoachingDetailsPro. */
export interface ICoachingDetailsPro extends ICoaching {
    /** Gets or sets the activities. */
    activities?: CoachingCoachingActivityDetails[] | undefined;
    /** Gets or sets the recipes. */
    recipes?: CoachingCoachingRecipeDetail[] | undefined;
    /** Gets or sets the suggestions. */
    suggestionsAlimentary?: CoachingSuggestionDetails[] | undefined;
    /** Gets or sets the suggestions. */
    suggestionsLifeStyle?: CoachingSuggestionDetails[] | undefined;
    /** Gets or sets the end date. */
    endValidationDate?: Date | undefined;
}

/** Contains the definition of an object of type CoachingCoachingActivityDetails. */
export class CoachingCoachingActivityDetails extends CoachingCoachingActivity implements ICoachingCoachingActivityDetails {
    /** Gets or sets the name. */
    name?: string | undefined;

    constructor(data?: ICoachingCoachingActivityDetails) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
        }
    }

    static override fromJS(data: any): CoachingCoachingActivityDetails {
        data = typeof data === 'object' ? data : {};
        let result = new CoachingCoachingActivityDetails();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type CoachingCoachingActivityDetails. */
export interface ICoachingCoachingActivityDetails extends ICoachingCoachingActivity {
    /** Gets or sets the name. */
    name?: string | undefined;
}

/** Contains the definition of an object of type CoachingCoachingRecipeDetail. */
export class CoachingCoachingRecipeDetail extends CoachingCoachingRecipe implements ICoachingCoachingRecipeDetail {
    /** Gets or sets the name. */
    name?: string | undefined;

    constructor(data?: ICoachingCoachingRecipeDetail) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
        }
    }

    static override fromJS(data: any): CoachingCoachingRecipeDetail {
        data = typeof data === 'object' ? data : {};
        let result = new CoachingCoachingRecipeDetail();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type CoachingCoachingRecipeDetail. */
export interface ICoachingCoachingRecipeDetail extends ICoachingCoachingRecipe {
    /** Gets or sets the name. */
    name?: string | undefined;
}

/** Contains the definition of an object of type CoachingSuggestionDetails. */
export class CoachingSuggestionDetails extends CoachingSuggestion implements ICoachingSuggestionDetails {
    /** Gets or sets the name. */
    name?: string | undefined;
    /** Gets or sets the type identifier. */
    typeId!: number;
    /** Gets or sets the type. */
    type!: SuggestionType;

    constructor(data?: ICoachingSuggestionDetails) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.typeId = _data["typeId"];
            this.type = _data["type"];
        }
    }

    static override fromJS(data: any): CoachingSuggestionDetails {
        data = typeof data === 'object' ? data : {};
        let result = new CoachingSuggestionDetails();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["typeId"] = this.typeId;
        data["type"] = this.type;
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type CoachingSuggestionDetails. */
export interface ICoachingSuggestionDetails extends ICoachingSuggestion {
    /** Gets or sets the name. */
    name?: string | undefined;
    /** Gets or sets the type identifier. */
    typeId: number;
    /** Gets or sets the type. */
    type: SuggestionType;
}

/** Contains the definition of an object of type SuggestionType. */
export enum SuggestionType {
    Unknow = 0,
    SuggestionFood = 1,
    SuggestionLifeStyle = 2,
    SuggestionPro = 3,
}

/** Contains the definition of an object of type PatientCoaching. */
export class PatientCoaching implements IPatientCoaching {
    /** Gets or sets the patient identifier. */
    patientId!: number;
    /** Gets or sets the doctor identifier. */
    doctorId!: number;
    /** Gets or sets the coaching identifier. */
    coachingId!: number;
    /** Gets or sets the coaching. */
    coaching?: Coaching | undefined;
    /** Gets or sets the validity end date. */
    validityEndDate!: Date;

    constructor(data?: IPatientCoaching) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.patientId = _data["patientId"];
            this.doctorId = _data["doctorId"];
            this.coachingId = _data["coachingId"];
            this.coaching = _data["coaching"] ? Coaching.fromJS(_data["coaching"]) : <any>undefined;
            this.validityEndDate = _data["validityEndDate"] ? new Date(_data["validityEndDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): PatientCoaching {
        data = typeof data === 'object' ? data : {};
        let result = new PatientCoaching();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["patientId"] = this.patientId;
        data["doctorId"] = this.doctorId;
        data["coachingId"] = this.coachingId;
        data["coaching"] = this.coaching ? this.coaching.toJSON() : <any>undefined;
        data["validityEndDate"] = this.validityEndDate ? this.validityEndDate.toISOString() : <any>undefined;
        return data;
    }
}

/** Contains the definition of an object of type PatientCoaching. */
export interface IPatientCoaching {
    /** Gets or sets the patient identifier. */
    patientId: number;
    /** Gets or sets the doctor identifier. */
    doctorId: number;
    /** Gets or sets the coaching identifier. */
    coachingId: number;
    /** Gets or sets the coaching. */
    coaching?: Coaching | undefined;
    /** Gets or sets the validity end date. */
    validityEndDate: Date;
}

/** Contains the definition of an object of type PatientCoachingDetails. */
export class PatientCoachingDetails extends PatientCoaching implements IPatientCoachingDetails {
    /** Gets or sets the title. */
    title?: string | undefined;
    /** Gets or sets the type. */
    type!: number;
    /** Gets or sets the name of the suggestible source with entity. */
    suggestibleSourceWithEntityName?: SuggestibleSourceWithEntityName[] | undefined;
    /** Gets or sets the name of the type. */
    typeName?: any | undefined;
    /** Gets or sets the intention. */
    intention!: IntentionLevelType;

    constructor(data?: IPatientCoachingDetails) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.title = _data["title"];
            this.type = _data["type"];
            if (Array.isArray(_data["suggestibleSourceWithEntityName"])) {
                this.suggestibleSourceWithEntityName = [] as any;
                for (let item of _data["suggestibleSourceWithEntityName"])
                    this.suggestibleSourceWithEntityName!.push(SuggestibleSourceWithEntityName.fromJS(item));
            }
            this.typeName = _data["typeName"];
            this.intention = _data["intention"];
        }
    }

    static override fromJS(data: any): PatientCoachingDetails {
        data = typeof data === 'object' ? data : {};
        let result = new PatientCoachingDetails();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["type"] = this.type;
        if (Array.isArray(this.suggestibleSourceWithEntityName)) {
            data["suggestibleSourceWithEntityName"] = [];
            for (let item of this.suggestibleSourceWithEntityName)
                data["suggestibleSourceWithEntityName"].push(item ? item.toJSON() : <any>undefined);
        }
        data["typeName"] = this.typeName;
        data["intention"] = this.intention;
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type PatientCoachingDetails. */
export interface IPatientCoachingDetails extends IPatientCoaching {
    /** Gets or sets the title. */
    title?: string | undefined;
    /** Gets or sets the type. */
    type: number;
    /** Gets or sets the name of the suggestible source with entity. */
    suggestibleSourceWithEntityName?: SuggestibleSourceWithEntityName[] | undefined;
    /** Gets or sets the name of the type. */
    typeName?: any | undefined;
    /** Gets or sets the intention. */
    intention: IntentionLevelType;
}

/** Contains the definition of an object of type SearchParamsCoaching. */
export class SearchParamsCoaching extends SearchParams implements ISearchParamsCoaching {
    /** Gets or sets the identifier. */
    id?: number | undefined;
    /** Gets or sets the publication status. */
    status?: StatusCoaching | undefined;
    /** Gets or sets the title. */
    title?: string | undefined;
    /** Gets or sets the type. */
    type?: number | undefined;

    constructor(data?: ISearchParamsCoaching) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.status = _data["status"];
            this.title = _data["title"];
            this.type = _data["type"];
        }
    }

    static override fromJS(data: any): SearchParamsCoaching {
        data = typeof data === 'object' ? data : {};
        let result = new SearchParamsCoaching();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["status"] = this.status;
        data["title"] = this.title;
        data["type"] = this.type;
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type SearchParamsCoaching. */
export interface ISearchParamsCoaching extends ISearchParams {
    /** Gets or sets the identifier. */
    id?: number | undefined;
    /** Gets or sets the publication status. */
    status?: StatusCoaching | undefined;
    /** Gets or sets the title. */
    title?: string | undefined;
    /** Gets or sets the type. */
    type?: number | undefined;
}

/** Contains the definition of an object of type PatientRecipe */
export class PatientRecipe implements IPatientRecipe {
    /** Gets or sets a value indicating whether this instance is book marked. */
    isBookMarked!: boolean;
    /** Gets or sets a value indicating whether this instance is in cart. */
    isInCart!: boolean;
    /** Gets or sets the nb person. */
    nbPerson?: number | undefined;
    /** Gets or sets the patient identifier. */
    patientId!: number;
    /** Gets or sets the recipe. */
    recipe?: CoachingRecipe | undefined;
    /** Gets or sets the recipe identifier. */
    recipeId!: number;

    constructor(data?: IPatientRecipe) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isBookMarked = _data["isBookMarked"];
            this.isInCart = _data["isInCart"];
            this.nbPerson = _data["nbPerson"];
            this.patientId = _data["patientId"];
            this.recipe = _data["recipe"] ? CoachingRecipe.fromJS(_data["recipe"]) : <any>undefined;
            this.recipeId = _data["recipeId"];
        }
    }

    static fromJS(data: any): PatientRecipe {
        data = typeof data === 'object' ? data : {};
        let result = new PatientRecipe();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isBookMarked"] = this.isBookMarked;
        data["isInCart"] = this.isInCart;
        data["nbPerson"] = this.nbPerson;
        data["patientId"] = this.patientId;
        data["recipe"] = this.recipe ? this.recipe.toJSON() : <any>undefined;
        data["recipeId"] = this.recipeId;
        return data;
    }
}

/** Contains the definition of an object of type PatientRecipe */
export interface IPatientRecipe {
    /** Gets or sets a value indicating whether this instance is book marked. */
    isBookMarked: boolean;
    /** Gets or sets a value indicating whether this instance is in cart. */
    isInCart: boolean;
    /** Gets or sets the nb person. */
    nbPerson?: number | undefined;
    /** Gets or sets the patient identifier. */
    patientId: number;
    /** Gets or sets the recipe. */
    recipe?: CoachingRecipe | undefined;
    /** Gets or sets the recipe identifier. */
    recipeId: number;
}

/** Contains the definition of an object of type CoachingRecipe. */
export class CoachingRecipe implements ICoachingRecipe {
    /** Gets or sets the duration. */
    duration!: number;
    /** Gets or sets the eco responsability. */
    facility!: number;
    /** Gets or sets the identifier. */
    id!: number;
    /** Gets or sets the image URL. */
    imageUrl?: string | undefined;
    /** Gets or sets a value indicating whether this instance is spotlighted. */
    isSpotlighted!: boolean;
    /** Gets or sets the seasons. */
    seasons?: CoachingRecipeSeason[] | undefined;
    /** Gets or sets the coaching recipe status. */
    status!: CoachingRecipeStatus;
    /** Gets or sets the title. */
    title!: string;
    /** Gets or sets the coaching recipe dish types. */
    coachingRecipeDishTypes?: CoachingRecipeDishType[] | undefined;
    /** Gets or sets the coaching recipe dietary plans. */
    coachingRecipeDietaryPlans?: CoachingRecipeDietaryPlan[] | undefined;

    constructor(data?: ICoachingRecipe) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.duration = _data["duration"];
            this.facility = _data["facility"];
            this.id = _data["id"];
            this.imageUrl = _data["imageUrl"];
            this.isSpotlighted = _data["isSpotlighted"];
            if (Array.isArray(_data["seasons"])) {
                this.seasons = [] as any;
                for (let item of _data["seasons"])
                    this.seasons!.push(CoachingRecipeSeason.fromJS(item));
            }
            this.status = _data["status"];
            this.title = _data["title"];
            if (Array.isArray(_data["coachingRecipeDishTypes"])) {
                this.coachingRecipeDishTypes = [] as any;
                for (let item of _data["coachingRecipeDishTypes"])
                    this.coachingRecipeDishTypes!.push(CoachingRecipeDishType.fromJS(item));
            }
            if (Array.isArray(_data["coachingRecipeDietaryPlans"])) {
                this.coachingRecipeDietaryPlans = [] as any;
                for (let item of _data["coachingRecipeDietaryPlans"])
                    this.coachingRecipeDietaryPlans!.push(CoachingRecipeDietaryPlan.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CoachingRecipe {
        data = typeof data === 'object' ? data : {};
        let result = new CoachingRecipe();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["duration"] = this.duration;
        data["facility"] = this.facility;
        data["id"] = this.id;
        data["imageUrl"] = this.imageUrl;
        data["isSpotlighted"] = this.isSpotlighted;
        if (Array.isArray(this.seasons)) {
            data["seasons"] = [];
            for (let item of this.seasons)
                data["seasons"].push(item ? item.toJSON() : <any>undefined);
        }
        data["status"] = this.status;
        data["title"] = this.title;
        if (Array.isArray(this.coachingRecipeDishTypes)) {
            data["coachingRecipeDishTypes"] = [];
            for (let item of this.coachingRecipeDishTypes)
                data["coachingRecipeDishTypes"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.coachingRecipeDietaryPlans)) {
            data["coachingRecipeDietaryPlans"] = [];
            for (let item of this.coachingRecipeDietaryPlans)
                data["coachingRecipeDietaryPlans"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

/** Contains the definition of an object of type CoachingRecipe. */
export interface ICoachingRecipe {
    /** Gets or sets the duration. */
    duration: number;
    /** Gets or sets the eco responsability. */
    facility: number;
    /** Gets or sets the identifier. */
    id: number;
    /** Gets or sets the image URL. */
    imageUrl?: string | undefined;
    /** Gets or sets a value indicating whether this instance is spotlighted. */
    isSpotlighted: boolean;
    /** Gets or sets the seasons. */
    seasons?: CoachingRecipeSeason[] | undefined;
    /** Gets or sets the coaching recipe status. */
    status: CoachingRecipeStatus;
    /** Gets or sets the title. */
    title: string;
    /** Gets or sets the coaching recipe dish types. */
    coachingRecipeDishTypes?: CoachingRecipeDishType[] | undefined;
    /** Gets or sets the coaching recipe dietary plans. */
    coachingRecipeDietaryPlans?: CoachingRecipeDietaryPlan[] | undefined;
}

/** Contains the definition of an object of type CoachingRecipeDishType. */
export class CoachingRecipeDishType implements ICoachingRecipeDishType {
    /** Gets or sets the coaching recipe identifier. */
    coachingRecipeId!: number;
    /** Gets or sets the type of the public. */
    dishTypeId!: number;

    constructor(data?: ICoachingRecipeDishType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.coachingRecipeId = _data["coachingRecipeId"];
            this.dishTypeId = _data["dishTypeId"];
        }
    }

    static fromJS(data: any): CoachingRecipeDishType {
        data = typeof data === 'object' ? data : {};
        let result = new CoachingRecipeDishType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["coachingRecipeId"] = this.coachingRecipeId;
        data["dishTypeId"] = this.dishTypeId;
        return data;
    }
}

/** Contains the definition of an object of type CoachingRecipeDishType. */
export interface ICoachingRecipeDishType {
    /** Gets or sets the coaching recipe identifier. */
    coachingRecipeId: number;
    /** Gets or sets the type of the public. */
    dishTypeId: number;
}

/** Contains the definition of an object of type CoachingRecipeDietaryPlan. */
export class CoachingRecipeDietaryPlan implements ICoachingRecipeDietaryPlan {
    /** Gets or sets the coaching recipe identifier. */
    coachingRecipeId!: number;
    /** Gets or sets the dietary plan identifier. */
    dietaryPlanId!: number;

    constructor(data?: ICoachingRecipeDietaryPlan) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.coachingRecipeId = _data["coachingRecipeId"];
            this.dietaryPlanId = _data["dietaryPlanId"];
        }
    }

    static fromJS(data: any): CoachingRecipeDietaryPlan {
        data = typeof data === 'object' ? data : {};
        let result = new CoachingRecipeDietaryPlan();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["coachingRecipeId"] = this.coachingRecipeId;
        data["dietaryPlanId"] = this.dietaryPlanId;
        return data;
    }
}

/** Contains the definition of an object of type CoachingRecipeDietaryPlan. */
export interface ICoachingRecipeDietaryPlan {
    /** Gets or sets the coaching recipe identifier. */
    coachingRecipeId: number;
    /** Gets or sets the dietary plan identifier. */
    dietaryPlanId: number;
}

/** Contains the definition of an object of type CoachingRecipeSearchParams. */
export class CoachingRecipeSearchParams extends SearchParams implements ICoachingRecipeSearchParams {
    /** Gets or sets the title. */
    title?: string | undefined;
    /** Gets or sets the type of the dish. */
    dishType?: number | undefined;
    /** Gets or sets the dietary plan. */
    dietaryPlan?: number | undefined;
    /** Gets or sets the dietary plan. */
    status?: CoachingRecipeStatus | undefined;
    /** Gets or sets the allergens. */
    allergenIds?: number[] | undefined;
    /** Gets or sets a value indicating whether this instance is spotlighted. */
    isSpotlighted!: boolean;
    /** Gets or sets the season ids. */
    seasonIds?: number[] | undefined;
    /** Gets or sets the nutrient ids. */
    promotedNutrientIds?: number[] | undefined;

    constructor(data?: ICoachingRecipeSearchParams) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.title = _data["title"];
            this.dishType = _data["dishType"];
            this.dietaryPlan = _data["dietaryPlan"];
            this.status = _data["status"];
            if (Array.isArray(_data["allergenIds"])) {
                this.allergenIds = [] as any;
                for (let item of _data["allergenIds"])
                    this.allergenIds!.push(item);
            }
            this.isSpotlighted = _data["isSpotlighted"];
            if (Array.isArray(_data["seasonIds"])) {
                this.seasonIds = [] as any;
                for (let item of _data["seasonIds"])
                    this.seasonIds!.push(item);
            }
            if (Array.isArray(_data["promotedNutrientIds"])) {
                this.promotedNutrientIds = [] as any;
                for (let item of _data["promotedNutrientIds"])
                    this.promotedNutrientIds!.push(item);
            }
        }
    }

    static override fromJS(data: any): CoachingRecipeSearchParams {
        data = typeof data === 'object' ? data : {};
        let result = new CoachingRecipeSearchParams();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["dishType"] = this.dishType;
        data["dietaryPlan"] = this.dietaryPlan;
        data["status"] = this.status;
        if (Array.isArray(this.allergenIds)) {
            data["allergenIds"] = [];
            for (let item of this.allergenIds)
                data["allergenIds"].push(item);
        }
        data["isSpotlighted"] = this.isSpotlighted;
        if (Array.isArray(this.seasonIds)) {
            data["seasonIds"] = [];
            for (let item of this.seasonIds)
                data["seasonIds"].push(item);
        }
        if (Array.isArray(this.promotedNutrientIds)) {
            data["promotedNutrientIds"] = [];
            for (let item of this.promotedNutrientIds)
                data["promotedNutrientIds"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type CoachingRecipeSearchParams. */
export interface ICoachingRecipeSearchParams extends ISearchParams {
    /** Gets or sets the title. */
    title?: string | undefined;
    /** Gets or sets the type of the dish. */
    dishType?: number | undefined;
    /** Gets or sets the dietary plan. */
    dietaryPlan?: number | undefined;
    /** Gets or sets the dietary plan. */
    status?: CoachingRecipeStatus | undefined;
    /** Gets or sets the allergens. */
    allergenIds?: number[] | undefined;
    /** Gets or sets a value indicating whether this instance is spotlighted. */
    isSpotlighted: boolean;
    /** Gets or sets the season ids. */
    seasonIds?: number[] | undefined;
    /** Gets or sets the nutrient ids. */
    promotedNutrientIds?: number[] | undefined;
}

/** Contains the definition of an object of type PatientRecipeSearchParams */
export class PatientRecipeSearchParams extends CoachingRecipeSearchParams implements IPatientRecipeSearchParams {
    /** Gets or sets the coaching recipe prefab filter. */
    coachingRecipePrefabFilter!: CoachingRecipePrefabFilter;
    /** Gets or sets the dietary plan. */
    dietaryPlans?: number[] | undefined;
    /** Gets or sets the dish types. */
    dishTypes?: number[] | undefined;
    /** Gets or sets the eco responsibility. */
    ecoResponsibilities?: number[] | undefined;
    /** Gets or sets the key words. */
    keyWords?: string[] | undefined;
    /** Gets or sets the ingredients. */
    ingredients?: string[] | undefined;

    constructor(data?: IPatientRecipeSearchParams) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.coachingRecipePrefabFilter = _data["coachingRecipePrefabFilter"];
            if (Array.isArray(_data["dietaryPlans"])) {
                this.dietaryPlans = [] as any;
                for (let item of _data["dietaryPlans"])
                    this.dietaryPlans!.push(item);
            }
            if (Array.isArray(_data["dishTypes"])) {
                this.dishTypes = [] as any;
                for (let item of _data["dishTypes"])
                    this.dishTypes!.push(item);
            }
            if (Array.isArray(_data["ecoResponsibilities"])) {
                this.ecoResponsibilities = [] as any;
                for (let item of _data["ecoResponsibilities"])
                    this.ecoResponsibilities!.push(item);
            }
            if (Array.isArray(_data["keyWords"])) {
                this.keyWords = [] as any;
                for (let item of _data["keyWords"])
                    this.keyWords!.push(item);
            }
            if (Array.isArray(_data["ingredients"])) {
                this.ingredients = [] as any;
                for (let item of _data["ingredients"])
                    this.ingredients!.push(item);
            }
        }
    }

    static override fromJS(data: any): PatientRecipeSearchParams {
        data = typeof data === 'object' ? data : {};
        let result = new PatientRecipeSearchParams();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["coachingRecipePrefabFilter"] = this.coachingRecipePrefabFilter;
        if (Array.isArray(this.dietaryPlans)) {
            data["dietaryPlans"] = [];
            for (let item of this.dietaryPlans)
                data["dietaryPlans"].push(item);
        }
        if (Array.isArray(this.dishTypes)) {
            data["dishTypes"] = [];
            for (let item of this.dishTypes)
                data["dishTypes"].push(item);
        }
        if (Array.isArray(this.ecoResponsibilities)) {
            data["ecoResponsibilities"] = [];
            for (let item of this.ecoResponsibilities)
                data["ecoResponsibilities"].push(item);
        }
        if (Array.isArray(this.keyWords)) {
            data["keyWords"] = [];
            for (let item of this.keyWords)
                data["keyWords"].push(item);
        }
        if (Array.isArray(this.ingredients)) {
            data["ingredients"] = [];
            for (let item of this.ingredients)
                data["ingredients"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type PatientRecipeSearchParams */
export interface IPatientRecipeSearchParams extends ICoachingRecipeSearchParams {
    /** Gets or sets the coaching recipe prefab filter. */
    coachingRecipePrefabFilter: CoachingRecipePrefabFilter;
    /** Gets or sets the dietary plan. */
    dietaryPlans?: number[] | undefined;
    /** Gets or sets the dish types. */
    dishTypes?: number[] | undefined;
    /** Gets or sets the eco responsibility. */
    ecoResponsibilities?: number[] | undefined;
    /** Gets or sets the key words. */
    keyWords?: string[] | undefined;
    /** Gets or sets the ingredients. */
    ingredients?: string[] | undefined;
}

/** Contains the definition of an object of type CoachingRecipePrefabFilter */
export enum CoachingRecipePrefabFilter {
    None = 0,
    Spotlighted = 1,
    Bookmarked = 2,
    Suggested = 3,
    NutritionProgram = 4,
}

/** Contains the definition of an object of type PatientCart */
export class PatientCart implements IPatientCart {
    /** Gets or sets the comment. */
    comment?: string | undefined;
    /** Gets or sets the ingredients. */
    ingredients?: PatientCartIngredient[] | undefined;
    /** Gets or sets the patient identifier. */
    patientId!: number;

    constructor(data?: IPatientCart) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.comment = _data["Comment"];
            if (Array.isArray(_data["Ingredients"])) {
                this.ingredients = [] as any;
                for (let item of _data["Ingredients"])
                    this.ingredients!.push(PatientCartIngredient.fromJS(item));
            }
            this.patientId = _data["PatientId"];
        }
    }

    static fromJS(data: any): PatientCart {
        data = typeof data === 'object' ? data : {};
        let result = new PatientCart();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Comment"] = this.comment;
        if (Array.isArray(this.ingredients)) {
            data["Ingredients"] = [];
            for (let item of this.ingredients)
                data["Ingredients"].push(item ? item.toJSON() : <any>undefined);
        }
        data["PatientId"] = this.patientId;
        return data;
    }
}

/** Contains the definition of an object of type PatientCart */
export interface IPatientCart {
    /** Gets or sets the comment. */
    comment?: string | undefined;
    /** Gets or sets the ingredients. */
    ingredients?: PatientCartIngredient[] | undefined;
    /** Gets or sets the patient identifier. */
    patientId: number;
}

/** Contains the definition of an object of type PatientCartIngredient */
export class PatientCartIngredient implements IPatientCartIngredient {
    /** Gets or sets the identifier. */
    id!: number;
    /** Gets or sets a value indicating whether this instance is selected. */
    isSelected!: boolean;
    /** Gets or sets the name of the ingredient. */
    name?: string | undefined;
    /** Gets or sets the patient identifier. */
    patientId!: number;
    /** Gets or sets the quantity. */
    quantity!: number;
    /** Gets or sets the type of the coaching recipe ingredient. */
    type!: number;

    constructor(data?: IPatientCartIngredient) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isSelected = _data["isSelected"];
            this.name = _data["name"];
            this.patientId = _data["patientId"];
            this.quantity = _data["quantity"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): PatientCartIngredient {
        data = typeof data === 'object' ? data : {};
        let result = new PatientCartIngredient();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isSelected"] = this.isSelected;
        data["name"] = this.name;
        data["patientId"] = this.patientId;
        data["quantity"] = this.quantity;
        data["type"] = this.type;
        return data;
    }
}

/** Contains the definition of an object of type PatientCartIngredient */
export interface IPatientCartIngredient {
    /** Gets or sets the identifier. */
    id: number;
    /** Gets or sets a value indicating whether this instance is selected. */
    isSelected: boolean;
    /** Gets or sets the name of the ingredient. */
    name?: string | undefined;
    /** Gets or sets the patient identifier. */
    patientId: number;
    /** Gets or sets the quantity. */
    quantity: number;
    /** Gets or sets the type of the coaching recipe ingredient. */
    type: number;
}

/** Contains the definition of an object of type CoachingRecipeDetails. */
export class CoachingRecipeDetails extends CoachingRecipe implements ICoachingRecipeDetails {
    /** Gets or sets the allergens. */
    allergens?: CoachingRecipeAllergen[] | undefined;
    /** Gets or sets the description. */
    description!: string;
    /** Gets or sets the eco responsability. */
    ecoResponsabilities!: CoachingRecipeEcoResponsability[];
    /** Gets or sets the ingredients. */
    coachingRecipeIngredients?: CoachingRecipeIngredient[] | undefined;
    /** Gets or sets the nb person. */
    nbPerson!: number;
    /** Gets or sets the zoom sections. */
    zoomSections?: ZoomSection[] | undefined;
    /** Gets or sets the nutrients. */
    nutrients?: RecipeNutrientLite[] | undefined;
    /** Gets or sets the list of ingredients with carbohydrates. */
    listNutriCarbs?: IngredientNutrient[] | undefined;
    /** Gets or sets the list of ingredients with proteins. */
    listNutriProteins?: IngredientNutrient[] | undefined;
    /** Gets or sets the list of ingredients with lipids. */
    listNutriLipids?: IngredientNutrient[] | undefined;
    /** Gets or sets the promoted nutrients. */
    promotedNutrients?: PromotedNutrient[] | undefined;
    /** Gets or sets the weight per portion. */
    weightPerPortion!: number;
    /** Gets or sets the calorific power per portion. */
    calorificPowerPerPortion!: number;
    /** Gets or sets the nutrient categories. */
    nutrientCategories?: RecipeNutrientCategory[] | undefined;
    /** Gets or sets the streaming URL. */
    streamingUrl?: string | undefined;
    /** Gets or sets the streaming element identifier. */
    streamingElementId?: number | undefined;
    /** Gets or sets the name of the streaming element. */
    streamingElementName?: string | undefined;

    constructor(data?: ICoachingRecipeDetails) {
        super(data);
        if (!data) {
            this.ecoResponsabilities = [];
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["allergens"])) {
                this.allergens = [] as any;
                for (let item of _data["allergens"])
                    this.allergens!.push(CoachingRecipeAllergen.fromJS(item));
            }
            this.description = _data["description"];
            if (Array.isArray(_data["ecoResponsabilities"])) {
                this.ecoResponsabilities = [] as any;
                for (let item of _data["ecoResponsabilities"])
                    this.ecoResponsabilities!.push(CoachingRecipeEcoResponsability.fromJS(item));
            }
            if (Array.isArray(_data["coachingRecipeIngredients"])) {
                this.coachingRecipeIngredients = [] as any;
                for (let item of _data["coachingRecipeIngredients"])
                    this.coachingRecipeIngredients!.push(CoachingRecipeIngredient.fromJS(item));
            }
            this.nbPerson = _data["nbPerson"];
            if (Array.isArray(_data["zoomSections"])) {
                this.zoomSections = [] as any;
                for (let item of _data["zoomSections"])
                    this.zoomSections!.push(ZoomSection.fromJS(item));
            }
            if (Array.isArray(_data["nutrients"])) {
                this.nutrients = [] as any;
                for (let item of _data["nutrients"])
                    this.nutrients!.push(RecipeNutrientLite.fromJS(item));
            }
            if (Array.isArray(_data["listNutriCarbs"])) {
                this.listNutriCarbs = [] as any;
                for (let item of _data["listNutriCarbs"])
                    this.listNutriCarbs!.push(IngredientNutrient.fromJS(item));
            }
            if (Array.isArray(_data["listNutriProteins"])) {
                this.listNutriProteins = [] as any;
                for (let item of _data["listNutriProteins"])
                    this.listNutriProteins!.push(IngredientNutrient.fromJS(item));
            }
            if (Array.isArray(_data["listNutriLipids"])) {
                this.listNutriLipids = [] as any;
                for (let item of _data["listNutriLipids"])
                    this.listNutriLipids!.push(IngredientNutrient.fromJS(item));
            }
            if (Array.isArray(_data["promotedNutrients"])) {
                this.promotedNutrients = [] as any;
                for (let item of _data["promotedNutrients"])
                    this.promotedNutrients!.push(PromotedNutrient.fromJS(item));
            }
            this.weightPerPortion = _data["weightPerPortion"];
            this.calorificPowerPerPortion = _data["calorificPowerPerPortion"];
            if (Array.isArray(_data["nutrientCategories"])) {
                this.nutrientCategories = [] as any;
                for (let item of _data["nutrientCategories"])
                    this.nutrientCategories!.push(RecipeNutrientCategory.fromJS(item));
            }
            this.streamingUrl = _data["streamingUrl"];
            this.streamingElementId = _data["streamingElementId"];
            this.streamingElementName = _data["streamingElementName"];
        }
    }

    static override fromJS(data: any): CoachingRecipeDetails {
        data = typeof data === 'object' ? data : {};
        let result = new CoachingRecipeDetails();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.allergens)) {
            data["allergens"] = [];
            for (let item of this.allergens)
                data["allergens"].push(item ? item.toJSON() : <any>undefined);
        }
        data["description"] = this.description;
        if (Array.isArray(this.ecoResponsabilities)) {
            data["ecoResponsabilities"] = [];
            for (let item of this.ecoResponsabilities)
                data["ecoResponsabilities"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.coachingRecipeIngredients)) {
            data["coachingRecipeIngredients"] = [];
            for (let item of this.coachingRecipeIngredients)
                data["coachingRecipeIngredients"].push(item ? item.toJSON() : <any>undefined);
        }
        data["nbPerson"] = this.nbPerson;
        if (Array.isArray(this.zoomSections)) {
            data["zoomSections"] = [];
            for (let item of this.zoomSections)
                data["zoomSections"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.nutrients)) {
            data["nutrients"] = [];
            for (let item of this.nutrients)
                data["nutrients"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.listNutriCarbs)) {
            data["listNutriCarbs"] = [];
            for (let item of this.listNutriCarbs)
                data["listNutriCarbs"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.listNutriProteins)) {
            data["listNutriProteins"] = [];
            for (let item of this.listNutriProteins)
                data["listNutriProteins"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.listNutriLipids)) {
            data["listNutriLipids"] = [];
            for (let item of this.listNutriLipids)
                data["listNutriLipids"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.promotedNutrients)) {
            data["promotedNutrients"] = [];
            for (let item of this.promotedNutrients)
                data["promotedNutrients"].push(item ? item.toJSON() : <any>undefined);
        }
        data["weightPerPortion"] = this.weightPerPortion;
        data["calorificPowerPerPortion"] = this.calorificPowerPerPortion;
        if (Array.isArray(this.nutrientCategories)) {
            data["nutrientCategories"] = [];
            for (let item of this.nutrientCategories)
                data["nutrientCategories"].push(item ? item.toJSON() : <any>undefined);
        }
        data["streamingUrl"] = this.streamingUrl;
        data["streamingElementId"] = this.streamingElementId;
        data["streamingElementName"] = this.streamingElementName;
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type CoachingRecipeDetails. */
export interface ICoachingRecipeDetails extends ICoachingRecipe {
    /** Gets or sets the allergens. */
    allergens?: CoachingRecipeAllergen[] | undefined;
    /** Gets or sets the description. */
    description: string;
    /** Gets or sets the eco responsability. */
    ecoResponsabilities: CoachingRecipeEcoResponsability[];
    /** Gets or sets the ingredients. */
    coachingRecipeIngredients?: CoachingRecipeIngredient[] | undefined;
    /** Gets or sets the nb person. */
    nbPerson: number;
    /** Gets or sets the zoom sections. */
    zoomSections?: ZoomSection[] | undefined;
    /** Gets or sets the nutrients. */
    nutrients?: RecipeNutrientLite[] | undefined;
    /** Gets or sets the list of ingredients with carbohydrates. */
    listNutriCarbs?: IngredientNutrient[] | undefined;
    /** Gets or sets the list of ingredients with proteins. */
    listNutriProteins?: IngredientNutrient[] | undefined;
    /** Gets or sets the list of ingredients with lipids. */
    listNutriLipids?: IngredientNutrient[] | undefined;
    /** Gets or sets the promoted nutrients. */
    promotedNutrients?: PromotedNutrient[] | undefined;
    /** Gets or sets the weight per portion. */
    weightPerPortion: number;
    /** Gets or sets the calorific power per portion. */
    calorificPowerPerPortion: number;
    /** Gets or sets the nutrient categories. */
    nutrientCategories?: RecipeNutrientCategory[] | undefined;
    /** Gets or sets the streaming URL. */
    streamingUrl?: string | undefined;
    /** Gets or sets the streaming element identifier. */
    streamingElementId?: number | undefined;
    /** Gets or sets the name of the streaming element. */
    streamingElementName?: string | undefined;
}

/** Contains the definition of an object of type CoachingRecipeEcoResponsability. */
export class CoachingRecipeEcoResponsability implements ICoachingRecipeEcoResponsability {
    /** Gets or sets the coaching recipe identifier. */
    coachingRecipeId!: number;
    /** Gets or sets the dietary plan identifier. */
    ecoResponsabilityId!: number;

    constructor(data?: ICoachingRecipeEcoResponsability) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.coachingRecipeId = _data["coachingRecipeId"];
            this.ecoResponsabilityId = _data["ecoResponsabilityId"];
        }
    }

    static fromJS(data: any): CoachingRecipeEcoResponsability {
        data = typeof data === 'object' ? data : {};
        let result = new CoachingRecipeEcoResponsability();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["coachingRecipeId"] = this.coachingRecipeId;
        data["ecoResponsabilityId"] = this.ecoResponsabilityId;
        return data;
    }
}

/** Contains the definition of an object of type CoachingRecipeEcoResponsability. */
export interface ICoachingRecipeEcoResponsability {
    /** Gets or sets the coaching recipe identifier. */
    coachingRecipeId: number;
    /** Gets or sets the dietary plan identifier. */
    ecoResponsabilityId: number;
}

/** Contains the definition of an object of type CoachingRecipeIngredient. */
export class CoachingRecipeIngredient implements ICoachingRecipeIngredient {
    /** Gets or sets the identifier. */
    ingredientId!: number;
    /** Gets or sets the recipe identifier. */
    recipeId!: number;
    /** Gets or sets the unit type identifier. */
    unitTypeId!: number;
    /** Gets or sets the quantity. */
    quantity!: number;

    constructor(data?: ICoachingRecipeIngredient) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ingredientId = _data["ingredientId"];
            this.recipeId = _data["recipeId"];
            this.unitTypeId = _data["unitTypeId"];
            this.quantity = _data["quantity"];
        }
    }

    static fromJS(data: any): CoachingRecipeIngredient {
        data = typeof data === 'object' ? data : {};
        let result = new CoachingRecipeIngredient();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ingredientId"] = this.ingredientId;
        data["recipeId"] = this.recipeId;
        data["unitTypeId"] = this.unitTypeId;
        data["quantity"] = this.quantity;
        return data;
    }
}

/** Contains the definition of an object of type CoachingRecipeIngredient. */
export interface ICoachingRecipeIngredient {
    /** Gets or sets the identifier. */
    ingredientId: number;
    /** Gets or sets the recipe identifier. */
    recipeId: number;
    /** Gets or sets the unit type identifier. */
    unitTypeId: number;
    /** Gets or sets the quantity. */
    quantity: number;
}

/** Contains the definition of an object of type ZoomSectionLite */
export class ZoomSectionLite implements IZoomSectionLite {
    /** Gets or sets the identifier. */
    id!: number;
    /** Gets or sets the title. */
    title?: string | undefined;
    /** Gets or sets the zoom type identifier. */
    zoomTypeId?: number | undefined;
    /** Gets or sets a value indicating whether this instance is active. */
    isArchived!: boolean;

    constructor(data?: IZoomSectionLite) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.zoomTypeId = _data["zoomTypeId"];
            this.isArchived = _data["isArchived"];
        }
    }

    static fromJS(data: any): ZoomSectionLite {
        data = typeof data === 'object' ? data : {};
        let result = new ZoomSectionLite();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["zoomTypeId"] = this.zoomTypeId;
        data["isArchived"] = this.isArchived;
        return data;
    }
}

/** Contains the definition of an object of type ZoomSectionLite */
export interface IZoomSectionLite {
    /** Gets or sets the identifier. */
    id: number;
    /** Gets or sets the title. */
    title?: string | undefined;
    /** Gets or sets the zoom type identifier. */
    zoomTypeId?: number | undefined;
    /** Gets or sets a value indicating whether this instance is active. */
    isArchived: boolean;
}

/** Contains the definition of an object of type zoomSection */
export class ZoomSection extends ZoomSectionLite implements IZoomSection {
    /** Gets or sets the custom zoom image path. */
    imageUrl?: string | undefined;
    /** Gets or sets the desccription. */
    description?: string | undefined;
    /** Gets or sets the upload custom zoom image. */
    uploadCustomZoomImage?: any | undefined;

    constructor(data?: IZoomSection) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.imageUrl = _data["imageUrl"];
            this.description = _data["description"];
            this.uploadCustomZoomImage = _data["uploadCustomZoomImage"];
        }
    }

    static override fromJS(data: any): ZoomSection {
        data = typeof data === 'object' ? data : {};
        let result = new ZoomSection();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["imageUrl"] = this.imageUrl;
        data["description"] = this.description;
        data["uploadCustomZoomImage"] = this.uploadCustomZoomImage;
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type zoomSection */
export interface IZoomSection extends IZoomSectionLite {
    /** Gets or sets the custom zoom image path. */
    imageUrl?: string | undefined;
    /** Gets or sets the desccription. */
    description?: string | undefined;
    /** Gets or sets the upload custom zoom image. */
    uploadCustomZoomImage?: any | undefined;
}

/** Contains the definition of an object of type RecipeNutrientLite. */
export class RecipeNutrientLite implements IRecipeNutrientLite {
    /** Gets or sets the name. */
    name?: string | undefined;
    /** Gets or sets the category. */
    category?: RecipeNutrientCategory | undefined;
    /** Gets or sets the quantity. */
    quantity!: number;
    /** Gets or sets the nutrient unit type. */
    unitType!: NutrientUnitType;
    /** Gets or sets the quantity per portion. */
    quantityPerPortion!: number;

    constructor(data?: IRecipeNutrientLite) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.category = _data["category"] ? RecipeNutrientCategory.fromJS(_data["category"]) : <any>undefined;
            this.quantity = _data["quantity"];
            this.unitType = _data["unitType"];
            this.quantityPerPortion = _data["quantityPerPortion"];
        }
    }

    static fromJS(data: any): RecipeNutrientLite {
        data = typeof data === 'object' ? data : {};
        let result = new RecipeNutrientLite();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["category"] = this.category ? this.category.toJSON() : <any>undefined;
        data["quantity"] = this.quantity;
        data["unitType"] = this.unitType;
        data["quantityPerPortion"] = this.quantityPerPortion;
        return data;
    }
}

/** Contains the definition of an object of type RecipeNutrientLite. */
export interface IRecipeNutrientLite {
    /** Gets or sets the name. */
    name?: string | undefined;
    /** Gets or sets the category. */
    category?: RecipeNutrientCategory | undefined;
    /** Gets or sets the quantity. */
    quantity: number;
    /** Gets or sets the nutrient unit type. */
    unitType: NutrientUnitType;
    /** Gets or sets the quantity per portion. */
    quantityPerPortion: number;
}

/** Contains the definition of an object of type RecipeNutrientCategory. */
export class RecipeNutrientCategory implements IRecipeNutrientCategory {
    /** Gets or sets the identifier. */
    id!: number;
    /** Gets or sets the name. */
    name?: string | undefined;

    constructor(data?: IRecipeNutrientCategory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): RecipeNutrientCategory {
        data = typeof data === 'object' ? data : {};
        let result = new RecipeNutrientCategory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

/** Contains the definition of an object of type RecipeNutrientCategory. */
export interface IRecipeNutrientCategory {
    /** Gets or sets the identifier. */
    id: number;
    /** Gets or sets the name. */
    name?: string | undefined;
}

/** Contains the definition of an object of type NutrientUnitType. */
export enum NutrientUnitType {
    Unknow = 0,
    MicroGram = 1,
    MilliGram = 2,
    Gram = 3,
    PresentOrNotPresent = 4,
    KiloGram = 5,
}

/** Contains the definition of an object of type IngredientNutrient. */
export class IngredientNutrient implements IIngredientNutrient {
    /** Gets or sets the recipe identifier. */
    ingredientId!: number;
    /** Gets or sets the nutrient identifier. */
    nutrientId!: number;
    /** Gets or sets the quantity. */
    quantity!: number;
    /** Gets or sets the name of the nutrient. */
    nutrientName?: string | undefined;

    constructor(data?: IIngredientNutrient) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ingredientId = _data["ingredientId"];
            this.nutrientId = _data["nutrientId"];
            this.quantity = _data["quantity"];
            this.nutrientName = _data["nutrientName"];
        }
    }

    static fromJS(data: any): IngredientNutrient {
        data = typeof data === 'object' ? data : {};
        let result = new IngredientNutrient();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ingredientId"] = this.ingredientId;
        data["nutrientId"] = this.nutrientId;
        data["quantity"] = this.quantity;
        data["nutrientName"] = this.nutrientName;
        return data;
    }
}

/** Contains the definition of an object of type IngredientNutrient. */
export interface IIngredientNutrient {
    /** Gets or sets the recipe identifier. */
    ingredientId: number;
    /** Gets or sets the nutrient identifier. */
    nutrientId: number;
    /** Gets or sets the quantity. */
    quantity: number;
    /** Gets or sets the name of the nutrient. */
    nutrientName?: string | undefined;
}

export class PaginatorWrapperOfIEnumerableOfCoachingRecipeForLibrary implements IPaginatorWrapperOfIEnumerableOfCoachingRecipeForLibrary {
    totalRecords!: number;
    data?: CoachingRecipeForLibrary[] | undefined;

    constructor(data?: IPaginatorWrapperOfIEnumerableOfCoachingRecipeForLibrary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRecords = _data["totalRecords"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(CoachingRecipeForLibrary.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatorWrapperOfIEnumerableOfCoachingRecipeForLibrary {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatorWrapperOfIEnumerableOfCoachingRecipeForLibrary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IPaginatorWrapperOfIEnumerableOfCoachingRecipeForLibrary {
    totalRecords: number;
    data?: CoachingRecipeForLibrary[] | undefined;
}

/** Contains the definition of an object of type CoachingRecipe. */
export class CoachingRecipeForLibrary extends CoachingRecipe implements ICoachingRecipeForLibrary {
    /** Gets or sets a value indicating whether this instance is selected. */
    isSelected!: boolean;
    /** Gets or sets a value indicating whether this instance is already in consult. */
    isAlreadyInConsult!: boolean;

    constructor(data?: ICoachingRecipeForLibrary) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.isSelected = _data["isSelected"];
            this.isAlreadyInConsult = _data["isAlreadyInConsult"];
        }
    }

    static override fromJS(data: any): CoachingRecipeForLibrary {
        data = typeof data === 'object' ? data : {};
        let result = new CoachingRecipeForLibrary();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSelected"] = this.isSelected;
        data["isAlreadyInConsult"] = this.isAlreadyInConsult;
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type CoachingRecipe. */
export interface ICoachingRecipeForLibrary extends ICoachingRecipe {
    /** Gets or sets a value indicating whether this instance is selected. */
    isSelected: boolean;
    /** Gets or sets a value indicating whether this instance is already in consult. */
    isAlreadyInConsult: boolean;
}

/** Contains the definition of an object of type CoachingRecipeLibrarySearchParam. */
export class CoachingRecipeLibrarySearchParam extends SearchParams implements ICoachingRecipeLibrarySearchParam {
    /** Gets or sets the title. */
    title?: string | undefined;
    /** Gets or sets the Consultation Id. */
    consultationId!: number;
    /** Gets or sets the Dish Types. */
    dishTypes?: number[] | undefined;
    /** Gets or sets the Diatary Plans. */
    dietaryPlans?: number[] | undefined;
    /** Gets or sets the Seasons. */
    seasons?: number[] | undefined;
    /** Gets or sets the EcoResponsibilities. */
    ecoResponsabilities?: number[] | undefined;
    /** Gets or sets the Allergens. */
    allergens?: number[] | undefined;
    /** Gets or sets the Nutrients. */
    nutrients?: number[] | undefined;
    /** Gets or sets the Ingredients. */
    ingredients?: number[] | undefined;
    /** Gets or sets the nutrition program meal Id. */
    nutritionProgramMealId?: number | undefined;

    constructor(data?: ICoachingRecipeLibrarySearchParam) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.title = _data["title"];
            this.consultationId = _data["consultationId"];
            if (Array.isArray(_data["dishTypes"])) {
                this.dishTypes = [] as any;
                for (let item of _data["dishTypes"])
                    this.dishTypes!.push(item);
            }
            if (Array.isArray(_data["dietaryPlans"])) {
                this.dietaryPlans = [] as any;
                for (let item of _data["dietaryPlans"])
                    this.dietaryPlans!.push(item);
            }
            if (Array.isArray(_data["seasons"])) {
                this.seasons = [] as any;
                for (let item of _data["seasons"])
                    this.seasons!.push(item);
            }
            if (Array.isArray(_data["ecoResponsabilities"])) {
                this.ecoResponsabilities = [] as any;
                for (let item of _data["ecoResponsabilities"])
                    this.ecoResponsabilities!.push(item);
            }
            if (Array.isArray(_data["allergens"])) {
                this.allergens = [] as any;
                for (let item of _data["allergens"])
                    this.allergens!.push(item);
            }
            if (Array.isArray(_data["nutrients"])) {
                this.nutrients = [] as any;
                for (let item of _data["nutrients"])
                    this.nutrients!.push(item);
            }
            if (Array.isArray(_data["ingredients"])) {
                this.ingredients = [] as any;
                for (let item of _data["ingredients"])
                    this.ingredients!.push(item);
            }
            this.nutritionProgramMealId = _data["nutritionProgramMealId"];
        }
    }

    static override fromJS(data: any): CoachingRecipeLibrarySearchParam {
        data = typeof data === 'object' ? data : {};
        let result = new CoachingRecipeLibrarySearchParam();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["consultationId"] = this.consultationId;
        if (Array.isArray(this.dishTypes)) {
            data["dishTypes"] = [];
            for (let item of this.dishTypes)
                data["dishTypes"].push(item);
        }
        if (Array.isArray(this.dietaryPlans)) {
            data["dietaryPlans"] = [];
            for (let item of this.dietaryPlans)
                data["dietaryPlans"].push(item);
        }
        if (Array.isArray(this.seasons)) {
            data["seasons"] = [];
            for (let item of this.seasons)
                data["seasons"].push(item);
        }
        if (Array.isArray(this.ecoResponsabilities)) {
            data["ecoResponsabilities"] = [];
            for (let item of this.ecoResponsabilities)
                data["ecoResponsabilities"].push(item);
        }
        if (Array.isArray(this.allergens)) {
            data["allergens"] = [];
            for (let item of this.allergens)
                data["allergens"].push(item);
        }
        if (Array.isArray(this.nutrients)) {
            data["nutrients"] = [];
            for (let item of this.nutrients)
                data["nutrients"].push(item);
        }
        if (Array.isArray(this.ingredients)) {
            data["ingredients"] = [];
            for (let item of this.ingredients)
                data["ingredients"].push(item);
        }
        data["nutritionProgramMealId"] = this.nutritionProgramMealId;
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type CoachingRecipeLibrarySearchParam. */
export interface ICoachingRecipeLibrarySearchParam extends ISearchParams {
    /** Gets or sets the title. */
    title?: string | undefined;
    /** Gets or sets the Consultation Id. */
    consultationId: number;
    /** Gets or sets the Dish Types. */
    dishTypes?: number[] | undefined;
    /** Gets or sets the Diatary Plans. */
    dietaryPlans?: number[] | undefined;
    /** Gets or sets the Seasons. */
    seasons?: number[] | undefined;
    /** Gets or sets the EcoResponsibilities. */
    ecoResponsabilities?: number[] | undefined;
    /** Gets or sets the Allergens. */
    allergens?: number[] | undefined;
    /** Gets or sets the Nutrients. */
    nutrients?: number[] | undefined;
    /** Gets or sets the Ingredients. */
    ingredients?: number[] | undefined;
    /** Gets or sets the nutrition program meal Id. */
    nutritionProgramMealId?: number | undefined;
}

/** Contains the definition of an object of type UpdateCoachingActivity. */
export class UpdateCoachingActivity extends CoachingActivityBaseEdit implements IUpdateCoachingActivity {
    /** Gets or sets the identifier. */
    id!: number;

    constructor(data?: IUpdateCoachingActivity) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
        }
    }

    static override fromJS(data: any): UpdateCoachingActivity {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCoachingActivity();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type UpdateCoachingActivity. */
export interface IUpdateCoachingActivity extends ICoachingActivityBaseEdit {
    /** Gets or sets the identifier. */
    id: number;
}

/** Contains the definition of an object of type UpdateCoachingRecipe. */
export class UpdateCoachingRecipe extends CoachingRecipeBaseEdit implements IUpdateCoachingRecipe {
    /** Gets or sets the identifier. */
    id!: number;
    /** Gets or sets the ingredients. */
    coachingRecipeIngredients?: UpdateCoachingRecipeIngredient[] | undefined;

    constructor(data?: IUpdateCoachingRecipe) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["coachingRecipeIngredients"])) {
                this.coachingRecipeIngredients = [] as any;
                for (let item of _data["coachingRecipeIngredients"])
                    this.coachingRecipeIngredients!.push(UpdateCoachingRecipeIngredient.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): UpdateCoachingRecipe {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCoachingRecipe();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.coachingRecipeIngredients)) {
            data["coachingRecipeIngredients"] = [];
            for (let item of this.coachingRecipeIngredients)
                data["coachingRecipeIngredients"].push(item ? item.toJSON() : <any>undefined);
        }
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type UpdateCoachingRecipe. */
export interface IUpdateCoachingRecipe extends ICoachingRecipeBaseEdit {
    /** Gets or sets the identifier. */
    id: number;
    /** Gets or sets the ingredients. */
    coachingRecipeIngredients?: UpdateCoachingRecipeIngredient[] | undefined;
}

/** Contains the definition of an object of type UpdateCoachingRecipeIngredient. */
export class UpdateCoachingRecipeIngredient extends CoachingRecipeIngredientBaseEdit implements IUpdateCoachingRecipeIngredient {
    /** Gets or sets the identifier. */
    recipeId!: number;

    constructor(data?: IUpdateCoachingRecipeIngredient) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.recipeId = _data["recipeId"];
        }
    }

    static override fromJS(data: any): UpdateCoachingRecipeIngredient {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCoachingRecipeIngredient();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["recipeId"] = this.recipeId;
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type UpdateCoachingRecipeIngredient. */
export interface IUpdateCoachingRecipeIngredient extends ICoachingRecipeIngredientBaseEdit {
    /** Gets or sets the identifier. */
    recipeId: number;
}

export class StatusValueResourceOfInteger implements IStatusValueResourceOfInteger {
    status!: ResponseStatus;
    value!: number;

    constructor(data?: IStatusValueResourceOfInteger) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): StatusValueResourceOfInteger {
        data = typeof data === 'object' ? data : {};
        let result = new StatusValueResourceOfInteger();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["value"] = this.value;
        return data;
    }
}

export interface IStatusValueResourceOfInteger {
    status: ResponseStatus;
    value: number;
}

/** Contains the definition of an object of type ResponseStatus. */
export enum ResponseStatus {
    Success = 0,
    EmailAlreadyExists = 1,
    UnknownProfession = 2,
    UnknownCountry = 3,
    UserNameAlreadyExists = 4,
    ResellerCodeNotUnique = 5,
    InvalidAdvantageCode = 6,
    ProfessionNotFilledIn = 7,
    BadPassword = 8,
    UpdatePasswordFail = 9,
    IsSiinAcademyProductAlreadyExists = 10,
    UnknownEmail = 11,
    UnknownUser = 12,
    DeletedOrInactiveUser = 13,
    InvalidSponsorshipCode = 14,
    InvoiceNotPaid = 19,
    MemberError = 20,
    MissingArgumentImportExternalCursus = 21,
    AlreadyRegistrationOnRelatedSession = 22,
    InvalidInsuranceToken = 23,
    NoPatient = 24,
    PatientAlreadyLinkedToDoctor = 25,
    FormularyAlreadyHasQuestions = 26,
    FormularyAlreadyHasSleepDiary = 27,
    OverlapingConsultationSchedule = 28,
    ConsultationFull = 29,
    PatientAlreadyInConsultation = 30,
    AlreadyConsultationOfThisType = 31,
    ExpiredInsuranceContract = 32,
    NoMoreFreeConsultations = 33,
    InvalidMemberRole = 34,
    TokenAlreadyUsed = 35,
    MinimalTimeSlotDurationLacking = 36,
    OverlapingTimeSlotSchedule = 40,
    InvalidUntilDate = 41,
    OverlapingUnavailabilitySchedule = 42,
    IsDefaultInsuranceReasonAlreadyExists = 43,
    OtherAccessibleForInsuranceAlreadyExists = 44,
    IsProNutriInscriptionAlreadyExists = 45,
    CantRemoveConsultInRole = 46,
    AccountingReferenceAlreadyExists = 47,
    InvoiceNumberAlreadyExists = 48,
    SubventionNumberAlreadyExists = 49,
    InvoiceAmountCannotExceedSubventionAmount = 50,
    PatientBlockedByDoctor = 51,
    CantDeleteQuestion = 52,
    SuccessAndNewFormularyVersion = 53,
    OutputAssetAlreadyExist = 54,
    AccountNotActivated = 55,
    NoConsultationConfigActive = 56,
    ConsultationConfigHasNoLocation = 57,
    DoctorDoesNotAuthorizeAnyConsultationType = 58,
    StripeIsNotFullyConfigured = 59,
    OnlinePaymentIsNotAuthorized = 60,
    CannotCancelPurchaseOrder = 61,
    PncContractNotSigned = 62,
    AmountToCaptureBiggerThanAuthorized = 63,
    ErrorWhenCapturingPayment = 64,
    PaymentAlreadyCaptured = 65,
    CancelledConsultation = 66,
    MaximumConsultationTypesInFooterReached = 67,
    PatientHasNotAcceptedGDPR = 68,
    ImportPatientInvalidTemplate = 69,
    OverlapingDoctorConsultationSchedule = 70,
    ProfessionnalNumberNoMatchFound = 71,
    CaptureCancelledOrExpired = 72,
    OverlappingUnavailabilityEventSchedule = 73,
    InvalidMemberRoleNoPhone = 74,
    CantDeleteNutritionalSupplement = 75,
    InvalidInvoiceReferenceNumber = 76,
    ConsultationOlderDraftExists = 77,
    ConsultationCapturedAmountNull = 78,
    AlreadyClient = 79,
    ConsultationInFuture = 80,
    InUse = 81,
}

/** Contains the definition of an object of type ConsultInFormularyVersionBaseEdit. */
export class ConsultInFormularyVersionBaseEdit implements IConsultInFormularyVersionBaseEdit {
    /** Gets or sets the status. */
    status!: StatusConsultInFormulary;
    /** Gets or sets the title. */
    title?: string | undefined;
    /** Gets or sets the identifier. */
    id!: number;
    /** Gets or sets the formulary identifier. */
    formularyId!: number;
    /** Gets or sets the disease category identifier. */
    insuranceId?: number | undefined;
    /** Gets or sets the medical description. */
    medicalDescription?: string | undefined;
    /** Gets or sets the patient instruction. */
    patientInstruction?: string | undefined;
    /** Gets or sets the allowed subscription levels. */
    allowedSubscriptionLevels?: number[] | undefined;
    /** Gets or sets the suggestible. */
    suggestible?: Suggestible | undefined;

    constructor(data?: IConsultInFormularyVersionBaseEdit) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.title = _data["title"];
            this.id = _data["id"];
            this.formularyId = _data["formularyId"];
            this.insuranceId = _data["insuranceId"];
            this.medicalDescription = _data["medicalDescription"];
            this.patientInstruction = _data["patientInstruction"];
            if (Array.isArray(_data["allowedSubscriptionLevels"])) {
                this.allowedSubscriptionLevels = [] as any;
                for (let item of _data["allowedSubscriptionLevels"])
                    this.allowedSubscriptionLevels!.push(item);
            }
            this.suggestible = _data["suggestible"] ? Suggestible.fromJS(_data["suggestible"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ConsultInFormularyVersionBaseEdit {
        data = typeof data === 'object' ? data : {};
        let result = new ConsultInFormularyVersionBaseEdit();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["title"] = this.title;
        data["id"] = this.id;
        data["formularyId"] = this.formularyId;
        data["insuranceId"] = this.insuranceId;
        data["medicalDescription"] = this.medicalDescription;
        data["patientInstruction"] = this.patientInstruction;
        if (Array.isArray(this.allowedSubscriptionLevels)) {
            data["allowedSubscriptionLevels"] = [];
            for (let item of this.allowedSubscriptionLevels)
                data["allowedSubscriptionLevels"].push(item);
        }
        data["suggestible"] = this.suggestible ? this.suggestible.toJSON() : <any>undefined;
        return data;
    }
}

/** Contains the definition of an object of type ConsultInFormularyVersionBaseEdit. */
export interface IConsultInFormularyVersionBaseEdit {
    /** Gets or sets the status. */
    status: StatusConsultInFormulary;
    /** Gets or sets the title. */
    title?: string | undefined;
    /** Gets or sets the identifier. */
    id: number;
    /** Gets or sets the formulary identifier. */
    formularyId: number;
    /** Gets or sets the disease category identifier. */
    insuranceId?: number | undefined;
    /** Gets or sets the medical description. */
    medicalDescription?: string | undefined;
    /** Gets or sets the patient instruction. */
    patientInstruction?: string | undefined;
    /** Gets or sets the allowed subscription levels. */
    allowedSubscriptionLevels?: number[] | undefined;
    /** Gets or sets the suggestible. */
    suggestible?: Suggestible | undefined;
}

/** Contains the definition of an object of type CreateConsultInFormularyVersion. */
export class CreateConsultInFormularyVersion extends ConsultInFormularyVersionBaseEdit implements ICreateConsultInFormularyVersion {
    /** Gets or sets the type of the formulary. */
    formularyType!: FormularyType;
    /** Gets or sets a value indicating whether this instance is question categorized. */
    isQuestionCategorized!: boolean;
    /** Gets or sets a value indicating whether this instance has intervals. */
    hasIntervals!: boolean;
    /** Gets or sets a value indicating whether this instance has results. */
    hasWeightResults!: boolean;

    constructor(data?: ICreateConsultInFormularyVersion) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.formularyType = _data["formularyType"];
            this.isQuestionCategorized = _data["isQuestionCategorized"];
            this.hasIntervals = _data["hasIntervals"];
            this.hasWeightResults = _data["hasWeightResults"];
        }
    }

    static override fromJS(data: any): CreateConsultInFormularyVersion {
        data = typeof data === 'object' ? data : {};
        let result = new CreateConsultInFormularyVersion();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["formularyType"] = this.formularyType;
        data["isQuestionCategorized"] = this.isQuestionCategorized;
        data["hasIntervals"] = this.hasIntervals;
        data["hasWeightResults"] = this.hasWeightResults;
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type CreateConsultInFormularyVersion. */
export interface ICreateConsultInFormularyVersion extends IConsultInFormularyVersionBaseEdit {
    /** Gets or sets the type of the formulary. */
    formularyType: FormularyType;
    /** Gets or sets a value indicating whether this instance is question categorized. */
    isQuestionCategorized: boolean;
    /** Gets or sets a value indicating whether this instance has intervals. */
    hasIntervals: boolean;
    /** Gets or sets a value indicating whether this instance has results. */
    hasWeightResults: boolean;
}

/** Contains the definition of an object of type FormularyType. */
export enum FormularyType {
    Unknown = 0,
    Classic = 1,
    Hypothesis = 2,
    Impact = 3,
    SleepDiary = 4,
}

/** Contains the definition of an object of type StatusConsultInFormulary. */
export enum StatusConsultInFormulary {
    Unknown = 0,
    Published = 1,
    Unpublished = 2,
    InProgress = 3,
}

/** Contains the definition of an object of type QuestionBaseEdit. */
export class QuestionBaseEdit implements IQuestionBaseEdit {
    /** Gets or sets the answers. */
    answers?: Answer[] | undefined;
    /** Gets or sets the category identifier. */
    categoryId?: number | undefined;
    /** Gets or sets the description. */
    description?: string | undefined;
    /** Gets or sets the formulary version identifier. */
    formularyVersionId!: number;
    /** Gets or sets a value indicating whether [scale visibility]. */
    isScaleVisible!: boolean;
    /** Gets or sets the sort order. */
    sortOrder!: number;
    /** Gets or sets the sleep diary. */
    sleepDiary?: SleepDiary | undefined;
    /** Gets or sets the title. */
    title?: string | undefined;
    /** Gets or sets the type. */
    type!: QuestionType;

    constructor(data?: IQuestionBaseEdit) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["answers"])) {
                this.answers = [] as any;
                for (let item of _data["answers"])
                    this.answers!.push(Answer.fromJS(item));
            }
            this.categoryId = _data["categoryId"];
            this.description = _data["description"];
            this.formularyVersionId = _data["formularyVersionId"];
            this.isScaleVisible = _data["isScaleVisible"];
            this.sortOrder = _data["sortOrder"];
            this.sleepDiary = _data["sleepDiary"] ? SleepDiary.fromJS(_data["sleepDiary"]) : <any>undefined;
            this.title = _data["title"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): QuestionBaseEdit {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionBaseEdit();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.answers)) {
            data["answers"] = [];
            for (let item of this.answers)
                data["answers"].push(item ? item.toJSON() : <any>undefined);
        }
        data["categoryId"] = this.categoryId;
        data["description"] = this.description;
        data["formularyVersionId"] = this.formularyVersionId;
        data["isScaleVisible"] = this.isScaleVisible;
        data["sortOrder"] = this.sortOrder;
        data["sleepDiary"] = this.sleepDiary ? this.sleepDiary.toJSON() : <any>undefined;
        data["title"] = this.title;
        data["type"] = this.type;
        return data;
    }
}

/** Contains the definition of an object of type QuestionBaseEdit. */
export interface IQuestionBaseEdit {
    /** Gets or sets the answers. */
    answers?: Answer[] | undefined;
    /** Gets or sets the category identifier. */
    categoryId?: number | undefined;
    /** Gets or sets the description. */
    description?: string | undefined;
    /** Gets or sets the formulary version identifier. */
    formularyVersionId: number;
    /** Gets or sets a value indicating whether [scale visibility]. */
    isScaleVisible: boolean;
    /** Gets or sets the sort order. */
    sortOrder: number;
    /** Gets or sets the sleep diary. */
    sleepDiary?: SleepDiary | undefined;
    /** Gets or sets the title. */
    title?: string | undefined;
    /** Gets or sets the type. */
    type: QuestionType;
}

/** Contains the definition of an object of type CreateQuestion. */
export class CreateQuestion extends QuestionBaseEdit implements ICreateQuestion {

    constructor(data?: ICreateQuestion) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): CreateQuestion {
        data = typeof data === 'object' ? data : {};
        let result = new CreateQuestion();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type CreateQuestion. */
export interface ICreateQuestion extends IQuestionBaseEdit {
}

/** Contains the definition of an object of type Answer. */
export class Answer implements IAnswer {
    /** Gets or sets the identifier. */
    id!: number;
    /** Gets or sets the question identifier. */
    questionId!: number;
    /** Gets or sets the value. */
    value!: string;
    /** Gets or sets the weight. */
    weight!: number;

    constructor(data?: IAnswer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.questionId = _data["questionId"];
            this.value = _data["value"];
            this.weight = _data["weight"];
        }
    }

    static fromJS(data: any): Answer {
        data = typeof data === 'object' ? data : {};
        let result = new Answer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["questionId"] = this.questionId;
        data["value"] = this.value;
        data["weight"] = this.weight;
        return data;
    }
}

/** Contains the definition of an object of type Answer. */
export interface IAnswer {
    /** Gets or sets the identifier. */
    id: number;
    /** Gets or sets the question identifier. */
    questionId: number;
    /** Gets or sets the value. */
    value: string;
    /** Gets or sets the weight. */
    weight: number;
}

/** Contains the definition of an object of type SleepDiary. */
export class SleepDiary implements ISleepDiary {
    /** Gets or sets a value indicating whether this instance has awakeness quality. */
    hasAwakenessQuality!: boolean;
    /** Gets or sets a value indicating whether this instance has hypnotic. */
    hasHypnotic!: boolean;
    /** Gets or sets a value indicating whether this instance has intentional nap. */
    hasIntentionalNap!: boolean;
    /** Gets or sets a value indicating whether this instance has lights off time. */
    hasLightsOffTime!: boolean;
    /** Gets or sets a value indicating whether this instance has night wake period. */
    hasNightWakePeriod!: boolean;
    /** Gets or sets a value indicating whether this instance has sleep period. */
    hasSleepPeriod!: boolean;
    /** Gets or sets a value indicating whether this instance has sleep quality. */
    hasSleepQuality!: boolean;
    /** Gets or sets a value indicating whether this instance has tiredness. */
    hasTiredness!: boolean;
    /** Gets or sets a value indicating whether this instance has unintentional nap. */
    hasUnintentionalNap!: boolean;
    /** Gets or sets a value indicating whether this instance has wake up time. */
    hasWakeUpTime!: boolean;
    /** Gets or sets a value indicating whether this instance has will for sleep. */
    hasWillForSleep!: boolean;
    /** Gets or sets the number of weeks. */
    numberOfWeeks!: number;
    /** Gets or sets the question identifier. */
    questionId!: number;

    constructor(data?: ISleepDiary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hasAwakenessQuality = _data["hasAwakenessQuality"];
            this.hasHypnotic = _data["hasHypnotic"];
            this.hasIntentionalNap = _data["hasIntentionalNap"];
            this.hasLightsOffTime = _data["hasLightsOffTime"];
            this.hasNightWakePeriod = _data["hasNightWakePeriod"];
            this.hasSleepPeriod = _data["hasSleepPeriod"];
            this.hasSleepQuality = _data["hasSleepQuality"];
            this.hasTiredness = _data["hasTiredness"];
            this.hasUnintentionalNap = _data["hasUnintentionalNap"];
            this.hasWakeUpTime = _data["hasWakeUpTime"];
            this.hasWillForSleep = _data["hasWillForSleep"];
            this.numberOfWeeks = _data["numberOfWeeks"];
            this.questionId = _data["questionId"];
        }
    }

    static fromJS(data: any): SleepDiary {
        data = typeof data === 'object' ? data : {};
        let result = new SleepDiary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasAwakenessQuality"] = this.hasAwakenessQuality;
        data["hasHypnotic"] = this.hasHypnotic;
        data["hasIntentionalNap"] = this.hasIntentionalNap;
        data["hasLightsOffTime"] = this.hasLightsOffTime;
        data["hasNightWakePeriod"] = this.hasNightWakePeriod;
        data["hasSleepPeriod"] = this.hasSleepPeriod;
        data["hasSleepQuality"] = this.hasSleepQuality;
        data["hasTiredness"] = this.hasTiredness;
        data["hasUnintentionalNap"] = this.hasUnintentionalNap;
        data["hasWakeUpTime"] = this.hasWakeUpTime;
        data["hasWillForSleep"] = this.hasWillForSleep;
        data["numberOfWeeks"] = this.numberOfWeeks;
        data["questionId"] = this.questionId;
        return data;
    }
}

/** Contains the definition of an object of type SleepDiary. */
export interface ISleepDiary {
    /** Gets or sets a value indicating whether this instance has awakeness quality. */
    hasAwakenessQuality: boolean;
    /** Gets or sets a value indicating whether this instance has hypnotic. */
    hasHypnotic: boolean;
    /** Gets or sets a value indicating whether this instance has intentional nap. */
    hasIntentionalNap: boolean;
    /** Gets or sets a value indicating whether this instance has lights off time. */
    hasLightsOffTime: boolean;
    /** Gets or sets a value indicating whether this instance has night wake period. */
    hasNightWakePeriod: boolean;
    /** Gets or sets a value indicating whether this instance has sleep period. */
    hasSleepPeriod: boolean;
    /** Gets or sets a value indicating whether this instance has sleep quality. */
    hasSleepQuality: boolean;
    /** Gets or sets a value indicating whether this instance has tiredness. */
    hasTiredness: boolean;
    /** Gets or sets a value indicating whether this instance has unintentional nap. */
    hasUnintentionalNap: boolean;
    /** Gets or sets a value indicating whether this instance has wake up time. */
    hasWakeUpTime: boolean;
    /** Gets or sets a value indicating whether this instance has will for sleep. */
    hasWillForSleep: boolean;
    /** Gets or sets the number of weeks. */
    numberOfWeeks: number;
    /** Gets or sets the question identifier. */
    questionId: number;
}

/** Contains the definition of an object of type QuestionType. */
export enum QuestionType {
    Unknown = 0,
    YesOrNo = 1,
    MultipleChoice = 2,
    ScaleChoice = 3,
    SleepDiary = 4,
    FreeField = 5,
    FreeFieldWithImage = 6,
    Meal = 7,
}

/** Contains the definition of an object of type FormularyResultBaseEdit. */
export class FormularyResultBaseEdit implements IFormularyResultBaseEdit {
    /** Gets or sets the formulary version identifier. */
    formularyVersionId?: number | undefined;
    /** Gets or sets the minimum interval. */
    minInterval!: number;
    /** Gets or sets the maximum interval. */
    maxInterval!: number;
    /** Gets or sets the signification. */
    signification?: string | undefined;
    /** Gets or sets the stat category. */
    statCategory?: StatCategory | undefined;
    /** Gets or sets the type of the formula result. */
    type!: FormularyResultType;
    /** Gets or sets the question category identifier. */
    questionCategoryId?: number | undefined;
    /** Gets or sets the question identifier. */
    questionId?: number | undefined;
    /** Gets or sets the hypothese identifier. */
    hypothesisId?: number | undefined;
    /** Gets or sets the formulary result hypothesis. */
    formularyResultHypothesis?: FormularyResultHypothesis[] | undefined;
    /** Gets or sets the formulary result diseases. */
    formularyResultDiseases?: FormularyResultDisease[] | undefined;

    constructor(data?: IFormularyResultBaseEdit) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.formularyVersionId = _data["formularyVersionId"];
            this.minInterval = _data["minInterval"];
            this.maxInterval = _data["maxInterval"];
            this.signification = _data["signification"];
            this.statCategory = _data["statCategory"];
            this.type = _data["type"];
            this.questionCategoryId = _data["questionCategoryId"];
            this.questionId = _data["questionId"];
            this.hypothesisId = _data["hypothesisId"];
            if (Array.isArray(_data["formularyResultHypothesis"])) {
                this.formularyResultHypothesis = [] as any;
                for (let item of _data["formularyResultHypothesis"])
                    this.formularyResultHypothesis!.push(FormularyResultHypothesis.fromJS(item));
            }
            if (Array.isArray(_data["formularyResultDiseases"])) {
                this.formularyResultDiseases = [] as any;
                for (let item of _data["formularyResultDiseases"])
                    this.formularyResultDiseases!.push(FormularyResultDisease.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FormularyResultBaseEdit {
        data = typeof data === 'object' ? data : {};
        let result = new FormularyResultBaseEdit();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["formularyVersionId"] = this.formularyVersionId;
        data["minInterval"] = this.minInterval;
        data["maxInterval"] = this.maxInterval;
        data["signification"] = this.signification;
        data["statCategory"] = this.statCategory;
        data["type"] = this.type;
        data["questionCategoryId"] = this.questionCategoryId;
        data["questionId"] = this.questionId;
        data["hypothesisId"] = this.hypothesisId;
        if (Array.isArray(this.formularyResultHypothesis)) {
            data["formularyResultHypothesis"] = [];
            for (let item of this.formularyResultHypothesis)
                data["formularyResultHypothesis"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.formularyResultDiseases)) {
            data["formularyResultDiseases"] = [];
            for (let item of this.formularyResultDiseases)
                data["formularyResultDiseases"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

/** Contains the definition of an object of type FormularyResultBaseEdit. */
export interface IFormularyResultBaseEdit {
    /** Gets or sets the formulary version identifier. */
    formularyVersionId?: number | undefined;
    /** Gets or sets the minimum interval. */
    minInterval: number;
    /** Gets or sets the maximum interval. */
    maxInterval: number;
    /** Gets or sets the signification. */
    signification?: string | undefined;
    /** Gets or sets the stat category. */
    statCategory?: StatCategory | undefined;
    /** Gets or sets the type of the formula result. */
    type: FormularyResultType;
    /** Gets or sets the question category identifier. */
    questionCategoryId?: number | undefined;
    /** Gets or sets the question identifier. */
    questionId?: number | undefined;
    /** Gets or sets the hypothese identifier. */
    hypothesisId?: number | undefined;
    /** Gets or sets the formulary result hypothesis. */
    formularyResultHypothesis?: FormularyResultHypothesis[] | undefined;
    /** Gets or sets the formulary result diseases. */
    formularyResultDiseases?: FormularyResultDisease[] | undefined;
}

/** Contains the definition of an object of type CreateFormularyResult. */
export class CreateFormularyResult extends FormularyResultBaseEdit implements ICreateFormularyResult {

    constructor(data?: ICreateFormularyResult) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): CreateFormularyResult {
        data = typeof data === 'object' ? data : {};
        let result = new CreateFormularyResult();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type CreateFormularyResult. */
export interface ICreateFormularyResult extends IFormularyResultBaseEdit {
}

/** Contains the definition of an object of type StatCategory. */
export enum StatCategory {
    Unknow = 0,
    AverageSleepHours = 1,
    AverageSleepLatency = 2,
    AverageWakeUpLatency = 3,
}

/** Contains the definition of an object of type FormularyResultType. */
export enum FormularyResultType {
    Unknow = 0,
    Classic = 1,
    Hypothesis = 2,
    Statistic = 3,
    ClassicOnQuestion = 4,
}

/** Contains the definition of an object of type FormularyResultHypothesis. */
export class FormularyResultHypothesis implements IFormularyResultHypothesis {
    /** Gets or sets the hypothese identifier. */
    hypotheseId!: number;
    /** Gets or sets the formulary result identifier. */
    formularyResultId!: number;
    /** Gets or sets the weight. */
    weight!: number;

    constructor(data?: IFormularyResultHypothesis) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hypotheseId = _data["hypotheseId"];
            this.formularyResultId = _data["formularyResultId"];
            this.weight = _data["weight"];
        }
    }

    static fromJS(data: any): FormularyResultHypothesis {
        data = typeof data === 'object' ? data : {};
        let result = new FormularyResultHypothesis();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hypotheseId"] = this.hypotheseId;
        data["formularyResultId"] = this.formularyResultId;
        data["weight"] = this.weight;
        return data;
    }
}

/** Contains the definition of an object of type FormularyResultHypothesis. */
export interface IFormularyResultHypothesis {
    /** Gets or sets the hypothese identifier. */
    hypotheseId: number;
    /** Gets or sets the formulary result identifier. */
    formularyResultId: number;
    /** Gets or sets the weight. */
    weight: number;
}

/** Contains the definition of an object of type FormularyResult. */
export class FormularyResultDisease implements IFormularyResultDisease {
    /** Gets or sets the formulary result identifier. */
    formularyResultId!: number;
    /** Gets or sets the disease identifier. */
    diseaseId!: number;

    constructor(data?: IFormularyResultDisease) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.formularyResultId = _data["formularyResultId"];
            this.diseaseId = _data["diseaseId"];
        }
    }

    static fromJS(data: any): FormularyResultDisease {
        data = typeof data === 'object' ? data : {};
        let result = new FormularyResultDisease();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["formularyResultId"] = this.formularyResultId;
        data["diseaseId"] = this.diseaseId;
        return data;
    }
}

/** Contains the definition of an object of type FormularyResult. */
export interface IFormularyResultDisease {
    /** Gets or sets the formulary result identifier. */
    formularyResultId: number;
    /** Gets or sets the disease identifier. */
    diseaseId: number;
}

/** Contains the definition of an object of type ConsultInFormularyVersion. */
export class ConsultInFormularyVersion implements IConsultInFormularyVersion {
    /** Gets or sets the identifier. */
    id!: number;
    /** Gets or sets the formulary identifier. */
    formularyId!: number;
    /** Gets or sets a value indicating whether this instance has sleep diary. */
    hasSleepDiary!: boolean;
    /** Gets or sets the type. */
    formularyType!: FormularyType;
    /** Gets or sets a value indicating whether this instance is life style axis. */
    siinFormularyType?: SiinFormularyType | undefined;
    /** Gets or sets the title. */
    title!: string;
    /** Gets or sets the status. */
    status!: StatusConsultInFormulary;
    /** Gets or sets the allowed subscription levels. */
    allowedSubscriptionLevels?: number[] | undefined;
    /** Gets or sets the suggestible. */
    suggestible?: Suggestible | undefined;
    /** Gets or sets the last sending to patient. */
    lastSendingToPatient?: Date | undefined;
    /** Gets or sets the suggestible source with entity names. */
    suggestibleSourceWithEntityNames?: SuggestibleSourceWithEntityName[] | undefined;
    /** Gets or sets the intention. */
    intention!: IntentionLevelType;
    /** Gets or sets a value indicating whether this instance is selected. */
    isSelected!: boolean;
    /** Gets or sets a value indicating whether this instance is already in consult. */
    isAlreadyInConsult!: boolean;

    constructor(data?: IConsultInFormularyVersion) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.formularyId = _data["formularyId"];
            this.hasSleepDiary = _data["hasSleepDiary"];
            this.formularyType = _data["formularyType"];
            this.siinFormularyType = _data["siinFormularyType"];
            this.title = _data["title"];
            this.status = _data["status"];
            if (Array.isArray(_data["allowedSubscriptionLevels"])) {
                this.allowedSubscriptionLevels = [] as any;
                for (let item of _data["allowedSubscriptionLevels"])
                    this.allowedSubscriptionLevels!.push(item);
            }
            this.suggestible = _data["suggestible"] ? Suggestible.fromJS(_data["suggestible"]) : <any>undefined;
            this.lastSendingToPatient = _data["lastSendingToPatient"] ? new Date(_data["lastSendingToPatient"].toString()) : <any>undefined;
            if (Array.isArray(_data["suggestibleSourceWithEntityNames"])) {
                this.suggestibleSourceWithEntityNames = [] as any;
                for (let item of _data["suggestibleSourceWithEntityNames"])
                    this.suggestibleSourceWithEntityNames!.push(SuggestibleSourceWithEntityName.fromJS(item));
            }
            this.intention = _data["intention"];
            this.isSelected = _data["isSelected"];
            this.isAlreadyInConsult = _data["isAlreadyInConsult"];
        }
    }

    static fromJS(data: any): ConsultInFormularyVersion {
        data = typeof data === 'object' ? data : {};
        let result = new ConsultInFormularyVersion();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["formularyId"] = this.formularyId;
        data["hasSleepDiary"] = this.hasSleepDiary;
        data["formularyType"] = this.formularyType;
        data["siinFormularyType"] = this.siinFormularyType;
        data["title"] = this.title;
        data["status"] = this.status;
        if (Array.isArray(this.allowedSubscriptionLevels)) {
            data["allowedSubscriptionLevels"] = [];
            for (let item of this.allowedSubscriptionLevels)
                data["allowedSubscriptionLevels"].push(item);
        }
        data["suggestible"] = this.suggestible ? this.suggestible.toJSON() : <any>undefined;
        data["lastSendingToPatient"] = this.lastSendingToPatient ? this.lastSendingToPatient.toISOString() : <any>undefined;
        if (Array.isArray(this.suggestibleSourceWithEntityNames)) {
            data["suggestibleSourceWithEntityNames"] = [];
            for (let item of this.suggestibleSourceWithEntityNames)
                data["suggestibleSourceWithEntityNames"].push(item ? item.toJSON() : <any>undefined);
        }
        data["intention"] = this.intention;
        data["isSelected"] = this.isSelected;
        data["isAlreadyInConsult"] = this.isAlreadyInConsult;
        return data;
    }
}

/** Contains the definition of an object of type ConsultInFormularyVersion. */
export interface IConsultInFormularyVersion {
    /** Gets or sets the identifier. */
    id: number;
    /** Gets or sets the formulary identifier. */
    formularyId: number;
    /** Gets or sets a value indicating whether this instance has sleep diary. */
    hasSleepDiary: boolean;
    /** Gets or sets the type. */
    formularyType: FormularyType;
    /** Gets or sets a value indicating whether this instance is life style axis. */
    siinFormularyType?: SiinFormularyType | undefined;
    /** Gets or sets the title. */
    title: string;
    /** Gets or sets the status. */
    status: StatusConsultInFormulary;
    /** Gets or sets the allowed subscription levels. */
    allowedSubscriptionLevels?: number[] | undefined;
    /** Gets or sets the suggestible. */
    suggestible?: Suggestible | undefined;
    /** Gets or sets the last sending to patient. */
    lastSendingToPatient?: Date | undefined;
    /** Gets or sets the suggestible source with entity names. */
    suggestibleSourceWithEntityNames?: SuggestibleSourceWithEntityName[] | undefined;
    /** Gets or sets the intention. */
    intention: IntentionLevelType;
    /** Gets or sets a value indicating whether this instance is selected. */
    isSelected: boolean;
    /** Gets or sets a value indicating whether this instance is already in consult. */
    isAlreadyInConsult: boolean;
}

/** Contains the definition of an object of type ConsultInFormularyVersionDetails. */
export class ConsultInFormularyVersionDetails extends ConsultInFormularyVersion implements IConsultInFormularyVersionDetails {
    /** Gets or sets the disease category identifier. */
    insuranceId?: number | undefined;
    /** Gets or sets the medical description. */
    medicalDescription?: string | undefined;
    /** Gets or sets a value indicating whether this instance is question categorized. */
    isQuestionCategorized!: boolean;
    /** Gets or sets a value indicating whether this instance has intervals. */
    hasIntervals!: boolean;
    /** Gets or sets a value indicating whether this instance has results. */
    hasWeightResults!: boolean;
    /** Gets or sets the patient instruction. */
    patientInstruction?: string | undefined;
    /** Gets or sets the maximum weight. */
    maxWeight!: number;
    /** Gets or sets the minimum weight. */
    minWeight!: number;
    /** Gets or sets the questions. */
    questions?: Question[] | undefined;
    /** Gets or sets the results. */
    results?: FormularyResult[] | undefined;

    constructor(data?: IConsultInFormularyVersionDetails) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.insuranceId = _data["insuranceId"];
            this.medicalDescription = _data["medicalDescription"];
            this.isQuestionCategorized = _data["isQuestionCategorized"];
            this.hasIntervals = _data["hasIntervals"];
            this.hasWeightResults = _data["hasWeightResults"];
            this.patientInstruction = _data["patientInstruction"];
            this.maxWeight = _data["maxWeight"];
            this.minWeight = _data["minWeight"];
            if (Array.isArray(_data["questions"])) {
                this.questions = [] as any;
                for (let item of _data["questions"])
                    this.questions!.push(Question.fromJS(item));
            }
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(FormularyResult.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): ConsultInFormularyVersionDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ConsultInFormularyVersionDetails();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["insuranceId"] = this.insuranceId;
        data["medicalDescription"] = this.medicalDescription;
        data["isQuestionCategorized"] = this.isQuestionCategorized;
        data["hasIntervals"] = this.hasIntervals;
        data["hasWeightResults"] = this.hasWeightResults;
        data["patientInstruction"] = this.patientInstruction;
        data["maxWeight"] = this.maxWeight;
        data["minWeight"] = this.minWeight;
        if (Array.isArray(this.questions)) {
            data["questions"] = [];
            for (let item of this.questions)
                data["questions"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item ? item.toJSON() : <any>undefined);
        }
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type ConsultInFormularyVersionDetails. */
export interface IConsultInFormularyVersionDetails extends IConsultInFormularyVersion {
    /** Gets or sets the disease category identifier. */
    insuranceId?: number | undefined;
    /** Gets or sets the medical description. */
    medicalDescription?: string | undefined;
    /** Gets or sets a value indicating whether this instance is question categorized. */
    isQuestionCategorized: boolean;
    /** Gets or sets a value indicating whether this instance has intervals. */
    hasIntervals: boolean;
    /** Gets or sets a value indicating whether this instance has results. */
    hasWeightResults: boolean;
    /** Gets or sets the patient instruction. */
    patientInstruction?: string | undefined;
    /** Gets or sets the maximum weight. */
    maxWeight: number;
    /** Gets or sets the minimum weight. */
    minWeight: number;
    /** Gets or sets the questions. */
    questions?: Question[] | undefined;
    /** Gets or sets the results. */
    results?: FormularyResult[] | undefined;
}

/** Contains the definition of an object of type Question. */
export class Question implements IQuestion {
    /** Gets or sets the identifier. */
    id!: number;
    /** Gets or sets the formulary identifier. */
    formularyVersionId!: number;
    /** Gets or sets the type. */
    type!: QuestionType;
    /** Gets or sets the category identifier. */
    categoryId?: number | undefined;
    /** Gets or sets the title. */
    title!: string;
    /** Gets or sets the description. */
    description?: string | undefined;
    /** Gets or sets a value indicating whether [scale visibility]. */
    isScaleVisible!: boolean;
    /** Gets or sets the answers. */
    answers!: Answer[];
    /** Gets or sets the results. */
    results?: FormularyResult[] | undefined;
    /** Gets or sets the maximum weight. */
    maxWeight!: number;
    /** Gets or sets the minimum weight. */
    minWeight!: number;
    /** Gets or sets the sleep diary. */
    sleepDiary?: SleepDiary | undefined;

    constructor(data?: IQuestion) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.answers = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.formularyVersionId = _data["formularyVersionId"];
            this.type = _data["type"];
            this.categoryId = _data["categoryId"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.isScaleVisible = _data["isScaleVisible"];
            if (Array.isArray(_data["answers"])) {
                this.answers = [] as any;
                for (let item of _data["answers"])
                    this.answers!.push(Answer.fromJS(item));
            }
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(FormularyResult.fromJS(item));
            }
            this.maxWeight = _data["maxWeight"];
            this.minWeight = _data["minWeight"];
            this.sleepDiary = _data["sleepDiary"] ? SleepDiary.fromJS(_data["sleepDiary"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Question {
        data = typeof data === 'object' ? data : {};
        let result = new Question();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["formularyVersionId"] = this.formularyVersionId;
        data["type"] = this.type;
        data["categoryId"] = this.categoryId;
        data["title"] = this.title;
        data["description"] = this.description;
        data["isScaleVisible"] = this.isScaleVisible;
        if (Array.isArray(this.answers)) {
            data["answers"] = [];
            for (let item of this.answers)
                data["answers"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item ? item.toJSON() : <any>undefined);
        }
        data["maxWeight"] = this.maxWeight;
        data["minWeight"] = this.minWeight;
        data["sleepDiary"] = this.sleepDiary ? this.sleepDiary.toJSON() : <any>undefined;
        return data;
    }
}

/** Contains the definition of an object of type Question. */
export interface IQuestion {
    /** Gets or sets the identifier. */
    id: number;
    /** Gets or sets the formulary identifier. */
    formularyVersionId: number;
    /** Gets or sets the type. */
    type: QuestionType;
    /** Gets or sets the category identifier. */
    categoryId?: number | undefined;
    /** Gets or sets the title. */
    title: string;
    /** Gets or sets the description. */
    description?: string | undefined;
    /** Gets or sets a value indicating whether [scale visibility]. */
    isScaleVisible: boolean;
    /** Gets or sets the answers. */
    answers: Answer[];
    /** Gets or sets the results. */
    results?: FormularyResult[] | undefined;
    /** Gets or sets the maximum weight. */
    maxWeight: number;
    /** Gets or sets the minimum weight. */
    minWeight: number;
    /** Gets or sets the sleep diary. */
    sleepDiary?: SleepDiary | undefined;
}

/** Contains the definition of an object of type FormularyResult. */
export class FormularyResult implements IFormularyResult {
    /** Gets or sets the identifier. */
    id!: number;
    /** Gets or sets the formulary version identifier. */
    formularyVersionId!: number;
    /** Gets or sets the minimum interval. */
    minInterval!: number;
    /** Gets or sets the maximum interval. */
    maxInterval!: number;
    /** Gets or sets the signification. */
    signification?: string | undefined;
    /** Gets or sets the stat category. */
    statCategory?: StatCategory | undefined;
    /** Gets or sets the type of the formula result. */
    type!: FormularyResultType;
    /** Gets or sets the question category identifier. */
    questionCategoryId?: number | undefined;
    /** Gets or sets the question identifier. */
    questionId?: number | undefined;
    /** Gets or sets the hypothesis identifier. */
    hypothesisId?: number | undefined;
    /** Gets or sets the diseases. */
    formularydiseases?: FormularyResultDisease[] | undefined;
    /** Gets or sets the formulary result hypothesis. */
    formularyResultHypothesis?: FormularyResultHypothesis[] | undefined;

    constructor(data?: IFormularyResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.formularyVersionId = _data["formularyVersionId"];
            this.minInterval = _data["minInterval"];
            this.maxInterval = _data["maxInterval"];
            this.signification = _data["signification"];
            this.statCategory = _data["statCategory"];
            this.type = _data["type"];
            this.questionCategoryId = _data["questionCategoryId"];
            this.questionId = _data["questionId"];
            this.hypothesisId = _data["hypothesisId"];
            if (Array.isArray(_data["formularydiseases"])) {
                this.formularydiseases = [] as any;
                for (let item of _data["formularydiseases"])
                    this.formularydiseases!.push(FormularyResultDisease.fromJS(item));
            }
            if (Array.isArray(_data["formularyResultHypothesis"])) {
                this.formularyResultHypothesis = [] as any;
                for (let item of _data["formularyResultHypothesis"])
                    this.formularyResultHypothesis!.push(FormularyResultHypothesis.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FormularyResult {
        data = typeof data === 'object' ? data : {};
        let result = new FormularyResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["formularyVersionId"] = this.formularyVersionId;
        data["minInterval"] = this.minInterval;
        data["maxInterval"] = this.maxInterval;
        data["signification"] = this.signification;
        data["statCategory"] = this.statCategory;
        data["type"] = this.type;
        data["questionCategoryId"] = this.questionCategoryId;
        data["questionId"] = this.questionId;
        data["hypothesisId"] = this.hypothesisId;
        if (Array.isArray(this.formularydiseases)) {
            data["formularydiseases"] = [];
            for (let item of this.formularydiseases)
                data["formularydiseases"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.formularyResultHypothesis)) {
            data["formularyResultHypothesis"] = [];
            for (let item of this.formularyResultHypothesis)
                data["formularyResultHypothesis"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

/** Contains the definition of an object of type FormularyResult. */
export interface IFormularyResult {
    /** Gets or sets the identifier. */
    id: number;
    /** Gets or sets the formulary version identifier. */
    formularyVersionId: number;
    /** Gets or sets the minimum interval. */
    minInterval: number;
    /** Gets or sets the maximum interval. */
    maxInterval: number;
    /** Gets or sets the signification. */
    signification?: string | undefined;
    /** Gets or sets the stat category. */
    statCategory?: StatCategory | undefined;
    /** Gets or sets the type of the formula result. */
    type: FormularyResultType;
    /** Gets or sets the question category identifier. */
    questionCategoryId?: number | undefined;
    /** Gets or sets the question identifier. */
    questionId?: number | undefined;
    /** Gets or sets the hypothesis identifier. */
    hypothesisId?: number | undefined;
    /** Gets or sets the diseases. */
    formularydiseases?: FormularyResultDisease[] | undefined;
    /** Gets or sets the formulary result hypothesis. */
    formularyResultHypothesis?: FormularyResultHypothesis[] | undefined;
}

/** Contains the definition of an object of type SiinFormularyType. */
export enum SiinFormularyType {
    Unknow = 0,
    LifeStyle = 1,
    PhysiologicalHypothesis = 2,
    PerceivedHealthCondition = 3,
    WeightEvolution = 4,
}

export class PaginatorWrapperOfIEnumerableOfConsultInFormularyVersion implements IPaginatorWrapperOfIEnumerableOfConsultInFormularyVersion {
    totalRecords!: number;
    data?: ConsultInFormularyVersion[] | undefined;

    constructor(data?: IPaginatorWrapperOfIEnumerableOfConsultInFormularyVersion) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRecords = _data["totalRecords"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ConsultInFormularyVersion.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatorWrapperOfIEnumerableOfConsultInFormularyVersion {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatorWrapperOfIEnumerableOfConsultInFormularyVersion();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IPaginatorWrapperOfIEnumerableOfConsultInFormularyVersion {
    totalRecords: number;
    data?: ConsultInFormularyVersion[] | undefined;
}

/** Contains the definition of an object of type ConsultInFormularySearchParams. */
export class ConsultInFormularySearchParams extends SearchParamSuggestible implements IConsultInFormularySearchParams {

    constructor(data?: IConsultInFormularySearchParams) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ConsultInFormularySearchParams {
        data = typeof data === 'object' ? data : {};
        let result = new ConsultInFormularySearchParams();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type ConsultInFormularySearchParams. */
export interface IConsultInFormularySearchParams extends ISearchParamSuggestible {
}

/** Contains the definition of an object of type ConsultInFormularyBackOfficeSearchParams. */
export class ConsultInFormularyBackOfficeSearchParams extends SearchParams implements IConsultInFormularyBackOfficeSearchParams {
    /** Gets or sets the identifier. */
    id?: number | undefined;
    /** Gets or sets the title. */
    title?: string | undefined;
    /** Gets or sets the status. */
    status?: StatusConsultInFormulary | undefined;
    /** Gets or sets the trouble sphere. */
    troubleSphere?: number | undefined;
    /** Gets or sets the type of the survey. */
    surveyType?: number | undefined;

    constructor(data?: IConsultInFormularyBackOfficeSearchParams) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.troubleSphere = _data["troubleSphere"];
            this.surveyType = _data["surveyType"];
        }
    }

    static override fromJS(data: any): ConsultInFormularyBackOfficeSearchParams {
        data = typeof data === 'object' ? data : {};
        let result = new ConsultInFormularyBackOfficeSearchParams();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["status"] = this.status;
        data["troubleSphere"] = this.troubleSphere;
        data["surveyType"] = this.surveyType;
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type ConsultInFormularyBackOfficeSearchParams. */
export interface IConsultInFormularyBackOfficeSearchParams extends ISearchParams {
    /** Gets or sets the identifier. */
    id?: number | undefined;
    /** Gets or sets the title. */
    title?: string | undefined;
    /** Gets or sets the status. */
    status?: StatusConsultInFormulary | undefined;
    /** Gets or sets the trouble sphere. */
    troubleSphere?: number | undefined;
    /** Gets or sets the type of the survey. */
    surveyType?: number | undefined;
}

/** Contains the definition of an object of type FormularyConsultationCreation. */
export class FormularyConsultationCreation implements IFormularyConsultationCreation {
    /** Gets or sets the title. */
    title?: string | undefined;
    /** Gets or sets the formulary identifier. */
    formularyVersionId!: number;
    /** Gets or sets a value indicating whether this instance is selected. */
    isSelected!: boolean;
    /** Gets or sets the name of the suggestible source with entity. */
    suggestibleSourceWithEntityName?: SuggestibleSourceWithEntityName[] | undefined;
    /** Gets or sets the intention. */
    intention!: IntentionLevelType;
    /** Gets or sets the last sending date. */
    lastSendingDate?: Date | undefined;
    /** Gets or sets the consutation formulary identifier. */
    consutationFormularyId?: number | undefined;
    /** Gets or sets the consultation formulary status. */
    consultationFormularyStatus!: StatusConsultationFormularyEnum;
    /** Gets or sets a value indicating whether this is a sleep diary. */
    isSleepDiary!: boolean;
    /** Gets or sets a value indicating whether this is a sleep diary with answers. */
    hasSleepDiaryAnswers!: boolean;
    /** Gets or sets the formulary identifier. */
    formularyId!: number;

    constructor(data?: IFormularyConsultationCreation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.formularyVersionId = _data["formularyVersionId"];
            this.isSelected = _data["isSelected"];
            if (Array.isArray(_data["suggestibleSourceWithEntityName"])) {
                this.suggestibleSourceWithEntityName = [] as any;
                for (let item of _data["suggestibleSourceWithEntityName"])
                    this.suggestibleSourceWithEntityName!.push(SuggestibleSourceWithEntityName.fromJS(item));
            }
            this.intention = _data["intention"];
            this.lastSendingDate = _data["lastSendingDate"] ? new Date(_data["lastSendingDate"].toString()) : <any>undefined;
            this.consutationFormularyId = _data["consutationFormularyId"];
            this.consultationFormularyStatus = _data["consultationFormularyStatus"];
            this.isSleepDiary = _data["isSleepDiary"];
            this.hasSleepDiaryAnswers = _data["hasSleepDiaryAnswers"];
            this.formularyId = _data["formularyId"];
        }
    }

    static fromJS(data: any): FormularyConsultationCreation {
        data = typeof data === 'object' ? data : {};
        let result = new FormularyConsultationCreation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["formularyVersionId"] = this.formularyVersionId;
        data["isSelected"] = this.isSelected;
        if (Array.isArray(this.suggestibleSourceWithEntityName)) {
            data["suggestibleSourceWithEntityName"] = [];
            for (let item of this.suggestibleSourceWithEntityName)
                data["suggestibleSourceWithEntityName"].push(item ? item.toJSON() : <any>undefined);
        }
        data["intention"] = this.intention;
        data["lastSendingDate"] = this.lastSendingDate ? this.lastSendingDate.toISOString() : <any>undefined;
        data["consutationFormularyId"] = this.consutationFormularyId;
        data["consultationFormularyStatus"] = this.consultationFormularyStatus;
        data["isSleepDiary"] = this.isSleepDiary;
        data["hasSleepDiaryAnswers"] = this.hasSleepDiaryAnswers;
        data["formularyId"] = this.formularyId;
        return data;
    }
}

/** Contains the definition of an object of type FormularyConsultationCreation. */
export interface IFormularyConsultationCreation {
    /** Gets or sets the title. */
    title?: string | undefined;
    /** Gets or sets the formulary identifier. */
    formularyVersionId: number;
    /** Gets or sets a value indicating whether this instance is selected. */
    isSelected: boolean;
    /** Gets or sets the name of the suggestible source with entity. */
    suggestibleSourceWithEntityName?: SuggestibleSourceWithEntityName[] | undefined;
    /** Gets or sets the intention. */
    intention: IntentionLevelType;
    /** Gets or sets the last sending date. */
    lastSendingDate?: Date | undefined;
    /** Gets or sets the consutation formulary identifier. */
    consutationFormularyId?: number | undefined;
    /** Gets or sets the consultation formulary status. */
    consultationFormularyStatus: StatusConsultationFormularyEnum;
    /** Gets or sets a value indicating whether this is a sleep diary. */
    isSleepDiary: boolean;
    /** Gets or sets a value indicating whether this is a sleep diary with answers. */
    hasSleepDiaryAnswers: boolean;
    /** Gets or sets the formulary identifier. */
    formularyId: number;
}

/** Contains the definition of an object of type StatusConsultationFormularyEnum. */
export enum StatusConsultationFormularyEnum {
    New = 0,
    Open = 1,
    Complete = 2,
    Cancelled = 3,
}

/** Contains the definition of an object of type ConsultationCreationSearch. */
export class ConsultationCreationSearch implements IConsultationCreationSearch {
    /** Gets or sets the diseases. */
    diseases?: number[] | undefined;
    /** Gets or sets the doctor identifier. */
    doctorId!: number;
    /** Gets or sets the patient identifier. */
    patientId!: number;
    /** Gets or sets the consultation configuration identifier. */
    consultationConfigId!: number;
    /** Gets or sets the consultation reason identifier. */
    consultationReasonId?: number | undefined;

    constructor(data?: IConsultationCreationSearch) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["diseases"])) {
                this.diseases = [] as any;
                for (let item of _data["diseases"])
                    this.diseases!.push(item);
            }
            this.doctorId = _data["doctorId"];
            this.patientId = _data["patientId"];
            this.consultationConfigId = _data["consultationConfigId"];
            this.consultationReasonId = _data["consultationReasonId"];
        }
    }

    static fromJS(data: any): ConsultationCreationSearch {
        data = typeof data === 'object' ? data : {};
        let result = new ConsultationCreationSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.diseases)) {
            data["diseases"] = [];
            for (let item of this.diseases)
                data["diseases"].push(item);
        }
        data["doctorId"] = this.doctorId;
        data["patientId"] = this.patientId;
        data["consultationConfigId"] = this.consultationConfigId;
        data["consultationReasonId"] = this.consultationReasonId;
        return data;
    }
}

/** Contains the definition of an object of type ConsultationCreationSearch. */
export interface IConsultationCreationSearch {
    /** Gets or sets the diseases. */
    diseases?: number[] | undefined;
    /** Gets or sets the doctor identifier. */
    doctorId: number;
    /** Gets or sets the patient identifier. */
    patientId: number;
    /** Gets or sets the consultation configuration identifier. */
    consultationConfigId: number;
    /** Gets or sets the consultation reason identifier. */
    consultationReasonId?: number | undefined;
}

/** Contains the definition of an object of type FormularySuggestionSearch. */
export class FormularySuggestionSearch implements IFormularySuggestionSearch {
    /** Gets or sets the consultation reason id. */
    consultationReasonId!: number;
    /** Gets or sets the disease ids. */
    diseaseIds?: number[] | undefined;

    constructor(data?: IFormularySuggestionSearch) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.consultationReasonId = _data["consultationReasonId"];
            if (Array.isArray(_data["diseaseIds"])) {
                this.diseaseIds = [] as any;
                for (let item of _data["diseaseIds"])
                    this.diseaseIds!.push(item);
            }
        }
    }

    static fromJS(data: any): FormularySuggestionSearch {
        data = typeof data === 'object' ? data : {};
        let result = new FormularySuggestionSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["consultationReasonId"] = this.consultationReasonId;
        if (Array.isArray(this.diseaseIds)) {
            data["diseaseIds"] = [];
            for (let item of this.diseaseIds)
                data["diseaseIds"].push(item);
        }
        return data;
    }
}

/** Contains the definition of an object of type FormularySuggestionSearch. */
export interface IFormularySuggestionSearch {
    /** Gets or sets the consultation reason id. */
    consultationReasonId: number;
    /** Gets or sets the disease ids. */
    diseaseIds?: number[] | undefined;
}

/** Contains the definition of an object of type UpdateConsultInFormularyVersion. */
export class UpdateConsultInFormularyVersion extends ConsultInFormularyVersionBaseEdit implements IUpdateConsultInFormularyVersion {

    constructor(data?: IUpdateConsultInFormularyVersion) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): UpdateConsultInFormularyVersion {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateConsultInFormularyVersion();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type UpdateConsultInFormularyVersion. */
export interface IUpdateConsultInFormularyVersion extends IConsultInFormularyVersionBaseEdit {
}

/** Contains the definition of an object of type UpdateQuestion. */
export class UpdateQuestion extends QuestionBaseEdit implements IUpdateQuestion {
    /** Gets or sets the identifier. */
    id!: number;

    constructor(data?: IUpdateQuestion) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
        }
    }

    static override fromJS(data: any): UpdateQuestion {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateQuestion();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type UpdateQuestion. */
export interface IUpdateQuestion extends IQuestionBaseEdit {
    /** Gets or sets the identifier. */
    id: number;
}

/** Contains the definition of an object of type UpdateFormularyResult. */
export class UpdateFormularyResult extends FormularyResultBaseEdit implements IUpdateFormularyResult {
    /** Gets or sets the identifier. */
    id!: number;

    constructor(data?: IUpdateFormularyResult) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
        }
    }

    static override fromJS(data: any): UpdateFormularyResult {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateFormularyResult();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type UpdateFormularyResult. */
export interface IUpdateFormularyResult extends IFormularyResultBaseEdit {
    /** Gets or sets the identifier. */
    id: number;
}

/** Contains the definition of an object of type BaseEditBiologicalExam. */
export class BaseEditBiologicalExam implements IBaseEditBiologicalExam {
    /** Gets or sets the identifier. */
    id!: number;
    /** Gets or sets the name. */
    name?: string | undefined;
    /** Gets or sets the suggestible. */
    suggestible?: Suggestible | undefined;
    /** Gets or sets the identifier of the doctor. */
    doctorId?: number | undefined;
    /** Gets or sets the type of the biological exam. */
    nature!: BiologicalExamNatureSample;
    /** Gets or sets a value indicating whether this instance is active. */
    isArchived!: boolean;

    constructor(data?: IBaseEditBiologicalExam) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.suggestible = _data["suggestible"] ? Suggestible.fromJS(_data["suggestible"]) : <any>undefined;
            this.doctorId = _data["doctorId"];
            this.nature = _data["nature"];
            this.isArchived = _data["isArchived"];
        }
    }

    static fromJS(data: any): BaseEditBiologicalExam {
        data = typeof data === 'object' ? data : {};
        let result = new BaseEditBiologicalExam();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["suggestible"] = this.suggestible ? this.suggestible.toJSON() : <any>undefined;
        data["doctorId"] = this.doctorId;
        data["nature"] = this.nature;
        data["isArchived"] = this.isArchived;
        return data;
    }
}

/** Contains the definition of an object of type BaseEditBiologicalExam. */
export interface IBaseEditBiologicalExam {
    /** Gets or sets the identifier. */
    id: number;
    /** Gets or sets the name. */
    name?: string | undefined;
    /** Gets or sets the suggestible. */
    suggestible?: Suggestible | undefined;
    /** Gets or sets the identifier of the doctor. */
    doctorId?: number | undefined;
    /** Gets or sets the type of the biological exam. */
    nature: BiologicalExamNatureSample;
    /** Gets or sets a value indicating whether this instance is active. */
    isArchived: boolean;
}

/** Contains the definition of an object of type CreateBiologicalExam. */
export class CreateBiologicalExam extends BaseEditBiologicalExam implements ICreateBiologicalExam {

    constructor(data?: ICreateBiologicalExam) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): CreateBiologicalExam {
        data = typeof data === 'object' ? data : {};
        let result = new CreateBiologicalExam();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type CreateBiologicalExam. */
export interface ICreateBiologicalExam extends IBaseEditBiologicalExam {
}

/** Contains the definition of an object of type BiologicalExamNatureSample. */
export enum BiologicalExamNatureSample {
    Serum = 1,
    Plasma = 2,
    Urine = 3,
    Urine24Hour = 4,
    HeparinizedPlasma = 5,
    NightUrine = 6,
    WholeBloodEDTA = 7,
    PlasmaEDTA = 8,
    WholeBlood = 9,
    CitratePlasma = 10,
    Stool = 11,
    LowPlateletCitratePlasma = 12,
    WholeBloodOnCoagulant = 13,
    Saliva = 14,
    WholeBloodHeparinized = 15,
    WholeBloodOnCoagulantEdtaOrCitrate = 16,
    UrineSample = 17,
    Stool24Hours = 18,
    UrineSecondMicturitionMorning = 19,
    Urine5Hour = 20,
    WhoolBloodEdtaAndSerum = 21,
    Edta = 22,
    Citrate = 23,
    Iggt = 24,
    Cro = 25,
    EdtaUnderIce = 26,
    UrineNeuro = 27,
    Hista = 28,
    Al = 29,
    Bl = 30,
    Pyogenee = 31,
    WholeBloodOnCoagulantAndSerum = 32,
    Stone = 33,
    PlasmaEdtaAndUrine = 34,
    ArticularLiquid = 35,
    StoolAndSerum = 36,
    HairSkinNail = 37,
    BacterialCulture = 38,
    Culture = 39,
    Idente = 40,
    Heparin = 41,
    Smear = 42,
    Serum20Hours = 43,
    Gonoe = 44,
    Mycosee = 45,
    Miscellaneous = 46,
    Puncture = 47,
    Expectoration = 48,
    Dermatophyteso = 49,
    Fluore = 50,
    Parasitologiquea = 51,
    Homocu = 52,
    Epig = 53,
    Gerste = 54,
    NewB = 55,
    Fluore2HoursPp = 56,
    Pcrq = 57,
    Iggi = 58,
    Cult = 59,
    Homocysteine = 60,
    Serum120Minuts = 61,
    UrinePerm = 62,
    Le = 63,
    Fecauxs = 64,
    Meningocoqueo = 65,
    Pneumocoquese = 66,
    UrineMou = 67,
    Eda = 68,
    Bact = 69,
    Direct = 70,
    Nvl = 71,
    U24e = 72,
    Schistomai = 73,
    Igg22l = 74,
    Igg100l = 75,
    Igg25l = 76,
    Igg50l = 77,
    Parainfluenzaf = 78,
    HeparinOnIce = 79,
    Adenoviruse = 80,
    Pneumol = 81,
    Coror = 82,
    Colr = 83,
    Zonar = 84,
    Simplex1R = 85,
    Simplex2R = 86,
    PneumonC = 87,
    Genitc = 88,
    Hominc = 89,
    Oreillonse = 90,
    Rougeoleu = 91,
    Rsvv = 92,
    Ureae = 93,
    Ar = 94,
    Br = 95,
    Bindingt = 96,
    SerumAndUrine = 97,
    Ulr = 98,
    U24b = 99,
    Creat = 100,
    QuantiferonGray = 101,
    QuantiferonPurple = 102,
    QuantiferonGreen = 103,
    QuantiferonYellow = 104,
    Gbsb = 105,
    Edta2 = 106,
    Agy = 107,
    Groupes = 108,
    Amylasea = 109,
    Isph = 110,
    Septine9SpecialSample = 111,
    Nose = 112,
    Acidec = 113,
    Dibucainei = 114,
    Sperm = 115,
    Homao = 116,
    StreckTube = 117,
    Vagm = 118,
}

/** Contains the definition of an object of type BiologicalExamSet. */
export class BiologicalExamSet implements IBiologicalExamSet {
    /** Gets or sets the identifier. */
    id!: number;
    /** Gets or sets the identifier of the doctor */
    doctorId?: number | undefined;
    /** Gets or sets the name. */
    name?: string | undefined;
    /** Gets or sets the description. */
    description?: string | undefined;
    /** Gets or sets a value indicating whether this instance is active. */
    isArchived!: boolean;
    /** Gets or sets the biological exams. */
    biologicalExams?: BiologicalExam[] | undefined;

    constructor(data?: IBiologicalExamSet) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.doctorId = _data["doctorId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.isArchived = _data["isArchived"];
            if (Array.isArray(_data["biologicalExams"])) {
                this.biologicalExams = [] as any;
                for (let item of _data["biologicalExams"])
                    this.biologicalExams!.push(BiologicalExam.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BiologicalExamSet {
        data = typeof data === 'object' ? data : {};
        let result = new BiologicalExamSet();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["doctorId"] = this.doctorId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["isArchived"] = this.isArchived;
        if (Array.isArray(this.biologicalExams)) {
            data["biologicalExams"] = [];
            for (let item of this.biologicalExams)
                data["biologicalExams"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

/** Contains the definition of an object of type BiologicalExamSet. */
export interface IBiologicalExamSet {
    /** Gets or sets the identifier. */
    id: number;
    /** Gets or sets the identifier of the doctor */
    doctorId?: number | undefined;
    /** Gets or sets the name. */
    name?: string | undefined;
    /** Gets or sets the description. */
    description?: string | undefined;
    /** Gets or sets a value indicating whether this instance is active. */
    isArchived: boolean;
    /** Gets or sets the biological exams. */
    biologicalExams?: BiologicalExam[] | undefined;
}

/** Contains the definition of an object of type BiologicalExam. */
export class BiologicalExam implements IBiologicalExam {
    /** Gets or sets the identifier. */
    id!: number;
    /** Gets or sets the name. */
    name?: string | undefined;
    /** Gets or sets the nature of the sample. */
    natureSample!: BiologicalExamNatureSample;
    /** Gets or sets the doctorId. */
    doctorId?: number | undefined;
    /** Gets or sets the suggestible. */
    suggestible?: Suggestible | undefined;
    /** Gets or sets a value indicating whether this instance is active. */
    isArchived!: boolean;

    constructor(data?: IBiologicalExam) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.natureSample = _data["natureSample"];
            this.doctorId = _data["doctorId"];
            this.suggestible = _data["suggestible"] ? Suggestible.fromJS(_data["suggestible"]) : <any>undefined;
            this.isArchived = _data["isArchived"];
        }
    }

    static fromJS(data: any): BiologicalExam {
        data = typeof data === 'object' ? data : {};
        let result = new BiologicalExam();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["natureSample"] = this.natureSample;
        data["doctorId"] = this.doctorId;
        data["suggestible"] = this.suggestible ? this.suggestible.toJSON() : <any>undefined;
        data["isArchived"] = this.isArchived;
        return data;
    }
}

/** Contains the definition of an object of type BiologicalExam. */
export interface IBiologicalExam {
    /** Gets or sets the identifier. */
    id: number;
    /** Gets or sets the name. */
    name?: string | undefined;
    /** Gets or sets the nature of the sample. */
    natureSample: BiologicalExamNatureSample;
    /** Gets or sets the doctorId. */
    doctorId?: number | undefined;
    /** Gets or sets the suggestible. */
    suggestible?: Suggestible | undefined;
    /** Gets or sets a value indicating whether this instance is active. */
    isArchived: boolean;
}

/** Contains the definition of an object of type BaseEditComplementaryExam. */
export class BaseEditComplementaryExam implements IBaseEditComplementaryExam {
    /** Gets or sets the identifier. */
    id!: number;
    /** Gets or sets the name. */
    name?: string | undefined;
    /** Gets or sets the suggestible. */
    suggestible?: Suggestible | undefined;
    /** Gets or sets the identifier of the doctor. */
    doctorId?: number | undefined;
    /** Gets or sets a value indicating whether this instance is active. */
    isArchived!: boolean;
    /** Gets or sets a value indicating whether this instance is medical imaging. */
    isMedicalImaging!: boolean;

    constructor(data?: IBaseEditComplementaryExam) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.suggestible = _data["suggestible"] ? Suggestible.fromJS(_data["suggestible"]) : <any>undefined;
            this.doctorId = _data["doctorId"];
            this.isArchived = _data["isArchived"];
            this.isMedicalImaging = _data["isMedicalImaging"];
        }
    }

    static fromJS(data: any): BaseEditComplementaryExam {
        data = typeof data === 'object' ? data : {};
        let result = new BaseEditComplementaryExam();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["suggestible"] = this.suggestible ? this.suggestible.toJSON() : <any>undefined;
        data["doctorId"] = this.doctorId;
        data["isArchived"] = this.isArchived;
        data["isMedicalImaging"] = this.isMedicalImaging;
        return data;
    }
}

/** Contains the definition of an object of type BaseEditComplementaryExam. */
export interface IBaseEditComplementaryExam {
    /** Gets or sets the identifier. */
    id: number;
    /** Gets or sets the name. */
    name?: string | undefined;
    /** Gets or sets the suggestible. */
    suggestible?: Suggestible | undefined;
    /** Gets or sets the identifier of the doctor. */
    doctorId?: number | undefined;
    /** Gets or sets a value indicating whether this instance is active. */
    isArchived: boolean;
    /** Gets or sets a value indicating whether this instance is medical imaging. */
    isMedicalImaging: boolean;
}

/** Contains the definition of an object of type CreateComplementaryExam. */
export class CreateComplementaryExam extends BaseEditComplementaryExam implements ICreateComplementaryExam {

    constructor(data?: ICreateComplementaryExam) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): CreateComplementaryExam {
        data = typeof data === 'object' ? data : {};
        let result = new CreateComplementaryExam();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type CreateComplementaryExam. */
export interface ICreateComplementaryExam extends IBaseEditComplementaryExam {
}

/** Contains the definition of an object of type DiseaseBaseEdit. */
export class DiseaseBaseEdit implements IDiseaseBaseEdit {
    /** Gets or sets the identifier. */
    id!: number;
    /** Gets or sets a value indicating whether [library available]. */
    libraryAvailable!: boolean;
    /** Gets or sets the name. */
    name?: string | undefined;
    /** Gets or sets the disease category. */
    diseaseCategoryId!: number;
    /** Gets or sets the disease detail hypotheses. */
    diseaseDetailHypotheses?: DiseaseHypothese[] | undefined;
    /** Gets or sets a value indicating whether this instance is active. */
    isArchived!: boolean;

    constructor(data?: IDiseaseBaseEdit) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.libraryAvailable = _data["libraryAvailable"];
            this.name = _data["name"];
            this.diseaseCategoryId = _data["diseaseCategoryId"];
            if (Array.isArray(_data["diseaseDetailHypotheses"])) {
                this.diseaseDetailHypotheses = [] as any;
                for (let item of _data["diseaseDetailHypotheses"])
                    this.diseaseDetailHypotheses!.push(DiseaseHypothese.fromJS(item));
            }
            this.isArchived = _data["isArchived"];
        }
    }

    static fromJS(data: any): DiseaseBaseEdit {
        data = typeof data === 'object' ? data : {};
        let result = new DiseaseBaseEdit();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["libraryAvailable"] = this.libraryAvailable;
        data["name"] = this.name;
        data["diseaseCategoryId"] = this.diseaseCategoryId;
        if (Array.isArray(this.diseaseDetailHypotheses)) {
            data["diseaseDetailHypotheses"] = [];
            for (let item of this.diseaseDetailHypotheses)
                data["diseaseDetailHypotheses"].push(item ? item.toJSON() : <any>undefined);
        }
        data["isArchived"] = this.isArchived;
        return data;
    }
}

/** Contains the definition of an object of type DiseaseBaseEdit. */
export interface IDiseaseBaseEdit {
    /** Gets or sets the identifier. */
    id: number;
    /** Gets or sets a value indicating whether [library available]. */
    libraryAvailable: boolean;
    /** Gets or sets the name. */
    name?: string | undefined;
    /** Gets or sets the disease category. */
    diseaseCategoryId: number;
    /** Gets or sets the disease detail hypotheses. */
    diseaseDetailHypotheses?: DiseaseHypothese[] | undefined;
    /** Gets or sets a value indicating whether this instance is active. */
    isArchived: boolean;
}

/** Contains the definition of an object of type CreateDisease. */
export class CreateDisease extends DiseaseBaseEdit implements ICreateDisease {

    constructor(data?: ICreateDisease) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): CreateDisease {
        data = typeof data === 'object' ? data : {};
        let result = new CreateDisease();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type CreateDisease. */
export interface ICreateDisease extends IDiseaseBaseEdit {
}

/** Contains the definition of an object of type DiseaseHypothese. */
export class DiseaseHypothese implements IDiseaseHypothese {
    /** Gets or sets the hypothese identifier. */
    hypotheseId!: number;
    /** Gets or sets the type of the hypothese. */
    hypotheseType!: HypotheseType;

    constructor(data?: IDiseaseHypothese) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hypotheseId = _data["hypotheseId"];
            this.hypotheseType = _data["hypotheseType"];
        }
    }

    static fromJS(data: any): DiseaseHypothese {
        data = typeof data === 'object' ? data : {};
        let result = new DiseaseHypothese();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hypotheseId"] = this.hypotheseId;
        data["hypotheseType"] = this.hypotheseType;
        return data;
    }
}

/** Contains the definition of an object of type DiseaseHypothese. */
export interface IDiseaseHypothese {
    /** Gets or sets the hypothese identifier. */
    hypotheseId: number;
    /** Gets or sets the type of the hypothese. */
    hypotheseType: HypotheseType;
}

/** Contains the definition of an object of type HypotheseType */
export enum HypotheseType {
    Unknow = 0,
    HypotheseFirstIntention = 1,
    HypotheseSecondeIntention = 2,
}

/** Contains the definition of an object of type DiseaseCategory. */
export class DiseaseCategory implements IDiseaseCategory {
    /** Gets or sets the identifier. */
    id!: number;
    /** Gets or sets the name. */
    name!: string;
    /** Gets or sets a value indicating whether this instance is active. */
    isArchived!: boolean;

    constructor(data?: IDiseaseCategory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.isArchived = _data["isArchived"];
        }
    }

    static fromJS(data: any): DiseaseCategory {
        data = typeof data === 'object' ? data : {};
        let result = new DiseaseCategory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["isArchived"] = this.isArchived;
        return data;
    }
}

/** Contains the definition of an object of type DiseaseCategory. */
export interface IDiseaseCategory {
    /** Gets or sets the identifier. */
    id: number;
    /** Gets or sets the name. */
    name: string;
    /** Gets or sets a value indicating whether this instance is active. */
    isArchived: boolean;
}

export class PaginatorWrapperOfIEnumerableOfBiologicalExamWithWarnings implements IPaginatorWrapperOfIEnumerableOfBiologicalExamWithWarnings {
    totalRecords!: number;
    data?: BiologicalExamWithWarnings[] | undefined;

    constructor(data?: IPaginatorWrapperOfIEnumerableOfBiologicalExamWithWarnings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRecords = _data["totalRecords"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(BiologicalExamWithWarnings.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatorWrapperOfIEnumerableOfBiologicalExamWithWarnings {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatorWrapperOfIEnumerableOfBiologicalExamWithWarnings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IPaginatorWrapperOfIEnumerableOfBiologicalExamWithWarnings {
    totalRecords: number;
    data?: BiologicalExamWithWarnings[] | undefined;
}

/** Contains the definition of an object of type BiologicalExamWithWarnings. */
export class BiologicalExamWithWarnings extends BiologicalExam implements IBiologicalExamWithWarnings {
    /** Gets or sets the warnings. */
    warnings?: SuggestibleSourceWithEntityName[] | undefined;
    /** Gets or sets the suggestible source with entity names. */
    suggestibleSourceWithEntityNames?: SuggestibleSourceWithEntityName[] | undefined;
    /** Gets or sets the intention. */
    intention!: IntentionLevelType;
    /** Gets or sets a value indicating whether this instance is selected. */
    isSelected!: boolean;
    /** Gets or sets a value indicating whether this instance is already in consult. */
    isAlreadyInConsult!: boolean;
    /** Gets or sets the last sending to patient. */
    lastSendingToPatient?: Date | undefined;

    constructor(data?: IBiologicalExamWithWarnings) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["warnings"])) {
                this.warnings = [] as any;
                for (let item of _data["warnings"])
                    this.warnings!.push(SuggestibleSourceWithEntityName.fromJS(item));
            }
            if (Array.isArray(_data["suggestibleSourceWithEntityNames"])) {
                this.suggestibleSourceWithEntityNames = [] as any;
                for (let item of _data["suggestibleSourceWithEntityNames"])
                    this.suggestibleSourceWithEntityNames!.push(SuggestibleSourceWithEntityName.fromJS(item));
            }
            this.intention = _data["intention"];
            this.isSelected = _data["isSelected"];
            this.isAlreadyInConsult = _data["isAlreadyInConsult"];
            this.lastSendingToPatient = _data["lastSendingToPatient"] ? new Date(_data["lastSendingToPatient"].toString()) : <any>undefined;
        }
    }

    static override fromJS(data: any): BiologicalExamWithWarnings {
        data = typeof data === 'object' ? data : {};
        let result = new BiologicalExamWithWarnings();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.warnings)) {
            data["warnings"] = [];
            for (let item of this.warnings)
                data["warnings"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.suggestibleSourceWithEntityNames)) {
            data["suggestibleSourceWithEntityNames"] = [];
            for (let item of this.suggestibleSourceWithEntityNames)
                data["suggestibleSourceWithEntityNames"].push(item ? item.toJSON() : <any>undefined);
        }
        data["intention"] = this.intention;
        data["isSelected"] = this.isSelected;
        data["isAlreadyInConsult"] = this.isAlreadyInConsult;
        data["lastSendingToPatient"] = this.lastSendingToPatient ? this.lastSendingToPatient.toISOString() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type BiologicalExamWithWarnings. */
export interface IBiologicalExamWithWarnings extends IBiologicalExam {
    /** Gets or sets the warnings. */
    warnings?: SuggestibleSourceWithEntityName[] | undefined;
    /** Gets or sets the suggestible source with entity names. */
    suggestibleSourceWithEntityNames?: SuggestibleSourceWithEntityName[] | undefined;
    /** Gets or sets the intention. */
    intention: IntentionLevelType;
    /** Gets or sets a value indicating whether this instance is selected. */
    isSelected: boolean;
    /** Gets or sets a value indicating whether this instance is already in consult. */
    isAlreadyInConsult: boolean;
    /** Gets or sets the last sending to patient. */
    lastSendingToPatient?: Date | undefined;
}

/** Contains the definition of an object of type BiologicalExamSearchParams. */
export class BiologicalExamSearchParams extends SearchParamSuggestible implements IBiologicalExamSearchParams {
    /** Gets or sets the type of the biological exam. */
    natureType?: BiologicalExamNatureSample | undefined;
    /** Gets or sets a value indicating whether this instance is only custom. */
    onlyCustom!: boolean;
    /** Gets or sets a value indicating whether this instance should create a new isolated prescription. */
    createNewIsolatedPrescription?: boolean | undefined;

    constructor(data?: IBiologicalExamSearchParams) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.natureType = _data["natureType"];
            this.onlyCustom = _data["onlyCustom"];
            this.createNewIsolatedPrescription = _data["createNewIsolatedPrescription"];
        }
    }

    static override fromJS(data: any): BiologicalExamSearchParams {
        data = typeof data === 'object' ? data : {};
        let result = new BiologicalExamSearchParams();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["natureType"] = this.natureType;
        data["onlyCustom"] = this.onlyCustom;
        data["createNewIsolatedPrescription"] = this.createNewIsolatedPrescription;
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type BiologicalExamSearchParams. */
export interface IBiologicalExamSearchParams extends ISearchParamSuggestible {
    /** Gets or sets the type of the biological exam. */
    natureType?: BiologicalExamNatureSample | undefined;
    /** Gets or sets a value indicating whether this instance is only custom. */
    onlyCustom: boolean;
    /** Gets or sets a value indicating whether this instance should create a new isolated prescription. */
    createNewIsolatedPrescription?: boolean | undefined;
}

/** Contains the definition of an object of type ComplementaryExam. */
export class ComplementaryExam implements IComplementaryExam {
    /** Gets or sets the identifier. */
    id!: number;
    /** Gets or sets the name. */
    name?: string | undefined;
    /** Gets or sets the doctorId. */
    doctorId?: number | undefined;
    /** Gets or sets the suggestible. */
    suggestible?: Suggestible | undefined;
    /** Gets or sets a value indicating whether this instance is active. */
    isArchived!: boolean;
    /** Gets or sets a value indicating whether this instance is medical imaging. */
    isMedicalImaging!: boolean;

    constructor(data?: IComplementaryExam) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.doctorId = _data["doctorId"];
            this.suggestible = _data["suggestible"] ? Suggestible.fromJS(_data["suggestible"]) : <any>undefined;
            this.isArchived = _data["isArchived"];
            this.isMedicalImaging = _data["isMedicalImaging"];
        }
    }

    static fromJS(data: any): ComplementaryExam {
        data = typeof data === 'object' ? data : {};
        let result = new ComplementaryExam();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["doctorId"] = this.doctorId;
        data["suggestible"] = this.suggestible ? this.suggestible.toJSON() : <any>undefined;
        data["isArchived"] = this.isArchived;
        data["isMedicalImaging"] = this.isMedicalImaging;
        return data;
    }
}

/** Contains the definition of an object of type ComplementaryExam. */
export interface IComplementaryExam {
    /** Gets or sets the identifier. */
    id: number;
    /** Gets or sets the name. */
    name?: string | undefined;
    /** Gets or sets the doctorId. */
    doctorId?: number | undefined;
    /** Gets or sets the suggestible. */
    suggestible?: Suggestible | undefined;
    /** Gets or sets a value indicating whether this instance is active. */
    isArchived: boolean;
    /** Gets or sets a value indicating whether this instance is medical imaging. */
    isMedicalImaging: boolean;
}

/** Contains the definition of an object of type ComplementaryExamSearchParams. */
export class ComplementaryExamSearchParams extends SearchParamSuggestible implements IComplementaryExamSearchParams {
    /** Gets or sets a value indicating whether this instance is only custom. */
    onlyCustom!: boolean;

    constructor(data?: IComplementaryExamSearchParams) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.onlyCustom = _data["onlyCustom"];
        }
    }

    static override fromJS(data: any): ComplementaryExamSearchParams {
        data = typeof data === 'object' ? data : {};
        let result = new ComplementaryExamSearchParams();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["onlyCustom"] = this.onlyCustom;
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type ComplementaryExamSearchParams. */
export interface IComplementaryExamSearchParams extends ISearchParamSuggestible {
    /** Gets or sets a value indicating whether this instance is only custom. */
    onlyCustom: boolean;
}

export class PaginatorWrapperOfIEnumerableOfConsultationBiologicalExamSet implements IPaginatorWrapperOfIEnumerableOfConsultationBiologicalExamSet {
    totalRecords!: number;
    data?: ConsultationBiologicalExamSet[] | undefined;

    constructor(data?: IPaginatorWrapperOfIEnumerableOfConsultationBiologicalExamSet) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRecords = _data["totalRecords"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ConsultationBiologicalExamSet.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatorWrapperOfIEnumerableOfConsultationBiologicalExamSet {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatorWrapperOfIEnumerableOfConsultationBiologicalExamSet();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IPaginatorWrapperOfIEnumerableOfConsultationBiologicalExamSet {
    totalRecords: number;
    data?: ConsultationBiologicalExamSet[] | undefined;
}

/** Contains the definition of an object of type ConsultationBiologicalExamSet. */
export class ConsultationBiologicalExamSet implements IConsultationBiologicalExamSet {
    /** Gets or sets the identifier. */
    id!: number;
    /** Gets or sets the consultation identifier. */
    consultationId!: number;
    /** Gets or sets the biological exam set identifier. */
    biologicalSetId!: number;
    /** Gets or sets a value indicating whether this instance is selected. */
    isSelected!: boolean;
    /** Gets or sets a value indicating whether this instance is already in the consultation. */
    isAlreadyInConsult!: boolean;
    /** Gets or sets the sending date. */
    sendingDate?: Date | undefined;
    /** Gets or sets the biological exam set. */
    biologicalExamSet?: BiologicalExamSet | undefined;

    constructor(data?: IConsultationBiologicalExamSet) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.consultationId = _data["consultationId"];
            this.biologicalSetId = _data["biologicalSetId"];
            this.isSelected = _data["isSelected"];
            this.isAlreadyInConsult = _data["isAlreadyInConsult"];
            this.sendingDate = _data["sendingDate"] ? new Date(_data["sendingDate"].toString()) : <any>undefined;
            this.biologicalExamSet = _data["biologicalExamSet"] ? BiologicalExamSet.fromJS(_data["biologicalExamSet"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ConsultationBiologicalExamSet {
        data = typeof data === 'object' ? data : {};
        let result = new ConsultationBiologicalExamSet();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["consultationId"] = this.consultationId;
        data["biologicalSetId"] = this.biologicalSetId;
        data["isSelected"] = this.isSelected;
        data["isAlreadyInConsult"] = this.isAlreadyInConsult;
        data["sendingDate"] = this.sendingDate ? this.sendingDate.toISOString() : <any>undefined;
        data["biologicalExamSet"] = this.biologicalExamSet ? this.biologicalExamSet.toJSON() : <any>undefined;
        return data;
    }
}

/** Contains the definition of an object of type ConsultationBiologicalExamSet. */
export interface IConsultationBiologicalExamSet {
    /** Gets or sets the identifier. */
    id: number;
    /** Gets or sets the consultation identifier. */
    consultationId: number;
    /** Gets or sets the biological exam set identifier. */
    biologicalSetId: number;
    /** Gets or sets a value indicating whether this instance is selected. */
    isSelected: boolean;
    /** Gets or sets a value indicating whether this instance is already in the consultation. */
    isAlreadyInConsult: boolean;
    /** Gets or sets the sending date. */
    sendingDate?: Date | undefined;
    /** Gets or sets the biological exam set. */
    biologicalExamSet?: BiologicalExamSet | undefined;
}

/** Contains the definition of an object of type BiologicalExamSetSearchParams. */
export class BiologicalExamSetSearchParams extends SearchParamSuggestible implements IBiologicalExamSetSearchParams {
    /** Gets or sets a value indicating whether this instance is only custom. */
    onlyCustom!: boolean;
    /** Gets or sets the doctor identifier. */
    doctorId?: number | undefined;

    constructor(data?: IBiologicalExamSetSearchParams) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.onlyCustom = _data["onlyCustom"];
            this.doctorId = _data["doctorId"];
        }
    }

    static override fromJS(data: any): BiologicalExamSetSearchParams {
        data = typeof data === 'object' ? data : {};
        let result = new BiologicalExamSetSearchParams();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["onlyCustom"] = this.onlyCustom;
        data["doctorId"] = this.doctorId;
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type BiologicalExamSetSearchParams. */
export interface IBiologicalExamSetSearchParams extends ISearchParamSuggestible {
    /** Gets or sets a value indicating whether this instance is only custom. */
    onlyCustom: boolean;
    /** Gets or sets the doctor identifier. */
    doctorId?: number | undefined;
}

export class PaginatorWrapperOfIEnumerableOfComplementaryExamWithWarnings implements IPaginatorWrapperOfIEnumerableOfComplementaryExamWithWarnings {
    totalRecords!: number;
    data?: ComplementaryExamWithWarnings[] | undefined;

    constructor(data?: IPaginatorWrapperOfIEnumerableOfComplementaryExamWithWarnings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRecords = _data["totalRecords"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ComplementaryExamWithWarnings.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatorWrapperOfIEnumerableOfComplementaryExamWithWarnings {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatorWrapperOfIEnumerableOfComplementaryExamWithWarnings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IPaginatorWrapperOfIEnumerableOfComplementaryExamWithWarnings {
    totalRecords: number;
    data?: ComplementaryExamWithWarnings[] | undefined;
}

/** Contains the definition of an object of type ComplementaryExamWithWarnings. */
export class ComplementaryExamWithWarnings extends ComplementaryExam implements IComplementaryExamWithWarnings {
    /** Gets or sets the warnings. */
    warnings?: SuggestibleSourceWithEntityName[] | undefined;
    /** Gets or sets the suggestible source with entity names. */
    suggestibleSourceWithEntityNames?: SuggestibleSourceWithEntityName[] | undefined;
    /** Gets or sets the intention. */
    intention!: IntentionLevelType;
    /** Gets or sets a value indicating whether this instance is selected. */
    isSelected!: boolean;
    /** Gets or sets a value indicating whether this instance is already in consult. */
    isAlreadyInConsult!: boolean;
    /** Gets or sets the last sending to patient. */
    lastSendingToPatient?: Date | undefined;

    constructor(data?: IComplementaryExamWithWarnings) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["warnings"])) {
                this.warnings = [] as any;
                for (let item of _data["warnings"])
                    this.warnings!.push(SuggestibleSourceWithEntityName.fromJS(item));
            }
            if (Array.isArray(_data["suggestibleSourceWithEntityNames"])) {
                this.suggestibleSourceWithEntityNames = [] as any;
                for (let item of _data["suggestibleSourceWithEntityNames"])
                    this.suggestibleSourceWithEntityNames!.push(SuggestibleSourceWithEntityName.fromJS(item));
            }
            this.intention = _data["intention"];
            this.isSelected = _data["isSelected"];
            this.isAlreadyInConsult = _data["isAlreadyInConsult"];
            this.lastSendingToPatient = _data["lastSendingToPatient"] ? new Date(_data["lastSendingToPatient"].toString()) : <any>undefined;
        }
    }

    static override fromJS(data: any): ComplementaryExamWithWarnings {
        data = typeof data === 'object' ? data : {};
        let result = new ComplementaryExamWithWarnings();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.warnings)) {
            data["warnings"] = [];
            for (let item of this.warnings)
                data["warnings"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.suggestibleSourceWithEntityNames)) {
            data["suggestibleSourceWithEntityNames"] = [];
            for (let item of this.suggestibleSourceWithEntityNames)
                data["suggestibleSourceWithEntityNames"].push(item ? item.toJSON() : <any>undefined);
        }
        data["intention"] = this.intention;
        data["isSelected"] = this.isSelected;
        data["isAlreadyInConsult"] = this.isAlreadyInConsult;
        data["lastSendingToPatient"] = this.lastSendingToPatient ? this.lastSendingToPatient.toISOString() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type ComplementaryExamWithWarnings. */
export interface IComplementaryExamWithWarnings extends IComplementaryExam {
    /** Gets or sets the warnings. */
    warnings?: SuggestibleSourceWithEntityName[] | undefined;
    /** Gets or sets the suggestible source with entity names. */
    suggestibleSourceWithEntityNames?: SuggestibleSourceWithEntityName[] | undefined;
    /** Gets or sets the intention. */
    intention: IntentionLevelType;
    /** Gets or sets a value indicating whether this instance is selected. */
    isSelected: boolean;
    /** Gets or sets a value indicating whether this instance is already in consult. */
    isAlreadyInConsult: boolean;
    /** Gets or sets the last sending to patient. */
    lastSendingToPatient?: Date | undefined;
}

export class PaginatorWrapperOfIEnumerableOfConsultationTypeLibrary implements IPaginatorWrapperOfIEnumerableOfConsultationTypeLibrary {
    totalRecords!: number;
    data?: ConsultationTypeLibrary[] | undefined;

    constructor(data?: IPaginatorWrapperOfIEnumerableOfConsultationTypeLibrary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRecords = _data["totalRecords"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ConsultationTypeLibrary.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatorWrapperOfIEnumerableOfConsultationTypeLibrary {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatorWrapperOfIEnumerableOfConsultationTypeLibrary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IPaginatorWrapperOfIEnumerableOfConsultationTypeLibrary {
    totalRecords: number;
    data?: ConsultationTypeLibrary[] | undefined;
}

/** Contains the definition of an object of type ConsultationType. */
export class ConsultationType implements IConsultationType {
    /** Gets or sets a value indicating whether [accessible for classic patient]. */
    accessibleForClassicPatient!: boolean;
    /** Gets or sets a value indicating whether [accessible for insurance]. */
    accessibleForInsurance!: boolean;
    /** Gets or sets the big plan yearly limit. */
    bigPlanYearlyLimit?: string | undefined;
    /** Gets or sets a value indicating whether this ConsultationType is enabled. */
    enabled!: boolean;
    /** Gets or sets the identifier. */
    id!: number;
    /** Gets or sets a value indicating whether this instance is alternative medicine. */
    isAlternativeMedicine!: boolean;
    /** Gets or sets a value indicating whether this instance is active. */
    isArchived!: boolean;
    /** Gets or sets the small plan yearly limit. */
    smallPlanYearlyLimit?: string | undefined;
    /** Gets or sets the name. */
    name?: string | undefined;
    /** Gets or sets the suggestible. */
    suggestible?: Suggestible | undefined;
    /** Gets or sets a value indicating whether the consultation is in MyNutri footer */
    showInFooterMyNutri!: boolean;
    /** Gets or sets a value indicating whether the consultation type is only available for doctors */
    onlyForDoctors!: boolean;
    /** Gets or sets the allowed subscription levels. */
    allowedSubscriptionLevels?: number[] | undefined;

    constructor(data?: IConsultationType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessibleForClassicPatient = _data["accessibleForClassicPatient"];
            this.accessibleForInsurance = _data["accessibleForInsurance"];
            this.bigPlanYearlyLimit = _data["bigPlanYearlyLimit"];
            this.enabled = _data["enabled"];
            this.id = _data["id"];
            this.isAlternativeMedicine = _data["isAlternativeMedicine"];
            this.isArchived = _data["isArchived"];
            this.smallPlanYearlyLimit = _data["smallPlanYearlyLimit"];
            this.name = _data["name"];
            this.suggestible = _data["suggestible"] ? Suggestible.fromJS(_data["suggestible"]) : <any>undefined;
            this.showInFooterMyNutri = _data["showInFooterMyNutri"];
            this.onlyForDoctors = _data["onlyForDoctors"];
            if (Array.isArray(_data["allowedSubscriptionLevels"])) {
                this.allowedSubscriptionLevels = [] as any;
                for (let item of _data["allowedSubscriptionLevels"])
                    this.allowedSubscriptionLevels!.push(item);
            }
        }
    }

    static fromJS(data: any): ConsultationType {
        data = typeof data === 'object' ? data : {};
        let result = new ConsultationType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessibleForClassicPatient"] = this.accessibleForClassicPatient;
        data["accessibleForInsurance"] = this.accessibleForInsurance;
        data["bigPlanYearlyLimit"] = this.bigPlanYearlyLimit;
        data["enabled"] = this.enabled;
        data["id"] = this.id;
        data["isAlternativeMedicine"] = this.isAlternativeMedicine;
        data["isArchived"] = this.isArchived;
        data["smallPlanYearlyLimit"] = this.smallPlanYearlyLimit;
        data["name"] = this.name;
        data["suggestible"] = this.suggestible ? this.suggestible.toJSON() : <any>undefined;
        data["showInFooterMyNutri"] = this.showInFooterMyNutri;
        data["onlyForDoctors"] = this.onlyForDoctors;
        if (Array.isArray(this.allowedSubscriptionLevels)) {
            data["allowedSubscriptionLevels"] = [];
            for (let item of this.allowedSubscriptionLevels)
                data["allowedSubscriptionLevels"].push(item);
        }
        return data;
    }
}

/** Contains the definition of an object of type ConsultationType. */
export interface IConsultationType {
    /** Gets or sets a value indicating whether [accessible for classic patient]. */
    accessibleForClassicPatient: boolean;
    /** Gets or sets a value indicating whether [accessible for insurance]. */
    accessibleForInsurance: boolean;
    /** Gets or sets the big plan yearly limit. */
    bigPlanYearlyLimit?: string | undefined;
    /** Gets or sets a value indicating whether this ConsultationType is enabled. */
    enabled: boolean;
    /** Gets or sets the identifier. */
    id: number;
    /** Gets or sets a value indicating whether this instance is alternative medicine. */
    isAlternativeMedicine: boolean;
    /** Gets or sets a value indicating whether this instance is active. */
    isArchived: boolean;
    /** Gets or sets the small plan yearly limit. */
    smallPlanYearlyLimit?: string | undefined;
    /** Gets or sets the name. */
    name?: string | undefined;
    /** Gets or sets the suggestible. */
    suggestible?: Suggestible | undefined;
    /** Gets or sets a value indicating whether the consultation is in MyNutri footer */
    showInFooterMyNutri: boolean;
    /** Gets or sets a value indicating whether the consultation type is only available for doctors */
    onlyForDoctors: boolean;
    /** Gets or sets the allowed subscription levels. */
    allowedSubscriptionLevels?: number[] | undefined;
}

/** Contains the definition of an object of type ConsultationTypeLibrary. */
export class ConsultationTypeLibrary extends ConsultationType implements IConsultationTypeLibrary {
    /** Gets or sets the suggestible source with entity names. */
    suggestibleSourceWithEntityNames?: SuggestibleSourceWithEntityName[] | undefined;
    /** Gets or sets the intention. */
    intention!: IntentionLevelType;
    /** Gets or sets a value indicating whether this instance is selected. */
    isSelected!: boolean;
    /** Gets or sets a value indicating whether this instance is already in consult. */
    isAlreadyInConsult!: boolean;
    /** Gets or sets the last sending to patient. */
    lastSendingToPatient?: Date | undefined;

    constructor(data?: IConsultationTypeLibrary) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["suggestibleSourceWithEntityNames"])) {
                this.suggestibleSourceWithEntityNames = [] as any;
                for (let item of _data["suggestibleSourceWithEntityNames"])
                    this.suggestibleSourceWithEntityNames!.push(SuggestibleSourceWithEntityName.fromJS(item));
            }
            this.intention = _data["intention"];
            this.isSelected = _data["isSelected"];
            this.isAlreadyInConsult = _data["isAlreadyInConsult"];
            this.lastSendingToPatient = _data["lastSendingToPatient"] ? new Date(_data["lastSendingToPatient"].toString()) : <any>undefined;
        }
    }

    static override fromJS(data: any): ConsultationTypeLibrary {
        data = typeof data === 'object' ? data : {};
        let result = new ConsultationTypeLibrary();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.suggestibleSourceWithEntityNames)) {
            data["suggestibleSourceWithEntityNames"] = [];
            for (let item of this.suggestibleSourceWithEntityNames)
                data["suggestibleSourceWithEntityNames"].push(item ? item.toJSON() : <any>undefined);
        }
        data["intention"] = this.intention;
        data["isSelected"] = this.isSelected;
        data["isAlreadyInConsult"] = this.isAlreadyInConsult;
        data["lastSendingToPatient"] = this.lastSendingToPatient ? this.lastSendingToPatient.toISOString() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type ConsultationTypeLibrary. */
export interface IConsultationTypeLibrary extends IConsultationType {
    /** Gets or sets the suggestible source with entity names. */
    suggestibleSourceWithEntityNames?: SuggestibleSourceWithEntityName[] | undefined;
    /** Gets or sets the intention. */
    intention: IntentionLevelType;
    /** Gets or sets a value indicating whether this instance is selected. */
    isSelected: boolean;
    /** Gets or sets a value indicating whether this instance is already in consult. */
    isAlreadyInConsult: boolean;
    /** Gets or sets the last sending to patient. */
    lastSendingToPatient?: Date | undefined;
}

/** Contains the definition of an object of type SearchParamConsultationTypeLibrary. */
export class SearchParamConsultationTypeLibrary extends SearchParamSuggestible implements ISearchParamConsultationTypeLibrary {
    /** Gets or sets a value indicating whether this instance is PNC. */
    isPSNC!: boolean;

    constructor(data?: ISearchParamConsultationTypeLibrary) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.isPSNC = _data["IsPSNC"];
        }
    }

    static override fromJS(data: any): SearchParamConsultationTypeLibrary {
        data = typeof data === 'object' ? data : {};
        let result = new SearchParamConsultationTypeLibrary();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["IsPSNC"] = this.isPSNC;
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type SearchParamConsultationTypeLibrary. */
export interface ISearchParamConsultationTypeLibrary extends ISearchParamSuggestible {
    /** Gets or sets a value indicating whether this instance is PNC. */
    isPSNC: boolean;
}

/** Contains the definition of an object of type Disease. */
export class Disease implements IDisease {
    /** Gets or sets the identifier. */
    id!: number;
    /** Gets or sets the alternative medicines. */
    diseaseAlternativeMedicines?: DiseaseAlternativeMedicine[] | undefined;
    /** Gets or sets the category identifier. */
    diseaseCategoryId!: number;
    /** Gets or sets the name. */
    name!: string;
    /** Gets or sets a value indicating whether [library available]. */
    libraryAvailable!: boolean;
    /** Gets or sets the type of the disease suggestion. */
    diseaseSuggestionType!: DiseaseSuggestionType;
    /** Gets or sets a value indicating whether [IsArchived available]. */
    isArchived!: boolean;

    constructor(data?: IDisease) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["diseaseAlternativeMedicines"])) {
                this.diseaseAlternativeMedicines = [] as any;
                for (let item of _data["diseaseAlternativeMedicines"])
                    this.diseaseAlternativeMedicines!.push(DiseaseAlternativeMedicine.fromJS(item));
            }
            this.diseaseCategoryId = _data["diseaseCategoryId"];
            this.name = _data["name"];
            this.libraryAvailable = _data["libraryAvailable"];
            this.diseaseSuggestionType = _data["diseaseSuggestionType"];
            this.isArchived = _data["isArchived"];
        }
    }

    static fromJS(data: any): Disease {
        data = typeof data === 'object' ? data : {};
        let result = new Disease();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.diseaseAlternativeMedicines)) {
            data["diseaseAlternativeMedicines"] = [];
            for (let item of this.diseaseAlternativeMedicines)
                data["diseaseAlternativeMedicines"].push(item ? item.toJSON() : <any>undefined);
        }
        data["diseaseCategoryId"] = this.diseaseCategoryId;
        data["name"] = this.name;
        data["libraryAvailable"] = this.libraryAvailable;
        data["diseaseSuggestionType"] = this.diseaseSuggestionType;
        data["isArchived"] = this.isArchived;
        return data;
    }
}

/** Contains the definition of an object of type Disease. */
export interface IDisease {
    /** Gets or sets the identifier. */
    id: number;
    /** Gets or sets the alternative medicines. */
    diseaseAlternativeMedicines?: DiseaseAlternativeMedicine[] | undefined;
    /** Gets or sets the category identifier. */
    diseaseCategoryId: number;
    /** Gets or sets the name. */
    name: string;
    /** Gets or sets a value indicating whether [library available]. */
    libraryAvailable: boolean;
    /** Gets or sets the type of the disease suggestion. */
    diseaseSuggestionType: DiseaseSuggestionType;
    /** Gets or sets a value indicating whether [IsArchived available]. */
    isArchived: boolean;
}

/** Conbtains the definition of an object of type DiseaseAlternativeMedicine */
export class DiseaseAlternativeMedicine implements IDiseaseAlternativeMedicine {
    /** Gets or sets the alternative medicine identifier. */
    consultationTypeId!: number;
    /** Gets or sets the disease identifier. */
    diseaseId!: number;

    constructor(data?: IDiseaseAlternativeMedicine) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.consultationTypeId = _data["consultationTypeId"];
            this.diseaseId = _data["diseaseId"];
        }
    }

    static fromJS(data: any): DiseaseAlternativeMedicine {
        data = typeof data === 'object' ? data : {};
        let result = new DiseaseAlternativeMedicine();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["consultationTypeId"] = this.consultationTypeId;
        data["diseaseId"] = this.diseaseId;
        return data;
    }
}

/** Conbtains the definition of an object of type DiseaseAlternativeMedicine */
export interface IDiseaseAlternativeMedicine {
    /** Gets or sets the alternative medicine identifier. */
    consultationTypeId: number;
    /** Gets or sets the disease identifier. */
    diseaseId: number;
}

/** Contains the definition of an object of type DiseaseSuggestionType. */
export enum DiseaseSuggestionType {
    Unknow = 0,
    ActualDisease = 1,
    PersonnalMedicalHistory = 2,
    FromFormulary = 3,
}

/** Contains the definition of an object of type DiseaseCategoryDetails. */
export class DiseaseCategoryDetails extends DiseaseCategory implements IDiseaseCategoryDetails {
    /** Gets or sets the diseases. */
    diseases?: DropdownValue[] | undefined;

    constructor(data?: IDiseaseCategoryDetails) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["diseases"])) {
                this.diseases = [] as any;
                for (let item of _data["diseases"])
                    this.diseases!.push(DropdownValue.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): DiseaseCategoryDetails {
        data = typeof data === 'object' ? data : {};
        let result = new DiseaseCategoryDetails();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.diseases)) {
            data["diseases"] = [];
            for (let item of this.diseases)
                data["diseases"].push(item ? item.toJSON() : <any>undefined);
        }
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type DiseaseCategoryDetails. */
export interface IDiseaseCategoryDetails extends IDiseaseCategory {
    /** Gets or sets the diseases. */
    diseases?: DropdownValue[] | undefined;
}

/** Contains the definition of an object of type DiseaseDetails. */
export class DiseaseDetails implements IDiseaseDetails {
    /** Gets or sets the entity identifier. */
    diseaseId!: number;
    /** Gets or sets the name. */
    name?: string | undefined;
    /** Gets or sets the disease category. */
    diseaseCategoryId!: number;
    /** Gets or sets a value indicating whether [IsArchived available]. */
    isArchived!: boolean;
    /** Gets or sets the suggestible complementary exam. */
    suggestibleComplementaryExam?: SuggestibleDetail[] | undefined;
    /** Gets or sets the suggestible biological exam. */
    suggestibleBiologicalExam?: SuggestibleDetailBiologicalExam[] | undefined;
    /** Gets or sets the suggestible orientation. */
    suggestibleOrientation?: SuggestibleDetail[] | undefined;
    /** Gets or sets the suggestible nutritiion. */
    suggestibleNutritiion?: SuggestibleDetail[] | undefined;
    /** Gets or sets the suggestible activities. */
    suggestibleActivities?: SuggestibleDetail[] | undefined;
    /** Gets or sets the suggestible coaching. */
    suggestibleCoaching?: SuggestibleDetail[] | undefined;
    /** Gets or sets the suggestible nutrient. */
    suggestibleNutrient?: SuggestibleDetail[] | undefined;
    /** Gets or sets the suggestible suggestion alimentary. */
    suggestibleSuggestionAlimentary?: SuggestibleDetailSuggestion[] | undefined;
    /** Gets or sets the suggestible suggestion life style. */
    suggestibleSuggestionLifeStyle?: SuggestibleDetailSuggestion[] | undefined;
    /** Gets or sets the suggestible formulary. */
    suggestibleFormulary?: SuggestibleDetail[] | undefined;
    /** Gets or sets the suggestible suggestion pro. */
    suggestibleSuggestionPro?: SuggestibleDetailSuggestion[] | undefined;
    /** Gets or sets the disease detail hypotheses. */
    diseaseDetailHypotheses?: DiseaseDetailHypothese[] | undefined;
    /** Gets or sets a value indicating whether [library available]. */
    libraryAvailable!: boolean;

    constructor(data?: IDiseaseDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.diseaseId = _data["diseaseId"];
            this.name = _data["name"];
            this.diseaseCategoryId = _data["diseaseCategoryId"];
            this.isArchived = _data["isArchived"];
            if (Array.isArray(_data["suggestibleComplementaryExam"])) {
                this.suggestibleComplementaryExam = [] as any;
                for (let item of _data["suggestibleComplementaryExam"])
                    this.suggestibleComplementaryExam!.push(SuggestibleDetail.fromJS(item));
            }
            if (Array.isArray(_data["suggestibleBiologicalExam"])) {
                this.suggestibleBiologicalExam = [] as any;
                for (let item of _data["suggestibleBiologicalExam"])
                    this.suggestibleBiologicalExam!.push(SuggestibleDetailBiologicalExam.fromJS(item));
            }
            if (Array.isArray(_data["suggestibleOrientation"])) {
                this.suggestibleOrientation = [] as any;
                for (let item of _data["suggestibleOrientation"])
                    this.suggestibleOrientation!.push(SuggestibleDetail.fromJS(item));
            }
            if (Array.isArray(_data["suggestibleNutritiion"])) {
                this.suggestibleNutritiion = [] as any;
                for (let item of _data["suggestibleNutritiion"])
                    this.suggestibleNutritiion!.push(SuggestibleDetail.fromJS(item));
            }
            if (Array.isArray(_data["suggestibleActivities"])) {
                this.suggestibleActivities = [] as any;
                for (let item of _data["suggestibleActivities"])
                    this.suggestibleActivities!.push(SuggestibleDetail.fromJS(item));
            }
            if (Array.isArray(_data["suggestibleCoaching"])) {
                this.suggestibleCoaching = [] as any;
                for (let item of _data["suggestibleCoaching"])
                    this.suggestibleCoaching!.push(SuggestibleDetail.fromJS(item));
            }
            if (Array.isArray(_data["suggestibleNutrient"])) {
                this.suggestibleNutrient = [] as any;
                for (let item of _data["suggestibleNutrient"])
                    this.suggestibleNutrient!.push(SuggestibleDetail.fromJS(item));
            }
            if (Array.isArray(_data["suggestibleSuggestionAlimentary"])) {
                this.suggestibleSuggestionAlimentary = [] as any;
                for (let item of _data["suggestibleSuggestionAlimentary"])
                    this.suggestibleSuggestionAlimentary!.push(SuggestibleDetailSuggestion.fromJS(item));
            }
            if (Array.isArray(_data["suggestibleSuggestionLifeStyle"])) {
                this.suggestibleSuggestionLifeStyle = [] as any;
                for (let item of _data["suggestibleSuggestionLifeStyle"])
                    this.suggestibleSuggestionLifeStyle!.push(SuggestibleDetailSuggestion.fromJS(item));
            }
            if (Array.isArray(_data["suggestibleFormulary"])) {
                this.suggestibleFormulary = [] as any;
                for (let item of _data["suggestibleFormulary"])
                    this.suggestibleFormulary!.push(SuggestibleDetail.fromJS(item));
            }
            if (Array.isArray(_data["suggestibleSuggestionPro"])) {
                this.suggestibleSuggestionPro = [] as any;
                for (let item of _data["suggestibleSuggestionPro"])
                    this.suggestibleSuggestionPro!.push(SuggestibleDetailSuggestion.fromJS(item));
            }
            if (Array.isArray(_data["diseaseDetailHypotheses"])) {
                this.diseaseDetailHypotheses = [] as any;
                for (let item of _data["diseaseDetailHypotheses"])
                    this.diseaseDetailHypotheses!.push(DiseaseDetailHypothese.fromJS(item));
            }
            this.libraryAvailable = _data["libraryAvailable"];
        }
    }

    static fromJS(data: any): DiseaseDetails {
        data = typeof data === 'object' ? data : {};
        let result = new DiseaseDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["diseaseId"] = this.diseaseId;
        data["name"] = this.name;
        data["diseaseCategoryId"] = this.diseaseCategoryId;
        data["isArchived"] = this.isArchived;
        if (Array.isArray(this.suggestibleComplementaryExam)) {
            data["suggestibleComplementaryExam"] = [];
            for (let item of this.suggestibleComplementaryExam)
                data["suggestibleComplementaryExam"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.suggestibleBiologicalExam)) {
            data["suggestibleBiologicalExam"] = [];
            for (let item of this.suggestibleBiologicalExam)
                data["suggestibleBiologicalExam"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.suggestibleOrientation)) {
            data["suggestibleOrientation"] = [];
            for (let item of this.suggestibleOrientation)
                data["suggestibleOrientation"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.suggestibleNutritiion)) {
            data["suggestibleNutritiion"] = [];
            for (let item of this.suggestibleNutritiion)
                data["suggestibleNutritiion"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.suggestibleActivities)) {
            data["suggestibleActivities"] = [];
            for (let item of this.suggestibleActivities)
                data["suggestibleActivities"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.suggestibleCoaching)) {
            data["suggestibleCoaching"] = [];
            for (let item of this.suggestibleCoaching)
                data["suggestibleCoaching"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.suggestibleNutrient)) {
            data["suggestibleNutrient"] = [];
            for (let item of this.suggestibleNutrient)
                data["suggestibleNutrient"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.suggestibleSuggestionAlimentary)) {
            data["suggestibleSuggestionAlimentary"] = [];
            for (let item of this.suggestibleSuggestionAlimentary)
                data["suggestibleSuggestionAlimentary"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.suggestibleSuggestionLifeStyle)) {
            data["suggestibleSuggestionLifeStyle"] = [];
            for (let item of this.suggestibleSuggestionLifeStyle)
                data["suggestibleSuggestionLifeStyle"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.suggestibleFormulary)) {
            data["suggestibleFormulary"] = [];
            for (let item of this.suggestibleFormulary)
                data["suggestibleFormulary"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.suggestibleSuggestionPro)) {
            data["suggestibleSuggestionPro"] = [];
            for (let item of this.suggestibleSuggestionPro)
                data["suggestibleSuggestionPro"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.diseaseDetailHypotheses)) {
            data["diseaseDetailHypotheses"] = [];
            for (let item of this.diseaseDetailHypotheses)
                data["diseaseDetailHypotheses"].push(item ? item.toJSON() : <any>undefined);
        }
        data["libraryAvailable"] = this.libraryAvailable;
        return data;
    }
}

/** Contains the definition of an object of type DiseaseDetails. */
export interface IDiseaseDetails {
    /** Gets or sets the entity identifier. */
    diseaseId: number;
    /** Gets or sets the name. */
    name?: string | undefined;
    /** Gets or sets the disease category. */
    diseaseCategoryId: number;
    /** Gets or sets a value indicating whether [IsArchived available]. */
    isArchived: boolean;
    /** Gets or sets the suggestible complementary exam. */
    suggestibleComplementaryExam?: SuggestibleDetail[] | undefined;
    /** Gets or sets the suggestible biological exam. */
    suggestibleBiologicalExam?: SuggestibleDetailBiologicalExam[] | undefined;
    /** Gets or sets the suggestible orientation. */
    suggestibleOrientation?: SuggestibleDetail[] | undefined;
    /** Gets or sets the suggestible nutritiion. */
    suggestibleNutritiion?: SuggestibleDetail[] | undefined;
    /** Gets or sets the suggestible activities. */
    suggestibleActivities?: SuggestibleDetail[] | undefined;
    /** Gets or sets the suggestible coaching. */
    suggestibleCoaching?: SuggestibleDetail[] | undefined;
    /** Gets or sets the suggestible nutrient. */
    suggestibleNutrient?: SuggestibleDetail[] | undefined;
    /** Gets or sets the suggestible suggestion alimentary. */
    suggestibleSuggestionAlimentary?: SuggestibleDetailSuggestion[] | undefined;
    /** Gets or sets the suggestible suggestion life style. */
    suggestibleSuggestionLifeStyle?: SuggestibleDetailSuggestion[] | undefined;
    /** Gets or sets the suggestible formulary. */
    suggestibleFormulary?: SuggestibleDetail[] | undefined;
    /** Gets or sets the suggestible suggestion pro. */
    suggestibleSuggestionPro?: SuggestibleDetailSuggestion[] | undefined;
    /** Gets or sets the disease detail hypotheses. */
    diseaseDetailHypotheses?: DiseaseDetailHypothese[] | undefined;
    /** Gets or sets a value indicating whether [library available]. */
    libraryAvailable: boolean;
}

/** Contains the definition of an object of type SuggestibleDetail. */
export class SuggestibleDetail implements ISuggestibleDetail {
    /** Gets or sets the type of the suggestible. */
    suggestibleType!: SuggestibleType;
    /** Gets or sets the suggestible identifier. */
    suggestibleId!: number;
    /** Gets or sets the type of the coaching. */
    coachingType!: number;
    /** Gets or sets the name. */
    name?: string | undefined;
    /** Gets or sets the type of the suggestible source. */
    suggestibleSourceType!: SuggestibleSourceType;
    /** Gets or sets the entity identifier. */
    entityId!: number;

    constructor(data?: ISuggestibleDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.suggestibleType = _data["suggestibleType"];
            this.suggestibleId = _data["suggestibleId"];
            this.coachingType = _data["coachingType"];
            this.name = _data["name"];
            this.suggestibleSourceType = _data["suggestibleSourceType"];
            this.entityId = _data["entityId"];
        }
    }

    static fromJS(data: any): SuggestibleDetail {
        data = typeof data === 'object' ? data : {};
        let result = new SuggestibleDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["suggestibleType"] = this.suggestibleType;
        data["suggestibleId"] = this.suggestibleId;
        data["coachingType"] = this.coachingType;
        data["name"] = this.name;
        data["suggestibleSourceType"] = this.suggestibleSourceType;
        data["entityId"] = this.entityId;
        return data;
    }
}

/** Contains the definition of an object of type SuggestibleDetail. */
export interface ISuggestibleDetail {
    /** Gets or sets the type of the suggestible. */
    suggestibleType: SuggestibleType;
    /** Gets or sets the suggestible identifier. */
    suggestibleId: number;
    /** Gets or sets the type of the coaching. */
    coachingType: number;
    /** Gets or sets the name. */
    name?: string | undefined;
    /** Gets or sets the type of the suggestible source. */
    suggestibleSourceType: SuggestibleSourceType;
    /** Gets or sets the entity identifier. */
    entityId: number;
}

/** Contains the definition of an object of type SuggestibleDetailBiologicalExam. */
export class SuggestibleDetailBiologicalExam extends SuggestibleDetail implements ISuggestibleDetailBiologicalExam {
    /** Gets or sets the disease category identifier. */
    nature!: BiologicalExamNatureSample;

    constructor(data?: ISuggestibleDetailBiologicalExam) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.nature = _data["nature"];
        }
    }

    static override fromJS(data: any): SuggestibleDetailBiologicalExam {
        data = typeof data === 'object' ? data : {};
        let result = new SuggestibleDetailBiologicalExam();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nature"] = this.nature;
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type SuggestibleDetailBiologicalExam. */
export interface ISuggestibleDetailBiologicalExam extends ISuggestibleDetail {
    /** Gets or sets the disease category identifier. */
    nature: BiologicalExamNatureSample;
}

/** Contains the definition of an object of type SuggestibleDetailSuggestion. */
export class SuggestibleDetailSuggestion extends SuggestibleDetail implements ISuggestibleDetailSuggestion {
    /** Gets or sets the type identifier. */
    typeId!: number;
    /** Gets or sets the type of the public. */
    publicType!: SuggestionPublicType;
    /** Gets or sets the name of the suggestion type. */
    suggestionTypeName?: string | undefined;

    constructor(data?: ISuggestibleDetailSuggestion) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.typeId = _data["typeId"];
            this.publicType = _data["publicType"];
            this.suggestionTypeName = _data["suggestionTypeName"];
        }
    }

    static override fromJS(data: any): SuggestibleDetailSuggestion {
        data = typeof data === 'object' ? data : {};
        let result = new SuggestibleDetailSuggestion();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typeId"] = this.typeId;
        data["publicType"] = this.publicType;
        data["suggestionTypeName"] = this.suggestionTypeName;
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type SuggestibleDetailSuggestion. */
export interface ISuggestibleDetailSuggestion extends ISuggestibleDetail {
    /** Gets or sets the type identifier. */
    typeId: number;
    /** Gets or sets the type of the public. */
    publicType: SuggestionPublicType;
    /** Gets or sets the name of the suggestion type. */
    suggestionTypeName?: string | undefined;
}

/** Contains the definition of an object of type SuggestionPublicType */
export enum SuggestionPublicType {
    My = 0,
    Pro = 1,
}

/** Contains the definition of an object of type DiseaseDetailHypothese. */
export class DiseaseDetailHypothese implements IDiseaseDetailHypothese {
    /** Gets or sets the hypothese identifier. */
    hypotheseId!: number;
    /** Gets or sets the type of the hypothese. */
    hypotheseIntention!: HypotheseType;

    constructor(data?: IDiseaseDetailHypothese) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hypotheseId = _data["HypotheseId"];
            this.hypotheseIntention = _data["HypotheseIntention"];
        }
    }

    static fromJS(data: any): DiseaseDetailHypothese {
        data = typeof data === 'object' ? data : {};
        let result = new DiseaseDetailHypothese();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["HypotheseId"] = this.hypotheseId;
        data["HypotheseIntention"] = this.hypotheseIntention;
        return data;
    }
}

/** Contains the definition of an object of type DiseaseDetailHypothese. */
export interface IDiseaseDetailHypothese {
    /** Gets or sets the hypothese identifier. */
    hypotheseId: number;
    /** Gets or sets the type of the hypothese. */
    hypotheseIntention: HypotheseType;
}

/** Contains the definition of an object of type SearchParamDisease. */
export class SearchParamDisease extends SearchParams implements ISearchParamDisease {
    /** Gets or sets the title. */
    title?: string | undefined;
    /** Gets or sets the title. */
    diseaseCategoryId!: number;
    /** Gets or sets a value indicating whether this instance is for bo. */
    isForBO!: boolean;

    constructor(data?: ISearchParamDisease) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.title = _data["Title"];
            this.diseaseCategoryId = _data["DiseaseCategoryId"];
            this.isForBO = _data["IsForBO"];
        }
    }

    static override fromJS(data: any): SearchParamDisease {
        data = typeof data === 'object' ? data : {};
        let result = new SearchParamDisease();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Title"] = this.title;
        data["DiseaseCategoryId"] = this.diseaseCategoryId;
        data["IsForBO"] = this.isForBO;
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type SearchParamDisease. */
export interface ISearchParamDisease extends ISearchParams {
    /** Gets or sets the title. */
    title?: string | undefined;
    /** Gets or sets the title. */
    diseaseCategoryId: number;
    /** Gets or sets a value indicating whether this instance is for bo. */
    isForBO: boolean;
}

export class PaginatorWrapperOfIEnumerableOfDisease implements IPaginatorWrapperOfIEnumerableOfDisease {
    totalRecords!: number;
    data?: Disease[] | undefined;

    constructor(data?: IPaginatorWrapperOfIEnumerableOfDisease) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRecords = _data["totalRecords"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(Disease.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatorWrapperOfIEnumerableOfDisease {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatorWrapperOfIEnumerableOfDisease();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IPaginatorWrapperOfIEnumerableOfDisease {
    totalRecords: number;
    data?: Disease[] | undefined;
}

/** Contains the definition of an object of type SearchParamDiseaseLibrary. */
export class SearchParamDiseaseLibrary extends SearchParams implements ISearchParamDiseaseLibrary {
    /** Gets or sets the title. */
    categorieId!: number;
    /** Gets or sets the title. */
    title?: string | undefined;
    /** Gets or sets the consultation identifier. */
    consultationId?: number | undefined;
    /** Gets or sets the patient identifier. */
    patientId?: number | undefined;
    /** Gets or sets a value indicating whether this instance is from siin. */
    isFromSiin!: boolean;

    constructor(data?: ISearchParamDiseaseLibrary) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.categorieId = _data["CategorieId"];
            this.title = _data["Title"];
            this.consultationId = _data["ConsultationId"];
            this.patientId = _data["PatientId"];
            this.isFromSiin = _data["IsFromSiin"];
        }
    }

    static override fromJS(data: any): SearchParamDiseaseLibrary {
        data = typeof data === 'object' ? data : {};
        let result = new SearchParamDiseaseLibrary();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CategorieId"] = this.categorieId;
        data["Title"] = this.title;
        data["ConsultationId"] = this.consultationId;
        data["PatientId"] = this.patientId;
        data["IsFromSiin"] = this.isFromSiin;
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type SearchParamDiseaseLibrary. */
export interface ISearchParamDiseaseLibrary extends ISearchParams {
    /** Gets or sets the title. */
    categorieId: number;
    /** Gets or sets the title. */
    title?: string | undefined;
    /** Gets or sets the consultation identifier. */
    consultationId?: number | undefined;
    /** Gets or sets the patient identifier. */
    patientId?: number | undefined;
    /** Gets or sets a value indicating whether this instance is from siin. */
    isFromSiin: boolean;
}

export class SelectItemOfLiteDisease implements ISelectItemOfLiteDisease {
    label?: string | undefined;
    value?: LiteDisease | undefined;

    constructor(data?: ISelectItemOfLiteDisease) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.label = _data["label"];
            this.value = _data["value"] ? LiteDisease.fromJS(_data["value"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SelectItemOfLiteDisease {
        data = typeof data === 'object' ? data : {};
        let result = new SelectItemOfLiteDisease();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        data["value"] = this.value ? this.value.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISelectItemOfLiteDisease {
    label?: string | undefined;
    value?: LiteDisease | undefined;
}

/** Contains the definition of an object of type LiteDisease. */
export class LiteDisease implements ILiteDisease {
    /** Gets or sets the name of the category. */
    categoryId!: number;
    /** Gets or sets the identifier. */
    id!: number;

    constructor(data?: ILiteDisease) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.categoryId = _data["categoryId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): LiteDisease {
        data = typeof data === 'object' ? data : {};
        let result = new LiteDisease();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["categoryId"] = this.categoryId;
        data["id"] = this.id;
        return data;
    }
}

/** Contains the definition of an object of type LiteDisease. */
export interface ILiteDisease {
    /** Gets or sets the name of the category. */
    categoryId: number;
    /** Gets or sets the identifier. */
    id: number;
}

/** Contains the definition of an object of type Document. */
export class Document implements IDocument {
    /** Gets or sets the created date. */
    createdDate!: Date;
    /** Gets or sets the doctor. */
    doctor?: DoctorLiteInfo | undefined;
    /** Gets or sets the doctor identifier. */
    doctorId?: number | undefined;
    /** Gets or sets the document URL. */
    documentPath?: string | undefined;
    /** Gets or sets the identifier. */
    id!: number;
    /** Gets or sets a value indicating whether this instance is from patient. */
    isFromPatient!: boolean;
    /** Gets or sets the name. */
    name?: string | undefined;
    /** Gets or sets the patient identifier. */
    patientId!: number;
    /** Gets or sets the shared with doctors. */
    sharedWithDoctors?: DoctorLiteInfo[] | undefined;
    /** Gets or sets the type. */
    type!: DocumentType;
    /** Gets or sets the sending date. */
    sendingDate?: Date | undefined;
    /** Gets or sets a value indicating whether this instance is selected. */
    isSelected!: boolean;
    /** Gets or sets a value indicating whether the document is interne. */
    isInterne!: boolean;
    /** Gets or sets a value indicating whether the document should be sent automatically to the patient. */
    autoSendToPatient!: boolean;
    /** Gets or sets the comment. */
    comment?: string | undefined;
    /** Gets a value indicating whether gets or sets a value indicating whether the document is a WYSIWYG document. */
    isWysiwygDoc!: boolean;
    /** Gets or sets the html content. */
    htmlContent?: string | undefined;
    /** Gets or sets the html content. */
    consultationId?: string | undefined;

    constructor(data?: IDocument) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.doctor = _data["doctor"] ? DoctorLiteInfo.fromJS(_data["doctor"]) : <any>undefined;
            this.doctorId = _data["doctorId"];
            this.documentPath = _data["documentPath"];
            this.id = _data["id"];
            this.isFromPatient = _data["isFromPatient"];
            this.name = _data["name"];
            this.patientId = _data["patientId"];
            if (Array.isArray(_data["sharedWithDoctors"])) {
                this.sharedWithDoctors = [] as any;
                for (let item of _data["sharedWithDoctors"])
                    this.sharedWithDoctors!.push(DoctorLiteInfo.fromJS(item));
            }
            this.type = _data["type"];
            this.sendingDate = _data["sendingDate"] ? new Date(_data["sendingDate"].toString()) : <any>undefined;
            this.isSelected = _data["isSelected"];
            this.isInterne = _data["isInterne"];
            this.autoSendToPatient = _data["autoSendToPatient"];
            this.comment = _data["comment"];
            this.isWysiwygDoc = _data["isWysiwygDoc"];
            this.htmlContent = _data["htmlContent"];
            this.consultationId = _data["consultationId"];
        }
    }

    static fromJS(data: any): Document {
        data = typeof data === 'object' ? data : {};
        let result = new Document();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["doctor"] = this.doctor ? this.doctor.toJSON() : <any>undefined;
        data["doctorId"] = this.doctorId;
        data["documentPath"] = this.documentPath;
        data["id"] = this.id;
        data["isFromPatient"] = this.isFromPatient;
        data["name"] = this.name;
        data["patientId"] = this.patientId;
        if (Array.isArray(this.sharedWithDoctors)) {
            data["sharedWithDoctors"] = [];
            for (let item of this.sharedWithDoctors)
                data["sharedWithDoctors"].push(item ? item.toJSON() : <any>undefined);
        }
        data["type"] = this.type;
        data["sendingDate"] = this.sendingDate ? this.sendingDate.toISOString() : <any>undefined;
        data["isSelected"] = this.isSelected;
        data["isInterne"] = this.isInterne;
        data["autoSendToPatient"] = this.autoSendToPatient;
        data["comment"] = this.comment;
        data["isWysiwygDoc"] = this.isWysiwygDoc;
        data["htmlContent"] = this.htmlContent;
        data["consultationId"] = this.consultationId;
        return data;
    }
}

/** Contains the definition of an object of type Document. */
export interface IDocument {
    /** Gets or sets the created date. */
    createdDate: Date;
    /** Gets or sets the doctor. */
    doctor?: DoctorLiteInfo | undefined;
    /** Gets or sets the doctor identifier. */
    doctorId?: number | undefined;
    /** Gets or sets the document URL. */
    documentPath?: string | undefined;
    /** Gets or sets the identifier. */
    id: number;
    /** Gets or sets a value indicating whether this instance is from patient. */
    isFromPatient: boolean;
    /** Gets or sets the name. */
    name?: string | undefined;
    /** Gets or sets the patient identifier. */
    patientId: number;
    /** Gets or sets the shared with doctors. */
    sharedWithDoctors?: DoctorLiteInfo[] | undefined;
    /** Gets or sets the type. */
    type: DocumentType;
    /** Gets or sets the sending date. */
    sendingDate?: Date | undefined;
    /** Gets or sets a value indicating whether this instance is selected. */
    isSelected: boolean;
    /** Gets or sets a value indicating whether the document is interne. */
    isInterne: boolean;
    /** Gets or sets a value indicating whether the document should be sent automatically to the patient. */
    autoSendToPatient: boolean;
    /** Gets or sets the comment. */
    comment?: string | undefined;
    /** Gets a value indicating whether gets or sets a value indicating whether the document is a WYSIWYG document. */
    isWysiwygDoc: boolean;
    /** Gets or sets the html content. */
    htmlContent?: string | undefined;
    /** Gets or sets the html content. */
    consultationId?: string | undefined;
}

/** Contains the definition of an object of type DocumentForLibrary. */
export class DocumentForLibrary extends Document implements IDocumentForLibrary {
    /** Gets or sets the document type for library. */
    typeForLibrary!: DocumentTypeForLibrary;

    constructor(data?: IDocumentForLibrary) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.typeForLibrary = _data["typeForLibrary"];
        }
    }

    static override fromJS(data: any): DocumentForLibrary {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentForLibrary();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typeForLibrary"] = this.typeForLibrary;
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type DocumentForLibrary. */
export interface IDocumentForLibrary extends IDocument {
    /** Gets or sets the document type for library. */
    typeForLibrary: DocumentTypeForLibrary;
}

/** Contains the definition of an object of type DocumentTypeForLibrary. */
export enum DocumentTypeForLibrary {
    Unknown = 0,
    Siin = 1,
    Custom = 2,
}

/** Contains the definition of an object of type DoctorLiteInfo. */
export class DoctorLiteInfo implements IDoctorLiteInfo {
    /** Gets or sets the color code. */
    colorCode?: string | undefined;
    /** Gets or sets the time limit in hours. */
    consultationCancellationTimeLimit!: number;
    /** Gets or sets the identifier. */
    id!: number;
    /** Gets or sets the display name. */
    displayName?: string | undefined;
    /** Gets or sets the first name. */
    firstName?: string | undefined;
    /** Gets or sets the last name. */
    lastName?: string | undefined;
    /** Gets or sets the phone number. */
    phoneNumber?: string | undefined;
    /** Gets or sets the profile picture url. */
    profilePictureUrl?: string | undefined;
    /** Gets or sets the email. */
    email?: string | undefined;
    /** Gets or sets a value indicating whether gets or sets the auto confirmation. */
    autoConfirmation!: boolean;

    constructor(data?: IDoctorLiteInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.colorCode = _data["colorCode"];
            this.consultationCancellationTimeLimit = _data["consultationCancellationTimeLimit"];
            this.id = _data["id"];
            this.displayName = _data["displayName"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.phoneNumber = _data["phoneNumber"];
            this.profilePictureUrl = _data["profilePictureUrl"];
            this.email = _data["email"];
            this.autoConfirmation = _data["autoConfirmation"];
        }
    }

    static fromJS(data: any): DoctorLiteInfo {
        data = typeof data === 'object' ? data : {};
        let result = new DoctorLiteInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["colorCode"] = this.colorCode;
        data["consultationCancellationTimeLimit"] = this.consultationCancellationTimeLimit;
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["phoneNumber"] = this.phoneNumber;
        data["profilePictureUrl"] = this.profilePictureUrl;
        data["email"] = this.email;
        data["autoConfirmation"] = this.autoConfirmation;
        return data;
    }
}

/** Contains the definition of an object of type DoctorLiteInfo. */
export interface IDoctorLiteInfo {
    /** Gets or sets the color code. */
    colorCode?: string | undefined;
    /** Gets or sets the time limit in hours. */
    consultationCancellationTimeLimit: number;
    /** Gets or sets the identifier. */
    id: number;
    /** Gets or sets the display name. */
    displayName?: string | undefined;
    /** Gets or sets the first name. */
    firstName?: string | undefined;
    /** Gets or sets the last name. */
    lastName?: string | undefined;
    /** Gets or sets the phone number. */
    phoneNumber?: string | undefined;
    /** Gets or sets the profile picture url. */
    profilePictureUrl?: string | undefined;
    /** Gets or sets the email. */
    email?: string | undefined;
    /** Gets or sets a value indicating whether gets or sets the auto confirmation. */
    autoConfirmation: boolean;
}

/** Contains the definition of an object of type DocumentType. */
export enum DocumentType {
    Unknown = 0,
    Suggestion = 1,
    CareCertificate = 2,
    Certificate = 3,
    MedicalResult = 4,
    BiologyResult = 5,
    Other = 6,
    ColleagueResult = 7,
    Insurance = 8,
    MedicalImageryResult = 9,
    Prescription = 10,
    HonoraryInvoice = 11,
    DocumentTemplateAutoGenerated = 12,
    ThirdPartyPatientsImportsErrors = 13,
    Report = 14,
    PatientsDocumentsExport = 15,
}

/** Contains the definition of an object of type DocumentLibrarySearchParam. */
export class DocumentLibrarySearchParam implements IDocumentLibrarySearchParam {
    /** Gets or sets the consultation identifier. */
    consultationId?: number | undefined;
    /** Gets or sets the title. */
    title?: string | undefined;
    /** Gets or sets a value indicating whether the document is internal or not. */
    customOnly!: boolean;

    constructor(data?: IDocumentLibrarySearchParam) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.consultationId = _data["consultationId"];
            this.title = _data["title"];
            this.customOnly = _data["customOnly"];
        }
    }

    static fromJS(data: any): DocumentLibrarySearchParam {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentLibrarySearchParam();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["consultationId"] = this.consultationId;
        data["title"] = this.title;
        data["customOnly"] = this.customOnly;
        return data;
    }
}

/** Contains the definition of an object of type DocumentLibrarySearchParam. */
export interface IDocumentLibrarySearchParam {
    /** Gets or sets the consultation identifier. */
    consultationId?: number | undefined;
    /** Gets or sets the title. */
    title?: string | undefined;
    /** Gets or sets a value indicating whether the document is internal or not. */
    customOnly: boolean;
}

/** Contains the definition of an object of type DocumentTemplateLite. */
export class DocumentTemplateLite implements IDocumentTemplateLite {
    /** Gets or sets the technical identifier. */
    technicalId?: string | undefined;
    /** Gets or sets the name. */
    title?: string | undefined;
    /** Gets or sets the only for country ISO3. */
    excludeForCountryIso3?: string | undefined;
    /** Gets or sets a value indicating whether [library available]. */
    automaticGeneration!: boolean;

    constructor(data?: IDocumentTemplateLite) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.technicalId = _data["technicalId"];
            this.title = _data["title"];
            this.excludeForCountryIso3 = _data["excludeForCountryIso3"];
            this.automaticGeneration = _data["automaticGeneration"];
        }
    }

    static fromJS(data: any): DocumentTemplateLite {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentTemplateLite();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["technicalId"] = this.technicalId;
        data["title"] = this.title;
        data["excludeForCountryIso3"] = this.excludeForCountryIso3;
        data["automaticGeneration"] = this.automaticGeneration;
        return data;
    }
}

/** Contains the definition of an object of type DocumentTemplateLite. */
export interface IDocumentTemplateLite {
    /** Gets or sets the technical identifier. */
    technicalId?: string | undefined;
    /** Gets or sets the name. */
    title?: string | undefined;
    /** Gets or sets the only for country ISO3. */
    excludeForCountryIso3?: string | undefined;
    /** Gets or sets a value indicating whether [library available]. */
    automaticGeneration: boolean;
}

/** Contains the definition of an object of type DocumentTemplateLibrary. */
export class DocumentTemplateLibrary extends DocumentTemplateLite implements IDocumentTemplateLibrary {
    /** Gets or sets a value indicating whether this instance is selected. */
    isSelected!: boolean;
    /** Gets or sets the name of the template. */
    templateName?: string | undefined;
    /** Gets or sets a value indicating whether this instance is present in consultation. */
    isPresentInConsultation!: boolean;

    constructor(data?: IDocumentTemplateLibrary) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.isSelected = _data["isSelected"];
            this.templateName = _data["templateName"];
            this.isPresentInConsultation = _data["isPresentInConsultation"];
        }
    }

    static override fromJS(data: any): DocumentTemplateLibrary {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentTemplateLibrary();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSelected"] = this.isSelected;
        data["templateName"] = this.templateName;
        data["isPresentInConsultation"] = this.isPresentInConsultation;
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type DocumentTemplateLibrary. */
export interface IDocumentTemplateLibrary extends IDocumentTemplateLite {
    /** Gets or sets a value indicating whether this instance is selected. */
    isSelected: boolean;
    /** Gets or sets the name of the template. */
    templateName?: string | undefined;
    /** Gets or sets a value indicating whether this instance is present in consultation. */
    isPresentInConsultation: boolean;
}

/** Contains the definition of an object of type UpdateBiologicalExam. */
export class UpdateBiologicalExam extends BaseEditBiologicalExam implements IUpdateBiologicalExam {

    constructor(data?: IUpdateBiologicalExam) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): UpdateBiologicalExam {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateBiologicalExam();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type UpdateBiologicalExam. */
export interface IUpdateBiologicalExam extends IBaseEditBiologicalExam {
}

/** Contains the definition of an object of type UpdateComplementaryExam. */
export class UpdateComplementaryExam extends BaseEditComplementaryExam implements IUpdateComplementaryExam {

    constructor(data?: IUpdateComplementaryExam) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): UpdateComplementaryExam {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateComplementaryExam();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type UpdateComplementaryExam. */
export interface IUpdateComplementaryExam extends IBaseEditComplementaryExam {
}

/** Contains the definition of an object of type UpdateDisease. */
export class UpdateDisease extends DiseaseBaseEdit implements IUpdateDisease {

    constructor(data?: IUpdateDisease) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): UpdateDisease {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDisease();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type UpdateDisease. */
export interface IUpdateDisease extends IDiseaseBaseEdit {
}

/** Contains the definition of an object of type ConsultInMessage. */
export class ConsultInMessage implements IConsultInMessage {
    /** Gets or sets the identifier. */
    id!: number;
    /** Gets or sets the Content. */
    content?: string | undefined;
    /** Gets or sets the date. */
    date!: Date;
    /** Gets or sets a value indicating whether this instance is seen. */
    isSeen!: boolean;
    /** Gets or sets the sender identifier. */
    senderId!: number;
    /** Gets or sets the receiver identifier. */
    receiverId!: number;
    /** Gets or sets the consultation identifier. */
    consultationId!: number;

    constructor(data?: IConsultInMessage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.content = _data["content"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.isSeen = _data["isSeen"];
            this.senderId = _data["senderId"];
            this.receiverId = _data["receiverId"];
            this.consultationId = _data["consultationId"];
        }
    }

    static fromJS(data: any): ConsultInMessage {
        data = typeof data === 'object' ? data : {};
        let result = new ConsultInMessage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["content"] = this.content;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["isSeen"] = this.isSeen;
        data["senderId"] = this.senderId;
        data["receiverId"] = this.receiverId;
        data["consultationId"] = this.consultationId;
        return data;
    }
}

/** Contains the definition of an object of type ConsultInMessage. */
export interface IConsultInMessage {
    /** Gets or sets the identifier. */
    id: number;
    /** Gets or sets the Content. */
    content?: string | undefined;
    /** Gets or sets the date. */
    date: Date;
    /** Gets or sets a value indicating whether this instance is seen. */
    isSeen: boolean;
    /** Gets or sets the sender identifier. */
    senderId: number;
    /** Gets or sets the receiver identifier. */
    receiverId: number;
    /** Gets or sets the consultation identifier. */
    consultationId: number;
}

/** Contains the definition of an object of type ConsultInDiscussion. */
export class ConsultInDiscussion implements IConsultInDiscussion {
    /** Gets or sets the addressee's first name. */
    addresseeFirstName?: string | undefined;
    /** Gets or sets the addressee's identifier. */
    addresseeId!: number;
    /** Gets or sets the addressee's last name. */
    addresseeLastName?: string | undefined;
    /** Gets or sets the addressee's profile picture URL. */
    addresseeProfilePictureUrl?: string | undefined;
    /** Gets or sets the list of messages. */
    messages?: ConsultInMessage[] | undefined;

    constructor(data?: IConsultInDiscussion) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.addresseeFirstName = _data["addresseeFirstName"];
            this.addresseeId = _data["addresseeId"];
            this.addresseeLastName = _data["addresseeLastName"];
            this.addresseeProfilePictureUrl = _data["addresseeProfilePictureUrl"];
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(ConsultInMessage.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ConsultInDiscussion {
        data = typeof data === 'object' ? data : {};
        let result = new ConsultInDiscussion();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["addresseeFirstName"] = this.addresseeFirstName;
        data["addresseeId"] = this.addresseeId;
        data["addresseeLastName"] = this.addresseeLastName;
        data["addresseeProfilePictureUrl"] = this.addresseeProfilePictureUrl;
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

/** Contains the definition of an object of type ConsultInDiscussion. */
export interface IConsultInDiscussion {
    /** Gets or sets the addressee's first name. */
    addresseeFirstName?: string | undefined;
    /** Gets or sets the addressee's identifier. */
    addresseeId: number;
    /** Gets or sets the addressee's last name. */
    addresseeLastName?: string | undefined;
    /** Gets or sets the addressee's profile picture URL. */
    addresseeProfilePictureUrl?: string | undefined;
    /** Gets or sets the list of messages. */
    messages?: ConsultInMessage[] | undefined;
}

/** Contains the definition of an object of type ChatSearchParams. */
export class ChatSearchParams implements IChatSearchParams {
    /** Gets or sets the filter period. */
    filterPeriod!: NoteFilterPeriodEnum;
    /** Gets or sets the patient identifier. */
    patientId?: number | undefined;
    /** Gets or sets the consultation identifier. */
    consultationId?: number | undefined;

    constructor(data?: IChatSearchParams) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filterPeriod = _data["filterPeriod"];
            this.patientId = _data["patientId"];
            this.consultationId = _data["consultationId"];
        }
    }

    static fromJS(data: any): ChatSearchParams {
        data = typeof data === 'object' ? data : {};
        let result = new ChatSearchParams();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filterPeriod"] = this.filterPeriod;
        data["patientId"] = this.patientId;
        data["consultationId"] = this.consultationId;
        return data;
    }
}

/** Contains the definition of an object of type ChatSearchParams. */
export interface IChatSearchParams {
    /** Gets or sets the filter period. */
    filterPeriod: NoteFilterPeriodEnum;
    /** Gets or sets the patient identifier. */
    patientId?: number | undefined;
    /** Gets or sets the consultation identifier. */
    consultationId?: number | undefined;
}

/** Contains the definition of an object of type NoteFilterPeriodEnum. */
export enum NoteFilterPeriodEnum {
    Unknown = 0,
    All = 1,
    Today = 2,
    ThisWeek = 3,
    LastWeeks = 4,
    NextWeeks = 5,
}

/** Contains the definition of an object of type DoctorIntegrationPartner. */
export class DoctorIntegrationPartner implements IDoctorIntegrationPartner {
    /** Gets or sets the doctor identifier. */
    doctorId!: number;
    /** Gets or sets the integration partner. */
    integrationPartner?: IntegrationPartner | undefined;
    /** Gets or sets the integration partner identifier. */
    integrationPartnerId!: number;
    /** Gets or sets a value indicating whether the integration partner is active. */
    isActive!: boolean;

    constructor(data?: IDoctorIntegrationPartner) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.doctorId = _data["doctorId"];
            this.integrationPartner = _data["integrationPartner"] ? IntegrationPartner.fromJS(_data["integrationPartner"]) : <any>undefined;
            this.integrationPartnerId = _data["integrationPartnerId"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): DoctorIntegrationPartner {
        data = typeof data === 'object' ? data : {};
        let result = new DoctorIntegrationPartner();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["doctorId"] = this.doctorId;
        data["integrationPartner"] = this.integrationPartner ? this.integrationPartner.toJSON() : <any>undefined;
        data["integrationPartnerId"] = this.integrationPartnerId;
        data["isActive"] = this.isActive;
        return data;
    }
}

/** Contains the definition of an object of type DoctorIntegrationPartner. */
export interface IDoctorIntegrationPartner {
    /** Gets or sets the doctor identifier. */
    doctorId: number;
    /** Gets or sets the integration partner. */
    integrationPartner?: IntegrationPartner | undefined;
    /** Gets or sets the integration partner identifier. */
    integrationPartnerId: number;
    /** Gets or sets a value indicating whether the integration partner is active. */
    isActive: boolean;
}

/** Contains the definition of an object of type IntegrationPartner. */
export class IntegrationPartner implements IIntegrationPartner {
    /** Gets or sets the identifier. */
    id!: number;
    /** Gets or sets the title. */
    title?: string | undefined;
    /** Gets or sets the code. */
    code?: string | undefined;
    /** Gets or sets the description. */
    description?: string | undefined;
    /** Gets or sets the website url. */
    websiteUrl?: string | undefined;
    /** Gets or sets the picture path. */
    picture?: string | undefined;
    /** Gets or sets a value indicating whether the integration partner is archived. */
    isArchived!: boolean;

    constructor(data?: IIntegrationPartner) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.code = _data["code"];
            this.description = _data["description"];
            this.websiteUrl = _data["websiteUrl"];
            this.picture = _data["picture"];
            this.isArchived = _data["isArchived"];
        }
    }

    static fromJS(data: any): IntegrationPartner {
        data = typeof data === 'object' ? data : {};
        let result = new IntegrationPartner();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["code"] = this.code;
        data["description"] = this.description;
        data["websiteUrl"] = this.websiteUrl;
        data["picture"] = this.picture;
        data["isArchived"] = this.isArchived;
        return data;
    }
}

/** Contains the definition of an object of type IntegrationPartner. */
export interface IIntegrationPartner {
    /** Gets or sets the identifier. */
    id: number;
    /** Gets or sets the title. */
    title?: string | undefined;
    /** Gets or sets the code. */
    code?: string | undefined;
    /** Gets or sets the description. */
    description?: string | undefined;
    /** Gets or sets the website url. */
    websiteUrl?: string | undefined;
    /** Gets or sets the picture path. */
    picture?: string | undefined;
    /** Gets or sets a value indicating whether the integration partner is archived. */
    isArchived: boolean;
}

/** Contains the defintion of an object of type DoctorSubUser */
export class DoctorSubUser implements IDoctorSubUser {
    /** Gets or sets the identifier. */
    doctorSubUserId!: number;
    /** Gets or sets the nom. */
    lastName?: string | undefined;
    /** Gets or sets the prenom. */
    firstName?: string | undefined;
    /** Gets or sets the role. */
    role!: Roles;
    /** Gets or sets the sub role. */
    subRole!: DoctorSubUserSubRole;
    /** Gets or sets the email. */
    email?: string | undefined;
    /** Gets or sets a value indicating whether this instance is active. */
    isActive!: boolean;

    constructor(data?: IDoctorSubUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.doctorSubUserId = _data["doctorSubUserId"];
            this.lastName = _data["lastName"];
            this.firstName = _data["firstName"];
            this.role = _data["role"];
            this.subRole = _data["subRole"];
            this.email = _data["email"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): DoctorSubUser {
        data = typeof data === 'object' ? data : {};
        let result = new DoctorSubUser();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["doctorSubUserId"] = this.doctorSubUserId;
        data["lastName"] = this.lastName;
        data["firstName"] = this.firstName;
        data["role"] = this.role;
        data["subRole"] = this.subRole;
        data["email"] = this.email;
        data["isActive"] = this.isActive;
        return data;
    }
}

/** Contains the defintion of an object of type DoctorSubUser */
export interface IDoctorSubUser {
    /** Gets or sets the identifier. */
    doctorSubUserId: number;
    /** Gets or sets the nom. */
    lastName?: string | undefined;
    /** Gets or sets the prenom. */
    firstName?: string | undefined;
    /** Gets or sets the role. */
    role: Roles;
    /** Gets or sets the sub role. */
    subRole: DoctorSubUserSubRole;
    /** Gets or sets the email. */
    email?: string | undefined;
    /** Gets or sets a value indicating whether this instance is active. */
    isActive: boolean;
}

/** Contains the definition of an object of type Roles. */
export enum Roles {
    Unknown = 0,
    Dealer = 1,
    Webmaster = 2,
    Client = 3,
    Teacher = 4,
    Manager = 5,
    ConsultIn = 6,
    Patient = 7,
    SubUser = 8,
}

/** Contains the definition of an object of type DoctorSubUserSubRole. */
export enum DoctorSubUserSubRole {
    None = 0,
    Assistant = 1,
    Secretary = 2,
}

/** Contains the defintion of an object of type DoctorSubUserDetail */
export class DoctorSubUserDetail implements IDoctorSubUserDetail {
    /** Gets or sets the nom. */
    lastName?: string | undefined;
    /** Gets or sets the prenom. */
    firstName?: string | undefined;
    /** Gets or sets the email. */
    email?: string | undefined;
    /** Gets or sets a value indicating whether this instance is active. */
    isActive!: boolean;
    /** Gets or sets the role. */
    role!: Roles;
    /** Gets or sets the sub role. */
    subRole!: DoctorSubUserSubRole;

    constructor(data?: IDoctorSubUserDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lastName = _data["lastName"];
            this.firstName = _data["firstName"];
            this.email = _data["email"];
            this.isActive = _data["isActive"];
            this.role = _data["role"];
            this.subRole = _data["subRole"];
        }
    }

    static fromJS(data: any): DoctorSubUserDetail {
        data = typeof data === 'object' ? data : {};
        let result = new DoctorSubUserDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lastName"] = this.lastName;
        data["firstName"] = this.firstName;
        data["email"] = this.email;
        data["isActive"] = this.isActive;
        data["role"] = this.role;
        data["subRole"] = this.subRole;
        return data;
    }
}

/** Contains the defintion of an object of type DoctorSubUserDetail */
export interface IDoctorSubUserDetail {
    /** Gets or sets the nom. */
    lastName?: string | undefined;
    /** Gets or sets the prenom. */
    firstName?: string | undefined;
    /** Gets or sets the email. */
    email?: string | undefined;
    /** Gets or sets a value indicating whether this instance is active. */
    isActive: boolean;
    /** Gets or sets the role. */
    role: Roles;
    /** Gets or sets the sub role. */
    subRole: DoctorSubUserSubRole;
}

/** Contains the definition of an object of type BaseEditMedicalOffice. */
export class BaseEditMedicalOffice implements IBaseEditMedicalOffice {
    /** Gets or sets the city. */
    city?: string | undefined;
    /** Gets or sets the country. */
    country?: string | undefined;
    /** Gets or sets the doctor identifier. */
    doctorId!: number;
    /** Gets or sets a value indicating whether the medical office is the main business address. */
    mainBusinessAddress!: boolean;
    /** Gets or sets the name. */
    name?: string | undefined;
    /** Gets or sets the number. */
    number?: string | undefined;
    /** Gets or sets the street. */
    street?: string | undefined;
    /** Gets or sets the region. */
    region?: string | undefined;
    /** Gets or sets the zip code. */
    zipCode?: string | undefined;

    constructor(data?: IBaseEditMedicalOffice) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.city = _data["city"];
            this.country = _data["country"];
            this.doctorId = _data["doctorId"];
            this.mainBusinessAddress = _data["mainBusinessAddress"];
            this.name = _data["name"];
            this.number = _data["number"];
            this.street = _data["street"];
            this.region = _data["region"];
            this.zipCode = _data["zipCode"];
        }
    }

    static fromJS(data: any): BaseEditMedicalOffice {
        data = typeof data === 'object' ? data : {};
        let result = new BaseEditMedicalOffice();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["city"] = this.city;
        data["country"] = this.country;
        data["doctorId"] = this.doctorId;
        data["mainBusinessAddress"] = this.mainBusinessAddress;
        data["name"] = this.name;
        data["number"] = this.number;
        data["street"] = this.street;
        data["region"] = this.region;
        data["zipCode"] = this.zipCode;
        return data;
    }
}

/** Contains the definition of an object of type BaseEditMedicalOffice. */
export interface IBaseEditMedicalOffice {
    /** Gets or sets the city. */
    city?: string | undefined;
    /** Gets or sets the country. */
    country?: string | undefined;
    /** Gets or sets the doctor identifier. */
    doctorId: number;
    /** Gets or sets a value indicating whether the medical office is the main business address. */
    mainBusinessAddress: boolean;
    /** Gets or sets the name. */
    name?: string | undefined;
    /** Gets or sets the number. */
    number?: string | undefined;
    /** Gets or sets the street. */
    street?: string | undefined;
    /** Gets or sets the region. */
    region?: string | undefined;
    /** Gets or sets the zip code. */
    zipCode?: string | undefined;
}

/** Contains the definition of an object of type CreateMedicalOffice. */
export class CreateMedicalOffice extends BaseEditMedicalOffice implements ICreateMedicalOffice {
    /** Gets or sets a value indicating whether gets or sets the isActive value. */
    isActive!: boolean;

    constructor(data?: ICreateMedicalOffice) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.isActive = _data["isActive"];
        }
    }

    static override fromJS(data: any): CreateMedicalOffice {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMedicalOffice();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isActive"] = this.isActive;
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type CreateMedicalOffice. */
export interface ICreateMedicalOffice extends IBaseEditMedicalOffice {
    /** Gets or sets a value indicating whether gets or sets the isActive value. */
    isActive: boolean;
}

/** Contains the definition of an object of type DoctorSubUserCreation. */
export class DoctorSubUserCreation implements IDoctorSubUserCreation {
    /** Gets or sets the nom. */
    lastName?: string | undefined;
    /** Gets or sets the prenom. */
    firstName?: string | undefined;
    /** Gets or sets the email. */
    email?: string | undefined;
    /** Gets or sets the sub role. */
    subRole!: DoctorSubUserSubRole;

    constructor(data?: IDoctorSubUserCreation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lastName = _data["lastName"];
            this.firstName = _data["firstName"];
            this.email = _data["email"];
            this.subRole = _data["subRole"];
        }
    }

    static fromJS(data: any): DoctorSubUserCreation {
        data = typeof data === 'object' ? data : {};
        let result = new DoctorSubUserCreation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lastName"] = this.lastName;
        data["firstName"] = this.firstName;
        data["email"] = this.email;
        data["subRole"] = this.subRole;
        return data;
    }
}

/** Contains the definition of an object of type DoctorSubUserCreation. */
export interface IDoctorSubUserCreation {
    /** Gets or sets the nom. */
    lastName?: string | undefined;
    /** Gets or sets the prenom. */
    firstName?: string | undefined;
    /** Gets or sets the email. */
    email?: string | undefined;
    /** Gets or sets the sub role. */
    subRole: DoctorSubUserSubRole;
}

/** Contains the definition of an object of type BillableInsurance */
export class BillableInsurance implements IBillableInsurance {
    /** Gets or sets the billable months. */
    billableMonths?: Date[] | undefined;
    /** Gets or sets the insurance identifier. */
    insuranceId!: number;
    /** Gets or sets the name of the insurance. */
    insuranceName?: string | undefined;

    constructor(data?: IBillableInsurance) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["BillableMonths"])) {
                this.billableMonths = [] as any;
                for (let item of _data["BillableMonths"])
                    this.billableMonths!.push(new Date(item));
            }
            this.insuranceId = _data["InsuranceId"];
            this.insuranceName = _data["InsuranceName"];
        }
    }

    static fromJS(data: any): BillableInsurance {
        data = typeof data === 'object' ? data : {};
        let result = new BillableInsurance();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.billableMonths)) {
            data["BillableMonths"] = [];
            for (let item of this.billableMonths)
                data["BillableMonths"].push(item.toISOString());
        }
        data["InsuranceId"] = this.insuranceId;
        data["InsuranceName"] = this.insuranceName;
        return data;
    }
}

/** Contains the definition of an object of type BillableInsurance */
export interface IBillableInsurance {
    /** Gets or sets the billable months. */
    billableMonths?: Date[] | undefined;
    /** Gets or sets the insurance identifier. */
    insuranceId: number;
    /** Gets or sets the name of the insurance. */
    insuranceName?: string | undefined;
}

/** Contains the definition of an object of type DoctorBillingInfos */
export class DoctorBillingInfos implements IDoctorBillingInfos {
    /** Gets or sets the bic. */
    bic?: string | undefined;
    /** Gets or sets the city. */
    city?: string | undefined;
    /** Gets or sets the company. */
    company?: string | undefined;
    /** Gets or sets the consultation means of payment identifiers. */
    consultationMeansOfPaymentIds?: number[] | undefined;
    /** Gets or sets the country. */
    country?: string | undefined;
    /** Gets or sets the iban. */
    iban?: string | undefined;
    /** Gets or sets a value indicating whether payment online is authorized. */
    isPaymentOnlineAuthorized!: boolean;
    /** Gets or sets a value indicating whether payment on site is authorized. */
    isPaymentOnSiteAuthorized!: boolean;
    /** Gets or sets a value indicating whether stripe account is fully configured. */
    isStripeFullyConfigured!: boolean;
    /** Gets or sets the number. */
    number?: string | undefined;
    /** Gets or sets the street. */
    street?: string | undefined;
    /** Gets or sets the vat number. */
    vatNumber?: string | undefined;
    /** Gets or sets the zip code. */
    zipCode?: string | undefined;

    constructor(data?: IDoctorBillingInfos) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bic = _data["bic"];
            this.city = _data["city"];
            this.company = _data["company"];
            if (Array.isArray(_data["consultationMeansOfPaymentIds"])) {
                this.consultationMeansOfPaymentIds = [] as any;
                for (let item of _data["consultationMeansOfPaymentIds"])
                    this.consultationMeansOfPaymentIds!.push(item);
            }
            this.country = _data["country"];
            this.iban = _data["iban"];
            this.isPaymentOnlineAuthorized = _data["isPaymentOnlineAuthorized"];
            this.isPaymentOnSiteAuthorized = _data["isPaymentOnSiteAuthorized"];
            this.isStripeFullyConfigured = _data["isStripeFullyConfigured"];
            this.number = _data["number"];
            this.street = _data["street"];
            this.vatNumber = _data["vatNumber"];
            this.zipCode = _data["zipCode"];
        }
    }

    static fromJS(data: any): DoctorBillingInfos {
        data = typeof data === 'object' ? data : {};
        let result = new DoctorBillingInfos();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bic"] = this.bic;
        data["city"] = this.city;
        data["company"] = this.company;
        if (Array.isArray(this.consultationMeansOfPaymentIds)) {
            data["consultationMeansOfPaymentIds"] = [];
            for (let item of this.consultationMeansOfPaymentIds)
                data["consultationMeansOfPaymentIds"].push(item);
        }
        data["country"] = this.country;
        data["iban"] = this.iban;
        data["isPaymentOnlineAuthorized"] = this.isPaymentOnlineAuthorized;
        data["isPaymentOnSiteAuthorized"] = this.isPaymentOnSiteAuthorized;
        data["isStripeFullyConfigured"] = this.isStripeFullyConfigured;
        data["number"] = this.number;
        data["street"] = this.street;
        data["vatNumber"] = this.vatNumber;
        data["zipCode"] = this.zipCode;
        return data;
    }
}

/** Contains the definition of an object of type DoctorBillingInfos */
export interface IDoctorBillingInfos {
    /** Gets or sets the bic. */
    bic?: string | undefined;
    /** Gets or sets the city. */
    city?: string | undefined;
    /** Gets or sets the company. */
    company?: string | undefined;
    /** Gets or sets the consultation means of payment identifiers. */
    consultationMeansOfPaymentIds?: number[] | undefined;
    /** Gets or sets the country. */
    country?: string | undefined;
    /** Gets or sets the iban. */
    iban?: string | undefined;
    /** Gets or sets a value indicating whether payment online is authorized. */
    isPaymentOnlineAuthorized: boolean;
    /** Gets or sets a value indicating whether payment on site is authorized. */
    isPaymentOnSiteAuthorized: boolean;
    /** Gets or sets a value indicating whether stripe account is fully configured. */
    isStripeFullyConfigured: boolean;
    /** Gets or sets the number. */
    number?: string | undefined;
    /** Gets or sets the street. */
    street?: string | undefined;
    /** Gets or sets the vat number. */
    vatNumber?: string | undefined;
    /** Gets or sets the zip code. */
    zipCode?: string | undefined;
}

/** Contains the definition of an object of type DoctorBillingInfos */
export class DoctorPaymentInfos implements IDoctorPaymentInfos {
    /** Gets or sets the consultation means of payment identifiers. */
    consultationMeansOfPaymentIds?: number[] | undefined;
    /** Gets or sets the consultation means of payment labels. */
    consultationMeansOfPaymentLabels?: string[] | undefined;
    /** Gets or sets a value indicating whether payment online is authorized. */
    isPaymentOnlineAuthorized!: boolean;
    /** Gets or sets a value indicating whether payment on site is authorized. */
    isPaymentOnSiteAuthorized!: boolean;

    constructor(data?: IDoctorPaymentInfos) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["consultationMeansOfPaymentIds"])) {
                this.consultationMeansOfPaymentIds = [] as any;
                for (let item of _data["consultationMeansOfPaymentIds"])
                    this.consultationMeansOfPaymentIds!.push(item);
            }
            if (Array.isArray(_data["consultationMeansOfPaymentLabels"])) {
                this.consultationMeansOfPaymentLabels = [] as any;
                for (let item of _data["consultationMeansOfPaymentLabels"])
                    this.consultationMeansOfPaymentLabels!.push(item);
            }
            this.isPaymentOnlineAuthorized = _data["isPaymentOnlineAuthorized"];
            this.isPaymentOnSiteAuthorized = _data["isPaymentOnSiteAuthorized"];
        }
    }

    static fromJS(data: any): DoctorPaymentInfos {
        data = typeof data === 'object' ? data : {};
        let result = new DoctorPaymentInfos();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.consultationMeansOfPaymentIds)) {
            data["consultationMeansOfPaymentIds"] = [];
            for (let item of this.consultationMeansOfPaymentIds)
                data["consultationMeansOfPaymentIds"].push(item);
        }
        if (Array.isArray(this.consultationMeansOfPaymentLabels)) {
            data["consultationMeansOfPaymentLabels"] = [];
            for (let item of this.consultationMeansOfPaymentLabels)
                data["consultationMeansOfPaymentLabels"].push(item);
        }
        data["isPaymentOnlineAuthorized"] = this.isPaymentOnlineAuthorized;
        data["isPaymentOnSiteAuthorized"] = this.isPaymentOnSiteAuthorized;
        return data;
    }
}

/** Contains the definition of an object of type DoctorBillingInfos */
export interface IDoctorPaymentInfos {
    /** Gets or sets the consultation means of payment identifiers. */
    consultationMeansOfPaymentIds?: number[] | undefined;
    /** Gets or sets the consultation means of payment labels. */
    consultationMeansOfPaymentLabels?: string[] | undefined;
    /** Gets or sets a value indicating whether payment online is authorized. */
    isPaymentOnlineAuthorized: boolean;
    /** Gets or sets a value indicating whether payment on site is authorized. */
    isPaymentOnSiteAuthorized: boolean;
}

/** Contains the definition of an object of type CurrentDoctorInfo. */
export class CurrentDoctorInfo implements ICurrentDoctorInfo {
    /** Gets or sets the first name. */
    firstName?: string | undefined;
    /** Gets or sets the identifier. */
    id!: number;
    /** Gets or sets the last name. */
    lastName?: string | undefined;
    /** Gets or sets the country. */
    country?: string | undefined;
    /** Gets or sets the profile picture url. */
    profilePictureUrl?: string | undefined;
    /** Gets or sets the subscription levels. */
    subscriptionLevels?: number[] | undefined;
    /** Gets or sets the subscription level. */
    subscriptionLevel!: ProNutriConsultSubscriptionLevel;
    /** Gets or sets a value indicating whether doctor can use teleconsultation. */
    canUseTeleConsult!: boolean;
    /** Gets or sets a value indicating whether doctor has biody. */
    hasBiody!: boolean;

    constructor(data?: ICurrentDoctorInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.id = _data["id"];
            this.lastName = _data["lastName"];
            this.country = _data["country"];
            this.profilePictureUrl = _data["profilePictureUrl"];
            if (Array.isArray(_data["subscriptionLevels"])) {
                this.subscriptionLevels = [] as any;
                for (let item of _data["subscriptionLevels"])
                    this.subscriptionLevels!.push(item);
            }
            this.subscriptionLevel = _data["subscriptionLevel"];
            this.canUseTeleConsult = _data["canUseTeleConsult"];
            this.hasBiody = _data["hasBiody"];
        }
    }

    static fromJS(data: any): CurrentDoctorInfo {
        data = typeof data === 'object' ? data : {};
        let result = new CurrentDoctorInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["id"] = this.id;
        data["lastName"] = this.lastName;
        data["country"] = this.country;
        data["profilePictureUrl"] = this.profilePictureUrl;
        if (Array.isArray(this.subscriptionLevels)) {
            data["subscriptionLevels"] = [];
            for (let item of this.subscriptionLevels)
                data["subscriptionLevels"].push(item);
        }
        data["subscriptionLevel"] = this.subscriptionLevel;
        data["canUseTeleConsult"] = this.canUseTeleConsult;
        data["hasBiody"] = this.hasBiody;
        return data;
    }
}

/** Contains the definition of an object of type CurrentDoctorInfo. */
export interface ICurrentDoctorInfo {
    /** Gets or sets the first name. */
    firstName?: string | undefined;
    /** Gets or sets the identifier. */
    id: number;
    /** Gets or sets the last name. */
    lastName?: string | undefined;
    /** Gets or sets the country. */
    country?: string | undefined;
    /** Gets or sets the profile picture url. */
    profilePictureUrl?: string | undefined;
    /** Gets or sets the subscription levels. */
    subscriptionLevels?: number[] | undefined;
    /** Gets or sets the subscription level. */
    subscriptionLevel: ProNutriConsultSubscriptionLevel;
    /** Gets or sets a value indicating whether doctor can use teleconsultation. */
    canUseTeleConsult: boolean;
    /** Gets or sets a value indicating whether doctor has biody. */
    hasBiody: boolean;
}

/** Contains the definition of an object of type ProNutriConsultSubscriptionLevel. */
export enum ProNutriConsultSubscriptionLevel {
    ProNutriConsultEssential = 1,
    ProNutriConsultAdvanced = 2,
    ProNutriConsultExpert = 3,
    Consultant = 4,
}

export class PaginatorWrapperOfIEnumerableOfDoctorPatient implements IPaginatorWrapperOfIEnumerableOfDoctorPatient {
    totalRecords!: number;
    data?: DoctorPatient[] | undefined;

    constructor(data?: IPaginatorWrapperOfIEnumerableOfDoctorPatient) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRecords = _data["totalRecords"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(DoctorPatient.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatorWrapperOfIEnumerableOfDoctorPatient {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatorWrapperOfIEnumerableOfDoctorPatient();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IPaginatorWrapperOfIEnumerableOfDoctorPatient {
    totalRecords: number;
    data?: DoctorPatient[] | undefined;
}

/** Contains the definition of an object of type DoctorPatient */
export class DoctorPatient implements IDoctorPatient {
    /** Gets or sets the doctor identifier. */
    doctorId!: number;
    /** Gets or sets a value indicating whether this instance is patient blocked. */
    isPatientBlocked!: boolean;
    /** Gets or sets the last or next consultation date. */
    lastOrNextConsultationDate?: Date | undefined;
    /** Gets or sets the last or next consultation mode. */
    lastOrNextConsultationMode?: ConsultationLocation | undefined;
    /** Gets or sets the nb tasks to do. */
    nbNoteToDo!: number;
    /** Gets or sets the patient identifier. */
    patientId!: number;
    /** Gets or sets the patient. */
    patientInfo?: PatientInfo | undefined;
    /** Gets or sets a value indicating whether this patient account is blocked. */
    isPatientAccountLockedOut!: boolean;
    /** Gets or sets the patient responsible display name. */
    responsibleDisplayName?: string | undefined;
    /** Gets or sets the patient responsible identifier. */
    responsibleId?: number | undefined;
    /** Gets or sets the doctor. */
    doctorDetails?: DoctorConsultSiinInfos | undefined;
    /** Gets or sets the patient biody identifier. */
    biodyPatientId?: number | undefined;
    /** Gets or sets the missing fields for the creation in biody. */
    biodyMissingFields?: string | undefined;
    /** Gets or sets a value indicating whether this instance is patient archived. */
    isPatientArchived!: boolean;

    constructor(data?: IDoctorPatient) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.doctorId = _data["doctorId"];
            this.isPatientBlocked = _data["isPatientBlocked"];
            this.lastOrNextConsultationDate = _data["lastOrNextConsultationDate"] ? new Date(_data["lastOrNextConsultationDate"].toString()) : <any>undefined;
            this.lastOrNextConsultationMode = _data["lastOrNextConsultationMode"];
            this.nbNoteToDo = _data["nbNoteToDo"];
            this.patientId = _data["patientId"];
            this.patientInfo = _data["patientInfo"] ? PatientInfo.fromJS(_data["patientInfo"]) : <any>undefined;
            this.isPatientAccountLockedOut = _data["isPatientAccountLockedOut"];
            this.responsibleDisplayName = _data["responsibleDisplayName"];
            this.responsibleId = _data["responsibleId"];
            this.doctorDetails = _data["doctorDetails"] ? DoctorConsultSiinInfos.fromJS(_data["doctorDetails"]) : <any>undefined;
            this.biodyPatientId = _data["biodyPatientId"];
            this.biodyMissingFields = _data["biodyMissingFields"];
            this.isPatientArchived = _data["isPatientArchived"];
        }
    }

    static fromJS(data: any): DoctorPatient {
        data = typeof data === 'object' ? data : {};
        let result = new DoctorPatient();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["doctorId"] = this.doctorId;
        data["isPatientBlocked"] = this.isPatientBlocked;
        data["lastOrNextConsultationDate"] = this.lastOrNextConsultationDate ? this.lastOrNextConsultationDate.toISOString() : <any>undefined;
        data["lastOrNextConsultationMode"] = this.lastOrNextConsultationMode;
        data["nbNoteToDo"] = this.nbNoteToDo;
        data["patientId"] = this.patientId;
        data["patientInfo"] = this.patientInfo ? this.patientInfo.toJSON() : <any>undefined;
        data["isPatientAccountLockedOut"] = this.isPatientAccountLockedOut;
        data["responsibleDisplayName"] = this.responsibleDisplayName;
        data["responsibleId"] = this.responsibleId;
        data["doctorDetails"] = this.doctorDetails ? this.doctorDetails.toJSON() : <any>undefined;
        data["biodyPatientId"] = this.biodyPatientId;
        data["biodyMissingFields"] = this.biodyMissingFields;
        data["isPatientArchived"] = this.isPatientArchived;
        return data;
    }
}

/** Contains the definition of an object of type DoctorPatient */
export interface IDoctorPatient {
    /** Gets or sets the doctor identifier. */
    doctorId: number;
    /** Gets or sets a value indicating whether this instance is patient blocked. */
    isPatientBlocked: boolean;
    /** Gets or sets the last or next consultation date. */
    lastOrNextConsultationDate?: Date | undefined;
    /** Gets or sets the last or next consultation mode. */
    lastOrNextConsultationMode?: ConsultationLocation | undefined;
    /** Gets or sets the nb tasks to do. */
    nbNoteToDo: number;
    /** Gets or sets the patient identifier. */
    patientId: number;
    /** Gets or sets the patient. */
    patientInfo?: PatientInfo | undefined;
    /** Gets or sets a value indicating whether this patient account is blocked. */
    isPatientAccountLockedOut: boolean;
    /** Gets or sets the patient responsible display name. */
    responsibleDisplayName?: string | undefined;
    /** Gets or sets the patient responsible identifier. */
    responsibleId?: number | undefined;
    /** Gets or sets the doctor. */
    doctorDetails?: DoctorConsultSiinInfos | undefined;
    /** Gets or sets the patient biody identifier. */
    biodyPatientId?: number | undefined;
    /** Gets or sets the missing fields for the creation in biody. */
    biodyMissingFields?: string | undefined;
    /** Gets or sets a value indicating whether this instance is patient archived. */
    isPatientArchived: boolean;
}

/** Contains the definition of an object of type ConsultationLocation. */
export enum ConsultationLocation {
    Unknown = 0,
    OnSite = 1,
    Remote = 2,
}

/** Contains the definition of an object of type PatientLiteInfo. */
export class PatientLiteInfo implements IPatientLiteInfo {
    /** Gets or sets the birth date. */
    birthDate!: Date;
    /** Gets or sets the display name. */
    displayName?: string | undefined;
    /** Gets or sets the email. */
    email?: string | undefined;
    /** Gets or sets the first name. */
    firstName!: string;
    /** Gets or sets the identifier. */
    id!: number;
    /** Gets or sets the identifier. */
    memberId?: number | undefined;
    /** Gets or sets the last name. */
    lastName!: string;
    /** Gets or sets the profile picture URL. */
    profilePictureUrl?: string | undefined;
    /** Gets or sets the identifier of the relative. */
    responsiblePatientId?: number | undefined;
    /** Gets or sets the gender. */
    gender?: string | undefined;
    /** Gets or sets the first phone. */
    phoneNumber?: string | undefined;
    /** Gets or sets the vat number. */
    vatNumber?: string | undefined;

    constructor(data?: IPatientLiteInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : <any>undefined;
            this.displayName = _data["displayName"];
            this.email = _data["email"];
            this.firstName = _data["firstName"];
            this.id = _data["id"];
            this.memberId = _data["memberId"];
            this.lastName = _data["lastName"];
            this.profilePictureUrl = _data["profilePictureUrl"];
            this.responsiblePatientId = _data["responsiblePatientId"];
            this.gender = _data["gender"];
            this.phoneNumber = _data["phoneNumber"];
            this.vatNumber = _data["vatNumber"];
        }
    }

    static fromJS(data: any): PatientLiteInfo {
        data = typeof data === 'object' ? data : {};
        let result = new PatientLiteInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["displayName"] = this.displayName;
        data["email"] = this.email;
        data["firstName"] = this.firstName;
        data["id"] = this.id;
        data["memberId"] = this.memberId;
        data["lastName"] = this.lastName;
        data["profilePictureUrl"] = this.profilePictureUrl;
        data["responsiblePatientId"] = this.responsiblePatientId;
        data["gender"] = this.gender;
        data["phoneNumber"] = this.phoneNumber;
        data["vatNumber"] = this.vatNumber;
        return data;
    }
}

/** Contains the definition of an object of type PatientLiteInfo. */
export interface IPatientLiteInfo {
    /** Gets or sets the birth date. */
    birthDate: Date;
    /** Gets or sets the display name. */
    displayName?: string | undefined;
    /** Gets or sets the email. */
    email?: string | undefined;
    /** Gets or sets the first name. */
    firstName: string;
    /** Gets or sets the identifier. */
    id: number;
    /** Gets or sets the identifier. */
    memberId?: number | undefined;
    /** Gets or sets the last name. */
    lastName: string;
    /** Gets or sets the profile picture URL. */
    profilePictureUrl?: string | undefined;
    /** Gets or sets the identifier of the relative. */
    responsiblePatientId?: number | undefined;
    /** Gets or sets the gender. */
    gender?: string | undefined;
    /** Gets or sets the first phone. */
    phoneNumber?: string | undefined;
    /** Gets or sets the vat number. */
    vatNumber?: string | undefined;
}

/** Contains the definition of an object of type PatientInfo. */
export class PatientInfo extends PatientLiteInfo implements IPatientInfo {
    /** Gets or sets the medication. */
    backgroundTreatment?: string | undefined;
    /** Gets or sets a value indicating whether this instance has task to do. */
    hasTaskToDo!: boolean;
    /** Gets or sets the health plan. */
    healthPlan?: HealthPlan | undefined;
    /** Gets or sets the insurance token. */
    insuranceToken?: string | undefined;
    /** Gets or sets the insurance identifier. */
    insuranceId?: number | undefined;
    /** Gets or sets a value indicating whether this instance has agreed SMS. */
    hasAgreedSMS!: boolean;
    /** Gets or sets the physical activity. */
    physicalActivity!: PhysicalActivity;
    /** Gets or sets the weight objective. */
    weightObjective!: WeightObjective;

    constructor(data?: IPatientInfo) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.backgroundTreatment = _data["backgroundTreatment"];
            this.hasTaskToDo = _data["hasTaskToDo"];
            this.healthPlan = _data["healthPlan"];
            this.insuranceToken = _data["insuranceToken"];
            this.insuranceId = _data["insuranceId"];
            this.hasAgreedSMS = _data["hasAgreedSMS"];
            this.physicalActivity = _data["physicalActivity"];
            this.weightObjective = _data["weightObjective"];
        }
    }

    static override fromJS(data: any): PatientInfo {
        data = typeof data === 'object' ? data : {};
        let result = new PatientInfo();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["backgroundTreatment"] = this.backgroundTreatment;
        data["hasTaskToDo"] = this.hasTaskToDo;
        data["healthPlan"] = this.healthPlan;
        data["insuranceToken"] = this.insuranceToken;
        data["insuranceId"] = this.insuranceId;
        data["hasAgreedSMS"] = this.hasAgreedSMS;
        data["physicalActivity"] = this.physicalActivity;
        data["weightObjective"] = this.weightObjective;
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type PatientInfo. */
export interface IPatientInfo extends IPatientLiteInfo {
    /** Gets or sets the medication. */
    backgroundTreatment?: string | undefined;
    /** Gets or sets a value indicating whether this instance has task to do. */
    hasTaskToDo: boolean;
    /** Gets or sets the health plan. */
    healthPlan?: HealthPlan | undefined;
    /** Gets or sets the insurance token. */
    insuranceToken?: string | undefined;
    /** Gets or sets the insurance identifier. */
    insuranceId?: number | undefined;
    /** Gets or sets a value indicating whether this instance has agreed SMS. */
    hasAgreedSMS: boolean;
    /** Gets or sets the physical activity. */
    physicalActivity: PhysicalActivity;
    /** Gets or sets the weight objective. */
    weightObjective: WeightObjective;
}

/** Contains the definition of an object of type HealthPlan */
export enum HealthPlan {
    Unknown = 0,
    MyHealth = 1,
    MyHealthPlus = 2,
}

/** Contains the definition of an object of type PhysicalActivity. */
export enum PhysicalActivity {
    Unknown = 0,
    Sedentary = 1,
    Low = 2,
    Medium = 3,
    High = 4,
    Intense = 5,
}

/** Contains the definition of an object of type WeightObjective. */
export enum WeightObjective {
    Unknown = 0,
    FatLoss = 1,
    Maintaining = 2,
    IncreaseMuscleMass = 3,
}

/** Contains the definition of an object of type DoctorConsultSiinInfos. */
export class DoctorConsultSiinInfos implements IDoctorConsultSiinInfos {
    /** Gets or sets the email. */
    email?: string | undefined;
    /** Gets or sets the phone number. */
    phoneNumber?: string | undefined;
    /** Gets the display name. */
    displayName?: string | undefined;
    /** Gets or sets the firstname. */
    firstname?: string | undefined;
    /** Gets or sets a value indicating whether this instance has diploma. */
    hasDiploma!: boolean;
    /** Gets or sets the identifier. */
    id!: number;
    /** Gets or sets the lastname. */
    lastname?: string | undefined;
    /** Gets or sets the latitude. */
    latitude!: number;
    /** Gets or sets the longitude. */
    longitude!: number;
    /** Gets or sets the moodle identifier. */
    moodleId!: number;
    /** Gets or sets the postal code. */
    postalCode?: string | undefined;
    /** Gets or sets the type of the profession logo. */
    professionLogoType?: string | undefined;
    /** Gets or sets the name of the profession. */
    professionName?: string | undefined;
    /** Gets or sets the profession. */
    professionOther?: string | undefined;
    /** Gets or sets the street. */
    street?: string | undefined;
    /** Gets or sets the street number. */
    streetNumber?: string | undefined;
    /** Gets or sets the URL. */
    url?: string | undefined;
    /** Gets or sets the bic. */
    bic?: string | undefined;
    /** Gets or sets the billing address city. */
    billingAddressCity?: string | undefined;
    /** Gets or sets the billing address country. */
    billingAddressCountry?: string | undefined;
    /** Gets or sets the billing address number. */
    billingAddressNumber?: string | undefined;
    /** Gets or sets the billing address street. */
    billingAddressStreet?: string | undefined;
    /** Gets or sets the billing address zip code. */
    billingAddressZipCode?: string | undefined;
    /** Gets or sets the company. */
    company?: string | undefined;
    /** Gets or sets the iban. */
    iban?: string | undefined;
    /** Gets or sets the vat number. */
    vatnumber?: string | undefined;
    /** Gets or sets the siin diplomas. */
    siinDiplomas?: string[] | undefined;
    /** Gets or sets a value indicating whether [does on site consultation]. */
    doesOnSiteConsultation!: boolean;
    /** Gets or sets a value indicating whether [does remote consultation]. */
    doesRemoteConsultation!: boolean;
    /** Gets or sets the means of payment. */
    meansOfPayments?: DoctorMeansOfPayment[] | undefined;
    /** Gets or sets the medical offices. */
    medicalOffices?: MedicalOffice[] | undefined;
    /** Gets or sets the profil description. */
    profileDescription?: string | undefined;
    /** Gets or sets the profil picture url. */
    profilePictureUrl?: string | undefined;
    /** Gets or sets the refund methods. */
    refundMethods?: DoctorRefundMethod[] | undefined;
    /** Gets or sets the specialization description. */
    specializationDescription?: string | undefined;
    /** Gets or sets the specializations. */
    specializations?: DoctorSpecialization[] | undefined;
    /** Gets or sets the medical specialization. */
    medicalSpecializationId!: number;
    /** Gets or sets the website. */
    website?: string | undefined;
    /** Gets or sets a value indicating whether this instance is health professional. */
    isHealthProfessional!: boolean;
    /** Gets or sets a value indicating whether the doctor has a professional number (inami, adeli, rpps, gln). */
    hasProfessionalNumber!: boolean;
    /** Gets or sets a value indicating whether show doctor prefix. */
    showDoctorPrefix!: boolean;
    /** Gets or sets the first availability. */
    firstAvailability?: FirstAvailability | undefined;

    constructor(data?: IDoctorConsultSiinInfos) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.displayName = _data["displayName"];
            this.firstname = _data["firstname"];
            this.hasDiploma = _data["hasDiploma"];
            this.id = _data["id"];
            this.lastname = _data["lastname"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.moodleId = _data["moodleId"];
            this.postalCode = _data["postalCode"];
            this.professionLogoType = _data["professionLogoType"];
            this.professionName = _data["professionName"];
            this.professionOther = _data["professionOther"];
            this.street = _data["street"];
            this.streetNumber = _data["streetNumber"];
            this.url = _data["url"];
            this.bic = _data["bic"];
            this.billingAddressCity = _data["billingAddressCity"];
            this.billingAddressCountry = _data["billingAddressCountry"];
            this.billingAddressNumber = _data["billingAddressNumber"];
            this.billingAddressStreet = _data["billingAddressStreet"];
            this.billingAddressZipCode = _data["billingAddressZipCode"];
            this.company = _data["company"];
            this.iban = _data["iban"];
            this.vatnumber = _data["vatnumber"];
            if (Array.isArray(_data["siinDiplomas"])) {
                this.siinDiplomas = [] as any;
                for (let item of _data["siinDiplomas"])
                    this.siinDiplomas!.push(item);
            }
            this.doesOnSiteConsultation = _data["doesOnSiteConsultation"];
            this.doesRemoteConsultation = _data["doesRemoteConsultation"];
            if (Array.isArray(_data["meansOfPayments"])) {
                this.meansOfPayments = [] as any;
                for (let item of _data["meansOfPayments"])
                    this.meansOfPayments!.push(DoctorMeansOfPayment.fromJS(item));
            }
            if (Array.isArray(_data["medicalOffices"])) {
                this.medicalOffices = [] as any;
                for (let item of _data["medicalOffices"])
                    this.medicalOffices!.push(MedicalOffice.fromJS(item));
            }
            this.profileDescription = _data["profileDescription"];
            this.profilePictureUrl = _data["profilePictureUrl"];
            if (Array.isArray(_data["refundMethods"])) {
                this.refundMethods = [] as any;
                for (let item of _data["refundMethods"])
                    this.refundMethods!.push(DoctorRefundMethod.fromJS(item));
            }
            this.specializationDescription = _data["specializationDescription"];
            if (Array.isArray(_data["specializations"])) {
                this.specializations = [] as any;
                for (let item of _data["specializations"])
                    this.specializations!.push(DoctorSpecialization.fromJS(item));
            }
            this.medicalSpecializationId = _data["medicalSpecializationId"];
            this.website = _data["website"];
            this.isHealthProfessional = _data["isHealthProfessional"];
            this.hasProfessionalNumber = _data["hasProfessionalNumber"];
            this.showDoctorPrefix = _data["showDoctorPrefix"];
            this.firstAvailability = _data["firstAvailability"] ? FirstAvailability.fromJS(_data["firstAvailability"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DoctorConsultSiinInfos {
        data = typeof data === 'object' ? data : {};
        let result = new DoctorConsultSiinInfos();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["displayName"] = this.displayName;
        data["firstname"] = this.firstname;
        data["hasDiploma"] = this.hasDiploma;
        data["id"] = this.id;
        data["lastname"] = this.lastname;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["moodleId"] = this.moodleId;
        data["postalCode"] = this.postalCode;
        data["professionLogoType"] = this.professionLogoType;
        data["professionName"] = this.professionName;
        data["professionOther"] = this.professionOther;
        data["street"] = this.street;
        data["streetNumber"] = this.streetNumber;
        data["url"] = this.url;
        data["bic"] = this.bic;
        data["billingAddressCity"] = this.billingAddressCity;
        data["billingAddressCountry"] = this.billingAddressCountry;
        data["billingAddressNumber"] = this.billingAddressNumber;
        data["billingAddressStreet"] = this.billingAddressStreet;
        data["billingAddressZipCode"] = this.billingAddressZipCode;
        data["company"] = this.company;
        data["iban"] = this.iban;
        data["vatnumber"] = this.vatnumber;
        if (Array.isArray(this.siinDiplomas)) {
            data["siinDiplomas"] = [];
            for (let item of this.siinDiplomas)
                data["siinDiplomas"].push(item);
        }
        data["doesOnSiteConsultation"] = this.doesOnSiteConsultation;
        data["doesRemoteConsultation"] = this.doesRemoteConsultation;
        if (Array.isArray(this.meansOfPayments)) {
            data["meansOfPayments"] = [];
            for (let item of this.meansOfPayments)
                data["meansOfPayments"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.medicalOffices)) {
            data["medicalOffices"] = [];
            for (let item of this.medicalOffices)
                data["medicalOffices"].push(item ? item.toJSON() : <any>undefined);
        }
        data["profileDescription"] = this.profileDescription;
        data["profilePictureUrl"] = this.profilePictureUrl;
        if (Array.isArray(this.refundMethods)) {
            data["refundMethods"] = [];
            for (let item of this.refundMethods)
                data["refundMethods"].push(item ? item.toJSON() : <any>undefined);
        }
        data["specializationDescription"] = this.specializationDescription;
        if (Array.isArray(this.specializations)) {
            data["specializations"] = [];
            for (let item of this.specializations)
                data["specializations"].push(item ? item.toJSON() : <any>undefined);
        }
        data["medicalSpecializationId"] = this.medicalSpecializationId;
        data["website"] = this.website;
        data["isHealthProfessional"] = this.isHealthProfessional;
        data["hasProfessionalNumber"] = this.hasProfessionalNumber;
        data["showDoctorPrefix"] = this.showDoctorPrefix;
        data["firstAvailability"] = this.firstAvailability ? this.firstAvailability.toJSON() : <any>undefined;
        return data;
    }
}

/** Contains the definition of an object of type DoctorConsultSiinInfos. */
export interface IDoctorConsultSiinInfos {
    /** Gets or sets the email. */
    email?: string | undefined;
    /** Gets or sets the phone number. */
    phoneNumber?: string | undefined;
    /** Gets the display name. */
    displayName?: string | undefined;
    /** Gets or sets the firstname. */
    firstname?: string | undefined;
    /** Gets or sets a value indicating whether this instance has diploma. */
    hasDiploma: boolean;
    /** Gets or sets the identifier. */
    id: number;
    /** Gets or sets the lastname. */
    lastname?: string | undefined;
    /** Gets or sets the latitude. */
    latitude: number;
    /** Gets or sets the longitude. */
    longitude: number;
    /** Gets or sets the moodle identifier. */
    moodleId: number;
    /** Gets or sets the postal code. */
    postalCode?: string | undefined;
    /** Gets or sets the type of the profession logo. */
    professionLogoType?: string | undefined;
    /** Gets or sets the name of the profession. */
    professionName?: string | undefined;
    /** Gets or sets the profession. */
    professionOther?: string | undefined;
    /** Gets or sets the street. */
    street?: string | undefined;
    /** Gets or sets the street number. */
    streetNumber?: string | undefined;
    /** Gets or sets the URL. */
    url?: string | undefined;
    /** Gets or sets the bic. */
    bic?: string | undefined;
    /** Gets or sets the billing address city. */
    billingAddressCity?: string | undefined;
    /** Gets or sets the billing address country. */
    billingAddressCountry?: string | undefined;
    /** Gets or sets the billing address number. */
    billingAddressNumber?: string | undefined;
    /** Gets or sets the billing address street. */
    billingAddressStreet?: string | undefined;
    /** Gets or sets the billing address zip code. */
    billingAddressZipCode?: string | undefined;
    /** Gets or sets the company. */
    company?: string | undefined;
    /** Gets or sets the iban. */
    iban?: string | undefined;
    /** Gets or sets the vat number. */
    vatnumber?: string | undefined;
    /** Gets or sets the siin diplomas. */
    siinDiplomas?: string[] | undefined;
    /** Gets or sets a value indicating whether [does on site consultation]. */
    doesOnSiteConsultation: boolean;
    /** Gets or sets a value indicating whether [does remote consultation]. */
    doesRemoteConsultation: boolean;
    /** Gets or sets the means of payment. */
    meansOfPayments?: DoctorMeansOfPayment[] | undefined;
    /** Gets or sets the medical offices. */
    medicalOffices?: MedicalOffice[] | undefined;
    /** Gets or sets the profil description. */
    profileDescription?: string | undefined;
    /** Gets or sets the profil picture url. */
    profilePictureUrl?: string | undefined;
    /** Gets or sets the refund methods. */
    refundMethods?: DoctorRefundMethod[] | undefined;
    /** Gets or sets the specialization description. */
    specializationDescription?: string | undefined;
    /** Gets or sets the specializations. */
    specializations?: DoctorSpecialization[] | undefined;
    /** Gets or sets the medical specialization. */
    medicalSpecializationId: number;
    /** Gets or sets the website. */
    website?: string | undefined;
    /** Gets or sets a value indicating whether this instance is health professional. */
    isHealthProfessional: boolean;
    /** Gets or sets a value indicating whether the doctor has a professional number (inami, adeli, rpps, gln). */
    hasProfessionalNumber: boolean;
    /** Gets or sets a value indicating whether show doctor prefix. */
    showDoctorPrefix: boolean;
    /** Gets or sets the first availability. */
    firstAvailability?: FirstAvailability | undefined;
}

/** Contains the definition of an object of type DoctorMeansOfPayment */
export class DoctorMeansOfPayment implements IDoctorMeansOfPayment {
    /** Gets or sets the doctor identifier. */
    doctorId!: number;
    /** Gets or sets the means of payment. */
    meansOfPaymentId!: number;

    constructor(data?: IDoctorMeansOfPayment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.doctorId = _data["doctorId"];
            this.meansOfPaymentId = _data["meansOfPaymentId"];
        }
    }

    static fromJS(data: any): DoctorMeansOfPayment {
        data = typeof data === 'object' ? data : {};
        let result = new DoctorMeansOfPayment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["doctorId"] = this.doctorId;
        data["meansOfPaymentId"] = this.meansOfPaymentId;
        return data;
    }
}

/** Contains the definition of an object of type DoctorMeansOfPayment */
export interface IDoctorMeansOfPayment {
    /** Gets or sets the doctor identifier. */
    doctorId: number;
    /** Gets or sets the means of payment. */
    meansOfPaymentId: number;
}

/** Contains the definition of an object of type MedicalOffice. */
export class MedicalOffice implements IMedicalOffice {
    /** Gets or sets the city. */
    city?: string | undefined;
    /** Gets or sets the country. */
    country?: string | undefined;
    /** Gets or sets the doctor identifier. */
    doctorId!: number;
    /** Gets or sets the identifier. */
    id!: number;
    /** Gets or sets a value indicating whether gets or sets the isActive value. */
    isActive!: boolean;
    /** Gets or sets the latitude. */
    latitude!: number;
    /** Gets or sets the longitude. */
    longitude!: number;
    /** Gets or sets a value indicating whether the medical office is the main business address. */
    mainBusinessAddress!: boolean;
    /** Gets or sets the name. */
    name?: string | undefined;
    /** Gets or sets the number. */
    number?: string | undefined;
    /** Gets or sets the street. */
    street?: string | undefined;
    /** Gets or sets the zip code. */
    zipCode?: string | undefined;

    constructor(data?: IMedicalOffice) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.city = _data["city"];
            this.country = _data["country"];
            this.doctorId = _data["doctorId"];
            this.id = _data["id"];
            this.isActive = _data["isActive"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.mainBusinessAddress = _data["mainBusinessAddress"];
            this.name = _data["name"];
            this.number = _data["number"];
            this.street = _data["street"];
            this.zipCode = _data["zipCode"];
        }
    }

    static fromJS(data: any): MedicalOffice {
        data = typeof data === 'object' ? data : {};
        let result = new MedicalOffice();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["city"] = this.city;
        data["country"] = this.country;
        data["doctorId"] = this.doctorId;
        data["id"] = this.id;
        data["isActive"] = this.isActive;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["mainBusinessAddress"] = this.mainBusinessAddress;
        data["name"] = this.name;
        data["number"] = this.number;
        data["street"] = this.street;
        data["zipCode"] = this.zipCode;
        return data;
    }
}

/** Contains the definition of an object of type MedicalOffice. */
export interface IMedicalOffice {
    /** Gets or sets the city. */
    city?: string | undefined;
    /** Gets or sets the country. */
    country?: string | undefined;
    /** Gets or sets the doctor identifier. */
    doctorId: number;
    /** Gets or sets the identifier. */
    id: number;
    /** Gets or sets a value indicating whether gets or sets the isActive value. */
    isActive: boolean;
    /** Gets or sets the latitude. */
    latitude: number;
    /** Gets or sets the longitude. */
    longitude: number;
    /** Gets or sets a value indicating whether the medical office is the main business address. */
    mainBusinessAddress: boolean;
    /** Gets or sets the name. */
    name?: string | undefined;
    /** Gets or sets the number. */
    number?: string | undefined;
    /** Gets or sets the street. */
    street?: string | undefined;
    /** Gets or sets the zip code. */
    zipCode?: string | undefined;
}

/** Contains the definition of an object of type DoctorRefundMethod */
export class DoctorRefundMethod implements IDoctorRefundMethod {
    /** Gets or sets the doctor identifier. */
    doctorId!: number;
    /** Gets or sets the refund method. */
    refundMethodId!: number;

    constructor(data?: IDoctorRefundMethod) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.doctorId = _data["doctorId"];
            this.refundMethodId = _data["refundMethodId"];
        }
    }

    static fromJS(data: any): DoctorRefundMethod {
        data = typeof data === 'object' ? data : {};
        let result = new DoctorRefundMethod();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["doctorId"] = this.doctorId;
        data["refundMethodId"] = this.refundMethodId;
        return data;
    }
}

/** Contains the definition of an object of type DoctorRefundMethod */
export interface IDoctorRefundMethod {
    /** Gets or sets the doctor identifier. */
    doctorId: number;
    /** Gets or sets the refund method. */
    refundMethodId: number;
}

/** Contains the defintion of an object of type DoctorSpecialization */
export class DoctorSpecialization implements IDoctorSpecialization {
    /** Gets or sets the doctor identifier. */
    doctorId!: number;
    /** Gets or sets the medical specialization. */
    medicalSpecializationId!: number;
    /** Gets or sets the medical specialization label. */
    medicalSpecializationLabel?: string | undefined;

    constructor(data?: IDoctorSpecialization) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.doctorId = _data["doctorId"];
            this.medicalSpecializationId = _data["medicalSpecializationId"];
            this.medicalSpecializationLabel = _data["medicalSpecializationLabel"];
        }
    }

    static fromJS(data: any): DoctorSpecialization {
        data = typeof data === 'object' ? data : {};
        let result = new DoctorSpecialization();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["doctorId"] = this.doctorId;
        data["medicalSpecializationId"] = this.medicalSpecializationId;
        data["medicalSpecializationLabel"] = this.medicalSpecializationLabel;
        return data;
    }
}

/** Contains the defintion of an object of type DoctorSpecialization */
export interface IDoctorSpecialization {
    /** Gets or sets the doctor identifier. */
    doctorId: number;
    /** Gets or sets the medical specialization. */
    medicalSpecializationId: number;
    /** Gets or sets the medical specialization label. */
    medicalSpecializationLabel?: string | undefined;
}

/** Contains the definition of an object of type FirstAvailability. */
export class FirstAvailability implements IFirstAvailability {
    /** Gets or sets the first date on site. */
    firstDayOnSite?: Date | undefined;
    /** Gets or sets the first date on remote. */
    firstDayOnRemote?: Date | undefined;

    constructor(data?: IFirstAvailability) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstDayOnSite = _data["firstDayOnSite"] ? new Date(_data["firstDayOnSite"].toString()) : <any>undefined;
            this.firstDayOnRemote = _data["firstDayOnRemote"] ? new Date(_data["firstDayOnRemote"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): FirstAvailability {
        data = typeof data === 'object' ? data : {};
        let result = new FirstAvailability();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstDayOnSite"] = this.firstDayOnSite ? this.firstDayOnSite.toISOString() : <any>undefined;
        data["firstDayOnRemote"] = this.firstDayOnRemote ? this.firstDayOnRemote.toISOString() : <any>undefined;
        return data;
    }
}

/** Contains the definition of an object of type FirstAvailability. */
export interface IFirstAvailability {
    /** Gets or sets the first date on site. */
    firstDayOnSite?: Date | undefined;
    /** Gets or sets the first date on remote. */
    firstDayOnRemote?: Date | undefined;
}

/** Contains the definition of an object of type DoctorPatientsSearchParams. */
export class DoctorPatientsSearchParams implements IDoctorPatientsSearchParams {
    /** Gets or sets the doctor patient name. */
    name?: string | undefined;
    /** Gets or sets the doctor patient page. */
    page?: number | undefined;
    /** Gets or sets the relative patient identifier. */
    responsiblePatientId?: number | undefined;
    /** Gets or sets a value indicating whether to get the patients for the Biody import. */
    forBiodyImport!: boolean;
    /** Gets or sets a value indicating whether to get the archived patients. */
    archived!: boolean;

    constructor(data?: IDoctorPatientsSearchParams) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.page = _data["page"];
            this.responsiblePatientId = _data["responsiblePatientId"];
            this.forBiodyImport = _data["forBiodyImport"];
            this.archived = _data["archived"];
        }
    }

    static fromJS(data: any): DoctorPatientsSearchParams {
        data = typeof data === 'object' ? data : {};
        let result = new DoctorPatientsSearchParams();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["page"] = this.page;
        data["responsiblePatientId"] = this.responsiblePatientId;
        data["forBiodyImport"] = this.forBiodyImport;
        data["archived"] = this.archived;
        return data;
    }
}

/** Contains the definition of an object of type DoctorPatientsSearchParams. */
export interface IDoctorPatientsSearchParams {
    /** Gets or sets the doctor patient name. */
    name?: string | undefined;
    /** Gets or sets the doctor patient page. */
    page?: number | undefined;
    /** Gets or sets the relative patient identifier. */
    responsiblePatientId?: number | undefined;
    /** Gets or sets a value indicating whether to get the patients for the Biody import. */
    forBiodyImport: boolean;
    /** Gets or sets a value indicating whether to get the archived patients. */
    archived: boolean;
}

/** Contains the definition of an object of type DoctorAppointmentConfiguration. */
export class DoctorAppointmentConfiguration implements IDoctorAppointmentConfiguration {
    /** Gets or sets a value indicating whether [automatic confirmation]. */
    autoConfirmation!: boolean;
    /** Gets or sets a value indicating whether [agenda enabled]. */
    agendaEnabled!: boolean;
    /** Gets or sets a value indicating whether [profil enabled]. */
    profilEnabled!: boolean;
    /** Gets or sets a value indicating whether [does remote consultation]. */
    doesRemoteConsultation!: boolean;
    /** Gets or sets a value indicating whether [does online booking]. */
    doesOnSiteConsultation!: boolean;
    /** Gets or sets the time limit in hours. */
    consultationCancellationTimeLimit!: SettingTimeCancellation;
    /** Gets or sets the consultation acceptation time limit. */
    consultationAcceptationTimeLimit!: SettingTimeAcceptation;
    /** Gets or sets a value indicating whether [auto suggestion is preselected]. */
    isPreSelectedAutoSuggestActive!: boolean;
    /** Gets or sets a value indicating whether [consultation configuration formularies is sent to patient]. */
    isConsultationConfigFormulariesSentToPatientActive!: boolean;
    /** Gets or sets the doctor mail settings. */
    doctorMailsToSend?: DoctorMailsToSend[] | undefined;
    /** Gets or sets a value indicating whether the practitioner allows the waiting list. */
    allowsWaitingList!: boolean;

    constructor(data?: IDoctorAppointmentConfiguration) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.autoConfirmation = _data["autoConfirmation"];
            this.agendaEnabled = _data["agendaEnabled"];
            this.profilEnabled = _data["profilEnabled"];
            this.doesRemoteConsultation = _data["doesRemoteConsultation"];
            this.doesOnSiteConsultation = _data["doesOnSiteConsultation"];
            this.consultationCancellationTimeLimit = _data["consultationCancellationTimeLimit"];
            this.consultationAcceptationTimeLimit = _data["consultationAcceptationTimeLimit"];
            this.isPreSelectedAutoSuggestActive = _data["isPreSelectedAutoSuggestActive"];
            this.isConsultationConfigFormulariesSentToPatientActive = _data["isConsultationConfigFormulariesSentToPatientActive"];
            if (Array.isArray(_data["DoctorMailsToSend"])) {
                this.doctorMailsToSend = [] as any;
                for (let item of _data["DoctorMailsToSend"])
                    this.doctorMailsToSend!.push(item);
            }
            this.allowsWaitingList = _data["allowsWaitingList"];
        }
    }

    static fromJS(data: any): DoctorAppointmentConfiguration {
        data = typeof data === 'object' ? data : {};
        let result = new DoctorAppointmentConfiguration();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["autoConfirmation"] = this.autoConfirmation;
        data["agendaEnabled"] = this.agendaEnabled;
        data["profilEnabled"] = this.profilEnabled;
        data["doesRemoteConsultation"] = this.doesRemoteConsultation;
        data["doesOnSiteConsultation"] = this.doesOnSiteConsultation;
        data["consultationCancellationTimeLimit"] = this.consultationCancellationTimeLimit;
        data["consultationAcceptationTimeLimit"] = this.consultationAcceptationTimeLimit;
        data["isPreSelectedAutoSuggestActive"] = this.isPreSelectedAutoSuggestActive;
        data["isConsultationConfigFormulariesSentToPatientActive"] = this.isConsultationConfigFormulariesSentToPatientActive;
        if (Array.isArray(this.doctorMailsToSend)) {
            data["DoctorMailsToSend"] = [];
            for (let item of this.doctorMailsToSend)
                data["DoctorMailsToSend"].push(item);
        }
        data["allowsWaitingList"] = this.allowsWaitingList;
        return data;
    }
}

/** Contains the definition of an object of type DoctorAppointmentConfiguration. */
export interface IDoctorAppointmentConfiguration {
    /** Gets or sets a value indicating whether [automatic confirmation]. */
    autoConfirmation: boolean;
    /** Gets or sets a value indicating whether [agenda enabled]. */
    agendaEnabled: boolean;
    /** Gets or sets a value indicating whether [profil enabled]. */
    profilEnabled: boolean;
    /** Gets or sets a value indicating whether [does remote consultation]. */
    doesRemoteConsultation: boolean;
    /** Gets or sets a value indicating whether [does online booking]. */
    doesOnSiteConsultation: boolean;
    /** Gets or sets the time limit in hours. */
    consultationCancellationTimeLimit: SettingTimeCancellation;
    /** Gets or sets the consultation acceptation time limit. */
    consultationAcceptationTimeLimit: SettingTimeAcceptation;
    /** Gets or sets a value indicating whether [auto suggestion is preselected]. */
    isPreSelectedAutoSuggestActive: boolean;
    /** Gets or sets a value indicating whether [consultation configuration formularies is sent to patient]. */
    isConsultationConfigFormulariesSentToPatientActive: boolean;
    /** Gets or sets the doctor mail settings. */
    doctorMailsToSend?: DoctorMailsToSend[] | undefined;
    /** Gets or sets a value indicating whether the practitioner allows the waiting list. */
    allowsWaitingList: boolean;
}

/** Contains the definition of an object of type consultationCancellationTimeLimit. ATTENTION en cas de modifications : certaines clés de dictionnaires Umbraco sont directement liées aux noms de l'enum ("Site.ConsultSiin.Profile.CancellationTimeLimit."). */
export enum SettingTimeCancellation {
    Unknown = 0,
    Time12h = 1,
    Time24h = 2,
    Time48h = 3,
    Time72h = 4,
    Time1week = 5,
}

/** Contains the definition of an object of type consultationAcceptationTimeLimit */
export enum SettingTimeAcceptation {
    Unknown = 0,
    Time1h = 1,
    Time12h = 2,
    Time24h = 3,
    Time48h = 4,
    Time72h = 5,
    Time1week = 6,
}

/** Contains the definition of an object of type DoctorMailsToSend. */
export enum DoctorMailsToSend {
    Unknown = 0,
    PatientUpcomingAppointmentReminderInFewDays = 1,
    PatientUpcomingAppointmentReminderThisDay = 2,
    PatientUpcomingAppointmentReminderInOneHour = 3,
    PatientFormulariesToFillNotification = 4,
    NewDocumentByDoctorNotification = 5,
}

/** Contains the definition of an object of type DoctorLiteInfo. */
export class DoctorProfile implements IDoctorProfile {
    /** Gets or sets the inami number. */
    inamiNumber?: string | undefined;
    /** Gets or sets the adeli number. */
    adeliNumber?: string | undefined;
    /** Gets or sets the RPPS number. */
    rppsNumber?: string | undefined;
    /** Gets or sets the GLN number. */
    glnNumber?: string | undefined;
    /** Gets or sets the profession. */
    specialityIds?: number[] | undefined;
    /** Gets or sets the nationality. */
    nationality?: string | undefined;
    /** Gets or sets the number. */
    number?: string | undefined;
    /** Gets or sets the email. */
    email?: string | undefined;
    /** Gets or sets the profession. */
    professionId!: number;
    /** Gets or sets the precision profession. */
    precisionProfession?: string | undefined;
    /** Gets or sets the website. */
    website?: string | undefined;
    /** Gets or sets the language. */
    languages?: number[] | undefined;
    /** Gets or sets the doctor consultation types. */
    doctorConsultationTypeIds?: number[] | undefined;
    /** Gets or sets the speciality description. */
    specializationDescription?: string | undefined;
    /** Gets or sets the URL picture. */
    urlPicture?: string | undefined;
    /** Gets or sets the profile image URL. */
    urlSignature?: string | undefined;
    /** Gets or sets the logo image URL. */
    urlLogo?: string | undefined;
    /** Gets or sets the gender. */
    gender?: string | undefined;
    /** Gets or sets the training. */
    training?: string | undefined;
    /** Gets or sets the pricing. */
    pricing?: string | undefined;
    /** Gets or sets the unavailability. */
    unavailability?: string | undefined;
    /** Gets or sets the schedules. */
    schedules?: string | undefined;
    /** Gets or sets the means of transportation. */
    means_of_transportation?: string | undefined;
    /** Gets or sets the practical information. */
    practicalInformation?: string | undefined;
    /** Gets or sets the profile description. */
    profileDescription?: string | undefined;
    /** Gets or sets a value indicating whether to Show Pro Number In mynutriconsult Anuary. */
    showProNumberInAnuary!: boolean;
    /** Gets or sets a value indicating whether to Show phone number In mynutriconsult Anuary. */
    showPhoneNumberInAnuary!: boolean;
    /** Gets or sets a value indicating whether to Show email In mynutriconsult Anuary. */
    showEmailInAnuary!: boolean;
    /** Gets or sets a value indicating whether to show the phone number on the prescriptions. */
    showPhoneNumberOnPrescription!: boolean;
    /** Gets or sets a value indicating whether to show the medical office on the prescriptions. */
    showMedicalOfficeOnPrescription!: boolean;

    constructor(data?: IDoctorProfile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.inamiNumber = _data["inamiNumber"];
            this.adeliNumber = _data["adeliNumber"];
            this.rppsNumber = _data["rppsNumber"];
            this.glnNumber = _data["glnNumber"];
            if (Array.isArray(_data["specialityIds"])) {
                this.specialityIds = [] as any;
                for (let item of _data["specialityIds"])
                    this.specialityIds!.push(item);
            }
            this.nationality = _data["nationality"];
            this.number = _data["number"];
            this.email = _data["email"];
            this.professionId = _data["professionId"];
            this.precisionProfession = _data["precisionProfession"];
            this.website = _data["website"];
            if (Array.isArray(_data["languages"])) {
                this.languages = [] as any;
                for (let item of _data["languages"])
                    this.languages!.push(item);
            }
            if (Array.isArray(_data["doctorConsultationTypeIds"])) {
                this.doctorConsultationTypeIds = [] as any;
                for (let item of _data["doctorConsultationTypeIds"])
                    this.doctorConsultationTypeIds!.push(item);
            }
            this.specializationDescription = _data["specializationDescription"];
            this.urlPicture = _data["urlPicture"];
            this.urlSignature = _data["urlSignature"];
            this.urlLogo = _data["urlLogo"];
            this.gender = _data["gender"];
            this.training = _data["training"];
            this.pricing = _data["pricing"];
            this.unavailability = _data["unavailability"];
            this.schedules = _data["schedules"];
            this.means_of_transportation = _data["means of transportation"];
            this.practicalInformation = _data["practicalInformation"];
            this.profileDescription = _data["profileDescription"];
            this.showProNumberInAnuary = _data["showProNumberInAnuary"];
            this.showPhoneNumberInAnuary = _data["showPhoneNumberInAnuary"];
            this.showEmailInAnuary = _data["showEmailInAnuary"];
            this.showPhoneNumberOnPrescription = _data["showPhoneNumberOnPrescription"];
            this.showMedicalOfficeOnPrescription = _data["showMedicalOfficeOnPrescription"];
        }
    }

    static fromJS(data: any): DoctorProfile {
        data = typeof data === 'object' ? data : {};
        let result = new DoctorProfile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["inamiNumber"] = this.inamiNumber;
        data["adeliNumber"] = this.adeliNumber;
        data["rppsNumber"] = this.rppsNumber;
        data["glnNumber"] = this.glnNumber;
        if (Array.isArray(this.specialityIds)) {
            data["specialityIds"] = [];
            for (let item of this.specialityIds)
                data["specialityIds"].push(item);
        }
        data["nationality"] = this.nationality;
        data["number"] = this.number;
        data["email"] = this.email;
        data["professionId"] = this.professionId;
        data["precisionProfession"] = this.precisionProfession;
        data["website"] = this.website;
        if (Array.isArray(this.languages)) {
            data["languages"] = [];
            for (let item of this.languages)
                data["languages"].push(item);
        }
        if (Array.isArray(this.doctorConsultationTypeIds)) {
            data["doctorConsultationTypeIds"] = [];
            for (let item of this.doctorConsultationTypeIds)
                data["doctorConsultationTypeIds"].push(item);
        }
        data["specializationDescription"] = this.specializationDescription;
        data["urlPicture"] = this.urlPicture;
        data["urlSignature"] = this.urlSignature;
        data["urlLogo"] = this.urlLogo;
        data["gender"] = this.gender;
        data["training"] = this.training;
        data["pricing"] = this.pricing;
        data["unavailability"] = this.unavailability;
        data["schedules"] = this.schedules;
        data["means of transportation"] = this.means_of_transportation;
        data["practicalInformation"] = this.practicalInformation;
        data["profileDescription"] = this.profileDescription;
        data["showProNumberInAnuary"] = this.showProNumberInAnuary;
        data["showPhoneNumberInAnuary"] = this.showPhoneNumberInAnuary;
        data["showEmailInAnuary"] = this.showEmailInAnuary;
        data["showPhoneNumberOnPrescription"] = this.showPhoneNumberOnPrescription;
        data["showMedicalOfficeOnPrescription"] = this.showMedicalOfficeOnPrescription;
        return data;
    }
}

/** Contains the definition of an object of type DoctorLiteInfo. */
export interface IDoctorProfile {
    /** Gets or sets the inami number. */
    inamiNumber?: string | undefined;
    /** Gets or sets the adeli number. */
    adeliNumber?: string | undefined;
    /** Gets or sets the RPPS number. */
    rppsNumber?: string | undefined;
    /** Gets or sets the GLN number. */
    glnNumber?: string | undefined;
    /** Gets or sets the profession. */
    specialityIds?: number[] | undefined;
    /** Gets or sets the nationality. */
    nationality?: string | undefined;
    /** Gets or sets the number. */
    number?: string | undefined;
    /** Gets or sets the email. */
    email?: string | undefined;
    /** Gets or sets the profession. */
    professionId: number;
    /** Gets or sets the precision profession. */
    precisionProfession?: string | undefined;
    /** Gets or sets the website. */
    website?: string | undefined;
    /** Gets or sets the language. */
    languages?: number[] | undefined;
    /** Gets or sets the doctor consultation types. */
    doctorConsultationTypeIds?: number[] | undefined;
    /** Gets or sets the speciality description. */
    specializationDescription?: string | undefined;
    /** Gets or sets the URL picture. */
    urlPicture?: string | undefined;
    /** Gets or sets the profile image URL. */
    urlSignature?: string | undefined;
    /** Gets or sets the logo image URL. */
    urlLogo?: string | undefined;
    /** Gets or sets the gender. */
    gender?: string | undefined;
    /** Gets or sets the training. */
    training?: string | undefined;
    /** Gets or sets the pricing. */
    pricing?: string | undefined;
    /** Gets or sets the unavailability. */
    unavailability?: string | undefined;
    /** Gets or sets the schedules. */
    schedules?: string | undefined;
    /** Gets or sets the means of transportation. */
    means_of_transportation?: string | undefined;
    /** Gets or sets the practical information. */
    practicalInformation?: string | undefined;
    /** Gets or sets the profile description. */
    profileDescription?: string | undefined;
    /** Gets or sets a value indicating whether to Show Pro Number In mynutriconsult Anuary. */
    showProNumberInAnuary: boolean;
    /** Gets or sets a value indicating whether to Show phone number In mynutriconsult Anuary. */
    showPhoneNumberInAnuary: boolean;
    /** Gets or sets a value indicating whether to Show email In mynutriconsult Anuary. */
    showEmailInAnuary: boolean;
    /** Gets or sets a value indicating whether to show the phone number on the prescriptions. */
    showPhoneNumberOnPrescription: boolean;
    /** Gets or sets a value indicating whether to show the medical office on the prescriptions. */
    showMedicalOfficeOnPrescription: boolean;
}

/** Contains the definition of an object of type DoctorDirectorySearchParams. */
export class DoctorDirectorySearchParams extends SearchParams implements IDoctorDirectorySearchParams {
    /** Gets or sets the language. */
    language?: number | undefined;
    /** Gets or sets the location. */
    location?: string | undefined;
    /** Gets or sets the consultation reason identifier. */
    consultationReasonId?: number | undefined;
    /** Gets or sets a value indicating whether does remote consultation. */
    doesRemoteConsultation!: boolean;
    /** Gets or sets the availabilities. */
    availabilities!: DoctorDirectoryAvailability;
    /** Gets or sets the radius. */
    radius?: number | undefined;
    /** Gets or sets a value indicating whether the result is for the map. */
    forMap!: boolean;
    /** Gets or sets the consultation type identifier. */
    consultationTypeId?: number | undefined;
    /** Gets or sets the doctor name to find. */
    doctorName?: string | undefined;

    constructor(data?: IDoctorDirectorySearchParams) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.language = _data["language"];
            this.location = _data["location"];
            this.consultationReasonId = _data["consultationReasonId"];
            this.doesRemoteConsultation = _data["doesRemoteConsultation"];
            this.availabilities = _data["availabilities"];
            this.radius = _data["radius"];
            this.forMap = _data["forMap"];
            this.consultationTypeId = _data["consultationTypeId"];
            this.doctorName = _data["doctorName"];
        }
    }

    static override fromJS(data: any): DoctorDirectorySearchParams {
        data = typeof data === 'object' ? data : {};
        let result = new DoctorDirectorySearchParams();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["language"] = this.language;
        data["location"] = this.location;
        data["consultationReasonId"] = this.consultationReasonId;
        data["doesRemoteConsultation"] = this.doesRemoteConsultation;
        data["availabilities"] = this.availabilities;
        data["radius"] = this.radius;
        data["forMap"] = this.forMap;
        data["consultationTypeId"] = this.consultationTypeId;
        data["doctorName"] = this.doctorName;
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type DoctorDirectorySearchParams. */
export interface IDoctorDirectorySearchParams extends ISearchParams {
    /** Gets or sets the language. */
    language?: number | undefined;
    /** Gets or sets the location. */
    location?: string | undefined;
    /** Gets or sets the consultation reason identifier. */
    consultationReasonId?: number | undefined;
    /** Gets or sets a value indicating whether does remote consultation. */
    doesRemoteConsultation: boolean;
    /** Gets or sets the availabilities. */
    availabilities: DoctorDirectoryAvailability;
    /** Gets or sets the radius. */
    radius?: number | undefined;
    /** Gets or sets a value indicating whether the result is for the map. */
    forMap: boolean;
    /** Gets or sets the consultation type identifier. */
    consultationTypeId?: number | undefined;
    /** Gets or sets the doctor name to find. */
    doctorName?: string | undefined;
}

/** Contains the definition of an object of type DoctorDirectoryAvailability. */
export enum DoctorDirectoryAvailability {
    Unknown = 0,
    AvToday = 1,
    Av3Days = 2,
    Av1Week = 3,
    Av1Month = 4,
}

/** Contains the definition of an object of type GeocodeAddressDropdown. */
export class GeocodeAddressDropdown implements IGeocodeAddressDropdown {
    /** Gets or sets the entityType. */
    entityType?: string | undefined;
    /** Gets or sets the municipality. */
    municipality?: string | undefined;
    /** Gets or sets the municipality subdivision. */
    municipalitySubdivision?: string | undefined;
    /** Gets or sets the Country. */
    country?: string | undefined;
    /** Gets or sets the country Code ISO3. */
    countryCodeISO3?: string | undefined;
    /** Gets or sets the country subdivision. */
    countrySubdivision?: string | undefined;
    /** Gets or sets the country secondary subdivision. */
    countrySecondarySubdivision?: string | undefined;
    /** Gets or sets the full address. */
    fullAddress?: string | undefined;

    constructor(data?: IGeocodeAddressDropdown) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.entityType = _data["entityType"];
            this.municipality = _data["municipality"];
            this.municipalitySubdivision = _data["municipalitySubdivision"];
            this.country = _data["country"];
            this.countryCodeISO3 = _data["countryCodeISO3"];
            this.countrySubdivision = _data["countrySubdivision"];
            this.countrySecondarySubdivision = _data["countrySecondarySubdivision"];
            this.fullAddress = _data["fullAddress"];
        }
    }

    static fromJS(data: any): GeocodeAddressDropdown {
        data = typeof data === 'object' ? data : {};
        let result = new GeocodeAddressDropdown();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityType"] = this.entityType;
        data["municipality"] = this.municipality;
        data["municipalitySubdivision"] = this.municipalitySubdivision;
        data["country"] = this.country;
        data["countryCodeISO3"] = this.countryCodeISO3;
        data["countrySubdivision"] = this.countrySubdivision;
        data["countrySecondarySubdivision"] = this.countrySecondarySubdivision;
        data["fullAddress"] = this.fullAddress;
        return data;
    }
}

/** Contains the definition of an object of type GeocodeAddressDropdown. */
export interface IGeocodeAddressDropdown {
    /** Gets or sets the entityType. */
    entityType?: string | undefined;
    /** Gets or sets the municipality. */
    municipality?: string | undefined;
    /** Gets or sets the municipality subdivision. */
    municipalitySubdivision?: string | undefined;
    /** Gets or sets the Country. */
    country?: string | undefined;
    /** Gets or sets the country Code ISO3. */
    countryCodeISO3?: string | undefined;
    /** Gets or sets the country subdivision. */
    countrySubdivision?: string | undefined;
    /** Gets or sets the country secondary subdivision. */
    countrySecondarySubdivision?: string | undefined;
    /** Gets or sets the full address. */
    fullAddress?: string | undefined;
}

/** Contains the definition of an object of type UpdateDoctorProfile. */
export class UpdateDoctorProfile implements IUpdateDoctorProfile {
    /** Gets or sets the identifier. */
    id!: number;
    /** Gets or sets the inami number. */
    inamiNumber?: string | undefined;
    /** Gets or sets the adeli number. */
    adeliNumber?: string | undefined;
    /** Gets or sets the RPPS number. */
    rppsNumber?: string | undefined;
    /** Gets or sets the GLN number. */
    glnNumber?: string | undefined;
    /** Gets or sets the profession. */
    professionId!: number;
    /** Gets or sets the precision profession. */
    precisionProfession?: string | undefined;
    /** Gets or sets the speciality. */
    specialityIds?: number[] | undefined;
    /** Gets or sets the nationality. */
    nationality?: string | undefined;
    /** Gets or sets the number. */
    phoneNumber?: string | undefined;
    /** Gets or sets the email. */
    email?: string | undefined;
    /** Gets or sets the website. */
    website?: string | undefined;
    /** Gets or sets the language. */
    languageIds?: number[] | undefined;
    /** Gets or sets the doctor consultation types. */
    consultationTypeIds?: number[] | undefined;
    /** Gets or sets the speciality description. */
    specializationDescription?: string | undefined;
    /** Gets or sets the training. */
    training?: string | undefined;
    /** Gets or sets the pricing. */
    pricing?: string | undefined;
    /** Gets or sets the unavailability. */
    unavailability?: string | undefined;
    /** Gets or sets the schedules. */
    schedules?: string | undefined;
    /** Gets or sets the means of transportation. */
    means_of_transportation?: string | undefined;
    /** Gets or sets the practical information. */
    practicalInformation?: string | undefined;
    /** Gets or sets the profile description. */
    profileDescription?: string | undefined;
    /** Gets or sets a value indicating whether to Show Pro Number In mynutriconsult Anuary. */
    showProNumberInAnuary!: boolean;
    /** Gets or sets a value indicating whether to Show phone number In mynutriconsult Anuary. */
    showPhoneNumberInAnuary!: boolean;
    /** Gets or sets a value indicating whether to Show email In mynutriconsult Anuary. */
    showEmailInAnuary!: boolean;
    /** Gets or sets a value indicating whether to show the phone number on the prescriptions. */
    showPhoneNumberOnPrescription!: boolean;
    /** Gets or sets a value indicating whether to show the medical office on the prescriptions. */
    showMedicalOfficeOnPrescription!: boolean;

    constructor(data?: IUpdateDoctorProfile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.inamiNumber = _data["inamiNumber"];
            this.adeliNumber = _data["adeliNumber"];
            this.rppsNumber = _data["rppsNumber"];
            this.glnNumber = _data["glnNumber"];
            this.professionId = _data["professionId"];
            this.precisionProfession = _data["precisionProfession"];
            if (Array.isArray(_data["specialityIds"])) {
                this.specialityIds = [] as any;
                for (let item of _data["specialityIds"])
                    this.specialityIds!.push(item);
            }
            this.nationality = _data["nationality"];
            this.phoneNumber = _data["phoneNumber"];
            this.email = _data["email"];
            this.website = _data["website"];
            if (Array.isArray(_data["languageIds"])) {
                this.languageIds = [] as any;
                for (let item of _data["languageIds"])
                    this.languageIds!.push(item);
            }
            if (Array.isArray(_data["consultationTypeIds"])) {
                this.consultationTypeIds = [] as any;
                for (let item of _data["consultationTypeIds"])
                    this.consultationTypeIds!.push(item);
            }
            this.specializationDescription = _data["specializationDescription"];
            this.training = _data["training"];
            this.pricing = _data["pricing"];
            this.unavailability = _data["unavailability"];
            this.schedules = _data["schedules"];
            this.means_of_transportation = _data["means of transportation"];
            this.practicalInformation = _data["practicalInformation"];
            this.profileDescription = _data["profileDescription"];
            this.showProNumberInAnuary = _data["showProNumberInAnuary"];
            this.showPhoneNumberInAnuary = _data["showPhoneNumberInAnuary"];
            this.showEmailInAnuary = _data["showEmailInAnuary"];
            this.showPhoneNumberOnPrescription = _data["showPhoneNumberOnPrescription"];
            this.showMedicalOfficeOnPrescription = _data["showMedicalOfficeOnPrescription"];
        }
    }

    static fromJS(data: any): UpdateDoctorProfile {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDoctorProfile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["inamiNumber"] = this.inamiNumber;
        data["adeliNumber"] = this.adeliNumber;
        data["rppsNumber"] = this.rppsNumber;
        data["glnNumber"] = this.glnNumber;
        data["professionId"] = this.professionId;
        data["precisionProfession"] = this.precisionProfession;
        if (Array.isArray(this.specialityIds)) {
            data["specialityIds"] = [];
            for (let item of this.specialityIds)
                data["specialityIds"].push(item);
        }
        data["nationality"] = this.nationality;
        data["phoneNumber"] = this.phoneNumber;
        data["email"] = this.email;
        data["website"] = this.website;
        if (Array.isArray(this.languageIds)) {
            data["languageIds"] = [];
            for (let item of this.languageIds)
                data["languageIds"].push(item);
        }
        if (Array.isArray(this.consultationTypeIds)) {
            data["consultationTypeIds"] = [];
            for (let item of this.consultationTypeIds)
                data["consultationTypeIds"].push(item);
        }
        data["specializationDescription"] = this.specializationDescription;
        data["training"] = this.training;
        data["pricing"] = this.pricing;
        data["unavailability"] = this.unavailability;
        data["schedules"] = this.schedules;
        data["means of transportation"] = this.means_of_transportation;
        data["practicalInformation"] = this.practicalInformation;
        data["profileDescription"] = this.profileDescription;
        data["showProNumberInAnuary"] = this.showProNumberInAnuary;
        data["showPhoneNumberInAnuary"] = this.showPhoneNumberInAnuary;
        data["showEmailInAnuary"] = this.showEmailInAnuary;
        data["showPhoneNumberOnPrescription"] = this.showPhoneNumberOnPrescription;
        data["showMedicalOfficeOnPrescription"] = this.showMedicalOfficeOnPrescription;
        return data;
    }
}

/** Contains the definition of an object of type UpdateDoctorProfile. */
export interface IUpdateDoctorProfile {
    /** Gets or sets the identifier. */
    id: number;
    /** Gets or sets the inami number. */
    inamiNumber?: string | undefined;
    /** Gets or sets the adeli number. */
    adeliNumber?: string | undefined;
    /** Gets or sets the RPPS number. */
    rppsNumber?: string | undefined;
    /** Gets or sets the GLN number. */
    glnNumber?: string | undefined;
    /** Gets or sets the profession. */
    professionId: number;
    /** Gets or sets the precision profession. */
    precisionProfession?: string | undefined;
    /** Gets or sets the speciality. */
    specialityIds?: number[] | undefined;
    /** Gets or sets the nationality. */
    nationality?: string | undefined;
    /** Gets or sets the number. */
    phoneNumber?: string | undefined;
    /** Gets or sets the email. */
    email?: string | undefined;
    /** Gets or sets the website. */
    website?: string | undefined;
    /** Gets or sets the language. */
    languageIds?: number[] | undefined;
    /** Gets or sets the doctor consultation types. */
    consultationTypeIds?: number[] | undefined;
    /** Gets or sets the speciality description. */
    specializationDescription?: string | undefined;
    /** Gets or sets the training. */
    training?: string | undefined;
    /** Gets or sets the pricing. */
    pricing?: string | undefined;
    /** Gets or sets the unavailability. */
    unavailability?: string | undefined;
    /** Gets or sets the schedules. */
    schedules?: string | undefined;
    /** Gets or sets the means of transportation. */
    means_of_transportation?: string | undefined;
    /** Gets or sets the practical information. */
    practicalInformation?: string | undefined;
    /** Gets or sets the profile description. */
    profileDescription?: string | undefined;
    /** Gets or sets a value indicating whether to Show Pro Number In mynutriconsult Anuary. */
    showProNumberInAnuary: boolean;
    /** Gets or sets a value indicating whether to Show phone number In mynutriconsult Anuary. */
    showPhoneNumberInAnuary: boolean;
    /** Gets or sets a value indicating whether to Show email In mynutriconsult Anuary. */
    showEmailInAnuary: boolean;
    /** Gets or sets a value indicating whether to show the phone number on the prescriptions. */
    showPhoneNumberOnPrescription: boolean;
    /** Gets or sets a value indicating whether to show the medical office on the prescriptions. */
    showMedicalOfficeOnPrescription: boolean;
}

/** Contains the definition of an object of type UpdateDoctorSubUser. */
export class UpdateDoctorSubUser implements IUpdateDoctorSubUser {
    /** Gets or sets the identifier. */
    id!: number;
    /** Gets or sets the nom. */
    lastName?: string | undefined;
    /** Gets or sets the prenom. */
    firstName?: string | undefined;
    /** Gets or sets the email. */
    email?: string | undefined;
    /** Gets or sets a value indicating whether this instance is active. */
    isActive!: boolean;
    /** Gets or sets the sub role. */
    subRole!: DoctorSubUserSubRole;

    constructor(data?: IUpdateDoctorSubUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.lastName = _data["lastName"];
            this.firstName = _data["firstName"];
            this.email = _data["email"];
            this.isActive = _data["isActive"];
            this.subRole = _data["subRole"];
        }
    }

    static fromJS(data: any): UpdateDoctorSubUser {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDoctorSubUser();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["lastName"] = this.lastName;
        data["firstName"] = this.firstName;
        data["email"] = this.email;
        data["isActive"] = this.isActive;
        data["subRole"] = this.subRole;
        return data;
    }
}

/** Contains the definition of an object of type UpdateDoctorSubUser. */
export interface IUpdateDoctorSubUser {
    /** Gets or sets the identifier. */
    id: number;
    /** Gets or sets the nom. */
    lastName?: string | undefined;
    /** Gets or sets the prenom. */
    firstName?: string | undefined;
    /** Gets or sets the email. */
    email?: string | undefined;
    /** Gets or sets a value indicating whether this instance is active. */
    isActive: boolean;
    /** Gets or sets the sub role. */
    subRole: DoctorSubUserSubRole;
}

/** Contains the definition of an object of type UpdateMedicalOffice. */
export class UpdateMedicalOffice extends BaseEditMedicalOffice implements IUpdateMedicalOffice {
    /** Gets or sets the identifier. */
    id!: number;

    constructor(data?: IUpdateMedicalOffice) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
        }
    }

    static override fromJS(data: any): UpdateMedicalOffice {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMedicalOffice();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type UpdateMedicalOffice. */
export interface IUpdateMedicalOffice extends IBaseEditMedicalOffice {
    /** Gets or sets the identifier. */
    id: number;
}

/** Contains the definition of an object of type DoctorInvoiceSettingsInfos. */
export class DoctorInvoiceSettingsInfos implements IDoctorInvoiceSettingsInfos {
    /** Gets or sets the email. */
    email?: string | undefined;
    /** Gets or sets the free text to be shown in the invoice footer. */
    footerText?: string | undefined;
    /** Gets or sets a value indicating whether the invoice feature is enabled. */
    isEnabled!: boolean;
    /** Gets or sets a value indicating whether invoices are sent automatically. */
    isAutoSendEnabled!: boolean;
    /** Gets or sets a value indicating whether VAT is enabled. */
    isVATEnabled!: boolean;
    /** Gets or sets the billing location name. */
    location?: string | undefined;
    /** Gets or sets the phone number associated with the invoice. */
    phoneNumber?: string | undefined;
    /** Gets or sets the applicable VAT rate. */
    vATRate?: number | undefined;
    /** Gets or sets the legal text to be displayed on the invoice. */
    legalText?: string | undefined;
    /** Gets or sets the prefix to be shown on the invoice. */
    prefix?: string | undefined;
    /** Gets or sets the suffix to be shown on the invoice. */
    suffix?: string | undefined;
    /** Gets or sets a value indicating whether the invoices can be synchronized. */
    canSynchronize!: boolean;
    /** Gets or sets a value indicating whether the signature should be included on the invoice. */
    includeSignature!: boolean;

    constructor(data?: IDoctorInvoiceSettingsInfos) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.footerText = _data["footerText"];
            this.isEnabled = _data["isEnabled"];
            this.isAutoSendEnabled = _data["isAutoSendEnabled"];
            this.isVATEnabled = _data["isVATEnabled"];
            this.location = _data["location"];
            this.phoneNumber = _data["phoneNumber"];
            this.vATRate = _data["vATRate"];
            this.legalText = _data["legalText"];
            this.prefix = _data["prefix"];
            this.suffix = _data["suffix"];
            this.canSynchronize = _data["canSynchronize"];
            this.includeSignature = _data["includeSignature"];
        }
    }

    static fromJS(data: any): DoctorInvoiceSettingsInfos {
        data = typeof data === 'object' ? data : {};
        let result = new DoctorInvoiceSettingsInfos();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["footerText"] = this.footerText;
        data["isEnabled"] = this.isEnabled;
        data["isAutoSendEnabled"] = this.isAutoSendEnabled;
        data["isVATEnabled"] = this.isVATEnabled;
        data["location"] = this.location;
        data["phoneNumber"] = this.phoneNumber;
        data["vATRate"] = this.vATRate;
        data["legalText"] = this.legalText;
        data["prefix"] = this.prefix;
        data["suffix"] = this.suffix;
        data["canSynchronize"] = this.canSynchronize;
        data["includeSignature"] = this.includeSignature;
        return data;
    }
}

/** Contains the definition of an object of type DoctorInvoiceSettingsInfos. */
export interface IDoctorInvoiceSettingsInfos {
    /** Gets or sets the email. */
    email?: string | undefined;
    /** Gets or sets the free text to be shown in the invoice footer. */
    footerText?: string | undefined;
    /** Gets or sets a value indicating whether the invoice feature is enabled. */
    isEnabled: boolean;
    /** Gets or sets a value indicating whether invoices are sent automatically. */
    isAutoSendEnabled: boolean;
    /** Gets or sets a value indicating whether VAT is enabled. */
    isVATEnabled: boolean;
    /** Gets or sets the billing location name. */
    location?: string | undefined;
    /** Gets or sets the phone number associated with the invoice. */
    phoneNumber?: string | undefined;
    /** Gets or sets the applicable VAT rate. */
    vATRate?: number | undefined;
    /** Gets or sets the legal text to be displayed on the invoice. */
    legalText?: string | undefined;
    /** Gets or sets the prefix to be shown on the invoice. */
    prefix?: string | undefined;
    /** Gets or sets the suffix to be shown on the invoice. */
    suffix?: string | undefined;
    /** Gets or sets a value indicating whether the invoices can be synchronized. */
    canSynchronize: boolean;
    /** Gets or sets a value indicating whether the signature should be included on the invoice. */
    includeSignature: boolean;
}

/** Contains the definition of an object of type Insurance. */
export class Insurance implements IInsurance {
    /** Gets or sets the color code. */
    colorCode?: string | undefined;
    /** Gets or sets the end date. */
    endDate?: Date | undefined;
    /** Gets or sets the identifier. */
    id!: number;
    /** Gets or sets the insurer. */
    insurer?: string | undefined;
    /** Gets or sets the logo url. */
    logoImageUrl?: string | undefined;
    /** Gets or sets the start date. */
    startDate!: Date;
    /** Gets or sets the upload file. */
    uploadImageLogo?: any | undefined;

    constructor(data?: IInsurance) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.colorCode = _data["colorCode"];
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.id = _data["id"];
            this.insurer = _data["insurer"];
            this.logoImageUrl = _data["logoImageUrl"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.uploadImageLogo = _data["uploadImageLogo"];
        }
    }

    static fromJS(data: any): Insurance {
        data = typeof data === 'object' ? data : {};
        let result = new Insurance();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["colorCode"] = this.colorCode;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["id"] = this.id;
        data["insurer"] = this.insurer;
        data["logoImageUrl"] = this.logoImageUrl;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["uploadImageLogo"] = this.uploadImageLogo;
        return data;
    }
}

/** Contains the definition of an object of type Insurance. */
export interface IInsurance {
    /** Gets or sets the color code. */
    colorCode?: string | undefined;
    /** Gets or sets the end date. */
    endDate?: Date | undefined;
    /** Gets or sets the identifier. */
    id: number;
    /** Gets or sets the insurer. */
    insurer?: string | undefined;
    /** Gets or sets the logo url. */
    logoImageUrl?: string | undefined;
    /** Gets or sets the start date. */
    startDate: Date;
    /** Gets or sets the upload file. */
    uploadImageLogo?: any | undefined;
}

/** Contains the definition of an object of type InsuranceDetails. */
export class InsuranceDetails extends Insurance implements IInsuranceDetails {
    /** Gets or sets the billing company. */
    billingCompany?: string | undefined;
    /** Gets or sets the billing service. */
    billingService?: string | undefined;
    /** Gets or sets the city. */
    city?: string | undefined;
    /** Gets or sets the consultation price. */
    consultationPrice!: number;
    /** Gets or sets the country. */
    country?: string | undefined;
    /** Gets or sets the nb maximum consultations per person. */
    nbMaxConsultationPerPerson!: number;
    /** Gets or sets the number. */
    number?: string | undefined;
    /** Gets or sets the street. */
    street?: string | undefined;
    /** Gets or sets the tokens. */
    tokens?: InsuranceToken[] | undefined;
    /** Gets or sets the zip code. */
    zipCode?: string | undefined;

    constructor(data?: IInsuranceDetails) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.billingCompany = _data["billingCompany"];
            this.billingService = _data["billingService"];
            this.city = _data["city"];
            this.consultationPrice = _data["consultationPrice"];
            this.country = _data["country"];
            this.nbMaxConsultationPerPerson = _data["nbMaxConsultationPerPerson"];
            this.number = _data["number"];
            this.street = _data["street"];
            if (Array.isArray(_data["tokens"])) {
                this.tokens = [] as any;
                for (let item of _data["tokens"])
                    this.tokens!.push(InsuranceToken.fromJS(item));
            }
            this.zipCode = _data["zipCode"];
        }
    }

    static override fromJS(data: any): InsuranceDetails {
        data = typeof data === 'object' ? data : {};
        let result = new InsuranceDetails();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["billingCompany"] = this.billingCompany;
        data["billingService"] = this.billingService;
        data["city"] = this.city;
        data["consultationPrice"] = this.consultationPrice;
        data["country"] = this.country;
        data["nbMaxConsultationPerPerson"] = this.nbMaxConsultationPerPerson;
        data["number"] = this.number;
        data["street"] = this.street;
        if (Array.isArray(this.tokens)) {
            data["tokens"] = [];
            for (let item of this.tokens)
                data["tokens"].push(item ? item.toJSON() : <any>undefined);
        }
        data["zipCode"] = this.zipCode;
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type InsuranceDetails. */
export interface IInsuranceDetails extends IInsurance {
    /** Gets or sets the billing company. */
    billingCompany?: string | undefined;
    /** Gets or sets the billing service. */
    billingService?: string | undefined;
    /** Gets or sets the city. */
    city?: string | undefined;
    /** Gets or sets the consultation price. */
    consultationPrice: number;
    /** Gets or sets the country. */
    country?: string | undefined;
    /** Gets or sets the nb maximum consultations per person. */
    nbMaxConsultationPerPerson: number;
    /** Gets or sets the number. */
    number?: string | undefined;
    /** Gets or sets the street. */
    street?: string | undefined;
    /** Gets or sets the tokens. */
    tokens?: InsuranceToken[] | undefined;
    /** Gets or sets the zip code. */
    zipCode?: string | undefined;
}

/** Contains the definition of an object of type InsuranceToken. */
export class InsuranceToken implements IInsuranceToken {
    /** Gets or sets the consultation consumed count. */
    consumedConsultationsCount?: number | undefined;
    /** Gets or sets the insurance identifier. */
    insuranceId!: number;
    /** Gets or sets the token. */
    token?: string | undefined;

    constructor(data?: IInsuranceToken) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.consumedConsultationsCount = _data["consumedConsultationsCount"];
            this.insuranceId = _data["insuranceId"];
            this.token = _data["token"];
        }
    }

    static fromJS(data: any): InsuranceToken {
        data = typeof data === 'object' ? data : {};
        let result = new InsuranceToken();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["consumedConsultationsCount"] = this.consumedConsultationsCount;
        data["insuranceId"] = this.insuranceId;
        data["token"] = this.token;
        return data;
    }
}

/** Contains the definition of an object of type InsuranceToken. */
export interface IInsuranceToken {
    /** Gets or sets the consultation consumed count. */
    consumedConsultationsCount?: number | undefined;
    /** Gets or sets the insurance identifier. */
    insuranceId: number;
    /** Gets or sets the token. */
    token?: string | undefined;
}

/** Contains the definition of an object of type InsuranceSearchParams. */
export class InsuranceSearchParams extends SearchParams implements IInsuranceSearchParams {
    /** Gets or sets the name of the contract. */
    contractName?: string | undefined;
    /** Gets or sets the insurer. */
    insurer?: string | undefined;

    constructor(data?: IInsuranceSearchParams) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.contractName = _data["contractName"];
            this.insurer = _data["insurer"];
        }
    }

    static override fromJS(data: any): InsuranceSearchParams {
        data = typeof data === 'object' ? data : {};
        let result = new InsuranceSearchParams();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contractName"] = this.contractName;
        data["insurer"] = this.insurer;
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type InsuranceSearchParams. */
export interface IInsuranceSearchParams extends ISearchParams {
    /** Gets or sets the name of the contract. */
    contractName?: string | undefined;
    /** Gets or sets the insurer. */
    insurer?: string | undefined;
}

/** Contains the definition of an object of type InsuranceTokenImport. */
export class InsuranceTokenImport implements IInsuranceTokenImport {
    /** Gets or sets the chart. */
    fileToImport?: any | undefined;
    /** Gets or sets the member identifier. */
    insuranceId!: number;

    constructor(data?: IInsuranceTokenImport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileToImport = _data["fileToImport"];
            this.insuranceId = _data["insuranceId"];
        }
    }

    static fromJS(data: any): InsuranceTokenImport {
        data = typeof data === 'object' ? data : {};
        let result = new InsuranceTokenImport();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileToImport"] = this.fileToImport;
        data["insuranceId"] = this.insuranceId;
        return data;
    }
}

/** Contains the definition of an object of type InsuranceTokenImport. */
export interface IInsuranceTokenImport {
    /** Gets or sets the chart. */
    fileToImport?: any | undefined;
    /** Gets or sets the member identifier. */
    insuranceId: number;
}

export class StatusValueResourceOfPatientInsurance implements IStatusValueResourceOfPatientInsurance {
    status!: ResponseStatus;
    value?: PatientInsurance | undefined;

    constructor(data?: IStatusValueResourceOfPatientInsurance) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.value = _data["value"] ? PatientInsurance.fromJS(_data["value"]) : <any>undefined;
        }
    }

    static fromJS(data: any): StatusValueResourceOfPatientInsurance {
        data = typeof data === 'object' ? data : {};
        let result = new StatusValueResourceOfPatientInsurance();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["value"] = this.value ? this.value.toJSON() : <any>undefined;
        return data;
    }
}

export interface IStatusValueResourceOfPatientInsurance {
    status: ResponseStatus;
    value?: PatientInsurance | undefined;
}

/** Contains the definition of an object of type PatientInsurance. */
export class PatientInsurance implements IPatientInsurance {
    /** Gets or sets the nb visit. */
    consumedConsultations!: number;
    /** Gets or sets the insurance. */
    insurance?: Insurance | undefined;
    /** Gets or sets a value indicating whether [token used]. */
    isTokenUsed!: boolean;
    /** Gets or sets the last name of the consultation doctor display. */
    lastConsultationDoctorDisplayName?: string | undefined;
    /** Gets or sets the last consultation doctor identifier. */
    lastConsultationDoctorId?: number | undefined;
    /** Gets or sets the first name of the patient. */
    patientFirstName?: string | undefined;
    /** Gets or sets the patient identifier. */
    patientId?: number | undefined;
    /** Gets or sets the left consultations. */
    remainingConsultations!: number;

    constructor(data?: IPatientInsurance) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.consumedConsultations = _data["consumedConsultations"];
            this.insurance = _data["insurance"] ? Insurance.fromJS(_data["insurance"]) : <any>undefined;
            this.isTokenUsed = _data["isTokenUsed"];
            this.lastConsultationDoctorDisplayName = _data["lastConsultationDoctorDisplayName"];
            this.lastConsultationDoctorId = _data["lastConsultationDoctorId"];
            this.patientFirstName = _data["patientFirstName"];
            this.patientId = _data["patientId"];
            this.remainingConsultations = _data["remainingConsultations"];
        }
    }

    static fromJS(data: any): PatientInsurance {
        data = typeof data === 'object' ? data : {};
        let result = new PatientInsurance();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["consumedConsultations"] = this.consumedConsultations;
        data["insurance"] = this.insurance ? this.insurance.toJSON() : <any>undefined;
        data["isTokenUsed"] = this.isTokenUsed;
        data["lastConsultationDoctorDisplayName"] = this.lastConsultationDoctorDisplayName;
        data["lastConsultationDoctorId"] = this.lastConsultationDoctorId;
        data["patientFirstName"] = this.patientFirstName;
        data["patientId"] = this.patientId;
        data["remainingConsultations"] = this.remainingConsultations;
        return data;
    }
}

/** Contains the definition of an object of type PatientInsurance. */
export interface IPatientInsurance {
    /** Gets or sets the nb visit. */
    consumedConsultations: number;
    /** Gets or sets the insurance. */
    insurance?: Insurance | undefined;
    /** Gets or sets a value indicating whether [token used]. */
    isTokenUsed: boolean;
    /** Gets or sets the last name of the consultation doctor display. */
    lastConsultationDoctorDisplayName?: string | undefined;
    /** Gets or sets the last consultation doctor identifier. */
    lastConsultationDoctorId?: number | undefined;
    /** Gets or sets the first name of the patient. */
    patientFirstName?: string | undefined;
    /** Gets or sets the patient identifier. */
    patientId?: number | undefined;
    /** Gets or sets the left consultations. */
    remainingConsultations: number;
}

/** Contains the definition of an object of type NoteResponseBaseEdit. */
export class NoteResponseBaseEdit implements INoteResponseBaseEdit {
    /** Gets or sets the limit date. */
    date!: Date;
    /** Gets or sets the description. */
    description?: string | undefined;
    /** Gets or sets the task identifier. */
    noteId!: number;

    constructor(data?: INoteResponseBaseEdit) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.description = _data["description"];
            this.noteId = _data["noteId"];
        }
    }

    static fromJS(data: any): NoteResponseBaseEdit {
        data = typeof data === 'object' ? data : {};
        let result = new NoteResponseBaseEdit();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["description"] = this.description;
        data["noteId"] = this.noteId;
        return data;
    }
}

/** Contains the definition of an object of type NoteResponseBaseEdit. */
export interface INoteResponseBaseEdit {
    /** Gets or sets the limit date. */
    date: Date;
    /** Gets or sets the description. */
    description?: string | undefined;
    /** Gets or sets the task identifier. */
    noteId: number;
}

/** Contains the definition of an object of type CreateNoteResponse. */
export class CreateNoteResponse extends NoteResponseBaseEdit implements ICreateNoteResponse {

    constructor(data?: ICreateNoteResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): CreateNoteResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateNoteResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type CreateNoteResponse. */
export interface ICreateNoteResponse extends INoteResponseBaseEdit {
}

/** Contains the definition of an object of type NoteBaseEdit. */
export class NoteBaseEdit implements INoteBaseEdit {
    /** Gets or sets the limit date. */
    date!: Date;
    /** Gets or sets the description. */
    description?: string | undefined;
    /** Gets or sets the question identifier. */
    doctorId!: number;
    /** Gets or sets a value indicating whether this instance is internal. */
    isInternal!: boolean;
    /** Gets or sets the patient identifier. */
    patientId?: number | undefined;

    constructor(data?: INoteBaseEdit) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.description = _data["description"];
            this.doctorId = _data["doctorId"];
            this.isInternal = _data["isInternal"];
            this.patientId = _data["patientId"];
        }
    }

    static fromJS(data: any): NoteBaseEdit {
        data = typeof data === 'object' ? data : {};
        let result = new NoteBaseEdit();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["description"] = this.description;
        data["doctorId"] = this.doctorId;
        data["isInternal"] = this.isInternal;
        data["patientId"] = this.patientId;
        return data;
    }
}

/** Contains the definition of an object of type NoteBaseEdit. */
export interface INoteBaseEdit {
    /** Gets or sets the limit date. */
    date: Date;
    /** Gets or sets the description. */
    description?: string | undefined;
    /** Gets or sets the question identifier. */
    doctorId: number;
    /** Gets or sets a value indicating whether this instance is internal. */
    isInternal: boolean;
    /** Gets or sets the patient identifier. */
    patientId?: number | undefined;
}

/** Contains the definition of an object of type CreateNote. */
export class CreateNote extends NoteBaseEdit implements ICreateNote {

    constructor(data?: ICreateNote) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): CreateNote {
        data = typeof data === 'object' ? data : {};
        let result = new CreateNote();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type CreateNote. */
export interface ICreateNote extends INoteBaseEdit {
}

/** Contains the definition of an object of type ConsultInNote. */
export class ConsultInNote implements IConsultInNote {
    /** Gets or sets the created date. */
    createdDate!: Date;
    /** Gets or sets the description. */
    description?: string | undefined;
    /** Gets or sets the doctor identifier. */
    doctorId!: number;
    /** Gets or sets the author identifier. */
    authorId!: number;
    /** Gets or sets a value indicating whether this ConsultInNote is done. */
    done!: boolean;
    /** Gets or sets the identifier. */
    id!: number;
    /** Gets or sets a value indicating whether this instance is internal. */
    isInternal!: boolean;
    /** Gets or sets the limit date. */
    date!: Date;
    /** Gets or sets the first name. */
    authorFirstName?: string | undefined;
    /** Gets or sets the last name. */
    authorLastName?: string | undefined;
    /** Gets or sets the initial. */
    initial?: string | undefined;
    /** Gets or sets the first name of the patient. */
    patientFirstName?: string | undefined;
    /** Gets or sets the last name of the patient. */
    patientLastName?: string | undefined;
    /** Gets or sets the note responses. */
    noteResponses?: NoteResponse[] | undefined;
    /** Gets or sets the note responses count. */
    noteResponsesCount!: number;

    constructor(data?: IConsultInNote) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.description = _data["description"];
            this.doctorId = _data["doctorId"];
            this.authorId = _data["authorId"];
            this.done = _data["done"];
            this.id = _data["id"];
            this.isInternal = _data["isInternal"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.authorFirstName = _data["authorFirstName"];
            this.authorLastName = _data["authorLastName"];
            this.initial = _data["initial"];
            this.patientFirstName = _data["patientFirstName"];
            this.patientLastName = _data["patientLastName"];
            if (Array.isArray(_data["noteResponses"])) {
                this.noteResponses = [] as any;
                for (let item of _data["noteResponses"])
                    this.noteResponses!.push(NoteResponse.fromJS(item));
            }
            this.noteResponsesCount = _data["noteResponsesCount"];
        }
    }

    static fromJS(data: any): ConsultInNote {
        data = typeof data === 'object' ? data : {};
        let result = new ConsultInNote();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["description"] = this.description;
        data["doctorId"] = this.doctorId;
        data["authorId"] = this.authorId;
        data["done"] = this.done;
        data["id"] = this.id;
        data["isInternal"] = this.isInternal;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["authorFirstName"] = this.authorFirstName;
        data["authorLastName"] = this.authorLastName;
        data["initial"] = this.initial;
        data["patientFirstName"] = this.patientFirstName;
        data["patientLastName"] = this.patientLastName;
        if (Array.isArray(this.noteResponses)) {
            data["noteResponses"] = [];
            for (let item of this.noteResponses)
                data["noteResponses"].push(item ? item.toJSON() : <any>undefined);
        }
        data["noteResponsesCount"] = this.noteResponsesCount;
        return data;
    }
}

/** Contains the definition of an object of type ConsultInNote. */
export interface IConsultInNote {
    /** Gets or sets the created date. */
    createdDate: Date;
    /** Gets or sets the description. */
    description?: string | undefined;
    /** Gets or sets the doctor identifier. */
    doctorId: number;
    /** Gets or sets the author identifier. */
    authorId: number;
    /** Gets or sets a value indicating whether this ConsultInNote is done. */
    done: boolean;
    /** Gets or sets the identifier. */
    id: number;
    /** Gets or sets a value indicating whether this instance is internal. */
    isInternal: boolean;
    /** Gets or sets the limit date. */
    date: Date;
    /** Gets or sets the first name. */
    authorFirstName?: string | undefined;
    /** Gets or sets the last name. */
    authorLastName?: string | undefined;
    /** Gets or sets the initial. */
    initial?: string | undefined;
    /** Gets or sets the first name of the patient. */
    patientFirstName?: string | undefined;
    /** Gets or sets the last name of the patient. */
    patientLastName?: string | undefined;
    /** Gets or sets the note responses. */
    noteResponses?: NoteResponse[] | undefined;
    /** Gets or sets the note responses count. */
    noteResponsesCount: number;
}

/** Contains the definition of an object of type NoteResponse. */
export class NoteResponse implements INoteResponse {
    /** Gets or sets the identifier. */
    id!: number;
    /** Gets or sets the description. */
    description?: string | undefined;
    /** Gets or sets the note identifier. */
    noteId!: number;
    /** Gets or sets the author identifier. */
    authorId!: number;
    /** Gets or sets the date. */
    date!: Date;
    /** Gets or sets the first name. */
    firstName?: string | undefined;
    /** Gets or sets the last name. */
    lastName?: string | undefined;
    /** Gets or sets the initial. */
    initial?: string | undefined;

    constructor(data?: INoteResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.noteId = _data["noteId"];
            this.authorId = _data["authorId"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.initial = _data["initial"];
        }
    }

    static fromJS(data: any): NoteResponse {
        data = typeof data === 'object' ? data : {};
        let result = new NoteResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["noteId"] = this.noteId;
        data["authorId"] = this.authorId;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["initial"] = this.initial;
        return data;
    }
}

/** Contains the definition of an object of type NoteResponse. */
export interface INoteResponse {
    /** Gets or sets the identifier. */
    id: number;
    /** Gets or sets the description. */
    description?: string | undefined;
    /** Gets or sets the note identifier. */
    noteId: number;
    /** Gets or sets the author identifier. */
    authorId: number;
    /** Gets or sets the date. */
    date: Date;
    /** Gets or sets the first name. */
    firstName?: string | undefined;
    /** Gets or sets the last name. */
    lastName?: string | undefined;
    /** Gets or sets the initial. */
    initial?: string | undefined;
}

/** Contains the definition of an object of type ConsultInNote. */
export class ConsultInOrderedNote implements IConsultInOrderedNote {
    /** Gets or sets the date. */
    date!: Date;
    /** Gets or sets the notes. */
    notes?: ConsultInNote[] | undefined;

    constructor(data?: IConsultInOrderedNote) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            if (Array.isArray(_data["notes"])) {
                this.notes = [] as any;
                for (let item of _data["notes"])
                    this.notes!.push(ConsultInNote.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ConsultInOrderedNote {
        data = typeof data === 'object' ? data : {};
        let result = new ConsultInOrderedNote();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        if (Array.isArray(this.notes)) {
            data["notes"] = [];
            for (let item of this.notes)
                data["notes"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

/** Contains the definition of an object of type ConsultInNote. */
export interface IConsultInOrderedNote {
    /** Gets or sets the date. */
    date: Date;
    /** Gets or sets the notes. */
    notes?: ConsultInNote[] | undefined;
}

/** Contains the definition of an object of type NoteSearchParams. */
export class NoteSearchParams extends SearchParams implements INoteSearchParams {
    /** Gets or sets the date. */
    dateOfTheDayToFind?: Date | undefined;
    /** Gets or sets a value indicating whether this NoteSearchParams is done. */
    filterOption!: NoteFilterOptionEnum;
    /** Gets or sets the filter period. */
    filterPeriod!: NoteFilterPeriodEnum;
    /** Gets or sets a value indicating whether [internat task]. */
    internalNote!: boolean;
    /** Gets or sets the patient identifier. */
    patientId?: number | undefined;

    constructor(data?: INoteSearchParams) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.dateOfTheDayToFind = _data["dateOfTheDayToFind"] ? new Date(_data["dateOfTheDayToFind"].toString()) : <any>undefined;
            this.filterOption = _data["filterOption"];
            this.filterPeriod = _data["filterPeriod"];
            this.internalNote = _data["internalNote"];
            this.patientId = _data["patientId"];
        }
    }

    static override fromJS(data: any): NoteSearchParams {
        data = typeof data === 'object' ? data : {};
        let result = new NoteSearchParams();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateOfTheDayToFind"] = this.dateOfTheDayToFind ? this.dateOfTheDayToFind.toISOString() : <any>undefined;
        data["filterOption"] = this.filterOption;
        data["filterPeriod"] = this.filterPeriod;
        data["internalNote"] = this.internalNote;
        data["patientId"] = this.patientId;
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type NoteSearchParams. */
export interface INoteSearchParams extends ISearchParams {
    /** Gets or sets the date. */
    dateOfTheDayToFind?: Date | undefined;
    /** Gets or sets a value indicating whether this NoteSearchParams is done. */
    filterOption: NoteFilterOptionEnum;
    /** Gets or sets the filter period. */
    filterPeriod: NoteFilterPeriodEnum;
    /** Gets or sets a value indicating whether [internat task]. */
    internalNote: boolean;
    /** Gets or sets the patient identifier. */
    patientId?: number | undefined;
}

/** Contains the definition of an enum of type NoteFilterOptionEnum. */
export enum NoteFilterOptionEnum {
    Unknown = 0,
    OnlyActive = 1,
    OnlyInactive = 2,
    All = 3,
}

/** Contains the definition of an object of type Login. */
export class Login implements ILogin {
    /** Gets or sets the password. */
    password!: string;
    /** Gets or sets the name of the user. */
    userName!: string;

    constructor(data?: ILogin) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.password = _data["password"];
            this.userName = _data["userName"];
        }
    }

    static fromJS(data: any): Login {
        data = typeof data === 'object' ? data : {};
        let result = new Login();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["password"] = this.password;
        data["userName"] = this.userName;
        return data;
    }
}

/** Contains the definition of an object of type Login. */
export interface ILogin {
    /** Gets or sets the password. */
    password: string;
    /** Gets or sets the name of the user. */
    userName: string;
}

/** Represents an action result for a &lt;see cref="F:System.Net.HttpStatusCode.Redirect"/&gt;. */
export class RedirectResult implements IRedirectResult {
    /** Gets the location at which the content has been created. */
    location?: string | undefined;
    /** Gets the request message which led to this result. */
    request?: HttpRequestMessage | undefined;

    constructor(data?: IRedirectResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.location = _data["Location"];
            this.request = _data["Request"] ? HttpRequestMessage.fromJS(_data["Request"]) : <any>undefined;
        }
    }

    static fromJS(data: any): RedirectResult {
        data = typeof data === 'object' ? data : {};
        let result = new RedirectResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Location"] = this.location;
        data["Request"] = this.request ? this.request.toJSON() : <any>undefined;
        return data;
    }
}

/** Represents an action result for a &lt;see cref="F:System.Net.HttpStatusCode.Redirect"/&gt;. */
export interface IRedirectResult {
    /** Gets the location at which the content has been created. */
    location?: string | undefined;
    /** Gets the request message which led to this result. */
    request?: HttpRequestMessage | undefined;
}

export class HttpRequestMessage implements IHttpRequestMessage {
    version?: Version | undefined;
    content?: HttpContent | undefined;
    method?: HttpMethod | undefined;
    requestUri?: string | undefined;
    headers?: HttpRequestHeaders | undefined;
    properties?: { [key: string]: any; } | undefined;

    constructor(data?: IHttpRequestMessage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.version = _data["Version"] ? Version.fromJS(_data["Version"]) : <any>undefined;
            this.content = _data["Content"] ? HttpContent.fromJS(_data["Content"]) : <any>undefined;
            this.method = _data["Method"] ? HttpMethod.fromJS(_data["Method"]) : <any>undefined;
            this.requestUri = _data["RequestUri"];
            this.headers = _data["Headers"] ? HttpRequestHeaders.fromJS(_data["Headers"]) : <any>undefined;
            if (_data["Properties"]) {
                this.properties = {} as any;
                for (let key in _data["Properties"]) {
                    if (_data["Properties"].hasOwnProperty(key))
                        (<any>this.properties)![key] = _data["Properties"][key];
                }
            }
        }
    }

    static fromJS(data: any): HttpRequestMessage {
        data = typeof data === 'object' ? data : {};
        let result = new HttpRequestMessage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Version"] = this.version ? this.version.toJSON() : <any>undefined;
        data["Content"] = this.content ? this.content.toJSON() : <any>undefined;
        data["Method"] = this.method ? this.method.toJSON() : <any>undefined;
        data["RequestUri"] = this.requestUri;
        data["Headers"] = this.headers ? this.headers.toJSON() : <any>undefined;
        if (this.properties) {
            data["Properties"] = {};
            for (let key in this.properties) {
                if (this.properties.hasOwnProperty(key))
                    (<any>data["Properties"])[key] = (<any>this.properties)[key];
            }
        }
        return data;
    }
}

export interface IHttpRequestMessage {
    version?: Version | undefined;
    content?: HttpContent | undefined;
    method?: HttpMethod | undefined;
    requestUri?: string | undefined;
    headers?: HttpRequestHeaders | undefined;
    properties?: { [key: string]: any; } | undefined;
}

export class Version implements IVersion {
    major!: number;
    minor!: number;
    build!: number;
    revision!: number;
    majorRevision!: number;
    minorRevision!: number;

    constructor(data?: IVersion) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.major = _data["Major"];
            this.minor = _data["Minor"];
            this.build = _data["Build"];
            this.revision = _data["Revision"];
            this.majorRevision = _data["MajorRevision"];
            this.minorRevision = _data["MinorRevision"];
        }
    }

    static fromJS(data: any): Version {
        data = typeof data === 'object' ? data : {};
        let result = new Version();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Major"] = this.major;
        data["Minor"] = this.minor;
        data["Build"] = this.build;
        data["Revision"] = this.revision;
        data["MajorRevision"] = this.majorRevision;
        data["MinorRevision"] = this.minorRevision;
        return data;
    }
}

export interface IVersion {
    major: number;
    minor: number;
    build: number;
    revision: number;
    majorRevision: number;
    minorRevision: number;
}

export abstract class HttpContent implements IHttpContent {
    headers?: HttpContentHeaders | undefined;

    constructor(data?: IHttpContent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.headers = _data["Headers"] ? HttpContentHeaders.fromJS(_data["Headers"]) : <any>undefined;
        }
    }

    static fromJS(data: any): HttpContent {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'HttpContent' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Headers"] = this.headers ? this.headers.toJSON() : <any>undefined;
        return data;
    }
}

export interface IHttpContent {
    headers?: HttpContentHeaders | undefined;
}

export class Anonymous implements IAnonymous {
    allow?: string[] | undefined;
    contentDisposition?: ContentDispositionHeaderValue | undefined;
    contentEncoding?: string[] | undefined;
    contentLanguage?: string[] | undefined;
    contentLength?: number | undefined;
    contentLocation?: string | undefined;
    contentMD5?: string | undefined;
    contentRange?: ContentRangeHeaderValue | undefined;
    contentType?: MediaTypeHeaderValue | undefined;
    expires?: Date | undefined;
    lastModified?: Date | undefined;

    constructor(data?: IAnonymous) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Allow"])) {
                this.allow = [] as any;
                for (let item of _data["Allow"])
                    this.allow!.push(item);
            }
            this.contentDisposition = _data["ContentDisposition"] ? ContentDispositionHeaderValue.fromJS(_data["ContentDisposition"]) : <any>undefined;
            if (Array.isArray(_data["ContentEncoding"])) {
                this.contentEncoding = [] as any;
                for (let item of _data["ContentEncoding"])
                    this.contentEncoding!.push(item);
            }
            if (Array.isArray(_data["ContentLanguage"])) {
                this.contentLanguage = [] as any;
                for (let item of _data["ContentLanguage"])
                    this.contentLanguage!.push(item);
            }
            this.contentLength = _data["ContentLength"];
            this.contentLocation = _data["ContentLocation"];
            this.contentMD5 = _data["ContentMD5"];
            this.contentRange = _data["ContentRange"] ? ContentRangeHeaderValue.fromJS(_data["ContentRange"]) : <any>undefined;
            this.contentType = _data["ContentType"] ? MediaTypeHeaderValue.fromJS(_data["ContentType"]) : <any>undefined;
            this.expires = _data["Expires"] ? new Date(_data["Expires"].toString()) : <any>undefined;
            this.lastModified = _data["LastModified"] ? new Date(_data["LastModified"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): Anonymous {
        data = typeof data === 'object' ? data : {};
        let result = new Anonymous();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.allow)) {
            data["Allow"] = [];
            for (let item of this.allow)
                data["Allow"].push(item);
        }
        data["ContentDisposition"] = this.contentDisposition ? this.contentDisposition.toJSON() : <any>undefined;
        if (Array.isArray(this.contentEncoding)) {
            data["ContentEncoding"] = [];
            for (let item of this.contentEncoding)
                data["ContentEncoding"].push(item);
        }
        if (Array.isArray(this.contentLanguage)) {
            data["ContentLanguage"] = [];
            for (let item of this.contentLanguage)
                data["ContentLanguage"].push(item);
        }
        data["ContentLength"] = this.contentLength;
        data["ContentLocation"] = this.contentLocation;
        data["ContentMD5"] = this.contentMD5;
        data["ContentRange"] = this.contentRange ? this.contentRange.toJSON() : <any>undefined;
        data["ContentType"] = this.contentType ? this.contentType.toJSON() : <any>undefined;
        data["Expires"] = this.expires ? this.expires.toISOString() : <any>undefined;
        data["LastModified"] = this.lastModified ? this.lastModified.toISOString() : <any>undefined;
        return data;
    }
}

export interface IAnonymous {
    allow?: string[] | undefined;
    contentDisposition?: ContentDispositionHeaderValue | undefined;
    contentEncoding?: string[] | undefined;
    contentLanguage?: string[] | undefined;
    contentLength?: number | undefined;
    contentLocation?: string | undefined;
    contentMD5?: string | undefined;
    contentRange?: ContentRangeHeaderValue | undefined;
    contentType?: MediaTypeHeaderValue | undefined;
    expires?: Date | undefined;
    lastModified?: Date | undefined;
}

export class HttpContentHeaders extends Anonymous implements IHttpContentHeaders {

    constructor(data?: IHttpContentHeaders) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): HttpContentHeaders {
        data = typeof data === 'object' ? data : {};
        let result = new HttpContentHeaders();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IHttpContentHeaders extends IAnonymous {
}

export class ContentDispositionHeaderValue implements IContentDispositionHeaderValue {
    dispositionType?: string | undefined;
    parameters?: NameValueHeaderValue[] | undefined;
    name?: string | undefined;
    fileName?: string | undefined;
    fileNameStar?: string | undefined;
    creationDate?: Date | undefined;
    modificationDate?: Date | undefined;
    readDate?: Date | undefined;
    size?: number | undefined;

    constructor(data?: IContentDispositionHeaderValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dispositionType = _data["DispositionType"];
            if (Array.isArray(_data["Parameters"])) {
                this.parameters = [] as any;
                for (let item of _data["Parameters"])
                    this.parameters!.push(NameValueHeaderValue.fromJS(item));
            }
            this.name = _data["Name"];
            this.fileName = _data["FileName"];
            this.fileNameStar = _data["FileNameStar"];
            this.creationDate = _data["CreationDate"] ? new Date(_data["CreationDate"].toString()) : <any>undefined;
            this.modificationDate = _data["ModificationDate"] ? new Date(_data["ModificationDate"].toString()) : <any>undefined;
            this.readDate = _data["ReadDate"] ? new Date(_data["ReadDate"].toString()) : <any>undefined;
            this.size = _data["Size"];
        }
    }

    static fromJS(data: any): ContentDispositionHeaderValue {
        data = typeof data === 'object' ? data : {};
        let result = new ContentDispositionHeaderValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["DispositionType"] = this.dispositionType;
        if (Array.isArray(this.parameters)) {
            data["Parameters"] = [];
            for (let item of this.parameters)
                data["Parameters"].push(item ? item.toJSON() : <any>undefined);
        }
        data["Name"] = this.name;
        data["FileName"] = this.fileName;
        data["FileNameStar"] = this.fileNameStar;
        data["CreationDate"] = this.creationDate ? this.creationDate.toISOString() : <any>undefined;
        data["ModificationDate"] = this.modificationDate ? this.modificationDate.toISOString() : <any>undefined;
        data["ReadDate"] = this.readDate ? this.readDate.toISOString() : <any>undefined;
        data["Size"] = this.size;
        return data;
    }
}

export interface IContentDispositionHeaderValue {
    dispositionType?: string | undefined;
    parameters?: NameValueHeaderValue[] | undefined;
    name?: string | undefined;
    fileName?: string | undefined;
    fileNameStar?: string | undefined;
    creationDate?: Date | undefined;
    modificationDate?: Date | undefined;
    readDate?: Date | undefined;
    size?: number | undefined;
}

export class NameValueHeaderValue implements INameValueHeaderValue {
    name?: string | undefined;
    value?: string | undefined;

    constructor(data?: INameValueHeaderValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["Name"];
            this.value = _data["Value"];
        }
    }

    static fromJS(data: any): NameValueHeaderValue {
        data = typeof data === 'object' ? data : {};
        let result = new NameValueHeaderValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Name"] = this.name;
        data["Value"] = this.value;
        return data;
    }
}

export interface INameValueHeaderValue {
    name?: string | undefined;
    value?: string | undefined;
}

export class ContentRangeHeaderValue implements IContentRangeHeaderValue {
    unit?: string | undefined;
    from?: number | undefined;
    to?: number | undefined;
    length?: number | undefined;
    hasLength!: boolean;
    hasRange!: boolean;

    constructor(data?: IContentRangeHeaderValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.unit = _data["Unit"];
            this.from = _data["From"];
            this.to = _data["To"];
            this.length = _data["Length"];
            this.hasLength = _data["HasLength"];
            this.hasRange = _data["HasRange"];
        }
    }

    static fromJS(data: any): ContentRangeHeaderValue {
        data = typeof data === 'object' ? data : {};
        let result = new ContentRangeHeaderValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Unit"] = this.unit;
        data["From"] = this.from;
        data["To"] = this.to;
        data["Length"] = this.length;
        data["HasLength"] = this.hasLength;
        data["HasRange"] = this.hasRange;
        return data;
    }
}

export interface IContentRangeHeaderValue {
    unit?: string | undefined;
    from?: number | undefined;
    to?: number | undefined;
    length?: number | undefined;
    hasLength: boolean;
    hasRange: boolean;
}

export class MediaTypeHeaderValue implements IMediaTypeHeaderValue {
    charSet?: string | undefined;
    parameters?: NameValueHeaderValue[] | undefined;
    mediaType?: string | undefined;

    constructor(data?: IMediaTypeHeaderValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.charSet = _data["CharSet"];
            if (Array.isArray(_data["Parameters"])) {
                this.parameters = [] as any;
                for (let item of _data["Parameters"])
                    this.parameters!.push(NameValueHeaderValue.fromJS(item));
            }
            this.mediaType = _data["MediaType"];
        }
    }

    static fromJS(data: any): MediaTypeHeaderValue {
        data = typeof data === 'object' ? data : {};
        let result = new MediaTypeHeaderValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CharSet"] = this.charSet;
        if (Array.isArray(this.parameters)) {
            data["Parameters"] = [];
            for (let item of this.parameters)
                data["Parameters"].push(item ? item.toJSON() : <any>undefined);
        }
        data["MediaType"] = this.mediaType;
        return data;
    }
}

export interface IMediaTypeHeaderValue {
    charSet?: string | undefined;
    parameters?: NameValueHeaderValue[] | undefined;
    mediaType?: string | undefined;
}

export class KeyValuePairOfStringAndIEnumerableOfString implements IKeyValuePairOfStringAndIEnumerableOfString {
    key?: string | undefined;
    value?: string[] | undefined;

    constructor(data?: IKeyValuePairOfStringAndIEnumerableOfString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["Key"];
            if (Array.isArray(_data["Value"])) {
                this.value = [] as any;
                for (let item of _data["Value"])
                    this.value!.push(item);
            }
        }
    }

    static fromJS(data: any): KeyValuePairOfStringAndIEnumerableOfString {
        data = typeof data === 'object' ? data : {};
        let result = new KeyValuePairOfStringAndIEnumerableOfString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Key"] = this.key;
        if (Array.isArray(this.value)) {
            data["Value"] = [];
            for (let item of this.value)
                data["Value"].push(item);
        }
        return data;
    }
}

export interface IKeyValuePairOfStringAndIEnumerableOfString {
    key?: string | undefined;
    value?: string[] | undefined;
}

export class HttpMethod implements IHttpMethod {
    method?: string | undefined;

    constructor(data?: IHttpMethod) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.method = _data["Method"];
        }
    }

    static fromJS(data: any): HttpMethod {
        data = typeof data === 'object' ? data : {};
        let result = new HttpMethod();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Method"] = this.method;
        return data;
    }
}

export interface IHttpMethod {
    method?: string | undefined;
}

export class Anonymous2 implements IAnonymous2 {
    accept?: MediaTypeWithQualityHeaderValue[] | undefined;
    acceptCharset?: StringWithQualityHeaderValue[] | undefined;
    acceptEncoding?: StringWithQualityHeaderValue[] | undefined;
    acceptLanguage?: StringWithQualityHeaderValue[] | undefined;
    authorization?: AuthenticationHeaderValue | undefined;
    expect?: NameValueWithParametersHeaderValue[] | undefined;
    expectContinue?: boolean | undefined;
    from?: string | undefined;
    host?: string | undefined;
    ifMatch?: EntityTagHeaderValue[] | undefined;
    ifModifiedSince?: Date | undefined;
    ifNoneMatch?: EntityTagHeaderValue[] | undefined;
    ifRange?: RangeConditionHeaderValue | undefined;
    ifUnmodifiedSince?: Date | undefined;
    maxForwards?: number | undefined;
    proxyAuthorization?: AuthenticationHeaderValue | undefined;
    range?: RangeHeaderValue | undefined;
    referrer?: string | undefined;
    tE?: TransferCodingWithQualityHeaderValue[] | undefined;
    userAgent?: ProductInfoHeaderValue[] | undefined;
    cacheControl?: CacheControlHeaderValue | undefined;
    connection?: string[] | undefined;
    connectionClose?: boolean | undefined;
    date?: Date | undefined;
    pragma?: NameValueHeaderValue[] | undefined;
    trailer?: string[] | undefined;
    transferEncoding?: TransferCodingHeaderValue[] | undefined;
    transferEncodingChunked?: boolean | undefined;
    upgrade?: ProductHeaderValue[] | undefined;
    via?: ViaHeaderValue[] | undefined;
    warning?: WarningHeaderValue[] | undefined;

    constructor(data?: IAnonymous2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Accept"])) {
                this.accept = [] as any;
                for (let item of _data["Accept"])
                    this.accept!.push(MediaTypeWithQualityHeaderValue.fromJS(item));
            }
            if (Array.isArray(_data["AcceptCharset"])) {
                this.acceptCharset = [] as any;
                for (let item of _data["AcceptCharset"])
                    this.acceptCharset!.push(StringWithQualityHeaderValue.fromJS(item));
            }
            if (Array.isArray(_data["AcceptEncoding"])) {
                this.acceptEncoding = [] as any;
                for (let item of _data["AcceptEncoding"])
                    this.acceptEncoding!.push(StringWithQualityHeaderValue.fromJS(item));
            }
            if (Array.isArray(_data["AcceptLanguage"])) {
                this.acceptLanguage = [] as any;
                for (let item of _data["AcceptLanguage"])
                    this.acceptLanguage!.push(StringWithQualityHeaderValue.fromJS(item));
            }
            this.authorization = _data["Authorization"] ? AuthenticationHeaderValue.fromJS(_data["Authorization"]) : <any>undefined;
            if (Array.isArray(_data["Expect"])) {
                this.expect = [] as any;
                for (let item of _data["Expect"])
                    this.expect!.push(NameValueWithParametersHeaderValue.fromJS(item));
            }
            this.expectContinue = _data["ExpectContinue"];
            this.from = _data["From"];
            this.host = _data["Host"];
            if (Array.isArray(_data["IfMatch"])) {
                this.ifMatch = [] as any;
                for (let item of _data["IfMatch"])
                    this.ifMatch!.push(EntityTagHeaderValue.fromJS(item));
            }
            this.ifModifiedSince = _data["IfModifiedSince"] ? new Date(_data["IfModifiedSince"].toString()) : <any>undefined;
            if (Array.isArray(_data["IfNoneMatch"])) {
                this.ifNoneMatch = [] as any;
                for (let item of _data["IfNoneMatch"])
                    this.ifNoneMatch!.push(EntityTagHeaderValue.fromJS(item));
            }
            this.ifRange = _data["IfRange"] ? RangeConditionHeaderValue.fromJS(_data["IfRange"]) : <any>undefined;
            this.ifUnmodifiedSince = _data["IfUnmodifiedSince"] ? new Date(_data["IfUnmodifiedSince"].toString()) : <any>undefined;
            this.maxForwards = _data["MaxForwards"];
            this.proxyAuthorization = _data["ProxyAuthorization"] ? AuthenticationHeaderValue.fromJS(_data["ProxyAuthorization"]) : <any>undefined;
            this.range = _data["Range"] ? RangeHeaderValue.fromJS(_data["Range"]) : <any>undefined;
            this.referrer = _data["Referrer"];
            if (Array.isArray(_data["TE"])) {
                this.tE = [] as any;
                for (let item of _data["TE"])
                    this.tE!.push(TransferCodingWithQualityHeaderValue.fromJS(item));
            }
            if (Array.isArray(_data["UserAgent"])) {
                this.userAgent = [] as any;
                for (let item of _data["UserAgent"])
                    this.userAgent!.push(ProductInfoHeaderValue.fromJS(item));
            }
            this.cacheControl = _data["CacheControl"] ? CacheControlHeaderValue.fromJS(_data["CacheControl"]) : <any>undefined;
            if (Array.isArray(_data["Connection"])) {
                this.connection = [] as any;
                for (let item of _data["Connection"])
                    this.connection!.push(item);
            }
            this.connectionClose = _data["ConnectionClose"];
            this.date = _data["Date"] ? new Date(_data["Date"].toString()) : <any>undefined;
            if (Array.isArray(_data["Pragma"])) {
                this.pragma = [] as any;
                for (let item of _data["Pragma"])
                    this.pragma!.push(NameValueHeaderValue.fromJS(item));
            }
            if (Array.isArray(_data["Trailer"])) {
                this.trailer = [] as any;
                for (let item of _data["Trailer"])
                    this.trailer!.push(item);
            }
            if (Array.isArray(_data["TransferEncoding"])) {
                this.transferEncoding = [] as any;
                for (let item of _data["TransferEncoding"])
                    this.transferEncoding!.push(TransferCodingHeaderValue.fromJS(item));
            }
            this.transferEncodingChunked = _data["TransferEncodingChunked"];
            if (Array.isArray(_data["Upgrade"])) {
                this.upgrade = [] as any;
                for (let item of _data["Upgrade"])
                    this.upgrade!.push(ProductHeaderValue.fromJS(item));
            }
            if (Array.isArray(_data["Via"])) {
                this.via = [] as any;
                for (let item of _data["Via"])
                    this.via!.push(ViaHeaderValue.fromJS(item));
            }
            if (Array.isArray(_data["Warning"])) {
                this.warning = [] as any;
                for (let item of _data["Warning"])
                    this.warning!.push(WarningHeaderValue.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Anonymous2 {
        data = typeof data === 'object' ? data : {};
        let result = new Anonymous2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.accept)) {
            data["Accept"] = [];
            for (let item of this.accept)
                data["Accept"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.acceptCharset)) {
            data["AcceptCharset"] = [];
            for (let item of this.acceptCharset)
                data["AcceptCharset"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.acceptEncoding)) {
            data["AcceptEncoding"] = [];
            for (let item of this.acceptEncoding)
                data["AcceptEncoding"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.acceptLanguage)) {
            data["AcceptLanguage"] = [];
            for (let item of this.acceptLanguage)
                data["AcceptLanguage"].push(item ? item.toJSON() : <any>undefined);
        }
        data["Authorization"] = this.authorization ? this.authorization.toJSON() : <any>undefined;
        if (Array.isArray(this.expect)) {
            data["Expect"] = [];
            for (let item of this.expect)
                data["Expect"].push(item ? item.toJSON() : <any>undefined);
        }
        data["ExpectContinue"] = this.expectContinue;
        data["From"] = this.from;
        data["Host"] = this.host;
        if (Array.isArray(this.ifMatch)) {
            data["IfMatch"] = [];
            for (let item of this.ifMatch)
                data["IfMatch"].push(item ? item.toJSON() : <any>undefined);
        }
        data["IfModifiedSince"] = this.ifModifiedSince ? this.ifModifiedSince.toISOString() : <any>undefined;
        if (Array.isArray(this.ifNoneMatch)) {
            data["IfNoneMatch"] = [];
            for (let item of this.ifNoneMatch)
                data["IfNoneMatch"].push(item ? item.toJSON() : <any>undefined);
        }
        data["IfRange"] = this.ifRange ? this.ifRange.toJSON() : <any>undefined;
        data["IfUnmodifiedSince"] = this.ifUnmodifiedSince ? this.ifUnmodifiedSince.toISOString() : <any>undefined;
        data["MaxForwards"] = this.maxForwards;
        data["ProxyAuthorization"] = this.proxyAuthorization ? this.proxyAuthorization.toJSON() : <any>undefined;
        data["Range"] = this.range ? this.range.toJSON() : <any>undefined;
        data["Referrer"] = this.referrer;
        if (Array.isArray(this.tE)) {
            data["TE"] = [];
            for (let item of this.tE)
                data["TE"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.userAgent)) {
            data["UserAgent"] = [];
            for (let item of this.userAgent)
                data["UserAgent"].push(item ? item.toJSON() : <any>undefined);
        }
        data["CacheControl"] = this.cacheControl ? this.cacheControl.toJSON() : <any>undefined;
        if (Array.isArray(this.connection)) {
            data["Connection"] = [];
            for (let item of this.connection)
                data["Connection"].push(item);
        }
        data["ConnectionClose"] = this.connectionClose;
        data["Date"] = this.date ? this.date.toISOString() : <any>undefined;
        if (Array.isArray(this.pragma)) {
            data["Pragma"] = [];
            for (let item of this.pragma)
                data["Pragma"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.trailer)) {
            data["Trailer"] = [];
            for (let item of this.trailer)
                data["Trailer"].push(item);
        }
        if (Array.isArray(this.transferEncoding)) {
            data["TransferEncoding"] = [];
            for (let item of this.transferEncoding)
                data["TransferEncoding"].push(item ? item.toJSON() : <any>undefined);
        }
        data["TransferEncodingChunked"] = this.transferEncodingChunked;
        if (Array.isArray(this.upgrade)) {
            data["Upgrade"] = [];
            for (let item of this.upgrade)
                data["Upgrade"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.via)) {
            data["Via"] = [];
            for (let item of this.via)
                data["Via"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.warning)) {
            data["Warning"] = [];
            for (let item of this.warning)
                data["Warning"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IAnonymous2 {
    accept?: MediaTypeWithQualityHeaderValue[] | undefined;
    acceptCharset?: StringWithQualityHeaderValue[] | undefined;
    acceptEncoding?: StringWithQualityHeaderValue[] | undefined;
    acceptLanguage?: StringWithQualityHeaderValue[] | undefined;
    authorization?: AuthenticationHeaderValue | undefined;
    expect?: NameValueWithParametersHeaderValue[] | undefined;
    expectContinue?: boolean | undefined;
    from?: string | undefined;
    host?: string | undefined;
    ifMatch?: EntityTagHeaderValue[] | undefined;
    ifModifiedSince?: Date | undefined;
    ifNoneMatch?: EntityTagHeaderValue[] | undefined;
    ifRange?: RangeConditionHeaderValue | undefined;
    ifUnmodifiedSince?: Date | undefined;
    maxForwards?: number | undefined;
    proxyAuthorization?: AuthenticationHeaderValue | undefined;
    range?: RangeHeaderValue | undefined;
    referrer?: string | undefined;
    tE?: TransferCodingWithQualityHeaderValue[] | undefined;
    userAgent?: ProductInfoHeaderValue[] | undefined;
    cacheControl?: CacheControlHeaderValue | undefined;
    connection?: string[] | undefined;
    connectionClose?: boolean | undefined;
    date?: Date | undefined;
    pragma?: NameValueHeaderValue[] | undefined;
    trailer?: string[] | undefined;
    transferEncoding?: TransferCodingHeaderValue[] | undefined;
    transferEncodingChunked?: boolean | undefined;
    upgrade?: ProductHeaderValue[] | undefined;
    via?: ViaHeaderValue[] | undefined;
    warning?: WarningHeaderValue[] | undefined;
}

export class HttpRequestHeaders extends Anonymous2 implements IHttpRequestHeaders {

    constructor(data?: IHttpRequestHeaders) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): HttpRequestHeaders {
        data = typeof data === 'object' ? data : {};
        let result = new HttpRequestHeaders();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IHttpRequestHeaders extends IAnonymous2 {
}

export class MediaTypeWithQualityHeaderValue extends MediaTypeHeaderValue implements IMediaTypeWithQualityHeaderValue {
    quality?: number | undefined;

    constructor(data?: IMediaTypeWithQualityHeaderValue) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.quality = _data["Quality"];
        }
    }

    static override fromJS(data: any): MediaTypeWithQualityHeaderValue {
        data = typeof data === 'object' ? data : {};
        let result = new MediaTypeWithQualityHeaderValue();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Quality"] = this.quality;
        super.toJSON(data);
        return data;
    }
}

export interface IMediaTypeWithQualityHeaderValue extends IMediaTypeHeaderValue {
    quality?: number | undefined;
}

export class StringWithQualityHeaderValue implements IStringWithQualityHeaderValue {
    value?: string | undefined;
    quality?: number | undefined;

    constructor(data?: IStringWithQualityHeaderValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["Value"];
            this.quality = _data["Quality"];
        }
    }

    static fromJS(data: any): StringWithQualityHeaderValue {
        data = typeof data === 'object' ? data : {};
        let result = new StringWithQualityHeaderValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Value"] = this.value;
        data["Quality"] = this.quality;
        return data;
    }
}

export interface IStringWithQualityHeaderValue {
    value?: string | undefined;
    quality?: number | undefined;
}

export class AuthenticationHeaderValue implements IAuthenticationHeaderValue {
    scheme?: string | undefined;
    parameter?: string | undefined;

    constructor(data?: IAuthenticationHeaderValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.scheme = _data["Scheme"];
            this.parameter = _data["Parameter"];
        }
    }

    static fromJS(data: any): AuthenticationHeaderValue {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticationHeaderValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Scheme"] = this.scheme;
        data["Parameter"] = this.parameter;
        return data;
    }
}

export interface IAuthenticationHeaderValue {
    scheme?: string | undefined;
    parameter?: string | undefined;
}

export class NameValueWithParametersHeaderValue extends NameValueHeaderValue implements INameValueWithParametersHeaderValue {
    parameters?: NameValueHeaderValue[] | undefined;

    constructor(data?: INameValueWithParametersHeaderValue) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["Parameters"])) {
                this.parameters = [] as any;
                for (let item of _data["Parameters"])
                    this.parameters!.push(NameValueHeaderValue.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): NameValueWithParametersHeaderValue {
        data = typeof data === 'object' ? data : {};
        let result = new NameValueWithParametersHeaderValue();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.parameters)) {
            data["Parameters"] = [];
            for (let item of this.parameters)
                data["Parameters"].push(item ? item.toJSON() : <any>undefined);
        }
        super.toJSON(data);
        return data;
    }
}

export interface INameValueWithParametersHeaderValue extends INameValueHeaderValue {
    parameters?: NameValueHeaderValue[] | undefined;
}

export class EntityTagHeaderValue implements IEntityTagHeaderValue {
    tag?: string | undefined;
    isWeak!: boolean;

    constructor(data?: IEntityTagHeaderValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tag = _data["Tag"];
            this.isWeak = _data["IsWeak"];
        }
    }

    static fromJS(data: any): EntityTagHeaderValue {
        data = typeof data === 'object' ? data : {};
        let result = new EntityTagHeaderValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Tag"] = this.tag;
        data["IsWeak"] = this.isWeak;
        return data;
    }
}

export interface IEntityTagHeaderValue {
    tag?: string | undefined;
    isWeak: boolean;
}

export class RangeConditionHeaderValue implements IRangeConditionHeaderValue {
    date?: Date | undefined;
    entityTag?: EntityTagHeaderValue | undefined;

    constructor(data?: IRangeConditionHeaderValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["Date"] ? new Date(_data["Date"].toString()) : <any>undefined;
            this.entityTag = _data["EntityTag"] ? EntityTagHeaderValue.fromJS(_data["EntityTag"]) : <any>undefined;
        }
    }

    static fromJS(data: any): RangeConditionHeaderValue {
        data = typeof data === 'object' ? data : {};
        let result = new RangeConditionHeaderValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["EntityTag"] = this.entityTag ? this.entityTag.toJSON() : <any>undefined;
        return data;
    }
}

export interface IRangeConditionHeaderValue {
    date?: Date | undefined;
    entityTag?: EntityTagHeaderValue | undefined;
}

export class RangeHeaderValue implements IRangeHeaderValue {
    unit?: string | undefined;
    ranges?: RangeItemHeaderValue[] | undefined;

    constructor(data?: IRangeHeaderValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.unit = _data["Unit"];
            if (Array.isArray(_data["Ranges"])) {
                this.ranges = [] as any;
                for (let item of _data["Ranges"])
                    this.ranges!.push(RangeItemHeaderValue.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RangeHeaderValue {
        data = typeof data === 'object' ? data : {};
        let result = new RangeHeaderValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Unit"] = this.unit;
        if (Array.isArray(this.ranges)) {
            data["Ranges"] = [];
            for (let item of this.ranges)
                data["Ranges"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IRangeHeaderValue {
    unit?: string | undefined;
    ranges?: RangeItemHeaderValue[] | undefined;
}

export class RangeItemHeaderValue implements IRangeItemHeaderValue {
    from?: number | undefined;
    to?: number | undefined;

    constructor(data?: IRangeItemHeaderValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.from = _data["From"];
            this.to = _data["To"];
        }
    }

    static fromJS(data: any): RangeItemHeaderValue {
        data = typeof data === 'object' ? data : {};
        let result = new RangeItemHeaderValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["From"] = this.from;
        data["To"] = this.to;
        return data;
    }
}

export interface IRangeItemHeaderValue {
    from?: number | undefined;
    to?: number | undefined;
}

export class TransferCodingHeaderValue implements ITransferCodingHeaderValue {
    value?: string | undefined;
    parameters?: NameValueHeaderValue[] | undefined;

    constructor(data?: ITransferCodingHeaderValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["Value"];
            if (Array.isArray(_data["Parameters"])) {
                this.parameters = [] as any;
                for (let item of _data["Parameters"])
                    this.parameters!.push(NameValueHeaderValue.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TransferCodingHeaderValue {
        data = typeof data === 'object' ? data : {};
        let result = new TransferCodingHeaderValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Value"] = this.value;
        if (Array.isArray(this.parameters)) {
            data["Parameters"] = [];
            for (let item of this.parameters)
                data["Parameters"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface ITransferCodingHeaderValue {
    value?: string | undefined;
    parameters?: NameValueHeaderValue[] | undefined;
}

export class TransferCodingWithQualityHeaderValue extends TransferCodingHeaderValue implements ITransferCodingWithQualityHeaderValue {
    quality?: number | undefined;

    constructor(data?: ITransferCodingWithQualityHeaderValue) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.quality = _data["Quality"];
        }
    }

    static override fromJS(data: any): TransferCodingWithQualityHeaderValue {
        data = typeof data === 'object' ? data : {};
        let result = new TransferCodingWithQualityHeaderValue();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Quality"] = this.quality;
        super.toJSON(data);
        return data;
    }
}

export interface ITransferCodingWithQualityHeaderValue extends ITransferCodingHeaderValue {
    quality?: number | undefined;
}

export class ProductInfoHeaderValue implements IProductInfoHeaderValue {
    product?: ProductHeaderValue | undefined;
    comment?: string | undefined;

    constructor(data?: IProductInfoHeaderValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.product = _data["Product"] ? ProductHeaderValue.fromJS(_data["Product"]) : <any>undefined;
            this.comment = _data["Comment"];
        }
    }

    static fromJS(data: any): ProductInfoHeaderValue {
        data = typeof data === 'object' ? data : {};
        let result = new ProductInfoHeaderValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Product"] = this.product ? this.product.toJSON() : <any>undefined;
        data["Comment"] = this.comment;
        return data;
    }
}

export interface IProductInfoHeaderValue {
    product?: ProductHeaderValue | undefined;
    comment?: string | undefined;
}

export class ProductHeaderValue implements IProductHeaderValue {
    name?: string | undefined;
    version?: string | undefined;

    constructor(data?: IProductHeaderValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["Name"];
            this.version = _data["Version"];
        }
    }

    static fromJS(data: any): ProductHeaderValue {
        data = typeof data === 'object' ? data : {};
        let result = new ProductHeaderValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Name"] = this.name;
        data["Version"] = this.version;
        return data;
    }
}

export interface IProductHeaderValue {
    name?: string | undefined;
    version?: string | undefined;
}

export class CacheControlHeaderValue implements ICacheControlHeaderValue {
    noCache!: boolean;
    noCacheHeaders?: string[] | undefined;
    noStore!: boolean;
    maxAge?: string | undefined;
    sharedMaxAge?: string | undefined;
    maxStale!: boolean;
    maxStaleLimit?: string | undefined;
    minFresh?: string | undefined;
    noTransform!: boolean;
    onlyIfCached!: boolean;
    public!: boolean;
    private!: boolean;
    privateHeaders?: string[] | undefined;
    mustRevalidate!: boolean;
    proxyRevalidate!: boolean;
    extensions?: NameValueHeaderValue[] | undefined;

    constructor(data?: ICacheControlHeaderValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.noCache = _data["NoCache"];
            if (Array.isArray(_data["NoCacheHeaders"])) {
                this.noCacheHeaders = [] as any;
                for (let item of _data["NoCacheHeaders"])
                    this.noCacheHeaders!.push(item);
            }
            this.noStore = _data["NoStore"];
            this.maxAge = _data["MaxAge"];
            this.sharedMaxAge = _data["SharedMaxAge"];
            this.maxStale = _data["MaxStale"];
            this.maxStaleLimit = _data["MaxStaleLimit"];
            this.minFresh = _data["MinFresh"];
            this.noTransform = _data["NoTransform"];
            this.onlyIfCached = _data["OnlyIfCached"];
            this.public = _data["Public"];
            this.private = _data["Private"];
            if (Array.isArray(_data["PrivateHeaders"])) {
                this.privateHeaders = [] as any;
                for (let item of _data["PrivateHeaders"])
                    this.privateHeaders!.push(item);
            }
            this.mustRevalidate = _data["MustRevalidate"];
            this.proxyRevalidate = _data["ProxyRevalidate"];
            if (Array.isArray(_data["Extensions"])) {
                this.extensions = [] as any;
                for (let item of _data["Extensions"])
                    this.extensions!.push(NameValueHeaderValue.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CacheControlHeaderValue {
        data = typeof data === 'object' ? data : {};
        let result = new CacheControlHeaderValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["NoCache"] = this.noCache;
        if (Array.isArray(this.noCacheHeaders)) {
            data["NoCacheHeaders"] = [];
            for (let item of this.noCacheHeaders)
                data["NoCacheHeaders"].push(item);
        }
        data["NoStore"] = this.noStore;
        data["MaxAge"] = this.maxAge;
        data["SharedMaxAge"] = this.sharedMaxAge;
        data["MaxStale"] = this.maxStale;
        data["MaxStaleLimit"] = this.maxStaleLimit;
        data["MinFresh"] = this.minFresh;
        data["NoTransform"] = this.noTransform;
        data["OnlyIfCached"] = this.onlyIfCached;
        data["Public"] = this.public;
        data["Private"] = this.private;
        if (Array.isArray(this.privateHeaders)) {
            data["PrivateHeaders"] = [];
            for (let item of this.privateHeaders)
                data["PrivateHeaders"].push(item);
        }
        data["MustRevalidate"] = this.mustRevalidate;
        data["ProxyRevalidate"] = this.proxyRevalidate;
        if (Array.isArray(this.extensions)) {
            data["Extensions"] = [];
            for (let item of this.extensions)
                data["Extensions"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface ICacheControlHeaderValue {
    noCache: boolean;
    noCacheHeaders?: string[] | undefined;
    noStore: boolean;
    maxAge?: string | undefined;
    sharedMaxAge?: string | undefined;
    maxStale: boolean;
    maxStaleLimit?: string | undefined;
    minFresh?: string | undefined;
    noTransform: boolean;
    onlyIfCached: boolean;
    public: boolean;
    private: boolean;
    privateHeaders?: string[] | undefined;
    mustRevalidate: boolean;
    proxyRevalidate: boolean;
    extensions?: NameValueHeaderValue[] | undefined;
}

export class ViaHeaderValue implements IViaHeaderValue {
    protocolName?: string | undefined;
    protocolVersion?: string | undefined;
    receivedBy?: string | undefined;
    comment?: string | undefined;

    constructor(data?: IViaHeaderValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.protocolName = _data["ProtocolName"];
            this.protocolVersion = _data["ProtocolVersion"];
            this.receivedBy = _data["ReceivedBy"];
            this.comment = _data["Comment"];
        }
    }

    static fromJS(data: any): ViaHeaderValue {
        data = typeof data === 'object' ? data : {};
        let result = new ViaHeaderValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ProtocolName"] = this.protocolName;
        data["ProtocolVersion"] = this.protocolVersion;
        data["ReceivedBy"] = this.receivedBy;
        data["Comment"] = this.comment;
        return data;
    }
}

export interface IViaHeaderValue {
    protocolName?: string | undefined;
    protocolVersion?: string | undefined;
    receivedBy?: string | undefined;
    comment?: string | undefined;
}

export class WarningHeaderValue implements IWarningHeaderValue {
    code!: number;
    agent?: string | undefined;
    text?: string | undefined;
    date?: Date | undefined;

    constructor(data?: IWarningHeaderValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["Code"];
            this.agent = _data["Agent"];
            this.text = _data["Text"];
            this.date = _data["Date"] ? new Date(_data["Date"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): WarningHeaderValue {
        data = typeof data === 'object' ? data : {};
        let result = new WarningHeaderValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Code"] = this.code;
        data["Agent"] = this.agent;
        data["Text"] = this.text;
        data["Date"] = this.date ? this.date.toISOString() : <any>undefined;
        return data;
    }
}

export interface IWarningHeaderValue {
    code: number;
    agent?: string | undefined;
    text?: string | undefined;
    date?: Date | undefined;
}

/** Contains the definition of an object of type CourseSessionRegistrationRequest. */
export class CourseSessionRegistrationRequest implements ICourseSessionRegistrationRequest {
    /** Gets or sets the course session identifier. */
    courseSessionId!: number;
    /** Gets or sets the member identifier. */
    memberId!: number;
    /** Gets or sets the validity start date. */
    validityStartDate!: Date;
    /** Gets or sets the validity end date. */
    validityEndDate?: Date | undefined;

    constructor(data?: ICourseSessionRegistrationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.courseSessionId = _data["courseSessionId"];
            this.memberId = _data["memberId"];
            this.validityStartDate = _data["validityStartDate"] ? new Date(_data["validityStartDate"].toString()) : <any>undefined;
            this.validityEndDate = _data["validityEndDate"] ? new Date(_data["validityEndDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CourseSessionRegistrationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CourseSessionRegistrationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["courseSessionId"] = this.courseSessionId;
        data["memberId"] = this.memberId;
        data["validityStartDate"] = this.validityStartDate ? this.validityStartDate.toISOString() : <any>undefined;
        data["validityEndDate"] = this.validityEndDate ? this.validityEndDate.toISOString() : <any>undefined;
        return data;
    }
}

/** Contains the definition of an object of type CourseSessionRegistrationRequest. */
export interface ICourseSessionRegistrationRequest {
    /** Gets or sets the course session identifier. */
    courseSessionId: number;
    /** Gets or sets the member identifier. */
    memberId: number;
    /** Gets or sets the validity start date. */
    validityStartDate: Date;
    /** Gets or sets the validity end date. */
    validityEndDate?: Date | undefined;
}

/** UpdateSiinAmbassadorRequest */
export class UpdateSiinAmbassadorRequest implements IUpdateSiinAmbassadorRequest {
    /** Gets or sets the member identifier. */
    memberId!: number;

    constructor(data?: IUpdateSiinAmbassadorRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.memberId = _data["memberId"];
        }
    }

    static fromJS(data: any): UpdateSiinAmbassadorRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSiinAmbassadorRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberId"] = this.memberId;
        return data;
    }
}

/** UpdateSiinAmbassadorRequest */
export interface IUpdateSiinAmbassadorRequest {
    /** Gets or sets the member identifier. */
    memberId: number;
}

/** Contains the definition of an object of type Member. */
export class Member implements IMember {
    /** Gets or sets the country. */
    country?: string | undefined;
    /** Gets or sets the display name. */
    displayName?: string | undefined;
    /** Gets or sets the identifier. */
    id!: number;
    /** Gets or sets a value indicating whether this instance is locked out. */
    isLockedOut!: boolean;
    /** Gets or sets the moodle identifier. */
    moodleId!: number;
    /** Gets or sets the nationality. */
    nationality?: string | undefined;
    /** Gets or sets the name of the partener. */
    partnerName?: string | undefined;
    /** Gets or sets the profession. */
    professionId!: number;
    /** Gets or sets the precision profession. */
    precisionProfession?: string | undefined;
    /** Gets or sets the profession. */
    professionOther?: string | undefined;
    /** Gets or sets the role. */
    roles!: Roles[];
    /** Gets or sets my property. */
    typesId?: number[] | undefined;

    constructor(data?: IMember) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.roles = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.country = _data["country"];
            this.displayName = _data["displayName"];
            this.id = _data["id"];
            this.isLockedOut = _data["isLockedOut"];
            this.moodleId = _data["moodleId"];
            this.nationality = _data["nationality"];
            this.partnerName = _data["partnerName"];
            this.professionId = _data["professionId"];
            this.precisionProfession = _data["precisionProfession"];
            this.professionOther = _data["professionOther"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
            if (Array.isArray(_data["typesId"])) {
                this.typesId = [] as any;
                for (let item of _data["typesId"])
                    this.typesId!.push(item);
            }
        }
    }

    static fromJS(data: any): Member {
        data = typeof data === 'object' ? data : {};
        let result = new Member();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["country"] = this.country;
        data["displayName"] = this.displayName;
        data["id"] = this.id;
        data["isLockedOut"] = this.isLockedOut;
        data["moodleId"] = this.moodleId;
        data["nationality"] = this.nationality;
        data["partnerName"] = this.partnerName;
        data["professionId"] = this.professionId;
        data["precisionProfession"] = this.precisionProfession;
        data["professionOther"] = this.professionOther;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        if (Array.isArray(this.typesId)) {
            data["typesId"] = [];
            for (let item of this.typesId)
                data["typesId"].push(item);
        }
        return data;
    }
}

/** Contains the definition of an object of type Member. */
export interface IMember {
    /** Gets or sets the country. */
    country?: string | undefined;
    /** Gets or sets the display name. */
    displayName?: string | undefined;
    /** Gets or sets the identifier. */
    id: number;
    /** Gets or sets a value indicating whether this instance is locked out. */
    isLockedOut: boolean;
    /** Gets or sets the moodle identifier. */
    moodleId: number;
    /** Gets or sets the nationality. */
    nationality?: string | undefined;
    /** Gets or sets the name of the partener. */
    partnerName?: string | undefined;
    /** Gets or sets the profession. */
    professionId: number;
    /** Gets or sets the precision profession. */
    precisionProfession?: string | undefined;
    /** Gets or sets the profession. */
    professionOther?: string | undefined;
    /** Gets or sets the role. */
    roles: Roles[];
    /** Gets or sets my property. */
    typesId?: number[] | undefined;
}

/** Contains the definition of an object of type MemberDetails. */
export class MemberDetails extends Member implements IMemberDetails {
    /** Gets or sets the academy inscription date. */
    academyInscriptionDate?: Date | undefined;
    /** Gets or sets the academy validity date. */
    academyValidityDate?: Date | undefined;
    /** Gets or sets the adeli number. */
    adeliNumber?: string | undefined;
    /** Gets or sets the advantage code. */
    advantageCode?: string | undefined;
    /** Gets or sets the birth date. */
    birthDate?: Date | undefined;
    /** Gets or sets the chart. */
    chart?: Media | undefined;
    /** Gets or sets the chart identifier. */
    chartId?: number | undefined;
    /** Gets or sets the city. */
    city?: string | undefined;
    /** Gets or sets a value indicating whether [consent GDPR]. */
    consentGdpr!: boolean;
    /** Gets or sets the created date. */
    createdDate!: Date;
    /** Gets or sets the credits. */
    credits!: number;
    /** Gets or sets the department. */
    departement?: string | undefined;
    /** Gets or sets the description. */
    description?: string | undefined;
    /** Gets or sets the diploma ids. */
    diplomaIds?: number[] | undefined;
    /** Gets or sets the directory city. */
    directoryCity?: string | undefined;
    /** Gets or sets the directory country. */
    directoryCountry?: string | undefined;
    /** Gets or sets the directory email. */
    directoryEmail?: string | undefined;
    /** Gets or sets the directory number. */
    directoryNumber?: string | undefined;
    /** Gets or sets the directory other information. */
    directoryOtherInfo?: string | undefined;
    /** Gets or sets the directory phone. */
    directoryPhone?: string | undefined;
    /** Gets or sets the directory postal code. */
    directoryPostalCode?: string | undefined;
    /** Gets or sets the directory street. */
    directoryStreet?: string | undefined;
    /** Gets or sets a value indicating whether [directory use another address]. */
    directoryUseAnotherAddress!: boolean;
    /** Gets or sets the email. */
    email!: string;
    /** Gets or sets a value indicating whether this MemberDetails is employe. */
    employe!: boolean;
    /** Gets or sets the fax. */
    fax?: string | undefined;
    /** Gets or sets the firstname. */
    firstName?: string | undefined;
    /** Gets or sets the first phone. */
    firstPhone?: string | undefined;
    /** Gets or sets the gender. */
    gender!: string;
    /** Gets or sets the GLN number. */
    glnNumber?: string | undefined;
    /** Gets or sets the godfather code. */
    godfatherCode?: string | undefined;
    /** Gets or sets a value indicating whether this instance has signed ethical chart. */
    hasSignedEthicalChart!: boolean;
    /** Gets or sets a value indicating whether ProNutriConsult contract is signed. */
    hasSignedPncContract!: boolean;
    /** Gets or sets a value indicating whether [hide in directory]. */
    hideInDirectory!: boolean;
    /** Gets or sets the image URL. */
    imageUrl?: string | undefined;
    /** Gets or sets the inami number. */
    inamiNumber?: string | undefined;
    /** Gets or sets a value indicating whether this instance is eligible for DPC. */
    isEligibleDPC?: boolean | undefined;
    /** Gets or sets a value indicating whether [is health professional]. */
    isHealthProfessional!: boolean;
    /** Gets or sets a value indicating whether [is health professional without valid number]. */
    isHealthProfessionalWithoutValidNumber!: boolean;
    /** Gets or sets a value indicating whether this instance is opportunity. */
    isOpportunity!: boolean;
    /** Gets or sets a value indicating whether this instance is risky. */
    isRisky!: boolean;
    /** Gets or sets the language. */
    language?: string | undefined;
    /** Gets or sets the last connection date. */
    lastConnectionDate!: Date;
    /** Gets or sets the lastname. */
    lastName?: string | undefined;
    /** Gets or sets a value indicating whether [liberal profession]. */
    liberalProfession!: boolean;
    /** Gets or sets the name of the maiden. */
    maidenName?: string | undefined;
    /** Gets or sets the medical order number. */
    medicalOrderNumber?: string | undefined;
    /** Gets or sets a value indicating whether [newsletter subscription]. */
    newsletterSubscription!: boolean;
    /** Gets or sets the number. */
    number?: string | undefined;
    /** Gets or sets the password. */
    password?: string | undefined;
    /** Gets or sets the pharmacy authorization number. */
    pharmacyAuthorizationNumber?: string | undefined;
    /** Gets or sets the pole emploi number. */
    poleEmploiNumber?: string | undefined;
    /** Gets or sets the postal code. */
    postalCode?: string | undefined;
    /** Gets or sets the ProNutriConsult contract identifier. */
    proNutriConsultContractId?: number | undefined;
    /** Gets or sets the reseller code. */
    resellerCode?: string | undefined;
    /** Gets or sets the RPPS number. */
    rppsNumber?: string | undefined;
    /** Gets or sets the schedules. */
    schedules?: Schedule[] | undefined;
    /** Gets or sets the schedules string. */
    schedulesString?: string | undefined;
    /** Gets or sets the second phone. */
    secondPhone?: string | undefined;
    /** Gets or sets the siin commission. */
    siinCommission!: number;
    /** Gets or sets the society. */
    society?: string | undefined;
    /** Gets or sets the speciality identifier. */
    specialityId?: number | undefined;
    /** Gets or sets the speciality text field. */
    specialityTextField?: string | undefined;
    /** Gets or sets the sponsorship code. */
    sponsorshipCode?: string | undefined;
    /** Gets or sets the street. */
    street?: string | undefined;
    /** Gets or sets a value indicating whether [subject to vat]. */
    subjectToVat!: boolean;
    /** Gets or sets a value indicating whether this MemberDetails is unemployed. */
    unemployed!: boolean;
    /** Gets or sets the username. */
    username!: string;
    /** Gets or sets the vat number. */
    vatNumber?: string | undefined;
    /** Gets or sets the website. */
    website?: string | undefined;
    /** Gets or sets the current profession identifier. */
    currentProfessionId?: number | undefined;
    /** Gets or sets a value indicating whether to lock the profession. */
    lockProfession!: boolean;
    /** Gets or sets a value indicating whether to lock the health professional. */
    lockHealthPro!: boolean;

    constructor(data?: IMemberDetails) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.academyInscriptionDate = _data["academyInscriptionDate"] ? new Date(_data["academyInscriptionDate"].toString()) : <any>undefined;
            this.academyValidityDate = _data["academyValidityDate"] ? new Date(_data["academyValidityDate"].toString()) : <any>undefined;
            this.adeliNumber = _data["adeliNumber"];
            this.advantageCode = _data["advantageCode"];
            this.birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : <any>undefined;
            this.chart = _data["chart"] ? Media.fromJS(_data["chart"]) : <any>undefined;
            this.chartId = _data["chartId"];
            this.city = _data["city"];
            this.consentGdpr = _data["consentGdpr"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.credits = _data["credits"];
            this.departement = _data["departement"];
            this.description = _data["description"];
            if (Array.isArray(_data["diplomaIds"])) {
                this.diplomaIds = [] as any;
                for (let item of _data["diplomaIds"])
                    this.diplomaIds!.push(item);
            }
            this.directoryCity = _data["directoryCity"];
            this.directoryCountry = _data["directoryCountry"];
            this.directoryEmail = _data["directoryEmail"];
            this.directoryNumber = _data["directoryNumber"];
            this.directoryOtherInfo = _data["directoryOtherInfo"];
            this.directoryPhone = _data["directoryPhone"];
            this.directoryPostalCode = _data["directoryPostalCode"];
            this.directoryStreet = _data["directoryStreet"];
            this.directoryUseAnotherAddress = _data["directoryUseAnotherAddress"];
            this.email = _data["email"];
            this.employe = _data["employe"];
            this.fax = _data["fax"];
            this.firstName = _data["firstName"];
            this.firstPhone = _data["firstPhone"];
            this.gender = _data["gender"];
            this.glnNumber = _data["glnNumber"];
            this.godfatherCode = _data["godfatherCode"];
            this.hasSignedEthicalChart = _data["hasSignedEthicalChart"];
            this.hasSignedPncContract = _data["hasSignedPncContract"];
            this.hideInDirectory = _data["hideInDirectory"];
            this.imageUrl = _data["imageUrl"];
            this.inamiNumber = _data["inamiNumber"];
            this.isEligibleDPC = _data["isEligibleDPC"];
            this.isHealthProfessional = _data["isHealthProfessional"];
            this.isHealthProfessionalWithoutValidNumber = _data["isHealthProfessionalWithoutValidNumber"];
            this.isOpportunity = _data["isOpportunity"];
            this.isRisky = _data["isRisky"];
            this.language = _data["language"];
            this.lastConnectionDate = _data["lastConnectionDate"] ? new Date(_data["lastConnectionDate"].toString()) : <any>undefined;
            this.lastName = _data["lastName"];
            this.liberalProfession = _data["liberalProfession"];
            this.maidenName = _data["maidenName"];
            this.medicalOrderNumber = _data["medicalOrderNumber"];
            this.newsletterSubscription = _data["newsletterSubscription"];
            this.number = _data["number"];
            this.password = _data["password"];
            this.pharmacyAuthorizationNumber = _data["pharmacyAuthorizationNumber"];
            this.poleEmploiNumber = _data["poleEmploiNumber"];
            this.postalCode = _data["postalCode"];
            this.proNutriConsultContractId = _data["proNutriConsultContractId"];
            this.resellerCode = _data["resellerCode"];
            this.rppsNumber = _data["rppsNumber"];
            if (Array.isArray(_data["schedules"])) {
                this.schedules = [] as any;
                for (let item of _data["schedules"])
                    this.schedules!.push(Schedule.fromJS(item));
            }
            this.schedulesString = _data["schedulesString"];
            this.secondPhone = _data["secondPhone"];
            this.siinCommission = _data["siinCommission"];
            this.society = _data["society"];
            this.specialityId = _data["specialityId"];
            this.specialityTextField = _data["specialityTextField"];
            this.sponsorshipCode = _data["sponsorshipCode"];
            this.street = _data["street"];
            this.subjectToVat = _data["subjectToVat"];
            this.unemployed = _data["unemployed"];
            this.username = _data["username"];
            this.vatNumber = _data["vatNumber"];
            this.website = _data["website"];
            this.currentProfessionId = _data["currentProfessionId"];
            this.lockProfession = _data["lockProfession"];
            this.lockHealthPro = _data["lockHealthPro"];
        }
    }

    static override fromJS(data: any): MemberDetails {
        data = typeof data === 'object' ? data : {};
        let result = new MemberDetails();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["academyInscriptionDate"] = this.academyInscriptionDate ? this.academyInscriptionDate.toISOString() : <any>undefined;
        data["academyValidityDate"] = this.academyValidityDate ? this.academyValidityDate.toISOString() : <any>undefined;
        data["adeliNumber"] = this.adeliNumber;
        data["advantageCode"] = this.advantageCode;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["chart"] = this.chart ? this.chart.toJSON() : <any>undefined;
        data["chartId"] = this.chartId;
        data["city"] = this.city;
        data["consentGdpr"] = this.consentGdpr;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["credits"] = this.credits;
        data["departement"] = this.departement;
        data["description"] = this.description;
        if (Array.isArray(this.diplomaIds)) {
            data["diplomaIds"] = [];
            for (let item of this.diplomaIds)
                data["diplomaIds"].push(item);
        }
        data["directoryCity"] = this.directoryCity;
        data["directoryCountry"] = this.directoryCountry;
        data["directoryEmail"] = this.directoryEmail;
        data["directoryNumber"] = this.directoryNumber;
        data["directoryOtherInfo"] = this.directoryOtherInfo;
        data["directoryPhone"] = this.directoryPhone;
        data["directoryPostalCode"] = this.directoryPostalCode;
        data["directoryStreet"] = this.directoryStreet;
        data["directoryUseAnotherAddress"] = this.directoryUseAnotherAddress;
        data["email"] = this.email;
        data["employe"] = this.employe;
        data["fax"] = this.fax;
        data["firstName"] = this.firstName;
        data["firstPhone"] = this.firstPhone;
        data["gender"] = this.gender;
        data["glnNumber"] = this.glnNumber;
        data["godfatherCode"] = this.godfatherCode;
        data["hasSignedEthicalChart"] = this.hasSignedEthicalChart;
        data["hasSignedPncContract"] = this.hasSignedPncContract;
        data["hideInDirectory"] = this.hideInDirectory;
        data["imageUrl"] = this.imageUrl;
        data["inamiNumber"] = this.inamiNumber;
        data["isEligibleDPC"] = this.isEligibleDPC;
        data["isHealthProfessional"] = this.isHealthProfessional;
        data["isHealthProfessionalWithoutValidNumber"] = this.isHealthProfessionalWithoutValidNumber;
        data["isOpportunity"] = this.isOpportunity;
        data["isRisky"] = this.isRisky;
        data["language"] = this.language;
        data["lastConnectionDate"] = this.lastConnectionDate ? this.lastConnectionDate.toISOString() : <any>undefined;
        data["lastName"] = this.lastName;
        data["liberalProfession"] = this.liberalProfession;
        data["maidenName"] = this.maidenName;
        data["medicalOrderNumber"] = this.medicalOrderNumber;
        data["newsletterSubscription"] = this.newsletterSubscription;
        data["number"] = this.number;
        data["password"] = this.password;
        data["pharmacyAuthorizationNumber"] = this.pharmacyAuthorizationNumber;
        data["poleEmploiNumber"] = this.poleEmploiNumber;
        data["postalCode"] = this.postalCode;
        data["proNutriConsultContractId"] = this.proNutriConsultContractId;
        data["resellerCode"] = this.resellerCode;
        data["rppsNumber"] = this.rppsNumber;
        if (Array.isArray(this.schedules)) {
            data["schedules"] = [];
            for (let item of this.schedules)
                data["schedules"].push(item ? item.toJSON() : <any>undefined);
        }
        data["schedulesString"] = this.schedulesString;
        data["secondPhone"] = this.secondPhone;
        data["siinCommission"] = this.siinCommission;
        data["society"] = this.society;
        data["specialityId"] = this.specialityId;
        data["specialityTextField"] = this.specialityTextField;
        data["sponsorshipCode"] = this.sponsorshipCode;
        data["street"] = this.street;
        data["subjectToVat"] = this.subjectToVat;
        data["unemployed"] = this.unemployed;
        data["username"] = this.username;
        data["vatNumber"] = this.vatNumber;
        data["website"] = this.website;
        data["currentProfessionId"] = this.currentProfessionId;
        data["lockProfession"] = this.lockProfession;
        data["lockHealthPro"] = this.lockHealthPro;
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type MemberDetails. */
export interface IMemberDetails extends IMember {
    /** Gets or sets the academy inscription date. */
    academyInscriptionDate?: Date | undefined;
    /** Gets or sets the academy validity date. */
    academyValidityDate?: Date | undefined;
    /** Gets or sets the adeli number. */
    adeliNumber?: string | undefined;
    /** Gets or sets the advantage code. */
    advantageCode?: string | undefined;
    /** Gets or sets the birth date. */
    birthDate?: Date | undefined;
    /** Gets or sets the chart. */
    chart?: Media | undefined;
    /** Gets or sets the chart identifier. */
    chartId?: number | undefined;
    /** Gets or sets the city. */
    city?: string | undefined;
    /** Gets or sets a value indicating whether [consent GDPR]. */
    consentGdpr: boolean;
    /** Gets or sets the created date. */
    createdDate: Date;
    /** Gets or sets the credits. */
    credits: number;
    /** Gets or sets the department. */
    departement?: string | undefined;
    /** Gets or sets the description. */
    description?: string | undefined;
    /** Gets or sets the diploma ids. */
    diplomaIds?: number[] | undefined;
    /** Gets or sets the directory city. */
    directoryCity?: string | undefined;
    /** Gets or sets the directory country. */
    directoryCountry?: string | undefined;
    /** Gets or sets the directory email. */
    directoryEmail?: string | undefined;
    /** Gets or sets the directory number. */
    directoryNumber?: string | undefined;
    /** Gets or sets the directory other information. */
    directoryOtherInfo?: string | undefined;
    /** Gets or sets the directory phone. */
    directoryPhone?: string | undefined;
    /** Gets or sets the directory postal code. */
    directoryPostalCode?: string | undefined;
    /** Gets or sets the directory street. */
    directoryStreet?: string | undefined;
    /** Gets or sets a value indicating whether [directory use another address]. */
    directoryUseAnotherAddress: boolean;
    /** Gets or sets the email. */
    email: string;
    /** Gets or sets a value indicating whether this MemberDetails is employe. */
    employe: boolean;
    /** Gets or sets the fax. */
    fax?: string | undefined;
    /** Gets or sets the firstname. */
    firstName?: string | undefined;
    /** Gets or sets the first phone. */
    firstPhone?: string | undefined;
    /** Gets or sets the gender. */
    gender: string;
    /** Gets or sets the GLN number. */
    glnNumber?: string | undefined;
    /** Gets or sets the godfather code. */
    godfatherCode?: string | undefined;
    /** Gets or sets a value indicating whether this instance has signed ethical chart. */
    hasSignedEthicalChart: boolean;
    /** Gets or sets a value indicating whether ProNutriConsult contract is signed. */
    hasSignedPncContract: boolean;
    /** Gets or sets a value indicating whether [hide in directory]. */
    hideInDirectory: boolean;
    /** Gets or sets the image URL. */
    imageUrl?: string | undefined;
    /** Gets or sets the inami number. */
    inamiNumber?: string | undefined;
    /** Gets or sets a value indicating whether this instance is eligible for DPC. */
    isEligibleDPC?: boolean | undefined;
    /** Gets or sets a value indicating whether [is health professional]. */
    isHealthProfessional: boolean;
    /** Gets or sets a value indicating whether [is health professional without valid number]. */
    isHealthProfessionalWithoutValidNumber: boolean;
    /** Gets or sets a value indicating whether this instance is opportunity. */
    isOpportunity: boolean;
    /** Gets or sets a value indicating whether this instance is risky. */
    isRisky: boolean;
    /** Gets or sets the language. */
    language?: string | undefined;
    /** Gets or sets the last connection date. */
    lastConnectionDate: Date;
    /** Gets or sets the lastname. */
    lastName?: string | undefined;
    /** Gets or sets a value indicating whether [liberal profession]. */
    liberalProfession: boolean;
    /** Gets or sets the name of the maiden. */
    maidenName?: string | undefined;
    /** Gets or sets the medical order number. */
    medicalOrderNumber?: string | undefined;
    /** Gets or sets a value indicating whether [newsletter subscription]. */
    newsletterSubscription: boolean;
    /** Gets or sets the number. */
    number?: string | undefined;
    /** Gets or sets the password. */
    password?: string | undefined;
    /** Gets or sets the pharmacy authorization number. */
    pharmacyAuthorizationNumber?: string | undefined;
    /** Gets or sets the pole emploi number. */
    poleEmploiNumber?: string | undefined;
    /** Gets or sets the postal code. */
    postalCode?: string | undefined;
    /** Gets or sets the ProNutriConsult contract identifier. */
    proNutriConsultContractId?: number | undefined;
    /** Gets or sets the reseller code. */
    resellerCode?: string | undefined;
    /** Gets or sets the RPPS number. */
    rppsNumber?: string | undefined;
    /** Gets or sets the schedules. */
    schedules?: Schedule[] | undefined;
    /** Gets or sets the schedules string. */
    schedulesString?: string | undefined;
    /** Gets or sets the second phone. */
    secondPhone?: string | undefined;
    /** Gets or sets the siin commission. */
    siinCommission: number;
    /** Gets or sets the society. */
    society?: string | undefined;
    /** Gets or sets the speciality identifier. */
    specialityId?: number | undefined;
    /** Gets or sets the speciality text field. */
    specialityTextField?: string | undefined;
    /** Gets or sets the sponsorship code. */
    sponsorshipCode?: string | undefined;
    /** Gets or sets the street. */
    street?: string | undefined;
    /** Gets or sets a value indicating whether [subject to vat]. */
    subjectToVat: boolean;
    /** Gets or sets a value indicating whether this MemberDetails is unemployed. */
    unemployed: boolean;
    /** Gets or sets the username. */
    username: string;
    /** Gets or sets the vat number. */
    vatNumber?: string | undefined;
    /** Gets or sets the website. */
    website?: string | undefined;
    /** Gets or sets the current profession identifier. */
    currentProfessionId?: number | undefined;
    /** Gets or sets a value indicating whether to lock the profession. */
    lockProfession: boolean;
    /** Gets or sets a value indicating whether to lock the health professional. */
    lockHealthPro: boolean;
}

/** Contains the definition of an object of type Media. */
export class Media implements IMedia {
    /** Gets or sets the identifier. */
    id!: number;
    /** Gets or sets the name. */
    name?: string | undefined;
    /** Gets or sets the URL. */
    url?: string | undefined;

    constructor(data?: IMedia) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.url = _data["url"];
        }
    }

    static fromJS(data: any): Media {
        data = typeof data === 'object' ? data : {};
        let result = new Media();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["url"] = this.url;
        return data;
    }
}

/** Contains the definition of an object of type Media. */
export interface IMedia {
    /** Gets or sets the identifier. */
    id: number;
    /** Gets or sets the name. */
    name?: string | undefined;
    /** Gets or sets the URL. */
    url?: string | undefined;
}

/** Contains the definition of an object of type Schedule. */
export class Schedule implements ISchedule {
    /** Gets or sets the midday start. */
    afternoonStart!: string;
    /** Gets or sets the name of the day. */
    dayName!: Days;
    /** Gets or sets the end day. */
    endDay!: string;
    /** Gets or sets the midday end. */
    morningEnd!: string;
    /** Gets or sets the start day. */
    startDay!: string;

    constructor(data?: ISchedule) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.afternoonStart = _data["afternoonStart"];
            this.dayName = _data["dayName"];
            this.endDay = _data["endDay"];
            this.morningEnd = _data["morningEnd"];
            this.startDay = _data["startDay"];
        }
    }

    static fromJS(data: any): Schedule {
        data = typeof data === 'object' ? data : {};
        let result = new Schedule();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["afternoonStart"] = this.afternoonStart;
        data["dayName"] = this.dayName;
        data["endDay"] = this.endDay;
        data["morningEnd"] = this.morningEnd;
        data["startDay"] = this.startDay;
        return data;
    }
}

/** Contains the definition of an object of type Schedule. */
export interface ISchedule {
    /** Gets or sets the midday start. */
    afternoonStart: string;
    /** Gets or sets the name of the day. */
    dayName: Days;
    /** Gets or sets the end day. */
    endDay: string;
    /** Gets or sets the midday end. */
    morningEnd: string;
    /** Gets or sets the start day. */
    startDay: string;
}

/** Contains the definition of an object of type UpdateCourseSessionRegistration. */
export class UpdateCourseSessionRegistration implements IUpdateCourseSessionRegistration {
    /** Gets or sets the identifier. */
    id!: number;
    /** Gets or sets a value indicating whether this UpdateCourseSessionRegistration is suspended. */
    suspended!: boolean;

    constructor(data?: IUpdateCourseSessionRegistration) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.suspended = _data["suspended"];
        }
    }

    static fromJS(data: any): UpdateCourseSessionRegistration {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCourseSessionRegistration();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["suspended"] = this.suspended;
        return data;
    }
}

/** Contains the definition of an object of type UpdateCourseSessionRegistration. */
export interface IUpdateCourseSessionRegistration {
    /** Gets or sets the identifier. */
    id: number;
    /** Gets or sets a value indicating whether this UpdateCourseSessionRegistration is suspended. */
    suspended: boolean;
}

/** Contains the definition of an object of type ChangePassword. */
export class ChangePassword implements IChangePassword {
    /** Gets or sets the password. */
    password!: string;
    /** Gets or sets the token. */
    token!: string;
    /** Gets or sets a value indicating whether the gdpr gets accepted. Only when a patient creates his password. */
    consentGdpr!: boolean;

    constructor(data?: IChangePassword) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.password = _data["password"];
            this.token = _data["token"];
            this.consentGdpr = _data["consentGdpr"];
        }
    }

    static fromJS(data: any): ChangePassword {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePassword();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["password"] = this.password;
        data["token"] = this.token;
        data["consentGdpr"] = this.consentGdpr;
        return data;
    }
}

/** Contains the definition of an object of type ChangePassword. */
export interface IChangePassword {
    /** Gets or sets the password. */
    password: string;
    /** Gets or sets the token. */
    token: string;
    /** Gets or sets a value indicating whether the gdpr gets accepted. Only when a patient creates his password. */
    consentGdpr: boolean;
}

/** DocumentUploadRequest */
export class DocumentUploadRequest implements IDocumentUploadRequest {
    /** Gets or sets the member identifier. */
    memberId!: number;
    /** Gets or sets the document. */
    document?: any | undefined;

    constructor(data?: IDocumentUploadRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.memberId = _data["memberId"];
            this.document = _data["document"];
        }
    }

    static fromJS(data: any): DocumentUploadRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentUploadRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberId"] = this.memberId;
        data["document"] = this.document;
        return data;
    }
}

/** DocumentUploadRequest */
export interface IDocumentUploadRequest {
    /** Gets or sets the member identifier. */
    memberId: number;
    /** Gets or sets the document. */
    document?: any | undefined;
}

/** Contains the definition of an object of type MemberProfilePicture. */
export class MemberProfilePicture implements IMemberProfilePicture {
    /** Gets or sets the member identifier. */
    memberId!: number;
    /** Gets or sets the chart. */
    profilePicture?: any | undefined;

    constructor(data?: IMemberProfilePicture) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.memberId = _data["memberId"];
            this.profilePicture = _data["profilePicture"];
        }
    }

    static fromJS(data: any): MemberProfilePicture {
        data = typeof data === 'object' ? data : {};
        let result = new MemberProfilePicture();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberId"] = this.memberId;
        data["profilePicture"] = this.profilePicture;
        return data;
    }
}

/** Contains the definition of an object of type MemberProfilePicture. */
export interface IMemberProfilePicture {
    /** Gets or sets the member identifier. */
    memberId: number;
    /** Gets or sets the chart. */
    profilePicture?: any | undefined;
}

/** Contains the definition of an object of type ProNutriConsultMemberInformation. */
export class ProNutriConsultMemberInformation implements IProNutriConsultMemberInformation {
    /** Gets or sets the member identifier. */
    memberId!: number;
    /** Gets or sets the subscription levels. */
    subscriptionLevels?: number[] | undefined;

    constructor(data?: IProNutriConsultMemberInformation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.memberId = _data["memberId"];
            if (Array.isArray(_data["subscriptionLevels"])) {
                this.subscriptionLevels = [] as any;
                for (let item of _data["subscriptionLevels"])
                    this.subscriptionLevels!.push(item);
            }
        }
    }

    static fromJS(data: any): ProNutriConsultMemberInformation {
        data = typeof data === 'object' ? data : {};
        let result = new ProNutriConsultMemberInformation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberId"] = this.memberId;
        if (Array.isArray(this.subscriptionLevels)) {
            data["subscriptionLevels"] = [];
            for (let item of this.subscriptionLevels)
                data["subscriptionLevels"].push(item);
        }
        return data;
    }
}

/** Contains the definition of an object of type ProNutriConsultMemberInformation. */
export interface IProNutriConsultMemberInformation {
    /** Gets or sets the member identifier. */
    memberId: number;
    /** Gets or sets the subscription levels. */
    subscriptionLevels?: number[] | undefined;
}

/** Contains the definition of an object of type CreateClientAccountParams. */
export class CreateClientAccountParams implements ICreateClientAccountParams {
    /** Gets or sets the email. */
    email?: string | undefined;

    constructor(data?: ICreateClientAccountParams) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): CreateClientAccountParams {
        data = typeof data === 'object' ? data : {};
        let result = new CreateClientAccountParams();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        return data;
    }
}

/** Contains the definition of an object of type CreateClientAccountParams. */
export interface ICreateClientAccountParams {
    /** Gets or sets the email. */
    email?: string | undefined;
}

/** Contains the definition of an object of type MemberActionReminder. */
export class MemberActionReminder implements IMemberActionReminder {
    /** Gets or sets the identifier. */
    id!: number;
    /** Gets or sets the  member identifier. */
    memberId!: number;
    /** Gets or sets the Title. */
    title?: string | undefined;
    /** Gets or sets the Type. */
    type!: MemberActionType;
    /** Gets or sets the tag. */
    tag?: MemberActionTag | undefined;
    /** Gets or sets the Description. */
    description?: string | undefined;
    /** Gets or sets the created date. */
    createdDate!: Date;
    /** Gets or sets the Deadline date. */
    deadline?: Date | undefined;
    /** Gets or sets the file. */
    file?: any | undefined;
    /** Gets or sets the file name. */
    fileName?: string | undefined;
    /** Gets or sets the file url. */
    fileUrl?: string | undefined;
    /** Gets or sets the Status. */
    status!: MemberActionStatus;

    constructor(data?: IMemberActionReminder) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.memberId = _data["memberId"];
            this.title = _data["title"];
            this.type = _data["type"];
            this.tag = _data["tag"];
            this.description = _data["description"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.deadline = _data["deadline"] ? new Date(_data["deadline"].toString()) : <any>undefined;
            this.file = _data["file"];
            this.fileName = _data["fileName"];
            this.fileUrl = _data["fileUrl"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): MemberActionReminder {
        data = typeof data === 'object' ? data : {};
        let result = new MemberActionReminder();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["memberId"] = this.memberId;
        data["title"] = this.title;
        data["type"] = this.type;
        data["tag"] = this.tag;
        data["description"] = this.description;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["deadline"] = this.deadline ? this.deadline.toISOString() : <any>undefined;
        data["file"] = this.file;
        data["fileName"] = this.fileName;
        data["fileUrl"] = this.fileUrl;
        data["status"] = this.status;
        return data;
    }
}

/** Contains the definition of an object of type MemberActionReminder. */
export interface IMemberActionReminder {
    /** Gets or sets the identifier. */
    id: number;
    /** Gets or sets the  member identifier. */
    memberId: number;
    /** Gets or sets the Title. */
    title?: string | undefined;
    /** Gets or sets the Type. */
    type: MemberActionType;
    /** Gets or sets the tag. */
    tag?: MemberActionTag | undefined;
    /** Gets or sets the Description. */
    description?: string | undefined;
    /** Gets or sets the created date. */
    createdDate: Date;
    /** Gets or sets the Deadline date. */
    deadline?: Date | undefined;
    /** Gets or sets the file. */
    file?: any | undefined;
    /** Gets or sets the file name. */
    fileName?: string | undefined;
    /** Gets or sets the file url. */
    fileUrl?: string | undefined;
    /** Gets or sets the Status. */
    status: MemberActionStatus;
}

/** Contains the definition of an object of type MemberActionType. */
export enum MemberActionType {
    ValidationDG = 0,
    Ambassador = 1,
    DpsNotice = 2,
    BPH = 3,
    Accounting = 4,
    Advisor = 5,
    DiplomaExamination = 6,
    Training = 7,
    Disability = 8,
    Partner = 9,
    Support = 10,
    Product = 11,
    ProNutriConsult = 12,
    SiinAca = 13,
}

/** Contains the definition of an object of type MemberActionTag. */
export enum MemberActionTag {
    Improvement = 1,
    Dysfunction = 2,
    Complaint = 3,
    Risk = 4,
    Opportunity = 5,
    Call = 6,
    Mail = 7,
    Email = 8,
}

/** Contains the definition of an object of type MemberActionStatus. */
export enum MemberActionStatus {
    InProgress = 0,
    ToDo = 1,
    Done = 2,
    Investigation = 3,
    Urgent = 4,
}

/** Contains the definition of an object of type MemberDocumentDetails. */
export class MemberDocumentDetails implements IMemberDocumentDetails {
    /** Gets or sets the Id. */
    id!: number;
    /** Gets or sets the member Id. */
    memberId!: number;
    /** Gets or sets the title. */
    title?: string | undefined;
    /** Gets or sets the description. */
    description?: string | undefined;
    /** Gets or sets the file. */
    file?: any | undefined;
    /** Gets or sets the file name. */
    fileName?: string | undefined;
    /** Gets or sets the file URL. */
    fileUrl?: string | undefined;
    /** Gets or sets a value indicating whether this instance is a SiiN Document. */
    isSiiNDocument!: boolean;
    /** Gets or sets a value indicating whether this instance is a new Document. */
    isNewDocument!: boolean;
    /** Gets or sets a value indicating whether this instance is deletable. */
    isDeletable!: boolean;
    /** Gets or sets the member document type. */
    tag!: MemberDocumentTag;
    /** Gets or sets a value indicating whether [validate by siin]. */
    isValidateBySiin!: boolean;
    /** Gets or sets the type identifier. */
    typeId!: number;
    /** Gets or sets the created date. */
    createdDate!: Date;
    /** Gets or sets the updated date. */
    updatedDate?: Date | undefined;

    constructor(data?: IMemberDocumentDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.memberId = _data["memberId"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.file = _data["file"];
            this.fileName = _data["fileName"];
            this.fileUrl = _data["fileUrl"];
            this.isSiiNDocument = _data["isSiiNDocument"];
            this.isNewDocument = _data["isNewDocument"];
            this.isDeletable = _data["isDeletable"];
            this.tag = _data["tag"];
            this.isValidateBySiin = _data["isValidateBySiin"];
            this.typeId = _data["typeId"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): MemberDocumentDetails {
        data = typeof data === 'object' ? data : {};
        let result = new MemberDocumentDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["memberId"] = this.memberId;
        data["title"] = this.title;
        data["description"] = this.description;
        data["file"] = this.file;
        data["fileName"] = this.fileName;
        data["fileUrl"] = this.fileUrl;
        data["isSiiNDocument"] = this.isSiiNDocument;
        data["isNewDocument"] = this.isNewDocument;
        data["isDeletable"] = this.isDeletable;
        data["tag"] = this.tag;
        data["isValidateBySiin"] = this.isValidateBySiin;
        data["typeId"] = this.typeId;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>undefined;
        return data;
    }
}

/** Contains the definition of an object of type MemberDocumentDetails. */
export interface IMemberDocumentDetails {
    /** Gets or sets the Id. */
    id: number;
    /** Gets or sets the member Id. */
    memberId: number;
    /** Gets or sets the title. */
    title?: string | undefined;
    /** Gets or sets the description. */
    description?: string | undefined;
    /** Gets or sets the file. */
    file?: any | undefined;
    /** Gets or sets the file name. */
    fileName?: string | undefined;
    /** Gets or sets the file URL. */
    fileUrl?: string | undefined;
    /** Gets or sets a value indicating whether this instance is a SiiN Document. */
    isSiiNDocument: boolean;
    /** Gets or sets a value indicating whether this instance is a new Document. */
    isNewDocument: boolean;
    /** Gets or sets a value indicating whether this instance is deletable. */
    isDeletable: boolean;
    /** Gets or sets the member document type. */
    tag: MemberDocumentTag;
    /** Gets or sets a value indicating whether [validate by siin]. */
    isValidateBySiin: boolean;
    /** Gets or sets the type identifier. */
    typeId: number;
    /** Gets or sets the created date. */
    createdDate: Date;
    /** Gets or sets the updated date. */
    updatedDate?: Date | undefined;
}

/** Contains the definition of an object of type MemberDocumentTag. */
export enum MemberDocumentTag {
    None = 0,
    Badge = 1,
    EthicalChart = 2,
    ProNutriConsultContract = 3,
}

/** Contains the definition of an object of type MemberDocumentCount. */
export class MemberDocumentCount implements IMemberDocumentCount {
    /** Gets or sets the siin document count. */
    siinDocumentsCount!: number;
    /** Gets or sets the client document count. */
    clientDocumentsCount!: number;

    constructor(data?: IMemberDocumentCount) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.siinDocumentsCount = _data["siinDocumentsCount"];
            this.clientDocumentsCount = _data["clientDocumentsCount"];
        }
    }

    static fromJS(data: any): MemberDocumentCount {
        data = typeof data === 'object' ? data : {};
        let result = new MemberDocumentCount();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["siinDocumentsCount"] = this.siinDocumentsCount;
        data["clientDocumentsCount"] = this.clientDocumentsCount;
        return data;
    }
}

/** Contains the definition of an object of type MemberDocumentCount. */
export interface IMemberDocumentCount {
    /** Gets or sets the siin document count. */
    siinDocumentsCount: number;
    /** Gets or sets the client document count. */
    clientDocumentsCount: number;
}

/** Contains the definition of an object of type MailMemberHistoryLite. */
export class MailMemberHistoryLite implements IMailMemberHistoryLite {
    /** Gets or sets the identifier. */
    id!: number;
    /** Gets or sets the sender. */
    sender?: string | undefined;
    /** Gets or sets the receiver. */
    receiver?: string | undefined;
    /** Gets or sets the sendingDate. */
    sendingDate!: Date;
    /** Gets or sets the subject. */
    subject?: string | undefined;
    /** Gets or sets the mail chimp identifier. */
    mailchimpId?: string | undefined;
    /** Gets or sets the mail state. */
    state!: MailMemberState;

    constructor(data?: IMailMemberHistoryLite) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sender = _data["sender"];
            this.receiver = _data["receiver"];
            this.sendingDate = _data["sendingDate"] ? new Date(_data["sendingDate"].toString()) : <any>undefined;
            this.subject = _data["subject"];
            this.mailchimpId = _data["mailchimpId"];
            this.state = _data["state"];
        }
    }

    static fromJS(data: any): MailMemberHistoryLite {
        data = typeof data === 'object' ? data : {};
        let result = new MailMemberHistoryLite();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sender"] = this.sender;
        data["receiver"] = this.receiver;
        data["sendingDate"] = this.sendingDate ? this.sendingDate.toISOString() : <any>undefined;
        data["subject"] = this.subject;
        data["mailchimpId"] = this.mailchimpId;
        data["state"] = this.state;
        return data;
    }
}

/** Contains the definition of an object of type MailMemberHistoryLite. */
export interface IMailMemberHistoryLite {
    /** Gets or sets the identifier. */
    id: number;
    /** Gets or sets the sender. */
    sender?: string | undefined;
    /** Gets or sets the receiver. */
    receiver?: string | undefined;
    /** Gets or sets the sendingDate. */
    sendingDate: Date;
    /** Gets or sets the subject. */
    subject?: string | undefined;
    /** Gets or sets the mail chimp identifier. */
    mailchimpId?: string | undefined;
    /** Gets or sets the mail state. */
    state: MailMemberState;
}

/** Contains the definition of an object of type MailMemberHistory. */
export enum MailMemberState {
    Unknown = 0,
    Sent = 1,
    Bounced = 2,
    Rejected = 3,
}

/** Contains the definition of an object of type MemberMailSearchParam. */
export class MemberMailSearchParam implements IMemberMailSearchParam {
    /** Gets or sets the member identifier. */
    memberId!: number;
    /** Gets or sets the page number. */
    page!: number;

    constructor(data?: IMemberMailSearchParam) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.memberId = _data["memberId"];
            this.page = _data["page"];
        }
    }

    static fromJS(data: any): MemberMailSearchParam {
        data = typeof data === 'object' ? data : {};
        let result = new MemberMailSearchParam();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberId"] = this.memberId;
        data["page"] = this.page;
        return data;
    }
}

/** Contains the definition of an object of type MemberMailSearchParam. */
export interface IMemberMailSearchParam {
    /** Gets or sets the member identifier. */
    memberId: number;
    /** Gets or sets the page number. */
    page: number;
}

/** Contains the definition of an object of type MailMemberHistory. */
export class MailMemberHistory extends MailMemberHistoryLite implements IMailMemberHistory {
    /** Gets or sets the body. */
    body?: string | undefined;
    /** Gets or sets the mail attachment. */
    mailMemberHistoryAttachments?: MailMemberHistoryAttachment[] | undefined;

    constructor(data?: IMailMemberHistory) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.body = _data["body"];
            if (Array.isArray(_data["mailMemberHistoryAttachments"])) {
                this.mailMemberHistoryAttachments = [] as any;
                for (let item of _data["mailMemberHistoryAttachments"])
                    this.mailMemberHistoryAttachments!.push(MailMemberHistoryAttachment.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): MailMemberHistory {
        data = typeof data === 'object' ? data : {};
        let result = new MailMemberHistory();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["body"] = this.body;
        if (Array.isArray(this.mailMemberHistoryAttachments)) {
            data["mailMemberHistoryAttachments"] = [];
            for (let item of this.mailMemberHistoryAttachments)
                data["mailMemberHistoryAttachments"].push(item ? item.toJSON() : <any>undefined);
        }
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type MailMemberHistory. */
export interface IMailMemberHistory extends IMailMemberHistoryLite {
    /** Gets or sets the body. */
    body?: string | undefined;
    /** Gets or sets the mail attachment. */
    mailMemberHistoryAttachments?: MailMemberHistoryAttachment[] | undefined;
}

/** Contains the definition of an object of type MailMemberHistoryAttachment. */
export class MailMemberHistoryAttachment implements IMailMemberHistoryAttachment {
    /** Gets or sets the identifier. */
    id!: number;
    /** Gets or sets the mail member history identifier. */
    mailMemberHistoryId!: number;
    /** Gets or sets the filePath. */
    filePath?: string | undefined;

    constructor(data?: IMailMemberHistoryAttachment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.mailMemberHistoryId = _data["MailMemberHistoryId"];
            this.filePath = _data["FilePath"];
        }
    }

    static fromJS(data: any): MailMemberHistoryAttachment {
        data = typeof data === 'object' ? data : {};
        let result = new MailMemberHistoryAttachment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["MailMemberHistoryId"] = this.mailMemberHistoryId;
        data["FilePath"] = this.filePath;
        return data;
    }
}

/** Contains the definition of an object of type MailMemberHistoryAttachment. */
export interface IMailMemberHistoryAttachment {
    /** Gets or sets the identifier. */
    id: number;
    /** Gets or sets the mail member history identifier. */
    mailMemberHistoryId: number;
    /** Gets or sets the filePath. */
    filePath?: string | undefined;
}

export class PaginatorWrapperOfIEnumerableOfMemberActionReminder implements IPaginatorWrapperOfIEnumerableOfMemberActionReminder {
    totalRecords!: number;
    data?: MemberActionReminder[] | undefined;

    constructor(data?: IPaginatorWrapperOfIEnumerableOfMemberActionReminder) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRecords = _data["totalRecords"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(MemberActionReminder.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatorWrapperOfIEnumerableOfMemberActionReminder {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatorWrapperOfIEnumerableOfMemberActionReminder();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IPaginatorWrapperOfIEnumerableOfMemberActionReminder {
    totalRecords: number;
    data?: MemberActionReminder[] | undefined;
}

/** Contains the definition of an object of type ActionSearchParams. */
export class ActionSearchParams extends SearchParams implements IActionSearchParams {
    /** Gets or sets the tag. */
    tag?: MemberActionTag | undefined;
    /** Gets or sets the Type. */
    type?: MemberActionType | undefined;
    /** Gets or sets the Status. */
    status?: MemberActionStatus | undefined;
    /** Gets or sets the  member identifier. */
    memberId?: number | undefined;
    /** Gets or sets the start created date. */
    startCreatedDate?: Date | undefined;
    /** Gets or sets the end created date. */
    endCreatedDate?: Date | undefined;
    /** Gets or sets the sort type. */
    sortType!: MemberActionOrderByType;

    constructor(data?: IActionSearchParams) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.tag = _data["Tag"];
            this.type = _data["Type"];
            this.status = _data["Status"];
            this.memberId = _data["MemberId"];
            this.startCreatedDate = _data["StartCreatedDate"] ? new Date(_data["StartCreatedDate"].toString()) : <any>undefined;
            this.endCreatedDate = _data["EndCreatedDate"] ? new Date(_data["EndCreatedDate"].toString()) : <any>undefined;
            this.sortType = _data["SortType"];
        }
    }

    static override fromJS(data: any): ActionSearchParams {
        data = typeof data === 'object' ? data : {};
        let result = new ActionSearchParams();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Tag"] = this.tag;
        data["Type"] = this.type;
        data["Status"] = this.status;
        data["MemberId"] = this.memberId;
        data["StartCreatedDate"] = this.startCreatedDate ? this.startCreatedDate.toISOString() : <any>undefined;
        data["EndCreatedDate"] = this.endCreatedDate ? this.endCreatedDate.toISOString() : <any>undefined;
        data["SortType"] = this.sortType;
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type ActionSearchParams. */
export interface IActionSearchParams extends ISearchParams {
    /** Gets or sets the tag. */
    tag?: MemberActionTag | undefined;
    /** Gets or sets the Type. */
    type?: MemberActionType | undefined;
    /** Gets or sets the Status. */
    status?: MemberActionStatus | undefined;
    /** Gets or sets the  member identifier. */
    memberId?: number | undefined;
    /** Gets or sets the start created date. */
    startCreatedDate?: Date | undefined;
    /** Gets or sets the end created date. */
    endCreatedDate?: Date | undefined;
    /** Gets or sets the sort type. */
    sortType: MemberActionOrderByType;
}

/** Contains the definition of an object of type MemberActionOrderByType. */
export enum MemberActionOrderByType {
    DeadlineAsc = 0,
    DeadlineDesc = 1,
}

/** Contains the definition of an object of type MemberSearchParams. */
export class MemberSearchParams extends SearchParams implements IMemberSearchParams {
    /** Gets or sets the advantage codes. */
    advantageCodes?: string[] | undefined;
    /** Gets or sets the country iso3. */
    countryIso3?: string | undefined;
    /** Gets or sets the departement. */
    departement?: number | undefined;
    /** Gets or sets the firstname. */
    firstName?: string | undefined;
    /** Gets or sets the identifier. */
    id?: number | undefined;
    /** Gets or sets the lastname. */
    lastName?: string | undefined;
    /** Gets or sets the profession identifier. */
    professionId?: number | undefined;
    /** Gets or sets the specialization identifier. */
    specializationId?: number | undefined;
    /** Gets or sets the reseller code. */
    resellerCode?: string | undefined;
    /** Gets or sets the role. */
    role?: Roles | undefined;
    /** Gets or sets a value indicating whether this MemberSearchParams is desactivated. */
    showDesactivated?: boolean | undefined;
    /** Gets or sets a value indicating whether this MemberSearchParams is Opportunity. */
    showOpportunity?: boolean | undefined;
    /** Gets or sets a value indicating whether this MemberSearchParams is Risky. */
    showRisky?: boolean | undefined;
    /** Gets or sets the types identifier. */
    typesId?: number[] | undefined;
    /** Gets or sets the title. */
    title?: string | undefined;

    constructor(data?: IMemberSearchParams) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["advantageCodes"])) {
                this.advantageCodes = [] as any;
                for (let item of _data["advantageCodes"])
                    this.advantageCodes!.push(item);
            }
            this.countryIso3 = _data["countryIso3"];
            this.departement = _data["departement"];
            this.firstName = _data["firstName"];
            this.id = _data["id"];
            this.lastName = _data["lastName"];
            this.professionId = _data["professionId"];
            this.specializationId = _data["specializationId"];
            this.resellerCode = _data["resellerCode"];
            this.role = _data["role"];
            this.showDesactivated = _data["showDesactivated"];
            this.showOpportunity = _data["showOpportunity"];
            this.showRisky = _data["showRisky"];
            if (Array.isArray(_data["typesId"])) {
                this.typesId = [] as any;
                for (let item of _data["typesId"])
                    this.typesId!.push(item);
            }
            this.title = _data["title"];
        }
    }

    static override fromJS(data: any): MemberSearchParams {
        data = typeof data === 'object' ? data : {};
        let result = new MemberSearchParams();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.advantageCodes)) {
            data["advantageCodes"] = [];
            for (let item of this.advantageCodes)
                data["advantageCodes"].push(item);
        }
        data["countryIso3"] = this.countryIso3;
        data["departement"] = this.departement;
        data["firstName"] = this.firstName;
        data["id"] = this.id;
        data["lastName"] = this.lastName;
        data["professionId"] = this.professionId;
        data["specializationId"] = this.specializationId;
        data["resellerCode"] = this.resellerCode;
        data["role"] = this.role;
        data["showDesactivated"] = this.showDesactivated;
        data["showOpportunity"] = this.showOpportunity;
        data["showRisky"] = this.showRisky;
        if (Array.isArray(this.typesId)) {
            data["typesId"] = [];
            for (let item of this.typesId)
                data["typesId"].push(item);
        }
        data["title"] = this.title;
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type MemberSearchParams. */
export interface IMemberSearchParams extends ISearchParams {
    /** Gets or sets the advantage codes. */
    advantageCodes?: string[] | undefined;
    /** Gets or sets the country iso3. */
    countryIso3?: string | undefined;
    /** Gets or sets the departement. */
    departement?: number | undefined;
    /** Gets or sets the firstname. */
    firstName?: string | undefined;
    /** Gets or sets the identifier. */
    id?: number | undefined;
    /** Gets or sets the lastname. */
    lastName?: string | undefined;
    /** Gets or sets the profession identifier. */
    professionId?: number | undefined;
    /** Gets or sets the specialization identifier. */
    specializationId?: number | undefined;
    /** Gets or sets the reseller code. */
    resellerCode?: string | undefined;
    /** Gets or sets the role. */
    role?: Roles | undefined;
    /** Gets or sets a value indicating whether this MemberSearchParams is desactivated. */
    showDesactivated?: boolean | undefined;
    /** Gets or sets a value indicating whether this MemberSearchParams is Opportunity. */
    showOpportunity?: boolean | undefined;
    /** Gets or sets a value indicating whether this MemberSearchParams is Risky. */
    showRisky?: boolean | undefined;
    /** Gets or sets the types identifier. */
    typesId?: number[] | undefined;
    /** Gets or sets the title. */
    title?: string | undefined;
}

/** MemberBonusRequest */
export class MemberBonusRequest implements IMemberBonusRequest {
    /** Gets or sets the member ids. */
    memberIds?: number[] | undefined;
    /** Gets or sets the credits. */
    credits!: number;
    /** Gets or sets the description. */
    description?: string | undefined;

    constructor(data?: IMemberBonusRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["memberIds"])) {
                this.memberIds = [] as any;
                for (let item of _data["memberIds"])
                    this.memberIds!.push(item);
            }
            this.credits = _data["credits"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): MemberBonusRequest {
        data = typeof data === 'object' ? data : {};
        let result = new MemberBonusRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.memberIds)) {
            data["memberIds"] = [];
            for (let item of this.memberIds)
                data["memberIds"].push(item);
        }
        data["credits"] = this.credits;
        data["description"] = this.description;
        return data;
    }
}

/** MemberBonusRequest */
export interface IMemberBonusRequest {
    /** Gets or sets the member ids. */
    memberIds?: number[] | undefined;
    /** Gets or sets the credits. */
    credits: number;
    /** Gets or sets the description. */
    description?: string | undefined;
}

/** CanPurchaseCourseSessionStatus */
export enum CanPurchaseCourseSessionStatus {
    Unknown = 0,
    CanPurchase = 1,
    HasEternalRegistration = 2,
    HasInactiveRegistration = 3,
    UpdatedCourseSessionRegistrationMissing = 4,
    PrerequisiteCourseSessionRegistrationMissing = 5,
    ExistingSubscription = 6,
}

/** Contains the definition of an object of type MemberCompleteInfo. */
export class MemberCompleteInfo implements IMemberCompleteInfo {
    /** Gets or sets the adeli number. */
    adeliNumber?: string | undefined;
    /** Gets or sets the birth date. */
    birthDate!: string;
    /** Gets or sets the city. */
    city?: string | undefined;
    /** Gets or sets a value indicating whether [consent GDPR]. */
    consentGdpr!: boolean;
    /** Gets or sets the country. */
    country?: string | undefined;
    /** Gets or sets the fax. */
    fax?: string | undefined;
    /** Gets or sets the first phone. */
    firstPhone?: string | undefined;
    /** Gets or sets the gln number. */
    glnNumber?: string | undefined;
    /** Gets or sets the inami number. */
    inamiNumber?: string | undefined;
    /** Gets or sets a value indicating whether this MemberCompleteInfo is employee. */
    isEmployee!: boolean;
    /** Gets or sets a value indicating whether this instance is unemployee. */
    isUnemployed!: boolean;
    /** Gets or sets a value indicating whether [liberal profession]. */
    liberalProfession!: boolean;
    /** Gets or sets the name of the maiden. */
    maidenName?: string | undefined;
    /** Gets or sets the medical order number. */
    medicalOrderNumber?: string | undefined;
    /** Gets or sets the nationality. */
    nationality!: string;
    /** Gets or sets a value indicating whether [newsletter subscription]. */
    newsletterSubscription!: boolean;
    /** Gets or sets the number.? */
    number?: string | undefined;
    /** Gets or sets the pharmacy authorization number. */
    pharmacyAuthorizationNumber?: string | undefined;
    /** Gets or sets a value indicating whether [pharmacy authorization requirement]. */
    pharmacyAuthorizationRequirement!: boolean;
    /** Gets or sets the pole emploi number. */
    poleEmploiNumber?: string | undefined;
    /** Gets or sets the postal code. */
    postalCode?: string | undefined;
    /** Gets or sets the profession. */
    professionId!: number;
    /** Gets or sets the profession other. */
    professionOther?: string | undefined;
    /** Gets or sets the RPPS number. */
    rppsNumber?: string | undefined;
    /** Gets or sets the second phone. */
    secondPhone?: string | undefined;
    /** Gets or sets the society. */
    society?: string | undefined;
    /** Gets or sets the street. */
    street?: string | undefined;
    /** Gets or sets a value indicating whether [subject to vat]. */
    subjectToVat!: boolean;
    /** Gets or sets the vat number. */
    vatNumber?: string | undefined;
    /** Gets or sets the current profession. */
    currentProfessionId?: number | undefined;
    /** Gets or sets a value indicating whether PNC is in cart. */
    pncInCart!: boolean;

    constructor(data?: IMemberCompleteInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.adeliNumber = _data["adeliNumber"];
            this.birthDate = _data["birthDate"];
            this.city = _data["city"];
            this.consentGdpr = _data["consentGdpr"];
            this.country = _data["country"];
            this.fax = _data["fax"];
            this.firstPhone = _data["firstPhone"];
            this.glnNumber = _data["glnNumber"];
            this.inamiNumber = _data["inamiNumber"];
            this.isEmployee = _data["isEmployee"];
            this.isUnemployed = _data["isUnemployed"];
            this.liberalProfession = _data["liberalProfession"];
            this.maidenName = _data["maidenName"];
            this.medicalOrderNumber = _data["medicalOrderNumber"];
            this.nationality = _data["nationality"];
            this.newsletterSubscription = _data["newsletterSubscription"];
            this.number = _data["number"];
            this.pharmacyAuthorizationNumber = _data["pharmacyAuthorizationNumber"];
            this.pharmacyAuthorizationRequirement = _data["pharmacyAuthorizationRequirement"];
            this.poleEmploiNumber = _data["poleEmploiNumber"];
            this.postalCode = _data["postalCode"];
            this.professionId = _data["professionId"];
            this.professionOther = _data["professionOther"];
            this.rppsNumber = _data["rppsNumber"];
            this.secondPhone = _data["secondPhone"];
            this.society = _data["society"];
            this.street = _data["street"];
            this.subjectToVat = _data["subjectToVat"];
            this.vatNumber = _data["vatNumber"];
            this.currentProfessionId = _data["currentProfessionId"];
            this.pncInCart = _data["pncInCart"];
        }
    }

    static fromJS(data: any): MemberCompleteInfo {
        data = typeof data === 'object' ? data : {};
        let result = new MemberCompleteInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["adeliNumber"] = this.adeliNumber;
        data["birthDate"] = this.birthDate;
        data["city"] = this.city;
        data["consentGdpr"] = this.consentGdpr;
        data["country"] = this.country;
        data["fax"] = this.fax;
        data["firstPhone"] = this.firstPhone;
        data["glnNumber"] = this.glnNumber;
        data["inamiNumber"] = this.inamiNumber;
        data["isEmployee"] = this.isEmployee;
        data["isUnemployed"] = this.isUnemployed;
        data["liberalProfession"] = this.liberalProfession;
        data["maidenName"] = this.maidenName;
        data["medicalOrderNumber"] = this.medicalOrderNumber;
        data["nationality"] = this.nationality;
        data["newsletterSubscription"] = this.newsletterSubscription;
        data["number"] = this.number;
        data["pharmacyAuthorizationNumber"] = this.pharmacyAuthorizationNumber;
        data["pharmacyAuthorizationRequirement"] = this.pharmacyAuthorizationRequirement;
        data["poleEmploiNumber"] = this.poleEmploiNumber;
        data["postalCode"] = this.postalCode;
        data["professionId"] = this.professionId;
        data["professionOther"] = this.professionOther;
        data["rppsNumber"] = this.rppsNumber;
        data["secondPhone"] = this.secondPhone;
        data["society"] = this.society;
        data["street"] = this.street;
        data["subjectToVat"] = this.subjectToVat;
        data["vatNumber"] = this.vatNumber;
        data["currentProfessionId"] = this.currentProfessionId;
        data["pncInCart"] = this.pncInCart;
        return data;
    }
}

/** Contains the definition of an object of type MemberCompleteInfo. */
export interface IMemberCompleteInfo {
    /** Gets or sets the adeli number. */
    adeliNumber?: string | undefined;
    /** Gets or sets the birth date. */
    birthDate: string;
    /** Gets or sets the city. */
    city?: string | undefined;
    /** Gets or sets a value indicating whether [consent GDPR]. */
    consentGdpr: boolean;
    /** Gets or sets the country. */
    country?: string | undefined;
    /** Gets or sets the fax. */
    fax?: string | undefined;
    /** Gets or sets the first phone. */
    firstPhone?: string | undefined;
    /** Gets or sets the gln number. */
    glnNumber?: string | undefined;
    /** Gets or sets the inami number. */
    inamiNumber?: string | undefined;
    /** Gets or sets a value indicating whether this MemberCompleteInfo is employee. */
    isEmployee: boolean;
    /** Gets or sets a value indicating whether this instance is unemployee. */
    isUnemployed: boolean;
    /** Gets or sets a value indicating whether [liberal profession]. */
    liberalProfession: boolean;
    /** Gets or sets the name of the maiden. */
    maidenName?: string | undefined;
    /** Gets or sets the medical order number. */
    medicalOrderNumber?: string | undefined;
    /** Gets or sets the nationality. */
    nationality: string;
    /** Gets or sets a value indicating whether [newsletter subscription]. */
    newsletterSubscription: boolean;
    /** Gets or sets the number.? */
    number?: string | undefined;
    /** Gets or sets the pharmacy authorization number. */
    pharmacyAuthorizationNumber?: string | undefined;
    /** Gets or sets a value indicating whether [pharmacy authorization requirement]. */
    pharmacyAuthorizationRequirement: boolean;
    /** Gets or sets the pole emploi number. */
    poleEmploiNumber?: string | undefined;
    /** Gets or sets the postal code. */
    postalCode?: string | undefined;
    /** Gets or sets the profession. */
    professionId: number;
    /** Gets or sets the profession other. */
    professionOther?: string | undefined;
    /** Gets or sets the RPPS number. */
    rppsNumber?: string | undefined;
    /** Gets or sets the second phone. */
    secondPhone?: string | undefined;
    /** Gets or sets the society. */
    society?: string | undefined;
    /** Gets or sets the street. */
    street?: string | undefined;
    /** Gets or sets a value indicating whether [subject to vat]. */
    subjectToVat: boolean;
    /** Gets or sets the vat number. */
    vatNumber?: string | undefined;
    /** Gets or sets the current profession. */
    currentProfessionId?: number | undefined;
    /** Gets or sets a value indicating whether PNC is in cart. */
    pncInCart: boolean;
}

/** Contains the definition of an object of type MemberInfoToCreateFromExistingAccount. */
export class MemberInfoToCreateFromExistingAccount implements IMemberInfoToCreateFromExistingAccount {
    /** Gets or sets the advantage code. */
    advantageCode?: string | undefined;
    /** Gets or sets the firstname. */
    firstName!: string;
    /** Gets or sets the gender. */
    gender!: string;
    /** Gets or sets the lastname. */
    lastName!: string;
    /** Gets or sets the password. */
    password!: string;

    constructor(data?: IMemberInfoToCreateFromExistingAccount) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.advantageCode = _data["advantageCode"];
            this.firstName = _data["firstName"];
            this.gender = _data["gender"];
            this.lastName = _data["lastName"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): MemberInfoToCreateFromExistingAccount {
        data = typeof data === 'object' ? data : {};
        let result = new MemberInfoToCreateFromExistingAccount();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["advantageCode"] = this.advantageCode;
        data["firstName"] = this.firstName;
        data["gender"] = this.gender;
        data["lastName"] = this.lastName;
        data["password"] = this.password;
        return data;
    }
}

/** Contains the definition of an object of type MemberInfoToCreateFromExistingAccount. */
export interface IMemberInfoToCreateFromExistingAccount {
    /** Gets or sets the advantage code. */
    advantageCode?: string | undefined;
    /** Gets or sets the firstname. */
    firstName: string;
    /** Gets or sets the gender. */
    gender: string;
    /** Gets or sets the lastname. */
    lastName: string;
    /** Gets or sets the password. */
    password: string;
}

/** Contains the definition of an object of type ExternalCursusMember */
export class ExternalCursusMember implements IExternalCursusMember {
    /** Gets or sets the identifier. */
    id!: number;
    /** Gets or sets the first name. */
    firstName?: string | undefined;
    /** Gets or sets the last name. */
    lastName?: string | undefined;
    /** Gets or sets the email. */
    email?: string | undefined;
    /** Gets or sets the school year. */
    externalCursusId!: number;

    constructor(data?: IExternalCursusMember) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.externalCursusId = _data["externalCursusId"];
        }
    }

    static fromJS(data: any): ExternalCursusMember {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalCursusMember();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["externalCursusId"] = this.externalCursusId;
        return data;
    }
}

/** Contains the definition of an object of type ExternalCursusMember */
export interface IExternalCursusMember {
    /** Gets or sets the identifier. */
    id: number;
    /** Gets or sets the first name. */
    firstName?: string | undefined;
    /** Gets or sets the last name. */
    lastName?: string | undefined;
    /** Gets or sets the email. */
    email?: string | undefined;
    /** Gets or sets the school year. */
    externalCursusId: number;
}

/** Contains the definition of an object of type MemberBasicInfo. */
export class MemberBasicInfo implements IMemberBasicInfo {
    /** Gets or sets the advantage code. */
    advantageCode?: string | undefined;
    /** Gets or sets the email. */
    email!: string;
    /** Gets or sets the firstname. */
    firstName!: string;
    /** Gets or sets the gender. */
    gender!: string;
    /** Gets or sets the lastname. */
    lastName!: string;
    /** Gets or sets the password. */
    password!: string;
    /** Gets or sets the sponsorship code. */
    sponsorshipCode?: string | undefined;

    constructor(data?: IMemberBasicInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.advantageCode = _data["advantageCode"];
            this.email = _data["email"];
            this.firstName = _data["firstName"];
            this.gender = _data["gender"];
            this.lastName = _data["lastName"];
            this.password = _data["password"];
            this.sponsorshipCode = _data["sponsorshipCode"];
        }
    }

    static fromJS(data: any): MemberBasicInfo {
        data = typeof data === 'object' ? data : {};
        let result = new MemberBasicInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["advantageCode"] = this.advantageCode;
        data["email"] = this.email;
        data["firstName"] = this.firstName;
        data["gender"] = this.gender;
        data["lastName"] = this.lastName;
        data["password"] = this.password;
        data["sponsorshipCode"] = this.sponsorshipCode;
        return data;
    }
}

/** Contains the definition of an object of type MemberBasicInfo. */
export interface IMemberBasicInfo {
    /** Gets or sets the advantage code. */
    advantageCode?: string | undefined;
    /** Gets or sets the email. */
    email: string;
    /** Gets or sets the firstname. */
    firstName: string;
    /** Gets or sets the gender. */
    gender: string;
    /** Gets or sets the lastname. */
    lastName: string;
    /** Gets or sets the password. */
    password: string;
    /** Gets or sets the sponsorship code. */
    sponsorshipCode?: string | undefined;
}

/** Contains the definition of an object of type PatientSignalitics. */
export class PatientSignalitics extends PatientInfo implements IPatientSignalitics {
    /** Gets or sets the address. */
    address?: string | undefined;
    /** Gets or sets the city. */
    city?: string | undefined;
    /** Gets or sets the country. */
    country?: string | undefined;
    /** Gets or sets the department. */
    departement?: string | undefined;
    /** Gets or sets the language. */
    language?: string | undefined;
    /** Gets or sets the name of the maiden. */
    maidenName?: string | undefined;
    /** Gets or sets the number. */
    number?: string | undefined;
    /** Gets or sets the postal code. */
    postalCode?: string | undefined;
    /** Gets or sets the size. */
    size?: number | undefined;
    /** Gets or sets the street. */
    street?: string | undefined;
    /** Gets or sets the weight. */
    weight?: number | undefined;
    /** Gets or sets the profession. */
    profession?: string | undefined;
    /** Gets or sets the marital status. */
    maritalStatus?: string | undefined;
    /** Gets or sets the family situation. */
    familySituation?: string | undefined;

    constructor(data?: IPatientSignalitics) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.address = _data["address"];
            this.city = _data["city"];
            this.country = _data["country"];
            this.departement = _data["departement"];
            this.language = _data["language"];
            this.maidenName = _data["maidenName"];
            this.number = _data["number"];
            this.postalCode = _data["postalCode"];
            this.size = _data["size"];
            this.street = _data["street"];
            this.weight = _data["weight"];
            this.profession = _data["profession"];
            this.maritalStatus = _data["maritalStatus"];
            this.familySituation = _data["familySituation"];
        }
    }

    static override fromJS(data: any): PatientSignalitics {
        data = typeof data === 'object' ? data : {};
        let result = new PatientSignalitics();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["address"] = this.address;
        data["city"] = this.city;
        data["country"] = this.country;
        data["departement"] = this.departement;
        data["language"] = this.language;
        data["maidenName"] = this.maidenName;
        data["number"] = this.number;
        data["postalCode"] = this.postalCode;
        data["size"] = this.size;
        data["street"] = this.street;
        data["weight"] = this.weight;
        data["profession"] = this.profession;
        data["maritalStatus"] = this.maritalStatus;
        data["familySituation"] = this.familySituation;
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type PatientSignalitics. */
export interface IPatientSignalitics extends IPatientInfo {
    /** Gets or sets the address. */
    address?: string | undefined;
    /** Gets or sets the city. */
    city?: string | undefined;
    /** Gets or sets the country. */
    country?: string | undefined;
    /** Gets or sets the department. */
    departement?: string | undefined;
    /** Gets or sets the language. */
    language?: string | undefined;
    /** Gets or sets the name of the maiden. */
    maidenName?: string | undefined;
    /** Gets or sets the number. */
    number?: string | undefined;
    /** Gets or sets the postal code. */
    postalCode?: string | undefined;
    /** Gets or sets the size. */
    size?: number | undefined;
    /** Gets or sets the street. */
    street?: string | undefined;
    /** Gets or sets the weight. */
    weight?: number | undefined;
    /** Gets or sets the profession. */
    profession?: string | undefined;
    /** Gets or sets the marital status. */
    maritalStatus?: string | undefined;
    /** Gets or sets the family situation. */
    familySituation?: string | undefined;
}

/** Contains the definition of an object of type PatientRegistrationInfos */
export class PatientRegistrationInfos extends PatientSignalitics implements IPatientRegistrationInfos {
    /** Gets or sets a value indicating whether this instance has accepted GPDR. */
    hasAcceptedGdpr!: boolean;
    /** Gets or sets the password. */
    password?: string | undefined;
    /** Gets or sets the biody id. */
    biodyId?: number | undefined;

    constructor(data?: IPatientRegistrationInfos) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.hasAcceptedGdpr = _data["hasAcceptedGdpr"];
            this.password = _data["password"];
            this.biodyId = _data["biodyId"];
        }
    }

    static override fromJS(data: any): PatientRegistrationInfos {
        data = typeof data === 'object' ? data : {};
        let result = new PatientRegistrationInfos();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasAcceptedGdpr"] = this.hasAcceptedGdpr;
        data["password"] = this.password;
        data["biodyId"] = this.biodyId;
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type PatientRegistrationInfos */
export interface IPatientRegistrationInfos extends IPatientSignalitics {
    /** Gets or sets a value indicating whether this instance has accepted GPDR. */
    hasAcceptedGdpr: boolean;
    /** Gets or sets the password. */
    password?: string | undefined;
    /** Gets or sets the biody id. */
    biodyId?: number | undefined;
}

/** Contains the definition of an object of type CurrentMemberInfo. */
export class CurrentMemberInfo implements ICurrentMemberInfo {
    /** Gets or sets the adeli number. */
    adeliNumber?: string | undefined;
    /** Gets or sets the advantage code. */
    advantageCode?: string | undefined;
    /** Gets or sets the birth date. */
    birthDate!: Date;
    /** Gets or sets the City. */
    city!: string;
    /** Gets or sets a value indicating whether [consent GDPR]. */
    consentGdpr!: boolean;
    /** Gets or sets the country. */
    country!: string;
    /** Gets or sets the firstname. */
    firstname!: string;
    /** Gets or sets the first phone. */
    firstPhone?: string | undefined;
    /** Gets or sets the gender. */
    gender!: string;
    /** Gets or sets the inami number. */
    glnNumber?: string | undefined;
    /** Gets or sets the identifier. */
    id!: number;
    /** Gets or sets the inami number. */
    inamiNumber?: string | undefined;
    /** Gets or sets a value indicating whether this CurrentMemberInfo is employee. */
    isEmployee!: boolean;
    /** Gets or sets a value indicating whether [liberal profession]. */
    liberalProfession!: boolean;
    /** Gets or sets the name of the maiden. */
    maidenName?: string | undefined;
    /** Gets or sets the medical order number. */
    medicalOrderNumber?: string | undefined;
    /** Gets or sets the nationality. */
    nationality!: string;
    /** Gets or sets the Number. */
    number!: string;
    /** Gets or sets the pharmacy authorization number. */
    pharmacyAuthorizationNumber?: string | undefined;
    /** Gets or sets the PostalCode. */
    postalCode!: string;
    /** Gets or sets the profession identifier. */
    professionId!: number;
    /** Gets or sets the RPPS number. */
    rppsNumber?: string | undefined;
    /** Gets or sets the society. */
    society?: string | undefined;
    /** Gets or sets the street. */
    street!: string;
    /** Gets or sets a value indicating whether [subject to vat]. */
    subjectToVat!: boolean;
    /** Gets or sets the name of the user. */
    userName!: string;
    /** Gets or sets the vat number. */
    vatNumber?: string | undefined;
    /** Gets or sets the current profession identifier. */
    currentProfessionId?: number | undefined;

    constructor(data?: ICurrentMemberInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.adeliNumber = _data["adeliNumber"];
            this.advantageCode = _data["advantageCode"];
            this.birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : <any>undefined;
            this.city = _data["city"];
            this.consentGdpr = _data["consentGdpr"];
            this.country = _data["country"];
            this.firstname = _data["firstname"];
            this.firstPhone = _data["firstPhone"];
            this.gender = _data["gender"];
            this.glnNumber = _data["glnNumber"];
            this.id = _data["id"];
            this.inamiNumber = _data["inamiNumber"];
            this.isEmployee = _data["isEmployee"];
            this.liberalProfession = _data["liberalProfession"];
            this.maidenName = _data["maidenName"];
            this.medicalOrderNumber = _data["medicalOrderNumber"];
            this.nationality = _data["nationality"];
            this.number = _data["number"];
            this.pharmacyAuthorizationNumber = _data["pharmacyAuthorizationNumber"];
            this.postalCode = _data["postalCode"];
            this.professionId = _data["professionId"];
            this.rppsNumber = _data["rppsNumber"];
            this.society = _data["society"];
            this.street = _data["street"];
            this.subjectToVat = _data["subjectToVat"];
            this.userName = _data["userName"];
            this.vatNumber = _data["vatNumber"];
            this.currentProfessionId = _data["currentProfessionId"];
        }
    }

    static fromJS(data: any): CurrentMemberInfo {
        data = typeof data === 'object' ? data : {};
        let result = new CurrentMemberInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["adeliNumber"] = this.adeliNumber;
        data["advantageCode"] = this.advantageCode;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["city"] = this.city;
        data["consentGdpr"] = this.consentGdpr;
        data["country"] = this.country;
        data["firstname"] = this.firstname;
        data["firstPhone"] = this.firstPhone;
        data["gender"] = this.gender;
        data["glnNumber"] = this.glnNumber;
        data["id"] = this.id;
        data["inamiNumber"] = this.inamiNumber;
        data["isEmployee"] = this.isEmployee;
        data["liberalProfession"] = this.liberalProfession;
        data["maidenName"] = this.maidenName;
        data["medicalOrderNumber"] = this.medicalOrderNumber;
        data["nationality"] = this.nationality;
        data["number"] = this.number;
        data["pharmacyAuthorizationNumber"] = this.pharmacyAuthorizationNumber;
        data["postalCode"] = this.postalCode;
        data["professionId"] = this.professionId;
        data["rppsNumber"] = this.rppsNumber;
        data["society"] = this.society;
        data["street"] = this.street;
        data["subjectToVat"] = this.subjectToVat;
        data["userName"] = this.userName;
        data["vatNumber"] = this.vatNumber;
        data["currentProfessionId"] = this.currentProfessionId;
        return data;
    }
}

/** Contains the definition of an object of type CurrentMemberInfo. */
export interface ICurrentMemberInfo {
    /** Gets or sets the adeli number. */
    adeliNumber?: string | undefined;
    /** Gets or sets the advantage code. */
    advantageCode?: string | undefined;
    /** Gets or sets the birth date. */
    birthDate: Date;
    /** Gets or sets the City. */
    city: string;
    /** Gets or sets a value indicating whether [consent GDPR]. */
    consentGdpr: boolean;
    /** Gets or sets the country. */
    country: string;
    /** Gets or sets the firstname. */
    firstname: string;
    /** Gets or sets the first phone. */
    firstPhone?: string | undefined;
    /** Gets or sets the gender. */
    gender: string;
    /** Gets or sets the inami number. */
    glnNumber?: string | undefined;
    /** Gets or sets the identifier. */
    id: number;
    /** Gets or sets the inami number. */
    inamiNumber?: string | undefined;
    /** Gets or sets a value indicating whether this CurrentMemberInfo is employee. */
    isEmployee: boolean;
    /** Gets or sets a value indicating whether [liberal profession]. */
    liberalProfession: boolean;
    /** Gets or sets the name of the maiden. */
    maidenName?: string | undefined;
    /** Gets or sets the medical order number. */
    medicalOrderNumber?: string | undefined;
    /** Gets or sets the nationality. */
    nationality: string;
    /** Gets or sets the Number. */
    number: string;
    /** Gets or sets the pharmacy authorization number. */
    pharmacyAuthorizationNumber?: string | undefined;
    /** Gets or sets the PostalCode. */
    postalCode: string;
    /** Gets or sets the profession identifier. */
    professionId: number;
    /** Gets or sets the RPPS number. */
    rppsNumber?: string | undefined;
    /** Gets or sets the society. */
    society?: string | undefined;
    /** Gets or sets the street. */
    street: string;
    /** Gets or sets a value indicating whether [subject to vat]. */
    subjectToVat: boolean;
    /** Gets or sets the name of the user. */
    userName: string;
    /** Gets or sets the vat number. */
    vatNumber?: string | undefined;
    /** Gets or sets the current profession identifier. */
    currentProfessionId?: number | undefined;
}

/** Contains the definition of an object of type CurrentMemberDetails. */
export class CurrentMemberDetails extends CurrentMemberInfo implements ICurrentMemberDetails {
    /** Gets or sets the description. */
    description?: string | undefined;
    /** Gets or sets the directory city. */
    directoryCity!: string;
    /** Gets or sets the directory country. */
    directoryCountry!: string;
    /** Gets or sets the directory email. */
    directoryEmail?: string | undefined;
    /** Gets or sets the directory number. */
    directoryNumber!: string;
    /** Gets or sets the directory other information. */
    directoryOtherInfo?: string | undefined;
    /** Gets or sets the directory phone. */
    directoryPhone?: string | undefined;
    /** Gets or sets the directory postal code. */
    directoryPostalCode!: string;
    /** Gets or sets the directory street. */
    directoryStreet!: string;
    /** Gets or sets a value indicating whether [directory use another address]. */
    directoryUseAnotherAddress!: boolean;
    /** Gets or sets the email. */
    email!: string;
    /** Gets or sets the fax. */
    fax?: string | undefined;
    /** Gets or sets the godchild code. */
    godchildCode?: string | undefined;
    /** Gets or sets a value indicating whether [hide in directory]. */
    hideInDirectory!: boolean;
    /** Gets or sets the image URL. */
    imageUrl?: string | undefined;
    /** Gets or sets the language. */
    language?: string | undefined;
    /** Gets or sets the last name. */
    lastName!: string;
    /** Gets or sets a value indicating whether [newsletter subscription]. */
    newsletterSubscription!: boolean;
    /** Gets or sets the pole emploi number. */
    poleEmploiNumber?: string | undefined;
    /** Gets or sets the profession other. */
    professionOther?: string | undefined;
    /** Gets or sets the schedules. */
    schedules?: Schedule[] | undefined;
    /** Gets or sets the schedules string. */
    schedulesString?: string | undefined;
    /** Gets or sets the second phone. */
    secondPhone?: string | undefined;
    /** Gets or sets the speciality. */
    speciality?: string | undefined;
    /** Gets or sets the speciality identifier. */
    specialityId?: string | undefined;
    /** Gets or sets the speciality text field. */
    specialityTextField?: string | undefined;
    /** Gets or sets the sponsorship code. */
    sponsorshipCode?: string | undefined;
    /** Gets or sets the types identifier. */
    typesId?: number[] | undefined;
    /** Gets or sets a value indicating whether this CurrentMemberDetails is unemployed. */
    unemployed!: boolean;
    /** Gets or sets the website. */
    website?: string | undefined;
    /** Gets or sets a value indicating whether to lock the profession. */
    lockProfession!: boolean;

    constructor(data?: ICurrentMemberDetails) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.description = _data["description"];
            this.directoryCity = _data["directoryCity"];
            this.directoryCountry = _data["directoryCountry"];
            this.directoryEmail = _data["directoryEmail"];
            this.directoryNumber = _data["directoryNumber"];
            this.directoryOtherInfo = _data["directoryOtherInfo"];
            this.directoryPhone = _data["directoryPhone"];
            this.directoryPostalCode = _data["directoryPostalCode"];
            this.directoryStreet = _data["directoryStreet"];
            this.directoryUseAnotherAddress = _data["directoryUseAnotherAddress"];
            this.email = _data["email"];
            this.fax = _data["fax"];
            this.godchildCode = _data["godchildCode"];
            this.hideInDirectory = _data["hideInDirectory"];
            this.imageUrl = _data["imageUrl"];
            this.language = _data["language"];
            this.lastName = _data["lastName"];
            this.newsletterSubscription = _data["newsletterSubscription"];
            this.poleEmploiNumber = _data["poleEmploiNumber"];
            this.professionOther = _data["professionOther"];
            if (Array.isArray(_data["schedules"])) {
                this.schedules = [] as any;
                for (let item of _data["schedules"])
                    this.schedules!.push(Schedule.fromJS(item));
            }
            this.schedulesString = _data["schedulesString"];
            this.secondPhone = _data["secondPhone"];
            this.speciality = _data["speciality"];
            this.specialityId = _data["specialityId"];
            this.specialityTextField = _data["specialityTextField"];
            this.sponsorshipCode = _data["sponsorshipCode"];
            if (Array.isArray(_data["typesId"])) {
                this.typesId = [] as any;
                for (let item of _data["typesId"])
                    this.typesId!.push(item);
            }
            this.unemployed = _data["unemployed"];
            this.website = _data["website"];
            this.lockProfession = _data["lockProfession"];
        }
    }

    static override fromJS(data: any): CurrentMemberDetails {
        data = typeof data === 'object' ? data : {};
        let result = new CurrentMemberDetails();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["directoryCity"] = this.directoryCity;
        data["directoryCountry"] = this.directoryCountry;
        data["directoryEmail"] = this.directoryEmail;
        data["directoryNumber"] = this.directoryNumber;
        data["directoryOtherInfo"] = this.directoryOtherInfo;
        data["directoryPhone"] = this.directoryPhone;
        data["directoryPostalCode"] = this.directoryPostalCode;
        data["directoryStreet"] = this.directoryStreet;
        data["directoryUseAnotherAddress"] = this.directoryUseAnotherAddress;
        data["email"] = this.email;
        data["fax"] = this.fax;
        data["godchildCode"] = this.godchildCode;
        data["hideInDirectory"] = this.hideInDirectory;
        data["imageUrl"] = this.imageUrl;
        data["language"] = this.language;
        data["lastName"] = this.lastName;
        data["newsletterSubscription"] = this.newsletterSubscription;
        data["poleEmploiNumber"] = this.poleEmploiNumber;
        data["professionOther"] = this.professionOther;
        if (Array.isArray(this.schedules)) {
            data["schedules"] = [];
            for (let item of this.schedules)
                data["schedules"].push(item ? item.toJSON() : <any>undefined);
        }
        data["schedulesString"] = this.schedulesString;
        data["secondPhone"] = this.secondPhone;
        data["speciality"] = this.speciality;
        data["specialityId"] = this.specialityId;
        data["specialityTextField"] = this.specialityTextField;
        data["sponsorshipCode"] = this.sponsorshipCode;
        if (Array.isArray(this.typesId)) {
            data["typesId"] = [];
            for (let item of this.typesId)
                data["typesId"].push(item);
        }
        data["unemployed"] = this.unemployed;
        data["website"] = this.website;
        data["lockProfession"] = this.lockProfession;
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type CurrentMemberDetails. */
export interface ICurrentMemberDetails extends ICurrentMemberInfo {
    /** Gets or sets the description. */
    description?: string | undefined;
    /** Gets or sets the directory city. */
    directoryCity: string;
    /** Gets or sets the directory country. */
    directoryCountry: string;
    /** Gets or sets the directory email. */
    directoryEmail?: string | undefined;
    /** Gets or sets the directory number. */
    directoryNumber: string;
    /** Gets or sets the directory other information. */
    directoryOtherInfo?: string | undefined;
    /** Gets or sets the directory phone. */
    directoryPhone?: string | undefined;
    /** Gets or sets the directory postal code. */
    directoryPostalCode: string;
    /** Gets or sets the directory street. */
    directoryStreet: string;
    /** Gets or sets a value indicating whether [directory use another address]. */
    directoryUseAnotherAddress: boolean;
    /** Gets or sets the email. */
    email: string;
    /** Gets or sets the fax. */
    fax?: string | undefined;
    /** Gets or sets the godchild code. */
    godchildCode?: string | undefined;
    /** Gets or sets a value indicating whether [hide in directory]. */
    hideInDirectory: boolean;
    /** Gets or sets the image URL. */
    imageUrl?: string | undefined;
    /** Gets or sets the language. */
    language?: string | undefined;
    /** Gets or sets the last name. */
    lastName: string;
    /** Gets or sets a value indicating whether [newsletter subscription]. */
    newsletterSubscription: boolean;
    /** Gets or sets the pole emploi number. */
    poleEmploiNumber?: string | undefined;
    /** Gets or sets the profession other. */
    professionOther?: string | undefined;
    /** Gets or sets the schedules. */
    schedules?: Schedule[] | undefined;
    /** Gets or sets the schedules string. */
    schedulesString?: string | undefined;
    /** Gets or sets the second phone. */
    secondPhone?: string | undefined;
    /** Gets or sets the speciality. */
    speciality?: string | undefined;
    /** Gets or sets the speciality identifier. */
    specialityId?: string | undefined;
    /** Gets or sets the speciality text field. */
    specialityTextField?: string | undefined;
    /** Gets or sets the sponsorship code. */
    sponsorshipCode?: string | undefined;
    /** Gets or sets the types identifier. */
    typesId?: number[] | undefined;
    /** Gets or sets a value indicating whether this CurrentMemberDetails is unemployed. */
    unemployed: boolean;
    /** Gets or sets the website. */
    website?: string | undefined;
    /** Gets or sets a value indicating whether to lock the profession. */
    lockProfession: boolean;
}

/** Contains the definition of an object of type UpdatePassword. */
export class UpdatePassword implements IUpdatePassword {
    /** Gets or sets the old password. */
    oldPassword!: string;
    /** Gets or sets the password. */
    password!: string;

    constructor(data?: IUpdatePassword) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.oldPassword = _data["oldPassword"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): UpdatePassword {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePassword();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["oldPassword"] = this.oldPassword;
        data["password"] = this.password;
        return data;
    }
}

/** Contains the definition of an object of type UpdatePassword. */
export interface IUpdatePassword {
    /** Gets or sets the old password. */
    oldPassword: string;
    /** Gets or sets the password. */
    password: string;
}

/** Contains the definition of an object of type MemberActive. */
export class MemberActive implements IMemberActive {
    /** Gets or sets the city. */
    city?: string | undefined;
    /** Gets or sets the country. */
    country?: string | undefined;
    /** Gets the display name. */
    displayName?: string | undefined;
    /** Gets or sets the firstname. */
    firstname?: string | undefined;
    /** Gets or sets a value indicating whether this instance has diploma. */
    hasDiploma!: boolean;
    /** Gets or sets the identifier. */
    id!: number;
    /** Gets or sets the lastname. */
    lastname?: string | undefined;
    /** Gets or sets the latitude. */
    latitude!: number;
    /** Gets or sets the longitude. */
    longitude!: number;
    /** Gets or sets the moodle identifier. */
    moodleId!: number;
    /** Gets or sets the nationality. */
    nationality?: string | undefined;
    /** Gets or sets the postal code. */
    postalCode?: string | undefined;
    /** Gets or sets the type of the profession logo. */
    professionLogoType?: string | undefined;
    /** Gets or sets the name of the profession. */
    professionName?: string | undefined;
    /** Gets or sets the profession. */
    professionOther?: string | undefined;
    /** Gets or sets the street. */
    street?: string | undefined;
    /** Gets or sets the street number. */
    streetNumber?: string | undefined;
    /** Gets or sets the URL. */
    url?: string | undefined;

    constructor(data?: IMemberActive) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.city = _data["city"];
            this.country = _data["country"];
            this.displayName = _data["displayName"];
            this.firstname = _data["firstname"];
            this.hasDiploma = _data["hasDiploma"];
            this.id = _data["id"];
            this.lastname = _data["lastname"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.moodleId = _data["moodleId"];
            this.nationality = _data["nationality"];
            this.postalCode = _data["postalCode"];
            this.professionLogoType = _data["professionLogoType"];
            this.professionName = _data["professionName"];
            this.professionOther = _data["professionOther"];
            this.street = _data["street"];
            this.streetNumber = _data["streetNumber"];
            this.url = _data["url"];
        }
    }

    static fromJS(data: any): MemberActive {
        data = typeof data === 'object' ? data : {};
        let result = new MemberActive();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["city"] = this.city;
        data["country"] = this.country;
        data["displayName"] = this.displayName;
        data["firstname"] = this.firstname;
        data["hasDiploma"] = this.hasDiploma;
        data["id"] = this.id;
        data["lastname"] = this.lastname;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["moodleId"] = this.moodleId;
        data["nationality"] = this.nationality;
        data["postalCode"] = this.postalCode;
        data["professionLogoType"] = this.professionLogoType;
        data["professionName"] = this.professionName;
        data["professionOther"] = this.professionOther;
        data["street"] = this.street;
        data["streetNumber"] = this.streetNumber;
        data["url"] = this.url;
        return data;
    }
}

/** Contains the definition of an object of type MemberActive. */
export interface IMemberActive {
    /** Gets or sets the city. */
    city?: string | undefined;
    /** Gets or sets the country. */
    country?: string | undefined;
    /** Gets the display name. */
    displayName?: string | undefined;
    /** Gets or sets the firstname. */
    firstname?: string | undefined;
    /** Gets or sets a value indicating whether this instance has diploma. */
    hasDiploma: boolean;
    /** Gets or sets the identifier. */
    id: number;
    /** Gets or sets the lastname. */
    lastname?: string | undefined;
    /** Gets or sets the latitude. */
    latitude: number;
    /** Gets or sets the longitude. */
    longitude: number;
    /** Gets or sets the moodle identifier. */
    moodleId: number;
    /** Gets or sets the nationality. */
    nationality?: string | undefined;
    /** Gets or sets the postal code. */
    postalCode?: string | undefined;
    /** Gets or sets the type of the profession logo. */
    professionLogoType?: string | undefined;
    /** Gets or sets the name of the profession. */
    professionName?: string | undefined;
    /** Gets or sets the profession. */
    professionOther?: string | undefined;
    /** Gets or sets the street. */
    street?: string | undefined;
    /** Gets or sets the street number. */
    streetNumber?: string | undefined;
    /** Gets or sets the URL. */
    url?: string | undefined;
}

/** Contains the definition of an object of type MemberActiveSearchParams. */
export class MemberActiveSearchParams extends SearchParams implements IMemberActiveSearchParams {
    /** Gets or sets the address. */
    address?: string | undefined;
    /** Gets or sets the diploma ids. */
    diplomaIds?: number[] | undefined;
    /** Gets or sets the lastname. */
    lastname?: string | undefined;
    /** Gets or sets the profession identifier. */
    professionId?: number | undefined;
    /** Gets or sets the specialization identifier. */
    specializationId?: number | undefined;
    /** Gets or sets the radius. */
    radius?: number | undefined;

    constructor(data?: IMemberActiveSearchParams) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.address = _data["address"];
            if (Array.isArray(_data["diplomaIds"])) {
                this.diplomaIds = [] as any;
                for (let item of _data["diplomaIds"])
                    this.diplomaIds!.push(item);
            }
            this.lastname = _data["lastname"];
            this.professionId = _data["professionId"];
            this.specializationId = _data["specializationId"];
            this.radius = _data["radius"];
        }
    }

    static override fromJS(data: any): MemberActiveSearchParams {
        data = typeof data === 'object' ? data : {};
        let result = new MemberActiveSearchParams();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["address"] = this.address;
        if (Array.isArray(this.diplomaIds)) {
            data["diplomaIds"] = [];
            for (let item of this.diplomaIds)
                data["diplomaIds"].push(item);
        }
        data["lastname"] = this.lastname;
        data["professionId"] = this.professionId;
        data["specializationId"] = this.specializationId;
        data["radius"] = this.radius;
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type MemberActiveSearchParams. */
export interface IMemberActiveSearchParams extends ISearchParams {
    /** Gets or sets the address. */
    address?: string | undefined;
    /** Gets or sets the diploma ids. */
    diplomaIds?: number[] | undefined;
    /** Gets or sets the lastname. */
    lastname?: string | undefined;
    /** Gets or sets the profession identifier. */
    professionId?: number | undefined;
    /** Gets or sets the specialization identifier. */
    specializationId?: number | undefined;
    /** Gets or sets the radius. */
    radius?: number | undefined;
}

/** Contains the definition of an object of type ExternalCursus */
export class ExternalCursus implements IExternalCursus {
    /** Gets or sets the identifier. */
    id!: number;
    /** Gets or sets the auto inscription end date. */
    inscriptionEndDate?: Date | undefined;
    /** Gets or sets the course session list. */
    sessions?: ExternalCursusSession[] | undefined;
    /** Gets or sets the school year. */
    schoolYear?: string | undefined;
    /** Gets or sets the external cursus members. */
    externalCursusMembers?: ExternalCursusMember[] | undefined;

    constructor(data?: IExternalCursus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.inscriptionEndDate = _data["inscriptionEndDate"] ? new Date(_data["inscriptionEndDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["sessions"])) {
                this.sessions = [] as any;
                for (let item of _data["sessions"])
                    this.sessions!.push(ExternalCursusSession.fromJS(item));
            }
            this.schoolYear = _data["schoolYear"];
            if (Array.isArray(_data["externalCursusMembers"])) {
                this.externalCursusMembers = [] as any;
                for (let item of _data["externalCursusMembers"])
                    this.externalCursusMembers!.push(ExternalCursusMember.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ExternalCursus {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalCursus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["inscriptionEndDate"] = this.inscriptionEndDate ? this.inscriptionEndDate.toISOString() : <any>undefined;
        if (Array.isArray(this.sessions)) {
            data["sessions"] = [];
            for (let item of this.sessions)
                data["sessions"].push(item ? item.toJSON() : <any>undefined);
        }
        data["schoolYear"] = this.schoolYear;
        if (Array.isArray(this.externalCursusMembers)) {
            data["externalCursusMembers"] = [];
            for (let item of this.externalCursusMembers)
                data["externalCursusMembers"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

/** Contains the definition of an object of type ExternalCursus */
export interface IExternalCursus {
    /** Gets or sets the identifier. */
    id: number;
    /** Gets or sets the auto inscription end date. */
    inscriptionEndDate?: Date | undefined;
    /** Gets or sets the course session list. */
    sessions?: ExternalCursusSession[] | undefined;
    /** Gets or sets the school year. */
    schoolYear?: string | undefined;
    /** Gets or sets the external cursus members. */
    externalCursusMembers?: ExternalCursusMember[] | undefined;
}

/** Contains the definition of an object of type ExternalCursusSession */
export class ExternalCursusSession implements IExternalCursusSession {
    /** Gets or sets the identifier. */
    id!: number;
    /** Gets or sets the session identifier. */
    sessionId!: number;
    /** Gets or sets the session identifier. */
    session?: CourseSession | undefined;
    /** Gets or sets the external cursus identifier. */
    externalCursusId!: number;

    constructor(data?: IExternalCursusSession) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sessionId = _data["sessionId"];
            this.session = _data["session"] ? CourseSession.fromJS(_data["session"]) : <any>undefined;
            this.externalCursusId = _data["externalCursusId"];
        }
    }

    static fromJS(data: any): ExternalCursusSession {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalCursusSession();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sessionId"] = this.sessionId;
        data["session"] = this.session ? this.session.toJSON() : <any>undefined;
        data["externalCursusId"] = this.externalCursusId;
        return data;
    }
}

/** Contains the definition of an object of type ExternalCursusSession */
export interface IExternalCursusSession {
    /** Gets or sets the identifier. */
    id: number;
    /** Gets or sets the session identifier. */
    sessionId: number;
    /** Gets or sets the session identifier. */
    session?: CourseSession | undefined;
    /** Gets or sets the external cursus identifier. */
    externalCursusId: number;
}

/** Contains the definition of an object of type CourseSession. */
export class CourseSession implements ICourseSession {
    /** Gets or sets the course training identifier. */
    courseTrainingId!: number;
    /** Gets or sets the identifier. */
    id!: number;
    /** Gets or sets a value indicating whether this instance is eligible DPC. */
    isEligibleDPCReduction!: boolean;
    /** Gets or sets the publication status. */
    publicationStatus!: CourseSessionStatus;
    /** Gets or sets the session end date. */
    sessionEndDate?: Date | undefined;
    /** Gets or sets the session start date. */
    sessionStartDate!: Date;
    /** Gets or sets the full name. */
    shortName?: string | undefined;
    /** Gets or sets a value indicating whether to notify the inactivity by mail. */
    inactivityNotification!: boolean;
    /** Gets or sets a value indicating whether to enable and send the surveys by mail. */
    surveyEnabled!: boolean;

    constructor(data?: ICourseSession) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.courseTrainingId = _data["courseTrainingId"];
            this.id = _data["id"];
            this.isEligibleDPCReduction = _data["isEligibleDPCReduction"];
            this.publicationStatus = _data["publicationStatus"];
            this.sessionEndDate = _data["sessionEndDate"] ? new Date(_data["sessionEndDate"].toString()) : <any>undefined;
            this.sessionStartDate = _data["sessionStartDate"] ? new Date(_data["sessionStartDate"].toString()) : <any>undefined;
            this.shortName = _data["shortName"];
            this.inactivityNotification = _data["inactivityNotification"];
            this.surveyEnabled = _data["surveyEnabled"];
        }
    }

    static fromJS(data: any): CourseSession {
        data = typeof data === 'object' ? data : {};
        let result = new CourseSession();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["courseTrainingId"] = this.courseTrainingId;
        data["id"] = this.id;
        data["isEligibleDPCReduction"] = this.isEligibleDPCReduction;
        data["publicationStatus"] = this.publicationStatus;
        data["sessionEndDate"] = this.sessionEndDate ? this.sessionEndDate.toISOString() : <any>undefined;
        data["sessionStartDate"] = this.sessionStartDate ? this.sessionStartDate.toISOString() : <any>undefined;
        data["shortName"] = this.shortName;
        data["inactivityNotification"] = this.inactivityNotification;
        data["surveyEnabled"] = this.surveyEnabled;
        return data;
    }
}

/** Contains the definition of an object of type CourseSession. */
export interface ICourseSession {
    /** Gets or sets the course training identifier. */
    courseTrainingId: number;
    /** Gets or sets the identifier. */
    id: number;
    /** Gets or sets a value indicating whether this instance is eligible DPC. */
    isEligibleDPCReduction: boolean;
    /** Gets or sets the publication status. */
    publicationStatus: CourseSessionStatus;
    /** Gets or sets the session end date. */
    sessionEndDate?: Date | undefined;
    /** Gets or sets the session start date. */
    sessionStartDate: Date;
    /** Gets or sets the full name. */
    shortName?: string | undefined;
    /** Gets or sets a value indicating whether to notify the inactivity by mail. */
    inactivityNotification: boolean;
    /** Gets or sets a value indicating whether to enable and send the surveys by mail. */
    surveyEnabled: boolean;
}

/** Contains the definition of an object of type CourseSessionStatus. */
export enum CourseSessionStatus {
    Unknown = 0,
    Unpublished = 1,
    Published = 2,
}

/** Contains the definition of an object of type BonusHistory. */
export class BonusHistory implements IBonusHistory {
    /** Gets or sets the amount. */
    amount!: number;
    /** Gets or sets the description. */
    description?: string | undefined;
    /** Gets or sets the identifier. */
    id!: number;
    /** Gets or sets the member names. */
    memberNames?: string | undefined;
    /** Gets or sets the reason. */
    reason?: string | undefined;
    /** Gets or sets the created date. */
    createdDate!: Date;

    constructor(data?: IBonusHistory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.amount = _data["amount"];
            this.description = _data["description"];
            this.id = _data["id"];
            this.memberNames = _data["memberNames"];
            this.reason = _data["reason"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): BonusHistory {
        data = typeof data === 'object' ? data : {};
        let result = new BonusHistory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount;
        data["description"] = this.description;
        data["id"] = this.id;
        data["memberNames"] = this.memberNames;
        data["reason"] = this.reason;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        return data;
    }
}

/** Contains the definition of an object of type BonusHistory. */
export interface IBonusHistory {
    /** Gets or sets the amount. */
    amount: number;
    /** Gets or sets the description. */
    description?: string | undefined;
    /** Gets or sets the identifier. */
    id: number;
    /** Gets or sets the member names. */
    memberNames?: string | undefined;
    /** Gets or sets the reason. */
    reason?: string | undefined;
    /** Gets or sets the created date. */
    createdDate: Date;
}

/** Contains the definition of an object of type Country. */
export class Country implements ICountry {
    /** Gets or sets the iso2. */
    iso2?: string | undefined;
    /** Gets or sets the iso3. */
    iso3?: string | undefined;

    constructor(data?: ICountry) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.iso2 = _data["iso2"];
            this.iso3 = _data["iso3"];
        }
    }

    static fromJS(data: any): Country {
        data = typeof data === 'object' ? data : {};
        let result = new Country();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["iso2"] = this.iso2;
        data["iso3"] = this.iso3;
        return data;
    }
}

/** Contains the definition of an object of type Country. */
export interface ICountry {
    /** Gets or sets the iso2. */
    iso2?: string | undefined;
    /** Gets or sets the iso3. */
    iso3?: string | undefined;
}

/** Contains the definition of an object of type CountryWithName. */
export class CountryWithName implements ICountryWithName {
    /** Gets or sets the iso3. */
    iso3?: string | undefined;
    /** Gets or sets the name. */
    name?: string | undefined;

    constructor(data?: ICountryWithName) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.iso3 = _data["iso3"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CountryWithName {
        data = typeof data === 'object' ? data : {};
        let result = new CountryWithName();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["iso3"] = this.iso3;
        data["name"] = this.name;
        return data;
    }
}

/** Contains the definition of an object of type CountryWithName. */
export interface ICountryWithName {
    /** Gets or sets the iso3. */
    iso3?: string | undefined;
    /** Gets or sets the name. */
    name?: string | undefined;
}

/** Contains the definition of an object of type CurrentMember. */
export class CurrentMember implements ICurrentMember {
    /** Gets or sets the city. */
    city?: string | undefined;
    /** Gets or sets the country. */
    country?: string | undefined;
    /** Gets or sets the email. */
    email?: string | undefined;
    /** Gets or sets the first name. */
    firstName?: string | undefined;
    /** Gets or sets the first phone. */
    firstPhone?: string | undefined;
    /** Gets or sets the godchild code. */
    godfatherCode?: string | undefined;
    /** Gets or sets the identifier. */
    id!: number;
    /** Gets or sets the last name. */
    lastName?: string | undefined;
    /** Gets or sets the postal code. */
    postalCode?: string | undefined;
    /** Gets or sets the reseller code. */
    resellerCode?: string | undefined;
    /** Gets or sets the roles. */
    roles?: Roles[] | undefined;
    /** Gets or sets the siin commission. */
    siinCommission!: number;
    /** Gets or sets the street. */
    street?: string | undefined;
    /** Gets or sets the street number. */
    streetNumber?: string | undefined;
    /** Gets or sets the name of the user. */
    userName?: string | undefined;
    /** Gets or sets the nationality. */
    nationality?: string | undefined;
    /** Gets or sets the birthdate. */
    birthdate?: string | undefined;
    /** Gets or sets the gender. */
    gender?: string | undefined;

    constructor(data?: ICurrentMember) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.city = _data["city"];
            this.country = _data["country"];
            this.email = _data["email"];
            this.firstName = _data["firstName"];
            this.firstPhone = _data["firstPhone"];
            this.godfatherCode = _data["godfatherCode"];
            this.id = _data["id"];
            this.lastName = _data["lastName"];
            this.postalCode = _data["postalCode"];
            this.resellerCode = _data["resellerCode"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
            this.siinCommission = _data["siinCommission"];
            this.street = _data["street"];
            this.streetNumber = _data["streetNumber"];
            this.userName = _data["userName"];
            this.nationality = _data["nationality"];
            this.birthdate = _data["birthdate"];
            this.gender = _data["gender"];
        }
    }

    static fromJS(data: any): CurrentMember {
        data = typeof data === 'object' ? data : {};
        let result = new CurrentMember();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["city"] = this.city;
        data["country"] = this.country;
        data["email"] = this.email;
        data["firstName"] = this.firstName;
        data["firstPhone"] = this.firstPhone;
        data["godfatherCode"] = this.godfatherCode;
        data["id"] = this.id;
        data["lastName"] = this.lastName;
        data["postalCode"] = this.postalCode;
        data["resellerCode"] = this.resellerCode;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        data["siinCommission"] = this.siinCommission;
        data["street"] = this.street;
        data["streetNumber"] = this.streetNumber;
        data["userName"] = this.userName;
        data["nationality"] = this.nationality;
        data["birthdate"] = this.birthdate;
        data["gender"] = this.gender;
        return data;
    }
}

/** Contains the definition of an object of type CurrentMember. */
export interface ICurrentMember {
    /** Gets or sets the city. */
    city?: string | undefined;
    /** Gets or sets the country. */
    country?: string | undefined;
    /** Gets or sets the email. */
    email?: string | undefined;
    /** Gets or sets the first name. */
    firstName?: string | undefined;
    /** Gets or sets the first phone. */
    firstPhone?: string | undefined;
    /** Gets or sets the godchild code. */
    godfatherCode?: string | undefined;
    /** Gets or sets the identifier. */
    id: number;
    /** Gets or sets the last name. */
    lastName?: string | undefined;
    /** Gets or sets the postal code. */
    postalCode?: string | undefined;
    /** Gets or sets the reseller code. */
    resellerCode?: string | undefined;
    /** Gets or sets the roles. */
    roles?: Roles[] | undefined;
    /** Gets or sets the siin commission. */
    siinCommission: number;
    /** Gets or sets the street. */
    street?: string | undefined;
    /** Gets or sets the street number. */
    streetNumber?: string | undefined;
    /** Gets or sets the name of the user. */
    userName?: string | undefined;
    /** Gets or sets the nationality. */
    nationality?: string | undefined;
    /** Gets or sets the birthdate. */
    birthdate?: string | undefined;
    /** Gets or sets the gender. */
    gender?: string | undefined;
}

/** Contains the definition of an object of type CurrentMemberCartInfo. */
export class CurrentMemberCartInfo implements ICurrentMemberCartInfo {
    /** Gets or sets the adeli number. */
    adeliNumber?: string | undefined;
    /** Gets or sets the advantage code. */
    advantageCode?: string | undefined;
    /** Gets or sets the available subvention organizations. */
    availableSubventionOrganizations?: MemberSubventionOrganization[] | undefined;
    /** Gets or sets the birth date. */
    birthDate?: string | undefined;
    /** Gets or sets the city. */
    city?: string | undefined;
    /** Gets or sets a value indicating whether [consent GDPR]. */
    consentGdpr!: boolean;
    /** Gets or sets the country. */
    country?: string | undefined;
    /** Gets or sets the credits. */
    credits!: number;
    /** Gets or sets the fax. */
    fax?: string | undefined;
    /** Gets or sets the first name. */
    firstName?: string | undefined;
    /** Gets or sets the first phone. */
    firstPhone?: string | undefined;
    /** Gets or sets the gln number. */
    glnNumber?: string | undefined;
    /** Gets or sets the gender. */
    gender?: string | undefined;
    /** Gets or sets a value indicating whether [Has ProNutri offer with fixed price]. */
    hasProNutriOfferWithFixedPrice!: boolean;
    /** Gets or sets the identifier. */
    id!: number;
    /** Gets or sets the inami number. */
    inamiNumber?: string | undefined;
    /** Gets or sets a value indicating whether this CurrentMemberCartInfo is employee. */
    isEmployee!: boolean;
    /** Gets or sets a value indicating whether this instance is unemployee. */
    isUnemployed!: boolean;
    /** Gets or sets a value indicating whether this instance is siin academy member. */
    isSiinAcademyMember!: boolean;
    /** Gets or sets a value indicating whether this instance is siin client. */
    isSiinClient!: boolean;
    /** Gets or sets the last name. */
    lastName?: string | undefined;
    /** Gets or sets a value indicating whether [liberal profession]. */
    liberalProfession!: boolean;
    /** Gets or sets the name of the maiden. */
    maidenName?: string | undefined;
    /** Gets or sets the medical order number. */
    medicalOrderNumber?: string | undefined;
    /** Gets or sets the nationality. */
    nationality?: string | undefined;
    /** Gets or sets a value indicating whether [newsletter subscription]. */
    newsletterSubscription!: boolean;
    /** Gets or sets the number. */
    number?: string | undefined;
    /** Gets or sets the pharmacy authorization number. */
    pharmacyAuthorizationNumber?: string | undefined;
    /** Gets or sets a value indicating whether [pharmacy authorization requirement]. */
    pharmacyAuthorizationRequirement!: boolean;
    /** Gets or sets the pole emploi number. */
    poleEmploiNumber?: string | undefined;
    /** Gets or sets the postal code. */
    postalCode?: string | undefined;
    /** Gets or sets the profession identifier. */
    professionId?: number | undefined;
    /** Gets or sets the profession other. */
    professionOther?: string | undefined;
    /** Gets or sets the RPPS number. */
    rppsNumber?: string | undefined;
    /** Gets or sets the second phone. */
    secondPhone?: string | undefined;
    /** Gets or sets the society. */
    society?: string | undefined;
    /** Gets or sets the street. */
    street?: string | undefined;
    /** Gets or sets a value indicating whether [subject to vat]. */
    subjectToVat!: boolean;
    /** Gets or sets the name of the user. */
    userName?: string | undefined;
    /** Gets or sets the vat number. */
    vatNumber?: string | undefined;
    /** Gets or sets the current profession identifier. */
    currentProfessionId?: number | undefined;

    constructor(data?: ICurrentMemberCartInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.adeliNumber = _data["adeliNumber"];
            this.advantageCode = _data["advantageCode"];
            if (Array.isArray(_data["availableSubventionOrganizations"])) {
                this.availableSubventionOrganizations = [] as any;
                for (let item of _data["availableSubventionOrganizations"])
                    this.availableSubventionOrganizations!.push(MemberSubventionOrganization.fromJS(item));
            }
            this.birthDate = _data["birthDate"];
            this.city = _data["city"];
            this.consentGdpr = _data["consentGdpr"];
            this.country = _data["country"];
            this.credits = _data["credits"];
            this.fax = _data["fax"];
            this.firstName = _data["firstName"];
            this.firstPhone = _data["firstPhone"];
            this.glnNumber = _data["glnNumber"];
            this.gender = _data["gender"];
            this.hasProNutriOfferWithFixedPrice = _data["hasProNutriOfferWithFixedPrice"];
            this.id = _data["id"];
            this.inamiNumber = _data["inamiNumber"];
            this.isEmployee = _data["isEmployee"];
            this.isUnemployed = _data["isUnemployed"];
            this.isSiinAcademyMember = _data["isSiinAcademyMember"];
            this.isSiinClient = _data["isSiinClient"];
            this.lastName = _data["lastName"];
            this.liberalProfession = _data["liberalProfession"];
            this.maidenName = _data["maidenName"];
            this.medicalOrderNumber = _data["medicalOrderNumber"];
            this.nationality = _data["nationality"];
            this.newsletterSubscription = _data["newsletterSubscription"];
            this.number = _data["number"];
            this.pharmacyAuthorizationNumber = _data["pharmacyAuthorizationNumber"];
            this.pharmacyAuthorizationRequirement = _data["pharmacyAuthorizationRequirement"];
            this.poleEmploiNumber = _data["poleEmploiNumber"];
            this.postalCode = _data["postalCode"];
            this.professionId = _data["professionId"];
            this.professionOther = _data["professionOther"];
            this.rppsNumber = _data["rppsNumber"];
            this.secondPhone = _data["secondPhone"];
            this.society = _data["society"];
            this.street = _data["street"];
            this.subjectToVat = _data["subjectToVat"];
            this.userName = _data["userName"];
            this.vatNumber = _data["vatNumber"];
            this.currentProfessionId = _data["currentProfessionId"];
        }
    }

    static fromJS(data: any): CurrentMemberCartInfo {
        data = typeof data === 'object' ? data : {};
        let result = new CurrentMemberCartInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["adeliNumber"] = this.adeliNumber;
        data["advantageCode"] = this.advantageCode;
        if (Array.isArray(this.availableSubventionOrganizations)) {
            data["availableSubventionOrganizations"] = [];
            for (let item of this.availableSubventionOrganizations)
                data["availableSubventionOrganizations"].push(item ? item.toJSON() : <any>undefined);
        }
        data["birthDate"] = this.birthDate;
        data["city"] = this.city;
        data["consentGdpr"] = this.consentGdpr;
        data["country"] = this.country;
        data["credits"] = this.credits;
        data["fax"] = this.fax;
        data["firstName"] = this.firstName;
        data["firstPhone"] = this.firstPhone;
        data["glnNumber"] = this.glnNumber;
        data["gender"] = this.gender;
        data["hasProNutriOfferWithFixedPrice"] = this.hasProNutriOfferWithFixedPrice;
        data["id"] = this.id;
        data["inamiNumber"] = this.inamiNumber;
        data["isEmployee"] = this.isEmployee;
        data["isUnemployed"] = this.isUnemployed;
        data["isSiinAcademyMember"] = this.isSiinAcademyMember;
        data["isSiinClient"] = this.isSiinClient;
        data["lastName"] = this.lastName;
        data["liberalProfession"] = this.liberalProfession;
        data["maidenName"] = this.maidenName;
        data["medicalOrderNumber"] = this.medicalOrderNumber;
        data["nationality"] = this.nationality;
        data["newsletterSubscription"] = this.newsletterSubscription;
        data["number"] = this.number;
        data["pharmacyAuthorizationNumber"] = this.pharmacyAuthorizationNumber;
        data["pharmacyAuthorizationRequirement"] = this.pharmacyAuthorizationRequirement;
        data["poleEmploiNumber"] = this.poleEmploiNumber;
        data["postalCode"] = this.postalCode;
        data["professionId"] = this.professionId;
        data["professionOther"] = this.professionOther;
        data["rppsNumber"] = this.rppsNumber;
        data["secondPhone"] = this.secondPhone;
        data["society"] = this.society;
        data["street"] = this.street;
        data["subjectToVat"] = this.subjectToVat;
        data["userName"] = this.userName;
        data["vatNumber"] = this.vatNumber;
        data["currentProfessionId"] = this.currentProfessionId;
        return data;
    }
}

/** Contains the definition of an object of type CurrentMemberCartInfo. */
export interface ICurrentMemberCartInfo {
    /** Gets or sets the adeli number. */
    adeliNumber?: string | undefined;
    /** Gets or sets the advantage code. */
    advantageCode?: string | undefined;
    /** Gets or sets the available subvention organizations. */
    availableSubventionOrganizations?: MemberSubventionOrganization[] | undefined;
    /** Gets or sets the birth date. */
    birthDate?: string | undefined;
    /** Gets or sets the city. */
    city?: string | undefined;
    /** Gets or sets a value indicating whether [consent GDPR]. */
    consentGdpr: boolean;
    /** Gets or sets the country. */
    country?: string | undefined;
    /** Gets or sets the credits. */
    credits: number;
    /** Gets or sets the fax. */
    fax?: string | undefined;
    /** Gets or sets the first name. */
    firstName?: string | undefined;
    /** Gets or sets the first phone. */
    firstPhone?: string | undefined;
    /** Gets or sets the gln number. */
    glnNumber?: string | undefined;
    /** Gets or sets the gender. */
    gender?: string | undefined;
    /** Gets or sets a value indicating whether [Has ProNutri offer with fixed price]. */
    hasProNutriOfferWithFixedPrice: boolean;
    /** Gets or sets the identifier. */
    id: number;
    /** Gets or sets the inami number. */
    inamiNumber?: string | undefined;
    /** Gets or sets a value indicating whether this CurrentMemberCartInfo is employee. */
    isEmployee: boolean;
    /** Gets or sets a value indicating whether this instance is unemployee. */
    isUnemployed: boolean;
    /** Gets or sets a value indicating whether this instance is siin academy member. */
    isSiinAcademyMember: boolean;
    /** Gets or sets a value indicating whether this instance is siin client. */
    isSiinClient: boolean;
    /** Gets or sets the last name. */
    lastName?: string | undefined;
    /** Gets or sets a value indicating whether [liberal profession]. */
    liberalProfession: boolean;
    /** Gets or sets the name of the maiden. */
    maidenName?: string | undefined;
    /** Gets or sets the medical order number. */
    medicalOrderNumber?: string | undefined;
    /** Gets or sets the nationality. */
    nationality?: string | undefined;
    /** Gets or sets a value indicating whether [newsletter subscription]. */
    newsletterSubscription: boolean;
    /** Gets or sets the number. */
    number?: string | undefined;
    /** Gets or sets the pharmacy authorization number. */
    pharmacyAuthorizationNumber?: string | undefined;
    /** Gets or sets a value indicating whether [pharmacy authorization requirement]. */
    pharmacyAuthorizationRequirement: boolean;
    /** Gets or sets the pole emploi number. */
    poleEmploiNumber?: string | undefined;
    /** Gets or sets the postal code. */
    postalCode?: string | undefined;
    /** Gets or sets the profession identifier. */
    professionId?: number | undefined;
    /** Gets or sets the profession other. */
    professionOther?: string | undefined;
    /** Gets or sets the RPPS number. */
    rppsNumber?: string | undefined;
    /** Gets or sets the second phone. */
    secondPhone?: string | undefined;
    /** Gets or sets the society. */
    society?: string | undefined;
    /** Gets or sets the street. */
    street?: string | undefined;
    /** Gets or sets a value indicating whether [subject to vat]. */
    subjectToVat: boolean;
    /** Gets or sets the name of the user. */
    userName?: string | undefined;
    /** Gets or sets the vat number. */
    vatNumber?: string | undefined;
    /** Gets or sets the current profession identifier. */
    currentProfessionId?: number | undefined;
}

/** Contains the definition of an object of type MemberSubventionOrganization. */
export class MemberSubventionOrganization implements IMemberSubventionOrganization {
    /** Gets or sets the identifier. */
    id!: number;
    /** Gets or sets a value indicating whether this instance is automatic generated. */
    isAutoGenerated!: boolean;
    /** Gets or sets the name. */
    name?: string | undefined;

    constructor(data?: IMemberSubventionOrganization) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isAutoGenerated = _data["isAutoGenerated"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): MemberSubventionOrganization {
        data = typeof data === 'object' ? data : {};
        let result = new MemberSubventionOrganization();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isAutoGenerated"] = this.isAutoGenerated;
        data["name"] = this.name;
        return data;
    }
}

/** Contains the definition of an object of type MemberSubventionOrganization. */
export interface IMemberSubventionOrganization {
    /** Gets or sets the identifier. */
    id: number;
    /** Gets or sets a value indicating whether this instance is automatic generated. */
    isAutoGenerated: boolean;
    /** Gets or sets the name. */
    name?: string | undefined;
}

/** Contains the definition of an object of type CurrentMemberFinanceInfo. */
export class CurrentMemberFinanceInfo implements ICurrentMemberFinanceInfo {
    /** Gets or sets the credits. */
    credits!: number;
    /** Gets or sets the total to pay. */
    totalToPay!: number;

    constructor(data?: ICurrentMemberFinanceInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.credits = _data["credits"];
            this.totalToPay = _data["totalToPay"];
        }
    }

    static fromJS(data: any): CurrentMemberFinanceInfo {
        data = typeof data === 'object' ? data : {};
        let result = new CurrentMemberFinanceInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["credits"] = this.credits;
        data["totalToPay"] = this.totalToPay;
        return data;
    }
}

/** Contains the definition of an object of type CurrentMemberFinanceInfo. */
export interface ICurrentMemberFinanceInfo {
    /** Gets or sets the credits. */
    credits: number;
    /** Gets or sets the total to pay. */
    totalToPay: number;
}

/** Contains the definition of an object of type CurrentMemberProNutriInfo. */
export class CurrentMemberProNutriInfo implements ICurrentMemberProNutriInfo {
    /** Gets or sets a value indicating whether this instance is registration valid. */
    isRegistrationValid!: boolean;
    /** Gets or sets the validity end date. */
    validityEndDate?: Date | undefined;
    /** Gets or sets the validity start date. */
    validityStartDate?: Date | undefined;
    /** Gets or sets a value indicating whether ProNutriConsult contract is signed. */
    hasSignedPncContract!: boolean;

    constructor(data?: ICurrentMemberProNutriInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isRegistrationValid = _data["isRegistrationValid"];
            this.validityEndDate = _data["validityEndDate"] ? new Date(_data["validityEndDate"].toString()) : <any>undefined;
            this.validityStartDate = _data["validityStartDate"] ? new Date(_data["validityStartDate"].toString()) : <any>undefined;
            this.hasSignedPncContract = _data["hasSignedPncContract"];
        }
    }

    static fromJS(data: any): CurrentMemberProNutriInfo {
        data = typeof data === 'object' ? data : {};
        let result = new CurrentMemberProNutriInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isRegistrationValid"] = this.isRegistrationValid;
        data["validityEndDate"] = this.validityEndDate ? this.validityEndDate.toISOString() : <any>undefined;
        data["validityStartDate"] = this.validityStartDate ? this.validityStartDate.toISOString() : <any>undefined;
        data["hasSignedPncContract"] = this.hasSignedPncContract;
        return data;
    }
}

/** Contains the definition of an object of type CurrentMemberProNutriInfo. */
export interface ICurrentMemberProNutriInfo {
    /** Gets or sets a value indicating whether this instance is registration valid. */
    isRegistrationValid: boolean;
    /** Gets or sets the validity end date. */
    validityEndDate?: Date | undefined;
    /** Gets or sets the validity start date. */
    validityStartDate?: Date | undefined;
    /** Gets or sets a value indicating whether ProNutriConsult contract is signed. */
    hasSignedPncContract: boolean;
}

/** Contains the definition of an object of type CurrentMemberSiinAcademyInfo. */
export class CurrentMemberSiinAcademyInfo implements ICurrentMemberSiinAcademyInfo {
    /** Gets or sets the academy inscription date. */
    academyInscriptionDate?: Date | undefined;
    /** Gets or sets the academy validity date. */
    academyValidityDate?: Date | undefined;
    /** Gets or sets a value indicating whether this instance is siin academy member. */
    isSiinAcademyMember!: boolean;

    constructor(data?: ICurrentMemberSiinAcademyInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.academyInscriptionDate = _data["academyInscriptionDate"] ? new Date(_data["academyInscriptionDate"].toString()) : <any>undefined;
            this.academyValidityDate = _data["academyValidityDate"] ? new Date(_data["academyValidityDate"].toString()) : <any>undefined;
            this.isSiinAcademyMember = _data["isSiinAcademyMember"];
        }
    }

    static fromJS(data: any): CurrentMemberSiinAcademyInfo {
        data = typeof data === 'object' ? data : {};
        let result = new CurrentMemberSiinAcademyInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["academyInscriptionDate"] = this.academyInscriptionDate ? this.academyInscriptionDate.toISOString() : <any>undefined;
        data["academyValidityDate"] = this.academyValidityDate ? this.academyValidityDate.toISOString() : <any>undefined;
        data["isSiinAcademyMember"] = this.isSiinAcademyMember;
        return data;
    }
}

/** Contains the definition of an object of type CurrentMemberSiinAcademyInfo. */
export interface ICurrentMemberSiinAcademyInfo {
    /** Gets or sets the academy inscription date. */
    academyInscriptionDate?: Date | undefined;
    /** Gets or sets the academy validity date. */
    academyValidityDate?: Date | undefined;
    /** Gets or sets a value indicating whether this instance is siin academy member. */
    isSiinAcademyMember: boolean;
}

/** Contains the definition of an object of type Departement. */
export class Departement implements IDepartement {
    /** Gets or sets the code. */
    code?: string | undefined;
    /** Gets or sets the name. */
    name?: string | undefined;

    constructor(data?: IDepartement) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): Departement {
        data = typeof data === 'object' ? data : {};
        let result = new Departement();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        return data;
    }
}

/** Contains the definition of an object of type Departement. */
export interface IDepartement {
    /** Gets or sets the code. */
    code?: string | undefined;
    /** Gets or sets the name. */
    name?: string | undefined;
}

/** Contains the definition of an object of type MemberDuplicate. */
export class MemberDuplicate implements IMemberDuplicate {
    /** Gets or sets the first name. */
    firstName?: string | undefined;
    /** Gets or sets the identifier. */
    ids?: number[] | undefined;
    /** Gets or sets the last name. */
    lastName?: string | undefined;

    constructor(data?: IMemberDuplicate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
            this.lastName = _data["lastName"];
        }
    }

    static fromJS(data: any): MemberDuplicate {
        data = typeof data === 'object' ? data : {};
        let result = new MemberDuplicate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        data["lastName"] = this.lastName;
        return data;
    }
}

/** Contains the definition of an object of type MemberDuplicate. */
export interface IMemberDuplicate {
    /** Gets or sets the first name. */
    firstName?: string | undefined;
    /** Gets or sets the identifier. */
    ids?: number[] | undefined;
    /** Gets or sets the last name. */
    lastName?: string | undefined;
}

/** Contains the definition of an object with type MemberAmbassadorInfo */
export class MemberAmbassadorInfo implements IMemberAmbassadorInfo {
    /** Gets or sets a value indicating whether this instance has followed complete course. */
    hasFollowedCompleteCourseAndUpdate!: boolean;
    /** Gets or sets a value indicating whether this instance has signed ethic chart. */
    hasSignedEthicalChart!: boolean;
    /** Gets or sets a value indicating whether this instance has uploaded ethical chart. */
    hasUploadedEthicalChart!: boolean;
    /** Gets or sets a value indicating whether this instance is ambassador. */
    isAmbassador!: boolean;

    constructor(data?: IMemberAmbassadorInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hasFollowedCompleteCourseAndUpdate = _data["hasFollowedCompleteCourseAndUpdate"];
            this.hasSignedEthicalChart = _data["hasSignedEthicalChart"];
            this.hasUploadedEthicalChart = _data["hasUploadedEthicalChart"];
            this.isAmbassador = _data["isAmbassador"];
        }
    }

    static fromJS(data: any): MemberAmbassadorInfo {
        data = typeof data === 'object' ? data : {};
        let result = new MemberAmbassadorInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasFollowedCompleteCourseAndUpdate"] = this.hasFollowedCompleteCourseAndUpdate;
        data["hasSignedEthicalChart"] = this.hasSignedEthicalChart;
        data["hasUploadedEthicalChart"] = this.hasUploadedEthicalChart;
        data["isAmbassador"] = this.isAmbassador;
        return data;
    }
}

/** Contains the definition of an object with type MemberAmbassadorInfo */
export interface IMemberAmbassadorInfo {
    /** Gets or sets a value indicating whether this instance has followed complete course. */
    hasFollowedCompleteCourseAndUpdate: boolean;
    /** Gets or sets a value indicating whether this instance has signed ethic chart. */
    hasSignedEthicalChart: boolean;
    /** Gets or sets a value indicating whether this instance has uploaded ethical chart. */
    hasUploadedEthicalChart: boolean;
    /** Gets or sets a value indicating whether this instance is ambassador. */
    isAmbassador: boolean;
}

/** Definition of class ResellerClient */
export class ResellerClient implements IResellerClient {
    /** Gets or sets the email. */
    email?: string | undefined;
    /** Gets or sets the first name. */
    firstName?: string | undefined;
    /** Gets or sets the inscription date. */
    inscriptionDate!: Date;
    /** Gets or sets the last name. */
    lastName?: string | undefined;
    /** Gets or sets the profession. */
    profession?: string | undefined;
    /** Gets or sets the turnovers. */
    turnovers!: number;

    constructor(data?: IResellerClient) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.firstName = _data["firstName"];
            this.inscriptionDate = _data["inscriptionDate"] ? new Date(_data["inscriptionDate"].toString()) : <any>undefined;
            this.lastName = _data["lastName"];
            this.profession = _data["profession"];
            this.turnovers = _data["turnovers"];
        }
    }

    static fromJS(data: any): ResellerClient {
        data = typeof data === 'object' ? data : {};
        let result = new ResellerClient();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["firstName"] = this.firstName;
        data["inscriptionDate"] = this.inscriptionDate ? this.inscriptionDate.toISOString() : <any>undefined;
        data["lastName"] = this.lastName;
        data["profession"] = this.profession;
        data["turnovers"] = this.turnovers;
        return data;
    }
}

/** Definition of class ResellerClient */
export interface IResellerClient {
    /** Gets or sets the email. */
    email?: string | undefined;
    /** Gets or sets the first name. */
    firstName?: string | undefined;
    /** Gets or sets the inscription date. */
    inscriptionDate: Date;
    /** Gets or sets the last name. */
    lastName?: string | undefined;
    /** Gets or sets the profession. */
    profession?: string | undefined;
    /** Gets or sets the turnovers. */
    turnovers: number;
}

/** Contains a definition of GodfatherSponsorship */
export class GodfatherSponsorship extends ResellerClient implements IGodfatherSponsorship {
    /** Gets or sets the sponsorship commission. */
    sponsorshipCommission?: string | undefined;

    constructor(data?: IGodfatherSponsorship) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.sponsorshipCommission = _data["sponsorshipCommission"];
        }
    }

    static override fromJS(data: any): GodfatherSponsorship {
        data = typeof data === 'object' ? data : {};
        let result = new GodfatherSponsorship();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sponsorshipCommission"] = this.sponsorshipCommission;
        super.toJSON(data);
        return data;
    }
}

/** Contains a definition of GodfatherSponsorship */
export interface IGodfatherSponsorship extends IResellerClient {
    /** Gets or sets the sponsorship commission. */
    sponsorshipCommission?: string | undefined;
}

/** MemberBonus */
export class MemberBonus implements IMemberBonus {
    /** Gets or sets the first name. */
    firstName?: string | undefined;
    /** Gets or sets the identifier. */
    id!: number;
    /** Gets or sets the last name. */
    lastName?: string | undefined;

    constructor(data?: IMemberBonus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.id = _data["id"];
            this.lastName = _data["lastName"];
        }
    }

    static fromJS(data: any): MemberBonus {
        data = typeof data === 'object' ? data : {};
        let result = new MemberBonus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["id"] = this.id;
        data["lastName"] = this.lastName;
        return data;
    }
}

/** MemberBonus */
export interface IMemberBonus {
    /** Gets or sets the first name. */
    firstName?: string | undefined;
    /** Gets or sets the identifier. */
    id: number;
    /** Gets or sets the last name. */
    lastName?: string | undefined;
}

/** Contains the definition of an object of type NewClientFileNotification. */
export class NewClientFileNotification implements INewClientFileNotification {
    /** Gets or sets the client's firstname. */
    clientFirstName?: string | undefined;
    /** Gets or sets the client's lastname. */
    clientLastName?: string | undefined;
    /** Gets or sets the client's id. */
    clientId!: number;
    /** Gets or sets the datetime. */
    dateTime?: Date | undefined;
    /** Gets or sets the document title. */
    documentTitle?: string | undefined;
    /** Gets or sets a value indicating whether. */
    isNewDocument!: boolean;
    /** Gets or sets the client's new file id. */
    newFileId!: number;

    constructor(data?: INewClientFileNotification) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientFirstName = _data["clientFirstName"];
            this.clientLastName = _data["clientLastName"];
            this.clientId = _data["clientId"];
            this.dateTime = _data["dateTime"] ? new Date(_data["dateTime"].toString()) : <any>undefined;
            this.documentTitle = _data["documentTitle"];
            this.isNewDocument = _data["isNewDocument"];
            this.newFileId = _data["newFileId"];
        }
    }

    static fromJS(data: any): NewClientFileNotification {
        data = typeof data === 'object' ? data : {};
        let result = new NewClientFileNotification();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientFirstName"] = this.clientFirstName;
        data["clientLastName"] = this.clientLastName;
        data["clientId"] = this.clientId;
        data["dateTime"] = this.dateTime ? this.dateTime.toISOString() : <any>undefined;
        data["documentTitle"] = this.documentTitle;
        data["isNewDocument"] = this.isNewDocument;
        data["newFileId"] = this.newFileId;
        return data;
    }
}

/** Contains the definition of an object of type NewClientFileNotification. */
export interface INewClientFileNotification {
    /** Gets or sets the client's firstname. */
    clientFirstName?: string | undefined;
    /** Gets or sets the client's lastname. */
    clientLastName?: string | undefined;
    /** Gets or sets the client's id. */
    clientId: number;
    /** Gets or sets the datetime. */
    dateTime?: Date | undefined;
    /** Gets or sets the document title. */
    documentTitle?: string | undefined;
    /** Gets or sets a value indicating whether. */
    isNewDocument: boolean;
    /** Gets or sets the client's new file id. */
    newFileId: number;
}

/** Contains the definition of an object of type DocumentBOSearchParams. */
export class DocumentBOSearchParams extends SearchParams implements IDocumentBOSearchParams {
    /** Gets or sets the document type. */
    documentType?: number | undefined;
    /** Gets or sets the search string. */
    searchString?: string | undefined;

    constructor(data?: IDocumentBOSearchParams) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.documentType = _data["documentType"];
            this.searchString = _data["searchString"];
        }
    }

    static override fromJS(data: any): DocumentBOSearchParams {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentBOSearchParams();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentType"] = this.documentType;
        data["searchString"] = this.searchString;
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type DocumentBOSearchParams. */
export interface IDocumentBOSearchParams extends ISearchParams {
    /** Gets or sets the document type. */
    documentType?: number | undefined;
    /** Gets or sets the search string. */
    searchString?: string | undefined;
}

/** Contains the definition of an object of type NationalityWithName. */
export class NationalityWithName implements INationalityWithName {
    /** Gets or sets the iso3. */
    iso3?: string | undefined;
    /** Gets or sets the name. */
    name?: string | undefined;

    constructor(data?: INationalityWithName) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.iso3 = _data["iso3"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): NationalityWithName {
        data = typeof data === 'object' ? data : {};
        let result = new NationalityWithName();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["iso3"] = this.iso3;
        data["name"] = this.name;
        return data;
    }
}

/** Contains the definition of an object of type NationalityWithName. */
export interface INationalityWithName {
    /** Gets or sets the iso3. */
    iso3?: string | undefined;
    /** Gets or sets the name. */
    name?: string | undefined;
}

/** Contains the definition of an object of type PurchaseOrder. */
export class PurchaseOrder implements IPurchaseOrder {
    /** Gets or sets the amout. */
    amount!: number;
    /** Gets or sets the client identifier. */
    clientId!: number;
    /** Gets or sets the name of the client. */
    clientName?: string | undefined;
    /** Gets or sets the course session or product identifier. */
    courseSessionOrProductId!: number;
    /** Gets or sets the name of the course session or product. */
    courseSessionOrProductName?: string | undefined;
    /** Gets or sets the credits points. */
    creditsPoints?: number | undefined;
    /** Gets or sets the date. */
    date!: Date;
    /** Gets or sets the discount. */
    discount?: number | undefined;
    /** Gets or sets the identifier. */
    id!: number;
    /** Gets or sets a value indicating whether this instance is course session. */
    isCourseSession!: boolean;
    /** Gets or sets a value indicating whether this instance is a profession unregulated. */
    isAProfessionUnregulated!: boolean;
    /** Gets or sets a value indicating whether this instance is transfer allowed. */
    isTransferAllowed!: boolean;
    /** Gets or sets a value indicating whether this instance is online payment allowed. */
    isOnlinePaymentAllowed!: boolean;
    /** Gets or sets the Needs Assessment Id. */
    needsAssessmentId?: number | undefined;
    /** Gets or sets the payed amount. */
    paidAmount?: number | undefined;
    /** Gets or sets the status. */
    status!: StatusPurchaseOrder;
    /** Gets or sets the subvention identifier. */
    subventionId?: number | undefined;
    /** Gets or sets the subvention organization identifier. */
    subventionOrganizationId?: number | undefined;
    /** Gets or sets the subvention status. */
    subventionStatus!: StatusSubvention;
    /** Gets or sets the date at which the user consented on what information to give to his patients. */
    consentmentInfoProfessionDate?: Date | undefined;
    /** Gets or sets a value indicating whether the subvention is done by subrogation . */
    subventionBySubrogation?: boolean | undefined;

    constructor(data?: IPurchaseOrder) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.amount = _data["amount"];
            this.clientId = _data["clientId"];
            this.clientName = _data["clientName"];
            this.courseSessionOrProductId = _data["courseSessionOrProductId"];
            this.courseSessionOrProductName = _data["courseSessionOrProductName"];
            this.creditsPoints = _data["creditsPoints"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.discount = _data["discount"];
            this.id = _data["id"];
            this.isCourseSession = _data["isCourseSession"];
            this.isAProfessionUnregulated = _data["isAProfessionUnregulated"];
            this.isTransferAllowed = _data["isTransferAllowed"];
            this.isOnlinePaymentAllowed = _data["isOnlinePaymentAllowed"];
            this.needsAssessmentId = _data["needsAssessmentId"];
            this.paidAmount = _data["paidAmount"];
            this.status = _data["status"];
            this.subventionId = _data["subventionId"];
            this.subventionOrganizationId = _data["subventionOrganizationId"];
            this.subventionStatus = _data["subventionStatus"];
            this.consentmentInfoProfessionDate = _data["consentmentInfoProfessionDate"] ? new Date(_data["consentmentInfoProfessionDate"].toString()) : <any>undefined;
            this.subventionBySubrogation = _data["subventionBySubrogation"];
        }
    }

    static fromJS(data: any): PurchaseOrder {
        data = typeof data === 'object' ? data : {};
        let result = new PurchaseOrder();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount;
        data["clientId"] = this.clientId;
        data["clientName"] = this.clientName;
        data["courseSessionOrProductId"] = this.courseSessionOrProductId;
        data["courseSessionOrProductName"] = this.courseSessionOrProductName;
        data["creditsPoints"] = this.creditsPoints;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["discount"] = this.discount;
        data["id"] = this.id;
        data["isCourseSession"] = this.isCourseSession;
        data["isAProfessionUnregulated"] = this.isAProfessionUnregulated;
        data["isTransferAllowed"] = this.isTransferAllowed;
        data["isOnlinePaymentAllowed"] = this.isOnlinePaymentAllowed;
        data["needsAssessmentId"] = this.needsAssessmentId;
        data["paidAmount"] = this.paidAmount;
        data["status"] = this.status;
        data["subventionId"] = this.subventionId;
        data["subventionOrganizationId"] = this.subventionOrganizationId;
        data["subventionStatus"] = this.subventionStatus;
        data["consentmentInfoProfessionDate"] = this.consentmentInfoProfessionDate ? this.consentmentInfoProfessionDate.toISOString() : <any>undefined;
        data["subventionBySubrogation"] = this.subventionBySubrogation;
        return data;
    }
}

/** Contains the definition of an object of type PurchaseOrder. */
export interface IPurchaseOrder {
    /** Gets or sets the amout. */
    amount: number;
    /** Gets or sets the client identifier. */
    clientId: number;
    /** Gets or sets the name of the client. */
    clientName?: string | undefined;
    /** Gets or sets the course session or product identifier. */
    courseSessionOrProductId: number;
    /** Gets or sets the name of the course session or product. */
    courseSessionOrProductName?: string | undefined;
    /** Gets or sets the credits points. */
    creditsPoints?: number | undefined;
    /** Gets or sets the date. */
    date: Date;
    /** Gets or sets the discount. */
    discount?: number | undefined;
    /** Gets or sets the identifier. */
    id: number;
    /** Gets or sets a value indicating whether this instance is course session. */
    isCourseSession: boolean;
    /** Gets or sets a value indicating whether this instance is a profession unregulated. */
    isAProfessionUnregulated: boolean;
    /** Gets or sets a value indicating whether this instance is transfer allowed. */
    isTransferAllowed: boolean;
    /** Gets or sets a value indicating whether this instance is online payment allowed. */
    isOnlinePaymentAllowed: boolean;
    /** Gets or sets the Needs Assessment Id. */
    needsAssessmentId?: number | undefined;
    /** Gets or sets the payed amount. */
    paidAmount?: number | undefined;
    /** Gets or sets the status. */
    status: StatusPurchaseOrder;
    /** Gets or sets the subvention identifier. */
    subventionId?: number | undefined;
    /** Gets or sets the subvention organization identifier. */
    subventionOrganizationId?: number | undefined;
    /** Gets or sets the subvention status. */
    subventionStatus: StatusSubvention;
    /** Gets or sets the date at which the user consented on what information to give to his patients. */
    consentmentInfoProfessionDate?: Date | undefined;
    /** Gets or sets a value indicating whether the subvention is done by subrogation . */
    subventionBySubrogation?: boolean | undefined;
}

/** Contains the definition of an object of type StatusPurchaseOrder. */
export enum StatusPurchaseOrder {
    Unknown = 0,
    Open = 1,
    Closed = 2,
    Canceled = 3,
    ToVerify = 4,
    SubscriptionNotActivated = 5,
    MonthlySubscription = 6,
    YearlySubscription = 7,
    CanceledAtPeriodEnd = 8,
}

/** Contains the definition of an object of type StatusSubvention. */
export enum StatusSubvention {
    Unknown = 0,
    Untreated = 1,
    Registered = 2,
    PendingValidation = 3,
    PendingPayment = 4,
    Invoiced = 5,
    Paid = 6,
    Canceled = 7,
    Invalid = 8,
}

/** Contains the definition of an object of type PurchaseOrderDetails. */
export class PurchaseOrderDetails extends PurchaseOrder implements IPurchaseOrderDetails {
    /** Gets or sets the delivery address. */
    deliveryAddress?: string | undefined;
    /** Gets or sets the subvention organization billing address. */
    subventionOrganizationBillingAddress?: string | undefined;
    /** Gets or sets the subvention organization billing contact. */
    subventionOrganizationBillingContact?: string | undefined;
    /** Gets or sets the subvention organization billing email. */
    subventionOrganizationBillingEmail?: string | undefined;
    /** Gets or sets the subvention organization billing VAT. */
    subventionOrganizationBillingVAT?: string | undefined;
    /** Gets or sets the billing country iso3. */
    billingCountryIso3?: string | undefined;
    /** Gets or sets the Clien tBeneficiary Profession. */
    clientBeneficiaryProfession?: string | undefined;
    /** Gets or sets the Client Beneficiary RPPS. */
    clientBeneficiaryRpps?: string | undefined;
    /** Gets or sets the Client Beneficiary Adeli. */
    clientBeneficiaryAdeli?: string | undefined;
    /** Gets or sets the beneficiary address. */
    clientBeneficiaryAddress?: string | undefined;
    /** Gets or sets the beneficiary contact. */
    clientBeneficiaryContact?: string | undefined;
    /** Gets or sets the beneficiary email. */
    clientBeneficiaryEmail?: string | undefined;

    constructor(data?: IPurchaseOrderDetails) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.deliveryAddress = _data["deliveryAddress"];
            this.subventionOrganizationBillingAddress = _data["subventionOrganizationBillingAddress"];
            this.subventionOrganizationBillingContact = _data["subventionOrganizationBillingContact"];
            this.subventionOrganizationBillingEmail = _data["subventionOrganizationBillingEmail"];
            this.subventionOrganizationBillingVAT = _data["subventionOrganizationBillingVAT"];
            this.billingCountryIso3 = _data["billingCountryIso3"];
            this.clientBeneficiaryProfession = _data["clientBeneficiaryProfession"];
            this.clientBeneficiaryRpps = _data["clientBeneficiaryRpps"];
            this.clientBeneficiaryAdeli = _data["clientBeneficiaryAdeli"];
            this.clientBeneficiaryAddress = _data["clientBeneficiaryAddress"];
            this.clientBeneficiaryContact = _data["clientBeneficiaryContact"];
            this.clientBeneficiaryEmail = _data["clientBeneficiaryEmail"];
        }
    }

    static override fromJS(data: any): PurchaseOrderDetails {
        data = typeof data === 'object' ? data : {};
        let result = new PurchaseOrderDetails();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deliveryAddress"] = this.deliveryAddress;
        data["subventionOrganizationBillingAddress"] = this.subventionOrganizationBillingAddress;
        data["subventionOrganizationBillingContact"] = this.subventionOrganizationBillingContact;
        data["subventionOrganizationBillingEmail"] = this.subventionOrganizationBillingEmail;
        data["subventionOrganizationBillingVAT"] = this.subventionOrganizationBillingVAT;
        data["billingCountryIso3"] = this.billingCountryIso3;
        data["clientBeneficiaryProfession"] = this.clientBeneficiaryProfession;
        data["clientBeneficiaryRpps"] = this.clientBeneficiaryRpps;
        data["clientBeneficiaryAdeli"] = this.clientBeneficiaryAdeli;
        data["clientBeneficiaryAddress"] = this.clientBeneficiaryAddress;
        data["clientBeneficiaryContact"] = this.clientBeneficiaryContact;
        data["clientBeneficiaryEmail"] = this.clientBeneficiaryEmail;
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type PurchaseOrderDetails. */
export interface IPurchaseOrderDetails extends IPurchaseOrder {
    /** Gets or sets the delivery address. */
    deliveryAddress?: string | undefined;
    /** Gets or sets the subvention organization billing address. */
    subventionOrganizationBillingAddress?: string | undefined;
    /** Gets or sets the subvention organization billing contact. */
    subventionOrganizationBillingContact?: string | undefined;
    /** Gets or sets the subvention organization billing email. */
    subventionOrganizationBillingEmail?: string | undefined;
    /** Gets or sets the subvention organization billing VAT. */
    subventionOrganizationBillingVAT?: string | undefined;
    /** Gets or sets the billing country iso3. */
    billingCountryIso3?: string | undefined;
    /** Gets or sets the Clien tBeneficiary Profession. */
    clientBeneficiaryProfession?: string | undefined;
    /** Gets or sets the Client Beneficiary RPPS. */
    clientBeneficiaryRpps?: string | undefined;
    /** Gets or sets the Client Beneficiary Adeli. */
    clientBeneficiaryAdeli?: string | undefined;
    /** Gets or sets the beneficiary address. */
    clientBeneficiaryAddress?: string | undefined;
    /** Gets or sets the beneficiary contact. */
    clientBeneficiaryContact?: string | undefined;
    /** Gets or sets the beneficiary email. */
    clientBeneficiaryEmail?: string | undefined;
}

/** Contains the definition of an object of type DataStoreResource. */
export class DataStoreResource implements IDataStoreResource {
    /** Gets or sets the identifier. */
    id!: number;
    /** Gets or sets the name. */
    label?: string | undefined;
    /** Gets or sets the technical identifier. */
    technicalId!: number;

    constructor(data?: IDataStoreResource) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.label = _data["label"];
            this.technicalId = _data["technicalId"];
        }
    }

    static fromJS(data: any): DataStoreResource {
        data = typeof data === 'object' ? data : {};
        let result = new DataStoreResource();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["label"] = this.label;
        data["technicalId"] = this.technicalId;
        return data;
    }
}

/** Contains the definition of an object of type DataStoreResource. */
export interface IDataStoreResource {
    /** Gets or sets the identifier. */
    id: number;
    /** Gets or sets the name. */
    label?: string | undefined;
    /** Gets or sets the technical identifier. */
    technicalId: number;
}

/** Contains the definition of an object of type ExternalCursusImport. */
export class ExternalCursusImport implements IExternalCursusImport {
    /** Gets or sets the chart. */
    fileToImport?: any | undefined;
    /** Gets or sets the external cursus. */
    externalCursus?: ExternalCursus | undefined;

    constructor(data?: IExternalCursusImport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileToImport = _data["fileToImport"];
            this.externalCursus = _data["externalCursus"] ? ExternalCursus.fromJS(_data["externalCursus"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ExternalCursusImport {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalCursusImport();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileToImport"] = this.fileToImport;
        data["externalCursus"] = this.externalCursus ? this.externalCursus.toJSON() : <any>undefined;
        return data;
    }
}

/** Contains the definition of an object of type ExternalCursusImport. */
export interface IExternalCursusImport {
    /** Gets or sets the chart. */
    fileToImport?: any | undefined;
    /** Gets or sets the external cursus. */
    externalCursus?: ExternalCursus | undefined;
}

/** Contains the definition of an object of type Laboratory. */
export class Laboratory implements ILaboratory {
    /** Gets or sets the identifier. */
    id!: number;
    /** Gets or sets a value indicating whether this instance is archived. */
    isArchived!: boolean;
    /** Gets or sets the name. */
    name?: string | undefined;
    /** Gets or sets the website URL. */
    urls?: string[] | undefined;

    constructor(data?: ILaboratory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isArchived = _data["isArchived"];
            this.name = _data["name"];
            if (Array.isArray(_data["urls"])) {
                this.urls = [] as any;
                for (let item of _data["urls"])
                    this.urls!.push(item);
            }
        }
    }

    static fromJS(data: any): Laboratory {
        data = typeof data === 'object' ? data : {};
        let result = new Laboratory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isArchived"] = this.isArchived;
        data["name"] = this.name;
        if (Array.isArray(this.urls)) {
            data["urls"] = [];
            for (let item of this.urls)
                data["urls"].push(item);
        }
        return data;
    }
}

/** Contains the definition of an object of type Laboratory. */
export interface ILaboratory {
    /** Gets or sets the identifier. */
    id: number;
    /** Gets or sets a value indicating whether this instance is archived. */
    isArchived: boolean;
    /** Gets or sets the name. */
    name?: string | undefined;
    /** Gets or sets the website URL. */
    urls?: string[] | undefined;
}

/** Contains the definition of an object of type NutritionalSupplement. */
export class NutritionalSupplement implements INutritionalSupplement {
    /** Gets or sets the identifier. */
    id!: number;
    /** Gets or sets the name. */
    name?: string | undefined;
    /** Gets or sets the galenic. */
    galenic?: string | undefined;
    /** Gets or sets the laboratory. */
    laboratory?: Laboratory | undefined;
    /** Gets or sets the laboratory identifier. */
    laboratoryId?: number | undefined;
    /** Gets or sets the Brand. */
    brand?: string | undefined;
    /** Gets or sets the posology. */
    posology?: string | undefined;
    /** Gets or sets a value indicating whether this instance is active. */
    isArchived!: boolean;
    /** Gets or sets a value indicating whether this instance is from DGCCRF. */
    isFromDgccrf!: boolean;
    /** Gets or sets the integration partner identifier. */
    integrationPartnerId?: number | undefined;

    constructor(data?: INutritionalSupplement) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.galenic = _data["galenic"];
            this.laboratory = _data["laboratory"] ? Laboratory.fromJS(_data["laboratory"]) : <any>undefined;
            this.laboratoryId = _data["laboratoryId"];
            this.brand = _data["brand"];
            this.posology = _data["posology"];
            this.isArchived = _data["isArchived"];
            this.isFromDgccrf = _data["isFromDgccrf"];
            this.integrationPartnerId = _data["integrationPartnerId"];
        }
    }

    static fromJS(data: any): NutritionalSupplement {
        data = typeof data === 'object' ? data : {};
        let result = new NutritionalSupplement();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["galenic"] = this.galenic;
        data["laboratory"] = this.laboratory ? this.laboratory.toJSON() : <any>undefined;
        data["laboratoryId"] = this.laboratoryId;
        data["brand"] = this.brand;
        data["posology"] = this.posology;
        data["isArchived"] = this.isArchived;
        data["isFromDgccrf"] = this.isFromDgccrf;
        data["integrationPartnerId"] = this.integrationPartnerId;
        return data;
    }
}

/** Contains the definition of an object of type NutritionalSupplement. */
export interface INutritionalSupplement {
    /** Gets or sets the identifier. */
    id: number;
    /** Gets or sets the name. */
    name?: string | undefined;
    /** Gets or sets the galenic. */
    galenic?: string | undefined;
    /** Gets or sets the laboratory. */
    laboratory?: Laboratory | undefined;
    /** Gets or sets the laboratory identifier. */
    laboratoryId?: number | undefined;
    /** Gets or sets the Brand. */
    brand?: string | undefined;
    /** Gets or sets the posology. */
    posology?: string | undefined;
    /** Gets or sets a value indicating whether this instance is active. */
    isArchived: boolean;
    /** Gets or sets a value indicating whether this instance is from DGCCRF. */
    isFromDgccrf: boolean;
    /** Gets or sets the integration partner identifier. */
    integrationPartnerId?: number | undefined;
}

/** Contains the definition of an object of type NutritionalSupplementDetails. */
export class NutritionalSupplementDetails extends NutritionalSupplement implements INutritionalSupplementDetails {
    /** Gets or sets the At Risk Population. */
    atRiskPopulation?: string[] | undefined;
    /** Gets or sets the description. */
    description?: string | undefined;
    /** Gets or sets the description for Simplycure. */
    descriptionSimplycure?: string | undefined;
    /** Gets or sets the Ingredients. */
    ingredients?: DropdownValue[] | undefined;
    /** Gets or sets the Goals And Effects. */
    goalsAndEffects?: string[] | undefined;
    /** Gets or sets the Instructions. */
    instructions?: string | undefined;
    /** Gets or sets the Caution Note. */
    cautionNote?: string | undefined;
    /** Gets or sets the range. */
    range?: string | undefined;
    /** Gets or sets the aromas. */
    aromas?: string | undefined;
    /** Gets or sets the Plants. */
    plants?: DropdownValue[] | undefined;
    /** Gets or sets the Plants Families. */
    plantsFamilies?: string | undefined;
    /** Gets or sets the plants parts. */
    plantsParts?: string | undefined;

    constructor(data?: INutritionalSupplementDetails) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["atRiskPopulation"])) {
                this.atRiskPopulation = [] as any;
                for (let item of _data["atRiskPopulation"])
                    this.atRiskPopulation!.push(item);
            }
            this.description = _data["description"];
            this.descriptionSimplycure = _data["descriptionSimplycure"];
            if (Array.isArray(_data["ingredients"])) {
                this.ingredients = [] as any;
                for (let item of _data["ingredients"])
                    this.ingredients!.push(DropdownValue.fromJS(item));
            }
            if (Array.isArray(_data["goalsAndEffects"])) {
                this.goalsAndEffects = [] as any;
                for (let item of _data["goalsAndEffects"])
                    this.goalsAndEffects!.push(item);
            }
            this.instructions = _data["instructions"];
            this.cautionNote = _data["cautionNote"];
            this.range = _data["range"];
            this.aromas = _data["aromas"];
            if (Array.isArray(_data["plants"])) {
                this.plants = [] as any;
                for (let item of _data["plants"])
                    this.plants!.push(DropdownValue.fromJS(item));
            }
            this.plantsFamilies = _data["plantsFamilies"];
            this.plantsParts = _data["plantsParts"];
        }
    }

    static override fromJS(data: any): NutritionalSupplementDetails {
        data = typeof data === 'object' ? data : {};
        let result = new NutritionalSupplementDetails();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.atRiskPopulation)) {
            data["atRiskPopulation"] = [];
            for (let item of this.atRiskPopulation)
                data["atRiskPopulation"].push(item);
        }
        data["description"] = this.description;
        data["descriptionSimplycure"] = this.descriptionSimplycure;
        if (Array.isArray(this.ingredients)) {
            data["ingredients"] = [];
            for (let item of this.ingredients)
                data["ingredients"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.goalsAndEffects)) {
            data["goalsAndEffects"] = [];
            for (let item of this.goalsAndEffects)
                data["goalsAndEffects"].push(item);
        }
        data["instructions"] = this.instructions;
        data["cautionNote"] = this.cautionNote;
        data["range"] = this.range;
        data["aromas"] = this.aromas;
        if (Array.isArray(this.plants)) {
            data["plants"] = [];
            for (let item of this.plants)
                data["plants"].push(item ? item.toJSON() : <any>undefined);
        }
        data["plantsFamilies"] = this.plantsFamilies;
        data["plantsParts"] = this.plantsParts;
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type NutritionalSupplementDetails. */
export interface INutritionalSupplementDetails extends INutritionalSupplement {
    /** Gets or sets the At Risk Population. */
    atRiskPopulation?: string[] | undefined;
    /** Gets or sets the description. */
    description?: string | undefined;
    /** Gets or sets the description for Simplycure. */
    descriptionSimplycure?: string | undefined;
    /** Gets or sets the Ingredients. */
    ingredients?: DropdownValue[] | undefined;
    /** Gets or sets the Goals And Effects. */
    goalsAndEffects?: string[] | undefined;
    /** Gets or sets the Instructions. */
    instructions?: string | undefined;
    /** Gets or sets the Caution Note. */
    cautionNote?: string | undefined;
    /** Gets or sets the range. */
    range?: string | undefined;
    /** Gets or sets the aromas. */
    aromas?: string | undefined;
    /** Gets or sets the Plants. */
    plants?: DropdownValue[] | undefined;
    /** Gets or sets the Plants Families. */
    plantsFamilies?: string | undefined;
    /** Gets or sets the plants parts. */
    plantsParts?: string | undefined;
}

export class PaginatorWrapperOfIEnumerableOfNutritionalSupplementLite implements IPaginatorWrapperOfIEnumerableOfNutritionalSupplementLite {
    totalRecords!: number;
    data?: NutritionalSupplementLite[] | undefined;

    constructor(data?: IPaginatorWrapperOfIEnumerableOfNutritionalSupplementLite) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRecords = _data["totalRecords"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(NutritionalSupplementLite.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatorWrapperOfIEnumerableOfNutritionalSupplementLite {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatorWrapperOfIEnumerableOfNutritionalSupplementLite();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IPaginatorWrapperOfIEnumerableOfNutritionalSupplementLite {
    totalRecords: number;
    data?: NutritionalSupplementLite[] | undefined;
}

/** Contains the definition of an object of type NutritionalSupplementLite. */
export class NutritionalSupplementLite implements INutritionalSupplementLite {
    /** Gets or sets the identifier. */
    id!: number;
    /** Gets or sets the name. */
    name?: string | undefined;
    /** Gets or sets the name of the laboratory. */
    laboratoryName?: string | undefined;
    /** Gets or sets the name of the brand. */
    brand?: string | undefined;
    /** Gets or sets the posology. */
    posology?: string | undefined;
    /** Gets or sets a value indicating whether this instance is custom. */
    isCustom!: boolean;
    /** Gets or sets a value indicating whether this instance is selected. */
    isSelected!: boolean;
    /** Gets or sets a value indicating whether the doctor marked the nutritional supplement as favorite. */
    isFavorite!: boolean;
    /** Gets or sets a value indicating whether this instance is archived. */
    isArchived!: boolean;
    /** Gets or sets the last sending to patient. */
    lastSendingToPatient?: Date | undefined;
    /** Gets or sets a value indicating whether this instance is from DGCCRF. */
    isFromDgccrf!: boolean;

    constructor(data?: INutritionalSupplementLite) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.laboratoryName = _data["laboratoryName"];
            this.brand = _data["brand"];
            this.posology = _data["posology"];
            this.isCustom = _data["isCustom"];
            this.isSelected = _data["isSelected"];
            this.isFavorite = _data["isFavorite"];
            this.isArchived = _data["isArchived"];
            this.lastSendingToPatient = _data["lastSendingToPatient"] ? new Date(_data["lastSendingToPatient"].toString()) : <any>undefined;
            this.isFromDgccrf = _data["isFromDgccrf"];
        }
    }

    static fromJS(data: any): NutritionalSupplementLite {
        data = typeof data === 'object' ? data : {};
        let result = new NutritionalSupplementLite();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["laboratoryName"] = this.laboratoryName;
        data["brand"] = this.brand;
        data["posology"] = this.posology;
        data["isCustom"] = this.isCustom;
        data["isSelected"] = this.isSelected;
        data["isFavorite"] = this.isFavorite;
        data["isArchived"] = this.isArchived;
        data["lastSendingToPatient"] = this.lastSendingToPatient ? this.lastSendingToPatient.toISOString() : <any>undefined;
        data["isFromDgccrf"] = this.isFromDgccrf;
        return data;
    }
}

/** Contains the definition of an object of type NutritionalSupplementLite. */
export interface INutritionalSupplementLite {
    /** Gets or sets the identifier. */
    id: number;
    /** Gets or sets the name. */
    name?: string | undefined;
    /** Gets or sets the name of the laboratory. */
    laboratoryName?: string | undefined;
    /** Gets or sets the name of the brand. */
    brand?: string | undefined;
    /** Gets or sets the posology. */
    posology?: string | undefined;
    /** Gets or sets a value indicating whether this instance is custom. */
    isCustom: boolean;
    /** Gets or sets a value indicating whether this instance is selected. */
    isSelected: boolean;
    /** Gets or sets a value indicating whether the doctor marked the nutritional supplement as favorite. */
    isFavorite: boolean;
    /** Gets or sets a value indicating whether this instance is archived. */
    isArchived: boolean;
    /** Gets or sets the last sending to patient. */
    lastSendingToPatient?: Date | undefined;
    /** Gets or sets a value indicating whether this instance is from DGCCRF. */
    isFromDgccrf: boolean;
}

/** Contains the definition of an object of type NutritionalSupplementSearchParamLibrary. */
export class NutritionalSupplementSearchParamLibrary extends SearchParams implements INutritionalSupplementSearchParamLibrary {
    /** Gets or sets the name. */
    name?: string | undefined;
    /** Gets or sets the consultation identifier. */
    consultationId?: number | undefined;
    /** Gets or sets the patient identifier. */
    patientId?: number | undefined;
    /** Gets or sets the included Plants identifiers. */
    includedPlantsIds?: number[] | undefined;
    /** Gets or sets the excluded Plants identifiers. */
    excludedPlantsIds?: number[] | undefined;
    /** Gets or sets the included ingredients identifiers. */
    includedIngredientsIds?: number[] | undefined;
    /** Gets or sets the excluded ingredients identifiers. */
    excludedIngredientsIds?: number[] | undefined;
    /** Gets or sets the laboratory name. */
    laboratoryName?: string | undefined;
    /** Gets or sets the brand. */
    brand?: string | undefined;
    /** Gets or sets the Goals And Effects. */
    goalsAndEffects?: string | undefined;
    /** Gets or sets the galenics. */
    galenics?: string[] | undefined;
    /** Gets or sets a value indicating whether there are additives. */
    noAdditive!: boolean;
    /** Gets or sets a value indicating whether the function should return only the doctor's nutritional supplements or not. */
    myNsOnly!: boolean;

    constructor(data?: INutritionalSupplementSearchParamLibrary) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.consultationId = _data["consultationId"];
            this.patientId = _data["patientId"];
            if (Array.isArray(_data["includedPlantsIds"])) {
                this.includedPlantsIds = [] as any;
                for (let item of _data["includedPlantsIds"])
                    this.includedPlantsIds!.push(item);
            }
            if (Array.isArray(_data["excludedPlantsIds"])) {
                this.excludedPlantsIds = [] as any;
                for (let item of _data["excludedPlantsIds"])
                    this.excludedPlantsIds!.push(item);
            }
            if (Array.isArray(_data["includedIngredientsIds"])) {
                this.includedIngredientsIds = [] as any;
                for (let item of _data["includedIngredientsIds"])
                    this.includedIngredientsIds!.push(item);
            }
            if (Array.isArray(_data["excludedIngredientsIds"])) {
                this.excludedIngredientsIds = [] as any;
                for (let item of _data["excludedIngredientsIds"])
                    this.excludedIngredientsIds!.push(item);
            }
            this.laboratoryName = _data["laboratoryName"];
            this.brand = _data["brand"];
            this.goalsAndEffects = _data["goalsAndEffects"];
            if (Array.isArray(_data["galenics"])) {
                this.galenics = [] as any;
                for (let item of _data["galenics"])
                    this.galenics!.push(item);
            }
            this.noAdditive = _data["noAdditive"];
            this.myNsOnly = _data["myNsOnly"];
        }
    }

    static override fromJS(data: any): NutritionalSupplementSearchParamLibrary {
        data = typeof data === 'object' ? data : {};
        let result = new NutritionalSupplementSearchParamLibrary();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["consultationId"] = this.consultationId;
        data["patientId"] = this.patientId;
        if (Array.isArray(this.includedPlantsIds)) {
            data["includedPlantsIds"] = [];
            for (let item of this.includedPlantsIds)
                data["includedPlantsIds"].push(item);
        }
        if (Array.isArray(this.excludedPlantsIds)) {
            data["excludedPlantsIds"] = [];
            for (let item of this.excludedPlantsIds)
                data["excludedPlantsIds"].push(item);
        }
        if (Array.isArray(this.includedIngredientsIds)) {
            data["includedIngredientsIds"] = [];
            for (let item of this.includedIngredientsIds)
                data["includedIngredientsIds"].push(item);
        }
        if (Array.isArray(this.excludedIngredientsIds)) {
            data["excludedIngredientsIds"] = [];
            for (let item of this.excludedIngredientsIds)
                data["excludedIngredientsIds"].push(item);
        }
        data["laboratoryName"] = this.laboratoryName;
        data["brand"] = this.brand;
        data["goalsAndEffects"] = this.goalsAndEffects;
        if (Array.isArray(this.galenics)) {
            data["galenics"] = [];
            for (let item of this.galenics)
                data["galenics"].push(item);
        }
        data["noAdditive"] = this.noAdditive;
        data["myNsOnly"] = this.myNsOnly;
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type NutritionalSupplementSearchParamLibrary. */
export interface INutritionalSupplementSearchParamLibrary extends ISearchParams {
    /** Gets or sets the name. */
    name?: string | undefined;
    /** Gets or sets the consultation identifier. */
    consultationId?: number | undefined;
    /** Gets or sets the patient identifier. */
    patientId?: number | undefined;
    /** Gets or sets the included Plants identifiers. */
    includedPlantsIds?: number[] | undefined;
    /** Gets or sets the excluded Plants identifiers. */
    excludedPlantsIds?: number[] | undefined;
    /** Gets or sets the included ingredients identifiers. */
    includedIngredientsIds?: number[] | undefined;
    /** Gets or sets the excluded ingredients identifiers. */
    excludedIngredientsIds?: number[] | undefined;
    /** Gets or sets the laboratory name. */
    laboratoryName?: string | undefined;
    /** Gets or sets the brand. */
    brand?: string | undefined;
    /** Gets or sets the Goals And Effects. */
    goalsAndEffects?: string | undefined;
    /** Gets or sets the galenics. */
    galenics?: string[] | undefined;
    /** Gets or sets a value indicating whether there are additives. */
    noAdditive: boolean;
    /** Gets or sets a value indicating whether the function should return only the doctor's nutritional supplements or not. */
    myNsOnly: boolean;
}

/** Contains the definition of an object of type NutritionalSupplementActivePrincipleView. */
export class NutritionalSupplementActivePrincipleView implements INutritionalSupplementActivePrincipleView {
    /** Gets or sets the identifier. */
    id!: number;
    /** Gets or sets the display name. */
    label?: string | undefined;
    /** Gets or sets a value indicating whether the active principle is an additive or not. */
    isAdditive!: boolean;

    constructor(data?: INutritionalSupplementActivePrincipleView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.label = _data["label"];
            this.isAdditive = _data["isAdditive"];
        }
    }

    static fromJS(data: any): NutritionalSupplementActivePrincipleView {
        data = typeof data === 'object' ? data : {};
        let result = new NutritionalSupplementActivePrincipleView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["label"] = this.label;
        data["isAdditive"] = this.isAdditive;
        return data;
    }
}

/** Contains the definition of an object of type NutritionalSupplementActivePrincipleView. */
export interface INutritionalSupplementActivePrincipleView {
    /** Gets or sets the identifier. */
    id: number;
    /** Gets or sets the display name. */
    label?: string | undefined;
    /** Gets or sets a value indicating whether the active principle is an additive or not. */
    isAdditive: boolean;
}

/** Contains the definition of an object of type LaboratorySearchParams. */
export class LaboratorySearchParams extends SearchParams implements ILaboratorySearchParams {
    /** Gets or sets the name. */
    name?: string | undefined;
    /** Gets or sets a value indicating whether this instance is active. */
    isArchived?: boolean | undefined;

    constructor(data?: ILaboratorySearchParams) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.isArchived = _data["isArchived"];
        }
    }

    static override fromJS(data: any): LaboratorySearchParams {
        data = typeof data === 'object' ? data : {};
        let result = new LaboratorySearchParams();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["isArchived"] = this.isArchived;
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type LaboratorySearchParams. */
export interface ILaboratorySearchParams extends ISearchParams {
    /** Gets or sets the name. */
    name?: string | undefined;
    /** Gets or sets a value indicating whether this instance is active. */
    isArchived?: boolean | undefined;
}

/** Contains the definition of an object of type CurrentPatientInfo. */
export class CurrentPatientInfo implements ICurrentPatientInfo {
    /** Gets or sets the accessible menu. */
    accessibleMenu?: AccessibleMenu | undefined;
    /** Gets or sets the first name. */
    firstName?: string | undefined;
    /** Gets or sets the identifier. */
    id!: number;
    /** Gets or sets the insurance token. */
    insuranceToken?: string | undefined;
    /** Gets or sets the last name. */
    lastName?: string | undefined;
    /** Gets or sets the last seen document. */
    lastSeenDocument?: Date | undefined;
    /** Gets or sets the member identifier. */
    memberId!: number;
    /** Gets or sets the profile picture url. */
    profilePictureUrl?: string | undefined;
    /** Gets or sets a value indicating whether the patient has biody. */
    hasBiody!: boolean;

    constructor(data?: ICurrentPatientInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessibleMenu = _data["accessibleMenu"] ? AccessibleMenu.fromJS(_data["accessibleMenu"]) : <any>undefined;
            this.firstName = _data["firstName"];
            this.id = _data["id"];
            this.insuranceToken = _data["insuranceToken"];
            this.lastName = _data["lastName"];
            this.lastSeenDocument = _data["lastSeenDocument"] ? new Date(_data["lastSeenDocument"].toString()) : <any>undefined;
            this.memberId = _data["memberId"];
            this.profilePictureUrl = _data["profilePictureUrl"];
            this.hasBiody = _data["hasBiody"];
        }
    }

    static fromJS(data: any): CurrentPatientInfo {
        data = typeof data === 'object' ? data : {};
        let result = new CurrentPatientInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessibleMenu"] = this.accessibleMenu ? this.accessibleMenu.toJSON() : <any>undefined;
        data["firstName"] = this.firstName;
        data["id"] = this.id;
        data["insuranceToken"] = this.insuranceToken;
        data["lastName"] = this.lastName;
        data["lastSeenDocument"] = this.lastSeenDocument ? this.lastSeenDocument.toISOString() : <any>undefined;
        data["memberId"] = this.memberId;
        data["profilePictureUrl"] = this.profilePictureUrl;
        data["hasBiody"] = this.hasBiody;
        return data;
    }
}

/** Contains the definition of an object of type CurrentPatientInfo. */
export interface ICurrentPatientInfo {
    /** Gets or sets the accessible menu. */
    accessibleMenu?: AccessibleMenu | undefined;
    /** Gets or sets the first name. */
    firstName?: string | undefined;
    /** Gets or sets the identifier. */
    id: number;
    /** Gets or sets the insurance token. */
    insuranceToken?: string | undefined;
    /** Gets or sets the last name. */
    lastName?: string | undefined;
    /** Gets or sets the last seen document. */
    lastSeenDocument?: Date | undefined;
    /** Gets or sets the member identifier. */
    memberId: number;
    /** Gets or sets the profile picture url. */
    profilePictureUrl?: string | undefined;
    /** Gets or sets a value indicating whether the patient has biody. */
    hasBiody: boolean;
}

/** Contains the definition of an object of type AccessibleMenu. */
export class AccessibleMenu implements IAccessibleMenu {
    /** Gets or sets a value indicating whether this instance has activities. */
    hasActivities!: boolean;
    /** Gets or sets a value indicating whether this instance has cart. */
    hasCart!: boolean;
    /** Gets or sets a value indicating whether this instance has consultations. */
    hasConsultations!: boolean;
    /** Gets or sets a value indicating whether this instance has documents. */
    hasDocuments!: boolean;
    /** Gets or sets a value indicating whether this instance has formularies. */
    hasFormularies!: boolean;
    /** Gets or sets a value indicating whether this instance has coaching. */
    hasRecipes!: boolean;
    /** Gets or sets a value indicating whether this instance has sleep diary. */
    hasSleepDiary!: boolean;
    /** Gets or sets a value indicating whether this instance has suggestions. */
    hasSuggestions!: boolean;
    /** Gets or sets the sleep diary identifier. */
    sleepDiaryId?: number | undefined;

    constructor(data?: IAccessibleMenu) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hasActivities = _data["hasActivities"];
            this.hasCart = _data["hasCart"];
            this.hasConsultations = _data["hasConsultations"];
            this.hasDocuments = _data["hasDocuments"];
            this.hasFormularies = _data["hasFormularies"];
            this.hasRecipes = _data["hasRecipes"];
            this.hasSleepDiary = _data["hasSleepDiary"];
            this.hasSuggestions = _data["hasSuggestions"];
            this.sleepDiaryId = _data["sleepDiaryId"];
        }
    }

    static fromJS(data: any): AccessibleMenu {
        data = typeof data === 'object' ? data : {};
        let result = new AccessibleMenu();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasActivities"] = this.hasActivities;
        data["hasCart"] = this.hasCart;
        data["hasConsultations"] = this.hasConsultations;
        data["hasDocuments"] = this.hasDocuments;
        data["hasFormularies"] = this.hasFormularies;
        data["hasRecipes"] = this.hasRecipes;
        data["hasSleepDiary"] = this.hasSleepDiary;
        data["hasSuggestions"] = this.hasSuggestions;
        data["sleepDiaryId"] = this.sleepDiaryId;
        return data;
    }
}

/** Contains the definition of an object of type AccessibleMenu. */
export interface IAccessibleMenu {
    /** Gets or sets a value indicating whether this instance has activities. */
    hasActivities: boolean;
    /** Gets or sets a value indicating whether this instance has cart. */
    hasCart: boolean;
    /** Gets or sets a value indicating whether this instance has consultations. */
    hasConsultations: boolean;
    /** Gets or sets a value indicating whether this instance has documents. */
    hasDocuments: boolean;
    /** Gets or sets a value indicating whether this instance has formularies. */
    hasFormularies: boolean;
    /** Gets or sets a value indicating whether this instance has coaching. */
    hasRecipes: boolean;
    /** Gets or sets a value indicating whether this instance has sleep diary. */
    hasSleepDiary: boolean;
    /** Gets or sets a value indicating whether this instance has suggestions. */
    hasSuggestions: boolean;
    /** Gets or sets the sleep diary identifier. */
    sleepDiaryId?: number | undefined;
}

export class PaginatorWrapperOfIEnumerableOfDoctorConsultSiinInfos implements IPaginatorWrapperOfIEnumerableOfDoctorConsultSiinInfos {
    totalRecords!: number;
    data?: DoctorConsultSiinInfos[] | undefined;

    constructor(data?: IPaginatorWrapperOfIEnumerableOfDoctorConsultSiinInfos) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRecords = _data["totalRecords"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(DoctorConsultSiinInfos.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatorWrapperOfIEnumerableOfDoctorConsultSiinInfos {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatorWrapperOfIEnumerableOfDoctorConsultSiinInfos();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IPaginatorWrapperOfIEnumerableOfDoctorConsultSiinInfos {
    totalRecords: number;
    data?: DoctorConsultSiinInfos[] | undefined;
}

/** Contains the definition of an object of type DoctorFilter. */
export class DoctorFilter implements IDoctorFilter {
    /** Gets the display name. */
    displayName?: string | undefined;
    /** Gets or sets the first name. */
    firstName?: string | undefined;
    /** Gets or sets the identifier. */
    id!: number;
    /** Gets or sets the last name. */
    lastName?: string | undefined;

    constructor(data?: IDoctorFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.displayName = _data["displayName"];
            this.firstName = _data["firstName"];
            this.id = _data["id"];
            this.lastName = _data["lastName"];
        }
    }

    static fromJS(data: any): DoctorFilter {
        data = typeof data === 'object' ? data : {};
        let result = new DoctorFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayName"] = this.displayName;
        data["firstName"] = this.firstName;
        data["id"] = this.id;
        data["lastName"] = this.lastName;
        return data;
    }
}

/** Contains the definition of an object of type DoctorFilter. */
export interface IDoctorFilter {
    /** Gets the display name. */
    displayName?: string | undefined;
    /** Gets or sets the first name. */
    firstName?: string | undefined;
    /** Gets or sets the identifier. */
    id: number;
    /** Gets or sets the last name. */
    lastName?: string | undefined;
}

/** Contains the definition of an object of type PatientMeasureBaseEdit. */
export class PatientMeasureBaseEdit implements IPatientMeasureBaseEdit {
    /** Gets or sets the patient identifier., */
    patientId!: number;
    /** Gets or sets the type. */
    patientMeasureTypeId!: number;
    /** Gets or sets the value. */
    value?: number | undefined;
    /** Gets or sets the date of the measure. */
    date!: Date;
    /** Gets or sets the string value. */
    stringValue?: string | undefined;

    constructor(data?: IPatientMeasureBaseEdit) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.patientId = _data["patientId"];
            this.patientMeasureTypeId = _data["patientMeasureTypeId"];
            this.value = _data["value"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.stringValue = _data["stringValue"];
        }
    }

    static fromJS(data: any): PatientMeasureBaseEdit {
        data = typeof data === 'object' ? data : {};
        let result = new PatientMeasureBaseEdit();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["patientId"] = this.patientId;
        data["patientMeasureTypeId"] = this.patientMeasureTypeId;
        data["value"] = this.value;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["stringValue"] = this.stringValue;
        return data;
    }
}

/** Contains the definition of an object of type PatientMeasureBaseEdit. */
export interface IPatientMeasureBaseEdit {
    /** Gets or sets the patient identifier., */
    patientId: number;
    /** Gets or sets the type. */
    patientMeasureTypeId: number;
    /** Gets or sets the value. */
    value?: number | undefined;
    /** Gets or sets the date of the measure. */
    date: Date;
    /** Gets or sets the string value. */
    stringValue?: string | undefined;
}

/** Contains the definition of an object of type CreatePatientMeasure. */
export class CreatePatientMeasure extends PatientMeasureBaseEdit implements ICreatePatientMeasure {

    constructor(data?: ICreatePatientMeasure) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): CreatePatientMeasure {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePatientMeasure();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type CreatePatientMeasure. */
export interface ICreatePatientMeasure extends IPatientMeasureBaseEdit {
}

/** Contains the definition of an object of type PatientAnswer. */
export class PatientAnswer implements IPatientAnswer {
    /** Gets or sets the identifier. */
    id!: number;
    /** Gets or sets the answer identifier. */
    answerId?: number | undefined;
    /** Gets or sets the consultation identifier. */
    consultationId!: number;
    /** Gets or sets the question identifier. */
    questionId!: number;
    /** Gets or sets the scale choice answer. */
    scaleChoiceAnswer?: number | undefined;
    /** Gets or sets the free field answer. */
    freeFieldsAnswer?: string | undefined;
    /** Gets or sets the sleep diary answer. */
    sleepDiaryAnswerRows?: SleepDiaryAnswerRow[] | undefined;
    /** Gets or sets the upload image. */
    uploadImage?: any | undefined;
    /** Gets or sets the image URL. */
    imageUrl?: string | undefined;
    /** Gets or sets a value indicating whether the image changed. */
    imageChanged!: boolean;
    /** Gets or sets the foods. */
    foods?: PatientAnswerFood[] | undefined;
    /** Gets or sets the nutrition info. */
    nutritionInfo?: NutritionInfo | undefined;

    constructor(data?: IPatientAnswer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.answerId = _data["answerId"];
            this.consultationId = _data["consultationId"];
            this.questionId = _data["questionId"];
            this.scaleChoiceAnswer = _data["scaleChoiceAnswer"];
            this.freeFieldsAnswer = _data["freeFieldsAnswer"];
            if (Array.isArray(_data["sleepDiaryAnswerRows"])) {
                this.sleepDiaryAnswerRows = [] as any;
                for (let item of _data["sleepDiaryAnswerRows"])
                    this.sleepDiaryAnswerRows!.push(SleepDiaryAnswerRow.fromJS(item));
            }
            this.uploadImage = _data["uploadImage"];
            this.imageUrl = _data["imageUrl"];
            this.imageChanged = _data["imageChanged"];
            if (Array.isArray(_data["foods"])) {
                this.foods = [] as any;
                for (let item of _data["foods"])
                    this.foods!.push(PatientAnswerFood.fromJS(item));
            }
            this.nutritionInfo = _data["nutritionInfo"] ? NutritionInfo.fromJS(_data["nutritionInfo"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PatientAnswer {
        data = typeof data === 'object' ? data : {};
        let result = new PatientAnswer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["answerId"] = this.answerId;
        data["consultationId"] = this.consultationId;
        data["questionId"] = this.questionId;
        data["scaleChoiceAnswer"] = this.scaleChoiceAnswer;
        data["freeFieldsAnswer"] = this.freeFieldsAnswer;
        if (Array.isArray(this.sleepDiaryAnswerRows)) {
            data["sleepDiaryAnswerRows"] = [];
            for (let item of this.sleepDiaryAnswerRows)
                data["sleepDiaryAnswerRows"].push(item ? item.toJSON() : <any>undefined);
        }
        data["uploadImage"] = this.uploadImage;
        data["imageUrl"] = this.imageUrl;
        data["imageChanged"] = this.imageChanged;
        if (Array.isArray(this.foods)) {
            data["foods"] = [];
            for (let item of this.foods)
                data["foods"].push(item ? item.toJSON() : <any>undefined);
        }
        data["nutritionInfo"] = this.nutritionInfo ? this.nutritionInfo.toJSON() : <any>undefined;
        return data;
    }
}

/** Contains the definition of an object of type PatientAnswer. */
export interface IPatientAnswer {
    /** Gets or sets the identifier. */
    id: number;
    /** Gets or sets the answer identifier. */
    answerId?: number | undefined;
    /** Gets or sets the consultation identifier. */
    consultationId: number;
    /** Gets or sets the question identifier. */
    questionId: number;
    /** Gets or sets the scale choice answer. */
    scaleChoiceAnswer?: number | undefined;
    /** Gets or sets the free field answer. */
    freeFieldsAnswer?: string | undefined;
    /** Gets or sets the sleep diary answer. */
    sleepDiaryAnswerRows?: SleepDiaryAnswerRow[] | undefined;
    /** Gets or sets the upload image. */
    uploadImage?: any | undefined;
    /** Gets or sets the image URL. */
    imageUrl?: string | undefined;
    /** Gets or sets a value indicating whether the image changed. */
    imageChanged: boolean;
    /** Gets or sets the foods. */
    foods?: PatientAnswerFood[] | undefined;
    /** Gets or sets the nutrition info. */
    nutritionInfo?: NutritionInfo | undefined;
}

/** Contains the definition of an object of type SleepDiaryAnswerRow. */
export class SleepDiaryAnswerRow implements ISleepDiaryAnswerRow {
    /** Gets or sets the awakeness qualitity. */
    awakenessQuality!: number;
    /** Gets or sets the comment. */
    comment?: string | undefined;
    /** Gets or sets the date. */
    date!: Date;
    /** Gets or sets a value indicating whether the patient took hypnotics. */
    hypnotic!: boolean;
    /** Gets or sets the answers in a row. */
    rowAnswer?: SleepDiaryOption[] | undefined;
    /** Gets or sets the sleep quality. */
    sleepQuality!: number;

    constructor(data?: ISleepDiaryAnswerRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.awakenessQuality = _data["awakenessQuality"];
            this.comment = _data["comment"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.hypnotic = _data["hypnotic"];
            if (Array.isArray(_data["rowAnswer"])) {
                this.rowAnswer = [] as any;
                for (let item of _data["rowAnswer"])
                    this.rowAnswer!.push(item);
            }
            this.sleepQuality = _data["sleepQuality"];
        }
    }

    static fromJS(data: any): SleepDiaryAnswerRow {
        data = typeof data === 'object' ? data : {};
        let result = new SleepDiaryAnswerRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["awakenessQuality"] = this.awakenessQuality;
        data["comment"] = this.comment;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["hypnotic"] = this.hypnotic;
        if (Array.isArray(this.rowAnswer)) {
            data["rowAnswer"] = [];
            for (let item of this.rowAnswer)
                data["rowAnswer"].push(item);
        }
        data["sleepQuality"] = this.sleepQuality;
        return data;
    }
}

/** Contains the definition of an object of type SleepDiaryAnswerRow. */
export interface ISleepDiaryAnswerRow {
    /** Gets or sets the awakeness qualitity. */
    awakenessQuality: number;
    /** Gets or sets the comment. */
    comment?: string | undefined;
    /** Gets or sets the date. */
    date: Date;
    /** Gets or sets a value indicating whether the patient took hypnotics. */
    hypnotic: boolean;
    /** Gets or sets the answers in a row. */
    rowAnswer?: SleepDiaryOption[] | undefined;
    /** Gets or sets the sleep quality. */
    sleepQuality: number;
}

/** Contains the definition of an object of type SleepDiaryOption. */
export enum SleepDiaryOption {
    Empty = 0,
    LightsOffTime = 1,
    WakeUpTime = 2,
    SleepPeriod = 3,
    NightWakePeriod = 4,
    Tiredness = 5,
    WillForSleep = 6,
    UnintentionalNap = 7,
    IntentionalNap = 8,
}

/** Contains the definition of an object of type PatientAnswerFood. */
export class PatientAnswerFood implements IPatientAnswerFood {
    /** Gets or sets the identifier. */
    id!: number;
    /** Gets or sets the patient answer identifier. */
    patientAnswerId!: number;
    /** Gets or sets the identifier. */
    ingredientId!: number;
    /** Gets or sets the unit type identifier. */
    unitTypeId!: number;
    /** Gets or sets the quantity. */
    quantity!: number;
    /** Gets or sets the ingredient details. */
    ingredient?: Ingredient | undefined;

    constructor(data?: IPatientAnswerFood) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.patientAnswerId = _data["PatientAnswerId"];
            this.ingredientId = _data["IngredientId"];
            this.unitTypeId = _data["UnitTypeId"];
            this.quantity = _data["Quantity"];
            this.ingredient = _data["Ingredient"] ? Ingredient.fromJS(_data["Ingredient"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PatientAnswerFood {
        data = typeof data === 'object' ? data : {};
        let result = new PatientAnswerFood();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["PatientAnswerId"] = this.patientAnswerId;
        data["IngredientId"] = this.ingredientId;
        data["UnitTypeId"] = this.unitTypeId;
        data["Quantity"] = this.quantity;
        data["Ingredient"] = this.ingredient ? this.ingredient.toJSON() : <any>undefined;
        return data;
    }
}

/** Contains the definition of an object of type PatientAnswerFood. */
export interface IPatientAnswerFood {
    /** Gets or sets the identifier. */
    id: number;
    /** Gets or sets the patient answer identifier. */
    patientAnswerId: number;
    /** Gets or sets the identifier. */
    ingredientId: number;
    /** Gets or sets the unit type identifier. */
    unitTypeId: number;
    /** Gets or sets the quantity. */
    quantity: number;
    /** Gets or sets the ingredient details. */
    ingredient?: Ingredient | undefined;
}

/** Contains the definition of an object of type Ingredient. */
export class Ingredient implements IIngredient {
    /** Gets or sets the name. */
    name?: string | undefined;
    /** Gets or sets the identifier. */
    id!: number;
    /** Gets or sets the identifier. */
    unitTypes?: UnitType[] | undefined;
    /** Gets or sets the current status of the ingredient. */
    status!: IngredientStatus;

    constructor(data?: IIngredient) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.id = _data["id"];
            if (Array.isArray(_data["unitTypes"])) {
                this.unitTypes = [] as any;
                for (let item of _data["unitTypes"])
                    this.unitTypes!.push(UnitType.fromJS(item));
            }
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): Ingredient {
        data = typeof data === 'object' ? data : {};
        let result = new Ingredient();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["id"] = this.id;
        if (Array.isArray(this.unitTypes)) {
            data["unitTypes"] = [];
            for (let item of this.unitTypes)
                data["unitTypes"].push(item ? item.toJSON() : <any>undefined);
        }
        data["status"] = this.status;
        return data;
    }
}

/** Contains the definition of an object of type Ingredient. */
export interface IIngredient {
    /** Gets or sets the name. */
    name?: string | undefined;
    /** Gets or sets the identifier. */
    id: number;
    /** Gets or sets the identifier. */
    unitTypes?: UnitType[] | undefined;
    /** Gets or sets the current status of the ingredient. */
    status: IngredientStatus;
}

/** Contains the definition of an object of type UnitType. */
export class UnitType implements IUnitType {
    /** Gets or sets the name. */
    name?: string | undefined;
    /** Gets or sets the plural name. */
    pluralName?: string | undefined;
    /** Gets or sets the identifier. */
    id!: number;

    constructor(data?: IUnitType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.pluralName = _data["pluralName"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UnitType {
        data = typeof data === 'object' ? data : {};
        let result = new UnitType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["pluralName"] = this.pluralName;
        data["id"] = this.id;
        return data;
    }
}

/** Contains the definition of an object of type UnitType. */
export interface IUnitType {
    /** Gets or sets the name. */
    name?: string | undefined;
    /** Gets or sets the plural name. */
    pluralName?: string | undefined;
    /** Gets or sets the identifier. */
    id: number;
}

/** Contains the definition of an object of type IngredientStatus. */
export enum IngredientStatus {
    Private = 0,
    PendingValidation = 1,
    Public = 2,
}

/** Contains the definition of an object of type NutritionInfo. */
export class NutritionInfo implements INutritionInfo {
    /** Gets or sets the nutrition info type */
    title?: string | undefined;
    /** Gets or sets the quantity. */
    quantity!: number;
    /** Gets or sets the quantity per portion. */
    quantityPerPortion!: number;
    /** Gets or sets the unittypeid */
    proteins!: number;
    /** Gets or sets the unittypeid */
    lipids!: number;
    /** Gets or sets the unittypeid */
    carbs!: number;
    /** Gets or sets the nutrient with quantities. */
    nutrients?: RecipeNutrientLite[] | undefined;
    /** Gets or sets the nutrient categories. */
    nutrientCategories?: RecipeNutrientCategory[] | undefined;
    /** Gets or sets the calorific power per portion. */
    calorificPowerPerPortion!: number;
    /** Gets or sets the nutrient ingredients. */
    nutrientIngredients?: NutrientIngredient[] | undefined;
    /** Gets or sets the calorific power kcal. */
    calorificPowerKcal!: number;

    constructor(data?: INutritionInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.quantity = _data["quantity"];
            this.quantityPerPortion = _data["quantityPerPortion"];
            this.proteins = _data["proteins"];
            this.lipids = _data["lipids"];
            this.carbs = _data["carbs"];
            if (Array.isArray(_data["nutrients"])) {
                this.nutrients = [] as any;
                for (let item of _data["nutrients"])
                    this.nutrients!.push(RecipeNutrientLite.fromJS(item));
            }
            if (Array.isArray(_data["nutrientCategories"])) {
                this.nutrientCategories = [] as any;
                for (let item of _data["nutrientCategories"])
                    this.nutrientCategories!.push(RecipeNutrientCategory.fromJS(item));
            }
            this.calorificPowerPerPortion = _data["calorificPowerPerPortion"];
            if (Array.isArray(_data["nutrientIngredients"])) {
                this.nutrientIngredients = [] as any;
                for (let item of _data["nutrientIngredients"])
                    this.nutrientIngredients!.push(NutrientIngredient.fromJS(item));
            }
            this.calorificPowerKcal = _data["calorificPowerKcal"];
        }
    }

    static fromJS(data: any): NutritionInfo {
        data = typeof data === 'object' ? data : {};
        let result = new NutritionInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["quantity"] = this.quantity;
        data["quantityPerPortion"] = this.quantityPerPortion;
        data["proteins"] = this.proteins;
        data["lipids"] = this.lipids;
        data["carbs"] = this.carbs;
        if (Array.isArray(this.nutrients)) {
            data["nutrients"] = [];
            for (let item of this.nutrients)
                data["nutrients"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.nutrientCategories)) {
            data["nutrientCategories"] = [];
            for (let item of this.nutrientCategories)
                data["nutrientCategories"].push(item ? item.toJSON() : <any>undefined);
        }
        data["calorificPowerPerPortion"] = this.calorificPowerPerPortion;
        if (Array.isArray(this.nutrientIngredients)) {
            data["nutrientIngredients"] = [];
            for (let item of this.nutrientIngredients)
                data["nutrientIngredients"].push(item ? item.toJSON() : <any>undefined);
        }
        data["calorificPowerKcal"] = this.calorificPowerKcal;
        return data;
    }
}

/** Contains the definition of an object of type NutritionInfo. */
export interface INutritionInfo {
    /** Gets or sets the nutrition info type */
    title?: string | undefined;
    /** Gets or sets the quantity. */
    quantity: number;
    /** Gets or sets the quantity per portion. */
    quantityPerPortion: number;
    /** Gets or sets the unittypeid */
    proteins: number;
    /** Gets or sets the unittypeid */
    lipids: number;
    /** Gets or sets the unittypeid */
    carbs: number;
    /** Gets or sets the nutrient with quantities. */
    nutrients?: RecipeNutrientLite[] | undefined;
    /** Gets or sets the nutrient categories. */
    nutrientCategories?: RecipeNutrientCategory[] | undefined;
    /** Gets or sets the calorific power per portion. */
    calorificPowerPerPortion: number;
    /** Gets or sets the nutrient ingredients. */
    nutrientIngredients?: NutrientIngredient[] | undefined;
    /** Gets or sets the calorific power kcal. */
    calorificPowerKcal: number;
}

/** Contains the definition of an object of type NutrientIngredient. */
export class NutrientIngredient implements INutrientIngredient {
    /** Gets or sets the nutriment identifier. */
    nutrientId!: number;
    /** Gets or sets the ingredient identifier. */
    ingredientId!: number;
    /** Gets or sets the quantity. */
    quantity!: number;
    /** Gets or sets the name. */
    nutrient?: Nutrient | undefined;
    /** Gets or sets the ingredient. */
    ingredient?: Ingredient | undefined;

    constructor(data?: INutrientIngredient) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nutrientId = _data["nutrientId"];
            this.ingredientId = _data["ingredientId"];
            this.quantity = _data["quantity"];
            this.nutrient = _data["nutrient"] ? Nutrient.fromJS(_data["nutrient"]) : <any>undefined;
            this.ingredient = _data["ingredient"] ? Ingredient.fromJS(_data["ingredient"]) : <any>undefined;
        }
    }

    static fromJS(data: any): NutrientIngredient {
        data = typeof data === 'object' ? data : {};
        let result = new NutrientIngredient();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nutrientId"] = this.nutrientId;
        data["ingredientId"] = this.ingredientId;
        data["quantity"] = this.quantity;
        data["nutrient"] = this.nutrient ? this.nutrient.toJSON() : <any>undefined;
        data["ingredient"] = this.ingredient ? this.ingredient.toJSON() : <any>undefined;
        return data;
    }
}

/** Contains the definition of an object of type NutrientIngredient. */
export interface INutrientIngredient {
    /** Gets or sets the nutriment identifier. */
    nutrientId: number;
    /** Gets or sets the ingredient identifier. */
    ingredientId: number;
    /** Gets or sets the quantity. */
    quantity: number;
    /** Gets or sets the name. */
    nutrient?: Nutrient | undefined;
    /** Gets or sets the ingredient. */
    ingredient?: Ingredient | undefined;
}

/** Contains the definition of an object of type NutrientLite. */
export class NutrientLite implements INutrientLite {
    /** Gets or sets the identifier. */
    id!: number;
    /** Gets or sets the name. */
    name?: string | undefined;
    /** Gets or sets the type of the unit. */
    unitType!: NutrientUnitType;
    /** Gets or sets the category identifier. */
    categoryId!: number;
    /** Gets or sets the name of the category. */
    categoryName?: string | undefined;

    constructor(data?: INutrientLite) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.unitType = _data["unitType"];
            this.categoryId = _data["categoryId"];
            this.categoryName = _data["categoryName"];
        }
    }

    static fromJS(data: any): NutrientLite {
        data = typeof data === 'object' ? data : {};
        let result = new NutrientLite();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["unitType"] = this.unitType;
        data["categoryId"] = this.categoryId;
        data["categoryName"] = this.categoryName;
        return data;
    }
}

/** Contains the definition of an object of type NutrientLite. */
export interface INutrientLite {
    /** Gets or sets the identifier. */
    id: number;
    /** Gets or sets the name. */
    name?: string | undefined;
    /** Gets or sets the type of the unit. */
    unitType: NutrientUnitType;
    /** Gets or sets the category identifier. */
    categoryId: number;
    /** Gets or sets the name of the category. */
    categoryName?: string | undefined;
}

/** Contains the definition of an object of type Nutrient. */
export class Nutrient extends NutrientLite implements INutrient {
    /** Gets or sets a value indicating whether this instance is allergen. */
    isAllergen?: boolean | undefined;
    /** Gets or sets the synonyms. */
    synonyms?: string[] | undefined;
    /** Gets or sets the suggestible. */
    suggestible?: Suggestible | undefined;
    /** Gets or sets the category. */
    category?: NutrientCategory | undefined;

    constructor(data?: INutrient) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.isAllergen = _data["isAllergen"];
            if (Array.isArray(_data["synonyms"])) {
                this.synonyms = [] as any;
                for (let item of _data["synonyms"])
                    this.synonyms!.push(item);
            }
            this.suggestible = _data["suggestible"] ? Suggestible.fromJS(_data["suggestible"]) : <any>undefined;
            this.category = _data["category"] ? NutrientCategory.fromJS(_data["category"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): Nutrient {
        data = typeof data === 'object' ? data : {};
        let result = new Nutrient();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isAllergen"] = this.isAllergen;
        if (Array.isArray(this.synonyms)) {
            data["synonyms"] = [];
            for (let item of this.synonyms)
                data["synonyms"].push(item);
        }
        data["suggestible"] = this.suggestible ? this.suggestible.toJSON() : <any>undefined;
        data["category"] = this.category ? this.category.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type Nutrient. */
export interface INutrient extends INutrientLite {
    /** Gets or sets a value indicating whether this instance is allergen. */
    isAllergen?: boolean | undefined;
    /** Gets or sets the synonyms. */
    synonyms?: string[] | undefined;
    /** Gets or sets the suggestible. */
    suggestible?: Suggestible | undefined;
    /** Gets or sets the category. */
    category?: NutrientCategory | undefined;
}

/** Contains the definition of an object of type NutrientCategory. */
export class NutrientCategory implements INutrientCategory {
    /** Gets or sets the identifier. */
    id!: number;
    /** Gets or sets the name. */
    name?: string | undefined;

    constructor(data?: INutrientCategory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): NutrientCategory {
        data = typeof data === 'object' ? data : {};
        let result = new NutrientCategory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

/** Contains the definition of an object of type NutrientCategory. */
export interface INutrientCategory {
    /** Gets or sets the identifier. */
    id: number;
    /** Gets or sets the name. */
    name?: string | undefined;
}

/** Contains the definition of an object of type PatientSearchParams. */
export class PatientSearchParams extends SearchParams implements IPatientSearchParams {
    /** Gets or sets the birth date. */
    birthDate?: Date | undefined;
    /** Gets or sets the email. */
    email?: string | undefined;
    /** Gets or sets the first name. */
    firstName?: string | undefined;
    /** Gets or sets the last name. */
    lastName?: string | undefined;
    /** Gets or sets the responsible patient identifier. */
    responsiblePatientId?: number | undefined;

    constructor(data?: IPatientSearchParams) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : <any>undefined;
            this.email = _data["email"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.responsiblePatientId = _data["responsiblePatientId"];
        }
    }

    static override fromJS(data: any): PatientSearchParams {
        data = typeof data === 'object' ? data : {};
        let result = new PatientSearchParams();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["email"] = this.email;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["responsiblePatientId"] = this.responsiblePatientId;
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type PatientSearchParams. */
export interface IPatientSearchParams extends ISearchParams {
    /** Gets or sets the birth date. */
    birthDate?: Date | undefined;
    /** Gets or sets the email. */
    email?: string | undefined;
    /** Gets or sets the first name. */
    firstName?: string | undefined;
    /** Gets or sets the last name. */
    lastName?: string | undefined;
    /** Gets or sets the responsible patient identifier. */
    responsiblePatientId?: number | undefined;
}

/** Contains the definition of an object of type Allergy */
export class SiinAllergy implements ISiinAllergy {
    /** Gets or sets the identifier. */
    id!: number;
    /** Gets or sets a value indicating whether this instance is active. */
    isArchived!: boolean;
    /** Gets or sets the label. */
    label!: string;

    constructor(data?: ISiinAllergy) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isArchived = _data["isArchived"];
            this.label = _data["label"];
        }
    }

    static fromJS(data: any): SiinAllergy {
        data = typeof data === 'object' ? data : {};
        let result = new SiinAllergy();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isArchived"] = this.isArchived;
        data["label"] = this.label;
        return data;
    }
}

/** Contains the definition of an object of type Allergy */
export interface ISiinAllergy {
    /** Gets or sets the identifier. */
    id: number;
    /** Gets or sets a value indicating whether this instance is active. */
    isArchived: boolean;
    /** Gets or sets the label. */
    label: string;
}

export class StatusValueResourceOfNullableInteger implements IStatusValueResourceOfNullableInteger {
    status!: ResponseStatus;
    value?: number | undefined;

    constructor(data?: IStatusValueResourceOfNullableInteger) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): StatusValueResourceOfNullableInteger {
        data = typeof data === 'object' ? data : {};
        let result = new StatusValueResourceOfNullableInteger();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["value"] = this.value;
        return data;
    }
}

export interface IStatusValueResourceOfNullableInteger {
    status: ResponseStatus;
    value?: number | undefined;
}

/** Contains the definition of an object of type PatientMeasureType. */
export class PatientMeasureType implements IPatientMeasureType {
    /** Gets or sets the identifier. */
    id!: number;
    /** Gets or sets the unit. */
    unit?: string | undefined;
    /** Gets or sets the type. */
    type!: PatientMeasureTypeEnum;
    /** Gets or sets a value indicating whether this instance is checked. */
    isChecked!: boolean;

    constructor(data?: IPatientMeasureType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.unit = _data["unit"];
            this.type = _data["type"];
            this.isChecked = _data["isChecked"];
        }
    }

    static fromJS(data: any): PatientMeasureType {
        data = typeof data === 'object' ? data : {};
        let result = new PatientMeasureType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["unit"] = this.unit;
        data["type"] = this.type;
        data["isChecked"] = this.isChecked;
        return data;
    }
}

/** Contains the definition of an object of type PatientMeasureType. */
export interface IPatientMeasureType {
    /** Gets or sets the identifier. */
    id: number;
    /** Gets or sets the unit. */
    unit?: string | undefined;
    /** Gets or sets the type. */
    type: PatientMeasureTypeEnum;
    /** Gets or sets a value indicating whether this instance is checked. */
    isChecked: boolean;
}

/** Contains the definition of an object of type PatientMeasureTypeEnum. */
export enum PatientMeasureTypeEnum {
    Unknown = 0,
    Size = 1,
    Weight = 2,
    IMC = 3,
    CranianPerimeter = 4,
    WaistLine = 5,
    HipCircumference = 6,
    ReportWaistAndHip = 7,
    SystolicBloodPressure = 8,
    FatMass = 9,
    MuscleMass = 10,
    WaterVolume = 11,
    PhaseAngle = 12,
    ImpedanceRatio = 13,
    DiastolicBloodPressure = 14,
    BasicMetabolism = 15,
    EnergyRequirements = 16,
    NeckCircumference = 17,
    CupSize = 18,
    BiodyMeasurements = 19,
    IRC = 20,
    UterineHeight = 21,
}

/** Contains the definition of an object of type Allergy */
export class Allergy implements IAllergy {
    /** Gets or sets the type of the allergy. */
    allergyType!: AllergyType;
    /** Gets or sets the item identifier. */
    itemId!: number;
    /** Gets or sets the label. */
    label?: string | undefined;

    constructor(data?: IAllergy) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.allergyType = _data["allergyType"];
            this.itemId = _data["itemId"];
            this.label = _data["label"];
        }
    }

    static fromJS(data: any): Allergy {
        data = typeof data === 'object' ? data : {};
        let result = new Allergy();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["allergyType"] = this.allergyType;
        data["itemId"] = this.itemId;
        data["label"] = this.label;
        return data;
    }
}

/** Contains the definition of an object of type Allergy */
export interface IAllergy {
    /** Gets or sets the type of the allergy. */
    allergyType: AllergyType;
    /** Gets or sets the item identifier. */
    itemId: number;
    /** Gets or sets the label. */
    label?: string | undefined;
}

/** Contains the definition of an object of type AllergyComplementaryField */
export enum AllergyType {
    SiinAllergy = 0,
    Food = 1,
    FoodCategory = 2,
    Allergen = 3,
}

/** Contains the definition of an object of type PatientMeasure. */
export class PatientMeasure implements IPatientMeasure {
    /** Gets or sets the identifier. */
    id!: number;
    /** Gets or sets the patient identifier., */
    patientId!: number;
    /** Gets or sets the type. */
    patientMeasureTypeId!: number;
    /** Gets or sets the value. */
    value?: number | undefined;
    /** Gets or sets the date of the measure. */
    date!: Date;
    /** Gets or sets the percentage evolution. */
    percentageEvolution!: number;
    /** Gets or sets the type of the patient measure. */
    patientMeasureType?: PatientMeasureType | undefined;
    /** Gets or sets the status. */
    status!: PatientMeasureStatus;
    /** Gets or sets the biody Id. */
    biodyId?: number | undefined;

    constructor(data?: IPatientMeasure) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.patientId = _data["patientId"];
            this.patientMeasureTypeId = _data["patientMeasureTypeId"];
            this.value = _data["value"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.percentageEvolution = _data["percentageEvolution"];
            this.patientMeasureType = _data["patientMeasureType"] ? PatientMeasureType.fromJS(_data["patientMeasureType"]) : <any>undefined;
            this.status = _data["status"];
            this.biodyId = _data["biodyId"];
        }
    }

    static fromJS(data: any): PatientMeasure {
        data = typeof data === 'object' ? data : {};
        let result = new PatientMeasure();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["patientId"] = this.patientId;
        data["patientMeasureTypeId"] = this.patientMeasureTypeId;
        data["value"] = this.value;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["percentageEvolution"] = this.percentageEvolution;
        data["patientMeasureType"] = this.patientMeasureType ? this.patientMeasureType.toJSON() : <any>undefined;
        data["status"] = this.status;
        data["biodyId"] = this.biodyId;
        return data;
    }
}

/** Contains the definition of an object of type PatientMeasure. */
export interface IPatientMeasure {
    /** Gets or sets the identifier. */
    id: number;
    /** Gets or sets the patient identifier., */
    patientId: number;
    /** Gets or sets the type. */
    patientMeasureTypeId: number;
    /** Gets or sets the value. */
    value?: number | undefined;
    /** Gets or sets the date of the measure. */
    date: Date;
    /** Gets or sets the percentage evolution. */
    percentageEvolution: number;
    /** Gets or sets the type of the patient measure. */
    patientMeasureType?: PatientMeasureType | undefined;
    /** Gets or sets the status. */
    status: PatientMeasureStatus;
    /** Gets or sets the biody Id. */
    biodyId?: number | undefined;
}

/** Contains the definition of an object of type PatientMeasureStatus. */
export enum PatientMeasureStatus {
    Unknow = 0,
    Increase = 1,
    Decrease = 2,
    Equality = 3,
}

/** Contains the definition of an object of type PatientMeasureSearchParam. */
export class PatientMeasureSearchParam implements IPatientMeasureSearchParam {
    /** Gets or sets the type. */
    typeId!: number;
    /** Gets or sets the patient identifier. */
    patientId!: number;

    constructor(data?: IPatientMeasureSearchParam) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.typeId = _data["typeId"];
            this.patientId = _data["patientId"];
        }
    }

    static fromJS(data: any): PatientMeasureSearchParam {
        data = typeof data === 'object' ? data : {};
        let result = new PatientMeasureSearchParam();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typeId"] = this.typeId;
        data["patientId"] = this.patientId;
        return data;
    }
}

/** Contains the definition of an object of type PatientMeasureSearchParam. */
export interface IPatientMeasureSearchParam {
    /** Gets or sets the type. */
    typeId: number;
    /** Gets or sets the patient identifier. */
    patientId: number;
}

/** Contains the definition of an object of type AllergieSearchParams */
export class SiinAllergySearchParams extends SearchParams implements ISiinAllergySearchParams {
    /** Gets or sets the is active. */
    isDeactivated?: boolean | undefined;

    constructor(data?: ISiinAllergySearchParams) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.isDeactivated = _data["isDeactivated"];
        }
    }

    static override fromJS(data: any): SiinAllergySearchParams {
        data = typeof data === 'object' ? data : {};
        let result = new SiinAllergySearchParams();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isDeactivated"] = this.isDeactivated;
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type AllergieSearchParams */
export interface ISiinAllergySearchParams extends ISearchParams {
    /** Gets or sets the is active. */
    isDeactivated?: boolean | undefined;
}

export class PaginatorWrapperOfIEnumerableOfPatientCoachingActivity implements IPaginatorWrapperOfIEnumerableOfPatientCoachingActivity {
    totalRecords!: number;
    data?: PatientCoachingActivity[] | undefined;

    constructor(data?: IPaginatorWrapperOfIEnumerableOfPatientCoachingActivity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRecords = _data["totalRecords"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(PatientCoachingActivity.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatorWrapperOfIEnumerableOfPatientCoachingActivity {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatorWrapperOfIEnumerableOfPatientCoachingActivity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IPaginatorWrapperOfIEnumerableOfPatientCoachingActivity {
    totalRecords: number;
    data?: PatientCoachingActivity[] | undefined;
}

/** Contains the definition of an object of type PatientCoachingActivity */
export class PatientCoachingActivity implements IPatientCoachingActivity {
    /** Gets or sets the coaching activity identifier. */
    coachingActivityId!: number;
    /** Gets or sets the coaching activity title. */
    coachingActivityTitle?: string | undefined;
    /** Gets or sets a value indicating whether this instance is read. */
    isRead!: boolean;
    /** Gets or sets the patient identifier. */
    patientId!: number;

    constructor(data?: IPatientCoachingActivity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.coachingActivityId = _data["coachingActivityId"];
            this.coachingActivityTitle = _data["coachingActivityTitle"];
            this.isRead = _data["isRead"];
            this.patientId = _data["patientId"];
        }
    }

    static fromJS(data: any): PatientCoachingActivity {
        data = typeof data === 'object' ? data : {};
        let result = new PatientCoachingActivity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["coachingActivityId"] = this.coachingActivityId;
        data["coachingActivityTitle"] = this.coachingActivityTitle;
        data["isRead"] = this.isRead;
        data["patientId"] = this.patientId;
        return data;
    }
}

/** Contains the definition of an object of type PatientCoachingActivity */
export interface IPatientCoachingActivity {
    /** Gets or sets the coaching activity identifier. */
    coachingActivityId: number;
    /** Gets or sets the coaching activity title. */
    coachingActivityTitle?: string | undefined;
    /** Gets or sets a value indicating whether this instance is read. */
    isRead: boolean;
    /** Gets or sets the patient identifier. */
    patientId: number;
}

/** Contains the definition of an object of type PatientAllergy */
export class PatientAllergy implements IPatientAllergy {
    /** Gets or sets the allergen identifier. */
    allergenId?: number | undefined;
    /** Gets or sets the type of the allergy. */
    allergyType!: AllergyType;
    /** Gets or sets the food category identifier. */
    foodCategoryid?: number | undefined;
    /** Gets or sets the food identifier. */
    foodId?: number | undefined;
    /** Gets or sets the identifier. */
    id!: number;
    /** Gets or sets the patient identifier. */
    patientId!: number;
    /** Gets or sets the allergy identifier. */
    siinAllergyId?: number | undefined;
    /** Gets or sets the patient allergy type. */
    patientAllergyType!: PatientAllergyType;

    constructor(data?: IPatientAllergy) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.allergenId = _data["allergenId"];
            this.allergyType = _data["allergyType"];
            this.foodCategoryid = _data["foodCategoryid"];
            this.foodId = _data["foodId"];
            this.id = _data["id"];
            this.patientId = _data["patientId"];
            this.siinAllergyId = _data["siinAllergyId"];
            this.patientAllergyType = _data["patientAllergyType"];
        }
    }

    static fromJS(data: any): PatientAllergy {
        data = typeof data === 'object' ? data : {};
        let result = new PatientAllergy();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["allergenId"] = this.allergenId;
        data["allergyType"] = this.allergyType;
        data["foodCategoryid"] = this.foodCategoryid;
        data["foodId"] = this.foodId;
        data["id"] = this.id;
        data["patientId"] = this.patientId;
        data["siinAllergyId"] = this.siinAllergyId;
        data["patientAllergyType"] = this.patientAllergyType;
        return data;
    }
}

/** Contains the definition of an object of type PatientAllergy */
export interface IPatientAllergy {
    /** Gets or sets the allergen identifier. */
    allergenId?: number | undefined;
    /** Gets or sets the type of the allergy. */
    allergyType: AllergyType;
    /** Gets or sets the food category identifier. */
    foodCategoryid?: number | undefined;
    /** Gets or sets the food identifier. */
    foodId?: number | undefined;
    /** Gets or sets the identifier. */
    id: number;
    /** Gets or sets the patient identifier. */
    patientId: number;
    /** Gets or sets the allergy identifier. */
    siinAllergyId?: number | undefined;
    /** Gets or sets the patient allergy type. */
    patientAllergyType: PatientAllergyType;
}

/** Contains the definition of an object of type AllergyComplementaryField */
export enum PatientAllergyType {
    Allergy = 0,
    FoodIntolerance = 1,
}

/** Contains the definition of an object of type PatientMedicalHistory. */
export class PatientMedicalHistory implements IPatientMedicalHistory {
    /** Gets or sets the identifier. */
    id!: number;
    /** Gets or sets the type of the history. */
    historyType!: PatientMedicalHistoryType;
    /** Gets or sets the patient identifier. */
    patientId!: number;
    /** Gets or sets the disease identifier. */
    diseaseId?: number | undefined;
    /** Gets or sets the disease. */
    disease?: Disease | undefined;
    /** Gets or sets the custom medical history. */
    customMedicalHistory?: string | undefined;
    /** Gets or sets the family relationship. */
    familyRelationship!: FamilyRelationship;

    constructor(data?: IPatientMedicalHistory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.historyType = _data["historyType"];
            this.patientId = _data["patientId"];
            this.diseaseId = _data["diseaseId"];
            this.disease = _data["disease"] ? Disease.fromJS(_data["disease"]) : <any>undefined;
            this.customMedicalHistory = _data["customMedicalHistory"];
            this.familyRelationship = _data["familyRelationship"];
        }
    }

    static fromJS(data: any): PatientMedicalHistory {
        data = typeof data === 'object' ? data : {};
        let result = new PatientMedicalHistory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["historyType"] = this.historyType;
        data["patientId"] = this.patientId;
        data["diseaseId"] = this.diseaseId;
        data["disease"] = this.disease ? this.disease.toJSON() : <any>undefined;
        data["customMedicalHistory"] = this.customMedicalHistory;
        data["familyRelationship"] = this.familyRelationship;
        return data;
    }
}

/** Contains the definition of an object of type PatientMedicalHistory. */
export interface IPatientMedicalHistory {
    /** Gets or sets the identifier. */
    id: number;
    /** Gets or sets the type of the history. */
    historyType: PatientMedicalHistoryType;
    /** Gets or sets the patient identifier. */
    patientId: number;
    /** Gets or sets the disease identifier. */
    diseaseId?: number | undefined;
    /** Gets or sets the disease. */
    disease?: Disease | undefined;
    /** Gets or sets the custom medical history. */
    customMedicalHistory?: string | undefined;
    /** Gets or sets the family relationship. */
    familyRelationship: FamilyRelationship;
}

/** Contains the definition of an object of type PatientMedicalHistoryType */
export enum PatientMedicalHistoryType {
    Personal = 0,
    Family = 1,
}

/** Contains the definition of an object of type ConsultationStatus. */
export enum FamilyRelationship {
    Undefined = 0,
    Father = 1,
    Mother = 2,
    Sibling = 3,
}

/** Contains the definition of an object of type MedicalRecord */
export class MedicalRecord implements IMedicalRecord {
    /** Gets or sets the allergies more informations. */
    allergiesMoreInformations?: string | undefined;
    /** Gets or sets the medical histories. */
    medicalHistories?: PatientMedicalHistory[] | undefined;
    /** Gets or sets the medication. */
    backgroundTreatment?: string | undefined;
    /** Gets or sets the patient identifier. */
    patientId!: number;
    /** Gets or sets the obstetric history. */
    obstetricHistory?: string | undefined;
    /** Gets or sets other medical information. */
    otherMedicalInformation?: string | undefined;
    /** Gets or sets the patient gender. */
    gender?: string | undefined;
    /** Gets or sets the lifestyle. */
    lifestyle?: string | undefined;
    /** Gets or sets the referring physician. */
    referringPhysician?: string | undefined;
    /** Gets or sets the specialists. */
    specialists?: string | undefined;
    /** Gets or sets the physical activity. */
    physicalActivity!: PhysicalActivity;
    /** Gets or sets the weight objective. */
    weightObjective!: WeightObjective;

    constructor(data?: IMedicalRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.allergiesMoreInformations = _data["allergiesMoreInformations"];
            if (Array.isArray(_data["medicalHistories"])) {
                this.medicalHistories = [] as any;
                for (let item of _data["medicalHistories"])
                    this.medicalHistories!.push(PatientMedicalHistory.fromJS(item));
            }
            this.backgroundTreatment = _data["backgroundTreatment"];
            this.patientId = _data["patientId"];
            this.obstetricHistory = _data["obstetricHistory"];
            this.otherMedicalInformation = _data["otherMedicalInformation"];
            this.gender = _data["gender"];
            this.lifestyle = _data["lifestyle"];
            this.referringPhysician = _data["referringPhysician"];
            this.specialists = _data["specialists"];
            this.physicalActivity = _data["physicalActivity"];
            this.weightObjective = _data["weightObjective"];
        }
    }

    static fromJS(data: any): MedicalRecord {
        data = typeof data === 'object' ? data : {};
        let result = new MedicalRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["allergiesMoreInformations"] = this.allergiesMoreInformations;
        if (Array.isArray(this.medicalHistories)) {
            data["medicalHistories"] = [];
            for (let item of this.medicalHistories)
                data["medicalHistories"].push(item ? item.toJSON() : <any>undefined);
        }
        data["backgroundTreatment"] = this.backgroundTreatment;
        data["patientId"] = this.patientId;
        data["obstetricHistory"] = this.obstetricHistory;
        data["otherMedicalInformation"] = this.otherMedicalInformation;
        data["gender"] = this.gender;
        data["lifestyle"] = this.lifestyle;
        data["referringPhysician"] = this.referringPhysician;
        data["specialists"] = this.specialists;
        data["physicalActivity"] = this.physicalActivity;
        data["weightObjective"] = this.weightObjective;
        return data;
    }
}

/** Contains the definition of an object of type MedicalRecord */
export interface IMedicalRecord {
    /** Gets or sets the allergies more informations. */
    allergiesMoreInformations?: string | undefined;
    /** Gets or sets the medical histories. */
    medicalHistories?: PatientMedicalHistory[] | undefined;
    /** Gets or sets the medication. */
    backgroundTreatment?: string | undefined;
    /** Gets or sets the patient identifier. */
    patientId: number;
    /** Gets or sets the obstetric history. */
    obstetricHistory?: string | undefined;
    /** Gets or sets other medical information. */
    otherMedicalInformation?: string | undefined;
    /** Gets or sets the patient gender. */
    gender?: string | undefined;
    /** Gets or sets the lifestyle. */
    lifestyle?: string | undefined;
    /** Gets or sets the referring physician. */
    referringPhysician?: string | undefined;
    /** Gets or sets the specialists. */
    specialists?: string | undefined;
    /** Gets or sets the physical activity. */
    physicalActivity: PhysicalActivity;
    /** Gets or sets the weight objective. */
    weightObjective: WeightObjective;
}

/** Contains the definition of an object of type PatientConsultationFormulary. */
export class PatientConsultationFormulary implements IPatientConsultationFormulary {
    /** Gets or sets the consultation identifier. */
    consultationId!: number;
    /** Gets or sets the formulary title. */
    formularyTitle?: string | undefined;
    /** Gets or sets the formulary version identifier. */
    formularyVersionId!: number;
    /** Gets or sets a value indicating whether this instance has sleep diary. */
    hasSleepDiary!: boolean;
    /** Gets or sets the doctor identifier. */
    doctorId!: number;
    /** Gets or sets the name of the doctor. */
    doctorName?: string | undefined;
    /** Gets or sets the reception date. */
    receptionDate!: Date;
    /** Gets or sets the status. */
    status!: StatusConsultationFormularyEnum;
    /** Gets or sets the consultation status. */
    consultationStatus!: ConsultationStatus;

    constructor(data?: IPatientConsultationFormulary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.consultationId = _data["consultationId"];
            this.formularyTitle = _data["formularyTitle"];
            this.formularyVersionId = _data["formularyVersionId"];
            this.hasSleepDiary = _data["hasSleepDiary"];
            this.doctorId = _data["doctorId"];
            this.doctorName = _data["doctorName"];
            this.receptionDate = _data["receptionDate"] ? new Date(_data["receptionDate"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.consultationStatus = _data["consultationStatus"];
        }
    }

    static fromJS(data: any): PatientConsultationFormulary {
        data = typeof data === 'object' ? data : {};
        let result = new PatientConsultationFormulary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["consultationId"] = this.consultationId;
        data["formularyTitle"] = this.formularyTitle;
        data["formularyVersionId"] = this.formularyVersionId;
        data["hasSleepDiary"] = this.hasSleepDiary;
        data["doctorId"] = this.doctorId;
        data["doctorName"] = this.doctorName;
        data["receptionDate"] = this.receptionDate ? this.receptionDate.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["consultationStatus"] = this.consultationStatus;
        return data;
    }
}

/** Contains the definition of an object of type PatientConsultationFormulary. */
export interface IPatientConsultationFormulary {
    /** Gets or sets the consultation identifier. */
    consultationId: number;
    /** Gets or sets the formulary title. */
    formularyTitle?: string | undefined;
    /** Gets or sets the formulary version identifier. */
    formularyVersionId: number;
    /** Gets or sets a value indicating whether this instance has sleep diary. */
    hasSleepDiary: boolean;
    /** Gets or sets the doctor identifier. */
    doctorId: number;
    /** Gets or sets the name of the doctor. */
    doctorName?: string | undefined;
    /** Gets or sets the reception date. */
    receptionDate: Date;
    /** Gets or sets the status. */
    status: StatusConsultationFormularyEnum;
    /** Gets or sets the consultation status. */
    consultationStatus: ConsultationStatus;
}

/** Contains the definition of an object of type ConsultationStatus. */
export enum ConsultationStatus {
    NeedPatientConfirmation = 0,
    NeedDoctorConfirmation = 1,
    Confirmed = 2,
    Closed = 3,
    Canceled = 4,
    WaitingRoom = 5,
    InConsultation = 6,
    PatientSeen = 7,
    AbsentExcused = 8,
    AbsentNotExcused = 9,
}

/** Contains the definition of an object of type PatientConsultationFormularySearchParams. */
export class PatientConsultationFormularySearchParams implements IPatientConsultationFormularySearchParams {
    /** Gets or sets the consultation identifier. */
    consultationId?: number | undefined;
    /** Gets or sets the doctor ids. */
    doctorIds?: number[] | undefined;
    /** Gets or sets the status. */
    status?: StatusConsultationFormularyEnum[] | undefined;
    /** Gets or sets the formulary version ids. */
    formularyVersionIds?: number[] | undefined;

    constructor(data?: IPatientConsultationFormularySearchParams) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.consultationId = _data["consultationId"];
            if (Array.isArray(_data["doctorIds"])) {
                this.doctorIds = [] as any;
                for (let item of _data["doctorIds"])
                    this.doctorIds!.push(item);
            }
            if (Array.isArray(_data["status"])) {
                this.status = [] as any;
                for (let item of _data["status"])
                    this.status!.push(item);
            }
            if (Array.isArray(_data["formularyVersionIds"])) {
                this.formularyVersionIds = [] as any;
                for (let item of _data["formularyVersionIds"])
                    this.formularyVersionIds!.push(item);
            }
        }
    }

    static fromJS(data: any): PatientConsultationFormularySearchParams {
        data = typeof data === 'object' ? data : {};
        let result = new PatientConsultationFormularySearchParams();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["consultationId"] = this.consultationId;
        if (Array.isArray(this.doctorIds)) {
            data["doctorIds"] = [];
            for (let item of this.doctorIds)
                data["doctorIds"].push(item);
        }
        if (Array.isArray(this.status)) {
            data["status"] = [];
            for (let item of this.status)
                data["status"].push(item);
        }
        if (Array.isArray(this.formularyVersionIds)) {
            data["formularyVersionIds"] = [];
            for (let item of this.formularyVersionIds)
                data["formularyVersionIds"].push(item);
        }
        return data;
    }
}

/** Contains the definition of an object of type PatientConsultationFormularySearchParams. */
export interface IPatientConsultationFormularySearchParams {
    /** Gets or sets the consultation identifier. */
    consultationId?: number | undefined;
    /** Gets or sets the doctor ids. */
    doctorIds?: number[] | undefined;
    /** Gets or sets the status. */
    status?: StatusConsultationFormularyEnum[] | undefined;
    /** Gets or sets the formulary version ids. */
    formularyVersionIds?: number[] | undefined;
}

/** Contains the definition of an object of type PatientNotification. */
export class PatientNotification implements IPatientNotification {
    /** Gets or sets the consultation. */
    consultation?: Consultation | undefined;
    /** Gets or sets the suggestion identifier. */
    suggestionId?: number | undefined;
    /** Gets or sets the type. */
    type!: NotificationTypeEnum;
    /** Gets or sets the values. */
    values?: PatientNotificationValue[] | undefined;

    constructor(data?: IPatientNotification) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.consultation = _data["consultation"] ? Consultation.fromJS(_data["consultation"]) : <any>undefined;
            this.suggestionId = _data["suggestionId"];
            this.type = _data["type"];
            if (Array.isArray(_data["values"])) {
                this.values = [] as any;
                for (let item of _data["values"])
                    this.values!.push(PatientNotificationValue.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PatientNotification {
        data = typeof data === 'object' ? data : {};
        let result = new PatientNotification();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["consultation"] = this.consultation ? this.consultation.toJSON() : <any>undefined;
        data["suggestionId"] = this.suggestionId;
        data["type"] = this.type;
        if (Array.isArray(this.values)) {
            data["values"] = [];
            for (let item of this.values)
                data["values"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

/** Contains the definition of an object of type PatientNotification. */
export interface IPatientNotification {
    /** Gets or sets the consultation. */
    consultation?: Consultation | undefined;
    /** Gets or sets the suggestion identifier. */
    suggestionId?: number | undefined;
    /** Gets or sets the type. */
    type: NotificationTypeEnum;
    /** Gets or sets the values. */
    values?: PatientNotificationValue[] | undefined;
}

/** Contains the definition of an object of type ConsultationLiteInfo. */
export class ConsultationLiteInfo implements IConsultationLiteInfo {
    /** Gets or sets the identifier. */
    id!: number;
    /** Gets or sets the date. */
    date!: Date;
    /** Gets or sets the status. */
    status!: ConsultationStatus;

    constructor(data?: IConsultationLiteInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): ConsultationLiteInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ConsultationLiteInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["status"] = this.status;
        return data;
    }
}

/** Contains the definition of an object of type ConsultationLiteInfo. */
export interface IConsultationLiteInfo {
    /** Gets or sets the identifier. */
    id: number;
    /** Gets or sets the date. */
    date: Date;
    /** Gets or sets the status. */
    status: ConsultationStatus;
}

/** Contains the definition of an object of type Consultation. */
export class Consultation extends ConsultationLiteInfo implements IConsultation {
    /** Gets or sets the acute treatment. */
    acuteTreatment?: string | undefined;
    /** Gets or sets the captured amount (amount taken from the on-hold payment). */
    capturedAmount?: number | undefined;
    /** Gets or sets a value indicating whether the patient' has given consent about PSNC's information */
    consentPSNC!: boolean;
    /** Gets or sets the config id. */
    consultationConfigId!: number;
    /** Gets or sets the config id. */
    consultationConfig?: ConsultationConfig | undefined;
    /** Gets or sets the reason id. */
    consultationReasonId!: number;
    /** Gets or sets the type id. */
    consultationReason?: ConsultationReason | undefined;
    /** Gets or sets the medical office identifier. */
    medicalOfficeId?: number | undefined;
    /** Gets or sets the medical office. */
    medicalOffice?: MedicalOffice | undefined;
    /** Gets or sets the doctor identifier. */
    doctorId!: number;
    /** Gets or sets the doctor. */
    doctor?: DoctorLiteInfo | undefined;
    /** Gets or sets the duration. */
    duration!: number;
    /** Gets or sets the information. */
    information?: string | undefined;
    /** Gets or sets the location. */
    location!: ConsultationLocation;
    /** Gets or sets the nutrionnal supplement. */
    nutrionnalSupplement?: string | undefined;
    /** Gets or sets the patient. */
    patient?: PatientInfo | undefined;
    /** Gets or sets the patient comments. */
    patientComments?: string | undefined;
    /** Gets or sets the patient identifier. */
    patientId!: number;
    /** Gets or sets the status of the payment. */
    paymentStatus!: PaymentStatus;
    /** Gets or sets the summary. */
    summary?: string | undefined;
    /** Gets or sets the tag. */
    tag?: string | undefined;

    constructor(data?: IConsultation) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.acuteTreatment = _data["acuteTreatment"];
            this.capturedAmount = _data["capturedAmount"];
            this.consentPSNC = _data["consentPSNC"];
            this.consultationConfigId = _data["consultationConfigId"];
            this.consultationConfig = _data["consultationConfig"] ? ConsultationConfig.fromJS(_data["consultationConfig"]) : <any>undefined;
            this.consultationReasonId = _data["consultationReasonId"];
            this.consultationReason = _data["consultationReason"] ? ConsultationReason.fromJS(_data["consultationReason"]) : <any>undefined;
            this.medicalOfficeId = _data["medicalOfficeId"];
            this.medicalOffice = _data["medicalOffice"] ? MedicalOffice.fromJS(_data["medicalOffice"]) : <any>undefined;
            this.doctorId = _data["doctorId"];
            this.doctor = _data["doctor"] ? DoctorLiteInfo.fromJS(_data["doctor"]) : <any>undefined;
            this.duration = _data["duration"];
            this.information = _data["information"];
            this.location = _data["location"];
            this.nutrionnalSupplement = _data["nutrionnalSupplement"];
            this.patient = _data["patient"] ? PatientInfo.fromJS(_data["patient"]) : <any>undefined;
            this.patientComments = _data["patientComments"];
            this.patientId = _data["patientId"];
            this.paymentStatus = _data["paymentStatus"];
            this.summary = _data["summary"];
            this.tag = _data["tag"];
        }
    }

    static override fromJS(data: any): Consultation {
        data = typeof data === 'object' ? data : {};
        let result = new Consultation();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["acuteTreatment"] = this.acuteTreatment;
        data["capturedAmount"] = this.capturedAmount;
        data["consentPSNC"] = this.consentPSNC;
        data["consultationConfigId"] = this.consultationConfigId;
        data["consultationConfig"] = this.consultationConfig ? this.consultationConfig.toJSON() : <any>undefined;
        data["consultationReasonId"] = this.consultationReasonId;
        data["consultationReason"] = this.consultationReason ? this.consultationReason.toJSON() : <any>undefined;
        data["medicalOfficeId"] = this.medicalOfficeId;
        data["medicalOffice"] = this.medicalOffice ? this.medicalOffice.toJSON() : <any>undefined;
        data["doctorId"] = this.doctorId;
        data["doctor"] = this.doctor ? this.doctor.toJSON() : <any>undefined;
        data["duration"] = this.duration;
        data["information"] = this.information;
        data["location"] = this.location;
        data["nutrionnalSupplement"] = this.nutrionnalSupplement;
        data["patient"] = this.patient ? this.patient.toJSON() : <any>undefined;
        data["patientComments"] = this.patientComments;
        data["patientId"] = this.patientId;
        data["paymentStatus"] = this.paymentStatus;
        data["summary"] = this.summary;
        data["tag"] = this.tag;
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type Consultation. */
export interface IConsultation extends IConsultationLiteInfo {
    /** Gets or sets the acute treatment. */
    acuteTreatment?: string | undefined;
    /** Gets or sets the captured amount (amount taken from the on-hold payment). */
    capturedAmount?: number | undefined;
    /** Gets or sets a value indicating whether the patient' has given consent about PSNC's information */
    consentPSNC: boolean;
    /** Gets or sets the config id. */
    consultationConfigId: number;
    /** Gets or sets the config id. */
    consultationConfig?: ConsultationConfig | undefined;
    /** Gets or sets the reason id. */
    consultationReasonId: number;
    /** Gets or sets the type id. */
    consultationReason?: ConsultationReason | undefined;
    /** Gets or sets the medical office identifier. */
    medicalOfficeId?: number | undefined;
    /** Gets or sets the medical office. */
    medicalOffice?: MedicalOffice | undefined;
    /** Gets or sets the doctor identifier. */
    doctorId: number;
    /** Gets or sets the doctor. */
    doctor?: DoctorLiteInfo | undefined;
    /** Gets or sets the duration. */
    duration: number;
    /** Gets or sets the information. */
    information?: string | undefined;
    /** Gets or sets the location. */
    location: ConsultationLocation;
    /** Gets or sets the nutrionnal supplement. */
    nutrionnalSupplement?: string | undefined;
    /** Gets or sets the patient. */
    patient?: PatientInfo | undefined;
    /** Gets or sets the patient comments. */
    patientComments?: string | undefined;
    /** Gets or sets the patient identifier. */
    patientId: number;
    /** Gets or sets the status of the payment. */
    paymentStatus: PaymentStatus;
    /** Gets or sets the summary. */
    summary?: string | undefined;
    /** Gets or sets the tag. */
    tag?: string | undefined;
}

/** Contains the definition of an object of type ConsultationConfig. */
export class ConsultationConfig implements IConsultationConfig {
    /** Gets or sets the color. */
    color?: string | undefined;
    /** Gets or sets the locations. */
    locations?: ConsultationConfigLocation[] | undefined;
    /** Gets or sets the consultation configuration formularies. */
    formularies?: ConsultationConfigFormulary[] | undefined;
    /** Gets or sets the doctor identifier. */
    doctorId!: number;
    /** Gets or sets the duration. */
    duration!: number;
    /** Gets or sets the identifier. */
    id!: number;
    /** Gets or sets a value indicating whether this instance is active. */
    isActive!: boolean;
    /** Gets or sets a value indicating whether this consultation configuration is remote active. */
    isRemoteActive!: boolean;
    /** Gets or sets a value indicating whether this instance is insurance configuration. */
    isInsuranceConfig!: boolean;
    /** Gets or sets the maximum participant number. */
    maxParticipantNumber!: number;
    /** Gets or sets the name. */
    name?: string | undefined;
    /** Gets or sets the price. */
    price?: number | undefined;
    /** Gets or sets the consultation type. */
    consultationType?: ConsultationType | undefined;
    /** Gets or sets the consultation type id. */
    consultationTypeId?: number | undefined;
    /** Gets or sets the consultation subtype. */
    consultationSubType?: ConsultationSubType | undefined;
    /** Gets or sets the consultation subtype id. */
    consultationSubTypeId?: number | undefined;

    constructor(data?: IConsultationConfig) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.color = _data["color"];
            if (Array.isArray(_data["locations"])) {
                this.locations = [] as any;
                for (let item of _data["locations"])
                    this.locations!.push(ConsultationConfigLocation.fromJS(item));
            }
            if (Array.isArray(_data["formularies"])) {
                this.formularies = [] as any;
                for (let item of _data["formularies"])
                    this.formularies!.push(ConsultationConfigFormulary.fromJS(item));
            }
            this.doctorId = _data["doctorId"];
            this.duration = _data["duration"];
            this.id = _data["id"];
            this.isActive = _data["isActive"];
            this.isRemoteActive = _data["isRemoteActive"];
            this.isInsuranceConfig = _data["isInsuranceConfig"];
            this.maxParticipantNumber = _data["maxParticipantNumber"];
            this.name = _data["name"];
            this.price = _data["price"];
            this.consultationType = _data["consultationType"] ? ConsultationType.fromJS(_data["consultationType"]) : <any>undefined;
            this.consultationTypeId = _data["consultationTypeId"];
            this.consultationSubType = _data["consultationSubType"] ? ConsultationSubType.fromJS(_data["consultationSubType"]) : <any>undefined;
            this.consultationSubTypeId = _data["consultationSubTypeId"];
        }
    }

    static fromJS(data: any): ConsultationConfig {
        data = typeof data === 'object' ? data : {};
        let result = new ConsultationConfig();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["color"] = this.color;
        if (Array.isArray(this.locations)) {
            data["locations"] = [];
            for (let item of this.locations)
                data["locations"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.formularies)) {
            data["formularies"] = [];
            for (let item of this.formularies)
                data["formularies"].push(item ? item.toJSON() : <any>undefined);
        }
        data["doctorId"] = this.doctorId;
        data["duration"] = this.duration;
        data["id"] = this.id;
        data["isActive"] = this.isActive;
        data["isRemoteActive"] = this.isRemoteActive;
        data["isInsuranceConfig"] = this.isInsuranceConfig;
        data["maxParticipantNumber"] = this.maxParticipantNumber;
        data["name"] = this.name;
        data["price"] = this.price;
        data["consultationType"] = this.consultationType ? this.consultationType.toJSON() : <any>undefined;
        data["consultationTypeId"] = this.consultationTypeId;
        data["consultationSubType"] = this.consultationSubType ? this.consultationSubType.toJSON() : <any>undefined;
        data["consultationSubTypeId"] = this.consultationSubTypeId;
        return data;
    }
}

/** Contains the definition of an object of type ConsultationConfig. */
export interface IConsultationConfig {
    /** Gets or sets the color. */
    color?: string | undefined;
    /** Gets or sets the locations. */
    locations?: ConsultationConfigLocation[] | undefined;
    /** Gets or sets the consultation configuration formularies. */
    formularies?: ConsultationConfigFormulary[] | undefined;
    /** Gets or sets the doctor identifier. */
    doctorId: number;
    /** Gets or sets the duration. */
    duration: number;
    /** Gets or sets the identifier. */
    id: number;
    /** Gets or sets a value indicating whether this instance is active. */
    isActive: boolean;
    /** Gets or sets a value indicating whether this consultation configuration is remote active. */
    isRemoteActive: boolean;
    /** Gets or sets a value indicating whether this instance is insurance configuration. */
    isInsuranceConfig: boolean;
    /** Gets or sets the maximum participant number. */
    maxParticipantNumber: number;
    /** Gets or sets the name. */
    name?: string | undefined;
    /** Gets or sets the price. */
    price?: number | undefined;
    /** Gets or sets the consultation type. */
    consultationType?: ConsultationType | undefined;
    /** Gets or sets the consultation type id. */
    consultationTypeId?: number | undefined;
    /** Gets or sets the consultation subtype. */
    consultationSubType?: ConsultationSubType | undefined;
    /** Gets or sets the consultation subtype id. */
    consultationSubTypeId?: number | undefined;
}

/** Contains the definition of an object of type ConsultationConfigLocation. */
export class ConsultationConfigLocation implements IConsultationConfigLocation {
    /** Gets or sets the consultation configuration identifier. */
    consultationConfigId!: number;
    /** Gets or sets the location. */
    location!: number;

    constructor(data?: IConsultationConfigLocation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.consultationConfigId = _data["consultationConfigId"];
            this.location = _data["location"];
        }
    }

    static fromJS(data: any): ConsultationConfigLocation {
        data = typeof data === 'object' ? data : {};
        let result = new ConsultationConfigLocation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["consultationConfigId"] = this.consultationConfigId;
        data["location"] = this.location;
        return data;
    }
}

/** Contains the definition of an object of type ConsultationConfigLocation. */
export interface IConsultationConfigLocation {
    /** Gets or sets the consultation configuration identifier. */
    consultationConfigId: number;
    /** Gets or sets the location. */
    location: number;
}

/** Contains the definition of an object of type ConsultationConfigFormulary. */
export class ConsultationConfigFormulary implements IConsultationConfigFormulary {
    /** Gets or sets the consultation configuration identifier. */
    consultationConfigId!: number;
    /** Gets or sets the formulary identifier. */
    formularyId!: number;

    constructor(data?: IConsultationConfigFormulary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.consultationConfigId = _data["ConsultationConfigId"];
            this.formularyId = _data["FormularyId"];
        }
    }

    static fromJS(data: any): ConsultationConfigFormulary {
        data = typeof data === 'object' ? data : {};
        let result = new ConsultationConfigFormulary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ConsultationConfigId"] = this.consultationConfigId;
        data["FormularyId"] = this.formularyId;
        return data;
    }
}

/** Contains the definition of an object of type ConsultationConfigFormulary. */
export interface IConsultationConfigFormulary {
    /** Gets or sets the consultation configuration identifier. */
    consultationConfigId: number;
    /** Gets or sets the formulary identifier. */
    formularyId: number;
}

/** Contains the definition of an object of type ConsultationSubType. */
export class ConsultationSubType implements IConsultationSubType {
    /** Gets or sets the identifier. */
    id!: number;
    /** Gets or sets a value indicating whether this instance is active. */
    isArchived!: boolean;
    /** Gets or sets the name. */
    name?: string | undefined;

    constructor(data?: IConsultationSubType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isArchived = _data["isArchived"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): ConsultationSubType {
        data = typeof data === 'object' ? data : {};
        let result = new ConsultationSubType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isArchived"] = this.isArchived;
        data["name"] = this.name;
        return data;
    }
}

/** Contains the definition of an object of type ConsultationSubType. */
export interface IConsultationSubType {
    /** Gets or sets the identifier. */
    id: number;
    /** Gets or sets a value indicating whether this instance is active. */
    isArchived: boolean;
    /** Gets or sets the name. */
    name?: string | undefined;
}

/** Contains the definition of an object of type ConsultationReason. */
export class ConsultationReason implements IConsultationReason {
    /** Gets or sets the identifier. */
    id!: number;
    /** Gets or sets a value indicating whether this instance is default insurance reason. */
    isDefaultInsuranceReason!: boolean;
    /** Gets or sets the name. */
    name!: string;
    /** Gets or sets a value indicating whether this instance is active. */
    isArchived!: boolean;

    constructor(data?: IConsultationReason) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isDefaultInsuranceReason = _data["isDefaultInsuranceReason"];
            this.name = _data["name"];
            this.isArchived = _data["isArchived"];
        }
    }

    static fromJS(data: any): ConsultationReason {
        data = typeof data === 'object' ? data : {};
        let result = new ConsultationReason();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isDefaultInsuranceReason"] = this.isDefaultInsuranceReason;
        data["name"] = this.name;
        data["isArchived"] = this.isArchived;
        return data;
    }
}

/** Contains the definition of an object of type ConsultationReason. */
export interface IConsultationReason {
    /** Gets or sets the identifier. */
    id: number;
    /** Gets or sets a value indicating whether this instance is default insurance reason. */
    isDefaultInsuranceReason: boolean;
    /** Gets or sets the name. */
    name: string;
    /** Gets or sets a value indicating whether this instance is active. */
    isArchived: boolean;
}

/** Contains the definition of an object of type PaymentStatus */
export enum PaymentStatus {
    WaitingMeansOfPayment = 0,
    PayInCash = 1,
    WaitingForPayment = 2,
    Paid = 3,
    ToBillToInsurance = 4,
    Cancelled = 5,
    OnHold = 6,
}

/** Enum of the different types of notification. */
export enum NotificationTypeEnum {
    ValidateConsultation = 0,
    UpcomingConsultation = 1,
    DayOfConsultation = 2,
    RemainingConsultation = 3,
    NewDocument = 4,
    NewFormulary = 5,
    NewSuggestion = 6,
    NewSleepDiary = 7,
    SleepDiaryToSend = 8,
    NewActivity = 9,
    NewNotes = 10,
    FavoriteDoctors = 11,
    RecommendationLastConsultation = 12,
}

/** Contains the definition of an object of type PatientNotificationValue. */
export class PatientNotificationValue implements IPatientNotificationValue {
    /** Gets or sets the tag. */
    tag?: string | undefined;
    /** Gets or sets the value. */
    value?: string | undefined;

    constructor(data?: IPatientNotificationValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tag = _data["tag"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): PatientNotificationValue {
        data = typeof data === 'object' ? data : {};
        let result = new PatientNotificationValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tag"] = this.tag;
        data["value"] = this.value;
        return data;
    }
}

/** Contains the definition of an object of type PatientNotificationValue. */
export interface IPatientNotificationValue {
    /** Gets or sets the tag. */
    tag?: string | undefined;
    /** Gets or sets the value. */
    value?: string | undefined;
}

/** Contains the definition of an object of type PatientParameters. */
export class PatientParameters implements IPatientParameters {
    /** Gets or sets a value indicating whether this instance has accepted GDPR. */
    hasAcceptedGdpr!: boolean;
    /** Gets or sets a value indicating whether this instance has accepted SMS. */
    hasAcceptedSms!: boolean;

    constructor(data?: IPatientParameters) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hasAcceptedGdpr = _data["hasAcceptedGdpr"];
            this.hasAcceptedSms = _data["hasAcceptedSms"];
        }
    }

    static fromJS(data: any): PatientParameters {
        data = typeof data === 'object' ? data : {};
        let result = new PatientParameters();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasAcceptedGdpr"] = this.hasAcceptedGdpr;
        data["hasAcceptedSms"] = this.hasAcceptedSms;
        return data;
    }
}

/** Contains the definition of an object of type PatientParameters. */
export interface IPatientParameters {
    /** Gets or sets a value indicating whether this instance has accepted GDPR. */
    hasAcceptedGdpr: boolean;
    /** Gets or sets a value indicating whether this instance has accepted SMS. */
    hasAcceptedSms: boolean;
}

export class StatusValueResourceOfPatientInfo implements IStatusValueResourceOfPatientInfo {
    status!: ResponseStatus;
    value?: PatientInfo | undefined;

    constructor(data?: IStatusValueResourceOfPatientInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.value = _data["value"] ? PatientInfo.fromJS(_data["value"]) : <any>undefined;
        }
    }

    static fromJS(data: any): StatusValueResourceOfPatientInfo {
        data = typeof data === 'object' ? data : {};
        let result = new StatusValueResourceOfPatientInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["value"] = this.value ? this.value.toJSON() : <any>undefined;
        return data;
    }
}

export interface IStatusValueResourceOfPatientInfo {
    status: ResponseStatus;
    value?: PatientInfo | undefined;
}

/** Contains the definition of an object of type FormularyScore. */
export class FormularyScore implements IFormularyScore {
    /** Gets or sets the consultation identifier. */
    consultationId!: number;
    /** Gets or sets the date. */
    date!: Date;
    /** Gets or sets the status. */
    status!: StatusConsultationFormularyEnum;
    /** Gets or sets the maximum score. */
    maxScore!: number;
    /** Gets or sets the score. */
    score?: number | undefined;
    /** Gets or sets the score in percent. */
    scorePercent?: number | undefined;
    /** Gets or sets the signification. */
    signification?: string | undefined;
    /** Gets or sets the score by question category. */
    scoreByQuestionCategory?: FormularyQuestionCategoryScore[] | undefined;

    constructor(data?: IFormularyScore) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.consultationId = _data["consultationId"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.maxScore = _data["maxScore"];
            this.score = _data["score"];
            this.scorePercent = _data["scorePercent"];
            this.signification = _data["signification"];
            if (Array.isArray(_data["scoreByQuestionCategory"])) {
                this.scoreByQuestionCategory = [] as any;
                for (let item of _data["scoreByQuestionCategory"])
                    this.scoreByQuestionCategory!.push(FormularyQuestionCategoryScore.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FormularyScore {
        data = typeof data === 'object' ? data : {};
        let result = new FormularyScore();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["consultationId"] = this.consultationId;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["maxScore"] = this.maxScore;
        data["score"] = this.score;
        data["scorePercent"] = this.scorePercent;
        data["signification"] = this.signification;
        if (Array.isArray(this.scoreByQuestionCategory)) {
            data["scoreByQuestionCategory"] = [];
            for (let item of this.scoreByQuestionCategory)
                data["scoreByQuestionCategory"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

/** Contains the definition of an object of type FormularyScore. */
export interface IFormularyScore {
    /** Gets or sets the consultation identifier. */
    consultationId: number;
    /** Gets or sets the date. */
    date: Date;
    /** Gets or sets the status. */
    status: StatusConsultationFormularyEnum;
    /** Gets or sets the maximum score. */
    maxScore: number;
    /** Gets or sets the score. */
    score?: number | undefined;
    /** Gets or sets the score in percent. */
    scorePercent?: number | undefined;
    /** Gets or sets the signification. */
    signification?: string | undefined;
    /** Gets or sets the score by question category. */
    scoreByQuestionCategory?: FormularyQuestionCategoryScore[] | undefined;
}

/** Contains the definition of an object of type FormularyQuestionCategoryScore. */
export class FormularyQuestionCategoryScore implements IFormularyQuestionCategoryScore {
    /** Gets or sets the question category id to which is associated the score. */
    questionCategoryId!: number;
    /** Gets or sets the maximum score. */
    maxScore!: number;
    /** Gets or sets the score. */
    score!: number;
    /** Gets or sets the score in percent. */
    scorePercent?: number | undefined;
    /** Gets or sets the score signification. */
    signification?: string | undefined;

    constructor(data?: IFormularyQuestionCategoryScore) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.questionCategoryId = _data["questionCategoryId"];
            this.maxScore = _data["maxScore"];
            this.score = _data["score"];
            this.scorePercent = _data["scorePercent"];
            this.signification = _data["signification"];
        }
    }

    static fromJS(data: any): FormularyQuestionCategoryScore {
        data = typeof data === 'object' ? data : {};
        let result = new FormularyQuestionCategoryScore();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["questionCategoryId"] = this.questionCategoryId;
        data["maxScore"] = this.maxScore;
        data["score"] = this.score;
        data["scorePercent"] = this.scorePercent;
        data["signification"] = this.signification;
        return data;
    }
}

/** Contains the definition of an object of type FormularyQuestionCategoryScore. */
export interface IFormularyQuestionCategoryScore {
    /** Gets or sets the question category id to which is associated the score. */
    questionCategoryId: number;
    /** Gets or sets the maximum score. */
    maxScore: number;
    /** Gets or sets the score. */
    score: number;
    /** Gets or sets the score in percent. */
    scorePercent?: number | undefined;
    /** Gets or sets the score signification. */
    signification?: string | undefined;
}

/** Contains the definition of an object of type PatientAnswerSleepDiary */
export class PatientAnswerSleepDiary extends PatientAnswer implements IPatientAnswerSleepDiary {
    /** Gets or sets the average sleeping hours. */
    averageSleepingHours!: number;
    /** Gets or sets the average sleeping l atency. */
    averageSleepingLatency!: number;
    /** Gets or sets the average sleeping wake up. */
    averageSleepingWakeUp!: number;
    /** Gets or sets the sleep efficiency */
    sleepEfficiency!: number;
    /** Gets or sets the time in bed */
    averageTimeInBed!: number;
    /** Gets or sets the start date. */
    startDate!: Date;
    /** Gets or sets the end date. */
    endDate!: Date;

    constructor(data?: IPatientAnswerSleepDiary) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.averageSleepingHours = _data["averageSleepingHours"];
            this.averageSleepingLatency = _data["averageSleepingLatency"];
            this.averageSleepingWakeUp = _data["averageSleepingWakeUp"];
            this.sleepEfficiency = _data["sleepEfficiency"];
            this.averageTimeInBed = _data["averageTimeInBed"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
        }
    }

    static override fromJS(data: any): PatientAnswerSleepDiary {
        data = typeof data === 'object' ? data : {};
        let result = new PatientAnswerSleepDiary();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["averageSleepingHours"] = this.averageSleepingHours;
        data["averageSleepingLatency"] = this.averageSleepingLatency;
        data["averageSleepingWakeUp"] = this.averageSleepingWakeUp;
        data["sleepEfficiency"] = this.sleepEfficiency;
        data["averageTimeInBed"] = this.averageTimeInBed;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type PatientAnswerSleepDiary */
export interface IPatientAnswerSleepDiary extends IPatientAnswer {
    /** Gets or sets the average sleeping hours. */
    averageSleepingHours: number;
    /** Gets or sets the average sleeping l atency. */
    averageSleepingLatency: number;
    /** Gets or sets the average sleeping wake up. */
    averageSleepingWakeUp: number;
    /** Gets or sets the sleep efficiency */
    sleepEfficiency: number;
    /** Gets or sets the time in bed */
    averageTimeInBed: number;
    /** Gets or sets the start date. */
    startDate: Date;
    /** Gets or sets the end date. */
    endDate: Date;
}

/** Contains the definition of an object of type PatientInsuranceStatus. */
export class PatientInsuranceStatus implements IPatientInsuranceStatus {
    /** Gets or sets the token. */
    token?: string | undefined;
    /** Gets or sets a value indicating whether this instance is token valid. */
    isTokenValid!: boolean;
    /** Gets or sets the remaining consultation. */
    remainingConsultations?: number | undefined;

    constructor(data?: IPatientInsuranceStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
            this.isTokenValid = _data["isTokenValid"];
            this.remainingConsultations = _data["remainingConsultations"];
        }
    }

    static fromJS(data: any): PatientInsuranceStatus {
        data = typeof data === 'object' ? data : {};
        let result = new PatientInsuranceStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        data["isTokenValid"] = this.isTokenValid;
        data["remainingConsultations"] = this.remainingConsultations;
        return data;
    }
}

/** Contains the definition of an object of type PatientInsuranceStatus. */
export interface IPatientInsuranceStatus {
    /** Gets or sets the token. */
    token?: string | undefined;
    /** Gets or sets a value indicating whether this instance is token valid. */
    isTokenValid: boolean;
    /** Gets or sets the remaining consultation. */
    remainingConsultations?: number | undefined;
}

export class PaginatorWrapperOfIEnumerableOfPatientFormulary implements IPaginatorWrapperOfIEnumerableOfPatientFormulary {
    totalRecords!: number;
    data?: PatientFormulary[] | undefined;

    constructor(data?: IPaginatorWrapperOfIEnumerableOfPatientFormulary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRecords = _data["totalRecords"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(PatientFormulary.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatorWrapperOfIEnumerableOfPatientFormulary {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatorWrapperOfIEnumerableOfPatientFormulary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IPaginatorWrapperOfIEnumerableOfPatientFormulary {
    totalRecords: number;
    data?: PatientFormulary[] | undefined;
}

/** Contains the definition of an object of type PatientFormulary. */
export class PatientFormulary implements IPatientFormulary {
    /** Gets or sets the consultation identifier. */
    consultationId!: number;
    /** Gets or sets the formulary title. */
    formularyTitle?: string | undefined;
    /** Gets or sets the formulary version identifier. */
    formularyVersionId!: number;
    /** Gets or sets a value indicating whether this instance has sleep diary. */
    hasSleepDiary!: boolean;
    /** Gets or sets the last occurence score in percent. */
    percentage?: number | undefined;
    /** Gets or sets the sending date. */
    sendingDate!: Date;
    /** Gets or sets the status. */
    status!: StatusConsultationFormularyEnum;
    /** Gets or sets the consultation status. */
    consultationStatus!: ConsultationStatus;
    /** Gets or sets a value indicating whether this instance is for next consultation. */
    isForNextConsultation!: boolean;
    /** Gets or sets the sending date. */
    completionDate?: Date | undefined;

    constructor(data?: IPatientFormulary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.consultationId = _data["consultationId"];
            this.formularyTitle = _data["formularyTitle"];
            this.formularyVersionId = _data["formularyVersionId"];
            this.hasSleepDiary = _data["hasSleepDiary"];
            this.percentage = _data["percentage"];
            this.sendingDate = _data["sendingDate"] ? new Date(_data["sendingDate"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.consultationStatus = _data["consultationStatus"];
            this.isForNextConsultation = _data["isForNextConsultation"];
            this.completionDate = _data["completionDate"] ? new Date(_data["completionDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): PatientFormulary {
        data = typeof data === 'object' ? data : {};
        let result = new PatientFormulary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["consultationId"] = this.consultationId;
        data["formularyTitle"] = this.formularyTitle;
        data["formularyVersionId"] = this.formularyVersionId;
        data["hasSleepDiary"] = this.hasSleepDiary;
        data["percentage"] = this.percentage;
        data["sendingDate"] = this.sendingDate ? this.sendingDate.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["consultationStatus"] = this.consultationStatus;
        data["isForNextConsultation"] = this.isForNextConsultation;
        data["completionDate"] = this.completionDate ? this.completionDate.toISOString() : <any>undefined;
        return data;
    }
}

/** Contains the definition of an object of type PatientFormulary. */
export interface IPatientFormulary {
    /** Gets or sets the consultation identifier. */
    consultationId: number;
    /** Gets or sets the formulary title. */
    formularyTitle?: string | undefined;
    /** Gets or sets the formulary version identifier. */
    formularyVersionId: number;
    /** Gets or sets a value indicating whether this instance has sleep diary. */
    hasSleepDiary: boolean;
    /** Gets or sets the last occurence score in percent. */
    percentage?: number | undefined;
    /** Gets or sets the sending date. */
    sendingDate: Date;
    /** Gets or sets the status. */
    status: StatusConsultationFormularyEnum;
    /** Gets or sets the consultation status. */
    consultationStatus: ConsultationStatus;
    /** Gets or sets a value indicating whether this instance is for next consultation. */
    isForNextConsultation: boolean;
    /** Gets or sets the sending date. */
    completionDate?: Date | undefined;
}

/** Contains the definition of an object type PatientFormularySearchParams */
export class PatientFormularySearchParams extends SearchParams implements IPatientFormularySearchParams {
    /** Gets or sets the formulary title. */
    formularyTitle?: string | undefined;
    /** Gets or sets the patient identifier. */
    patientId!: number;

    constructor(data?: IPatientFormularySearchParams) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.formularyTitle = _data["formularyTitle"];
            this.patientId = _data["patientId"];
        }
    }

    static override fromJS(data: any): PatientFormularySearchParams {
        data = typeof data === 'object' ? data : {};
        let result = new PatientFormularySearchParams();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["formularyTitle"] = this.formularyTitle;
        data["patientId"] = this.patientId;
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object type PatientFormularySearchParams */
export interface IPatientFormularySearchParams extends ISearchParams {
    /** Gets or sets the formulary title. */
    formularyTitle?: string | undefined;
    /** Gets or sets the patient identifier. */
    patientId: number;
}

/** Contains the definition of an object of type QuestionScore. */
export class QuestionScore implements IQuestionScore {
    /** Gets or sets the date. */
    date!: Date;
    /** Gets or sets the maximum score. */
    maxScore!: number;
    /** Gets or sets the score. */
    score?: number | undefined;

    constructor(data?: IQuestionScore) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.maxScore = _data["maxScore"];
            this.score = _data["score"];
        }
    }

    static fromJS(data: any): QuestionScore {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionScore();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["maxScore"] = this.maxScore;
        data["score"] = this.score;
        return data;
    }
}

/** Contains the definition of an object of type QuestionScore. */
export interface IQuestionScore {
    /** Gets or sets the date. */
    date: Date;
    /** Gets or sets the maximum score. */
    maxScore: number;
    /** Gets or sets the score. */
    score?: number | undefined;
}

/** Contains the definition of an object of type PatientMeasureTypeDoctor. */
export class UpdatePatientMeasureTypeDoctor implements IUpdatePatientMeasureTypeDoctor {
    /** Gets or sets the patient measure type doctors. */
    patientMeasureTypeDoctors?: PatientMeasureTypeDoctor[] | undefined;
    /** Gets or sets the patient identifier. */
    patientId!: number;

    constructor(data?: IUpdatePatientMeasureTypeDoctor) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["patientMeasureTypeDoctors"])) {
                this.patientMeasureTypeDoctors = [] as any;
                for (let item of _data["patientMeasureTypeDoctors"])
                    this.patientMeasureTypeDoctors!.push(PatientMeasureTypeDoctor.fromJS(item));
            }
            this.patientId = _data["patientId"];
        }
    }

    static fromJS(data: any): UpdatePatientMeasureTypeDoctor {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePatientMeasureTypeDoctor();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.patientMeasureTypeDoctors)) {
            data["patientMeasureTypeDoctors"] = [];
            for (let item of this.patientMeasureTypeDoctors)
                data["patientMeasureTypeDoctors"].push(item ? item.toJSON() : <any>undefined);
        }
        data["patientId"] = this.patientId;
        return data;
    }
}

/** Contains the definition of an object of type PatientMeasureTypeDoctor. */
export interface IUpdatePatientMeasureTypeDoctor {
    /** Gets or sets the patient measure type doctors. */
    patientMeasureTypeDoctors?: PatientMeasureTypeDoctor[] | undefined;
    /** Gets or sets the patient identifier. */
    patientId: number;
}

/** Contains the definition of an object of type PatientMeasureTypeDoctor. */
export class PatientMeasureTypeDoctor implements IPatientMeasureTypeDoctor {
    /** Gets or sets the patient identifier. */
    patientId!: number;
    /** Gets or sets the doctor identifier. */
    doctorId!: number;
    /** Gets or sets the patient measure type identifier. */
    patientMeasureTypeId!: number;

    constructor(data?: IPatientMeasureTypeDoctor) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.patientId = _data["patientId"];
            this.doctorId = _data["doctorId"];
            this.patientMeasureTypeId = _data["patientMeasureTypeId"];
        }
    }

    static fromJS(data: any): PatientMeasureTypeDoctor {
        data = typeof data === 'object' ? data : {};
        let result = new PatientMeasureTypeDoctor();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["patientId"] = this.patientId;
        data["doctorId"] = this.doctorId;
        data["patientMeasureTypeId"] = this.patientMeasureTypeId;
        return data;
    }
}

/** Contains the definition of an object of type PatientMeasureTypeDoctor. */
export interface IPatientMeasureTypeDoctor {
    /** Gets or sets the patient identifier. */
    patientId: number;
    /** Gets or sets the doctor identifier. */
    doctorId: number;
    /** Gets or sets the patient measure type identifier. */
    patientMeasureTypeId: number;
}

/** Contains the definition of an object of type CurrentPatientDateSeeingDocumentsParams */
export class CurrentPatientDateSeeingDocumentsParams implements ICurrentPatientDateSeeingDocumentsParams {
    /** Gets or sets the patient identifier. */
    patientId!: number;

    constructor(data?: ICurrentPatientDateSeeingDocumentsParams) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.patientId = _data["patientId"];
        }
    }

    static fromJS(data: any): CurrentPatientDateSeeingDocumentsParams {
        data = typeof data === 'object' ? data : {};
        let result = new CurrentPatientDateSeeingDocumentsParams();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["patientId"] = this.patientId;
        return data;
    }
}

/** Contains the definition of an object of type CurrentPatientDateSeeingDocumentsParams */
export interface ICurrentPatientDateSeeingDocumentsParams {
    /** Gets or sets the patient identifier. */
    patientId: number;
}

/** Contains the definition of an object of type UpdatePatientMeasure. */
export class UpdatePatientMeasure extends PatientMeasureBaseEdit implements IUpdatePatientMeasure {
    /** Gets or sets the identifier. */
    id!: number;

    constructor(data?: IUpdatePatientMeasure) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
        }
    }

    static override fromJS(data: any): UpdatePatientMeasure {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePatientMeasure();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type UpdatePatientMeasure. */
export interface IUpdatePatientMeasure extends IPatientMeasureBaseEdit {
    /** Gets or sets the identifier. */
    id: number;
}

/** Contains the definition of an object of type PatientKeyPoints. */
export class PatientKeyPoints implements IPatientKeyPoints {
    /** Gets or sets the patient identifier. */
    patientId!: number;
    /** Gets or sets the key points. */
    keyPoints?: string | undefined;

    constructor(data?: IPatientKeyPoints) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.patientId = _data["patientId"];
            this.keyPoints = _data["keyPoints"];
        }
    }

    static fromJS(data: any): PatientKeyPoints {
        data = typeof data === 'object' ? data : {};
        let result = new PatientKeyPoints();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["patientId"] = this.patientId;
        data["keyPoints"] = this.keyPoints;
        return data;
    }
}

/** Contains the definition of an object of type PatientKeyPoints. */
export interface IPatientKeyPoints {
    /** Gets or sets the patient identifier. */
    patientId: number;
    /** Gets or sets the key points. */
    keyPoints?: string | undefined;
}

/** Contains the definition of an object of type PatientRecommendation. */
export class PatientRecommendation implements IPatientRecommendation {
    /** Gets or sets the identifier. */
    id!: number;
    /** Gets or sets the title. */
    title?: string | undefined;
    /** Gets or sets the date. */
    date?: Date | undefined;
    /** Gets or sets the unique identifier for the consultation. */
    consultationId!: number;

    constructor(data?: IPatientRecommendation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.consultationId = _data["consultationId"];
        }
    }

    static fromJS(data: any): PatientRecommendation {
        data = typeof data === 'object' ? data : {};
        let result = new PatientRecommendation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["consultationId"] = this.consultationId;
        return data;
    }
}

/** Contains the definition of an object of type PatientRecommendation. */
export interface IPatientRecommendation {
    /** Gets or sets the identifier. */
    id: number;
    /** Gets or sets the title. */
    title?: string | undefined;
    /** Gets or sets the date. */
    date?: Date | undefined;
    /** Gets or sets the unique identifier for the consultation. */
    consultationId: number;
}

/** Contains the definition of an object of type SearchParamsRecommendation. */
export class SearchParamsRecommendation extends SearchParams implements ISearchParamsRecommendation {
    /** Gets or sets the patient id. */
    patientId!: number;

    constructor(data?: ISearchParamsRecommendation) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.patientId = _data["patientId"];
        }
    }

    static override fromJS(data: any): SearchParamsRecommendation {
        data = typeof data === 'object' ? data : {};
        let result = new SearchParamsRecommendation();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["patientId"] = this.patientId;
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type SearchParamsRecommendation. */
export interface ISearchParamsRecommendation extends ISearchParams {
    /** Gets or sets the patient id. */
    patientId: number;
}

/** Contains the definition of an object of type SearchParamsRecommendation. */
export class SearchParamsRecommendationSuggestion extends SearchParamsRecommendation implements ISearchParamsRecommendationSuggestion {
    /** Gets or sets the type of the suggestion. */
    suggestionType!: SuggestionType;

    constructor(data?: ISearchParamsRecommendationSuggestion) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.suggestionType = _data["suggestionType"];
        }
    }

    static override fromJS(data: any): SearchParamsRecommendationSuggestion {
        data = typeof data === 'object' ? data : {};
        let result = new SearchParamsRecommendationSuggestion();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["suggestionType"] = this.suggestionType;
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type SearchParamsRecommendation. */
export interface ISearchParamsRecommendationSuggestion extends ISearchParamsRecommendation {
    /** Gets or sets the type of the suggestion. */
    suggestionType: SuggestionType;
}

/** Contains the definition of an object of type ConsultationDocumentTemplateLite. */
export class ConsultationDocumentTemplateLite implements IConsultationDocumentTemplateLite {
    /** Gets or sets the consultation identifier. */
    consultationId!: number;
    /** Gets or sets the date time. */
    sendingDate?: Date | undefined;
    /** Gets or sets the title. */
    title?: string | undefined;
    /** Gets or sets the identifier. */
    id!: number;
    /** Gets or sets a value indicating whether [prescription exist]. */
    prescriptionExist!: boolean;
    /** Gets or sets the status. */
    status!: ConsultationDocumentTemplateStatus;
    /** Gets or sets a value indicating whether this instance is selected. */
    isSelected!: boolean;
    /** Gets or sets the name of the template. */
    templateName?: string | undefined;
    /** Gets or sets the type. */
    type!: ConsultationDocumentTemplateType;
    /** Gets or sets the entity identifier. */
    entityId?: number | undefined;
    /** Gets or sets the group identifier. */
    groupId?: number | undefined;
    /** Gets or sets a value indicating whether this instance is completable. */
    isCompletable!: boolean;
    /** Gets or sets the comment. */
    comment?: string | undefined;
    /** Gets or sets the document identifier. */
    documentId?: number | undefined;
    /** Gets or sets the updated date. */
    updatedDate?: Date | undefined;

    constructor(data?: IConsultationDocumentTemplateLite) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.consultationId = _data["consultationId"];
            this.sendingDate = _data["sendingDate"] ? new Date(_data["sendingDate"].toString()) : <any>undefined;
            this.title = _data["title"];
            this.id = _data["id"];
            this.prescriptionExist = _data["prescriptionExist"];
            this.status = _data["status"];
            this.isSelected = _data["isSelected"];
            this.templateName = _data["templateName"];
            this.type = _data["type"];
            this.entityId = _data["entityId"];
            this.groupId = _data["groupId"];
            this.isCompletable = _data["isCompletable"];
            this.comment = _data["comment"];
            this.documentId = _data["documentId"];
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ConsultationDocumentTemplateLite {
        data = typeof data === 'object' ? data : {};
        let result = new ConsultationDocumentTemplateLite();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["consultationId"] = this.consultationId;
        data["sendingDate"] = this.sendingDate ? this.sendingDate.toISOString() : <any>undefined;
        data["title"] = this.title;
        data["id"] = this.id;
        data["prescriptionExist"] = this.prescriptionExist;
        data["status"] = this.status;
        data["isSelected"] = this.isSelected;
        data["templateName"] = this.templateName;
        data["type"] = this.type;
        data["entityId"] = this.entityId;
        data["groupId"] = this.groupId;
        data["isCompletable"] = this.isCompletable;
        data["comment"] = this.comment;
        data["documentId"] = this.documentId;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>undefined;
        return data;
    }
}

/** Contains the definition of an object of type ConsultationDocumentTemplateLite. */
export interface IConsultationDocumentTemplateLite {
    /** Gets or sets the consultation identifier. */
    consultationId: number;
    /** Gets or sets the date time. */
    sendingDate?: Date | undefined;
    /** Gets or sets the title. */
    title?: string | undefined;
    /** Gets or sets the identifier. */
    id: number;
    /** Gets or sets a value indicating whether [prescription exist]. */
    prescriptionExist: boolean;
    /** Gets or sets the status. */
    status: ConsultationDocumentTemplateStatus;
    /** Gets or sets a value indicating whether this instance is selected. */
    isSelected: boolean;
    /** Gets or sets the name of the template. */
    templateName?: string | undefined;
    /** Gets or sets the type. */
    type: ConsultationDocumentTemplateType;
    /** Gets or sets the entity identifier. */
    entityId?: number | undefined;
    /** Gets or sets the group identifier. */
    groupId?: number | undefined;
    /** Gets or sets a value indicating whether this instance is completable. */
    isCompletable: boolean;
    /** Gets or sets the comment. */
    comment?: string | undefined;
    /** Gets or sets the document identifier. */
    documentId?: number | undefined;
    /** Gets or sets the updated date. */
    updatedDate?: Date | undefined;
}

/** Contains the definition of an object of type ConsultationDocumentTemplateStatus. */
export enum ConsultationDocumentTemplateStatus {
    Unknown = 0,
    New = 1,
    Completed = 2,
}

/** Contains the definition of an object of type ConsultationDocumentTemplateType. */
export enum ConsultationDocumentTemplateType {
    Unknown = 0,
    Other = 1,
    ComplementaryExam = 2,
    ComplementaryExamWithMedicalImagery = 3,
    BiologicalExams = 4,
    ConsultationType = 5,
    NutritionalSupplement = 6,
    ConsultationInvoice = 7,
    ConsultationInvoiceTemplateSettings = 8,
}

/** Contains the definition of an object of type PatientPrescriptionSearchParams. */
export class PatientPrescriptionSearchParams extends SearchParams implements IPatientPrescriptionSearchParams {
    /** Gets or sets the address. */
    patientId!: number;
    /** Gets or sets the type of prescription (NutritionalSupplement, ConsultationType, BiologicalExam, ComplementaryExam, ComplementaryExamMedical) */
    types?: ConsultationDocumentTemplateType[] | undefined;

    constructor(data?: IPatientPrescriptionSearchParams) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.patientId = _data["patientId"];
            if (Array.isArray(_data["types"])) {
                this.types = [] as any;
                for (let item of _data["types"])
                    this.types!.push(item);
            }
        }
    }

    static override fromJS(data: any): PatientPrescriptionSearchParams {
        data = typeof data === 'object' ? data : {};
        let result = new PatientPrescriptionSearchParams();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["patientId"] = this.patientId;
        if (Array.isArray(this.types)) {
            data["types"] = [];
            for (let item of this.types)
                data["types"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type PatientPrescriptionSearchParams. */
export interface IPatientPrescriptionSearchParams extends ISearchParams {
    /** Gets or sets the address. */
    patientId: number;
    /** Gets or sets the type of prescription (NutritionalSupplement, ConsultationType, BiologicalExam, ComplementaryExam, ComplementaryExamMedical) */
    types?: ConsultationDocumentTemplateType[] | undefined;
}

/** Contains the definition of an object of type ConsultationNutritionalSupplement. */
export class ConsultationNutritionalSupplement implements IConsultationNutritionalSupplement {
    /** Gets or sets the identifier. */
    id!: number;
    /** Gets or sets the consultation identifier. */
    consultationId!: number;
    /** Gets or sets the nutritional supplement. */
    nutritionalSupplementId!: number;
    /** Gets or sets the posology. */
    posology?: string | undefined;
    /** Gets or sets a value indicating whether this instance is selected. */
    isSelected!: boolean;
    /** Gets or sets the sending date. */
    lastSendingDate?: Date | undefined;
    /** Gets or sets the name of the laboratory. */
    laboratoryName?: string | undefined;
    /** Gets or sets the name. */
    name?: string | undefined;
    /** Gets or sets a value indicating whether this instance is custom. */
    isCustom!: boolean;
    /** Gets or sets the sending date. */
    sendingDate?: Date | undefined;

    constructor(data?: IConsultationNutritionalSupplement) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.consultationId = _data["consultationId"];
            this.nutritionalSupplementId = _data["nutritionalSupplementId"];
            this.posology = _data["posology"];
            this.isSelected = _data["isSelected"];
            this.lastSendingDate = _data["lastSendingDate"] ? new Date(_data["lastSendingDate"].toString()) : <any>undefined;
            this.laboratoryName = _data["LaboratoryName"];
            this.name = _data["name"];
            this.isCustom = _data["isCustom"];
            this.sendingDate = _data["sendingDate"] ? new Date(_data["sendingDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ConsultationNutritionalSupplement {
        data = typeof data === 'object' ? data : {};
        let result = new ConsultationNutritionalSupplement();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["consultationId"] = this.consultationId;
        data["nutritionalSupplementId"] = this.nutritionalSupplementId;
        data["posology"] = this.posology;
        data["isSelected"] = this.isSelected;
        data["lastSendingDate"] = this.lastSendingDate ? this.lastSendingDate.toISOString() : <any>undefined;
        data["LaboratoryName"] = this.laboratoryName;
        data["name"] = this.name;
        data["isCustom"] = this.isCustom;
        data["sendingDate"] = this.sendingDate ? this.sendingDate.toISOString() : <any>undefined;
        return data;
    }
}

/** Contains the definition of an object of type ConsultationNutritionalSupplement. */
export interface IConsultationNutritionalSupplement {
    /** Gets or sets the identifier. */
    id: number;
    /** Gets or sets the consultation identifier. */
    consultationId: number;
    /** Gets or sets the nutritional supplement. */
    nutritionalSupplementId: number;
    /** Gets or sets the posology. */
    posology?: string | undefined;
    /** Gets or sets a value indicating whether this instance is selected. */
    isSelected: boolean;
    /** Gets or sets the sending date. */
    lastSendingDate?: Date | undefined;
    /** Gets or sets the name of the laboratory. */
    laboratoryName?: string | undefined;
    /** Gets or sets the name. */
    name?: string | undefined;
    /** Gets or sets a value indicating whether this instance is custom. */
    isCustom: boolean;
    /** Gets or sets the sending date. */
    sendingDate?: Date | undefined;
}

/** Contains the definition of an object of type PatientConsultationSearchParams. */
export class PatientConsultationSearchParams extends SearchParams implements IPatientConsultationSearchParams {
    /** Gets or sets the doctor ids. */
    doctorIds?: number[] | undefined;
    /** Gets or sets the type ids. */
    typeIds?: number[] | undefined;
    /** Gets or sets the consultation statuses. */
    statuses?: ConsultationStatus[] | undefined;

    constructor(data?: IPatientConsultationSearchParams) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["doctorIds"])) {
                this.doctorIds = [] as any;
                for (let item of _data["doctorIds"])
                    this.doctorIds!.push(item);
            }
            if (Array.isArray(_data["typeIds"])) {
                this.typeIds = [] as any;
                for (let item of _data["typeIds"])
                    this.typeIds!.push(item);
            }
            if (Array.isArray(_data["statuses"])) {
                this.statuses = [] as any;
                for (let item of _data["statuses"])
                    this.statuses!.push(item);
            }
        }
    }

    static override fromJS(data: any): PatientConsultationSearchParams {
        data = typeof data === 'object' ? data : {};
        let result = new PatientConsultationSearchParams();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.doctorIds)) {
            data["doctorIds"] = [];
            for (let item of this.doctorIds)
                data["doctorIds"].push(item);
        }
        if (Array.isArray(this.typeIds)) {
            data["typeIds"] = [];
            for (let item of this.typeIds)
                data["typeIds"].push(item);
        }
        if (Array.isArray(this.statuses)) {
            data["statuses"] = [];
            for (let item of this.statuses)
                data["statuses"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type PatientConsultationSearchParams. */
export interface IPatientConsultationSearchParams extends ISearchParams {
    /** Gets or sets the doctor ids. */
    doctorIds?: number[] | undefined;
    /** Gets or sets the type ids. */
    typeIds?: number[] | undefined;
    /** Gets or sets the consultation statuses. */
    statuses?: ConsultationStatus[] | undefined;
}

/** Contains the definition of an object of type ConsultationTypeFilter. */
export class ConsultationTypeFilter implements IConsultationTypeFilter {
    /** Gets or sets the identifier. */
    id!: number;
    /** Gets or sets the name. */
    name?: string | undefined;

    constructor(data?: IConsultationTypeFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): ConsultationTypeFilter {
        data = typeof data === 'object' ? data : {};
        let result = new ConsultationTypeFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

/** Contains the definition of an object of type ConsultationTypeFilter. */
export interface IConsultationTypeFilter {
    /** Gets or sets the identifier. */
    id: number;
    /** Gets or sets the name. */
    name?: string | undefined;
}

/** Contains the definition of an object of type SearchParamPrescription. */
export class SearchParamPrescription implements ISearchParamPrescription {
    /** Gets or sets the name of the template. */
    templateName?: string | undefined;
    /** Gets or sets the consultation identifier. */
    consultationId?: number | undefined;
    /** Gets or sets the entity identifier. */
    entityId?: number | undefined;
    /** Gets or sets the group identifier. */
    groupId?: number | undefined;
    /** Gets or sets a value indicating whether this instance is for library. */
    isForLibrary!: boolean;
    /** Gets or sets the consultation document template identifier. */
    consultationDocumentTemplateIdOtherDoc!: number;
    /** Gets or sets the prescription type. */
    prescriptionType?: PrescriptionType | undefined;
    /** Gets or sets the item of consultation prescription identifier. Like biological exam item id, complementary exam item id, orientations, ... */
    prescriptionItemId?: number | undefined;
    /** Gets or sets the document identifier. */
    documentId?: number | undefined;

    constructor(data?: ISearchParamPrescription) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.templateName = _data["templateName"];
            this.consultationId = _data["consultationId"];
            this.entityId = _data["entityId"];
            this.groupId = _data["groupId"];
            this.isForLibrary = _data["isForLibrary"];
            this.consultationDocumentTemplateIdOtherDoc = _data["consultationDocumentTemplateIdOtherDoc"];
            this.prescriptionType = _data["prescriptionType"];
            this.prescriptionItemId = _data["prescriptionItemId"];
            this.documentId = _data["documentId"];
        }
    }

    static fromJS(data: any): SearchParamPrescription {
        data = typeof data === 'object' ? data : {};
        let result = new SearchParamPrescription();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["templateName"] = this.templateName;
        data["consultationId"] = this.consultationId;
        data["entityId"] = this.entityId;
        data["groupId"] = this.groupId;
        data["isForLibrary"] = this.isForLibrary;
        data["consultationDocumentTemplateIdOtherDoc"] = this.consultationDocumentTemplateIdOtherDoc;
        data["prescriptionType"] = this.prescriptionType;
        data["prescriptionItemId"] = this.prescriptionItemId;
        data["documentId"] = this.documentId;
        return data;
    }
}

/** Contains the definition of an object of type SearchParamPrescription. */
export interface ISearchParamPrescription {
    /** Gets or sets the name of the template. */
    templateName?: string | undefined;
    /** Gets or sets the consultation identifier. */
    consultationId?: number | undefined;
    /** Gets or sets the entity identifier. */
    entityId?: number | undefined;
    /** Gets or sets the group identifier. */
    groupId?: number | undefined;
    /** Gets or sets a value indicating whether this instance is for library. */
    isForLibrary: boolean;
    /** Gets or sets the consultation document template identifier. */
    consultationDocumentTemplateIdOtherDoc: number;
    /** Gets or sets the prescription type. */
    prescriptionType?: PrescriptionType | undefined;
    /** Gets or sets the item of consultation prescription identifier. Like biological exam item id, complementary exam item id, orientations, ... */
    prescriptionItemId?: number | undefined;
    /** Gets or sets the document identifier. */
    documentId?: number | undefined;
}

/** Contains the definition of an object of type PrescriptionType. */
export enum PrescriptionType {
    DocumentPrescriptionFoodComplement = 0,
    DocumentPrescriptionBiologicalExam = 1,
    DocumentPrescriptionComplementaryExam = 2,
    DocumentPrescriptionOrientation = 3,
}

/** Contains the definition of an object of type ConsultationRequiredPatientAction */
export class ConsultationRequiredPatientActions implements IConsultationRequiredPatientActions {
    /** Gets or sets a value indicating whether this instance has unread document. */
    hasUnreadDocument!: boolean;
    /** Gets or sets a value indicating whether this instance has un read formulary. */
    hasUnreadFormulary!: boolean;
    /** Gets or sets a value indicating whether this instance has un read suggestion. */
    hasUnreadSuggestion!: boolean;
    /** Gets or sets a value indicating whether this instance has unread notes. */
    hasUnreadNotes!: boolean;

    constructor(data?: IConsultationRequiredPatientActions) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hasUnreadDocument = _data["hasUnreadDocument"];
            this.hasUnreadFormulary = _data["hasUnreadFormulary"];
            this.hasUnreadSuggestion = _data["hasUnreadSuggestion"];
            this.hasUnreadNotes = _data["hasUnreadNotes"];
        }
    }

    static fromJS(data: any): ConsultationRequiredPatientActions {
        data = typeof data === 'object' ? data : {};
        let result = new ConsultationRequiredPatientActions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasUnreadDocument"] = this.hasUnreadDocument;
        data["hasUnreadFormulary"] = this.hasUnreadFormulary;
        data["hasUnreadSuggestion"] = this.hasUnreadSuggestion;
        data["hasUnreadNotes"] = this.hasUnreadNotes;
        return data;
    }
}

/** Contains the definition of an object of type ConsultationRequiredPatientAction */
export interface IConsultationRequiredPatientActions {
    /** Gets or sets a value indicating whether this instance has unread document. */
    hasUnreadDocument: boolean;
    /** Gets or sets a value indicating whether this instance has un read formulary. */
    hasUnreadFormulary: boolean;
    /** Gets or sets a value indicating whether this instance has un read suggestion. */
    hasUnreadSuggestion: boolean;
    /** Gets or sets a value indicating whether this instance has unread notes. */
    hasUnreadNotes: boolean;
}

/** Contains the definition of an object of type ConsultationDocumentBaseModel */
export class ConsultationDocumentTemplate implements IConsultationDocumentTemplate {
    /** Gets or sets the answers.
             */
    answers?: ConsultationDocumentTemplateAnswer[] | undefined;
    /** Gets or sets the consultation complementary exam identifier.
             */
    consultationComplementaryExamId?: number | undefined;
    /** Gets or sets the consultation consultation type identifier.
             */
    consultationConsultationTypeId?: number | undefined;
    /** Gets or sets the consultation identifier.
             */
    consultationId!: number;
    /** Gets or sets the identifier
             */
    id!: number;
    /** Gets or sets a value indicating whether this instance is selected. */
    isSelected!: boolean;
    /** Gets or sets the sending date.
             */
    sendingDate?: Date | undefined;
    /** Gets or sets the status.
             */
    status!: ConsultationDocumentTemplateStatus;
    /** Gets or sets the template name
             */
    templateName?: string | undefined;
    /** Gets or sets the type.
             */
    type!: ConsultationDocumentTemplateType;
    /** Gets or sets the document identifier. */
    documentId?: number | undefined;

    constructor(data?: IConsultationDocumentTemplate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["answers"])) {
                this.answers = [] as any;
                for (let item of _data["answers"])
                    this.answers!.push(ConsultationDocumentTemplateAnswer.fromJS(item));
            }
            this.consultationComplementaryExamId = _data["consultationComplementaryExamId"];
            this.consultationConsultationTypeId = _data["consultationConsultationTypeId"];
            this.consultationId = _data["consultationId"];
            this.id = _data["id"];
            this.isSelected = _data["isSelected"];
            this.sendingDate = _data["sendingDate"] ? new Date(_data["sendingDate"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.templateName = _data["templateName"];
            this.type = _data["type"];
            this.documentId = _data["documentId"];
        }
    }

    static fromJS(data: any): ConsultationDocumentTemplate {
        data = typeof data === 'object' ? data : {};
        let result = new ConsultationDocumentTemplate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.answers)) {
            data["answers"] = [];
            for (let item of this.answers)
                data["answers"].push(item ? item.toJSON() : <any>undefined);
        }
        data["consultationComplementaryExamId"] = this.consultationComplementaryExamId;
        data["consultationConsultationTypeId"] = this.consultationConsultationTypeId;
        data["consultationId"] = this.consultationId;
        data["id"] = this.id;
        data["isSelected"] = this.isSelected;
        data["sendingDate"] = this.sendingDate ? this.sendingDate.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["templateName"] = this.templateName;
        data["type"] = this.type;
        data["documentId"] = this.documentId;
        return data;
    }
}

/** Contains the definition of an object of type ConsultationDocumentBaseModel */
export interface IConsultationDocumentTemplate {
    /** Gets or sets the answers.
             */
    answers?: ConsultationDocumentTemplateAnswer[] | undefined;
    /** Gets or sets the consultation complementary exam identifier.
             */
    consultationComplementaryExamId?: number | undefined;
    /** Gets or sets the consultation consultation type identifier.
             */
    consultationConsultationTypeId?: number | undefined;
    /** Gets or sets the consultation identifier.
             */
    consultationId: number;
    /** Gets or sets the identifier
             */
    id: number;
    /** Gets or sets a value indicating whether this instance is selected. */
    isSelected: boolean;
    /** Gets or sets the sending date.
             */
    sendingDate?: Date | undefined;
    /** Gets or sets the status.
             */
    status: ConsultationDocumentTemplateStatus;
    /** Gets or sets the template name
             */
    templateName?: string | undefined;
    /** Gets or sets the type.
             */
    type: ConsultationDocumentTemplateType;
    /** Gets or sets the document identifier. */
    documentId?: number | undefined;
}

/** Contains the definition of an object of type ConsultationDocumentTemplateBaseAnswer. */
export class ConsultationDocumentTemplateBaseAnswer implements IConsultationDocumentTemplateBaseAnswer {
    /** Gets or sets the key. */
    key?: string | undefined;
    /** Gets or sets the value. */
    value?: string | undefined;

    constructor(data?: IConsultationDocumentTemplateBaseAnswer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): ConsultationDocumentTemplateBaseAnswer {
        data = typeof data === 'object' ? data : {};
        let result = new ConsultationDocumentTemplateBaseAnswer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["value"] = this.value;
        return data;
    }
}

/** Contains the definition of an object of type ConsultationDocumentTemplateBaseAnswer. */
export interface IConsultationDocumentTemplateBaseAnswer {
    /** Gets or sets the key. */
    key?: string | undefined;
    /** Gets or sets the value. */
    value?: string | undefined;
}

/** Contains the definition of an object of type ConsultationDocumentBaseModel */
export class ConsultationDocumentTemplateAnswer extends ConsultationDocumentTemplateBaseAnswer implements IConsultationDocumentTemplateAnswer {
    /** Gets or sets the field type. */
    fieldType!: FieldType;
    /** Gets or sets the values. */
    values?: ConsultationDocumentTemplateBaseAnswer[] | undefined;

    constructor(data?: IConsultationDocumentTemplateAnswer) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.fieldType = _data["fieldType"];
            if (Array.isArray(_data["values"])) {
                this.values = [] as any;
                for (let item of _data["values"])
                    this.values!.push(ConsultationDocumentTemplateBaseAnswer.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): ConsultationDocumentTemplateAnswer {
        data = typeof data === 'object' ? data : {};
        let result = new ConsultationDocumentTemplateAnswer();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fieldType"] = this.fieldType;
        if (Array.isArray(this.values)) {
            data["values"] = [];
            for (let item of this.values)
                data["values"].push(item ? item.toJSON() : <any>undefined);
        }
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type ConsultationDocumentBaseModel */
export interface IConsultationDocumentTemplateAnswer extends IConsultationDocumentTemplateBaseAnswer {
    /** Gets or sets the field type. */
    fieldType: FieldType;
    /** Gets or sets the values. */
    values?: ConsultationDocumentTemplateBaseAnswer[] | undefined;
}

/** Contains the definition of an object of type FieldType. */
export enum FieldType {
    SimpleField = 0,
    CheckboxField = 1,
    GroupField = 2,
    RichTextField = 3,
}

export class PaginatorWrapperOfIEnumerableOfConsultation implements IPaginatorWrapperOfIEnumerableOfConsultation {
    totalRecords!: number;
    data?: Consultation[] | undefined;

    constructor(data?: IPaginatorWrapperOfIEnumerableOfConsultation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRecords = _data["totalRecords"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(Consultation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatorWrapperOfIEnumerableOfConsultation {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatorWrapperOfIEnumerableOfConsultation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IPaginatorWrapperOfIEnumerableOfConsultation {
    totalRecords: number;
    data?: Consultation[] | undefined;
}

/** paginator wrapper of consultation */
export class ConsultationPaginatorWrapper extends PaginatorWrapperOfIEnumerableOfConsultation implements IConsultationPaginatorWrapper {
    /** Gets or sets a value indicating whether [has consultation needs doctor confirmation]. */
    hasConsultationNeedsDoctorConfirmation!: boolean;

    constructor(data?: IConsultationPaginatorWrapper) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.hasConsultationNeedsDoctorConfirmation = _data["hasConsultationNeedsDoctorConfirmation"];
        }
    }

    static override fromJS(data: any): ConsultationPaginatorWrapper {
        data = typeof data === 'object' ? data : {};
        let result = new ConsultationPaginatorWrapper();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasConsultationNeedsDoctorConfirmation"] = this.hasConsultationNeedsDoctorConfirmation;
        super.toJSON(data);
        return data;
    }
}

/** paginator wrapper of consultation */
export interface IConsultationPaginatorWrapper extends IPaginatorWrapperOfIEnumerableOfConsultation {
    /** Gets or sets a value indicating whether [has consultation needs doctor confirmation]. */
    hasConsultationNeedsDoctorConfirmation: boolean;
}

/** Contains the definition of an object of type SearchParamConsultation. */
export class SearchParamConsultation extends SearchParams implements ISearchParamConsultation {
    /** Gets or sets the id of the patient */
    patientId?: number | undefined;
    /** Gets or sets the consultation order by. */
    sortType?: ConsultationSortType | undefined;
    /** Gets or sets the consultation status order by. */
    statusType?: ConsultationStatusType | undefined;

    constructor(data?: ISearchParamConsultation) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.patientId = _data["patientId"];
            this.sortType = _data["sortType"];
            this.statusType = _data["statusType"];
        }
    }

    static override fromJS(data: any): SearchParamConsultation {
        data = typeof data === 'object' ? data : {};
        let result = new SearchParamConsultation();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["patientId"] = this.patientId;
        data["sortType"] = this.sortType;
        data["statusType"] = this.statusType;
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type SearchParamConsultation. */
export interface ISearchParamConsultation extends ISearchParams {
    /** Gets or sets the id of the patient */
    patientId?: number | undefined;
    /** Gets or sets the consultation order by. */
    sortType?: ConsultationSortType | undefined;
    /** Gets or sets the consultation status order by. */
    statusType?: ConsultationStatusType | undefined;
}

/** Contains the definition of an object of type ConsultationSortType. */
export enum ConsultationSortType {
    ConsultationDateAsc = 0,
    ConsultationDateDesc = 1,
}

/** Contains the definition of an object of type ConsultationStatusType. */
export enum ConsultationStatusType {
    All = 0,
    NeedPatientConfirmation = 1,
    NeedDoctorConfirmation = 2,
    NeedPayment = 3,
    ToClose = 4,
    NotPaid = 5,
}

export class ConsultationDocumentBaseModelOfIEnumerableOfConsultationNutritionalSupplement implements IConsultationDocumentBaseModelOfIEnumerableOfConsultationNutritionalSupplement {
    consultationDocumentTemplate?: ConsultationDocumentTemplate | undefined;
    consultationDate!: Date;
    consultationData?: ConsultationNutritionalSupplement[] | undefined;
    titleSet?: string | undefined;
    descriptionSet?: string | undefined;

    constructor(data?: IConsultationDocumentBaseModelOfIEnumerableOfConsultationNutritionalSupplement) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.consultationDocumentTemplate = _data["consultationDocumentTemplate"] ? ConsultationDocumentTemplate.fromJS(_data["consultationDocumentTemplate"]) : <any>undefined;
            this.consultationDate = _data["consultationDate"] ? new Date(_data["consultationDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["consultationData"])) {
                this.consultationData = [] as any;
                for (let item of _data["consultationData"])
                    this.consultationData!.push(ConsultationNutritionalSupplement.fromJS(item));
            }
            this.titleSet = _data["titleSet"];
            this.descriptionSet = _data["descriptionSet"];
        }
    }

    static fromJS(data: any): ConsultationDocumentBaseModelOfIEnumerableOfConsultationNutritionalSupplement {
        data = typeof data === 'object' ? data : {};
        let result = new ConsultationDocumentBaseModelOfIEnumerableOfConsultationNutritionalSupplement();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["consultationDocumentTemplate"] = this.consultationDocumentTemplate ? this.consultationDocumentTemplate.toJSON() : <any>undefined;
        data["consultationDate"] = this.consultationDate ? this.consultationDate.toISOString() : <any>undefined;
        if (Array.isArray(this.consultationData)) {
            data["consultationData"] = [];
            for (let item of this.consultationData)
                data["consultationData"].push(item ? item.toJSON() : <any>undefined);
        }
        data["titleSet"] = this.titleSet;
        data["descriptionSet"] = this.descriptionSet;
        return data;
    }
}

export interface IConsultationDocumentBaseModelOfIEnumerableOfConsultationNutritionalSupplement {
    consultationDocumentTemplate?: ConsultationDocumentTemplate | undefined;
    consultationDate: Date;
    consultationData?: ConsultationNutritionalSupplement[] | undefined;
    titleSet?: string | undefined;
    descriptionSet?: string | undefined;
}

export class ConsultationDocumentBaseModelOfIEnumerableOfConsultationBiologicalExamTitle implements IConsultationDocumentBaseModelOfIEnumerableOfConsultationBiologicalExamTitle {
    consultationDocumentTemplate?: ConsultationDocumentTemplate | undefined;
    consultationDate!: Date;
    consultationData?: ConsultationBiologicalExamTitle[] | undefined;
    titleSet?: string | undefined;
    descriptionSet?: string | undefined;

    constructor(data?: IConsultationDocumentBaseModelOfIEnumerableOfConsultationBiologicalExamTitle) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.consultationDocumentTemplate = _data["consultationDocumentTemplate"] ? ConsultationDocumentTemplate.fromJS(_data["consultationDocumentTemplate"]) : <any>undefined;
            this.consultationDate = _data["consultationDate"] ? new Date(_data["consultationDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["consultationData"])) {
                this.consultationData = [] as any;
                for (let item of _data["consultationData"])
                    this.consultationData!.push(ConsultationBiologicalExamTitle.fromJS(item));
            }
            this.titleSet = _data["titleSet"];
            this.descriptionSet = _data["descriptionSet"];
        }
    }

    static fromJS(data: any): ConsultationDocumentBaseModelOfIEnumerableOfConsultationBiologicalExamTitle {
        data = typeof data === 'object' ? data : {};
        let result = new ConsultationDocumentBaseModelOfIEnumerableOfConsultationBiologicalExamTitle();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["consultationDocumentTemplate"] = this.consultationDocumentTemplate ? this.consultationDocumentTemplate.toJSON() : <any>undefined;
        data["consultationDate"] = this.consultationDate ? this.consultationDate.toISOString() : <any>undefined;
        if (Array.isArray(this.consultationData)) {
            data["consultationData"] = [];
            for (let item of this.consultationData)
                data["consultationData"].push(item ? item.toJSON() : <any>undefined);
        }
        data["titleSet"] = this.titleSet;
        data["descriptionSet"] = this.descriptionSet;
        return data;
    }
}

export interface IConsultationDocumentBaseModelOfIEnumerableOfConsultationBiologicalExamTitle {
    consultationDocumentTemplate?: ConsultationDocumentTemplate | undefined;
    consultationDate: Date;
    consultationData?: ConsultationBiologicalExamTitle[] | undefined;
    titleSet?: string | undefined;
    descriptionSet?: string | undefined;
}

/** Contains the definition of an object of type ConsultationSuggestibleTitle. */
export class ConsultationSuggestibleTitle implements IConsultationSuggestibleTitle {
    /** Gets or sets the identifier. */
    id!: number;
    /** Gets or sets the type of the suggestible. */
    suggestibletype!: SuggestibleType;
    /** Gets or sets the intention. */
    intention!: IntentionLevelType;
    /** Gets or sets a value indicating whether this instance is from siin. */
    isFromSiin!: boolean;
    /** Gets or sets a value indicating whether this instance is personal. False by default. */
    isPersonal!: boolean;
    /** Gets or sets a value indicating whether this instance is selected. */
    isSelected!: boolean;
    /** Gets or sets the entity identifier. */
    entityId!: number;
    /** Gets or sets the title. */
    title?: string | undefined;
    /** Gets or sets the suggestible source types. */
    suggestibleSourceWithEntityNames?: SuggestibleSourceWithEntityName[] | undefined;
    /** Gets or sets the warnings. */
    warnings?: SuggestibleSourceWithEntityName[] | undefined;
    /** Gets or sets the last sending date. */
    lastSendingDate?: Date | undefined;
    /** Gets or sets the sending date. */
    sendingDate?: Date | undefined;
    /** Gets or sets a value indicating whether this prescription is present multiple time. */
    isMultiple!: boolean;
    /** Gets or sets the consultation document template identifier. */
    consultationDocumentTemplateId?: number | undefined;

    constructor(data?: IConsultationSuggestibleTitle) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.suggestibletype = _data["suggestibletype"];
            this.intention = _data["intention"];
            this.isFromSiin = _data["isFromSiin"];
            this.isPersonal = _data["isPersonal"];
            this.isSelected = _data["isSelected"];
            this.entityId = _data["entityId"];
            this.title = _data["title"];
            if (Array.isArray(_data["suggestibleSourceWithEntityNames"])) {
                this.suggestibleSourceWithEntityNames = [] as any;
                for (let item of _data["suggestibleSourceWithEntityNames"])
                    this.suggestibleSourceWithEntityNames!.push(SuggestibleSourceWithEntityName.fromJS(item));
            }
            if (Array.isArray(_data["warnings"])) {
                this.warnings = [] as any;
                for (let item of _data["warnings"])
                    this.warnings!.push(SuggestibleSourceWithEntityName.fromJS(item));
            }
            this.lastSendingDate = _data["lastSendingDate"] ? new Date(_data["lastSendingDate"].toString()) : <any>undefined;
            this.sendingDate = _data["sendingDate"] ? new Date(_data["sendingDate"].toString()) : <any>undefined;
            this.isMultiple = _data["isMultiple"];
            this.consultationDocumentTemplateId = _data["consultationDocumentTemplateId"];
        }
    }

    static fromJS(data: any): ConsultationSuggestibleTitle {
        data = typeof data === 'object' ? data : {};
        let result = new ConsultationSuggestibleTitle();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["suggestibletype"] = this.suggestibletype;
        data["intention"] = this.intention;
        data["isFromSiin"] = this.isFromSiin;
        data["isPersonal"] = this.isPersonal;
        data["isSelected"] = this.isSelected;
        data["entityId"] = this.entityId;
        data["title"] = this.title;
        if (Array.isArray(this.suggestibleSourceWithEntityNames)) {
            data["suggestibleSourceWithEntityNames"] = [];
            for (let item of this.suggestibleSourceWithEntityNames)
                data["suggestibleSourceWithEntityNames"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.warnings)) {
            data["warnings"] = [];
            for (let item of this.warnings)
                data["warnings"].push(item ? item.toJSON() : <any>undefined);
        }
        data["lastSendingDate"] = this.lastSendingDate ? this.lastSendingDate.toISOString() : <any>undefined;
        data["sendingDate"] = this.sendingDate ? this.sendingDate.toISOString() : <any>undefined;
        data["isMultiple"] = this.isMultiple;
        data["consultationDocumentTemplateId"] = this.consultationDocumentTemplateId;
        return data;
    }
}

/** Contains the definition of an object of type ConsultationSuggestibleTitle. */
export interface IConsultationSuggestibleTitle {
    /** Gets or sets the identifier. */
    id: number;
    /** Gets or sets the type of the suggestible. */
    suggestibletype: SuggestibleType;
    /** Gets or sets the intention. */
    intention: IntentionLevelType;
    /** Gets or sets a value indicating whether this instance is from siin. */
    isFromSiin: boolean;
    /** Gets or sets a value indicating whether this instance is personal. False by default. */
    isPersonal: boolean;
    /** Gets or sets a value indicating whether this instance is selected. */
    isSelected: boolean;
    /** Gets or sets the entity identifier. */
    entityId: number;
    /** Gets or sets the title. */
    title?: string | undefined;
    /** Gets or sets the suggestible source types. */
    suggestibleSourceWithEntityNames?: SuggestibleSourceWithEntityName[] | undefined;
    /** Gets or sets the warnings. */
    warnings?: SuggestibleSourceWithEntityName[] | undefined;
    /** Gets or sets the last sending date. */
    lastSendingDate?: Date | undefined;
    /** Gets or sets the sending date. */
    sendingDate?: Date | undefined;
    /** Gets or sets a value indicating whether this prescription is present multiple time. */
    isMultiple: boolean;
    /** Gets or sets the consultation document template identifier. */
    consultationDocumentTemplateId?: number | undefined;
}

/** Contains the definition of an object of type ConsultationBiologicalExamTitle. */
export class ConsultationBiologicalExamTitle extends ConsultationSuggestibleTitle implements IConsultationBiologicalExamTitle {
    /** Gets or sets the type. */
    nature!: BiologicalExamNatureSample;

    constructor(data?: IConsultationBiologicalExamTitle) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.nature = _data["nature"];
        }
    }

    static override fromJS(data: any): ConsultationBiologicalExamTitle {
        data = typeof data === 'object' ? data : {};
        let result = new ConsultationBiologicalExamTitle();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nature"] = this.nature;
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type ConsultationBiologicalExamTitle. */
export interface IConsultationBiologicalExamTitle extends IConsultationSuggestibleTitle {
    /** Gets or sets the type. */
    nature: BiologicalExamNatureSample;
}

export class ConsultationDocumentBaseModelOfConsultationComplementaryExamTitle implements IConsultationDocumentBaseModelOfConsultationComplementaryExamTitle {
    consultationDocumentTemplate?: ConsultationDocumentTemplate | undefined;
    consultationDate!: Date;
    consultationData?: ConsultationComplementaryExamTitle | undefined;
    titleSet?: string | undefined;
    descriptionSet?: string | undefined;

    constructor(data?: IConsultationDocumentBaseModelOfConsultationComplementaryExamTitle) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.consultationDocumentTemplate = _data["consultationDocumentTemplate"] ? ConsultationDocumentTemplate.fromJS(_data["consultationDocumentTemplate"]) : <any>undefined;
            this.consultationDate = _data["consultationDate"] ? new Date(_data["consultationDate"].toString()) : <any>undefined;
            this.consultationData = _data["consultationData"] ? ConsultationComplementaryExamTitle.fromJS(_data["consultationData"]) : <any>undefined;
            this.titleSet = _data["titleSet"];
            this.descriptionSet = _data["descriptionSet"];
        }
    }

    static fromJS(data: any): ConsultationDocumentBaseModelOfConsultationComplementaryExamTitle {
        data = typeof data === 'object' ? data : {};
        let result = new ConsultationDocumentBaseModelOfConsultationComplementaryExamTitle();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["consultationDocumentTemplate"] = this.consultationDocumentTemplate ? this.consultationDocumentTemplate.toJSON() : <any>undefined;
        data["consultationDate"] = this.consultationDate ? this.consultationDate.toISOString() : <any>undefined;
        data["consultationData"] = this.consultationData ? this.consultationData.toJSON() : <any>undefined;
        data["titleSet"] = this.titleSet;
        data["descriptionSet"] = this.descriptionSet;
        return data;
    }
}

export interface IConsultationDocumentBaseModelOfConsultationComplementaryExamTitle {
    consultationDocumentTemplate?: ConsultationDocumentTemplate | undefined;
    consultationDate: Date;
    consultationData?: ConsultationComplementaryExamTitle | undefined;
    titleSet?: string | undefined;
    descriptionSet?: string | undefined;
}

/** Contains the definition of an object of type ConsultationComplementaryExamTitle. */
export class ConsultationComplementaryExamTitle extends ConsultationSuggestibleTitle implements IConsultationComplementaryExamTitle {
    /** Gets or sets the prescription status. */
    prescriptionStatus!: ConsultationDocumentTemplateStatus;
    /** Gets or sets a value indicating whether [prescription exist]. */
    prescriptionExist!: boolean;
    /** Gets or sets the prescription identifier. */
    prescriptionId!: number;
    /** Gets or sets the prescrition title. */
    prescritionTitle?: string | undefined;
    /** Gets or sets the PrescriptionType. */
    prescriptionType!: ConsultationDocumentTemplateType;
    /** Gets or sets the prescription technical identifier. */
    prescriptionTechnicalId?: string | undefined;
    /** Gets or sets the document identifier. */
    documentId?: number | undefined;

    constructor(data?: IConsultationComplementaryExamTitle) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.prescriptionStatus = _data["prescriptionStatus"];
            this.prescriptionExist = _data["prescriptionExist"];
            this.prescriptionId = _data["prescriptionId"];
            this.prescritionTitle = _data["prescritionTitle"];
            this.prescriptionType = _data["prescriptionType"];
            this.prescriptionTechnicalId = _data["prescriptionTechnicalId"];
            this.documentId = _data["documentId"];
        }
    }

    static override fromJS(data: any): ConsultationComplementaryExamTitle {
        data = typeof data === 'object' ? data : {};
        let result = new ConsultationComplementaryExamTitle();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["prescriptionStatus"] = this.prescriptionStatus;
        data["prescriptionExist"] = this.prescriptionExist;
        data["prescriptionId"] = this.prescriptionId;
        data["prescritionTitle"] = this.prescritionTitle;
        data["prescriptionType"] = this.prescriptionType;
        data["prescriptionTechnicalId"] = this.prescriptionTechnicalId;
        data["documentId"] = this.documentId;
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type ConsultationComplementaryExamTitle. */
export interface IConsultationComplementaryExamTitle extends IConsultationSuggestibleTitle {
    /** Gets or sets the prescription status. */
    prescriptionStatus: ConsultationDocumentTemplateStatus;
    /** Gets or sets a value indicating whether [prescription exist]. */
    prescriptionExist: boolean;
    /** Gets or sets the prescription identifier. */
    prescriptionId: number;
    /** Gets or sets the prescrition title. */
    prescritionTitle?: string | undefined;
    /** Gets or sets the PrescriptionType. */
    prescriptionType: ConsultationDocumentTemplateType;
    /** Gets or sets the prescription technical identifier. */
    prescriptionTechnicalId?: string | undefined;
    /** Gets or sets the document identifier. */
    documentId?: number | undefined;
}

export class ConsultationDocumentBaseModelOfConsultationConsultationTypeTitle implements IConsultationDocumentBaseModelOfConsultationConsultationTypeTitle {
    consultationDocumentTemplate?: ConsultationDocumentTemplate | undefined;
    consultationDate!: Date;
    consultationData?: ConsultationConsultationTypeTitle | undefined;
    titleSet?: string | undefined;
    descriptionSet?: string | undefined;

    constructor(data?: IConsultationDocumentBaseModelOfConsultationConsultationTypeTitle) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.consultationDocumentTemplate = _data["consultationDocumentTemplate"] ? ConsultationDocumentTemplate.fromJS(_data["consultationDocumentTemplate"]) : <any>undefined;
            this.consultationDate = _data["consultationDate"] ? new Date(_data["consultationDate"].toString()) : <any>undefined;
            this.consultationData = _data["consultationData"] ? ConsultationConsultationTypeTitle.fromJS(_data["consultationData"]) : <any>undefined;
            this.titleSet = _data["titleSet"];
            this.descriptionSet = _data["descriptionSet"];
        }
    }

    static fromJS(data: any): ConsultationDocumentBaseModelOfConsultationConsultationTypeTitle {
        data = typeof data === 'object' ? data : {};
        let result = new ConsultationDocumentBaseModelOfConsultationConsultationTypeTitle();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["consultationDocumentTemplate"] = this.consultationDocumentTemplate ? this.consultationDocumentTemplate.toJSON() : <any>undefined;
        data["consultationDate"] = this.consultationDate ? this.consultationDate.toISOString() : <any>undefined;
        data["consultationData"] = this.consultationData ? this.consultationData.toJSON() : <any>undefined;
        data["titleSet"] = this.titleSet;
        data["descriptionSet"] = this.descriptionSet;
        return data;
    }
}

export interface IConsultationDocumentBaseModelOfConsultationConsultationTypeTitle {
    consultationDocumentTemplate?: ConsultationDocumentTemplate | undefined;
    consultationDate: Date;
    consultationData?: ConsultationConsultationTypeTitle | undefined;
    titleSet?: string | undefined;
    descriptionSet?: string | undefined;
}

/** Contains the definition of an object of type ConsultationConsultationTypeTitle. */
export class ConsultationConsultationTypeTitle extends ConsultationSuggestibleTitle implements IConsultationConsultationTypeTitle {
    /** Gets or sets the prescription status. */
    prescriptionStatus!: ConsultationDocumentTemplateStatus;
    /** Gets or sets a value indicating whether [prescription exist]. */
    prescriptionExist!: boolean;
    /** Gets or sets the prescription identifier. */
    prescriptionId!: number;
    /** Gets or sets the prescrition title. */
    prescritionTitle?: string | undefined;
    /** Gets or sets the PrescriptionType. */
    prescriptionType!: ConsultationDocumentTemplateType;
    /** Gets or sets the PrescriptionType. */
    prescriptionTechnicalId?: string | undefined;
    /** Gets or sets the document identifier. */
    documentId?: number | undefined;

    constructor(data?: IConsultationConsultationTypeTitle) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.prescriptionStatus = _data["prescriptionStatus"];
            this.prescriptionExist = _data["prescriptionExist"];
            this.prescriptionId = _data["prescriptionId"];
            this.prescritionTitle = _data["prescritionTitle"];
            this.prescriptionType = _data["prescriptionType"];
            this.prescriptionTechnicalId = _data["prescriptionTechnicalId"];
            this.documentId = _data["documentId"];
        }
    }

    static override fromJS(data: any): ConsultationConsultationTypeTitle {
        data = typeof data === 'object' ? data : {};
        let result = new ConsultationConsultationTypeTitle();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["prescriptionStatus"] = this.prescriptionStatus;
        data["prescriptionExist"] = this.prescriptionExist;
        data["prescriptionId"] = this.prescriptionId;
        data["prescritionTitle"] = this.prescritionTitle;
        data["prescriptionType"] = this.prescriptionType;
        data["prescriptionTechnicalId"] = this.prescriptionTechnicalId;
        data["documentId"] = this.documentId;
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type ConsultationConsultationTypeTitle. */
export interface IConsultationConsultationTypeTitle extends IConsultationSuggestibleTitle {
    /** Gets or sets the prescription status. */
    prescriptionStatus: ConsultationDocumentTemplateStatus;
    /** Gets or sets a value indicating whether [prescription exist]. */
    prescriptionExist: boolean;
    /** Gets or sets the prescription identifier. */
    prescriptionId: number;
    /** Gets or sets the prescrition title. */
    prescritionTitle?: string | undefined;
    /** Gets or sets the PrescriptionType. */
    prescriptionType: ConsultationDocumentTemplateType;
    /** Gets or sets the PrescriptionType. */
    prescriptionTechnicalId?: string | undefined;
    /** Gets or sets the document identifier. */
    documentId?: number | undefined;
}

/** Contains the definition of an object of type SendingBox. */
export class SendingBox implements ISendingBox {
    /** Gets or sets the consultation activities. */
    consultationActivities?: ConsultationActivityTitle[] | undefined;
    /** Gets or sets the consultation recipes. */
    consultationRecipes?: ConsultationRecipeTitle[] | undefined;
    /** Gets or sets the consultation suggestion food. */
    consultationSuggestionFood?: ConsultationSuggestionTitle[] | undefined;
    /** Gets or sets the consultation suggestion life style. */
    consultationSuggestionLifeStyle?: ConsultationSuggestionTitle[] | undefined;
    /** Gets or sets the prescription models. */
    prescriptionModels?: ConsultationDocumentTemplateLite2[] | undefined;
    /** Gets or sets the document prescription. */
    documentOtherPrescriptions?: ConsultationDocumentTemplateLite2[] | undefined;
    /** Gets or sets the document send by doctor. */
    documentSendByDoctors?: Document[] | undefined;
    /** Gets or sets the document prescriptions. */
    documentPrescriptions?: ConsultationDocumentTemplateLite2[] | undefined;

    constructor(data?: ISendingBox) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["consultationActivities"])) {
                this.consultationActivities = [] as any;
                for (let item of _data["consultationActivities"])
                    this.consultationActivities!.push(ConsultationActivityTitle.fromJS(item));
            }
            if (Array.isArray(_data["consultationRecipes"])) {
                this.consultationRecipes = [] as any;
                for (let item of _data["consultationRecipes"])
                    this.consultationRecipes!.push(ConsultationRecipeTitle.fromJS(item));
            }
            if (Array.isArray(_data["consultationSuggestionFood"])) {
                this.consultationSuggestionFood = [] as any;
                for (let item of _data["consultationSuggestionFood"])
                    this.consultationSuggestionFood!.push(ConsultationSuggestionTitle.fromJS(item));
            }
            if (Array.isArray(_data["consultationSuggestionLifeStyle"])) {
                this.consultationSuggestionLifeStyle = [] as any;
                for (let item of _data["consultationSuggestionLifeStyle"])
                    this.consultationSuggestionLifeStyle!.push(ConsultationSuggestionTitle.fromJS(item));
            }
            if (Array.isArray(_data["prescriptionModels"])) {
                this.prescriptionModels = [] as any;
                for (let item of _data["prescriptionModels"])
                    this.prescriptionModels!.push(ConsultationDocumentTemplateLite2.fromJS(item));
            }
            if (Array.isArray(_data["documentOtherPrescriptions"])) {
                this.documentOtherPrescriptions = [] as any;
                for (let item of _data["documentOtherPrescriptions"])
                    this.documentOtherPrescriptions!.push(ConsultationDocumentTemplateLite2.fromJS(item));
            }
            if (Array.isArray(_data["documentSendByDoctors"])) {
                this.documentSendByDoctors = [] as any;
                for (let item of _data["documentSendByDoctors"])
                    this.documentSendByDoctors!.push(Document.fromJS(item));
            }
            if (Array.isArray(_data["documentPrescriptions"])) {
                this.documentPrescriptions = [] as any;
                for (let item of _data["documentPrescriptions"])
                    this.documentPrescriptions!.push(ConsultationDocumentTemplateLite2.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SendingBox {
        data = typeof data === 'object' ? data : {};
        let result = new SendingBox();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.consultationActivities)) {
            data["consultationActivities"] = [];
            for (let item of this.consultationActivities)
                data["consultationActivities"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.consultationRecipes)) {
            data["consultationRecipes"] = [];
            for (let item of this.consultationRecipes)
                data["consultationRecipes"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.consultationSuggestionFood)) {
            data["consultationSuggestionFood"] = [];
            for (let item of this.consultationSuggestionFood)
                data["consultationSuggestionFood"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.consultationSuggestionLifeStyle)) {
            data["consultationSuggestionLifeStyle"] = [];
            for (let item of this.consultationSuggestionLifeStyle)
                data["consultationSuggestionLifeStyle"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.prescriptionModels)) {
            data["prescriptionModels"] = [];
            for (let item of this.prescriptionModels)
                data["prescriptionModels"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.documentOtherPrescriptions)) {
            data["documentOtherPrescriptions"] = [];
            for (let item of this.documentOtherPrescriptions)
                data["documentOtherPrescriptions"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.documentSendByDoctors)) {
            data["documentSendByDoctors"] = [];
            for (let item of this.documentSendByDoctors)
                data["documentSendByDoctors"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.documentPrescriptions)) {
            data["documentPrescriptions"] = [];
            for (let item of this.documentPrescriptions)
                data["documentPrescriptions"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

/** Contains the definition of an object of type SendingBox. */
export interface ISendingBox {
    /** Gets or sets the consultation activities. */
    consultationActivities?: ConsultationActivityTitle[] | undefined;
    /** Gets or sets the consultation recipes. */
    consultationRecipes?: ConsultationRecipeTitle[] | undefined;
    /** Gets or sets the consultation suggestion food. */
    consultationSuggestionFood?: ConsultationSuggestionTitle[] | undefined;
    /** Gets or sets the consultation suggestion life style. */
    consultationSuggestionLifeStyle?: ConsultationSuggestionTitle[] | undefined;
    /** Gets or sets the prescription models. */
    prescriptionModels?: ConsultationDocumentTemplateLite2[] | undefined;
    /** Gets or sets the document prescription. */
    documentOtherPrescriptions?: ConsultationDocumentTemplateLite2[] | undefined;
    /** Gets or sets the document send by doctor. */
    documentSendByDoctors?: Document[] | undefined;
    /** Gets or sets the document prescriptions. */
    documentPrescriptions?: ConsultationDocumentTemplateLite2[] | undefined;
}

/** Contains the definition of an object of type ConsultationActivityTitle. */
export class ConsultationActivityTitle extends ConsultationSuggestibleTitle implements IConsultationActivityTitle {

    constructor(data?: IConsultationActivityTitle) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ConsultationActivityTitle {
        data = typeof data === 'object' ? data : {};
        let result = new ConsultationActivityTitle();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type ConsultationActivityTitle. */
export interface IConsultationActivityTitle extends IConsultationSuggestibleTitle {
}

/** Contains the definition of an object of type ConsultationRecipeTitle. */
export class ConsultationRecipeTitle extends ConsultationSuggestibleTitle implements IConsultationRecipeTitle {

    constructor(data?: IConsultationRecipeTitle) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ConsultationRecipeTitle {
        data = typeof data === 'object' ? data : {};
        let result = new ConsultationRecipeTitle();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type ConsultationRecipeTitle. */
export interface IConsultationRecipeTitle extends IConsultationSuggestibleTitle {
}

/** Contains the definition of an object of type ConsultationSuggestionTitle. */
export class ConsultationSuggestionTitle extends ConsultationSuggestibleTitle implements IConsultationSuggestionTitle {
    /** Gets or sets the suggestiontype. */
    suggestiontype!: number;

    constructor(data?: IConsultationSuggestionTitle) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.suggestiontype = _data["suggestiontype"];
        }
    }

    static override fromJS(data: any): ConsultationSuggestionTitle {
        data = typeof data === 'object' ? data : {};
        let result = new ConsultationSuggestionTitle();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["suggestiontype"] = this.suggestiontype;
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type ConsultationSuggestionTitle. */
export interface IConsultationSuggestionTitle extends IConsultationSuggestibleTitle {
    /** Gets or sets the suggestiontype. */
    suggestiontype: number;
}

/** Contains the definition of an object of type ConsultationDocumentTemplateLite. */
export class ConsultationDocumentTemplateLite2 implements IConsultationDocumentTemplateLite2 {
    /** Gets or sets the date time. */
    sendingDate?: Date | undefined;
    /** Gets or sets the title. */
    title?: string | undefined;
    /** Gets or sets the identifier. */
    id!: number;
    /** Gets or sets a value indicating whether [prescription exist]. */
    prescriptionExist!: boolean;
    /** Gets or sets the status. */
    status!: ConsultationDocumentTemplateStatus;
    /** Gets or sets a value indicating whether this instance is selected. */
    isSelected?: boolean | undefined;
    /** Gets or sets the type. */
    type!: ConsultationDocumentTemplateType;
    /** Gets or sets the name of the template. */
    templateName?: string | undefined;
    /** Gets or sets the entity identifier. */
    entityId?: number | undefined;
    /** Gets or sets the group identifier. */
    groupId?: number | undefined;
    /** Gets or sets the consultation identifier. */
    consultationId!: number;
    /** Gets or sets a value indicating whether this instance is completable. */
    isCompletable!: boolean;
    /** Gets or sets the comment. */
    comment?: string | undefined;
    /** Gets or sets the document identifier. */
    documentId?: number | undefined;
    /** Gets or sets the updated date. */
    updatedDate?: Date | undefined;

    constructor(data?: IConsultationDocumentTemplateLite2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sendingDate = _data["SendingDate"] ? new Date(_data["SendingDate"].toString()) : <any>undefined;
            this.title = _data["Title"];
            this.id = _data["Id"];
            this.prescriptionExist = _data["PrescriptionExist"];
            this.status = _data["Status"];
            this.isSelected = _data["IsSelected"];
            this.type = _data["Type"];
            this.templateName = _data["TemplateName"];
            this.entityId = _data["EntityId"];
            this.groupId = _data["GroupId"];
            this.consultationId = _data["ConsultationId"];
            this.isCompletable = _data["IsCompletable"];
            this.comment = _data["Comment"];
            this.documentId = _data["DocumentId"];
            this.updatedDate = _data["UpdatedDate"] ? new Date(_data["UpdatedDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ConsultationDocumentTemplateLite2 {
        data = typeof data === 'object' ? data : {};
        let result = new ConsultationDocumentTemplateLite2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["SendingDate"] = this.sendingDate ? this.sendingDate.toISOString() : <any>undefined;
        data["Title"] = this.title;
        data["Id"] = this.id;
        data["PrescriptionExist"] = this.prescriptionExist;
        data["Status"] = this.status;
        data["IsSelected"] = this.isSelected;
        data["Type"] = this.type;
        data["TemplateName"] = this.templateName;
        data["EntityId"] = this.entityId;
        data["GroupId"] = this.groupId;
        data["ConsultationId"] = this.consultationId;
        data["IsCompletable"] = this.isCompletable;
        data["Comment"] = this.comment;
        data["DocumentId"] = this.documentId;
        data["UpdatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>undefined;
        return data;
    }
}

/** Contains the definition of an object of type ConsultationDocumentTemplateLite. */
export interface IConsultationDocumentTemplateLite2 {
    /** Gets or sets the date time. */
    sendingDate?: Date | undefined;
    /** Gets or sets the title. */
    title?: string | undefined;
    /** Gets or sets the identifier. */
    id: number;
    /** Gets or sets a value indicating whether [prescription exist]. */
    prescriptionExist: boolean;
    /** Gets or sets the status. */
    status: ConsultationDocumentTemplateStatus;
    /** Gets or sets a value indicating whether this instance is selected. */
    isSelected?: boolean | undefined;
    /** Gets or sets the type. */
    type: ConsultationDocumentTemplateType;
    /** Gets or sets the name of the template. */
    templateName?: string | undefined;
    /** Gets or sets the entity identifier. */
    entityId?: number | undefined;
    /** Gets or sets the group identifier. */
    groupId?: number | undefined;
    /** Gets or sets the consultation identifier. */
    consultationId: number;
    /** Gets or sets a value indicating whether this instance is completable. */
    isCompletable: boolean;
    /** Gets or sets the comment. */
    comment?: string | undefined;
    /** Gets or sets the document identifier. */
    documentId?: number | undefined;
    /** Gets or sets the updated date. */
    updatedDate?: Date | undefined;
}

/** Contains the definition of an object of type ConsultationSuggestion. */
export class ConsultationSuggestion implements IConsultationSuggestion {
    /** Gets or sets the consultation identifier. */
    consultationId!: number;
    /** Gets or sets a value indicating whether the suggestion was automatically generated from Siin. */
    isFromSiin!: boolean;
    /** Gets or sets a value indicating whether this instance is read. */
    isRead!: boolean;
    /** Gets or sets the previous sending date. */
    previousSendingDate?: Date | undefined;
    /** Gets or sets the sending date. */
    sendingDate?: Date | undefined;
    /** Gets or sets a value indicating whether the suggestion has alredy been sent or not to the patient. */
    sent!: boolean;
    /** Gets or sets the suggestion. */
    suggestion?: Suggestion | undefined;
    /** Gets or sets the suggestion identifier. */
    suggestionId!: number;
    /** Gets or sets the suggestion sources. */
    suggestionSources?: SuggestionSource[] | undefined;

    constructor(data?: IConsultationSuggestion) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.consultationId = _data["consultationId"];
            this.isFromSiin = _data["isFromSiin"];
            this.isRead = _data["isRead"];
            this.previousSendingDate = _data["previousSendingDate"] ? new Date(_data["previousSendingDate"].toString()) : <any>undefined;
            this.sendingDate = _data["sendingDate"] ? new Date(_data["sendingDate"].toString()) : <any>undefined;
            this.sent = _data["sent"];
            this.suggestion = _data["suggestion"] ? Suggestion.fromJS(_data["suggestion"]) : <any>undefined;
            this.suggestionId = _data["suggestionId"];
            if (Array.isArray(_data["suggestionSources"])) {
                this.suggestionSources = [] as any;
                for (let item of _data["suggestionSources"])
                    this.suggestionSources!.push(SuggestionSource.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ConsultationSuggestion {
        data = typeof data === 'object' ? data : {};
        let result = new ConsultationSuggestion();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["consultationId"] = this.consultationId;
        data["isFromSiin"] = this.isFromSiin;
        data["isRead"] = this.isRead;
        data["previousSendingDate"] = this.previousSendingDate ? this.previousSendingDate.toISOString() : <any>undefined;
        data["sendingDate"] = this.sendingDate ? this.sendingDate.toISOString() : <any>undefined;
        data["sent"] = this.sent;
        data["suggestion"] = this.suggestion ? this.suggestion.toJSON() : <any>undefined;
        data["suggestionId"] = this.suggestionId;
        if (Array.isArray(this.suggestionSources)) {
            data["suggestionSources"] = [];
            for (let item of this.suggestionSources)
                data["suggestionSources"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

/** Contains the definition of an object of type ConsultationSuggestion. */
export interface IConsultationSuggestion {
    /** Gets or sets the consultation identifier. */
    consultationId: number;
    /** Gets or sets a value indicating whether the suggestion was automatically generated from Siin. */
    isFromSiin: boolean;
    /** Gets or sets a value indicating whether this instance is read. */
    isRead: boolean;
    /** Gets or sets the previous sending date. */
    previousSendingDate?: Date | undefined;
    /** Gets or sets the sending date. */
    sendingDate?: Date | undefined;
    /** Gets or sets a value indicating whether the suggestion has alredy been sent or not to the patient. */
    sent: boolean;
    /** Gets or sets the suggestion. */
    suggestion?: Suggestion | undefined;
    /** Gets or sets the suggestion identifier. */
    suggestionId: number;
    /** Gets or sets the suggestion sources. */
    suggestionSources?: SuggestionSource[] | undefined;
}

/** Contains the definition of an object of type Suggestion. */
export class Suggestion implements ISuggestion {
    /** Gets or sets the identifier. */
    id!: number;
    /** Gets or sets a value indicating whether this instance is custom suggestion. */
    isCustomSuggestion!: boolean;
    /** Gets or sets the status. */
    status!: StatusSuggestion;
    /** Gets or sets the type of the public. */
    publicType!: SuggestionPublicType;
    /** Gets or sets the title. */
    title!: string;
    /** Gets or sets the type identifier. */
    typeId!: number;

    constructor(data?: ISuggestion) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isCustomSuggestion = _data["isCustomSuggestion"];
            this.status = _data["status"];
            this.publicType = _data["publicType"];
            this.title = _data["title"];
            this.typeId = _data["typeId"];
        }
    }

    static fromJS(data: any): Suggestion {
        data = typeof data === 'object' ? data : {};
        let result = new Suggestion();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isCustomSuggestion"] = this.isCustomSuggestion;
        data["status"] = this.status;
        data["publicType"] = this.publicType;
        data["title"] = this.title;
        data["typeId"] = this.typeId;
        return data;
    }
}

/** Contains the definition of an object of type Suggestion. */
export interface ISuggestion {
    /** Gets or sets the identifier. */
    id: number;
    /** Gets or sets a value indicating whether this instance is custom suggestion. */
    isCustomSuggestion: boolean;
    /** Gets or sets the status. */
    status: StatusSuggestion;
    /** Gets or sets the type of the public. */
    publicType: SuggestionPublicType;
    /** Gets or sets the title. */
    title: string;
    /** Gets or sets the type identifier. */
    typeId: number;
}

/** Contains the definition of an object of type StatusSuggestion. */
export enum StatusSuggestion {
    Unknown = 0,
    Published = 1,
    Unpublished = 2,
    InProgress = 3,
}

/** Contains the definition of an object of type SuggestionSource. */
export class SuggestionSource implements ISuggestionSource {
    /** Gets or sets the suggestion identifier. */
    suggestionId!: number;
    /** Gets or sets the source. */
    source!: SiinSuggestionSource;
    /** Gets or sets the reason. */
    reasons?: string[] | undefined;

    constructor(data?: ISuggestionSource) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.suggestionId = _data["suggestionId"];
            this.source = _data["source"];
            if (Array.isArray(_data["reasons"])) {
                this.reasons = [] as any;
                for (let item of _data["reasons"])
                    this.reasons!.push(item);
            }
        }
    }

    static fromJS(data: any): SuggestionSource {
        data = typeof data === 'object' ? data : {};
        let result = new SuggestionSource();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["suggestionId"] = this.suggestionId;
        data["source"] = this.source;
        if (Array.isArray(this.reasons)) {
            data["reasons"] = [];
            for (let item of this.reasons)
                data["reasons"].push(item);
        }
        return data;
    }
}

/** Contains the definition of an object of type SuggestionSource. */
export interface ISuggestionSource {
    /** Gets or sets the suggestion identifier. */
    suggestionId: number;
    /** Gets or sets the source. */
    source: SiinSuggestionSource;
    /** Gets or sets the reason. */
    reasons?: string[] | undefined;
}

/** Contains the definition of an object of type SiinSuggestionSource. */
export enum SiinSuggestionSource {
    MedicalHistory = 0,
    FormularyAnswer = 1,
    Disease = 2,
}

/** Contains the definition of an object of type SuggestionMyNutri. */
export class SuggestionMyNutri implements ISuggestionMyNutri {
    /** Gets or sets the suggestion identifier. */
    suggestionId!: number;
    /** Gets or sets the title. */
    title?: string | undefined;
    /** Gets or sets the sending date. */
    sendingDate?: Date | undefined;
    /** Gets or sets the ending date. */
    endingDate?: Date | undefined;
    /** Gets or sets the type identifier. */
    typeId!: number;
    /** Gets or sets a value indicating whether this instance is seen. */
    isSeen!: boolean;

    constructor(data?: ISuggestionMyNutri) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.suggestionId = _data["suggestionId"];
            this.title = _data["title"];
            this.sendingDate = _data["sendingDate"] ? new Date(_data["sendingDate"].toString()) : <any>undefined;
            this.endingDate = _data["endingDate"] ? new Date(_data["endingDate"].toString()) : <any>undefined;
            this.typeId = _data["typeId"];
            this.isSeen = _data["isSeen"];
        }
    }

    static fromJS(data: any): SuggestionMyNutri {
        data = typeof data === 'object' ? data : {};
        let result = new SuggestionMyNutri();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["suggestionId"] = this.suggestionId;
        data["title"] = this.title;
        data["sendingDate"] = this.sendingDate ? this.sendingDate.toISOString() : <any>undefined;
        data["endingDate"] = this.endingDate ? this.endingDate.toISOString() : <any>undefined;
        data["typeId"] = this.typeId;
        data["isSeen"] = this.isSeen;
        return data;
    }
}

/** Contains the definition of an object of type SuggestionMyNutri. */
export interface ISuggestionMyNutri {
    /** Gets or sets the suggestion identifier. */
    suggestionId: number;
    /** Gets or sets the title. */
    title?: string | undefined;
    /** Gets or sets the sending date. */
    sendingDate?: Date | undefined;
    /** Gets or sets the ending date. */
    endingDate?: Date | undefined;
    /** Gets or sets the type identifier. */
    typeId: number;
    /** Gets or sets a value indicating whether this instance is seen. */
    isSeen: boolean;
}

/** Contains the definition of an object of type ConsultationSuggestionSearchParams */
export class ConsultationSuggestionSearchParams extends SearchParams implements IConsultationSuggestionSearchParams {
    /** Gets or sets the suggestion ids. */
    suggestionIds?: number[] | undefined;
    /** Gets or sets the suggestions type identifiers. */
    suggestionTypeIds?: number[] | undefined;

    constructor(data?: IConsultationSuggestionSearchParams) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["suggestionIds"])) {
                this.suggestionIds = [] as any;
                for (let item of _data["suggestionIds"])
                    this.suggestionIds!.push(item);
            }
            if (Array.isArray(_data["suggestionTypeIds"])) {
                this.suggestionTypeIds = [] as any;
                for (let item of _data["suggestionTypeIds"])
                    this.suggestionTypeIds!.push(item);
            }
        }
    }

    static override fromJS(data: any): ConsultationSuggestionSearchParams {
        data = typeof data === 'object' ? data : {};
        let result = new ConsultationSuggestionSearchParams();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.suggestionIds)) {
            data["suggestionIds"] = [];
            for (let item of this.suggestionIds)
                data["suggestionIds"].push(item);
        }
        if (Array.isArray(this.suggestionTypeIds)) {
            data["suggestionTypeIds"] = [];
            for (let item of this.suggestionTypeIds)
                data["suggestionTypeIds"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type ConsultationSuggestionSearchParams */
export interface IConsultationSuggestionSearchParams extends ISearchParams {
    /** Gets or sets the suggestion ids. */
    suggestionIds?: number[] | undefined;
    /** Gets or sets the suggestions type identifiers. */
    suggestionTypeIds?: number[] | undefined;
}

/** Contains the definition of an object of type ConsultationSuggestionLite */
export class ConsultationSuggestionLite implements IConsultationSuggestionLite {
    /** Gets or sets the consultation identifier. */
    consultationId!: number;
    /** Gets or sets a value indicating whether this ConsultationSuggestionLite is read. */
    isRead!: boolean;
    /** Gets or sets the suggestion identifier. */
    suggestionId!: number;
    /** Gets or sets the title. */
    suggestionTitle?: string | undefined;
    /** Gets or sets the type identifier. */
    suggestionTypeId!: number;

    constructor(data?: IConsultationSuggestionLite) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.consultationId = _data["consultationId"];
            this.isRead = _data["isRead"];
            this.suggestionId = _data["suggestionId"];
            this.suggestionTitle = _data["suggestionTitle"];
            this.suggestionTypeId = _data["suggestionTypeId"];
        }
    }

    static fromJS(data: any): ConsultationSuggestionLite {
        data = typeof data === 'object' ? data : {};
        let result = new ConsultationSuggestionLite();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["consultationId"] = this.consultationId;
        data["isRead"] = this.isRead;
        data["suggestionId"] = this.suggestionId;
        data["suggestionTitle"] = this.suggestionTitle;
        data["suggestionTypeId"] = this.suggestionTypeId;
        return data;
    }
}

/** Contains the definition of an object of type ConsultationSuggestionLite */
export interface IConsultationSuggestionLite {
    /** Gets or sets the consultation identifier. */
    consultationId: number;
    /** Gets or sets a value indicating whether this ConsultationSuggestionLite is read. */
    isRead: boolean;
    /** Gets or sets the suggestion identifier. */
    suggestionId: number;
    /** Gets or sets the title. */
    suggestionTitle?: string | undefined;
    /** Gets or sets the type identifier. */
    suggestionTypeId: number;
}

/** Contains the definition of an object of type ConsultationSuggestibleInfo. */
export class ConsultationSuggestibleInfo implements IConsultationSuggestibleInfo {
    /** Gets or sets the consultation identifier. */
    consultationId!: number;
    /** Gets or sets the type of the suggestible. */
    suggestibleType!: SuggestibleType;
    /** Gets or sets the entity identifier. */
    entityId!: number;
    /** Gets or sets a value indicating whether this instance is selected. */
    isSelected!: boolean;
    /** Gets or sets the identifier. */
    id!: number;
    /** Gets or sets the set identifier. */
    setId?: number | undefined;
    /** Gets or sets a value indicating whether this instance is for next consultation. */
    isForNextConsultation?: boolean | undefined;
    /** Gets or sets the biological exam group id */
    biologicalExamGroupId?: number | undefined;
    /** Gets or sets a value indicating whether this instance should create a new isolated prescription. */
    createNewIsolatedPrescription?: boolean | undefined;
    /** Gets or sets the starting date sleep diary. */
    startingDateSleepDiary?: Date | undefined;

    constructor(data?: IConsultationSuggestibleInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.consultationId = _data["ConsultationId"];
            this.suggestibleType = _data["SuggestibleType"];
            this.entityId = _data["EntityId"];
            this.isSelected = _data["IsSelected"];
            this.id = _data["Id"];
            this.setId = _data["SetId"];
            this.isForNextConsultation = _data["IsForNextConsultation"];
            this.biologicalExamGroupId = _data["BiologicalExamGroupId"];
            this.createNewIsolatedPrescription = _data["CreateNewIsolatedPrescription"];
            this.startingDateSleepDiary = _data["StartingDateSleepDiary"] ? new Date(_data["StartingDateSleepDiary"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ConsultationSuggestibleInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ConsultationSuggestibleInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ConsultationId"] = this.consultationId;
        data["SuggestibleType"] = this.suggestibleType;
        data["EntityId"] = this.entityId;
        data["IsSelected"] = this.isSelected;
        data["Id"] = this.id;
        data["SetId"] = this.setId;
        data["IsForNextConsultation"] = this.isForNextConsultation;
        data["BiologicalExamGroupId"] = this.biologicalExamGroupId;
        data["CreateNewIsolatedPrescription"] = this.createNewIsolatedPrescription;
        data["StartingDateSleepDiary"] = this.startingDateSleepDiary ? this.startingDateSleepDiary.toISOString() : <any>undefined;
        return data;
    }
}

/** Contains the definition of an object of type ConsultationSuggestibleInfo. */
export interface IConsultationSuggestibleInfo {
    /** Gets or sets the consultation identifier. */
    consultationId: number;
    /** Gets or sets the type of the suggestible. */
    suggestibleType: SuggestibleType;
    /** Gets or sets the entity identifier. */
    entityId: number;
    /** Gets or sets a value indicating whether this instance is selected. */
    isSelected: boolean;
    /** Gets or sets the identifier. */
    id: number;
    /** Gets or sets the set identifier. */
    setId?: number | undefined;
    /** Gets or sets a value indicating whether this instance is for next consultation. */
    isForNextConsultation?: boolean | undefined;
    /** Gets or sets the biological exam group id */
    biologicalExamGroupId?: number | undefined;
    /** Gets or sets a value indicating whether this instance should create a new isolated prescription. */
    createNewIsolatedPrescription?: boolean | undefined;
    /** Gets or sets the starting date sleep diary. */
    startingDateSleepDiary?: Date | undefined;
}

/** Contains the definition of an object of type NutritionalSupplementSelectionInfo. */
export class NutritionalSupplementSelectionInfo implements INutritionalSupplementSelectionInfo {
    /** Gets or sets the nutritional supplement ids. */
    nutritionalSupplementIds?: number[] | undefined;
    /** Gets or sets a value indicating whether [selecttion status]. */
    selectionStatus!: boolean;
    /** Gets or sets the consultation identifier. */
    consultationId!: number;

    constructor(data?: INutritionalSupplementSelectionInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["nutritionalSupplementIds"])) {
                this.nutritionalSupplementIds = [] as any;
                for (let item of _data["nutritionalSupplementIds"])
                    this.nutritionalSupplementIds!.push(item);
            }
            this.selectionStatus = _data["selectionStatus"];
            this.consultationId = _data["consultationId"];
        }
    }

    static fromJS(data: any): NutritionalSupplementSelectionInfo {
        data = typeof data === 'object' ? data : {};
        let result = new NutritionalSupplementSelectionInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.nutritionalSupplementIds)) {
            data["nutritionalSupplementIds"] = [];
            for (let item of this.nutritionalSupplementIds)
                data["nutritionalSupplementIds"].push(item);
        }
        data["selectionStatus"] = this.selectionStatus;
        data["consultationId"] = this.consultationId;
        return data;
    }
}

/** Contains the definition of an object of type NutritionalSupplementSelectionInfo. */
export interface INutritionalSupplementSelectionInfo {
    /** Gets or sets the nutritional supplement ids. */
    nutritionalSupplementIds?: number[] | undefined;
    /** Gets or sets a value indicating whether [selecttion status]. */
    selectionStatus: boolean;
    /** Gets or sets the consultation identifier. */
    consultationId: number;
}

/** Contains the definition of an object of type DocumentTemplateSelectionInformation. */
export class DocumentTemplateSelectionInformation implements IDocumentTemplateSelectionInformation {
    /** Gets or sets the consultation identifier. */
    consultationId!: number;
    /** Gets or sets a value indicating whether this DocumentTemplateSelectionInformation is value. */
    value!: boolean;
    /** Gets or sets the name of the template (umbraco key) from librayr only. */
    templateName?: string | undefined;

    constructor(data?: IDocumentTemplateSelectionInformation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.consultationId = _data["consultationId"];
            this.value = _data["value"];
            this.templateName = _data["templateName"];
        }
    }

    static fromJS(data: any): DocumentTemplateSelectionInformation {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentTemplateSelectionInformation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["consultationId"] = this.consultationId;
        data["value"] = this.value;
        data["templateName"] = this.templateName;
        return data;
    }
}

/** Contains the definition of an object of type DocumentTemplateSelectionInformation. */
export interface IDocumentTemplateSelectionInformation {
    /** Gets or sets the consultation identifier. */
    consultationId: number;
    /** Gets or sets a value indicating whether this DocumentTemplateSelectionInformation is value. */
    value: boolean;
    /** Gets or sets the name of the template (umbraco key) from librayr only. */
    templateName?: string | undefined;
}

/** Contains the definition of an object of type SelectionInformations. */
export class SelectionInformations implements ISelectionInformations {
    /** Gets or sets the document ids. */
    ids?: number[] | undefined;
    /** Gets or sets a value indicating whether this SelectionInformations is value. */
    value!: boolean;
    /** Gets or sets the consultation identifier. */
    consultationId!: number;

    constructor(data?: ISelectionInformations) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
            this.value = _data["value"];
            this.consultationId = _data["consultationId"];
        }
    }

    static fromJS(data: any): SelectionInformations {
        data = typeof data === 'object' ? data : {};
        let result = new SelectionInformations();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        data["value"] = this.value;
        data["consultationId"] = this.consultationId;
        return data;
    }
}

/** Contains the definition of an object of type SelectionInformations. */
export interface ISelectionInformations {
    /** Gets or sets the document ids. */
    ids?: number[] | undefined;
    /** Gets or sets a value indicating whether this SelectionInformations is value. */
    value: boolean;
    /** Gets or sets the consultation identifier. */
    consultationId: number;
}

/** Contains the definition of an object of type ConsultationBaseEdit. */
export class ConsultationBaseEdit implements IConsultationBaseEdit {
    /** Gets or sets the identifier. */
    id!: number;
    /** Gets or sets the doctor identifier. */
    doctorId!: number;
    /** Gets or sets the patient identifier. */
    patientId!: number;

    constructor(data?: IConsultationBaseEdit) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.doctorId = _data["doctorId"];
            this.patientId = _data["patientId"];
        }
    }

    static fromJS(data: any): ConsultationBaseEdit {
        data = typeof data === 'object' ? data : {};
        let result = new ConsultationBaseEdit();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["doctorId"] = this.doctorId;
        data["patientId"] = this.patientId;
        return data;
    }
}

/** Contains the definition of an object of type ConsultationBaseEdit. */
export interface IConsultationBaseEdit {
    /** Gets or sets the identifier. */
    id: number;
    /** Gets or sets the doctor identifier. */
    doctorId: number;
    /** Gets or sets the patient identifier. */
    patientId: number;
}

/** Contains the definition of an object of type ConsultationBasicInfoEdit. */
export class ConsultationBasicInfoEdit extends ConsultationBaseEdit implements IConsultationBasicInfoEdit {
    /** Gets or sets the date. */
    date!: Date;
    /** Gets or sets a value indicating whether the patient' has given consent about PSNC's information */
    consentPSNC!: boolean;
    /** Gets or sets the consultation configuration identifier. */
    consultationConfigId!: number;
    /** Gets or sets the duration. */
    duration!: number;
    /** Gets or sets the patient token. */
    patientToken?: string | undefined;
    /** Gets or sets the insurance identifier. */
    insuranceId?: number | undefined;
    /** Gets or sets the location. */
    location!: ConsultationLocation;
    /** Gets or sets the status. */
    status!: ConsultationStatus;
    /** Gets or sets the payment status. */
    paymentStatus!: PaymentStatus;
    /** Gets or sets the medical office identifier. */
    medicalOfficeId?: number | undefined;

    constructor(data?: IConsultationBasicInfoEdit) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.consentPSNC = _data["consentPSNC"];
            this.consultationConfigId = _data["consultationConfigId"];
            this.duration = _data["duration"];
            this.patientToken = _data["patientToken"];
            this.insuranceId = _data["insuranceId"];
            this.location = _data["location"];
            this.status = _data["status"];
            this.paymentStatus = _data["paymentStatus"];
            this.medicalOfficeId = _data["medicalOfficeId"];
        }
    }

    static override fromJS(data: any): ConsultationBasicInfoEdit {
        data = typeof data === 'object' ? data : {};
        let result = new ConsultationBasicInfoEdit();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["consentPSNC"] = this.consentPSNC;
        data["consultationConfigId"] = this.consultationConfigId;
        data["duration"] = this.duration;
        data["patientToken"] = this.patientToken;
        data["insuranceId"] = this.insuranceId;
        data["location"] = this.location;
        data["status"] = this.status;
        data["paymentStatus"] = this.paymentStatus;
        data["medicalOfficeId"] = this.medicalOfficeId;
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type ConsultationBasicInfoEdit. */
export interface IConsultationBasicInfoEdit extends IConsultationBaseEdit {
    /** Gets or sets the date. */
    date: Date;
    /** Gets or sets a value indicating whether the patient' has given consent about PSNC's information */
    consentPSNC: boolean;
    /** Gets or sets the consultation configuration identifier. */
    consultationConfigId: number;
    /** Gets or sets the duration. */
    duration: number;
    /** Gets or sets the patient token. */
    patientToken?: string | undefined;
    /** Gets or sets the insurance identifier. */
    insuranceId?: number | undefined;
    /** Gets or sets the location. */
    location: ConsultationLocation;
    /** Gets or sets the status. */
    status: ConsultationStatus;
    /** Gets or sets the payment status. */
    paymentStatus: PaymentStatus;
    /** Gets or sets the medical office identifier. */
    medicalOfficeId?: number | undefined;
}

/** Contains the definition of an object of type ConsultationUpdate. */
export class ConsultationUpdate extends ConsultationBasicInfoEdit implements IConsultationUpdate {
    /** Gets or sets the cancellation date. */
    cancellationDate!: Date;

    constructor(data?: IConsultationUpdate) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.cancellationDate = _data["cancellationDate"] ? new Date(_data["cancellationDate"].toString()) : <any>undefined;
        }
    }

    static override fromJS(data: any): ConsultationUpdate {
        data = typeof data === 'object' ? data : {};
        let result = new ConsultationUpdate();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cancellationDate"] = this.cancellationDate ? this.cancellationDate.toISOString() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type ConsultationUpdate. */
export interface IConsultationUpdate extends IConsultationBasicInfoEdit {
    /** Gets or sets the cancellation date. */
    cancellationDate: Date;
}

/** Contains the definition of an object of type ConsultationCreation. */
export class ConsultationCreation extends ConsultationBasicInfoEdit implements IConsultationCreation {
    /** Gets or sets the acute treatment. */
    acuteTreatment?: string | undefined;
    /** Gets or sets the consultation reason identifier. */
    consultationReasonId?: number | undefined;
    /** Gets or sets the diseases. */
    diseases?: ConsultationDisease[] | undefined;
    /** Gets or sets the formularies. */
    formularies?: ConsultInFormularyVersion[] | undefined;
    /** Gets or sets the patient comments. */
    patientComments?: string | undefined;
    /** Gets or sets the sleep diary begin. */
    sleepDiaryBegin?: Date | undefined;
    /** Gets or sets a value indicating whether the patient has already confirmed the consultation */
    patientAlreadyConfirmed?: boolean | undefined;
    /** Gets or sets a value indicating whether to add to waiting list. */
    inWaitingList!: boolean;

    constructor(data?: IConsultationCreation) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.acuteTreatment = _data["acuteTreatment"];
            this.consultationReasonId = _data["consultationReasonId"];
            if (Array.isArray(_data["diseases"])) {
                this.diseases = [] as any;
                for (let item of _data["diseases"])
                    this.diseases!.push(ConsultationDisease.fromJS(item));
            }
            if (Array.isArray(_data["formularies"])) {
                this.formularies = [] as any;
                for (let item of _data["formularies"])
                    this.formularies!.push(ConsultInFormularyVersion.fromJS(item));
            }
            this.patientComments = _data["patientComments"];
            this.sleepDiaryBegin = _data["sleepDiaryBegin"] ? new Date(_data["sleepDiaryBegin"].toString()) : <any>undefined;
            this.patientAlreadyConfirmed = _data["patientAlreadyConfirmed"];
            this.inWaitingList = _data["inWaitingList"];
        }
    }

    static override fromJS(data: any): ConsultationCreation {
        data = typeof data === 'object' ? data : {};
        let result = new ConsultationCreation();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["acuteTreatment"] = this.acuteTreatment;
        data["consultationReasonId"] = this.consultationReasonId;
        if (Array.isArray(this.diseases)) {
            data["diseases"] = [];
            for (let item of this.diseases)
                data["diseases"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.formularies)) {
            data["formularies"] = [];
            for (let item of this.formularies)
                data["formularies"].push(item ? item.toJSON() : <any>undefined);
        }
        data["patientComments"] = this.patientComments;
        data["sleepDiaryBegin"] = this.sleepDiaryBegin ? this.sleepDiaryBegin.toISOString() : <any>undefined;
        data["patientAlreadyConfirmed"] = this.patientAlreadyConfirmed;
        data["inWaitingList"] = this.inWaitingList;
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type ConsultationCreation. */
export interface IConsultationCreation extends IConsultationBasicInfoEdit {
    /** Gets or sets the acute treatment. */
    acuteTreatment?: string | undefined;
    /** Gets or sets the consultation reason identifier. */
    consultationReasonId?: number | undefined;
    /** Gets or sets the diseases. */
    diseases?: ConsultationDisease[] | undefined;
    /** Gets or sets the formularies. */
    formularies?: ConsultInFormularyVersion[] | undefined;
    /** Gets or sets the patient comments. */
    patientComments?: string | undefined;
    /** Gets or sets the sleep diary begin. */
    sleepDiaryBegin?: Date | undefined;
    /** Gets or sets a value indicating whether the patient has already confirmed the consultation */
    patientAlreadyConfirmed?: boolean | undefined;
    /** Gets or sets a value indicating whether to add to waiting list. */
    inWaitingList: boolean;
}

/** Contains the definition of an object of type ConsultationDisease. */
export class ConsultationDisease implements IConsultationDisease {
    /** Gets or sets the consultation identifier. */
    consultationId!: number;
    /** Gets or sets the disease identifier. */
    diseaseId!: number;

    constructor(data?: IConsultationDisease) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.consultationId = _data["consultationId"];
            this.diseaseId = _data["diseaseId"];
        }
    }

    static fromJS(data: any): ConsultationDisease {
        data = typeof data === 'object' ? data : {};
        let result = new ConsultationDisease();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["consultationId"] = this.consultationId;
        data["diseaseId"] = this.diseaseId;
        return data;
    }
}

/** Contains the definition of an object of type ConsultationDisease. */
export interface IConsultationDisease {
    /** Gets or sets the consultation identifier. */
    consultationId: number;
    /** Gets or sets the disease identifier. */
    diseaseId: number;
}

/** Contains the definition of an object of type ConsultationInformationUpdate. */
export class ConsultationInformationUpdate extends ConsultationBaseEdit implements IConsultationInformationUpdate {
    /** Gets or sets the acute treatment. */
    acuteTreatment?: string | undefined;
    /** Gets or sets the consultation config identifier. */
    consultationConfigId!: number;
    /** Gets or sets the consultation reason identifier. */
    consultationReasonId!: number;
    /** Gets or sets the diseases. */
    diseases?: ConsultationDisease[] | undefined;
    /** Gets or sets the patient comments. */
    patientComments?: string | undefined;

    constructor(data?: IConsultationInformationUpdate) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.acuteTreatment = _data["acuteTreatment"];
            this.consultationConfigId = _data["consultationConfigId"];
            this.consultationReasonId = _data["consultationReasonId"];
            if (Array.isArray(_data["diseases"])) {
                this.diseases = [] as any;
                for (let item of _data["diseases"])
                    this.diseases!.push(ConsultationDisease.fromJS(item));
            }
            this.patientComments = _data["patientComments"];
        }
    }

    static override fromJS(data: any): ConsultationInformationUpdate {
        data = typeof data === 'object' ? data : {};
        let result = new ConsultationInformationUpdate();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["acuteTreatment"] = this.acuteTreatment;
        data["consultationConfigId"] = this.consultationConfigId;
        data["consultationReasonId"] = this.consultationReasonId;
        if (Array.isArray(this.diseases)) {
            data["diseases"] = [];
            for (let item of this.diseases)
                data["diseases"].push(item ? item.toJSON() : <any>undefined);
        }
        data["patientComments"] = this.patientComments;
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type ConsultationInformationUpdate. */
export interface IConsultationInformationUpdate extends IConsultationBaseEdit {
    /** Gets or sets the acute treatment. */
    acuteTreatment?: string | undefined;
    /** Gets or sets the consultation config identifier. */
    consultationConfigId: number;
    /** Gets or sets the consultation reason identifier. */
    consultationReasonId: number;
    /** Gets or sets the diseases. */
    diseases?: ConsultationDisease[] | undefined;
    /** Gets or sets the patient comments. */
    patientComments?: string | undefined;
}

/** Contains the definition of an object of type ConsultationReasonBaseEdit. */
export class ConsultationReasonBaseEdit implements IConsultationReasonBaseEdit {
    /** Gets or sets the name. */
    name?: string | undefined;
    /** Gets or sets a value indicating whether this instance is default insurance reason. */
    isDefaultInsuranceReason!: boolean;
    /** Gets or sets the prescriptions. */
    prescriptions?: SuggestibleSuggestibleSourceInfo[] | undefined;
    /** Gets or sets a value indicating whether this instance is active. */
    isArchived!: boolean;

    constructor(data?: IConsultationReasonBaseEdit) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.isDefaultInsuranceReason = _data["isDefaultInsuranceReason"];
            if (Array.isArray(_data["prescriptions"])) {
                this.prescriptions = [] as any;
                for (let item of _data["prescriptions"])
                    this.prescriptions!.push(SuggestibleSuggestibleSourceInfo.fromJS(item));
            }
            this.isArchived = _data["isArchived"];
        }
    }

    static fromJS(data: any): ConsultationReasonBaseEdit {
        data = typeof data === 'object' ? data : {};
        let result = new ConsultationReasonBaseEdit();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["isDefaultInsuranceReason"] = this.isDefaultInsuranceReason;
        if (Array.isArray(this.prescriptions)) {
            data["prescriptions"] = [];
            for (let item of this.prescriptions)
                data["prescriptions"].push(item ? item.toJSON() : <any>undefined);
        }
        data["isArchived"] = this.isArchived;
        return data;
    }
}

/** Contains the definition of an object of type ConsultationReasonBaseEdit. */
export interface IConsultationReasonBaseEdit {
    /** Gets or sets the name. */
    name?: string | undefined;
    /** Gets or sets a value indicating whether this instance is default insurance reason. */
    isDefaultInsuranceReason: boolean;
    /** Gets or sets the prescriptions. */
    prescriptions?: SuggestibleSuggestibleSourceInfo[] | undefined;
    /** Gets or sets a value indicating whether this instance is active. */
    isArchived: boolean;
}

/** Contains the definition of an object of type UpdateConsultationReason. */
export class UpdateConsultationReason extends ConsultationReasonBaseEdit implements IUpdateConsultationReason {
    /** Gets or sets the identifier. */
    id!: number;

    constructor(data?: IUpdateConsultationReason) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
        }
    }

    static override fromJS(data: any): UpdateConsultationReason {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateConsultationReason();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type UpdateConsultationReason. */
export interface IUpdateConsultationReason extends IConsultationReasonBaseEdit {
    /** Gets or sets the identifier. */
    id: number;
}

/** Contains the definition of an object of type SuggestibleSuggestibleSourceInfo. */
export class SuggestibleSuggestibleSourceInfo implements ISuggestibleSuggestibleSourceInfo {
    /** Gets or sets the type of the suggestible. */
    suggestibleType!: SuggestibleType;
    /** Gets or sets the type of the suggestible source. */
    suggestibleSourceType!: SuggestibleSourceType;
    /** Gets or sets the entity identifier. */
    entityId!: number;

    constructor(data?: ISuggestibleSuggestibleSourceInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.suggestibleType = _data["suggestibleType"];
            this.suggestibleSourceType = _data["suggestibleSourceType"];
            this.entityId = _data["EntityId"];
        }
    }

    static fromJS(data: any): SuggestibleSuggestibleSourceInfo {
        data = typeof data === 'object' ? data : {};
        let result = new SuggestibleSuggestibleSourceInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["suggestibleType"] = this.suggestibleType;
        data["suggestibleSourceType"] = this.suggestibleSourceType;
        data["EntityId"] = this.entityId;
        return data;
    }
}

/** Contains the definition of an object of type SuggestibleSuggestibleSourceInfo. */
export interface ISuggestibleSuggestibleSourceInfo {
    /** Gets or sets the type of the suggestible. */
    suggestibleType: SuggestibleType;
    /** Gets or sets the type of the suggestible source. */
    suggestibleSourceType: SuggestibleSourceType;
    /** Gets or sets the entity identifier. */
    entityId: number;
}

export class StatusValueResourceOfNullableDecimal implements IStatusValueResourceOfNullableDecimal {
    status!: ResponseStatus;
    value?: number | undefined;

    constructor(data?: IStatusValueResourceOfNullableDecimal) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): StatusValueResourceOfNullableDecimal {
        data = typeof data === 'object' ? data : {};
        let result = new StatusValueResourceOfNullableDecimal();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["value"] = this.value;
        return data;
    }
}

export interface IStatusValueResourceOfNullableDecimal {
    status: ResponseStatus;
    value?: number | undefined;
}

/** Contains the definition of an object of type ConsultationAutoUpdateStatusInfo. */
export class ConsultationAutoUpdateStatusInfo implements IConsultationAutoUpdateStatusInfo {
    /** Gets or sets the consultation identifier. */
    consultationId!: number;
    /** Gets or sets the number of member in the room. */
    membersInTheRoomCount!: number;

    constructor(data?: IConsultationAutoUpdateStatusInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.consultationId = _data["consultationId"];
            this.membersInTheRoomCount = _data["membersInTheRoomCount"];
        }
    }

    static fromJS(data: any): ConsultationAutoUpdateStatusInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ConsultationAutoUpdateStatusInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["consultationId"] = this.consultationId;
        data["membersInTheRoomCount"] = this.membersInTheRoomCount;
        return data;
    }
}

/** Contains the definition of an object of type ConsultationAutoUpdateStatusInfo. */
export interface IConsultationAutoUpdateStatusInfo {
    /** Gets or sets the consultation identifier. */
    consultationId: number;
    /** Gets or sets the number of member in the room. */
    membersInTheRoomCount: number;
}

/** Contains the definition of an object of type UpdateConsultationDocumentTemplate. */
export class UpdateConsultationDocumentTemplate implements IUpdateConsultationDocumentTemplate {
    /** Gets or sets the identifier. */
    id!: number;
    /** Gets or sets the answers.
             */
    answers?: ConsultationDocumentTemplateAnswer[] | undefined;

    constructor(data?: IUpdateConsultationDocumentTemplate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["answers"])) {
                this.answers = [] as any;
                for (let item of _data["answers"])
                    this.answers!.push(ConsultationDocumentTemplateAnswer.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateConsultationDocumentTemplate {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateConsultationDocumentTemplate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.answers)) {
            data["answers"] = [];
            for (let item of this.answers)
                data["answers"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

/** Contains the definition of an object of type UpdateConsultationDocumentTemplate. */
export interface IUpdateConsultationDocumentTemplate {
    /** Gets or sets the identifier. */
    id: number;
    /** Gets or sets the answers.
             */
    answers?: ConsultationDocumentTemplateAnswer[] | undefined;
}

/** Contains the definition of an object of type UpdateInformationModel. */
export class UpdateInformationModel implements IUpdateInformationModel {
    /** Gets or sets the consultation id. */
    consultationId!: number;
    /** Gets or sets the consultation's information. */
    information?: string | undefined;

    constructor(data?: IUpdateInformationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.consultationId = _data["consultationId"];
            this.information = _data["information"];
        }
    }

    static fromJS(data: any): UpdateInformationModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateInformationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["consultationId"] = this.consultationId;
        data["information"] = this.information;
        return data;
    }
}

/** Contains the definition of an object of type UpdateInformationModel. */
export interface IUpdateInformationModel {
    /** Gets or sets the consultation id. */
    consultationId: number;
    /** Gets or sets the consultation's information. */
    information?: string | undefined;
}

/** Contains the definition of an object of type ConsultationSummary. */
export class ConsultationSummary implements IConsultationSummary {
    /** Gets or sets the consultation id */
    consultationId!: number;
    /** Gets or sets the summary. */
    summary?: string | undefined;
    /** Gets or sets the tag. */
    tag?: string | undefined;

    constructor(data?: IConsultationSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.consultationId = _data["consultationId"];
            this.summary = _data["summary"];
            this.tag = _data["tag"];
        }
    }

    static fromJS(data: any): ConsultationSummary {
        data = typeof data === 'object' ? data : {};
        let result = new ConsultationSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["consultationId"] = this.consultationId;
        data["summary"] = this.summary;
        data["tag"] = this.tag;
        return data;
    }
}

/** Contains the definition of an object of type ConsultationSummary. */
export interface IConsultationSummary {
    /** Gets or sets the consultation id */
    consultationId: number;
    /** Gets or sets the summary. */
    summary?: string | undefined;
    /** Gets or sets the tag. */
    tag?: string | undefined;
}

/** Contains the definition of an object of type SendDocsParams. */
export class SendDocsParams implements ISendDocsParams {
    /** Gets or sets the consultation identifier. */
    consultationId?: number | undefined;
    /** Gets or sets the entity identifier. */
    entityId?: number | undefined;
    /** Gets or sets the group identifier. */
    groupId?: number | undefined;
    /** Gets or sets the consultation document template identifier. */
    consultationDocumentTemplateId?: number | undefined;
    /** Gets or sets the prescription type. */
    prescriptionType?: PrescriptionType | undefined;
    /** Gets or sets the item of consultation prescription identifier. Like biological exam item id, complementary exam item id, orientations, ... */
    prescriptionItemId?: number | undefined;
    /** Gets or sets the document identifier. */
    documentId?: number | undefined;

    constructor(data?: ISendDocsParams) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.consultationId = _data["consultationId"];
            this.entityId = _data["entityId"];
            this.groupId = _data["groupId"];
            this.consultationDocumentTemplateId = _data["consultationDocumentTemplateId"];
            this.prescriptionType = _data["prescriptionType"];
            this.prescriptionItemId = _data["prescriptionItemId"];
            this.documentId = _data["documentId"];
        }
    }

    static fromJS(data: any): SendDocsParams {
        data = typeof data === 'object' ? data : {};
        let result = new SendDocsParams();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["consultationId"] = this.consultationId;
        data["entityId"] = this.entityId;
        data["groupId"] = this.groupId;
        data["consultationDocumentTemplateId"] = this.consultationDocumentTemplateId;
        data["prescriptionType"] = this.prescriptionType;
        data["prescriptionItemId"] = this.prescriptionItemId;
        data["documentId"] = this.documentId;
        return data;
    }
}

/** Contains the definition of an object of type SendDocsParams. */
export interface ISendDocsParams {
    /** Gets or sets the consultation identifier. */
    consultationId?: number | undefined;
    /** Gets or sets the entity identifier. */
    entityId?: number | undefined;
    /** Gets or sets the group identifier. */
    groupId?: number | undefined;
    /** Gets or sets the consultation document template identifier. */
    consultationDocumentTemplateId?: number | undefined;
    /** Gets or sets the prescription type. */
    prescriptionType?: PrescriptionType | undefined;
    /** Gets or sets the item of consultation prescription identifier. Like biological exam item id, complementary exam item id, orientations, ... */
    prescriptionItemId?: number | undefined;
    /** Gets or sets the document identifier. */
    documentId?: number | undefined;
}

/** Contains the definition of an object of type ConsultationNutritionalSupplementBaseModel. */
export class ConsultationNutritionalSupplementBaseModel implements IConsultationNutritionalSupplementBaseModel {
    /** Gets or sets the consultation identifier. */
    consultationId!: number;
    /** Gets or sets the nutritional supplement. */
    nutritionalSupplementId!: number;

    constructor(data?: IConsultationNutritionalSupplementBaseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.consultationId = _data["consultationId"];
            this.nutritionalSupplementId = _data["nutritionalSupplementId"];
        }
    }

    static fromJS(data: any): ConsultationNutritionalSupplementBaseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ConsultationNutritionalSupplementBaseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["consultationId"] = this.consultationId;
        data["nutritionalSupplementId"] = this.nutritionalSupplementId;
        return data;
    }
}

/** Contains the definition of an object of type ConsultationNutritionalSupplementBaseModel. */
export interface IConsultationNutritionalSupplementBaseModel {
    /** Gets or sets the consultation identifier. */
    consultationId: number;
    /** Gets or sets the nutritional supplement. */
    nutritionalSupplementId: number;
}

/** Contains the definition of an object of type CreateConsultationNutritionalSupplement. */
export class CreateConsultationNutritionalSupplement extends ConsultationNutritionalSupplementBaseModel implements ICreateConsultationNutritionalSupplement {

    constructor(data?: ICreateConsultationNutritionalSupplement) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): CreateConsultationNutritionalSupplement {
        data = typeof data === 'object' ? data : {};
        let result = new CreateConsultationNutritionalSupplement();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type CreateConsultationNutritionalSupplement. */
export interface ICreateConsultationNutritionalSupplement extends IConsultationNutritionalSupplementBaseModel {
}

/** Contains the definition of an object of type ConsultationSuggestion. */
export class ConsultationSuggestionCreator implements IConsultationSuggestionCreator {
    /** Gets or sets the consultation identifier. */
    consultationId!: number;
    /** Gets or sets the suggestion identifier. */
    suggestionId!: number;

    constructor(data?: IConsultationSuggestionCreator) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.consultationId = _data["consultationId"];
            this.suggestionId = _data["suggestionId"];
        }
    }

    static fromJS(data: any): ConsultationSuggestionCreator {
        data = typeof data === 'object' ? data : {};
        let result = new ConsultationSuggestionCreator();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["consultationId"] = this.consultationId;
        data["suggestionId"] = this.suggestionId;
        return data;
    }
}

/** Contains the definition of an object of type ConsultationSuggestion. */
export interface IConsultationSuggestionCreator {
    /** Gets or sets the consultation identifier. */
    consultationId: number;
    /** Gets or sets the suggestion identifier. */
    suggestionId: number;
}

/** Contains the definition of an object of type ConsultationSelectionInformation. */
export class ConsultationSelectionInformation implements IConsultationSelectionInformation {
    /** Gets or sets a value indicating whether this instance is new empty prescription. */
    isNewEmptyPrescription!: boolean;
    /** Gets or sets a value indicating whether this instance is new empty prescription models. */
    isNewEmptyPrescriptionModels!: boolean;
    /** Gets or sets a value indicating whether this instance is new empty compelmntary exam. */
    isNewEmptyComplementaryExam!: boolean;
    /** Gets or sets a value indicating whether this instance is new empty biological exam. */
    isNewEmptyBiologicalExam!: boolean;
    /** Gets or sets a value indicating whether this instance is new empty consultation type. */
    isNewEmptyConsultationType!: boolean;
    /** Gets or sets a value indicating whether this instance is new empty nutritional supplement. */
    isNewEmptyNutritionalSupplement!: boolean;
    /** Gets or sets the number complementary exam selected. */
    numberComplementaryExamSelected!: number;
    /** Gets or sets the number biological exam selected. */
    numberBiologicalExamSelected!: number;
    /** Gets or sets the number biological exam set selected. */
    numberBiologicalExamSetSelected!: number;
    /** Gets or sets the number activity selected. */
    numberActivitySelected!: number;
    /** Gets or sets the number suggestion selected. */
    numberSuggestionSelectedFood!: number;
    /** Gets or sets the number suggestion selected. */
    numberSuggestionSelectedLifeStyle!: number;
    /** Gets or sets the number consultation type selected. */
    numberConsultationTypeSelected!: number;
    /** Gets or sets the number formulary selected. */
    numberFormularySelected!: number;
    /** Gets or sets the number nutritional supplement selected. */
    numberNutritionalSupplementSelected!: number;
    /** Gets or sets the number send box selected item. */
    numberSendBoxSelectedItem!: number;
    /** Gets or sets the number document send by doctor. */
    numberDocumentSendByDoctor!: number;
    /** Gets or sets the NumberDocumentTemplateModels . */
    numberDocumentTemplateModels!: number;
    /** Gets or sets the number document send by patient. */
    numberDocumentSendByPatient!: number;
    /** Gets or sets the number recipe selected. */
    numberRecipeSelected!: number;
    /** Gets or sets the number of message not seen. */
    numberMessagesNotSeen!: number;
    /** Gets or sets the number nutrition programs selected. */
    numberNutritionProgramsSelected!: number;

    constructor(data?: IConsultationSelectionInformation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isNewEmptyPrescription = _data["isNewEmptyPrescription"];
            this.isNewEmptyPrescriptionModels = _data["isNewEmptyPrescriptionModels"];
            this.isNewEmptyComplementaryExam = _data["isNewEmptyComplementaryExam"];
            this.isNewEmptyBiologicalExam = _data["isNewEmptyBiologicalExam"];
            this.isNewEmptyConsultationType = _data["isNewEmptyConsultationType"];
            this.isNewEmptyNutritionalSupplement = _data["isNewEmptyNutritionalSupplement"];
            this.numberComplementaryExamSelected = _data["numberComplementaryExamSelected"];
            this.numberBiologicalExamSelected = _data["numberBiologicalExamSelected"];
            this.numberBiologicalExamSetSelected = _data["numberBiologicalExamSetSelected"];
            this.numberActivitySelected = _data["numberActivitySelected"];
            this.numberSuggestionSelectedFood = _data["numberSuggestionSelectedFood"];
            this.numberSuggestionSelectedLifeStyle = _data["numberSuggestionSelectedLifeStyle"];
            this.numberConsultationTypeSelected = _data["numberConsultationTypeSelected"];
            this.numberFormularySelected = _data["numberFormularySelected"];
            this.numberNutritionalSupplementSelected = _data["numberNutritionalSupplementSelected"];
            this.numberSendBoxSelectedItem = _data["numberSendBoxSelectedItem"];
            this.numberDocumentSendByDoctor = _data["numberDocumentSendByDoctor"];
            this.numberDocumentTemplateModels = _data["numberDocumentTemplateModels"];
            this.numberDocumentSendByPatient = _data["numberDocumentSendByPatient"];
            this.numberRecipeSelected = _data["numberRecipeSelected"];
            this.numberMessagesNotSeen = _data["numberMessagesNotSeen"];
            this.numberNutritionProgramsSelected = _data["numberNutritionProgramsSelected"];
        }
    }

    static fromJS(data: any): ConsultationSelectionInformation {
        data = typeof data === 'object' ? data : {};
        let result = new ConsultationSelectionInformation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isNewEmptyPrescription"] = this.isNewEmptyPrescription;
        data["isNewEmptyPrescriptionModels"] = this.isNewEmptyPrescriptionModels;
        data["isNewEmptyComplementaryExam"] = this.isNewEmptyComplementaryExam;
        data["isNewEmptyBiologicalExam"] = this.isNewEmptyBiologicalExam;
        data["isNewEmptyConsultationType"] = this.isNewEmptyConsultationType;
        data["isNewEmptyNutritionalSupplement"] = this.isNewEmptyNutritionalSupplement;
        data["numberComplementaryExamSelected"] = this.numberComplementaryExamSelected;
        data["numberBiologicalExamSelected"] = this.numberBiologicalExamSelected;
        data["numberBiologicalExamSetSelected"] = this.numberBiologicalExamSetSelected;
        data["numberActivitySelected"] = this.numberActivitySelected;
        data["numberSuggestionSelectedFood"] = this.numberSuggestionSelectedFood;
        data["numberSuggestionSelectedLifeStyle"] = this.numberSuggestionSelectedLifeStyle;
        data["numberConsultationTypeSelected"] = this.numberConsultationTypeSelected;
        data["numberFormularySelected"] = this.numberFormularySelected;
        data["numberNutritionalSupplementSelected"] = this.numberNutritionalSupplementSelected;
        data["numberSendBoxSelectedItem"] = this.numberSendBoxSelectedItem;
        data["numberDocumentSendByDoctor"] = this.numberDocumentSendByDoctor;
        data["numberDocumentTemplateModels"] = this.numberDocumentTemplateModels;
        data["numberDocumentSendByPatient"] = this.numberDocumentSendByPatient;
        data["numberRecipeSelected"] = this.numberRecipeSelected;
        data["numberMessagesNotSeen"] = this.numberMessagesNotSeen;
        data["numberNutritionProgramsSelected"] = this.numberNutritionProgramsSelected;
        return data;
    }
}

/** Contains the definition of an object of type ConsultationSelectionInformation. */
export interface IConsultationSelectionInformation {
    /** Gets or sets a value indicating whether this instance is new empty prescription. */
    isNewEmptyPrescription: boolean;
    /** Gets or sets a value indicating whether this instance is new empty prescription models. */
    isNewEmptyPrescriptionModels: boolean;
    /** Gets or sets a value indicating whether this instance is new empty compelmntary exam. */
    isNewEmptyComplementaryExam: boolean;
    /** Gets or sets a value indicating whether this instance is new empty biological exam. */
    isNewEmptyBiologicalExam: boolean;
    /** Gets or sets a value indicating whether this instance is new empty consultation type. */
    isNewEmptyConsultationType: boolean;
    /** Gets or sets a value indicating whether this instance is new empty nutritional supplement. */
    isNewEmptyNutritionalSupplement: boolean;
    /** Gets or sets the number complementary exam selected. */
    numberComplementaryExamSelected: number;
    /** Gets or sets the number biological exam selected. */
    numberBiologicalExamSelected: number;
    /** Gets or sets the number biological exam set selected. */
    numberBiologicalExamSetSelected: number;
    /** Gets or sets the number activity selected. */
    numberActivitySelected: number;
    /** Gets or sets the number suggestion selected. */
    numberSuggestionSelectedFood: number;
    /** Gets or sets the number suggestion selected. */
    numberSuggestionSelectedLifeStyle: number;
    /** Gets or sets the number consultation type selected. */
    numberConsultationTypeSelected: number;
    /** Gets or sets the number formulary selected. */
    numberFormularySelected: number;
    /** Gets or sets the number nutritional supplement selected. */
    numberNutritionalSupplementSelected: number;
    /** Gets or sets the number send box selected item. */
    numberSendBoxSelectedItem: number;
    /** Gets or sets the number document send by doctor. */
    numberDocumentSendByDoctor: number;
    /** Gets or sets the NumberDocumentTemplateModels . */
    numberDocumentTemplateModels: number;
    /** Gets or sets the number document send by patient. */
    numberDocumentSendByPatient: number;
    /** Gets or sets the number recipe selected. */
    numberRecipeSelected: number;
    /** Gets or sets the number of message not seen. */
    numberMessagesNotSeen: number;
    /** Gets or sets the number nutrition programs selected. */
    numberNutritionProgramsSelected: number;
}

/** Contains the definition of an object of type ConsultationAnalysis */
export class ConsultationAnalysis implements IConsultationAnalysis {
    /** Gets or sets a value indicating whether this instance is complete. */
    isComplete!: boolean;
    /** Gets or sets a value indicating whether [patient is not linked to formulary]. */
    formularySendedToPatient!: boolean;
    /** Gets or sets a value indicating whether [questionnary exist]. */
    questionnaryExist!: boolean;

    constructor(data?: IConsultationAnalysis) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isComplete = _data["isComplete"];
            this.formularySendedToPatient = _data["formularySendedToPatient"];
            this.questionnaryExist = _data["questionnaryExist"];
        }
    }

    static fromJS(data: any): ConsultationAnalysis {
        data = typeof data === 'object' ? data : {};
        let result = new ConsultationAnalysis();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isComplete"] = this.isComplete;
        data["formularySendedToPatient"] = this.formularySendedToPatient;
        data["questionnaryExist"] = this.questionnaryExist;
        return data;
    }
}

/** Contains the definition of an object of type ConsultationAnalysis */
export interface IConsultationAnalysis {
    /** Gets or sets a value indicating whether this instance is complete. */
    isComplete: boolean;
    /** Gets or sets a value indicating whether [patient is not linked to formulary]. */
    formularySendedToPatient: boolean;
    /** Gets or sets a value indicating whether [questionnary exist]. */
    questionnaryExist: boolean;
}

/** Contains the definition of an object of type ConsultationAnalysis */
export class ConsultationAnalysisQuestions extends ConsultationAnalysis implements IConsultationAnalysisQuestions {
    /** Gets or sets the consultation analysis graphic category details. */
    consultationAnalysisGraphicCategoryDetails?: ConsultationAnalysisGraphicQuestionDetails[] | undefined;
    /** Gets or sets the consultation analysis identifier. */
    formularyId!: number;
    /** Gets or sets the date. */
    date!: Date;

    constructor(data?: IConsultationAnalysisQuestions) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["consultationAnalysisGraphicCategoryDetails"])) {
                this.consultationAnalysisGraphicCategoryDetails = [] as any;
                for (let item of _data["consultationAnalysisGraphicCategoryDetails"])
                    this.consultationAnalysisGraphicCategoryDetails!.push(ConsultationAnalysisGraphicQuestionDetails.fromJS(item));
            }
            this.formularyId = _data["formularyId"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
        }
    }

    static override fromJS(data: any): ConsultationAnalysisQuestions {
        data = typeof data === 'object' ? data : {};
        let result = new ConsultationAnalysisQuestions();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.consultationAnalysisGraphicCategoryDetails)) {
            data["consultationAnalysisGraphicCategoryDetails"] = [];
            for (let item of this.consultationAnalysisGraphicCategoryDetails)
                data["consultationAnalysisGraphicCategoryDetails"].push(item ? item.toJSON() : <any>undefined);
        }
        data["formularyId"] = this.formularyId;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type ConsultationAnalysis */
export interface IConsultationAnalysisQuestions extends IConsultationAnalysis {
    /** Gets or sets the consultation analysis graphic category details. */
    consultationAnalysisGraphicCategoryDetails?: ConsultationAnalysisGraphicQuestionDetails[] | undefined;
    /** Gets or sets the consultation analysis identifier. */
    formularyId: number;
    /** Gets or sets the date. */
    date: Date;
}

/** Contains the definition of an object of type ConsultationAnalysisGraphicQuestionDetails */
export class ConsultationAnalysisGraphicQuestionDetails implements IConsultationAnalysisGraphicQuestionDetails {
    /** Gets or sets the name of the question. */
    questionName?: string | undefined;
    /** Gets or sets the maximum value. */
    maxValue!: number;
    /** Gets or sets the value. */
    value!: number;
    /** Gets or sets the answer. */
    answer?: string | undefined;

    constructor(data?: IConsultationAnalysisGraphicQuestionDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.questionName = _data["questionName"];
            this.maxValue = _data["maxValue"];
            this.value = _data["value"];
            this.answer = _data["answer"];
        }
    }

    static fromJS(data: any): ConsultationAnalysisGraphicQuestionDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ConsultationAnalysisGraphicQuestionDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["questionName"] = this.questionName;
        data["maxValue"] = this.maxValue;
        data["value"] = this.value;
        data["answer"] = this.answer;
        return data;
    }
}

/** Contains the definition of an object of type ConsultationAnalysisGraphicQuestionDetails */
export interface IConsultationAnalysisGraphicQuestionDetails {
    /** Gets or sets the name of the question. */
    questionName?: string | undefined;
    /** Gets or sets the maximum value. */
    maxValue: number;
    /** Gets or sets the value. */
    value: number;
    /** Gets or sets the answer. */
    answer?: string | undefined;
}

/** Contains the definition of an object of type ConsultationAnalysis */
export class ConsultationAnalysisCategories extends ConsultationAnalysis implements IConsultationAnalysisCategories {
    /** Gets or sets the consultation analysis graphic categories. */
    consultationAnalysisGraphicQuestionDetails?: ConsultationAnalysisGraphicCategoryDetails[] | undefined;
    /** Gets or sets the created date. */
    date!: Date;
    /** Gets or sets a value indicating whether [more recent formulary exists but not completed]. */
    idMoreRecentFormularyButNotCompleted!: number;
    /** Gets or sets the consultation identifier more recent formulary but not completed */
    consultationIdOfFormulary!: number;
    /** Gets or sets the title. */
    title?: string | undefined;
    /** Gets or sets the consultation analysis identifier. */
    formularyId!: number;

    constructor(data?: IConsultationAnalysisCategories) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["consultationAnalysisGraphicQuestionDetails"])) {
                this.consultationAnalysisGraphicQuestionDetails = [] as any;
                for (let item of _data["consultationAnalysisGraphicQuestionDetails"])
                    this.consultationAnalysisGraphicQuestionDetails!.push(ConsultationAnalysisGraphicCategoryDetails.fromJS(item));
            }
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.idMoreRecentFormularyButNotCompleted = _data["idMoreRecentFormularyButNotCompleted"];
            this.consultationIdOfFormulary = _data["consultationIdOfFormulary"];
            this.title = _data["title"];
            this.formularyId = _data["formularyId"];
        }
    }

    static override fromJS(data: any): ConsultationAnalysisCategories {
        data = typeof data === 'object' ? data : {};
        let result = new ConsultationAnalysisCategories();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.consultationAnalysisGraphicQuestionDetails)) {
            data["consultationAnalysisGraphicQuestionDetails"] = [];
            for (let item of this.consultationAnalysisGraphicQuestionDetails)
                data["consultationAnalysisGraphicQuestionDetails"].push(item ? item.toJSON() : <any>undefined);
        }
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["idMoreRecentFormularyButNotCompleted"] = this.idMoreRecentFormularyButNotCompleted;
        data["consultationIdOfFormulary"] = this.consultationIdOfFormulary;
        data["title"] = this.title;
        data["formularyId"] = this.formularyId;
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type ConsultationAnalysis */
export interface IConsultationAnalysisCategories extends IConsultationAnalysis {
    /** Gets or sets the consultation analysis graphic categories. */
    consultationAnalysisGraphicQuestionDetails?: ConsultationAnalysisGraphicCategoryDetails[] | undefined;
    /** Gets or sets the created date. */
    date: Date;
    /** Gets or sets a value indicating whether [more recent formulary exists but not completed]. */
    idMoreRecentFormularyButNotCompleted: number;
    /** Gets or sets the consultation identifier more recent formulary but not completed */
    consultationIdOfFormulary: number;
    /** Gets or sets the title. */
    title?: string | undefined;
    /** Gets or sets the consultation analysis identifier. */
    formularyId: number;
}

/** Contains the definition of an object of type ConsultationAnalysisGraphicCategory */
export class ConsultationAnalysisGraphicCategory implements IConsultationAnalysisGraphicCategory {
    /** Gets or sets the maximum value. */
    maxValue!: number;
    /** Gets or sets the value. */
    value!: number;
    /** Gets or sets the category identifier. */
    categoryId!: number;
    /** Gets or sets the name of the category. */
    categoryName?: string | undefined;
    /** Gets or sets the percentage. */
    percentage!: number;
    /** Gets or sets the date. */
    date!: Date;

    constructor(data?: IConsultationAnalysisGraphicCategory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxValue = _data["maxValue"];
            this.value = _data["value"];
            this.categoryId = _data["categoryId"];
            this.categoryName = _data["categoryName"];
            this.percentage = _data["percentage"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ConsultationAnalysisGraphicCategory {
        data = typeof data === 'object' ? data : {};
        let result = new ConsultationAnalysisGraphicCategory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxValue"] = this.maxValue;
        data["value"] = this.value;
        data["categoryId"] = this.categoryId;
        data["categoryName"] = this.categoryName;
        data["percentage"] = this.percentage;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        return data;
    }
}

/** Contains the definition of an object of type ConsultationAnalysisGraphicCategory */
export interface IConsultationAnalysisGraphicCategory {
    /** Gets or sets the maximum value. */
    maxValue: number;
    /** Gets or sets the value. */
    value: number;
    /** Gets or sets the category identifier. */
    categoryId: number;
    /** Gets or sets the name of the category. */
    categoryName?: string | undefined;
    /** Gets or sets the percentage. */
    percentage: number;
    /** Gets or sets the date. */
    date: Date;
}

/** Contains the definition of an object of type ConsultationAnalysisGraphicCategoryDetails */
export class ConsultationAnalysisGraphicCategoryDetails extends ConsultationAnalysisGraphicCategory implements IConsultationAnalysisGraphicCategoryDetails {
    /** Gets or sets the question details. */
    questionDetails?: ConsultationAnalysisGraphicQuestionDetails[] | undefined;

    constructor(data?: IConsultationAnalysisGraphicCategoryDetails) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["questionDetails"])) {
                this.questionDetails = [] as any;
                for (let item of _data["questionDetails"])
                    this.questionDetails!.push(ConsultationAnalysisGraphicQuestionDetails.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): ConsultationAnalysisGraphicCategoryDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ConsultationAnalysisGraphicCategoryDetails();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.questionDetails)) {
            data["questionDetails"] = [];
            for (let item of this.questionDetails)
                data["questionDetails"].push(item ? item.toJSON() : <any>undefined);
        }
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type ConsultationAnalysisGraphicCategoryDetails */
export interface IConsultationAnalysisGraphicCategoryDetails extends IConsultationAnalysisGraphicCategory {
    /** Gets or sets the question details. */
    questionDetails?: ConsultationAnalysisGraphicQuestionDetails[] | undefined;
}

/** Contains the definition of an object of type CreateConsultationReason. */
export class CreateConsultationReason extends ConsultationReasonBaseEdit implements ICreateConsultationReason {

    constructor(data?: ICreateConsultationReason) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): CreateConsultationReason {
        data = typeof data === 'object' ? data : {};
        let result = new CreateConsultationReason();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type CreateConsultationReason. */
export interface ICreateConsultationReason extends IConsultationReasonBaseEdit {
}

/** Contains the definition of an object of type InsuranceConsultationCreation */
export class InsuranceConsultationCreation implements IInsuranceConsultationCreation {
    /** Gets or sets the acute treatment. */
    acuteTreatment?: string | undefined;
    /** Gets or sets the date. */
    date!: Date;
    /** Gets or sets the diseases. */
    diseases?: ConsultationDisease[] | undefined;
    /** Gets or sets the doctor identifier. */
    doctorId?: number | undefined;
    /** Gets or sets the location. */
    location!: ConsultationLocation;
    /** Gets or sets the patient comments. */
    patientComments?: string | undefined;

    constructor(data?: IInsuranceConsultationCreation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.acuteTreatment = _data["acuteTreatment"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            if (Array.isArray(_data["diseases"])) {
                this.diseases = [] as any;
                for (let item of _data["diseases"])
                    this.diseases!.push(ConsultationDisease.fromJS(item));
            }
            this.doctorId = _data["doctorId"];
            this.location = _data["location"];
            this.patientComments = _data["patientComments"];
        }
    }

    static fromJS(data: any): InsuranceConsultationCreation {
        data = typeof data === 'object' ? data : {};
        let result = new InsuranceConsultationCreation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["acuteTreatment"] = this.acuteTreatment;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        if (Array.isArray(this.diseases)) {
            data["diseases"] = [];
            for (let item of this.diseases)
                data["diseases"].push(item ? item.toJSON() : <any>undefined);
        }
        data["doctorId"] = this.doctorId;
        data["location"] = this.location;
        data["patientComments"] = this.patientComments;
        return data;
    }
}

/** Contains the definition of an object of type InsuranceConsultationCreation */
export interface IInsuranceConsultationCreation {
    /** Gets or sets the acute treatment. */
    acuteTreatment?: string | undefined;
    /** Gets or sets the date. */
    date: Date;
    /** Gets or sets the diseases. */
    diseases?: ConsultationDisease[] | undefined;
    /** Gets or sets the doctor identifier. */
    doctorId?: number | undefined;
    /** Gets or sets the location. */
    location: ConsultationLocation;
    /** Gets or sets the patient comments. */
    patientComments?: string | undefined;
}

export class StatusValueResourceOfIEnumerableOfDateTime implements IStatusValueResourceOfIEnumerableOfDateTime {
    status!: ResponseStatus;
    value?: Date[] | undefined;

    constructor(data?: IStatusValueResourceOfIEnumerableOfDateTime) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(new Date(item));
            }
        }
    }

    static fromJS(data: any): StatusValueResourceOfIEnumerableOfDateTime {
        data = typeof data === 'object' ? data : {};
        let result = new StatusValueResourceOfIEnumerableOfDateTime();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item.toISOString());
        }
        return data;
    }
}

export interface IStatusValueResourceOfIEnumerableOfDateTime {
    status: ResponseStatus;
    value?: Date[] | undefined;
}

/** Contains the definition of an object of type ConsultationAlternativeMedicine */
export class ConsultationAlternativeMedicine implements IConsultationAlternativeMedicine {
    /** Gets or sets the alternative medicine. */
    alternativeMedicine?: ConsultationType | undefined;
    /** Gets or sets the consultation type identifier. */
    alternativeMedicineId!: number;
    /** Gets or sets the consultation identifier. */
    consultationId!: number;
    /** Gets or sets a value indicating whether this instance is active. */
    isActive!: boolean;
    /** Gets or sets a value indicating whether this ConsultationAlternativeMedicine is sent. */
    sent!: boolean;
    /** Gets or sets the sending date. */
    sendingDate?: Date | undefined;
    /** Gets or sets the reasons. */
    sources?: Disease[] | undefined;

    constructor(data?: IConsultationAlternativeMedicine) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.alternativeMedicine = _data["alternativeMedicine"] ? ConsultationType.fromJS(_data["alternativeMedicine"]) : <any>undefined;
            this.alternativeMedicineId = _data["alternativeMedicineId"];
            this.consultationId = _data["consultationId"];
            this.isActive = _data["isActive"];
            this.sent = _data["sent"];
            this.sendingDate = _data["sendingDate"] ? new Date(_data["sendingDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["sources"])) {
                this.sources = [] as any;
                for (let item of _data["sources"])
                    this.sources!.push(Disease.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ConsultationAlternativeMedicine {
        data = typeof data === 'object' ? data : {};
        let result = new ConsultationAlternativeMedicine();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["alternativeMedicine"] = this.alternativeMedicine ? this.alternativeMedicine.toJSON() : <any>undefined;
        data["alternativeMedicineId"] = this.alternativeMedicineId;
        data["consultationId"] = this.consultationId;
        data["isActive"] = this.isActive;
        data["sent"] = this.sent;
        data["sendingDate"] = this.sendingDate ? this.sendingDate.toISOString() : <any>undefined;
        if (Array.isArray(this.sources)) {
            data["sources"] = [];
            for (let item of this.sources)
                data["sources"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

/** Contains the definition of an object of type ConsultationAlternativeMedicine */
export interface IConsultationAlternativeMedicine {
    /** Gets or sets the alternative medicine. */
    alternativeMedicine?: ConsultationType | undefined;
    /** Gets or sets the consultation type identifier. */
    alternativeMedicineId: number;
    /** Gets or sets the consultation identifier. */
    consultationId: number;
    /** Gets or sets a value indicating whether this instance is active. */
    isActive: boolean;
    /** Gets or sets a value indicating whether this ConsultationAlternativeMedicine is sent. */
    sent: boolean;
    /** Gets or sets the sending date. */
    sendingDate?: Date | undefined;
    /** Gets or sets the reasons. */
    sources?: Disease[] | undefined;
}

/** Contains the definition of an object of type AvailabilityParam. */
export class AvailabilityParam implements IAvailabilityParam {
    /** Gets or sets the acute treatment. */
    consultationConfigId!: number;
    /** Gets or sets the acute treatment. */
    numberOfDays!: number;
    /** Gets or sets the acute treatment. */
    firstDay?: Date | undefined;
    /** Gets or sets the doctor's identifier. */
    doctorId!: number;
    /** Gets or sets the medical office's identifier. */
    medicalOfficeId?: number | undefined;
    /** Gets or sets the consultation id. */
    consultationId?: number | undefined;

    constructor(data?: IAvailabilityParam) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.consultationConfigId = _data["consultationConfigId"];
            this.numberOfDays = _data["numberOfDays"];
            this.firstDay = _data["firstDay"] ? new Date(_data["firstDay"].toString()) : <any>undefined;
            this.doctorId = _data["doctorId"];
            this.medicalOfficeId = _data["medicalOfficeId"];
            this.consultationId = _data["consultationId"];
        }
    }

    static fromJS(data: any): AvailabilityParam {
        data = typeof data === 'object' ? data : {};
        let result = new AvailabilityParam();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["consultationConfigId"] = this.consultationConfigId;
        data["numberOfDays"] = this.numberOfDays;
        data["firstDay"] = this.firstDay ? this.firstDay.toISOString() : <any>undefined;
        data["doctorId"] = this.doctorId;
        data["medicalOfficeId"] = this.medicalOfficeId;
        data["consultationId"] = this.consultationId;
        return data;
    }
}

/** Contains the definition of an object of type AvailabilityParam. */
export interface IAvailabilityParam {
    /** Gets or sets the acute treatment. */
    consultationConfigId: number;
    /** Gets or sets the acute treatment. */
    numberOfDays: number;
    /** Gets or sets the acute treatment. */
    firstDay?: Date | undefined;
    /** Gets or sets the doctor's identifier. */
    doctorId: number;
    /** Gets or sets the medical office's identifier. */
    medicalOfficeId?: number | undefined;
    /** Gets or sets the consultation id. */
    consultationId?: number | undefined;
}

/** Contains the definition of an object of type ConsultationConfigLite */
export class ConsultationConfigLite implements IConsultationConfigLite {
    /** Gets or sets the consultation configuration identifier. */
    consultationConfigId!: number;
    /** Gets or sets the location. */
    consultationLocation!: ConsultationLocation;
    /** Gets or sets the location list. */
    locations?: ConsultationConfigLocation[] | undefined;
    /** Gets or sets the name of the consultation configuration name. */
    consultationConfigName?: string | undefined;
    /** Gets or sets the name of the consultation type. */
    consultationTypeName?: string | undefined;
    /** Gets or sets the name of the consultation type id. */
    consultationTypeId!: number;
    /** Gets or sets the name of the consultation sub type id. */
    consultationSubTypeId?: number | undefined;
    /** Gets or sets the name of the consultation sub type name. */
    consultationSubTypeName?: string | undefined;
    /** Gets or sets the price of the consultation. */
    price?: number | undefined;
    /** Gets or sets a value indicating whether the remote is active. */
    isRemoteActive!: boolean;

    constructor(data?: IConsultationConfigLite) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.consultationConfigId = _data["consultationConfigId"];
            this.consultationLocation = _data["consultationLocation"];
            if (Array.isArray(_data["locations"])) {
                this.locations = [] as any;
                for (let item of _data["locations"])
                    this.locations!.push(ConsultationConfigLocation.fromJS(item));
            }
            this.consultationConfigName = _data["consultationConfigName"];
            this.consultationTypeName = _data["consultationTypeName"];
            this.consultationTypeId = _data["consultationTypeId"];
            this.consultationSubTypeId = _data["consultationSubTypeId"];
            this.consultationSubTypeName = _data["consultationSubTypeName"];
            this.price = _data["price"];
            this.isRemoteActive = _data["isRemoteActive"];
        }
    }

    static fromJS(data: any): ConsultationConfigLite {
        data = typeof data === 'object' ? data : {};
        let result = new ConsultationConfigLite();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["consultationConfigId"] = this.consultationConfigId;
        data["consultationLocation"] = this.consultationLocation;
        if (Array.isArray(this.locations)) {
            data["locations"] = [];
            for (let item of this.locations)
                data["locations"].push(item ? item.toJSON() : <any>undefined);
        }
        data["consultationConfigName"] = this.consultationConfigName;
        data["consultationTypeName"] = this.consultationTypeName;
        data["consultationTypeId"] = this.consultationTypeId;
        data["consultationSubTypeId"] = this.consultationSubTypeId;
        data["consultationSubTypeName"] = this.consultationSubTypeName;
        data["price"] = this.price;
        data["isRemoteActive"] = this.isRemoteActive;
        return data;
    }
}

/** Contains the definition of an object of type ConsultationConfigLite */
export interface IConsultationConfigLite {
    /** Gets or sets the consultation configuration identifier. */
    consultationConfigId: number;
    /** Gets or sets the location. */
    consultationLocation: ConsultationLocation;
    /** Gets or sets the location list. */
    locations?: ConsultationConfigLocation[] | undefined;
    /** Gets or sets the name of the consultation configuration name. */
    consultationConfigName?: string | undefined;
    /** Gets or sets the name of the consultation type. */
    consultationTypeName?: string | undefined;
    /** Gets or sets the name of the consultation type id. */
    consultationTypeId: number;
    /** Gets or sets the name of the consultation sub type id. */
    consultationSubTypeId?: number | undefined;
    /** Gets or sets the name of the consultation sub type name. */
    consultationSubTypeName?: string | undefined;
    /** Gets or sets the price of the consultation. */
    price?: number | undefined;
    /** Gets or sets a value indicating whether the remote is active. */
    isRemoteActive: boolean;
}

/** Contains the definition of an object of type Notification */
export class Notification implements INotification {
    /** Gets or sets the type. */
    type!: NotificationType;
    /** Gets or sets the profile picture URL. */
    profilePictureUrl?: string | undefined;
    /** Gets or sets the name. */
    patientLastName?: string | undefined;
    /** Gets or sets the first name. */
    patientFirstName?: string | undefined;
    /** Gets or sets the motif de consultation. */
    configName?: string | undefined;
    /** Gets or sets the color of the motif. */
    configColor?: string | undefined;
    /** Gets or sets the consultation status. */
    consultationStatus!: ConsultationStatus;
    /** Gets or sets the tag. */
    tag?: string | undefined;
    /** Gets or sets the consultation identifier. */
    consultationId!: number;
    /** Gets or sets the patient identifier. */
    patientId!: number;
    /** Gets or sets a value indicating whether [does remote consultation]. */
    doesRemoteConsultation!: boolean;
    /** Gets or sets the consultation date. */
    date!: Date;

    constructor(data?: INotification) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.profilePictureUrl = _data["profilePictureUrl"];
            this.patientLastName = _data["patientLastName"];
            this.patientFirstName = _data["patientFirstName"];
            this.configName = _data["configName"];
            this.configColor = _data["configColor"];
            this.consultationStatus = _data["consultationStatus"];
            this.tag = _data["tag"];
            this.consultationId = _data["consultationId"];
            this.patientId = _data["patientId"];
            this.doesRemoteConsultation = _data["doesRemoteConsultation"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): Notification {
        data = typeof data === 'object' ? data : {};
        let result = new Notification();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["profilePictureUrl"] = this.profilePictureUrl;
        data["patientLastName"] = this.patientLastName;
        data["patientFirstName"] = this.patientFirstName;
        data["configName"] = this.configName;
        data["configColor"] = this.configColor;
        data["consultationStatus"] = this.consultationStatus;
        data["tag"] = this.tag;
        data["consultationId"] = this.consultationId;
        data["patientId"] = this.patientId;
        data["doesRemoteConsultation"] = this.doesRemoteConsultation;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        return data;
    }
}

/** Contains the definition of an object of type Notification */
export interface INotification {
    /** Gets or sets the type. */
    type: NotificationType;
    /** Gets or sets the profile picture URL. */
    profilePictureUrl?: string | undefined;
    /** Gets or sets the name. */
    patientLastName?: string | undefined;
    /** Gets or sets the first name. */
    patientFirstName?: string | undefined;
    /** Gets or sets the motif de consultation. */
    configName?: string | undefined;
    /** Gets or sets the color of the motif. */
    configColor?: string | undefined;
    /** Gets or sets the consultation status. */
    consultationStatus: ConsultationStatus;
    /** Gets or sets the tag. */
    tag?: string | undefined;
    /** Gets or sets the consultation identifier. */
    consultationId: number;
    /** Gets or sets the patient identifier. */
    patientId: number;
    /** Gets or sets a value indicating whether [does remote consultation]. */
    doesRemoteConsultation: boolean;
    /** Gets or sets the consultation date. */
    date: Date;
}

/** Contains the definition of an object of type NotificationType. */
export enum NotificationType {
    Unknown = 0,
    InConsultation = 1,
    InWaitingRoom = 2,
    ConsultationNotClosed = 3,
    InComing = 4,
    ToBeConfirmed = 5,
}

export class StatusValueResourceOfConsultationDetails implements IStatusValueResourceOfConsultationDetails {
    status!: ResponseStatus;
    value?: ConsultationDetails | undefined;

    constructor(data?: IStatusValueResourceOfConsultationDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.value = _data["value"] ? ConsultationDetails.fromJS(_data["value"]) : <any>undefined;
        }
    }

    static fromJS(data: any): StatusValueResourceOfConsultationDetails {
        data = typeof data === 'object' ? data : {};
        let result = new StatusValueResourceOfConsultationDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["value"] = this.value ? this.value.toJSON() : <any>undefined;
        return data;
    }
}

export interface IStatusValueResourceOfConsultationDetails {
    status: ResponseStatus;
    value?: ConsultationDetails | undefined;
}

/** Contains the definition of an object of type ConsultationDetails. */
export class ConsultationDetails extends Consultation implements IConsultationDetails {
    /** Gets or sets the diseases. */
    diseases?: Disease[] | undefined;
    /** Gets or sets the formularies. */
    formularies?: ConsultInFormularyVersion[] | undefined;
    /** Gets or sets the consultation suggestible sources. */
    consultationSuggestibleSources?: ConsultationSuggestibleSource[] | undefined;

    constructor(data?: IConsultationDetails) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["diseases"])) {
                this.diseases = [] as any;
                for (let item of _data["diseases"])
                    this.diseases!.push(Disease.fromJS(item));
            }
            if (Array.isArray(_data["formularies"])) {
                this.formularies = [] as any;
                for (let item of _data["formularies"])
                    this.formularies!.push(ConsultInFormularyVersion.fromJS(item));
            }
            if (Array.isArray(_data["consultationSuggestibleSources"])) {
                this.consultationSuggestibleSources = [] as any;
                for (let item of _data["consultationSuggestibleSources"])
                    this.consultationSuggestibleSources!.push(ConsultationSuggestibleSource.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): ConsultationDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ConsultationDetails();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.diseases)) {
            data["diseases"] = [];
            for (let item of this.diseases)
                data["diseases"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.formularies)) {
            data["formularies"] = [];
            for (let item of this.formularies)
                data["formularies"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.consultationSuggestibleSources)) {
            data["consultationSuggestibleSources"] = [];
            for (let item of this.consultationSuggestibleSources)
                data["consultationSuggestibleSources"].push(item ? item.toJSON() : <any>undefined);
        }
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type ConsultationDetails. */
export interface IConsultationDetails extends IConsultation {
    /** Gets or sets the diseases. */
    diseases?: Disease[] | undefined;
    /** Gets or sets the formularies. */
    formularies?: ConsultInFormularyVersion[] | undefined;
    /** Gets or sets the consultation suggestible sources. */
    consultationSuggestibleSources?: ConsultationSuggestibleSource[] | undefined;
}

/** Contains the definition of an object of type ConsultationSuggestionSource */
export class ConsultationSuggestibleSource implements IConsultationSuggestibleSource {
    /** Gets or sets the suggestible source identifier. */
    suggestibleSourceId!: number;

    constructor(data?: IConsultationSuggestibleSource) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.suggestibleSourceId = _data["suggestibleSourceId"];
        }
    }

    static fromJS(data: any): ConsultationSuggestibleSource {
        data = typeof data === 'object' ? data : {};
        let result = new ConsultationSuggestibleSource();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["suggestibleSourceId"] = this.suggestibleSourceId;
        return data;
    }
}

/** Contains the definition of an object of type ConsultationSuggestionSource */
export interface IConsultationSuggestibleSource {
    /** Gets or sets the suggestible source identifier. */
    suggestibleSourceId: number;
}

/** Contains the definition of an object of type ConsultationInformations. */
export class ConsultationInformations implements IConsultationInformations {
    /** Gets or sets the acute treatment. */
    acuteTreatment?: string | undefined;
    /** Gets or sets the consultation config identifier. */
    consultationConfigId!: number;
    /** Gets or sets the consultation reason identifier. */
    consultationReasonId!: number;
    /** Gets or sets the diseases. */
    diseases?: Disease[] | undefined;
    /** Gets or sets the identifier. */
    id!: number;
    /** Gets or sets the patient comments. */
    patientComments?: string | undefined;

    constructor(data?: IConsultationInformations) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.acuteTreatment = _data["acuteTreatment"];
            this.consultationConfigId = _data["consultationConfigId"];
            this.consultationReasonId = _data["consultationReasonId"];
            if (Array.isArray(_data["diseases"])) {
                this.diseases = [] as any;
                for (let item of _data["diseases"])
                    this.diseases!.push(Disease.fromJS(item));
            }
            this.id = _data["id"];
            this.patientComments = _data["patientComments"];
        }
    }

    static fromJS(data: any): ConsultationInformations {
        data = typeof data === 'object' ? data : {};
        let result = new ConsultationInformations();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["acuteTreatment"] = this.acuteTreatment;
        data["consultationConfigId"] = this.consultationConfigId;
        data["consultationReasonId"] = this.consultationReasonId;
        if (Array.isArray(this.diseases)) {
            data["diseases"] = [];
            for (let item of this.diseases)
                data["diseases"].push(item ? item.toJSON() : <any>undefined);
        }
        data["id"] = this.id;
        data["patientComments"] = this.patientComments;
        return data;
    }
}

/** Contains the definition of an object of type ConsultationInformations. */
export interface IConsultationInformations {
    /** Gets or sets the acute treatment. */
    acuteTreatment?: string | undefined;
    /** Gets or sets the consultation config identifier. */
    consultationConfigId: number;
    /** Gets or sets the consultation reason identifier. */
    consultationReasonId: number;
    /** Gets or sets the diseases. */
    diseases?: Disease[] | undefined;
    /** Gets or sets the identifier. */
    id: number;
    /** Gets or sets the patient comments. */
    patientComments?: string | undefined;
}

/** Contains the definition of an object of type ConsultationInformationPatient. */
export class ConsultationInformationPatient implements IConsultationInformationPatient {
    /** Gets or sets the consultation location. */
    consultationLocation!: ConsultationLocation;
    /** Gets or sets the medical office. */
    medicalOffice?: MedicalOffice | undefined;

    constructor(data?: IConsultationInformationPatient) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.consultationLocation = _data["consultationLocation"];
            this.medicalOffice = _data["medicalOffice"] ? MedicalOffice.fromJS(_data["medicalOffice"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ConsultationInformationPatient {
        data = typeof data === 'object' ? data : {};
        let result = new ConsultationInformationPatient();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["consultationLocation"] = this.consultationLocation;
        data["medicalOffice"] = this.medicalOffice ? this.medicalOffice.toJSON() : <any>undefined;
        return data;
    }
}

/** Contains the definition of an object of type ConsultationInformationPatient. */
export interface IConsultationInformationPatient {
    /** Gets or sets the consultation location. */
    consultationLocation: ConsultationLocation;
    /** Gets or sets the medical office. */
    medicalOffice?: MedicalOffice | undefined;
}

/** Contains the definition of an object of type ConsultationFormulary. */
export class ConsultationFormulary implements IConsultationFormulary {
    /** Gets or sets the identifier. */
    id!: number;
    /** Gets or sets the consultation identifier. */
    consultationId!: number;
    /** Gets or sets the formulary. */
    formularyVersion?: ConsultInFormularyVersion | undefined;
    /** Gets or sets the formulary version identifier. */
    formularyVersionId!: number;
    /** Gets or sets a value indicating whether this instance is filled. */
    status!: StatusConsultationFormularyEnum;

    constructor(data?: IConsultationFormulary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.consultationId = _data["consultationId"];
            this.formularyVersion = _data["formularyVersion"] ? ConsultInFormularyVersion.fromJS(_data["formularyVersion"]) : <any>undefined;
            this.formularyVersionId = _data["formularyVersionId"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): ConsultationFormulary {
        data = typeof data === 'object' ? data : {};
        let result = new ConsultationFormulary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["consultationId"] = this.consultationId;
        data["formularyVersion"] = this.formularyVersion ? this.formularyVersion.toJSON() : <any>undefined;
        data["formularyVersionId"] = this.formularyVersionId;
        data["status"] = this.status;
        return data;
    }
}

/** Contains the definition of an object of type ConsultationFormulary. */
export interface IConsultationFormulary {
    /** Gets or sets the identifier. */
    id: number;
    /** Gets or sets the consultation identifier. */
    consultationId: number;
    /** Gets or sets the formulary. */
    formularyVersion?: ConsultInFormularyVersion | undefined;
    /** Gets or sets the formulary version identifier. */
    formularyVersionId: number;
    /** Gets or sets a value indicating whether this instance is filled. */
    status: StatusConsultationFormularyEnum;
}

/** Contains the definition of an object of type ConsultationFormularyTitle. */
export class ConsultationFormularyTitle extends ConsultationSuggestibleTitle implements IConsultationFormularyTitle {
    /** Gets or sets a value indicating whether this instance is filled. */
    consultationFormularyStatus!: StatusConsultationFormularyEnum;
    /** Gets or sets the type. */
    type!: FormularyType;
    /** Gets or sets a value indicating whether this instance has sleep diary. */
    hasSleepDiary!: boolean;
    /** Gets or sets the sending date. */
    completionDate?: Date | undefined;

    constructor(data?: IConsultationFormularyTitle) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.consultationFormularyStatus = _data["consultationFormularyStatus"];
            this.type = _data["type"];
            this.hasSleepDiary = _data["hasSleepDiary"];
            this.completionDate = _data["completionDate"] ? new Date(_data["completionDate"].toString()) : <any>undefined;
        }
    }

    static override fromJS(data: any): ConsultationFormularyTitle {
        data = typeof data === 'object' ? data : {};
        let result = new ConsultationFormularyTitle();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["consultationFormularyStatus"] = this.consultationFormularyStatus;
        data["type"] = this.type;
        data["hasSleepDiary"] = this.hasSleepDiary;
        data["completionDate"] = this.completionDate ? this.completionDate.toISOString() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type ConsultationFormularyTitle. */
export interface IConsultationFormularyTitle extends IConsultationSuggestibleTitle {
    /** Gets or sets a value indicating whether this instance is filled. */
    consultationFormularyStatus: StatusConsultationFormularyEnum;
    /** Gets or sets the type. */
    type: FormularyType;
    /** Gets or sets a value indicating whether this instance has sleep diary. */
    hasSleepDiary: boolean;
    /** Gets or sets the sending date. */
    completionDate?: Date | undefined;
}

/** Contains the definition of an object of type ConsultationReasonDetails. */
export class ConsultationReasonDetails implements IConsultationReasonDetails {
    /** Gets or sets the identifier. */
    id!: number;
    /** Gets or sets the name. */
    name?: string | undefined;
    /** Gets or sets a value indicating whether this instance is default insurance reason. */
    isDefaultInsuranceReason!: boolean;
    /** Gets or sets the suggestible details. */
    suggestibleDetails?: SuggestibleDetail[] | undefined;

    constructor(data?: IConsultationReasonDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.isDefaultInsuranceReason = _data["isDefaultInsuranceReason"];
            if (Array.isArray(_data["suggestibleDetails"])) {
                this.suggestibleDetails = [] as any;
                for (let item of _data["suggestibleDetails"])
                    this.suggestibleDetails!.push(SuggestibleDetail.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ConsultationReasonDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ConsultationReasonDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["isDefaultInsuranceReason"] = this.isDefaultInsuranceReason;
        if (Array.isArray(this.suggestibleDetails)) {
            data["suggestibleDetails"] = [];
            for (let item of this.suggestibleDetails)
                data["suggestibleDetails"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

/** Contains the definition of an object of type ConsultationReasonDetails. */
export interface IConsultationReasonDetails {
    /** Gets or sets the identifier. */
    id: number;
    /** Gets or sets the name. */
    name?: string | undefined;
    /** Gets or sets a value indicating whether this instance is default insurance reason. */
    isDefaultInsuranceReason: boolean;
    /** Gets or sets the suggestible details. */
    suggestibleDetails?: SuggestibleDetail[] | undefined;
}

/** Contains the definition of an object of type SearchParamConsultationSuggestible. */
export class SearchParamConsultationSuggestible implements ISearchParamConsultationSuggestible {
    /** Gets or sets the consultation identifier. */
    consultationId!: number;

    constructor(data?: ISearchParamConsultationSuggestible) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.consultationId = _data["consultationId"];
        }
    }

    static fromJS(data: any): SearchParamConsultationSuggestible {
        data = typeof data === 'object' ? data : {};
        let result = new SearchParamConsultationSuggestible();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["consultationId"] = this.consultationId;
        return data;
    }
}

/** Contains the definition of an object of type SearchParamConsultationSuggestible. */
export interface ISearchParamConsultationSuggestible {
    /** Gets or sets the consultation identifier. */
    consultationId: number;
}

/** Contains the definition of an object of type SearchParamConsultationSuggestibleSuggestion. */
export class SearchParamConsultationSuggestibleSuggestion extends SearchParamConsultationSuggestible implements ISearchParamConsultationSuggestibleSuggestion {
    /** Gets or sets the type of the suggestion. */
    suggestionType!: SuggestionType;

    constructor(data?: ISearchParamConsultationSuggestibleSuggestion) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.suggestionType = _data["SuggestionType"];
        }
    }

    static override fromJS(data: any): SearchParamConsultationSuggestibleSuggestion {
        data = typeof data === 'object' ? data : {};
        let result = new SearchParamConsultationSuggestibleSuggestion();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["SuggestionType"] = this.suggestionType;
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type SearchParamConsultationSuggestibleSuggestion. */
export interface ISearchParamConsultationSuggestibleSuggestion extends ISearchParamConsultationSuggestible {
    /** Gets or sets the type of the suggestion. */
    suggestionType: SuggestionType;
}

/** Contains the definition of an object of type ConsultationBiologicalExamTitleBySet. */
export class ConsultationBiologicalExamTitleBySet implements IConsultationBiologicalExamTitleBySet {
    /** Gets or sets the biological exam set identifier. */
    biologicalExamSetId?: number | undefined;
    /** Gets or sets the biological exam group identifier. */
    biologicalExamGroupId?: number | undefined;
    /** Gets or sets the biological exam set name. */
    biologicalExamSetName?: string | undefined;
    /** Gets or sets the consultation biological exams. */
    consultationBiologicalExamTitles?: ConsultationBiologicalExamTitle[] | undefined;
    /** Gets or sets the document. */
    documentLite?: ConsultationDocumentTemplateLite | undefined;
    /** Gets a value indicating whether all ConsultationBiologicalExamTitles are selected. */
    isAllSelected!: boolean;

    constructor(data?: IConsultationBiologicalExamTitleBySet) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.biologicalExamSetId = _data["biologicalExamSetId"];
            this.biologicalExamGroupId = _data["biologicalExamGroupId"];
            this.biologicalExamSetName = _data["biologicalExamSetName"];
            if (Array.isArray(_data["consultationBiologicalExamTitles"])) {
                this.consultationBiologicalExamTitles = [] as any;
                for (let item of _data["consultationBiologicalExamTitles"])
                    this.consultationBiologicalExamTitles!.push(ConsultationBiologicalExamTitle.fromJS(item));
            }
            this.documentLite = _data["documentLite"] ? ConsultationDocumentTemplateLite.fromJS(_data["documentLite"]) : <any>undefined;
            this.isAllSelected = _data["isAllSelected"];
        }
    }

    static fromJS(data: any): ConsultationBiologicalExamTitleBySet {
        data = typeof data === 'object' ? data : {};
        let result = new ConsultationBiologicalExamTitleBySet();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["biologicalExamSetId"] = this.biologicalExamSetId;
        data["biologicalExamGroupId"] = this.biologicalExamGroupId;
        data["biologicalExamSetName"] = this.biologicalExamSetName;
        if (Array.isArray(this.consultationBiologicalExamTitles)) {
            data["consultationBiologicalExamTitles"] = [];
            for (let item of this.consultationBiologicalExamTitles)
                data["consultationBiologicalExamTitles"].push(item ? item.toJSON() : <any>undefined);
        }
        data["documentLite"] = this.documentLite ? this.documentLite.toJSON() : <any>undefined;
        data["isAllSelected"] = this.isAllSelected;
        return data;
    }
}

/** Contains the definition of an object of type ConsultationBiologicalExamTitleBySet. */
export interface IConsultationBiologicalExamTitleBySet {
    /** Gets or sets the biological exam set identifier. */
    biologicalExamSetId?: number | undefined;
    /** Gets or sets the biological exam group identifier. */
    biologicalExamGroupId?: number | undefined;
    /** Gets or sets the biological exam set name. */
    biologicalExamSetName?: string | undefined;
    /** Gets or sets the consultation biological exams. */
    consultationBiologicalExamTitles?: ConsultationBiologicalExamTitle[] | undefined;
    /** Gets or sets the document. */
    documentLite?: ConsultationDocumentTemplateLite | undefined;
    /** Gets a value indicating whether all ConsultationBiologicalExamTitles are selected. */
    isAllSelected: boolean;
}

/** Contains the definition of an object of type Diploma. */
export class Diploma extends DataStoreResource implements IDiploma {
    /** Gets or sets the category identifier. */
    categoryId!: DiplomaType;

    constructor(data?: IDiploma) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.categoryId = _data["categoryId"];
        }
    }

    static override fromJS(data: any): Diploma {
        data = typeof data === 'object' ? data : {};
        let result = new Diploma();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["categoryId"] = this.categoryId;
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type Diploma. */
export interface IDiploma extends IDataStoreResource {
    /** Gets or sets the category identifier. */
    categoryId: DiplomaType;
}

/** Contains the definition of an object of type DiplomaType. */
export enum DiplomaType {
    Unknown = 0,
    Intelligent = 1,
    Neuro = 2,
    IntelligentNeuro = 3,
}

/** Contains the definition of an object of type CoachingTypeDetails. */
export class CoachingTypeDetails implements ICoachingTypeDetails {
    /** Gets or sets the identifier. */
    id!: number;
    /** Gets or sets the label. */
    label?: string | undefined;
    /** Gets or sets the banner URL. */
    bannerUrl?: string | undefined;

    constructor(data?: ICoachingTypeDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.label = _data["label"];
            this.bannerUrl = _data["bannerUrl"];
        }
    }

    static fromJS(data: any): CoachingTypeDetails {
        data = typeof data === 'object' ? data : {};
        let result = new CoachingTypeDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["label"] = this.label;
        data["bannerUrl"] = this.bannerUrl;
        return data;
    }
}

/** Contains the definition of an object of type CoachingTypeDetails. */
export interface ICoachingTypeDetails {
    /** Gets or sets the identifier. */
    id: number;
    /** Gets or sets the label. */
    label?: string | undefined;
    /** Gets or sets the banner URL. */
    bannerUrl?: string | undefined;
}

/** Contains the definition of an object of type DropdownValueWithTechnical. */
export class DropdownValueWithTechnical extends DropdownValue implements IDropdownValueWithTechnical {
    /** Gets or sets the identifier. */
    technicalId!: number;

    constructor(data?: IDropdownValueWithTechnical) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.technicalId = _data["technicalId"];
        }
    }

    static override fromJS(data: any): DropdownValueWithTechnical {
        data = typeof data === 'object' ? data : {};
        let result = new DropdownValueWithTechnical();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["technicalId"] = this.technicalId;
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type DropdownValueWithTechnical. */
export interface IDropdownValueWithTechnical extends IDropdownValue {
    /** Gets or sets the identifier. */
    technicalId: number;
}

/** Contains the definition of an object of type DpcThemeDetails. */
export class DpcThemeDetails implements IDpcThemeDetails {
    /** Gets or sets the identifier. */
    id!: number;
    /** Gets or sets the name. */
    label?: string | undefined;
    /** Gets or sets the technical identifier. */
    technicalId!: number;
    /** Gets or sets the title. */
    title?: string | undefined;

    constructor(data?: IDpcThemeDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.label = _data["label"];
            this.technicalId = _data["technicalId"];
            this.title = _data["title"];
        }
    }

    static fromJS(data: any): DpcThemeDetails {
        data = typeof data === 'object' ? data : {};
        let result = new DpcThemeDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["label"] = this.label;
        data["technicalId"] = this.technicalId;
        data["title"] = this.title;
        return data;
    }
}

/** Contains the definition of an object of type DpcThemeDetails. */
export interface IDpcThemeDetails {
    /** Gets or sets the identifier. */
    id: number;
    /** Gets or sets the name. */
    label?: string | undefined;
    /** Gets or sets the technical identifier. */
    technicalId: number;
    /** Gets or sets the title. */
    title?: string | undefined;
}

/** Contains the definition of an object of type ConsultInQuestionCategory. */
export class ConsultInQuestionCategory implements IConsultInQuestionCategory {
    /** Gets or sets the label. */
    label?: string | undefined;
    /** Gets or sets the description. */
    description?: string | undefined;
    /** Gets or sets the image URL. */
    imageUrl?: string | undefined;

    constructor(data?: IConsultInQuestionCategory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.label = _data["label"];
            this.description = _data["description"];
            this.imageUrl = _data["imageUrl"];
        }
    }

    static fromJS(data: any): ConsultInQuestionCategory {
        data = typeof data === 'object' ? data : {};
        let result = new ConsultInQuestionCategory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        data["description"] = this.description;
        data["imageUrl"] = this.imageUrl;
        return data;
    }
}

/** Contains the definition of an object of type ConsultInQuestionCategory. */
export interface IConsultInQuestionCategory {
    /** Gets or sets the label. */
    label?: string | undefined;
    /** Gets or sets the description. */
    description?: string | undefined;
    /** Gets or sets the image URL. */
    imageUrl?: string | undefined;
}

/** Contains the definition of an object of type PhysiopathologicalHypothesis */
export class PhysiopathologicalHypothesis implements IPhysiopathologicalHypothesis {
    /** Gets or sets the category identifier. */
    categoryId!: number;
    /** Gets or sets the identifier. */
    id!: number;
    /** Gets or sets the label. */
    label?: string | undefined;

    constructor(data?: IPhysiopathologicalHypothesis) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.categoryId = _data["categoryId"];
            this.id = _data["id"];
            this.label = _data["label"];
        }
    }

    static fromJS(data: any): PhysiopathologicalHypothesis {
        data = typeof data === 'object' ? data : {};
        let result = new PhysiopathologicalHypothesis();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["categoryId"] = this.categoryId;
        data["id"] = this.id;
        data["label"] = this.label;
        return data;
    }
}

/** Contains the definition of an object of type PhysiopathologicalHypothesis */
export interface IPhysiopathologicalHypothesis {
    /** Gets or sets the category identifier. */
    categoryId: number;
    /** Gets or sets the identifier. */
    id: number;
    /** Gets or sets the label. */
    label?: string | undefined;
}

/** Contains the definition of an object of type ProfessionsWithOtherProfessionId. */
export class ProfessionsWithOtherProfessionId implements IProfessionsWithOtherProfessionId {
    /** Gets or sets the other profession identifier. */
    otherProfessionId!: number;
    /** Gets or sets the professions. */
    professions?: DataStoreResource[] | undefined;

    constructor(data?: IProfessionsWithOtherProfessionId) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.otherProfessionId = _data["otherProfessionId"];
            if (Array.isArray(_data["professions"])) {
                this.professions = [] as any;
                for (let item of _data["professions"])
                    this.professions!.push(DataStoreResource.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProfessionsWithOtherProfessionId {
        data = typeof data === 'object' ? data : {};
        let result = new ProfessionsWithOtherProfessionId();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["otherProfessionId"] = this.otherProfessionId;
        if (Array.isArray(this.professions)) {
            data["professions"] = [];
            for (let item of this.professions)
                data["professions"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

/** Contains the definition of an object of type ProfessionsWithOtherProfessionId. */
export interface IProfessionsWithOtherProfessionId {
    /** Gets or sets the other profession identifier. */
    otherProfessionId: number;
    /** Gets or sets the professions. */
    professions?: DataStoreResource[] | undefined;
}

/** Contains the definition of an object of type SubventionOrganization. */
export class SubventionOrganization implements ISubventionOrganization {
    /** Gets or sets the identifier. */
    id!: number;
    /** Gets or sets the billing adress. */
    billingAddress?: string | undefined;
    /** Gets or sets the billing contact. */
    billingContact?: string | undefined;
    /** Gets or sets the billing email. */
    billingEmail?: string | undefined;
    /** Gets or sets the billing vat number. */
    billingVAT?: string | undefined;
    /** Gets or sets the technical identifier. */
    technicalId!: number;

    constructor(data?: ISubventionOrganization) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.billingAddress = _data["billingAddress"];
            this.billingContact = _data["billingContact"];
            this.billingEmail = _data["billingEmail"];
            this.billingVAT = _data["billingVAT"];
            this.technicalId = _data["technicalId"];
        }
    }

    static fromJS(data: any): SubventionOrganization {
        data = typeof data === 'object' ? data : {};
        let result = new SubventionOrganization();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["billingAddress"] = this.billingAddress;
        data["billingContact"] = this.billingContact;
        data["billingEmail"] = this.billingEmail;
        data["billingVAT"] = this.billingVAT;
        data["technicalId"] = this.technicalId;
        return data;
    }
}

/** Contains the definition of an object of type SubventionOrganization. */
export interface ISubventionOrganization {
    /** Gets or sets the identifier. */
    id: number;
    /** Gets or sets the billing adress. */
    billingAddress?: string | undefined;
    /** Gets or sets the billing contact. */
    billingContact?: string | undefined;
    /** Gets or sets the billing email. */
    billingEmail?: string | undefined;
    /** Gets or sets the billing vat number. */
    billingVAT?: string | undefined;
    /** Gets or sets the technical identifier. */
    technicalId: number;
}

/** Contains the definition of an object of type SuggestionTypeDetails. */
export class SuggestionTypeDetails implements ISuggestionTypeDetails {
    /** Gets or sets the identifier. */
    id!: number;
    /** Gets or sets the label. */
    label?: string | undefined;
    /** Gets or sets the banner URL. */
    bannerUrl?: string | undefined;

    constructor(data?: ISuggestionTypeDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.label = _data["label"];
            this.bannerUrl = _data["bannerUrl"];
        }
    }

    static fromJS(data: any): SuggestionTypeDetails {
        data = typeof data === 'object' ? data : {};
        let result = new SuggestionTypeDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["label"] = this.label;
        data["bannerUrl"] = this.bannerUrl;
        return data;
    }
}

/** Contains the definition of an object of type SuggestionTypeDetails. */
export interface ISuggestionTypeDetails {
    /** Gets or sets the identifier. */
    id: number;
    /** Gets or sets the label. */
    label?: string | undefined;
    /** Gets or sets the banner URL. */
    bannerUrl?: string | undefined;
}

/** Contains the definition of an object of type DocumentTemplate. */
export class DocumentTemplate extends DocumentTemplateLite implements IDocumentTemplate {
    /** Gets or sets the fields. */
    fields?: DocumentTemplateFieldObject[] | undefined;
    /** Gets or sets the PDF content. */
    pdfContent?: string | undefined;

    constructor(data?: IDocumentTemplate) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["fields"])) {
                this.fields = [] as any;
                for (let item of _data["fields"])
                    this.fields!.push(DocumentTemplateFieldObject.fromJS(item));
            }
            this.pdfContent = _data["pdfContent"];
        }
    }

    static override fromJS(data: any): DocumentTemplate {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentTemplate();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.fields)) {
            data["fields"] = [];
            for (let item of this.fields)
                data["fields"].push(item ? item.toJSON() : <any>undefined);
        }
        data["pdfContent"] = this.pdfContent;
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type DocumentTemplate. */
export interface IDocumentTemplate extends IDocumentTemplateLite {
    /** Gets or sets the fields. */
    fields?: DocumentTemplateFieldObject[] | undefined;
    /** Gets or sets the PDF content. */
    pdfContent?: string | undefined;
}

/** Contains the definition of an object of type DocumentTemplateFieldObject. */
export class DocumentTemplateFieldObject implements IDocumentTemplateFieldObject {
    /** Gets or sets the field type. */
    fieldType!: FieldType;
    /** Gets or sets the simple field. */
    simpleField?: DocumentTemplateField | undefined;
    /** Gets or sets the checkbox field. */
    checkboxField?: DocumentTemplateCheckboxField | undefined;
    /** Gets or sets the group field. */
    fieldsGroup?: DocumentTemplateGroupField | undefined;

    constructor(data?: IDocumentTemplateFieldObject) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fieldType = _data["fieldType"];
            this.simpleField = _data["simpleField"] ? DocumentTemplateField.fromJS(_data["simpleField"]) : <any>undefined;
            this.checkboxField = _data["checkboxField"] ? DocumentTemplateCheckboxField.fromJS(_data["checkboxField"]) : <any>undefined;
            this.fieldsGroup = _data["fieldsGroup"] ? DocumentTemplateGroupField.fromJS(_data["fieldsGroup"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DocumentTemplateFieldObject {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentTemplateFieldObject();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fieldType"] = this.fieldType;
        data["simpleField"] = this.simpleField ? this.simpleField.toJSON() : <any>undefined;
        data["checkboxField"] = this.checkboxField ? this.checkboxField.toJSON() : <any>undefined;
        data["fieldsGroup"] = this.fieldsGroup ? this.fieldsGroup.toJSON() : <any>undefined;
        return data;
    }
}

/** Contains the definition of an object of type DocumentTemplateFieldObject. */
export interface IDocumentTemplateFieldObject {
    /** Gets or sets the field type. */
    fieldType: FieldType;
    /** Gets or sets the simple field. */
    simpleField?: DocumentTemplateField | undefined;
    /** Gets or sets the checkbox field. */
    checkboxField?: DocumentTemplateCheckboxField | undefined;
    /** Gets or sets the group field. */
    fieldsGroup?: DocumentTemplateGroupField | undefined;
}

/** Contains the definition of an object of type DocumentTemplateFieldRequiredBase. */
export class DocumentTemplateFieldBase implements IDocumentTemplateFieldBase {
    /** Gets or sets the label. */
    label?: string | undefined;
    /** Gets or sets the key. */
    key?: string | undefined;

    constructor(data?: IDocumentTemplateFieldBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.label = _data["label"];
            this.key = _data["key"];
        }
    }

    static fromJS(data: any): DocumentTemplateFieldBase {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentTemplateFieldBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        data["key"] = this.key;
        return data;
    }
}

/** Contains the definition of an object of type DocumentTemplateFieldRequiredBase. */
export interface IDocumentTemplateFieldBase {
    /** Gets or sets the label. */
    label?: string | undefined;
    /** Gets or sets the key. */
    key?: string | undefined;
}

/** Contains the definition of an object of type DocumentTemplateFieldRequiredBase. */
export class DocumentTemplateFieldRequiredBase extends DocumentTemplateFieldBase implements IDocumentTemplateFieldRequiredBase {
    /** Gets or sets a value indicating whether this DocumentTemplateFieldRequiredBase is required. */
    required!: boolean;

    constructor(data?: IDocumentTemplateFieldRequiredBase) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.required = _data["required"];
        }
    }

    static override fromJS(data: any): DocumentTemplateFieldRequiredBase {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentTemplateFieldRequiredBase();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["required"] = this.required;
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type DocumentTemplateFieldRequiredBase. */
export interface IDocumentTemplateFieldRequiredBase extends IDocumentTemplateFieldBase {
    /** Gets or sets a value indicating whether this DocumentTemplateFieldRequiredBase is required. */
    required: boolean;
}

/** Contains the definition of an object of type DocumentTemplateField. */
export class DocumentTemplateField extends DocumentTemplateFieldRequiredBase implements IDocumentTemplateField {
    /** Gets or sets the placeholder. */
    placeholder?: string | undefined;

    constructor(data?: IDocumentTemplateField) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.placeholder = _data["placeholder"];
        }
    }

    static override fromJS(data: any): DocumentTemplateField {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentTemplateField();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["placeholder"] = this.placeholder;
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type DocumentTemplateField. */
export interface IDocumentTemplateField extends IDocumentTemplateFieldRequiredBase {
    /** Gets or sets the placeholder. */
    placeholder?: string | undefined;
}

/** Contains the definition of an object of type DocumentTemplateCheckboxField. */
export class DocumentTemplateCheckboxField extends DocumentTemplateFieldRequiredBase implements IDocumentTemplateCheckboxField {
    /** Gets or sets a value indicating whether if the field allow multiple values. */
    allowMultipleValues!: boolean;
    /** Gets or sets the options. */
    options?: DocumentTemplateOption[] | undefined;

    constructor(data?: IDocumentTemplateCheckboxField) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.allowMultipleValues = _data["allowMultipleValues"];
            if (Array.isArray(_data["options"])) {
                this.options = [] as any;
                for (let item of _data["options"])
                    this.options!.push(DocumentTemplateOption.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): DocumentTemplateCheckboxField {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentTemplateCheckboxField();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["allowMultipleValues"] = this.allowMultipleValues;
        if (Array.isArray(this.options)) {
            data["options"] = [];
            for (let item of this.options)
                data["options"].push(item ? item.toJSON() : <any>undefined);
        }
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type DocumentTemplateCheckboxField. */
export interface IDocumentTemplateCheckboxField extends IDocumentTemplateFieldRequiredBase {
    /** Gets or sets a value indicating whether if the field allow multiple values. */
    allowMultipleValues: boolean;
    /** Gets or sets the options. */
    options?: DocumentTemplateOption[] | undefined;
}

/** Contains the definition of an object of type DocumentTemplateOption. */
export class DocumentTemplateOption implements IDocumentTemplateOption {
    /** Gets or sets the label. */
    label?: string | undefined;
    /** Gets or sets the key. */
    key?: string | undefined;
    /** Gets or sets a value indicating whether [display text field]. */
    displayTextField!: boolean;

    constructor(data?: IDocumentTemplateOption) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.label = _data["label"];
            this.key = _data["key"];
            this.displayTextField = _data["displayTextField"];
        }
    }

    static fromJS(data: any): DocumentTemplateOption {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentTemplateOption();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        data["key"] = this.key;
        data["displayTextField"] = this.displayTextField;
        return data;
    }
}

/** Contains the definition of an object of type DocumentTemplateOption. */
export interface IDocumentTemplateOption {
    /** Gets or sets the label. */
    label?: string | undefined;
    /** Gets or sets the key. */
    key?: string | undefined;
    /** Gets or sets a value indicating whether [display text field]. */
    displayTextField: boolean;
}

/** Contains the definition of an object of type DocumentTemplateGroupField. */
export class DocumentTemplateGroupField extends DocumentTemplateFieldBase implements IDocumentTemplateGroupField {
    /** Gets or sets a value indicating whether if the field allow multiple values. */
    fields?: DocumentTemplateFieldObject[] | undefined;

    constructor(data?: IDocumentTemplateGroupField) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["fields"])) {
                this.fields = [] as any;
                for (let item of _data["fields"])
                    this.fields!.push(DocumentTemplateFieldObject.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): DocumentTemplateGroupField {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentTemplateGroupField();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.fields)) {
            data["fields"] = [];
            for (let item of this.fields)
                data["fields"].push(item ? item.toJSON() : <any>undefined);
        }
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type DocumentTemplateGroupField. */
export interface IDocumentTemplateGroupField extends IDocumentTemplateFieldBase {
    /** Gets or sets a value indicating whether if the field allow multiple values. */
    fields?: DocumentTemplateFieldObject[] | undefined;
}

/** Contains the definition of an object of type SuggestionBaseEdit. */
export class SuggestionBaseEdit implements ISuggestionBaseEdit {
    /** Gets or sets the allowed subscription levels. */
    allowedSubscriptionLevels?: number[] | undefined;
    /** Gets or sets the description. */
    description?: string | undefined;
    /** Gets or sets the doctor identifier. */
    doctorId?: number | undefined;
    /** Gets or sets the identifier. */
    id!: number;
    /** Gets or sets the type of the public. */
    publicType!: SuggestionPublicType;
    /** Gets or sets the status. */
    status!: StatusSuggestion;
    /** Gets or sets the suggestible. */
    suggestible?: Suggestible | undefined;
    /** Gets or sets the title. */
    title?: string | undefined;
    /** Gets or sets the type identifier. */
    typeId!: number;
    /** Gets or sets the zoom sections. */
    suggestionZoomSections?: SuggestionZoomSection[] | undefined;
    /** Gets or sets the suggestion diseases. */
    suggestionDiseases?: SuggestionDisease[] | undefined;
    /** Gets or sets the suggestion medical histories. */
    suggestionMedicalHistories?: SuggestionMedicalHistory[] | undefined;
    /** Gets or sets the upload files. */
    uploadBanner?: any | undefined;
    /** Gets or sets the upload files. */
    uploadFiles?: any[] | undefined;
    /** Gets or sets the upload images. */
    uploadImages?: any[] | undefined;
    /** Gets or sets the streaming elementid. */
    streamingElementid?: number | undefined;
    /** Gets or sets a value indicating whether this instance is active. */
    isArchived!: boolean;

    constructor(data?: ISuggestionBaseEdit) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["allowedSubscriptionLevels"])) {
                this.allowedSubscriptionLevels = [] as any;
                for (let item of _data["allowedSubscriptionLevels"])
                    this.allowedSubscriptionLevels!.push(item);
            }
            this.description = _data["description"];
            this.doctorId = _data["doctorId"];
            this.id = _data["id"];
            this.publicType = _data["publicType"];
            this.status = _data["status"];
            this.suggestible = _data["suggestible"] ? Suggestible.fromJS(_data["suggestible"]) : <any>undefined;
            this.title = _data["title"];
            this.typeId = _data["typeId"];
            if (Array.isArray(_data["suggestionZoomSections"])) {
                this.suggestionZoomSections = [] as any;
                for (let item of _data["suggestionZoomSections"])
                    this.suggestionZoomSections!.push(SuggestionZoomSection.fromJS(item));
            }
            if (Array.isArray(_data["suggestionDiseases"])) {
                this.suggestionDiseases = [] as any;
                for (let item of _data["suggestionDiseases"])
                    this.suggestionDiseases!.push(SuggestionDisease.fromJS(item));
            }
            if (Array.isArray(_data["suggestionMedicalHistories"])) {
                this.suggestionMedicalHistories = [] as any;
                for (let item of _data["suggestionMedicalHistories"])
                    this.suggestionMedicalHistories!.push(SuggestionMedicalHistory.fromJS(item));
            }
            this.uploadBanner = _data["uploadBanner"];
            if (Array.isArray(_data["uploadFiles"])) {
                this.uploadFiles = [] as any;
                for (let item of _data["uploadFiles"])
                    this.uploadFiles!.push(item);
            }
            if (Array.isArray(_data["uploadImages"])) {
                this.uploadImages = [] as any;
                for (let item of _data["uploadImages"])
                    this.uploadImages!.push(item);
            }
            this.streamingElementid = _data["streamingElementid"];
            this.isArchived = _data["isArchived"];
        }
    }

    static fromJS(data: any): SuggestionBaseEdit {
        data = typeof data === 'object' ? data : {};
        let result = new SuggestionBaseEdit();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.allowedSubscriptionLevels)) {
            data["allowedSubscriptionLevels"] = [];
            for (let item of this.allowedSubscriptionLevels)
                data["allowedSubscriptionLevels"].push(item);
        }
        data["description"] = this.description;
        data["doctorId"] = this.doctorId;
        data["id"] = this.id;
        data["publicType"] = this.publicType;
        data["status"] = this.status;
        data["suggestible"] = this.suggestible ? this.suggestible.toJSON() : <any>undefined;
        data["title"] = this.title;
        data["typeId"] = this.typeId;
        if (Array.isArray(this.suggestionZoomSections)) {
            data["suggestionZoomSections"] = [];
            for (let item of this.suggestionZoomSections)
                data["suggestionZoomSections"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.suggestionDiseases)) {
            data["suggestionDiseases"] = [];
            for (let item of this.suggestionDiseases)
                data["suggestionDiseases"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.suggestionMedicalHistories)) {
            data["suggestionMedicalHistories"] = [];
            for (let item of this.suggestionMedicalHistories)
                data["suggestionMedicalHistories"].push(item ? item.toJSON() : <any>undefined);
        }
        data["uploadBanner"] = this.uploadBanner;
        if (Array.isArray(this.uploadFiles)) {
            data["uploadFiles"] = [];
            for (let item of this.uploadFiles)
                data["uploadFiles"].push(item);
        }
        if (Array.isArray(this.uploadImages)) {
            data["uploadImages"] = [];
            for (let item of this.uploadImages)
                data["uploadImages"].push(item);
        }
        data["streamingElementid"] = this.streamingElementid;
        data["isArchived"] = this.isArchived;
        return data;
    }
}

/** Contains the definition of an object of type SuggestionBaseEdit. */
export interface ISuggestionBaseEdit {
    /** Gets or sets the allowed subscription levels. */
    allowedSubscriptionLevels?: number[] | undefined;
    /** Gets or sets the description. */
    description?: string | undefined;
    /** Gets or sets the doctor identifier. */
    doctorId?: number | undefined;
    /** Gets or sets the identifier. */
    id: number;
    /** Gets or sets the type of the public. */
    publicType: SuggestionPublicType;
    /** Gets or sets the status. */
    status: StatusSuggestion;
    /** Gets or sets the suggestible. */
    suggestible?: Suggestible | undefined;
    /** Gets or sets the title. */
    title?: string | undefined;
    /** Gets or sets the type identifier. */
    typeId: number;
    /** Gets or sets the zoom sections. */
    suggestionZoomSections?: SuggestionZoomSection[] | undefined;
    /** Gets or sets the suggestion diseases. */
    suggestionDiseases?: SuggestionDisease[] | undefined;
    /** Gets or sets the suggestion medical histories. */
    suggestionMedicalHistories?: SuggestionMedicalHistory[] | undefined;
    /** Gets or sets the upload files. */
    uploadBanner?: any | undefined;
    /** Gets or sets the upload files. */
    uploadFiles?: any[] | undefined;
    /** Gets or sets the upload images. */
    uploadImages?: any[] | undefined;
    /** Gets or sets the streaming elementid. */
    streamingElementid?: number | undefined;
    /** Gets or sets a value indicating whether this instance is active. */
    isArchived: boolean;
}

/** Contains the definition of an object of type CreateSuggestion. */
export class CreateSuggestion extends SuggestionBaseEdit implements ICreateSuggestion {

    constructor(data?: ICreateSuggestion) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): CreateSuggestion {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSuggestion();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type CreateSuggestion. */
export interface ICreateSuggestion extends ISuggestionBaseEdit {
}

/** Contains the definition of an object of type CreateCustomSuggestion. */
export class CreateCustomSuggestion extends CreateSuggestion implements ICreateCustomSuggestion {
    /** Gets or sets the typeId. */
    suggestionType!: SuggestionType;

    constructor(data?: ICreateCustomSuggestion) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.suggestionType = _data["suggestionType"];
        }
    }

    static override fromJS(data: any): CreateCustomSuggestion {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCustomSuggestion();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["suggestionType"] = this.suggestionType;
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type CreateCustomSuggestion. */
export interface ICreateCustomSuggestion extends ICreateSuggestion {
    /** Gets or sets the typeId. */
    suggestionType: SuggestionType;
}

/** Contains the definition of an object of type SuggestionSource. */
export class SuggestionZoomSection implements ISuggestionZoomSection {
    /** Gets or sets the suggestion identifier. */
    suggestionId!: number;
    /** Gets or sets the zoom section identifier. */
    zoomSectionId!: number;

    constructor(data?: ISuggestionZoomSection) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.suggestionId = _data["suggestionId"];
            this.zoomSectionId = _data["zoomSectionId"];
        }
    }

    static fromJS(data: any): SuggestionZoomSection {
        data = typeof data === 'object' ? data : {};
        let result = new SuggestionZoomSection();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["suggestionId"] = this.suggestionId;
        data["zoomSectionId"] = this.zoomSectionId;
        return data;
    }
}

/** Contains the definition of an object of type SuggestionSource. */
export interface ISuggestionZoomSection {
    /** Gets or sets the suggestion identifier. */
    suggestionId: number;
    /** Gets or sets the zoom section identifier. */
    zoomSectionId: number;
}

/** Contains the definition of an object of type SuggestionDisease */
export class SuggestionDisease implements ISuggestionDisease {
    /** Gets or sets the disease identifier. */
    diseaseId!: number;
    /** Gets or sets the suggestion identifier. */
    suggestionId!: number;

    constructor(data?: ISuggestionDisease) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.diseaseId = _data["diseaseId"];
            this.suggestionId = _data["suggestionId"];
        }
    }

    static fromJS(data: any): SuggestionDisease {
        data = typeof data === 'object' ? data : {};
        let result = new SuggestionDisease();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["diseaseId"] = this.diseaseId;
        data["suggestionId"] = this.suggestionId;
        return data;
    }
}

/** Contains the definition of an object of type SuggestionDisease */
export interface ISuggestionDisease {
    /** Gets or sets the disease identifier. */
    diseaseId: number;
    /** Gets or sets the suggestion identifier. */
    suggestionId: number;
}

/** Contains the definition of an object of type SuggestionMedicalHistory. */
export class SuggestionMedicalHistory implements ISuggestionMedicalHistory {
    /** Gets or sets the medical history identifier. */
    diseaseId!: number;
    /** Gets or sets the suggestion identifier. */
    suggestionId!: number;

    constructor(data?: ISuggestionMedicalHistory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.diseaseId = _data["diseaseId"];
            this.suggestionId = _data["suggestionId"];
        }
    }

    static fromJS(data: any): SuggestionMedicalHistory {
        data = typeof data === 'object' ? data : {};
        let result = new SuggestionMedicalHistory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["diseaseId"] = this.diseaseId;
        data["suggestionId"] = this.suggestionId;
        return data;
    }
}

/** Contains the definition of an object of type SuggestionMedicalHistory. */
export interface ISuggestionMedicalHistory {
    /** Gets or sets the medical history identifier. */
    diseaseId: number;
    /** Gets or sets the suggestion identifier. */
    suggestionId: number;
}

/** Contains the definition of an object of type SuggestionDetails. */
export class SuggestionDetails extends Suggestion implements ISuggestionDetails {
    /** Gets or sets the allowed subscription levels. */
    allowedSubscriptionLevels?: number[] | undefined;
    /** Gets or sets the image URL. */
    bannerUrl?: string | undefined;
    /** Gets or sets the description. */
    description?: string | undefined;
    /** Gets or sets the files. */
    files?: SuggestionMedia[] | undefined;
    /** Gets or sets the images. */
    images?: SuggestionMedia[] | undefined;
    /** Gets or sets the suggestible. */
    suggestible?: Suggestible | undefined;
    /** Gets or sets the suggestion diseases. */
    suggestionDiseases?: SuggestionDisease[] | undefined;
    /** Gets or sets the suggestion medical histories. */
    suggestionMedicalHistories?: SuggestionMedicalHistory[] | undefined;
    /** Gets or sets the upload files. */
    uploadBanner?: any | undefined;
    /** Gets or sets the upload files. */
    uploadFiles?: any[] | undefined;
    /** Gets or sets the upload images. */
    uploadImages?: any[] | undefined;
    /** Gets or sets the zoom sections. */
    zoomSections?: ZoomSection[] | undefined;
    /** Gets or sets the streaming URL. */
    streamingUrl?: string | undefined;
    /** Gets or sets the streaming element identifier. */
    streamingElementId?: number | undefined;
    /** Gets or sets the name of the streaming element. */
    streamingElementName?: string | undefined;

    constructor(data?: ISuggestionDetails) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["allowedSubscriptionLevels"])) {
                this.allowedSubscriptionLevels = [] as any;
                for (let item of _data["allowedSubscriptionLevels"])
                    this.allowedSubscriptionLevels!.push(item);
            }
            this.bannerUrl = _data["bannerUrl"];
            this.description = _data["description"];
            if (Array.isArray(_data["files"])) {
                this.files = [] as any;
                for (let item of _data["files"])
                    this.files!.push(SuggestionMedia.fromJS(item));
            }
            if (Array.isArray(_data["images"])) {
                this.images = [] as any;
                for (let item of _data["images"])
                    this.images!.push(SuggestionMedia.fromJS(item));
            }
            this.suggestible = _data["suggestible"] ? Suggestible.fromJS(_data["suggestible"]) : <any>undefined;
            if (Array.isArray(_data["suggestionDiseases"])) {
                this.suggestionDiseases = [] as any;
                for (let item of _data["suggestionDiseases"])
                    this.suggestionDiseases!.push(SuggestionDisease.fromJS(item));
            }
            if (Array.isArray(_data["suggestionMedicalHistories"])) {
                this.suggestionMedicalHistories = [] as any;
                for (let item of _data["suggestionMedicalHistories"])
                    this.suggestionMedicalHistories!.push(SuggestionMedicalHistory.fromJS(item));
            }
            this.uploadBanner = _data["uploadBanner"];
            if (Array.isArray(_data["uploadFiles"])) {
                this.uploadFiles = [] as any;
                for (let item of _data["uploadFiles"])
                    this.uploadFiles!.push(item);
            }
            if (Array.isArray(_data["uploadImages"])) {
                this.uploadImages = [] as any;
                for (let item of _data["uploadImages"])
                    this.uploadImages!.push(item);
            }
            if (Array.isArray(_data["zoomSections"])) {
                this.zoomSections = [] as any;
                for (let item of _data["zoomSections"])
                    this.zoomSections!.push(ZoomSection.fromJS(item));
            }
            this.streamingUrl = _data["streamingUrl"];
            this.streamingElementId = _data["streamingElementId"];
            this.streamingElementName = _data["streamingElementName"];
        }
    }

    static override fromJS(data: any): SuggestionDetails {
        data = typeof data === 'object' ? data : {};
        let result = new SuggestionDetails();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.allowedSubscriptionLevels)) {
            data["allowedSubscriptionLevels"] = [];
            for (let item of this.allowedSubscriptionLevels)
                data["allowedSubscriptionLevels"].push(item);
        }
        data["bannerUrl"] = this.bannerUrl;
        data["description"] = this.description;
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.images)) {
            data["images"] = [];
            for (let item of this.images)
                data["images"].push(item ? item.toJSON() : <any>undefined);
        }
        data["suggestible"] = this.suggestible ? this.suggestible.toJSON() : <any>undefined;
        if (Array.isArray(this.suggestionDiseases)) {
            data["suggestionDiseases"] = [];
            for (let item of this.suggestionDiseases)
                data["suggestionDiseases"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.suggestionMedicalHistories)) {
            data["suggestionMedicalHistories"] = [];
            for (let item of this.suggestionMedicalHistories)
                data["suggestionMedicalHistories"].push(item ? item.toJSON() : <any>undefined);
        }
        data["uploadBanner"] = this.uploadBanner;
        if (Array.isArray(this.uploadFiles)) {
            data["uploadFiles"] = [];
            for (let item of this.uploadFiles)
                data["uploadFiles"].push(item);
        }
        if (Array.isArray(this.uploadImages)) {
            data["uploadImages"] = [];
            for (let item of this.uploadImages)
                data["uploadImages"].push(item);
        }
        if (Array.isArray(this.zoomSections)) {
            data["zoomSections"] = [];
            for (let item of this.zoomSections)
                data["zoomSections"].push(item ? item.toJSON() : <any>undefined);
        }
        data["streamingUrl"] = this.streamingUrl;
        data["streamingElementId"] = this.streamingElementId;
        data["streamingElementName"] = this.streamingElementName;
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type SuggestionDetails. */
export interface ISuggestionDetails extends ISuggestion {
    /** Gets or sets the allowed subscription levels. */
    allowedSubscriptionLevels?: number[] | undefined;
    /** Gets or sets the image URL. */
    bannerUrl?: string | undefined;
    /** Gets or sets the description. */
    description?: string | undefined;
    /** Gets or sets the files. */
    files?: SuggestionMedia[] | undefined;
    /** Gets or sets the images. */
    images?: SuggestionMedia[] | undefined;
    /** Gets or sets the suggestible. */
    suggestible?: Suggestible | undefined;
    /** Gets or sets the suggestion diseases. */
    suggestionDiseases?: SuggestionDisease[] | undefined;
    /** Gets or sets the suggestion medical histories. */
    suggestionMedicalHistories?: SuggestionMedicalHistory[] | undefined;
    /** Gets or sets the upload files. */
    uploadBanner?: any | undefined;
    /** Gets or sets the upload files. */
    uploadFiles?: any[] | undefined;
    /** Gets or sets the upload images. */
    uploadImages?: any[] | undefined;
    /** Gets or sets the zoom sections. */
    zoomSections?: ZoomSection[] | undefined;
    /** Gets or sets the streaming URL. */
    streamingUrl?: string | undefined;
    /** Gets or sets the streaming element identifier. */
    streamingElementId?: number | undefined;
    /** Gets or sets the name of the streaming element. */
    streamingElementName?: string | undefined;
}

/** Contains the definition of an object of type SuggestionMedia. */
export class SuggestionMedia implements ISuggestionMedia {
    /** Gets or sets the identifier. */
    id!: number;
    /** Gets or sets the name. */
    name?: string | undefined;
    /** Gets or sets the URL. */
    url?: string | undefined;

    constructor(data?: ISuggestionMedia) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.url = _data["url"];
        }
    }

    static fromJS(data: any): SuggestionMedia {
        data = typeof data === 'object' ? data : {};
        let result = new SuggestionMedia();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["url"] = this.url;
        return data;
    }
}

/** Contains the definition of an object of type SuggestionMedia. */
export interface ISuggestionMedia {
    /** Gets or sets the identifier. */
    id: number;
    /** Gets or sets the name. */
    name?: string | undefined;
    /** Gets or sets the URL. */
    url?: string | undefined;
}

/** Contains the definition of an object of type SuggestionBaseSearchParams. */
export class SuggestionBaseSearchParams extends SearchParams implements ISuggestionBaseSearchParams {
    /** Gets or sets the title. */
    title?: string | undefined;
    /** Gets or sets the type of the public. */
    publicType?: SuggestionPublicType | undefined;

    constructor(data?: ISuggestionBaseSearchParams) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.title = _data["title"];
            this.publicType = _data["publicType"];
        }
    }

    static override fromJS(data: any): SuggestionBaseSearchParams {
        data = typeof data === 'object' ? data : {};
        let result = new SuggestionBaseSearchParams();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["publicType"] = this.publicType;
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type SuggestionBaseSearchParams. */
export interface ISuggestionBaseSearchParams extends ISearchParams {
    /** Gets or sets the title. */
    title?: string | undefined;
    /** Gets or sets the type of the public. */
    publicType?: SuggestionPublicType | undefined;
}

/** Contains the definition of an object of type SuggestionSearchParams. */
export class SuggestionSearchParams extends SuggestionBaseSearchParams implements ISuggestionSearchParams {
    /** Gets or sets the identifier. */
    id?: number | undefined;
    /** Gets or sets the status. */
    status!: StatusSuggestion;
    /** Gets or sets the type identifier. */
    typeId?: number | undefined;
    /** Gets or sets the subscription levels. */
    subscriptionLevels?: number[] | undefined;

    constructor(data?: ISuggestionSearchParams) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.status = _data["status"];
            this.typeId = _data["typeId"];
            if (Array.isArray(_data["subscriptionLevels"])) {
                this.subscriptionLevels = [] as any;
                for (let item of _data["subscriptionLevels"])
                    this.subscriptionLevels!.push(item);
            }
        }
    }

    static override fromJS(data: any): SuggestionSearchParams {
        data = typeof data === 'object' ? data : {};
        let result = new SuggestionSearchParams();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["status"] = this.status;
        data["typeId"] = this.typeId;
        if (Array.isArray(this.subscriptionLevels)) {
            data["subscriptionLevels"] = [];
            for (let item of this.subscriptionLevels)
                data["subscriptionLevels"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type SuggestionSearchParams. */
export interface ISuggestionSearchParams extends ISuggestionBaseSearchParams {
    /** Gets or sets the identifier. */
    id?: number | undefined;
    /** Gets or sets the status. */
    status: StatusSuggestion;
    /** Gets or sets the type identifier. */
    typeId?: number | undefined;
    /** Gets or sets the subscription levels. */
    subscriptionLevels?: number[] | undefined;
}

export class PaginatorWrapperOfIEnumerableOfSuggestionWithWarnings implements IPaginatorWrapperOfIEnumerableOfSuggestionWithWarnings {
    totalRecords!: number;
    data?: SuggestionWithWarnings[] | undefined;

    constructor(data?: IPaginatorWrapperOfIEnumerableOfSuggestionWithWarnings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRecords = _data["totalRecords"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(SuggestionWithWarnings.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatorWrapperOfIEnumerableOfSuggestionWithWarnings {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatorWrapperOfIEnumerableOfSuggestionWithWarnings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IPaginatorWrapperOfIEnumerableOfSuggestionWithWarnings {
    totalRecords: number;
    data?: SuggestionWithWarnings[] | undefined;
}

/** Contains the definition of an object of type SuggestionWithWarnings. */
export class SuggestionWithWarnings extends Suggestion implements ISuggestionWithWarnings {
    /** Gets or sets the warnings. */
    warnings?: SuggestibleSourceWithEntityName[] | undefined;
    /** Gets or sets the suggestible source with entity names. */
    suggestibleSourceWithEntityNames?: SuggestibleSourceWithEntityName[] | undefined;
    /** Gets or sets the intention. */
    intention!: IntentionLevelType;
    /** Gets or sets the suggestible. */
    suggestible?: Suggestible | undefined;
    /** Gets or sets a value indicating whether this instance is selected. */
    isSelected!: boolean;
    /** Gets or sets a value indicating whether this instance is already in consult. */
    isAlreadyInConsult!: boolean;
    /** Gets or sets the last sending to patient. */
    lastSendingToPatient?: Date | undefined;

    constructor(data?: ISuggestionWithWarnings) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["warnings"])) {
                this.warnings = [] as any;
                for (let item of _data["warnings"])
                    this.warnings!.push(SuggestibleSourceWithEntityName.fromJS(item));
            }
            if (Array.isArray(_data["suggestibleSourceWithEntityNames"])) {
                this.suggestibleSourceWithEntityNames = [] as any;
                for (let item of _data["suggestibleSourceWithEntityNames"])
                    this.suggestibleSourceWithEntityNames!.push(SuggestibleSourceWithEntityName.fromJS(item));
            }
            this.intention = _data["intention"];
            this.suggestible = _data["suggestible"] ? Suggestible.fromJS(_data["suggestible"]) : <any>undefined;
            this.isSelected = _data["isSelected"];
            this.isAlreadyInConsult = _data["isAlreadyInConsult"];
            this.lastSendingToPatient = _data["lastSendingToPatient"] ? new Date(_data["lastSendingToPatient"].toString()) : <any>undefined;
        }
    }

    static override fromJS(data: any): SuggestionWithWarnings {
        data = typeof data === 'object' ? data : {};
        let result = new SuggestionWithWarnings();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.warnings)) {
            data["warnings"] = [];
            for (let item of this.warnings)
                data["warnings"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.suggestibleSourceWithEntityNames)) {
            data["suggestibleSourceWithEntityNames"] = [];
            for (let item of this.suggestibleSourceWithEntityNames)
                data["suggestibleSourceWithEntityNames"].push(item ? item.toJSON() : <any>undefined);
        }
        data["intention"] = this.intention;
        data["suggestible"] = this.suggestible ? this.suggestible.toJSON() : <any>undefined;
        data["isSelected"] = this.isSelected;
        data["isAlreadyInConsult"] = this.isAlreadyInConsult;
        data["lastSendingToPatient"] = this.lastSendingToPatient ? this.lastSendingToPatient.toISOString() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type SuggestionWithWarnings. */
export interface ISuggestionWithWarnings extends ISuggestion {
    /** Gets or sets the warnings. */
    warnings?: SuggestibleSourceWithEntityName[] | undefined;
    /** Gets or sets the suggestible source with entity names. */
    suggestibleSourceWithEntityNames?: SuggestibleSourceWithEntityName[] | undefined;
    /** Gets or sets the intention. */
    intention: IntentionLevelType;
    /** Gets or sets the suggestible. */
    suggestible?: Suggestible | undefined;
    /** Gets or sets a value indicating whether this instance is selected. */
    isSelected: boolean;
    /** Gets or sets a value indicating whether this instance is already in consult. */
    isAlreadyInConsult: boolean;
    /** Gets or sets the last sending to patient. */
    lastSendingToPatient?: Date | undefined;
}

/** Contains the definition of an object of type SuggestionLibrarySearchParams. */
export class SuggestionLibrarySearchParams extends SuggestionBaseSearchParams implements ISuggestionLibrarySearchParams {
    /** Gets or sets the type of the suggestion. */
    suggestionType!: SuggestionType;
    /** Gets or sets the identifier of the suggestion. */
    suggestionTypeId?: number | undefined;
    /** Gets or sets the patient identifier. */
    patientId?: number | undefined;
    /** Gets or sets the consultation identifier. */
    consultationId?: number | undefined;
    /** Gets or sets a value indicating whether this instance is from siin. */
    isFromSiin!: boolean;
    /** Gets or sets a value indicating whether this instance is only custom. */
    onlyCustom!: boolean;

    constructor(data?: ISuggestionLibrarySearchParams) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.suggestionType = _data["suggestionType"];
            this.suggestionTypeId = _data["suggestionTypeId"];
            this.patientId = _data["patientId"];
            this.consultationId = _data["consultationId"];
            this.isFromSiin = _data["isFromSiin"];
            this.onlyCustom = _data["onlyCustom"];
        }
    }

    static override fromJS(data: any): SuggestionLibrarySearchParams {
        data = typeof data === 'object' ? data : {};
        let result = new SuggestionLibrarySearchParams();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["suggestionType"] = this.suggestionType;
        data["suggestionTypeId"] = this.suggestionTypeId;
        data["patientId"] = this.patientId;
        data["consultationId"] = this.consultationId;
        data["isFromSiin"] = this.isFromSiin;
        data["onlyCustom"] = this.onlyCustom;
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type SuggestionLibrarySearchParams. */
export interface ISuggestionLibrarySearchParams extends ISuggestionBaseSearchParams {
    /** Gets or sets the type of the suggestion. */
    suggestionType: SuggestionType;
    /** Gets or sets the identifier of the suggestion. */
    suggestionTypeId?: number | undefined;
    /** Gets or sets the patient identifier. */
    patientId?: number | undefined;
    /** Gets or sets the consultation identifier. */
    consultationId?: number | undefined;
    /** Gets or sets a value indicating whether this instance is from siin. */
    isFromSiin: boolean;
    /** Gets or sets a value indicating whether this instance is only custom. */
    onlyCustom: boolean;
}

export class SelectItemOfLiteSuggestion implements ISelectItemOfLiteSuggestion {
    label?: string | undefined;
    value?: LiteSuggestion | undefined;

    constructor(data?: ISelectItemOfLiteSuggestion) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.label = _data["label"];
            this.value = _data["value"] ? LiteSuggestion.fromJS(_data["value"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SelectItemOfLiteSuggestion {
        data = typeof data === 'object' ? data : {};
        let result = new SelectItemOfLiteSuggestion();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        data["value"] = this.value ? this.value.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISelectItemOfLiteSuggestion {
    label?: string | undefined;
    value?: LiteSuggestion | undefined;
}

/** Contains the definition of an object of type LiteSuggestion. */
export class LiteSuggestion implements ILiteSuggestion {
    /** Gets or sets the identifier. */
    id!: number;
    /** Gets or sets a value indicating whether this instance is custom. */
    isCustomSuggestion!: boolean;
    /** Gets or sets the type identifier. */
    typeId!: number;

    constructor(data?: ILiteSuggestion) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isCustomSuggestion = _data["isCustomSuggestion"];
            this.typeId = _data["typeId"];
        }
    }

    static fromJS(data: any): LiteSuggestion {
        data = typeof data === 'object' ? data : {};
        let result = new LiteSuggestion();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isCustomSuggestion"] = this.isCustomSuggestion;
        data["typeId"] = this.typeId;
        return data;
    }
}

/** Contains the definition of an object of type LiteSuggestion. */
export interface ILiteSuggestion {
    /** Gets or sets the identifier. */
    id: number;
    /** Gets or sets a value indicating whether this instance is custom. */
    isCustomSuggestion: boolean;
    /** Gets or sets the type identifier. */
    typeId: number;
}

/** Contains the definition of an object of type ZoomSectionSearchParams. */
export class ZoomSectionSearchParams extends SearchParams implements IZoomSectionSearchParams {
    /** Gets or sets the title. */
    title?: string | undefined;

    constructor(data?: IZoomSectionSearchParams) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.title = _data["Title"];
        }
    }

    static override fromJS(data: any): ZoomSectionSearchParams {
        data = typeof data === 'object' ? data : {};
        let result = new ZoomSectionSearchParams();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Title"] = this.title;
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type ZoomSectionSearchParams. */
export interface IZoomSectionSearchParams extends ISearchParams {
    /** Gets or sets the title. */
    title?: string | undefined;
}

/** Contains the definition of an object of type UpdateSuggestion. */
export class UpdateSuggestion extends SuggestionBaseEdit implements IUpdateSuggestion {

    constructor(data?: IUpdateSuggestion) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): UpdateSuggestion {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSuggestion();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type UpdateSuggestion. */
export interface IUpdateSuggestion extends ISuggestionBaseEdit {
}

/** Contains the definition of an object of type UpdateCustomSuggestion. */
export class UpdateCustomSuggestion extends UpdateSuggestion implements IUpdateCustomSuggestion {
    /** Gets or sets the typeId. */
    suggestionType!: SuggestionType;

    constructor(data?: IUpdateCustomSuggestion) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.suggestionType = _data["suggestionType"];
        }
    }

    static override fromJS(data: any): UpdateCustomSuggestion {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCustomSuggestion();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["suggestionType"] = this.suggestionType;
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type UpdateCustomSuggestion. */
export interface IUpdateCustomSuggestion extends IUpdateSuggestion {
    /** Gets or sets the typeId. */
    suggestionType: SuggestionType;
}

/** Contains the definition of an object of type DocumentCreation. */
export abstract class DocumentCreation implements IDocumentCreation {
    /** Gets or sets the file. */
    file?: any | undefined;
    /** Gets or sets the name. */
    name?: string | undefined;
    /** Gets or sets the type. */
    type!: DocumentType;
    /** Gets or sets a value indicating whether the document is interne. */
    isInterne!: boolean;

    constructor(data?: IDocumentCreation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.file = _data["file"];
            this.name = _data["name"];
            this.type = _data["type"];
            this.isInterne = _data["isInterne"];
        }
    }

    static fromJS(data: any): DocumentCreation {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'DocumentCreation' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["file"] = this.file;
        data["name"] = this.name;
        data["type"] = this.type;
        data["isInterne"] = this.isInterne;
        return data;
    }
}

/** Contains the definition of an object of type DocumentCreation. */
export interface IDocumentCreation {
    /** Gets or sets the file. */
    file?: any | undefined;
    /** Gets or sets the name. */
    name?: string | undefined;
    /** Gets or sets the type. */
    type: DocumentType;
    /** Gets or sets a value indicating whether the document is interne. */
    isInterne: boolean;
}

/** Contains the definition of an object of type DoctorDocumentCreation. */
export class DoctorDocumentCreation extends DocumentCreation implements IDoctorDocumentCreation {
    /** Gets or sets the consultation identifier. */
    consultationId?: number | undefined;
    /** Gets or sets the patient id. */
    patientId?: number | undefined;
    /** Gets or sets a value indicating whether the document is saved internally by the doctor. */
    customDoctorDocument!: boolean;
    /** Gets or sets a value indicating whether the document should be sent automatically to the patient. */
    autoSendToPatient!: boolean;
    /** Gets or sets the HTML content. */
    htmlContent?: string | undefined;

    constructor(data?: IDoctorDocumentCreation) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.consultationId = _data["consultationId"];
            this.patientId = _data["patientId"];
            this.customDoctorDocument = _data["customDoctorDocument"];
            this.autoSendToPatient = _data["autoSendToPatient"];
            this.htmlContent = _data["htmlContent"];
        }
    }

    static override fromJS(data: any): DoctorDocumentCreation {
        data = typeof data === 'object' ? data : {};
        let result = new DoctorDocumentCreation();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["consultationId"] = this.consultationId;
        data["patientId"] = this.patientId;
        data["customDoctorDocument"] = this.customDoctorDocument;
        data["autoSendToPatient"] = this.autoSendToPatient;
        data["htmlContent"] = this.htmlContent;
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type DoctorDocumentCreation. */
export interface IDoctorDocumentCreation extends IDocumentCreation {
    /** Gets or sets the consultation identifier. */
    consultationId?: number | undefined;
    /** Gets or sets the patient id. */
    patientId?: number | undefined;
    /** Gets or sets a value indicating whether the document is saved internally by the doctor. */
    customDoctorDocument: boolean;
    /** Gets or sets a value indicating whether the document should be sent automatically to the patient. */
    autoSendToPatient: boolean;
    /** Gets or sets the HTML content. */
    htmlContent?: string | undefined;
}

/** Contains the definition of an object of type PatientDocumentCreation */
export class PatientDocumentCreation extends DocumentCreation implements IPatientDocumentCreation {
    /** Gets or sets the shared with doctor ids. */
    sharedWithDoctorIds?: number[] | undefined;

    constructor(data?: IPatientDocumentCreation) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["sharedWithDoctorIds"])) {
                this.sharedWithDoctorIds = [] as any;
                for (let item of _data["sharedWithDoctorIds"])
                    this.sharedWithDoctorIds!.push(item);
            }
        }
    }

    static override fromJS(data: any): PatientDocumentCreation {
        data = typeof data === 'object' ? data : {};
        let result = new PatientDocumentCreation();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.sharedWithDoctorIds)) {
            data["sharedWithDoctorIds"] = [];
            for (let item of this.sharedWithDoctorIds)
                data["sharedWithDoctorIds"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type PatientDocumentCreation */
export interface IPatientDocumentCreation extends IDocumentCreation {
    /** Gets or sets the shared with doctor ids. */
    sharedWithDoctorIds?: number[] | undefined;
}

/** Contains the definition of an object of type DocumentWrapper. */
export class DocumentWrapper implements IDocumentWrapper {
    /** Gets or sets the date. */
    date!: Date;
    /** Gets or sets the document.
Null if not a real document. */
    document?: Document | undefined;
    /** Gets or sets a value indicating whether this instance is from patient. */
    isFromPatient!: boolean;
    /** Gets or sets the object identifier.
The id of the object if not a real document (ex: suggestion). */
    objectId?: number | undefined;
    /** Gets or sets the title. */
    title!: string;
    /** Gets or sets the type of the document. */
    type!: DocumentType;
    /** Gets or sets the comment. */
    comment?: string | undefined;

    constructor(data?: IDocumentWrapper) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.document = _data["document"] ? Document.fromJS(_data["document"]) : <any>undefined;
            this.isFromPatient = _data["isFromPatient"];
            this.objectId = _data["objectId"];
            this.title = _data["title"];
            this.type = _data["type"];
            this.comment = _data["comment"];
        }
    }

    static fromJS(data: any): DocumentWrapper {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentWrapper();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["document"] = this.document ? this.document.toJSON() : <any>undefined;
        data["isFromPatient"] = this.isFromPatient;
        data["objectId"] = this.objectId;
        data["title"] = this.title;
        data["type"] = this.type;
        data["comment"] = this.comment;
        return data;
    }
}

/** Contains the definition of an object of type DocumentWrapper. */
export interface IDocumentWrapper {
    /** Gets or sets the date. */
    date: Date;
    /** Gets or sets the document.
Null if not a real document. */
    document?: Document | undefined;
    /** Gets or sets a value indicating whether this instance is from patient. */
    isFromPatient: boolean;
    /** Gets or sets the object identifier.
The id of the object if not a real document (ex: suggestion). */
    objectId?: number | undefined;
    /** Gets or sets the title. */
    title: string;
    /** Gets or sets the type of the document. */
    type: DocumentType;
    /** Gets or sets the comment. */
    comment?: string | undefined;
}

/** Contains the definition of an object of type DocumentSearchParams. */
export class DocumentSearchParams extends SearchParams implements IDocumentSearchParams {
    /** Gets or sets the document ids. */
    documentIds?: string[] | undefined;
    /** Gets or sets the is from patient. */
    isFromPatient?: boolean | undefined;
    /** Gets or sets the patient identifier. */
    patientId?: number | undefined;
    /** Gets or sets the shared with doctor ids. */
    sharedWithDoctorIds?: number[] | undefined;
    /** Gets or sets the types. */
    types?: DocumentType[] | undefined;
    /** Gets or sets the OnlyDocuInterne. */
    onlyDocuInterne?: boolean | undefined;

    constructor(data?: IDocumentSearchParams) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["documentIds"])) {
                this.documentIds = [] as any;
                for (let item of _data["documentIds"])
                    this.documentIds!.push(item);
            }
            this.isFromPatient = _data["isFromPatient"];
            this.patientId = _data["patientId"];
            if (Array.isArray(_data["sharedWithDoctorIds"])) {
                this.sharedWithDoctorIds = [] as any;
                for (let item of _data["sharedWithDoctorIds"])
                    this.sharedWithDoctorIds!.push(item);
            }
            if (Array.isArray(_data["types"])) {
                this.types = [] as any;
                for (let item of _data["types"])
                    this.types!.push(item);
            }
            this.onlyDocuInterne = _data["onlyDocuInterne"];
        }
    }

    static override fromJS(data: any): DocumentSearchParams {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentSearchParams();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.documentIds)) {
            data["documentIds"] = [];
            for (let item of this.documentIds)
                data["documentIds"].push(item);
        }
        data["isFromPatient"] = this.isFromPatient;
        data["patientId"] = this.patientId;
        if (Array.isArray(this.sharedWithDoctorIds)) {
            data["sharedWithDoctorIds"] = [];
            for (let item of this.sharedWithDoctorIds)
                data["sharedWithDoctorIds"].push(item);
        }
        if (Array.isArray(this.types)) {
            data["types"] = [];
            for (let item of this.types)
                data["types"].push(item);
        }
        data["onlyDocuInterne"] = this.onlyDocuInterne;
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type DocumentSearchParams. */
export interface IDocumentSearchParams extends ISearchParams {
    /** Gets or sets the document ids. */
    documentIds?: string[] | undefined;
    /** Gets or sets the is from patient. */
    isFromPatient?: boolean | undefined;
    /** Gets or sets the patient identifier. */
    patientId?: number | undefined;
    /** Gets or sets the shared with doctor ids. */
    sharedWithDoctorIds?: number[] | undefined;
    /** Gets or sets the types. */
    types?: DocumentType[] | undefined;
    /** Gets or sets the OnlyDocuInterne. */
    onlyDocuInterne?: boolean | undefined;
}

/** Contains the definition of an object of type PatientFilterValues. */
export class PatientFilterValues implements IPatientFilterValues {
    /** Gets or sets the doctors. */
    doctors?: DoctorLiteInfo[] | undefined;
    /** Gets or sets the document types. */
    documentTypes?: DocumentType[] | undefined;
    /** Gets or sets the titles.
Must be composed of title + object id. */
    titles?: { [key: string]: string; } | undefined;

    constructor(data?: IPatientFilterValues) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["doctors"])) {
                this.doctors = [] as any;
                for (let item of _data["doctors"])
                    this.doctors!.push(DoctorLiteInfo.fromJS(item));
            }
            if (Array.isArray(_data["documentTypes"])) {
                this.documentTypes = [] as any;
                for (let item of _data["documentTypes"])
                    this.documentTypes!.push(item);
            }
            if (_data["titles"]) {
                this.titles = {} as any;
                for (let key in _data["titles"]) {
                    if (_data["titles"].hasOwnProperty(key))
                        (<any>this.titles)![key] = _data["titles"][key];
                }
            }
        }
    }

    static fromJS(data: any): PatientFilterValues {
        data = typeof data === 'object' ? data : {};
        let result = new PatientFilterValues();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.doctors)) {
            data["doctors"] = [];
            for (let item of this.doctors)
                data["doctors"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.documentTypes)) {
            data["documentTypes"] = [];
            for (let item of this.documentTypes)
                data["documentTypes"].push(item);
        }
        if (this.titles) {
            data["titles"] = {};
            for (let key in this.titles) {
                if (this.titles.hasOwnProperty(key))
                    (<any>data["titles"])[key] = (<any>this.titles)[key];
            }
        }
        return data;
    }
}

/** Contains the definition of an object of type PatientFilterValues. */
export interface IPatientFilterValues {
    /** Gets or sets the doctors. */
    doctors?: DoctorLiteInfo[] | undefined;
    /** Gets or sets the document types. */
    documentTypes?: DocumentType[] | undefined;
    /** Gets or sets the titles.
Must be composed of title + object id. */
    titles?: { [key: string]: string; } | undefined;
}

/** Contains the definition of an object of type DocumentToPatient. */
export class DocumentToPatient implements IDocumentToPatient {
    /** Gets or sets the consultation id. */
    consultationId!: number;
    /** Gets or sets the names. */
    documentId!: number;
    /** Gets or sets the consultation document template identifier. */
    consultationDocumentTemplateId?: number | undefined;
    /** Gets or sets the prescription type. */
    prescriptionType?: PrescriptionType | undefined;

    constructor(data?: IDocumentToPatient) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.consultationId = _data["ConsultationId"];
            this.documentId = _data["DocumentId"];
            this.consultationDocumentTemplateId = _data["ConsultationDocumentTemplateId"];
            this.prescriptionType = _data["PrescriptionType"];
        }
    }

    static fromJS(data: any): DocumentToPatient {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentToPatient();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ConsultationId"] = this.consultationId;
        data["DocumentId"] = this.documentId;
        data["ConsultationDocumentTemplateId"] = this.consultationDocumentTemplateId;
        data["PrescriptionType"] = this.prescriptionType;
        return data;
    }
}

/** Contains the definition of an object of type DocumentToPatient. */
export interface IDocumentToPatient {
    /** Gets or sets the consultation id. */
    consultationId: number;
    /** Gets or sets the names. */
    documentId: number;
    /** Gets or sets the consultation document template identifier. */
    consultationDocumentTemplateId?: number | undefined;
    /** Gets or sets the prescription type. */
    prescriptionType?: PrescriptionType | undefined;
}

/** Contains the definition of an object of type PatientDocumentEdition. */
export class PatientDocumentEdition extends PatientDocumentCreation implements IPatientDocumentEdition {
    /** Gets or sets the document identifier. */
    documentId!: number;

    constructor(data?: IPatientDocumentEdition) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.documentId = _data["documentId"];
        }
    }

    static override fromJS(data: any): PatientDocumentEdition {
        data = typeof data === 'object' ? data : {};
        let result = new PatientDocumentEdition();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentId"] = this.documentId;
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type PatientDocumentEdition. */
export interface IPatientDocumentEdition extends IPatientDocumentCreation {
    /** Gets or sets the document identifier. */
    documentId: number;
}

/** Contains the definition of an object of type UpdateDoctorDocument. */
export class UpdateDoctorDocument extends DocumentCreation implements IUpdateDoctorDocument {
    /** Gets or sets the document identifier. */
    documentId!: number;
    /** Gets or sets a value indicating whether the document should be sent automatically to the patient. */
    autoSendToPatient!: boolean;
    /** Gets or sets the HTML content. */
    htmlContent?: string | undefined;

    constructor(data?: IUpdateDoctorDocument) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.documentId = _data["documentId"];
            this.autoSendToPatient = _data["autoSendToPatient"];
            this.htmlContent = _data["htmlContent"];
        }
    }

    static override fromJS(data: any): UpdateDoctorDocument {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDoctorDocument();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentId"] = this.documentId;
        data["autoSendToPatient"] = this.autoSendToPatient;
        data["htmlContent"] = this.htmlContent;
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type UpdateDoctorDocument. */
export interface IUpdateDoctorDocument extends IDocumentCreation {
    /** Gets or sets the document identifier. */
    documentId: number;
    /** Gets or sets a value indicating whether the document should be sent automatically to the patient. */
    autoSendToPatient: boolean;
    /** Gets or sets the HTML content. */
    htmlContent?: string | undefined;
}

/** Contains the definition of an object of type TimeSlot. */
export class TimeSlot implements ITimeSlot {
    /** Gets or sets the identifier. */
    id!: number;
    /** Gets or sets the doctor identifier. */
    doctorId!: number;
    /** Gets or sets the title. */
    title?: string | undefined;
    /** Gets or sets the start date time. */
    startDateTime!: Date;
    /** Gets or sets the end date time. */
    endDateTime!: Date;
    /** Gets or sets a value indicating whether this instance is recurring. */
    isRecurring!: boolean;
    /** Gets or sets the frequency. */
    frequency?: FrequencyEnum | undefined;
    /** Gets or sets the until date. */
    untilDate?: Date | undefined;
    /** Gets or sets the onsite consultation configs. */
    consultationTypes?: ConsultationConfig[] | undefined;
    /** Gets or sets the remote consultation configs. */
    remoteConsultationTypes?: ConsultationConfig[] | undefined;
    /** Gets or sets the medical office. */
    medicalOfficeId?: number | undefined;
    /** Gets or sets the medical office name. */
    medicalOfficeName?: string | undefined;

    constructor(data?: ITimeSlot) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.doctorId = _data["doctorId"];
            this.title = _data["title"];
            this.startDateTime = _data["startDateTime"] ? new Date(_data["startDateTime"].toString()) : <any>undefined;
            this.endDateTime = _data["endDateTime"] ? new Date(_data["endDateTime"].toString()) : <any>undefined;
            this.isRecurring = _data["isRecurring"];
            this.frequency = _data["frequency"];
            this.untilDate = _data["untilDate"] ? new Date(_data["untilDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["consultationTypes"])) {
                this.consultationTypes = [] as any;
                for (let item of _data["consultationTypes"])
                    this.consultationTypes!.push(ConsultationConfig.fromJS(item));
            }
            if (Array.isArray(_data["remoteConsultationTypes"])) {
                this.remoteConsultationTypes = [] as any;
                for (let item of _data["remoteConsultationTypes"])
                    this.remoteConsultationTypes!.push(ConsultationConfig.fromJS(item));
            }
            this.medicalOfficeId = _data["medicalOfficeId"];
            this.medicalOfficeName = _data["medicalOfficeName"];
        }
    }

    static fromJS(data: any): TimeSlot {
        data = typeof data === 'object' ? data : {};
        let result = new TimeSlot();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["doctorId"] = this.doctorId;
        data["title"] = this.title;
        data["startDateTime"] = this.startDateTime ? this.startDateTime.toISOString() : <any>undefined;
        data["endDateTime"] = this.endDateTime ? this.endDateTime.toISOString() : <any>undefined;
        data["isRecurring"] = this.isRecurring;
        data["frequency"] = this.frequency;
        data["untilDate"] = this.untilDate ? this.untilDate.toISOString() : <any>undefined;
        if (Array.isArray(this.consultationTypes)) {
            data["consultationTypes"] = [];
            for (let item of this.consultationTypes)
                data["consultationTypes"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.remoteConsultationTypes)) {
            data["remoteConsultationTypes"] = [];
            for (let item of this.remoteConsultationTypes)
                data["remoteConsultationTypes"].push(item ? item.toJSON() : <any>undefined);
        }
        data["medicalOfficeId"] = this.medicalOfficeId;
        data["medicalOfficeName"] = this.medicalOfficeName;
        return data;
    }
}

/** Contains the definition of an object of type TimeSlot. */
export interface ITimeSlot {
    /** Gets or sets the identifier. */
    id: number;
    /** Gets or sets the doctor identifier. */
    doctorId: number;
    /** Gets or sets the title. */
    title?: string | undefined;
    /** Gets or sets the start date time. */
    startDateTime: Date;
    /** Gets or sets the end date time. */
    endDateTime: Date;
    /** Gets or sets a value indicating whether this instance is recurring. */
    isRecurring: boolean;
    /** Gets or sets the frequency. */
    frequency?: FrequencyEnum | undefined;
    /** Gets or sets the until date. */
    untilDate?: Date | undefined;
    /** Gets or sets the onsite consultation configs. */
    consultationTypes?: ConsultationConfig[] | undefined;
    /** Gets or sets the remote consultation configs. */
    remoteConsultationTypes?: ConsultationConfig[] | undefined;
    /** Gets or sets the medical office. */
    medicalOfficeId?: number | undefined;
    /** Gets or sets the medical office name. */
    medicalOfficeName?: string | undefined;
}

/** Enum of the different frequencies possible. */
export enum FrequencyEnum {
    Unknown = 0,
    Weekly = 1,
    EveryTwoWeek = 2,
    EveryFourWeek = 3,
}

/** Contains the definition of an object of type AgendaUnavailability. */
export class AgendaUnavailability implements IAgendaUnavailability {
    /** Gets or sets the identifier. */
    id!: number;
    /** Gets or sets the title. */
    title?: string | undefined;
    /** Gets or sets the doctor identifier. */
    doctorId!: number;
    /** Gets or sets the end date. */
    startDateTime!: Date;
    /** Gets or sets the start date. */
    endDateTime!: Date;
    /** Gets or sets the type. */
    type!: AgendaUnavailabilityType;
    /** Gets or sets the event contact id. */
    eventContactId?: number | undefined;
    /** Gets or sets the event contact. */
    eventContact?: AgendaUnavailabilityEventContact | undefined;
    /** Gets or sets the color. */
    color?: string | undefined;
    /** Gets or sets a value indicating whether this instance is recurring. */
    isRecurring!: boolean;
    /** Gets or sets the frequency. */
    frequency?: FrequencyEnum | undefined;
    /** Gets or sets the until date. */
    untilDate?: Date | undefined;

    constructor(data?: IAgendaUnavailability) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.doctorId = _data["doctorId"];
            this.startDateTime = _data["startDateTime"] ? new Date(_data["startDateTime"].toString()) : <any>undefined;
            this.endDateTime = _data["endDateTime"] ? new Date(_data["endDateTime"].toString()) : <any>undefined;
            this.type = _data["type"];
            this.eventContactId = _data["eventContactId"];
            this.eventContact = _data["eventContact"] ? AgendaUnavailabilityEventContact.fromJS(_data["eventContact"]) : <any>undefined;
            this.color = _data["color"];
            this.isRecurring = _data["isRecurring"];
            this.frequency = _data["frequency"];
            this.untilDate = _data["untilDate"] ? new Date(_data["untilDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): AgendaUnavailability {
        data = typeof data === 'object' ? data : {};
        let result = new AgendaUnavailability();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["doctorId"] = this.doctorId;
        data["startDateTime"] = this.startDateTime ? this.startDateTime.toISOString() : <any>undefined;
        data["endDateTime"] = this.endDateTime ? this.endDateTime.toISOString() : <any>undefined;
        data["type"] = this.type;
        data["eventContactId"] = this.eventContactId;
        data["eventContact"] = this.eventContact ? this.eventContact.toJSON() : <any>undefined;
        data["color"] = this.color;
        data["isRecurring"] = this.isRecurring;
        data["frequency"] = this.frequency;
        data["untilDate"] = this.untilDate ? this.untilDate.toISOString() : <any>undefined;
        return data;
    }
}

/** Contains the definition of an object of type AgendaUnavailability. */
export interface IAgendaUnavailability {
    /** Gets or sets the identifier. */
    id: number;
    /** Gets or sets the title. */
    title?: string | undefined;
    /** Gets or sets the doctor identifier. */
    doctorId: number;
    /** Gets or sets the end date. */
    startDateTime: Date;
    /** Gets or sets the start date. */
    endDateTime: Date;
    /** Gets or sets the type. */
    type: AgendaUnavailabilityType;
    /** Gets or sets the event contact id. */
    eventContactId?: number | undefined;
    /** Gets or sets the event contact. */
    eventContact?: AgendaUnavailabilityEventContact | undefined;
    /** Gets or sets the color. */
    color?: string | undefined;
    /** Gets or sets a value indicating whether this instance is recurring. */
    isRecurring: boolean;
    /** Gets or sets the frequency. */
    frequency?: FrequencyEnum | undefined;
    /** Gets or sets the until date. */
    untilDate?: Date | undefined;
}

/** Contains the definition of an object of type AgendaUnavailabilityType */
export enum AgendaUnavailabilityType {
    Classical = 0,
    Event = 1,
}

/** Contains the definition of an object of type AgendaUnavailabilityEventContact. */
export class AgendaUnavailabilityEventContact implements IAgendaUnavailabilityEventContact {
    /** Gets or sets the identifier. */
    id!: number;
    /** Gets or sets the first name. */
    firstName?: string | undefined;
    /** Gets or sets the last name. */
    lastName?: string | undefined;
    /** Gets or sets the email. */
    email?: string | undefined;
    /** Gets or sets the phone number. */
    phoneNumber?: string | undefined;
    /** Gets or sets the address. */
    address?: string | undefined;
    /** Gets or sets the doctor identifier. */
    doctorId!: number;

    constructor(data?: IAgendaUnavailabilityEventContact) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.address = _data["address"];
            this.doctorId = _data["doctorId"];
        }
    }

    static fromJS(data: any): AgendaUnavailabilityEventContact {
        data = typeof data === 'object' ? data : {};
        let result = new AgendaUnavailabilityEventContact();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["address"] = this.address;
        data["doctorId"] = this.doctorId;
        return data;
    }
}

/** Contains the definition of an object of type AgendaUnavailabilityEventContact. */
export interface IAgendaUnavailabilityEventContact {
    /** Gets or sets the identifier. */
    id: number;
    /** Gets or sets the first name. */
    firstName?: string | undefined;
    /** Gets or sets the last name. */
    lastName?: string | undefined;
    /** Gets or sets the email. */
    email?: string | undefined;
    /** Gets or sets the phone number. */
    phoneNumber?: string | undefined;
    /** Gets or sets the address. */
    address?: string | undefined;
    /** Gets or sets the doctor identifier. */
    doctorId: number;
}

/** Contains the definition of an object of type TimeSlot. */
export class DeleteTimeSlot implements IDeleteTimeSlot {
    /** Gets or sets the time slot identifier. */
    timeSlotId!: number;
    /** Gets or sets a value indicating whether to keep recurring occurences. */
    keepRecurringOccurrences!: boolean;
    /** Gets or sets the start date occurence. */
    startDateOccurence?: Date | undefined;
    /** Gets or sets the end date occurence. */
    endDateOccurence?: Date | undefined;

    constructor(data?: IDeleteTimeSlot) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.timeSlotId = _data["timeSlotId"];
            this.keepRecurringOccurrences = _data["keepRecurringOccurrences"];
            this.startDateOccurence = _data["startDateOccurence"] ? new Date(_data["startDateOccurence"].toString()) : <any>undefined;
            this.endDateOccurence = _data["endDateOccurence"] ? new Date(_data["endDateOccurence"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): DeleteTimeSlot {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteTimeSlot();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timeSlotId"] = this.timeSlotId;
        data["keepRecurringOccurrences"] = this.keepRecurringOccurrences;
        data["startDateOccurence"] = this.startDateOccurence ? this.startDateOccurence.toISOString() : <any>undefined;
        data["endDateOccurence"] = this.endDateOccurence ? this.endDateOccurence.toISOString() : <any>undefined;
        return data;
    }
}

/** Contains the definition of an object of type TimeSlot. */
export interface IDeleteTimeSlot {
    /** Gets or sets the time slot identifier. */
    timeSlotId: number;
    /** Gets or sets a value indicating whether to keep recurring occurences. */
    keepRecurringOccurrences: boolean;
    /** Gets or sets the start date occurence. */
    startDateOccurence?: Date | undefined;
    /** Gets or sets the end date occurence. */
    endDateOccurence?: Date | undefined;
}

/** Contains the definition of an object of type NoteToDoNumber. */
export class NoteToDoNumber implements INoteToDoNumber {
    /** Gets or sets the date. */
    date!: Date;
    /** Gets or sets the nb tasks to do. */
    nbNotesToDo!: number;

    constructor(data?: INoteToDoNumber) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.nbNotesToDo = _data["nbNotesToDo"];
        }
    }

    static fromJS(data: any): NoteToDoNumber {
        data = typeof data === 'object' ? data : {};
        let result = new NoteToDoNumber();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["nbNotesToDo"] = this.nbNotesToDo;
        return data;
    }
}

/** Contains the definition of an object of type NoteToDoNumber. */
export interface INoteToDoNumber {
    /** Gets or sets the date. */
    date: Date;
    /** Gets or sets the nb tasks to do. */
    nbNotesToDo: number;
}

/** Contains the definition of an object of type UpdateTimeSlot. */
export class UpdateTimeSlot extends TimeSlot implements IUpdateTimeSlot {
    /** Gets or sets a value indicating whether [keep recurring occurrences]. */
    keepRecurringOccurrences!: boolean;
    /** Gets or sets the start date occurence. */
    startDateOccurence?: Date | undefined;
    /** Gets or sets the end date occurence. */
    endDateOccurence?: Date | undefined;

    constructor(data?: IUpdateTimeSlot) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.keepRecurringOccurrences = _data["keepRecurringOccurrences"];
            this.startDateOccurence = _data["startDateOccurence"] ? new Date(_data["startDateOccurence"].toString()) : <any>undefined;
            this.endDateOccurence = _data["endDateOccurence"] ? new Date(_data["endDateOccurence"].toString()) : <any>undefined;
        }
    }

    static override fromJS(data: any): UpdateTimeSlot {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTimeSlot();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["keepRecurringOccurrences"] = this.keepRecurringOccurrences;
        data["startDateOccurence"] = this.startDateOccurence ? this.startDateOccurence.toISOString() : <any>undefined;
        data["endDateOccurence"] = this.endDateOccurence ? this.endDateOccurence.toISOString() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type UpdateTimeSlot. */
export interface IUpdateTimeSlot extends ITimeSlot {
    /** Gets or sets a value indicating whether [keep recurring occurrences]. */
    keepRecurringOccurrences: boolean;
    /** Gets or sets the start date occurence. */
    startDateOccurence?: Date | undefined;
    /** Gets or sets the end date occurence. */
    endDateOccurence?: Date | undefined;
}

/** Contains the definition of an object of type UpdateNutrient. */
export class BaseEditNutrient implements IBaseEditNutrient {
    /** Gets or sets the name. */
    name?: string | undefined;
    /** Gets or sets the category name. */
    categoryId!: number;
    /** Gets or sets the type of the unit. */
    unitType!: NutrientUnitType;
    /** Gets or sets a value indicating whether this instance is allergen. */
    isAllergen!: boolean;
    /** Gets or sets the synonyms. */
    synonyms?: string[] | undefined;
    /** Gets or sets the suggestible. */
    suggestible?: Suggestible | undefined;

    constructor(data?: IBaseEditNutrient) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.categoryId = _data["categoryId"];
            this.unitType = _data["unitType"];
            this.isAllergen = _data["isAllergen"];
            if (Array.isArray(_data["synonyms"])) {
                this.synonyms = [] as any;
                for (let item of _data["synonyms"])
                    this.synonyms!.push(item);
            }
            this.suggestible = _data["suggestible"] ? Suggestible.fromJS(_data["suggestible"]) : <any>undefined;
        }
    }

    static fromJS(data: any): BaseEditNutrient {
        data = typeof data === 'object' ? data : {};
        let result = new BaseEditNutrient();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["categoryId"] = this.categoryId;
        data["unitType"] = this.unitType;
        data["isAllergen"] = this.isAllergen;
        if (Array.isArray(this.synonyms)) {
            data["synonyms"] = [];
            for (let item of this.synonyms)
                data["synonyms"].push(item);
        }
        data["suggestible"] = this.suggestible ? this.suggestible.toJSON() : <any>undefined;
        return data;
    }
}

/** Contains the definition of an object of type UpdateNutrient. */
export interface IBaseEditNutrient {
    /** Gets or sets the name. */
    name?: string | undefined;
    /** Gets or sets the category name. */
    categoryId: number;
    /** Gets or sets the type of the unit. */
    unitType: NutrientUnitType;
    /** Gets or sets a value indicating whether this instance is allergen. */
    isAllergen: boolean;
    /** Gets or sets the synonyms. */
    synonyms?: string[] | undefined;
    /** Gets or sets the suggestible. */
    suggestible?: Suggestible | undefined;
}

/** Contains the definition of an object of type CreateNutrient. */
export class CreateNutrient extends BaseEditNutrient implements ICreateNutrient {

    constructor(data?: ICreateNutrient) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): CreateNutrient {
        data = typeof data === 'object' ? data : {};
        let result = new CreateNutrient();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type CreateNutrient. */
export interface ICreateNutrient extends IBaseEditNutrient {
}

/** Contains the definition of an object of type DropdownValue. */
export class DropdownValue2 implements IDropdownValue2 {
    /** Gets or sets the identifier. */
    id!: number;
    /** Gets or sets the label. */
    label?: string | undefined;

    constructor(data?: IDropdownValue2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.label = _data["Label"];
        }
    }

    static fromJS(data: any): DropdownValue2 {
        data = typeof data === 'object' ? data : {};
        let result = new DropdownValue2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Label"] = this.label;
        return data;
    }
}

/** Contains the definition of an object of type DropdownValue. */
export interface IDropdownValue2 {
    /** Gets or sets the identifier. */
    id: number;
    /** Gets or sets the label. */
    label?: string | undefined;
}

/** Contains the definition of an object of type IngredientDetails. */
export class IngredientDetails extends Ingredient implements IIngredientDetails {
    /** Gets or sets the quantity. */
    quantity!: number;
    /** Gets or sets the quantity per portion. */
    quantityPerPortion!: number;
    /** Gets or sets the unittypeid */
    unitTypeId!: number;
    /** Gets or sets the unittypeid */
    proteins!: number;
    /** Gets or sets the unittypeid */
    lipids!: number;
    /** Gets or sets the unittypeid */
    carbs!: number;
    /** Gets or sets the nutrient with quantities. */
    nutrients?: RecipeNutrientLite[] | undefined;
    /** Gets or sets the nutrient categories. */
    nutrientCategories?: RecipeNutrientCategory[] | undefined;
    /** Gets or sets the calorific power per portion. */
    calorificPowerPerPortion!: number;

    constructor(data?: IIngredientDetails) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.quantity = _data["quantity"];
            this.quantityPerPortion = _data["quantityPerPortion"];
            this.unitTypeId = _data["unitTypeId"];
            this.proteins = _data["proteins"];
            this.lipids = _data["lipids"];
            this.carbs = _data["carbs"];
            if (Array.isArray(_data["nutrients"])) {
                this.nutrients = [] as any;
                for (let item of _data["nutrients"])
                    this.nutrients!.push(RecipeNutrientLite.fromJS(item));
            }
            if (Array.isArray(_data["nutrientCategories"])) {
                this.nutrientCategories = [] as any;
                for (let item of _data["nutrientCategories"])
                    this.nutrientCategories!.push(RecipeNutrientCategory.fromJS(item));
            }
            this.calorificPowerPerPortion = _data["calorificPowerPerPortion"];
        }
    }

    static override fromJS(data: any): IngredientDetails {
        data = typeof data === 'object' ? data : {};
        let result = new IngredientDetails();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["quantity"] = this.quantity;
        data["quantityPerPortion"] = this.quantityPerPortion;
        data["unitTypeId"] = this.unitTypeId;
        data["proteins"] = this.proteins;
        data["lipids"] = this.lipids;
        data["carbs"] = this.carbs;
        if (Array.isArray(this.nutrients)) {
            data["nutrients"] = [];
            for (let item of this.nutrients)
                data["nutrients"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.nutrientCategories)) {
            data["nutrientCategories"] = [];
            for (let item of this.nutrientCategories)
                data["nutrientCategories"].push(item ? item.toJSON() : <any>undefined);
        }
        data["calorificPowerPerPortion"] = this.calorificPowerPerPortion;
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type IngredientDetails. */
export interface IIngredientDetails extends IIngredient {
    /** Gets or sets the quantity. */
    quantity: number;
    /** Gets or sets the quantity per portion. */
    quantityPerPortion: number;
    /** Gets or sets the unittypeid */
    unitTypeId: number;
    /** Gets or sets the unittypeid */
    proteins: number;
    /** Gets or sets the unittypeid */
    lipids: number;
    /** Gets or sets the unittypeid */
    carbs: number;
    /** Gets or sets the nutrient with quantities. */
    nutrients?: RecipeNutrientLite[] | undefined;
    /** Gets or sets the nutrient categories. */
    nutrientCategories?: RecipeNutrientCategory[] | undefined;
    /** Gets or sets the calorific power per portion. */
    calorificPowerPerPortion: number;
}

export class PaginatorWrapperOfIEnumerableOfIngredientForLibrary implements IPaginatorWrapperOfIEnumerableOfIngredientForLibrary {
    totalRecords!: number;
    data?: IngredientForLibrary[] | undefined;

    constructor(data?: IPaginatorWrapperOfIEnumerableOfIngredientForLibrary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRecords = _data["totalRecords"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(IngredientForLibrary.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatorWrapperOfIEnumerableOfIngredientForLibrary {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatorWrapperOfIEnumerableOfIngredientForLibrary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IPaginatorWrapperOfIEnumerableOfIngredientForLibrary {
    totalRecords: number;
    data?: IngredientForLibrary[] | undefined;
}

/** Contains the definition of an object of type IngredientForLibrary. */
export class IngredientForLibrary extends Ingredient implements IIngredientForLibrary {
    /** Gets or sets a value indicating whether ingredient Is Selected in library. */
    isSelected!: boolean;

    constructor(data?: IIngredientForLibrary) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.isSelected = _data["IsSelected"];
        }
    }

    static override fromJS(data: any): IngredientForLibrary {
        data = typeof data === 'object' ? data : {};
        let result = new IngredientForLibrary();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["IsSelected"] = this.isSelected;
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type IngredientForLibrary. */
export interface IIngredientForLibrary extends IIngredient {
    /** Gets or sets a value indicating whether ingredient Is Selected in library. */
    isSelected: boolean;
}

/** Contains the definition of an object of type CalnutSearchParams. */
export class CalnutSearchParams extends SearchParams implements ICalnutSearchParams {
    /** Gets or sets the title. */
    name?: string | undefined;
    /** Gets or sets the nutrition program meal Id. */
    nutritionProgramMealId?: number | undefined;
    /** Gets or sets the Allergens. */
    allergens?: number[] | undefined;
    /** Gets or sets a value indicating whether the ingredient is a custom ingredient.. */
    isCustomIngredient!: boolean;

    constructor(data?: ICalnutSearchParams) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.nutritionProgramMealId = _data["nutritionProgramMealId"];
            if (Array.isArray(_data["allergens"])) {
                this.allergens = [] as any;
                for (let item of _data["allergens"])
                    this.allergens!.push(item);
            }
            this.isCustomIngredient = _data["isCustomIngredient"];
        }
    }

    static override fromJS(data: any): CalnutSearchParams {
        data = typeof data === 'object' ? data : {};
        let result = new CalnutSearchParams();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["nutritionProgramMealId"] = this.nutritionProgramMealId;
        if (Array.isArray(this.allergens)) {
            data["allergens"] = [];
            for (let item of this.allergens)
                data["allergens"].push(item);
        }
        data["isCustomIngredient"] = this.isCustomIngredient;
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type CalnutSearchParams. */
export interface ICalnutSearchParams extends ISearchParams {
    /** Gets or sets the title. */
    name?: string | undefined;
    /** Gets or sets the nutrition program meal Id. */
    nutritionProgramMealId?: number | undefined;
    /** Gets or sets the Allergens. */
    allergens?: number[] | undefined;
    /** Gets or sets a value indicating whether the ingredient is a custom ingredient.. */
    isCustomIngredient: boolean;
}

/** Contains the definition of an object of type UpdateNutrient. */
export class UpdateNutrient extends BaseEditNutrient implements IUpdateNutrient {
    /** Gets or sets the identifier. */
    id!: number;

    constructor(data?: IUpdateNutrient) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
        }
    }

    static override fromJS(data: any): UpdateNutrient {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateNutrient();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type UpdateNutrient. */
export interface IUpdateNutrient extends IBaseEditNutrient {
    /** Gets or sets the identifier. */
    id: number;
}

export class PaginatorWrapperOfIEnumerableOfIngredientCalnut implements IPaginatorWrapperOfIEnumerableOfIngredientCalnut {
    totalRecords!: number;
    data?: IngredientCalnut[] | undefined;

    constructor(data?: IPaginatorWrapperOfIEnumerableOfIngredientCalnut) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRecords = _data["totalRecords"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(IngredientCalnut.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatorWrapperOfIEnumerableOfIngredientCalnut {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatorWrapperOfIEnumerableOfIngredientCalnut();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IPaginatorWrapperOfIEnumerableOfIngredientCalnut {
    totalRecords: number;
    data?: IngredientCalnut[] | undefined;
}

/** Contains the definition of an object of type IngredientCalnut. */
export class IngredientCalnut implements IIngredientCalnut {
    /** Gets or sets the calorific power kcal. */
    calorificPowerKcal!: number;
    /** Gets or sets the dab to gr equivalence. */
    dabToGrEquivalence?: number | undefined;
    /** Gets or sets the food category identifier. */
    foodCategoryId!: number;
    /** Gets or sets the identifier. */
    id!: number;
    /** Gets or sets the knob to gr equivalence. */
    knobToGrEquivalence?: number | undefined;
    /** Gets or sets the name. */
    name?: string | undefined;
    /** Gets or sets the one and half to gr equivalence. */
    oneAndHalfToGrEquivalence?: number | undefined;
    /** Gets or sets the piece to gr equivalence. */
    pieceToGrEquivalence?: number | undefined;
    /** Gets or sets the pinch to gr equivalence. */
    pinchToGrEquivalence?: number | undefined;
    /** Gets or sets the ingredient foods. */
    foods?: number[] | undefined;
    /** Gets or sets the nutrient ingredients. */
    ingredientNutrients?: IngredientNutrient[] | undefined;
    /** Gets or sets a value indicating whether is use. */
    isUsed!: boolean;
    /** Gets or sets the Doctor identifier. */
    doctorId?: number | undefined;
    /** Gets or sets the current status of the ingredient. */
    status!: IngredientStatus;
    /** Gets or sets the comment added by SiiN team when validating the ingredient. */
    comment?: string | undefined;

    constructor(data?: IIngredientCalnut) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.calorificPowerKcal = _data["calorificPowerKcal"];
            this.dabToGrEquivalence = _data["dabToGrEquivalence"];
            this.foodCategoryId = _data["foodCategoryId"];
            this.id = _data["id"];
            this.knobToGrEquivalence = _data["knobToGrEquivalence"];
            this.name = _data["name"];
            this.oneAndHalfToGrEquivalence = _data["oneAndHalfToGrEquivalence"];
            this.pieceToGrEquivalence = _data["pieceToGrEquivalence"];
            this.pinchToGrEquivalence = _data["pinchToGrEquivalence"];
            if (Array.isArray(_data["foods"])) {
                this.foods = [] as any;
                for (let item of _data["foods"])
                    this.foods!.push(item);
            }
            if (Array.isArray(_data["ingredientNutrients"])) {
                this.ingredientNutrients = [] as any;
                for (let item of _data["ingredientNutrients"])
                    this.ingredientNutrients!.push(IngredientNutrient.fromJS(item));
            }
            this.isUsed = _data["isUsed"];
            this.doctorId = _data["doctorId"];
            this.status = _data["status"];
            this.comment = _data["comment"];
        }
    }

    static fromJS(data: any): IngredientCalnut {
        data = typeof data === 'object' ? data : {};
        let result = new IngredientCalnut();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["calorificPowerKcal"] = this.calorificPowerKcal;
        data["dabToGrEquivalence"] = this.dabToGrEquivalence;
        data["foodCategoryId"] = this.foodCategoryId;
        data["id"] = this.id;
        data["knobToGrEquivalence"] = this.knobToGrEquivalence;
        data["name"] = this.name;
        data["oneAndHalfToGrEquivalence"] = this.oneAndHalfToGrEquivalence;
        data["pieceToGrEquivalence"] = this.pieceToGrEquivalence;
        data["pinchToGrEquivalence"] = this.pinchToGrEquivalence;
        if (Array.isArray(this.foods)) {
            data["foods"] = [];
            for (let item of this.foods)
                data["foods"].push(item);
        }
        if (Array.isArray(this.ingredientNutrients)) {
            data["ingredientNutrients"] = [];
            for (let item of this.ingredientNutrients)
                data["ingredientNutrients"].push(item ? item.toJSON() : <any>undefined);
        }
        data["isUsed"] = this.isUsed;
        data["doctorId"] = this.doctorId;
        data["status"] = this.status;
        data["comment"] = this.comment;
        return data;
    }
}

/** Contains the definition of an object of type IngredientCalnut. */
export interface IIngredientCalnut {
    /** Gets or sets the calorific power kcal. */
    calorificPowerKcal: number;
    /** Gets or sets the dab to gr equivalence. */
    dabToGrEquivalence?: number | undefined;
    /** Gets or sets the food category identifier. */
    foodCategoryId: number;
    /** Gets or sets the identifier. */
    id: number;
    /** Gets or sets the knob to gr equivalence. */
    knobToGrEquivalence?: number | undefined;
    /** Gets or sets the name. */
    name?: string | undefined;
    /** Gets or sets the one and half to gr equivalence. */
    oneAndHalfToGrEquivalence?: number | undefined;
    /** Gets or sets the piece to gr equivalence. */
    pieceToGrEquivalence?: number | undefined;
    /** Gets or sets the pinch to gr equivalence. */
    pinchToGrEquivalence?: number | undefined;
    /** Gets or sets the ingredient foods. */
    foods?: number[] | undefined;
    /** Gets or sets the nutrient ingredients. */
    ingredientNutrients?: IngredientNutrient[] | undefined;
    /** Gets or sets a value indicating whether is use. */
    isUsed: boolean;
    /** Gets or sets the Doctor identifier. */
    doctorId?: number | undefined;
    /** Gets or sets the current status of the ingredient. */
    status: IngredientStatus;
    /** Gets or sets the comment added by SiiN team when validating the ingredient. */
    comment?: string | undefined;
}

/** Contains the definition of an object of type IngredientSearchParams. */
export class IngredientSearchParams extends SearchParams implements IIngredientSearchParams {
    /** Gets or sets the name. */
    name?: string | undefined;
    /** Gets or sets the food category identifier. */
    foodCategoryIds?: number[] | undefined;
    /** Gets or sets the food identifier. */
    foodIds?: number[] | undefined;
    /** Gets or sets the status. */
    status!: IngredientStatus;

    constructor(data?: IIngredientSearchParams) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            if (Array.isArray(_data["foodCategoryIds"])) {
                this.foodCategoryIds = [] as any;
                for (let item of _data["foodCategoryIds"])
                    this.foodCategoryIds!.push(item);
            }
            if (Array.isArray(_data["foodIds"])) {
                this.foodIds = [] as any;
                for (let item of _data["foodIds"])
                    this.foodIds!.push(item);
            }
            this.status = _data["status"];
        }
    }

    static override fromJS(data: any): IngredientSearchParams {
        data = typeof data === 'object' ? data : {};
        let result = new IngredientSearchParams();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.foodCategoryIds)) {
            data["foodCategoryIds"] = [];
            for (let item of this.foodCategoryIds)
                data["foodCategoryIds"].push(item);
        }
        if (Array.isArray(this.foodIds)) {
            data["foodIds"] = [];
            for (let item of this.foodIds)
                data["foodIds"].push(item);
        }
        data["status"] = this.status;
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type IngredientSearchParams. */
export interface IIngredientSearchParams extends ISearchParams {
    /** Gets or sets the name. */
    name?: string | undefined;
    /** Gets or sets the food category identifier. */
    foodCategoryIds?: number[] | undefined;
    /** Gets or sets the food identifier. */
    foodIds?: number[] | undefined;
    /** Gets or sets the status. */
    status: IngredientStatus;
}

/** Contains the definition of an object of type IngredientCalnut. */
export class FoodCategory implements IFoodCategory {
    /** Gets or sets the identifier. */
    id!: number;
    /** Gets or sets the name. */
    name?: string | undefined;

    constructor(data?: IFoodCategory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): FoodCategory {
        data = typeof data === 'object' ? data : {};
        let result = new FoodCategory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

/** Contains the definition of an object of type IngredientCalnut. */
export interface IFoodCategory {
    /** Gets or sets the identifier. */
    id: number;
    /** Gets or sets the name. */
    name?: string | undefined;
}

/** Contains the definition of an object of type Food. */
export class Food implements IFood {
    /** Gets or sets the identifier. */
    id!: number;
    /** Gets or sets the name. */
    name?: string | undefined;

    constructor(data?: IFood) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): Food {
        data = typeof data === 'object' ? data : {};
        let result = new Food();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

/** Contains the definition of an object of type Food. */
export interface IFood {
    /** Gets or sets the identifier. */
    id: number;
    /** Gets or sets the name. */
    name?: string | undefined;
}

/** Contains the definition of an object of type ValidateIngredient. */
export class ValidateIngredient implements IValidateIngredient {
    /** Gets or sets the identifier. */
    id!: number;
    /** Gets or sets the status. */
    status!: IngredientStatus;

    constructor(data?: IValidateIngredient) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): ValidateIngredient {
        data = typeof data === 'object' ? data : {};
        let result = new ValidateIngredient();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["status"] = this.status;
        return data;
    }
}

/** Contains the definition of an object of type ValidateIngredient. */
export interface IValidateIngredient {
    /** Gets or sets the identifier. */
    id: number;
    /** Gets or sets the status. */
    status: IngredientStatus;
}

/** Contains the definition of an object of type ComplexSatisfactionForm. */
export class ComplexSatisfactionForm implements IComplexSatisfactionForm {
    /** Gets or sets the technical id. */
    technicalId?: string | undefined;
    /** Gets or sets the token. */
    token?: string | undefined;
    /** Gets or sets the answers. */
    answers?: ComplexSatisfactionAnswer[] | undefined;

    constructor(data?: IComplexSatisfactionForm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.technicalId = _data["technicalId"];
            this.token = _data["token"];
            if (Array.isArray(_data["answers"])) {
                this.answers = [] as any;
                for (let item of _data["answers"])
                    this.answers!.push(ComplexSatisfactionAnswer.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ComplexSatisfactionForm {
        data = typeof data === 'object' ? data : {};
        let result = new ComplexSatisfactionForm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["technicalId"] = this.technicalId;
        data["token"] = this.token;
        if (Array.isArray(this.answers)) {
            data["answers"] = [];
            for (let item of this.answers)
                data["answers"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

/** Contains the definition of an object of type ComplexSatisfactionForm. */
export interface IComplexSatisfactionForm {
    /** Gets or sets the technical id. */
    technicalId?: string | undefined;
    /** Gets or sets the token. */
    token?: string | undefined;
    /** Gets or sets the answers. */
    answers?: ComplexSatisfactionAnswer[] | undefined;
}

/** Contains the definition of an object of type ComplexSatisfactionAnswerBase. */
export class ComplexSatisfactionAnswerBase implements IComplexSatisfactionAnswerBase {
    /** Gets or sets the value. */
    value?: string | undefined;
    /** Gets or sets the key. */
    key?: string | undefined;

    constructor(data?: IComplexSatisfactionAnswerBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.key = _data["key"];
        }
    }

    static fromJS(data: any): ComplexSatisfactionAnswerBase {
        data = typeof data === 'object' ? data : {};
        let result = new ComplexSatisfactionAnswerBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["key"] = this.key;
        return data;
    }
}

/** Contains the definition of an object of type ComplexSatisfactionAnswerBase. */
export interface IComplexSatisfactionAnswerBase {
    /** Gets or sets the value. */
    value?: string | undefined;
    /** Gets or sets the key. */
    key?: string | undefined;
}

/** Contains the definition of an object of type ComplexSatisfactionAnswer. */
export class ComplexSatisfactionAnswer extends ComplexSatisfactionAnswerBase implements IComplexSatisfactionAnswer {
    /** Gets or sets the values. */
    values?: ComplexSatisfactionAnswerBase[] | undefined;

    constructor(data?: IComplexSatisfactionAnswer) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["values"])) {
                this.values = [] as any;
                for (let item of _data["values"])
                    this.values!.push(ComplexSatisfactionAnswerBase.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): ComplexSatisfactionAnswer {
        data = typeof data === 'object' ? data : {};
        let result = new ComplexSatisfactionAnswer();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.values)) {
            data["values"] = [];
            for (let item of this.values)
                data["values"].push(item ? item.toJSON() : <any>undefined);
        }
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type ComplexSatisfactionAnswer. */
export interface IComplexSatisfactionAnswer extends IComplexSatisfactionAnswerBase {
    /** Gets or sets the values. */
    values?: ComplexSatisfactionAnswerBase[] | undefined;
}

export class PaginatorWrapperOfIEnumerableOfSatisfactionForm implements IPaginatorWrapperOfIEnumerableOfSatisfactionForm {
    totalRecords!: number;
    data?: SatisfactionForm[] | undefined;

    constructor(data?: IPaginatorWrapperOfIEnumerableOfSatisfactionForm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRecords = _data["totalRecords"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(SatisfactionForm.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatorWrapperOfIEnumerableOfSatisfactionForm {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatorWrapperOfIEnumerableOfSatisfactionForm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IPaginatorWrapperOfIEnumerableOfSatisfactionForm {
    totalRecords: number;
    data?: SatisfactionForm[] | undefined;
}

/** Contains the definition of an object of type SatisfactionForm. */
export class SatisfactionForm implements ISatisfactionForm {
    /** Gets or sets the name. */
    id!: number;
    /** Gets or sets the name. */
    name?: string | undefined;
    /** Gets or sets the firstname. */
    firstname?: string | undefined;
    /** Gets or sets the member Id. */
    memberId?: number | undefined;
    /** Gets or sets the FormularyNameLong. */
    formationNameLong?: string | undefined;
    /** Gets or sets the FormularyNameShort. */
    formationNameShort?: string | undefined;
    /** Gets or sets the formularyType. */
    formularyType?: string | undefined;
    /** Gets or sets the CompleteDate. */
    completeDate!: Date;
    /** Gets or sets the session year. */
    year?: number | undefined;
    /** Gets or sets a value indicating whether this instance is seen. */
    isSeen!: boolean;

    constructor(data?: ISatisfactionForm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.firstname = _data["firstname"];
            this.memberId = _data["memberId"];
            this.formationNameLong = _data["formationNameLong"];
            this.formationNameShort = _data["formationNameShort"];
            this.formularyType = _data["formularyType"];
            this.completeDate = _data["completeDate"] ? new Date(_data["completeDate"].toString()) : <any>undefined;
            this.year = _data["year"];
            this.isSeen = _data["isSeen"];
        }
    }

    static fromJS(data: any): SatisfactionForm {
        data = typeof data === 'object' ? data : {};
        let result = new SatisfactionForm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["firstname"] = this.firstname;
        data["memberId"] = this.memberId;
        data["formationNameLong"] = this.formationNameLong;
        data["formationNameShort"] = this.formationNameShort;
        data["formularyType"] = this.formularyType;
        data["completeDate"] = this.completeDate ? this.completeDate.toISOString() : <any>undefined;
        data["year"] = this.year;
        data["isSeen"] = this.isSeen;
        return data;
    }
}

/** Contains the definition of an object of type SatisfactionForm. */
export interface ISatisfactionForm {
    /** Gets or sets the name. */
    id: number;
    /** Gets or sets the name. */
    name?: string | undefined;
    /** Gets or sets the firstname. */
    firstname?: string | undefined;
    /** Gets or sets the member Id. */
    memberId?: number | undefined;
    /** Gets or sets the FormularyNameLong. */
    formationNameLong?: string | undefined;
    /** Gets or sets the FormularyNameShort. */
    formationNameShort?: string | undefined;
    /** Gets or sets the formularyType. */
    formularyType?: string | undefined;
    /** Gets or sets the CompleteDate. */
    completeDate: Date;
    /** Gets or sets the session year. */
    year?: number | undefined;
    /** Gets or sets a value indicating whether this instance is seen. */
    isSeen: boolean;
}

/** Contains the definition of an object of type SatisfactionFormParams. */
export class SatisfactionFormParams extends SearchParams implements ISatisfactionFormParams {
    /** Gets or sets the name. */
    name?: string | undefined;
    /** Gets or sets the firstname. */
    firstname?: string | undefined;
    /** Gets or sets the formationName. */
    formationName?: string | undefined;
    /** Gets or sets the formularyType. */
    formularyType?: string | undefined;
    /** Gets or sets the role. */
    role?: string | undefined;
    /** Gets or sets the startDate. */
    startDate?: Date | undefined;
    /** Gets or sets the endDate. */
    endDate?: Date | undefined;
    /** Gets or sets the email. */
    email?: string | undefined;
    /** Gets or sets the session year. */
    year?: number | undefined;
    /** Gets or sets the subvention organization Id. */
    subventionOrganizationId?: number | undefined;
    /** Gets or sets a value indicating whether this instance is seen. */
    isSeen?: boolean | undefined;

    constructor(data?: ISatisfactionFormParams) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.firstname = _data["firstname"];
            this.formationName = _data["formationName"];
            this.formularyType = _data["formularyType"];
            this.role = _data["role"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.email = _data["email"];
            this.year = _data["year"];
            this.subventionOrganizationId = _data["subventionOrganizationId"];
            this.isSeen = _data["isSeen"];
        }
    }

    static override fromJS(data: any): SatisfactionFormParams {
        data = typeof data === 'object' ? data : {};
        let result = new SatisfactionFormParams();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["firstname"] = this.firstname;
        data["formationName"] = this.formationName;
        data["formularyType"] = this.formularyType;
        data["role"] = this.role;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["email"] = this.email;
        data["year"] = this.year;
        data["subventionOrganizationId"] = this.subventionOrganizationId;
        data["isSeen"] = this.isSeen;
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type SatisfactionFormParams. */
export interface ISatisfactionFormParams extends ISearchParams {
    /** Gets or sets the name. */
    name?: string | undefined;
    /** Gets or sets the firstname. */
    firstname?: string | undefined;
    /** Gets or sets the formationName. */
    formationName?: string | undefined;
    /** Gets or sets the formularyType. */
    formularyType?: string | undefined;
    /** Gets or sets the role. */
    role?: string | undefined;
    /** Gets or sets the startDate. */
    startDate?: Date | undefined;
    /** Gets or sets the endDate. */
    endDate?: Date | undefined;
    /** Gets or sets the email. */
    email?: string | undefined;
    /** Gets or sets the session year. */
    year?: number | undefined;
    /** Gets or sets the subvention organization Id. */
    subventionOrganizationId?: number | undefined;
    /** Gets or sets a value indicating whether this instance is seen. */
    isSeen?: boolean | undefined;
}

/** Contains the definition of an object of type DropdownValueString. */
export class DropdownValueString implements IDropdownValueString {
    /** Gets or sets the identifier. */
    id?: string | undefined;
    /** Gets or sets the label. */
    label?: string | undefined;

    constructor(data?: IDropdownValueString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.label = _data["Label"];
        }
    }

    static fromJS(data: any): DropdownValueString {
        data = typeof data === 'object' ? data : {};
        let result = new DropdownValueString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Label"] = this.label;
        return data;
    }
}

/** Contains the definition of an object of type DropdownValueString. */
export interface IDropdownValueString {
    /** Gets or sets the identifier. */
    id?: string | undefined;
    /** Gets or sets the label. */
    label?: string | undefined;
}

/** Contains the definition of an object of type MailMemberHistoryDetails. */
export class MailMemberHistoryDetails extends MailMemberHistory implements IMailMemberHistoryDetails {
    /** Gets or sets the member identifier. */
    memberId?: number | undefined;
    /** Gets or sets the firstname. */
    firstName?: string | undefined;
    /** Gets or sets the lastname. */
    lastName?: string | undefined;

    constructor(data?: IMailMemberHistoryDetails) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.memberId = _data["memberId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
        }
    }

    static override fromJS(data: any): MailMemberHistoryDetails {
        data = typeof data === 'object' ? data : {};
        let result = new MailMemberHistoryDetails();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberId"] = this.memberId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type MailMemberHistoryDetails. */
export interface IMailMemberHistoryDetails extends IMailMemberHistory {
    /** Gets or sets the member identifier. */
    memberId?: number | undefined;
    /** Gets or sets the firstname. */
    firstName?: string | undefined;
    /** Gets or sets the lastname. */
    lastName?: string | undefined;
}

/** Contains the definition of an object of type AnonymousSurveys. */
export class AnonymousSurveys implements IAnonymousSurveys {
    /** Gets or sets the Anonymous Surveys Id. */
    anonymousSurveysId!: number;
    /** Gets or sets the Satisfaction Type. */
    satisfactionType?: string | undefined;
    /** Gets or sets the Course Session Id. */
    courseSessionId?: number | undefined;
    /** Gets or sets the email address. */
    emailAddress?: string | undefined;
    /** Gets or sets the year. */
    year?: number | undefined;
    /** Gets or sets the linked client id. */
    linkedClientId?: number | undefined;
    /** Gets or sets the subvention organization id. */
    subventionOrganizationId?: number | undefined;

    constructor(data?: IAnonymousSurveys) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.anonymousSurveysId = _data["anonymousSurveysId"];
            this.satisfactionType = _data["satisfactionType"];
            this.courseSessionId = _data["courseSessionId"];
            this.emailAddress = _data["emailAddress"];
            this.year = _data["year"];
            this.linkedClientId = _data["linkedClientId"];
            this.subventionOrganizationId = _data["subventionOrganizationId"];
        }
    }

    static fromJS(data: any): AnonymousSurveys {
        data = typeof data === 'object' ? data : {};
        let result = new AnonymousSurveys();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["anonymousSurveysId"] = this.anonymousSurveysId;
        data["satisfactionType"] = this.satisfactionType;
        data["courseSessionId"] = this.courseSessionId;
        data["emailAddress"] = this.emailAddress;
        data["year"] = this.year;
        data["linkedClientId"] = this.linkedClientId;
        data["subventionOrganizationId"] = this.subventionOrganizationId;
        return data;
    }
}

/** Contains the definition of an object of type AnonymousSurveys. */
export interface IAnonymousSurveys {
    /** Gets or sets the Anonymous Surveys Id. */
    anonymousSurveysId: number;
    /** Gets or sets the Satisfaction Type. */
    satisfactionType?: string | undefined;
    /** Gets or sets the Course Session Id. */
    courseSessionId?: number | undefined;
    /** Gets or sets the email address. */
    emailAddress?: string | undefined;
    /** Gets or sets the year. */
    year?: number | undefined;
    /** Gets or sets the linked client id. */
    linkedClientId?: number | undefined;
    /** Gets or sets the subvention organization id. */
    subventionOrganizationId?: number | undefined;
}

/** Contains the definition of an object of type DoctorBiodyInformation */
export class DoctorBiodyInformation implements IDoctorBiodyInformation {
    /** Gets or sets the Biody login. */
    biodyLogin?: string | undefined;
    /** Gets or sets the Biody password. */
    biodyPassword?: string | undefined;

    constructor(data?: IDoctorBiodyInformation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.biodyLogin = _data["biodyLogin"];
            this.biodyPassword = _data["biodyPassword"];
        }
    }

    static fromJS(data: any): DoctorBiodyInformation {
        data = typeof data === 'object' ? data : {};
        let result = new DoctorBiodyInformation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["biodyLogin"] = this.biodyLogin;
        data["biodyPassword"] = this.biodyPassword;
        return data;
    }
}

/** Contains the definition of an object of type DoctorBiodyInformation */
export interface IDoctorBiodyInformation {
    /** Gets or sets the Biody login. */
    biodyLogin?: string | undefined;
    /** Gets or sets the Biody password. */
    biodyPassword?: string | undefined;
}

/** Contains the definition of an object of type BiodyPatient. */
export class BiodyPatient implements IBiodyPatient {
    /** Gets or sets the identifier. */
    id!: number;
    /** Gets or sets the firstname. */
    firstName?: string | undefined;
    /** Gets or sets the lastname. */
    lastName?: string | undefined;
    /** Gets or sets the birthdate. */
    birthDate!: Date;
    /** Gets or sets the gender. */
    gender?: string | undefined;
    /** Gets or sets the address. */
    address?: string | undefined;
    /** Gets or sets the city. */
    city?: string | undefined;
    /** Gets or sets the zipcode. */
    zipCode?: string | undefined;
    /** Gets or sets the state. */
    state?: string | undefined;
    /** Gets or sets the mobile number. */
    mobileNumber?: string | undefined;
    /** Gets or sets the email. */
    email?: string | undefined;
    /** Gets or sets the phone. */
    phone?: string | undefined;
    /** Gets or sets the country. */
    country?: string | undefined;
    /** Gets or sets a value indicating whether the biody patient partially matches a consultIn patient. */
    suggestedPncId?: number | undefined;

    constructor(data?: IBiodyPatient) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.firstName = _data["FirstName"];
            this.lastName = _data["LastName"];
            this.birthDate = _data["BirthDate"] ? new Date(_data["BirthDate"].toString()) : <any>undefined;
            this.gender = _data["Gender"];
            this.address = _data["Address"];
            this.city = _data["City"];
            this.zipCode = _data["ZipCode"];
            this.state = _data["State"];
            this.mobileNumber = _data["MobileNumber"];
            this.email = _data["Email"];
            this.phone = _data["Phone"];
            this.country = _data["Country"];
            this.suggestedPncId = _data["SuggestedPncId"];
        }
    }

    static fromJS(data: any): BiodyPatient {
        data = typeof data === 'object' ? data : {};
        let result = new BiodyPatient();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["FirstName"] = this.firstName;
        data["LastName"] = this.lastName;
        data["BirthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["Gender"] = this.gender;
        data["Address"] = this.address;
        data["City"] = this.city;
        data["ZipCode"] = this.zipCode;
        data["State"] = this.state;
        data["MobileNumber"] = this.mobileNumber;
        data["Email"] = this.email;
        data["Phone"] = this.phone;
        data["Country"] = this.country;
        data["SuggestedPncId"] = this.suggestedPncId;
        return data;
    }
}

/** Contains the definition of an object of type BiodyPatient. */
export interface IBiodyPatient {
    /** Gets or sets the identifier. */
    id: number;
    /** Gets or sets the firstname. */
    firstName?: string | undefined;
    /** Gets or sets the lastname. */
    lastName?: string | undefined;
    /** Gets or sets the birthdate. */
    birthDate: Date;
    /** Gets or sets the gender. */
    gender?: string | undefined;
    /** Gets or sets the address. */
    address?: string | undefined;
    /** Gets or sets the city. */
    city?: string | undefined;
    /** Gets or sets the zipcode. */
    zipCode?: string | undefined;
    /** Gets or sets the state. */
    state?: string | undefined;
    /** Gets or sets the mobile number. */
    mobileNumber?: string | undefined;
    /** Gets or sets the email. */
    email?: string | undefined;
    /** Gets or sets the phone. */
    phone?: string | undefined;
    /** Gets or sets the country. */
    country?: string | undefined;
    /** Gets or sets a value indicating whether the biody patient partially matches a consultIn patient. */
    suggestedPncId?: number | undefined;
}

/** Contains the definition of an object of type PatientBiodyMeasurement. */
export class PatientBiodyMeasurement implements IPatientBiodyMeasurement {
    /** Gets or sets the identifier. */
    biodyId!: number;
    /** Gets or sets the weight. */
    weight!: number;
    /** Gets or sets the height. */
    height!: number;
    /** Gets or sets the cupsize. */
    cupSize!: PatientMeasureCupSize;
    /** Gets or sets the imc. */
    imc!: number;
    /** Gets or sets the cible weight/skeleton balance. */
    weightSkeletonBalanceCible?: number | undefined;
    /** Gets or sets the cible fat free hydratation. */
    fatFreeHydratationCible?: number | undefined;
    /** Gets or sets the cible hydratation. */
    hydratationCible?: number | undefined;
    /** Gets or sets the cible fat mass at constant hydratation. */
    fatMassHydratationCible?: number | undefined;
    /** Gets or sets the cible calculated water balance. */
    calculatedWaterBalanceCible?: number | undefined;
    /** Gets or sets cible the muscle mass */
    muscleMassCible?: number | undefined;
    /** Gets or sets the cible IMC */
    imcCible?: number | undefined;
    /** Gets or sets the theorical gap fat mass at constant hydratation */
    fatMassTheoricalGap?: number | undefined;
    /** Gets or sets the theorical gap skeletal muscle mass */
    muscleMassTheoricalGap?: number | undefined;
    /** Gets or sets the theorical gap total water */
    hydricVolumeTheoricalGap?: number | undefined;
    /** Gets or sets the fat mass index */
    fatMassIndex?: number | undefined;
    /** Gets or sets the skeletal miscme index */
    muscleMassIndex?: number | undefined;
    /** Gets or sets the bone mineral content index */
    boneMassIndex?: number | undefined;
    /** Gets or sets the load muscle on skeleton index */
    muscleLoadIndex?: number | undefined;
    /** Gets or sets the load total on skeleton index */
    totalLoadIndex?: number | undefined;
    /** Gets or sets the water volume */
    waterVolume?: number | undefined;
    /** Gets or sets the thighs size */
    thighsSize?: number | undefined;
    /** Gets or sets the hips size */
    hipsSize?: number | undefined;
    /** Gets or sets the waist size */
    waistSize?: number | undefined;
    /** Gets or sets the chest size */
    chestSize?: number | undefined;
    /** Gets or sets the biceps size */
    bicepsSize?: number | undefined;
    /** Gets or sets the skeletal muscle mass */
    muscleMass?: number | undefined;
    /** Gets or sets the fat mass */
    fatMass?: number | undefined;
    /** Gets or sets the Basic Metabolism */
    basicMetabolism?: number | undefined;
    /** Gets or sets the Energy Requirements */
    energyRequirements?: number | undefined;
    /** Gets or sets the Phase Angle */
    phaseAngle?: number | undefined;
    /** Gets or sets the Phase Angle */
    impedanceRatio?: number | undefined;
    /** Gets or sets the dry mass without fat */
    dryMass?: number | undefined;
    /** Gets or sets the creation date. */
    creationDate!: Date;
    /** Gets or sets the biody patient identifier. */
    biodyPatientId!: number;
    /** Gets or sets the physical acivity. */
    physicalActivity!: number;

    constructor(data?: IPatientBiodyMeasurement) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.biodyId = _data["biodyId"];
            this.weight = _data["weight"];
            this.height = _data["height"];
            this.cupSize = _data["cupSize"];
            this.imc = _data["imc"];
            this.weightSkeletonBalanceCible = _data["weightSkeletonBalanceCible"];
            this.fatFreeHydratationCible = _data["fatFreeHydratationCible"];
            this.hydratationCible = _data["hydratationCible"];
            this.fatMassHydratationCible = _data["fatMassHydratationCible"];
            this.calculatedWaterBalanceCible = _data["calculatedWaterBalanceCible"];
            this.muscleMassCible = _data["muscleMassCible"];
            this.imcCible = _data["imcCible"];
            this.fatMassTheoricalGap = _data["fatMassTheoricalGap"];
            this.muscleMassTheoricalGap = _data["muscleMassTheoricalGap"];
            this.hydricVolumeTheoricalGap = _data["hydricVolumeTheoricalGap"];
            this.fatMassIndex = _data["fatMassIndex"];
            this.muscleMassIndex = _data["muscleMassIndex"];
            this.boneMassIndex = _data["boneMassIndex"];
            this.muscleLoadIndex = _data["muscleLoadIndex"];
            this.totalLoadIndex = _data["totalLoadIndex"];
            this.waterVolume = _data["waterVolume"];
            this.thighsSize = _data["thighsSize"];
            this.hipsSize = _data["hipsSize"];
            this.waistSize = _data["waistSize"];
            this.chestSize = _data["chestSize"];
            this.bicepsSize = _data["bicepsSize"];
            this.muscleMass = _data["muscleMass"];
            this.fatMass = _data["fatMass"];
            this.basicMetabolism = _data["basicMetabolism"];
            this.energyRequirements = _data["energyRequirements"];
            this.phaseAngle = _data["phaseAngle"];
            this.impedanceRatio = _data["impedanceRatio"];
            this.dryMass = _data["dryMass"];
            this.creationDate = _data["creationDate"] ? new Date(_data["creationDate"].toString()) : <any>undefined;
            this.biodyPatientId = _data["biodyPatientId"];
            this.physicalActivity = _data["physicalActivity"];
        }
    }

    static fromJS(data: any): PatientBiodyMeasurement {
        data = typeof data === 'object' ? data : {};
        let result = new PatientBiodyMeasurement();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["biodyId"] = this.biodyId;
        data["weight"] = this.weight;
        data["height"] = this.height;
        data["cupSize"] = this.cupSize;
        data["imc"] = this.imc;
        data["weightSkeletonBalanceCible"] = this.weightSkeletonBalanceCible;
        data["fatFreeHydratationCible"] = this.fatFreeHydratationCible;
        data["hydratationCible"] = this.hydratationCible;
        data["fatMassHydratationCible"] = this.fatMassHydratationCible;
        data["calculatedWaterBalanceCible"] = this.calculatedWaterBalanceCible;
        data["muscleMassCible"] = this.muscleMassCible;
        data["imcCible"] = this.imcCible;
        data["fatMassTheoricalGap"] = this.fatMassTheoricalGap;
        data["muscleMassTheoricalGap"] = this.muscleMassTheoricalGap;
        data["hydricVolumeTheoricalGap"] = this.hydricVolumeTheoricalGap;
        data["fatMassIndex"] = this.fatMassIndex;
        data["muscleMassIndex"] = this.muscleMassIndex;
        data["boneMassIndex"] = this.boneMassIndex;
        data["muscleLoadIndex"] = this.muscleLoadIndex;
        data["totalLoadIndex"] = this.totalLoadIndex;
        data["waterVolume"] = this.waterVolume;
        data["thighsSize"] = this.thighsSize;
        data["hipsSize"] = this.hipsSize;
        data["waistSize"] = this.waistSize;
        data["chestSize"] = this.chestSize;
        data["bicepsSize"] = this.bicepsSize;
        data["muscleMass"] = this.muscleMass;
        data["fatMass"] = this.fatMass;
        data["basicMetabolism"] = this.basicMetabolism;
        data["energyRequirements"] = this.energyRequirements;
        data["phaseAngle"] = this.phaseAngle;
        data["impedanceRatio"] = this.impedanceRatio;
        data["dryMass"] = this.dryMass;
        data["creationDate"] = this.creationDate ? this.creationDate.toISOString() : <any>undefined;
        data["biodyPatientId"] = this.biodyPatientId;
        data["physicalActivity"] = this.physicalActivity;
        return data;
    }
}

/** Contains the definition of an object of type PatientBiodyMeasurement. */
export interface IPatientBiodyMeasurement {
    /** Gets or sets the identifier. */
    biodyId: number;
    /** Gets or sets the weight. */
    weight: number;
    /** Gets or sets the height. */
    height: number;
    /** Gets or sets the cupsize. */
    cupSize: PatientMeasureCupSize;
    /** Gets or sets the imc. */
    imc: number;
    /** Gets or sets the cible weight/skeleton balance. */
    weightSkeletonBalanceCible?: number | undefined;
    /** Gets or sets the cible fat free hydratation. */
    fatFreeHydratationCible?: number | undefined;
    /** Gets or sets the cible hydratation. */
    hydratationCible?: number | undefined;
    /** Gets or sets the cible fat mass at constant hydratation. */
    fatMassHydratationCible?: number | undefined;
    /** Gets or sets the cible calculated water balance. */
    calculatedWaterBalanceCible?: number | undefined;
    /** Gets or sets cible the muscle mass */
    muscleMassCible?: number | undefined;
    /** Gets or sets the cible IMC */
    imcCible?: number | undefined;
    /** Gets or sets the theorical gap fat mass at constant hydratation */
    fatMassTheoricalGap?: number | undefined;
    /** Gets or sets the theorical gap skeletal muscle mass */
    muscleMassTheoricalGap?: number | undefined;
    /** Gets or sets the theorical gap total water */
    hydricVolumeTheoricalGap?: number | undefined;
    /** Gets or sets the fat mass index */
    fatMassIndex?: number | undefined;
    /** Gets or sets the skeletal miscme index */
    muscleMassIndex?: number | undefined;
    /** Gets or sets the bone mineral content index */
    boneMassIndex?: number | undefined;
    /** Gets or sets the load muscle on skeleton index */
    muscleLoadIndex?: number | undefined;
    /** Gets or sets the load total on skeleton index */
    totalLoadIndex?: number | undefined;
    /** Gets or sets the water volume */
    waterVolume?: number | undefined;
    /** Gets or sets the thighs size */
    thighsSize?: number | undefined;
    /** Gets or sets the hips size */
    hipsSize?: number | undefined;
    /** Gets or sets the waist size */
    waistSize?: number | undefined;
    /** Gets or sets the chest size */
    chestSize?: number | undefined;
    /** Gets or sets the biceps size */
    bicepsSize?: number | undefined;
    /** Gets or sets the skeletal muscle mass */
    muscleMass?: number | undefined;
    /** Gets or sets the fat mass */
    fatMass?: number | undefined;
    /** Gets or sets the Basic Metabolism */
    basicMetabolism?: number | undefined;
    /** Gets or sets the Energy Requirements */
    energyRequirements?: number | undefined;
    /** Gets or sets the Phase Angle */
    phaseAngle?: number | undefined;
    /** Gets or sets the Phase Angle */
    impedanceRatio?: number | undefined;
    /** Gets or sets the dry mass without fat */
    dryMass?: number | undefined;
    /** Gets or sets the creation date. */
    creationDate: Date;
    /** Gets or sets the biody patient identifier. */
    biodyPatientId: number;
    /** Gets or sets the physical acivity. */
    physicalActivity: number;
}

/** Contains the definition of an object of type PatientMeasureCupSize. */
export enum PatientMeasureCupSize {
    Unknown = 0,
    A = 1,
    B = 2,
    C = 3,
    D = 4,
    E = 5,
}

/** Contains the definition of an object of type NutritionProgramFood. */
export class NutritionProgramFood implements INutritionProgramFood {
    /** Gets or sets the meal time. */
    id!: number;
    /** Gets or sets the identifier. */
    ingredientId?: number | undefined;
    /** Gets or sets the recipe identifier. */
    recipeId?: number | undefined;
    /** Gets or sets the unit type identifier. */
    unitTypeId!: number;
    /** Gets or sets the quantity. */
    quantity!: number;
    /** Gets or sets a value indicating whether gets or sets the quantity. */
    selected!: boolean;

    constructor(data?: INutritionProgramFood) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.ingredientId = _data["ingredientId"];
            this.recipeId = _data["recipeId"];
            this.unitTypeId = _data["unitTypeId"];
            this.quantity = _data["quantity"];
            this.selected = _data["selected"];
        }
    }

    static fromJS(data: any): NutritionProgramFood {
        data = typeof data === 'object' ? data : {};
        let result = new NutritionProgramFood();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ingredientId"] = this.ingredientId;
        data["recipeId"] = this.recipeId;
        data["unitTypeId"] = this.unitTypeId;
        data["quantity"] = this.quantity;
        data["selected"] = this.selected;
        return data;
    }
}

/** Contains the definition of an object of type NutritionProgramFood. */
export interface INutritionProgramFood {
    /** Gets or sets the meal time. */
    id: number;
    /** Gets or sets the identifier. */
    ingredientId?: number | undefined;
    /** Gets or sets the recipe identifier. */
    recipeId?: number | undefined;
    /** Gets or sets the unit type identifier. */
    unitTypeId: number;
    /** Gets or sets the quantity. */
    quantity: number;
    /** Gets or sets a value indicating whether gets or sets the quantity. */
    selected: boolean;
}

/** Contains the definition of an object of type NutritionProgramFoodDetails. */
export class NutritionProgramFoodDetails extends NutritionProgramFood implements INutritionProgramFoodDetails {
    /** Gets or sets the meal time. */
    mealTime!: MealTime;
    /** Gets or sets the recipe identifier. */
    mealId?: number | undefined;
    /** Gets or sets the day. */
    day!: Days;
    /** Gets or sets the day identifier. */
    dayId?: number | undefined;
    /** Gets or sets the week identifier. */
    weekId!: number;
    /** Gets or sets the identifier. */
    ingredient?: Ingredient | undefined;
    /** Gets or sets the recipe identifier. */
    recipe?: CoachingRecipe | undefined;

    constructor(data?: INutritionProgramFoodDetails) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.mealTime = _data["mealTime"];
            this.mealId = _data["mealId"];
            this.day = _data["day"];
            this.dayId = _data["dayId"];
            this.weekId = _data["weekId"];
            this.ingredient = _data["ingredient"] ? Ingredient.fromJS(_data["ingredient"]) : <any>undefined;
            this.recipe = _data["recipe"] ? CoachingRecipe.fromJS(_data["recipe"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): NutritionProgramFoodDetails {
        data = typeof data === 'object' ? data : {};
        let result = new NutritionProgramFoodDetails();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mealTime"] = this.mealTime;
        data["mealId"] = this.mealId;
        data["day"] = this.day;
        data["dayId"] = this.dayId;
        data["weekId"] = this.weekId;
        data["ingredient"] = this.ingredient ? this.ingredient.toJSON() : <any>undefined;
        data["recipe"] = this.recipe ? this.recipe.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type NutritionProgramFoodDetails. */
export interface INutritionProgramFoodDetails extends INutritionProgramFood {
    /** Gets or sets the meal time. */
    mealTime: MealTime;
    /** Gets or sets the recipe identifier. */
    mealId?: number | undefined;
    /** Gets or sets the day. */
    day: Days;
    /** Gets or sets the day identifier. */
    dayId?: number | undefined;
    /** Gets or sets the week identifier. */
    weekId: number;
    /** Gets or sets the identifier. */
    ingredient?: Ingredient | undefined;
    /** Gets or sets the recipe identifier. */
    recipe?: CoachingRecipe | undefined;
}

/** Contains the definition of an object of type MealTime */
export enum MealTime {
    Unknown = 0,
    Breakfast = 1,
    Lunch = 2,
    Snack = 3,
    Dinner = 4,
}

/** Contains the definition of an object of type NutritionProgramWeek. */
export class NutritionProgramWeek implements INutritionProgramWeek {
    /** Gets or sets the identifier. */
    id!: number;
    /** Gets or sets the order. */
    order!: number;
    /** Gets or sets the days */
    days?: NutritionProgramDay[] | undefined;

    constructor(data?: INutritionProgramWeek) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.order = _data["order"];
            if (Array.isArray(_data["days"])) {
                this.days = [] as any;
                for (let item of _data["days"])
                    this.days!.push(NutritionProgramDay.fromJS(item));
            }
        }
    }

    static fromJS(data: any): NutritionProgramWeek {
        data = typeof data === 'object' ? data : {};
        let result = new NutritionProgramWeek();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["order"] = this.order;
        if (Array.isArray(this.days)) {
            data["days"] = [];
            for (let item of this.days)
                data["days"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

/** Contains the definition of an object of type NutritionProgramWeek. */
export interface INutritionProgramWeek {
    /** Gets or sets the identifier. */
    id: number;
    /** Gets or sets the order. */
    order: number;
    /** Gets or sets the days */
    days?: NutritionProgramDay[] | undefined;
}

/** Contains the definition of an object of type NutritionProgramDay. */
export class NutritionProgramDay implements INutritionProgramDay {
    /** Gets or sets the identifier. */
    id!: number;
    /** Gets or sets the day; */
    day!: Days;
    /** Gets or sets the meals. */
    meals?: NutritionProgramMeal[] | undefined;

    constructor(data?: INutritionProgramDay) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.day = _data["day"];
            if (Array.isArray(_data["meals"])) {
                this.meals = [] as any;
                for (let item of _data["meals"])
                    this.meals!.push(NutritionProgramMeal.fromJS(item));
            }
        }
    }

    static fromJS(data: any): NutritionProgramDay {
        data = typeof data === 'object' ? data : {};
        let result = new NutritionProgramDay();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["day"] = this.day;
        if (Array.isArray(this.meals)) {
            data["meals"] = [];
            for (let item of this.meals)
                data["meals"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

/** Contains the definition of an object of type NutritionProgramDay. */
export interface INutritionProgramDay {
    /** Gets or sets the identifier. */
    id: number;
    /** Gets or sets the day; */
    day: Days;
    /** Gets or sets the meals. */
    meals?: NutritionProgramMeal[] | undefined;
}

/** Contains the definition of an object of type NutritionProgramMeal. */
export class NutritionProgramMeal implements INutritionProgramMeal {
    /** Gets or sets the identifier. */
    id!: number;
    /** Gets or sets the meal time. */
    mealTime!: MealTime;
    /** Gets or sets the foods. */
    foods?: NutritionProgramFoodDetails[] | undefined;

    constructor(data?: INutritionProgramMeal) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.mealTime = _data["mealTime"];
            if (Array.isArray(_data["foods"])) {
                this.foods = [] as any;
                for (let item of _data["foods"])
                    this.foods!.push(NutritionProgramFoodDetails.fromJS(item));
            }
        }
    }

    static fromJS(data: any): NutritionProgramMeal {
        data = typeof data === 'object' ? data : {};
        let result = new NutritionProgramMeal();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["mealTime"] = this.mealTime;
        if (Array.isArray(this.foods)) {
            data["foods"] = [];
            for (let item of this.foods)
                data["foods"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

/** Contains the definition of an object of type NutritionProgramMeal. */
export interface INutritionProgramMeal {
    /** Gets or sets the identifier. */
    id: number;
    /** Gets or sets the meal time. */
    mealTime: MealTime;
    /** Gets or sets the foods. */
    foods?: NutritionProgramFoodDetails[] | undefined;
}

/** Contains the definition of an object of type CreateNutritionProgram. */
export class CreateNutritionProgram implements ICreateNutritionProgram {
    /** Gets or sets the name. */
    name?: string | undefined;
    /** Gets or sets the description. */
    description?: string | undefined;
    /** Gets or sets the diet type. */
    dietName?: string | undefined;

    constructor(data?: ICreateNutritionProgram) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.dietName = _data["dietName"];
        }
    }

    static fromJS(data: any): CreateNutritionProgram {
        data = typeof data === 'object' ? data : {};
        let result = new CreateNutritionProgram();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["dietName"] = this.dietName;
        return data;
    }
}

/** Contains the definition of an object of type CreateNutritionProgram. */
export interface ICreateNutritionProgram {
    /** Gets or sets the name. */
    name?: string | undefined;
    /** Gets or sets the description. */
    description?: string | undefined;
    /** Gets or sets the diet type. */
    dietName?: string | undefined;
}

/** Contains the definition of an object of type NutritionProgramDetails. */
export class NutritionProgramNutritionInfo extends NutritionInfo implements INutritionProgramNutritionInfo {
    /** Gets or sets the nutrition info type */
    type!: NutritionInfoType;
    /** Gets or sets the meal time. */
    mealTime?: MealTime | undefined;

    constructor(data?: INutritionProgramNutritionInfo) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.type = _data["type"];
            this.mealTime = _data["mealTime"];
        }
    }

    static override fromJS(data: any): NutritionProgramNutritionInfo {
        data = typeof data === 'object' ? data : {};
        let result = new NutritionProgramNutritionInfo();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["mealTime"] = this.mealTime;
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type NutritionProgramDetails. */
export interface INutritionProgramNutritionInfo extends INutritionInfo {
    /** Gets or sets the nutrition info type */
    type: NutritionInfoType;
    /** Gets or sets the meal time. */
    mealTime?: MealTime | undefined;
}

/** Contains the definition of an object of type NutrientUnitType. */
export enum NutritionInfoType {
    Unknown = 0,
    Meal = 1,
    Ingredient = 2,
    Recipe = 3,
    Day = 4,
}

/** Contains the definition of an object of type NutritionProgram. */
export class NutritionProgram extends CreateNutritionProgram implements INutritionProgram {
    /** Gets or sets the identifier. */
    id!: number;
    /** Gets or sets a value indicating whether the entity is active. */
    active!: boolean;
    /** Gets or sets the start date. */
    startDate?: Date | undefined;
    /** Gets or sets the duration. */
    duration!: number;

    constructor(data?: INutritionProgram) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.duration = _data["duration"];
        }
    }

    static override fromJS(data: any): NutritionProgram {
        data = typeof data === 'object' ? data : {};
        let result = new NutritionProgram();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["duration"] = this.duration;
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type NutritionProgram. */
export interface INutritionProgram extends ICreateNutritionProgram {
    /** Gets or sets the identifier. */
    id: number;
    /** Gets or sets a value indicating whether the entity is active. */
    active: boolean;
    /** Gets or sets the start date. */
    startDate?: Date | undefined;
    /** Gets or sets the duration. */
    duration: number;
}

/** Contains the definition of an object of type NutritionProgramDetails. */
export class NutritionProgramDetails extends NutritionProgram implements INutritionProgramDetails {
    /** Gets or sets the weeks */
    weeks?: NutritionProgramWeek[] | undefined;

    constructor(data?: INutritionProgramDetails) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["weeks"])) {
                this.weeks = [] as any;
                for (let item of _data["weeks"])
                    this.weeks!.push(NutritionProgramWeek.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): NutritionProgramDetails {
        data = typeof data === 'object' ? data : {};
        let result = new NutritionProgramDetails();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.weeks)) {
            data["weeks"] = [];
            for (let item of this.weeks)
                data["weeks"].push(item ? item.toJSON() : <any>undefined);
        }
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type NutritionProgramDetails. */
export interface INutritionProgramDetails extends INutritionProgram {
    /** Gets or sets the weeks */
    weeks?: NutritionProgramWeek[] | undefined;
}

/** Contains the definition of an object of type NutritionProgramSearchParams. */
export class NutritionProgramSearchParams extends SearchParams implements INutritionProgramSearchParams {
    /** Gets or sets the name. */
    name?: string | undefined;
    /** Gets or sets the consultation identifier. */
    consultationId?: number | undefined;
    /** Gets or sets the patient identifier. */
    patientId?: number | undefined;

    constructor(data?: INutritionProgramSearchParams) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.consultationId = _data["consultationId"];
            this.patientId = _data["patientId"];
        }
    }

    static override fromJS(data: any): NutritionProgramSearchParams {
        data = typeof data === 'object' ? data : {};
        let result = new NutritionProgramSearchParams();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["consultationId"] = this.consultationId;
        data["patientId"] = this.patientId;
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type NutritionProgramSearchParams. */
export interface INutritionProgramSearchParams extends ISearchParams {
    /** Gets or sets the name. */
    name?: string | undefined;
    /** Gets or sets the consultation identifier. */
    consultationId?: number | undefined;
    /** Gets or sets the patient identifier. */
    patientId?: number | undefined;
}

export class PaginatorWrapperOfIEnumerableOfNutritionProgram implements IPaginatorWrapperOfIEnumerableOfNutritionProgram {
    totalRecords!: number;
    data?: NutritionProgram[] | undefined;

    constructor(data?: IPaginatorWrapperOfIEnumerableOfNutritionProgram) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRecords = _data["totalRecords"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(NutritionProgram.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatorWrapperOfIEnumerableOfNutritionProgram {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatorWrapperOfIEnumerableOfNutritionProgram();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IPaginatorWrapperOfIEnumerableOfNutritionProgram {
    totalRecords: number;
    data?: NutritionProgram[] | undefined;
}

/** Contains the definition of an object of type NutritionProgramDuplicateMeal. */
export class NutritionProgramDuplicateMeal implements INutritionProgramDuplicateMeal {
    /** Gets or sets the week identifier. */
    weekId!: number;
    /** Gets or sets the identifier. */
    duplicatedMealId!: number;
    /** Gets or sets the targets. */
    targets?: NutritionProgramDuplicateMealDetails[] | undefined;

    constructor(data?: INutritionProgramDuplicateMeal) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.weekId = _data["weekId"];
            this.duplicatedMealId = _data["duplicatedMealId"];
            if (Array.isArray(_data["targets"])) {
                this.targets = [] as any;
                for (let item of _data["targets"])
                    this.targets!.push(NutritionProgramDuplicateMealDetails.fromJS(item));
            }
        }
    }

    static fromJS(data: any): NutritionProgramDuplicateMeal {
        data = typeof data === 'object' ? data : {};
        let result = new NutritionProgramDuplicateMeal();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["weekId"] = this.weekId;
        data["duplicatedMealId"] = this.duplicatedMealId;
        if (Array.isArray(this.targets)) {
            data["targets"] = [];
            for (let item of this.targets)
                data["targets"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

/** Contains the definition of an object of type NutritionProgramDuplicateMeal. */
export interface INutritionProgramDuplicateMeal {
    /** Gets or sets the week identifier. */
    weekId: number;
    /** Gets or sets the identifier. */
    duplicatedMealId: number;
    /** Gets or sets the targets. */
    targets?: NutritionProgramDuplicateMealDetails[] | undefined;
}

/** Contains the definition of an object of type NutritionProgramDuplicateMealDetails. */
export class NutritionProgramDuplicateMealDetails implements INutritionProgramDuplicateMealDetails {
    /** Gets or sets the meal time. */
    mealTime!: MealTime;
    /** Gets or sets the day. */
    day!: Days;

    constructor(data?: INutritionProgramDuplicateMealDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mealTime = _data["MealTime"];
            this.day = _data["Day"];
        }
    }

    static fromJS(data: any): NutritionProgramDuplicateMealDetails {
        data = typeof data === 'object' ? data : {};
        let result = new NutritionProgramDuplicateMealDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["MealTime"] = this.mealTime;
        data["Day"] = this.day;
        return data;
    }
}

/** Contains the definition of an object of type NutritionProgramDuplicateMealDetails. */
export interface INutritionProgramDuplicateMealDetails {
    /** Gets or sets the meal time. */
    mealTime: MealTime;
    /** Gets or sets the day. */
    day: Days;
}

export class PaginatorWrapperOfIEnumerableOfConsultationInvoice implements IPaginatorWrapperOfIEnumerableOfConsultationInvoice {
    totalRecords!: number;
    data?: ConsultationInvoice[] | undefined;

    constructor(data?: IPaginatorWrapperOfIEnumerableOfConsultationInvoice) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRecords = _data["totalRecords"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ConsultationInvoice.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatorWrapperOfIEnumerableOfConsultationInvoice {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatorWrapperOfIEnumerableOfConsultationInvoice();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IPaginatorWrapperOfIEnumerableOfConsultationInvoice {
    totalRecords: number;
    data?: ConsultationInvoice[] | undefined;
}

/** Contains the definition of an object of type ConsultationInvoice. */
export class ConsultationInvoice implements IConsultationInvoice {
    /** Gets or sets the identifier. */
    id!: number;
    /** Gets or sets the consultation reference. */
    referenceNumber?: string | undefined;
    /** Gets or sets the consultation reference year. */
    referenceYear!: number;
    /** Gets or sets the consultation id. */
    consultationId!: number;
    /** Gets or sets the amount. */
    amount?: number | undefined;
    /** Gets or sets the patient first name. */
    patientFirstName?: string | undefined;
    /** Gets or sets the patient last name. */
    patientLastName?: string | undefined;
    /** Gets or sets the patient last name. */
    patientId?: string | undefined;
    /** Gets or sets the doctor first name. */
    doctorFirstName?: string | undefined;
    /** Gets or sets the doctor last name. */
    doctorLastName?: string | undefined;
    /** Gets or sets the consultation date. */
    consultationDate!: Date;
    /** Gets or sets the invoice date. */
    invoiceDate!: Date;
    /** Gets or sets a value indicating whether the consultation is paid. */
    isPaid!: boolean;
    /** Gets or sets a value indicating whether this instance is visible for patient. */
    isVisibleForPatient!: boolean;
    /** Gets or sets the reference/prefix decided by the doctor. */
    prefix?: string | undefined;
    /** Gets or sets the reference/suffix to be shown on the invoice. */
    suffix?: string | undefined;
    /** Gets or sets the document URL. */
    documentPath?: string | undefined;
    /** Gets or sets the document view URL. */
    documentViewUrl?: string | undefined;
    /** Gets or sets the document download URL. */
    documentDownloadUrl?: string | undefined;

    constructor(data?: IConsultationInvoice) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.referenceNumber = _data["referenceNumber"];
            this.referenceYear = _data["referenceYear"];
            this.consultationId = _data["consultationId"];
            this.amount = _data["amount"];
            this.patientFirstName = _data["patientFirstName"];
            this.patientLastName = _data["patientLastName"];
            this.patientId = _data["patientId"];
            this.doctorFirstName = _data["doctorFirstName"];
            this.doctorLastName = _data["doctorLastName"];
            this.consultationDate = _data["consultationDate"] ? new Date(_data["consultationDate"].toString()) : <any>undefined;
            this.invoiceDate = _data["invoiceDate"] ? new Date(_data["invoiceDate"].toString()) : <any>undefined;
            this.isPaid = _data["isPaid"];
            this.isVisibleForPatient = _data["isVisibleForPatient"];
            this.prefix = _data["prefix"];
            this.suffix = _data["suffix"];
            this.documentPath = _data["documentPath"];
            this.documentViewUrl = _data["documentViewUrl"];
            this.documentDownloadUrl = _data["documentDownloadUrl"];
        }
    }

    static fromJS(data: any): ConsultationInvoice {
        data = typeof data === 'object' ? data : {};
        let result = new ConsultationInvoice();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["referenceNumber"] = this.referenceNumber;
        data["referenceYear"] = this.referenceYear;
        data["consultationId"] = this.consultationId;
        data["amount"] = this.amount;
        data["patientFirstName"] = this.patientFirstName;
        data["patientLastName"] = this.patientLastName;
        data["patientId"] = this.patientId;
        data["doctorFirstName"] = this.doctorFirstName;
        data["doctorLastName"] = this.doctorLastName;
        data["consultationDate"] = this.consultationDate ? this.consultationDate.toISOString() : <any>undefined;
        data["invoiceDate"] = this.invoiceDate ? this.invoiceDate.toISOString() : <any>undefined;
        data["isPaid"] = this.isPaid;
        data["isVisibleForPatient"] = this.isVisibleForPatient;
        data["prefix"] = this.prefix;
        data["suffix"] = this.suffix;
        data["documentPath"] = this.documentPath;
        data["documentViewUrl"] = this.documentViewUrl;
        data["documentDownloadUrl"] = this.documentDownloadUrl;
        return data;
    }
}

/** Contains the definition of an object of type ConsultationInvoice. */
export interface IConsultationInvoice {
    /** Gets or sets the identifier. */
    id: number;
    /** Gets or sets the consultation reference. */
    referenceNumber?: string | undefined;
    /** Gets or sets the consultation reference year. */
    referenceYear: number;
    /** Gets or sets the consultation id. */
    consultationId: number;
    /** Gets or sets the amount. */
    amount?: number | undefined;
    /** Gets or sets the patient first name. */
    patientFirstName?: string | undefined;
    /** Gets or sets the patient last name. */
    patientLastName?: string | undefined;
    /** Gets or sets the patient last name. */
    patientId?: string | undefined;
    /** Gets or sets the doctor first name. */
    doctorFirstName?: string | undefined;
    /** Gets or sets the doctor last name. */
    doctorLastName?: string | undefined;
    /** Gets or sets the consultation date. */
    consultationDate: Date;
    /** Gets or sets the invoice date. */
    invoiceDate: Date;
    /** Gets or sets a value indicating whether the consultation is paid. */
    isPaid: boolean;
    /** Gets or sets a value indicating whether this instance is visible for patient. */
    isVisibleForPatient: boolean;
    /** Gets or sets the reference/prefix decided by the doctor. */
    prefix?: string | undefined;
    /** Gets or sets the reference/suffix to be shown on the invoice. */
    suffix?: string | undefined;
    /** Gets or sets the document URL. */
    documentPath?: string | undefined;
    /** Gets or sets the document view URL. */
    documentViewUrl?: string | undefined;
    /** Gets or sets the document download URL. */
    documentDownloadUrl?: string | undefined;
}

/** Contains the definition of an object of type SearchParamConsultationInvoice. */
export class SearchParamConsultationInvoice extends SearchParams implements ISearchParamConsultationInvoice {
    /** Gets or sets the id of the patient */
    patientId?: number | undefined;
    /** Gets or sets the consultation order by. */
    sortType?: ConsultationInvoiceSortType | undefined;
    /** Gets or sets the period. */
    periodType?: InvoicePeriodType | undefined;
    /** Gets or sets the months. */
    months?: InvoiceMonthsType | undefined;
    /** Gets or sets the years. */
    years?: InvoiceYearsType | undefined;

    constructor(data?: ISearchParamConsultationInvoice) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.patientId = _data["patientId"];
            this.sortType = _data["sortType"];
            this.periodType = _data["periodType"];
            this.months = _data["months"];
            this.years = _data["years"];
        }
    }

    static override fromJS(data: any): SearchParamConsultationInvoice {
        data = typeof data === 'object' ? data : {};
        let result = new SearchParamConsultationInvoice();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["patientId"] = this.patientId;
        data["sortType"] = this.sortType;
        data["periodType"] = this.periodType;
        data["months"] = this.months;
        data["years"] = this.years;
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type SearchParamConsultationInvoice. */
export interface ISearchParamConsultationInvoice extends ISearchParams {
    /** Gets or sets the id of the patient */
    patientId?: number | undefined;
    /** Gets or sets the consultation order by. */
    sortType?: ConsultationInvoiceSortType | undefined;
    /** Gets or sets the period. */
    periodType?: InvoicePeriodType | undefined;
    /** Gets or sets the months. */
    months?: InvoiceMonthsType | undefined;
    /** Gets or sets the years. */
    years?: InvoiceYearsType | undefined;
}

/** Contains the definition of an object of type ConsultationInvoiceSortType. */
export enum ConsultationInvoiceSortType {
    ConsultationDateAsc = 0,
    ConsultationDateDesc = 1,
    ReferenceNumberAsc = 2,
    ReferenceNumberDesc = 3,
}

/** Contains the definition of an object of type InvoicePeriodType. */
export enum InvoicePeriodType {
    All = 0,
    Monthly = 1,
    Annual = 2,
}

/** Contains the definition of an object of type InvoiceMonthsType. */
export enum InvoiceMonthsType {
    January = 0,
    February = 1,
    March = 2,
    April = 3,
    May = 4,
    June = 5,
    July = 6,
    August = 7,
    September = 8,
    October = 9,
    November = 10,
    December = 11,
}

/** Contains the definition of an object of type InvoiceYearsType. */
export enum InvoiceYearsType {
    CurrentYear = 0,
    PreviousYear = 1,
}

/** Contains the definition of an object of type SearchParamConsultationInvoiceDraft. */
export class SearchParamConsultationInvoiceDraft extends SearchParams implements ISearchParamConsultationInvoiceDraft {
    /** Gets or sets the sort type. */
    sortType!: ConsultationDateOrderByType;

    constructor(data?: ISearchParamConsultationInvoiceDraft) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.sortType = _data["SortType"];
        }
    }

    static override fromJS(data: any): SearchParamConsultationInvoiceDraft {
        data = typeof data === 'object' ? data : {};
        let result = new SearchParamConsultationInvoiceDraft();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["SortType"] = this.sortType;
        super.toJSON(data);
        return data;
    }
}

/** Contains the definition of an object of type SearchParamConsultationInvoiceDraft. */
export interface ISearchParamConsultationInvoiceDraft extends ISearchParams {
    /** Gets or sets the sort type. */
    sortType: ConsultationDateOrderByType;
}

/** Contains the definition of an object of type ConsultationDateOrderByType. */
export enum ConsultationDateOrderByType {
    DateAsc = 0,
    DateDesc = 1,
}

/** Contains the definition of an object of type ConsultationInvoice. */
export class ConsultationInvoiceValidate implements IConsultationInvoiceValidate {
    /** Gets or sets the invoice identifier. */
    invoiceId!: number;
    /** Gets or sets the consultation identifier. */
    consultationId!: number;
    /** Gets or sets the reference number. */
    referenceNumber?: string | undefined;
    /** Gets or sets the reference year. */
    referenceYear!: number;

    constructor(data?: IConsultationInvoiceValidate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.invoiceId = _data["invoiceId"];
            this.consultationId = _data["consultationId"];
            this.referenceNumber = _data["referenceNumber"];
            this.referenceYear = _data["referenceYear"];
        }
    }

    static fromJS(data: any): ConsultationInvoiceValidate {
        data = typeof data === 'object' ? data : {};
        let result = new ConsultationInvoiceValidate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["invoiceId"] = this.invoiceId;
        data["consultationId"] = this.consultationId;
        data["referenceNumber"] = this.referenceNumber;
        data["referenceYear"] = this.referenceYear;
        return data;
    }
}

/** Contains the definition of an object of type ConsultationInvoice. */
export interface IConsultationInvoiceValidate {
    /** Gets or sets the invoice identifier. */
    invoiceId: number;
    /** Gets or sets the consultation identifier. */
    consultationId: number;
    /** Gets or sets the reference number. */
    referenceNumber?: string | undefined;
    /** Gets or sets the reference year. */
    referenceYear: number;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}